import * as React$3 from "react";
import React__default$1, { createElement as createElement$1, isValidElement, cloneElement, createContext, useContext, useState as useState$1, useRef, useEffect as useEffect$1, forwardRef, useLayoutEffect as useLayoutEffect$1, Fragment as Fragment$1, useMemo, useReducer, createRef } from "react";
import ReactMapGL, { StaticMap, Marker, NavigationControl } from "react-map-gl";
import { createPortal } from "react-dom";
import axios from "axios";
function _mergeNamespaces(n2, m2) {
  for (var i2 = 0; i2 < m2.length; i2++) {
    const e2 = m2[i2];
    if (typeof e2 !== "string" && !Array.isArray(e2)) {
      for (const k2 in e2) {
        if (k2 !== "default" && !(k2 in n2)) {
          const d2 = Object.getOwnPropertyDescriptor(e2, k2);
          if (d2) {
            Object.defineProperty(n2, k2, d2.get ? d2 : {
              enumerable: true,
              get: () => e2[k2]
            });
          }
        }
      }
    }
  }
  return Object.freeze(Object.defineProperty(n2, Symbol.toStringTag, { value: "Module" }));
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
function _classCallCheck(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _toPrimitive(input, hint) {
  if (_typeof$1(input) !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof$1(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof$1(key) === "symbol" ? key : String(key);
}
function _defineProperties(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _setPrototypeOf(o3, p2) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o4, p3) {
    o4.__proto__ = p3;
    return o4;
  };
  return _setPrototypeOf(o3, p2);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _getPrototypeOf(o3) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o4) {
    return o4.__proto__ || Object.getPrototypeOf(o4);
  };
  return _getPrototypeOf(o3);
}
function _defineProperty$2(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _arrayWithHoles(arr2) {
  if (Array.isArray(arr2))
    return arr2;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _arrayLikeToArray(arr2, len) {
  if (len == null || len > arr2.length)
    len = arr2.length;
  for (var i2 = 0, arr22 = new Array(len); i2 < len; i2++)
    arr22[i2] = arr2[i2];
  return arr22;
}
function _unsupportedIterableToArray(o3, minLen) {
  if (!o3)
    return;
  if (typeof o3 === "string")
    return _arrayLikeToArray(o3, minLen);
  var n2 = Object.prototype.toString.call(o3).slice(8, -1);
  if (n2 === "Object" && o3.constructor)
    n2 = o3.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o3);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray(o3, minLen);
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toArray(arr2) {
  return _arrayWithHoles(arr2) || _iterableToArray(arr2) || _unsupportedIterableToArray(arr2) || _nonIterableRest();
}
function ownKeys$6(object, enumerableOnly) {
  var keys2 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread$6(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$6(Object(source), true).forEach(function(key) {
      _defineProperty$2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var consoleLogger = {
  type: "logger",
  log: function log(args) {
    this.output("log", args);
  },
  warn: function warn(args) {
    this.output("warn", args);
  },
  error: function error(args) {
    this.output("error", args);
  },
  output: function output(type2, args) {
    if (console && console[type2])
      console[type2].apply(console, args);
  }
};
var Logger = function() {
  function Logger2(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck(this, Logger2);
    this.init(concreteLogger, options);
  }
  _createClass(Logger2, [{
    key: "init",
    value: function init2(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.prefix = options.prefix || "i18next:";
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log3() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return this.forward(args, "log", "", true);
    }
  }, {
    key: "warn",
    value: function warn4() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return this.forward(args, "warn", "", true);
    }
  }, {
    key: "error",
    value: function error2() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return this.forward(args, "error", "");
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug)
        return null;
      if (typeof args[0] === "string")
        args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create2(moduleName) {
      return new Logger2(this.logger, _objectSpread$6(_objectSpread$6({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }), this.options));
    }
  }, {
    key: "clone",
    value: function clone2(options) {
      options = options || this.options;
      options.prefix = options.prefix || this.prefix;
      return new Logger2(this.logger, options);
    }
  }]);
  return Logger2;
}();
var baseLogger = new Logger();
var EventEmitter = function() {
  function EventEmitter2() {
    _classCallCheck(this, EventEmitter2);
    this.observers = {};
  }
  _createClass(EventEmitter2, [{
    key: "on",
    value: function on(events2, listener) {
      var _this = this;
      events2.split(" ").forEach(function(event) {
        _this.observers[event] = _this.observers[event] || [];
        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event])
        return;
      if (!listener) {
        delete this.observers[event];
        return;
      }
      this.observers[event] = this.observers[event].filter(function(l2) {
        return l2 !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function(observer) {
          observer.apply(void 0, args);
        });
      }
      if (this.observers["*"]) {
        var _cloned = [].concat(this.observers["*"]);
        _cloned.forEach(function(observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);
  return EventEmitter2;
}();
function defer() {
  var res;
  var rej;
  var promise = new Promise(function(resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null)
    return "";
  return "" + object;
}
function copy(a2, s2, t2) {
  a2.forEach(function(m2) {
    if (s2[m2])
      t2[m2] = s2[m2];
  });
}
function getLastOfPath(object, path2, Empty) {
  function cleanKey(key2) {
    return key2 && key2.indexOf("###") > -1 ? key2.replace(/###/g, ".") : key2;
  }
  function canNotTraverseDeeper() {
    return !object || typeof object === "string";
  }
  var stack = typeof path2 !== "string" ? [].concat(path2) : path2.split(".");
  while (stack.length > 1) {
    if (canNotTraverseDeeper())
      return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty)
      object[key] = new Empty();
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }
  if (canNotTraverseDeeper())
    return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}
function setPath(object, path2, newValue) {
  var _getLastOfPath = getLastOfPath(object, path2, Object), obj = _getLastOfPath.obj, k2 = _getLastOfPath.k;
  obj[k2] = newValue;
}
function pushPath(object, path2, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path2, Object), obj = _getLastOfPath2.obj, k2 = _getLastOfPath2.k;
  obj[k2] = obj[k2] || [];
  if (concat)
    obj[k2] = obj[k2].concat(newValue);
  if (!concat)
    obj[k2].push(newValue);
}
function getPath(object, path2) {
  var _getLastOfPath3 = getLastOfPath(object, path2), obj = _getLastOfPath3.obj, k2 = _getLastOfPath3.k;
  if (!obj)
    return void 0;
  return obj[k2];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);
  if (value !== void 0) {
    return value;
  }
  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== "__proto__" && prop !== "constructor") {
      if (prop in target) {
        if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
          if (overwrite)
            target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }
  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function escape(data) {
  if (typeof data === "string") {
    return data.replace(/[&<>"'\/]/g, function(s2) {
      return _entityMap[s2];
    });
  }
  return data;
}
var isIE10 = typeof window !== "undefined" && window.navigator && typeof window.navigator.userAgentData === "undefined" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;
var chars = [" ", ",", "?", "!", ";"];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || "";
  keySeparator = keySeparator || "";
  var possibleChars = chars.filter(function(c2) {
    return nsSeparator.indexOf(c2) < 0 && keySeparator.indexOf(c2) < 0;
  });
  if (possibleChars.length === 0)
    return true;
  var r2 = new RegExp("(".concat(possibleChars.map(function(c2) {
    return c2 === "?" ? "\\?" : c2;
  }).join("|"), ")"));
  var matched = !r2.test(key);
  if (!matched) {
    var ki = key.indexOf(keySeparator);
    if (ki > 0 && !r2.test(key.substring(0, ki))) {
      matched = true;
    }
  }
  return matched;
}
function ownKeys$5(object, enumerableOnly) {
  var keys2 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread$5(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$5(Object(source), true).forEach(function(key) {
      _defineProperty$2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper$3(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$3() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
function deepFind(obj, path2) {
  var keySeparator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!obj)
    return void 0;
  if (obj[path2])
    return obj[path2];
  var paths = path2.split(keySeparator);
  var current = obj;
  for (var i2 = 0; i2 < paths.length; ++i2) {
    if (!current)
      return void 0;
    if (typeof current[paths[i2]] === "string" && i2 + 1 < paths.length) {
      return void 0;
    }
    if (current[paths[i2]] === void 0) {
      var j2 = 2;
      var p2 = paths.slice(i2, i2 + j2).join(keySeparator);
      var mix = current[p2];
      while (mix === void 0 && paths.length > i2 + j2) {
        j2++;
        p2 = paths.slice(i2, i2 + j2).join(keySeparator);
        mix = current[p2];
      }
      if (mix === void 0)
        return void 0;
      if (mix === null)
        return null;
      if (path2.endsWith(p2)) {
        if (typeof mix === "string")
          return mix;
        if (p2 && typeof mix[p2] === "string")
          return mix[p2];
      }
      var joinedPath = paths.slice(i2 + j2).join(keySeparator);
      if (joinedPath)
        return deepFind(mix, joinedPath, keySeparator);
      return void 0;
    }
    current = current[paths[i2]];
  }
  return current;
}
var ResourceStore = function(_EventEmitter) {
  _inherits(ResourceStore2, _EventEmitter);
  var _super = _createSuper$3(ResourceStore2);
  function ResourceStore2(data) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    _classCallCheck(this, ResourceStore2);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }
    _this.data = data || {};
    _this.options = options;
    if (_this.options.keySeparator === void 0) {
      _this.options.keySeparator = ".";
    }
    if (_this.options.ignoreJSONStructure === void 0) {
      _this.options.ignoreJSONStructure = true;
    }
    return _this;
  }
  _createClass(ResourceStore2, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);
      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      var keySeparator = options.keySeparator !== void 0 ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== void 0 ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path2 = [lng, ns];
      if (key && typeof key !== "string")
        path2 = path2.concat(key);
      if (key && typeof key === "string")
        path2 = path2.concat(keySeparator ? key.split(keySeparator) : key);
      if (lng.indexOf(".") > -1) {
        path2 = lng.split(".");
      }
      var result = getPath(this.data, path2);
      if (result || !ignoreJSONStructure || typeof key !== "string")
        return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === void 0)
        keySeparator = ".";
      var path2 = [lng, ns];
      if (key)
        path2 = path2.concat(keySeparator ? key.split(keySeparator) : key);
      if (lng.indexOf(".") > -1) {
        path2 = lng.split(".");
        value = ns;
        ns = path2[1];
      }
      this.addNamespaces(ns);
      setPath(this.data, path2, value);
      if (!options.silent)
        this.emit("added", lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources2) {
      var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        silent: false
      };
      for (var m2 in resources2) {
        if (typeof resources2[m2] === "string" || Object.prototype.toString.apply(resources2[m2]) === "[object Array]")
          this.addResource(lng, ns, m2, resources2[m2], {
            silent: true
          });
      }
      if (!options.silent)
        this.emit("added", lng, ns, resources2);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources2, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
        silent: false
      };
      var path2 = [lng, ns];
      if (lng.indexOf(".") > -1) {
        path2 = lng.split(".");
        deep = resources2;
        resources2 = ns;
        ns = path2[1];
      }
      this.addNamespaces(ns);
      var pack = getPath(this.data, path2) || {};
      if (deep) {
        deepExtend(pack, resources2, overwrite);
      } else {
        pack = _objectSpread$5(_objectSpread$5({}, pack), resources2);
      }
      setPath(this.data, path2, pack);
      if (!options.silent)
        this.emit("added", lng, ns, resources2);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }
      this.removeNamespaces(ns);
      this.emit("removed", lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== void 0;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns)
        ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === "v1")
        return _objectSpread$5(_objectSpread$5({}, {}), this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function hasLanguageSomeTranslations(lng) {
      var data = this.getDataByLanguage(lng);
      var n2 = data && Object.keys(data) || [];
      return !!n2.find(function(v2) {
        return data[v2] && Object.keys(data[v2]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);
  return ResourceStore2;
}(EventEmitter);
var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;
    processors.forEach(function(processor) {
      if (_this.processors[processor])
        value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};
function ownKeys$4$1(object, enumerableOnly) {
  var keys2 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread$4$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$4$1(Object(source), true).forEach(function(key) {
      _defineProperty$2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4$1(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper$2(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$2() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
var checkedLoadedFor = {};
var Translator = function(_EventEmitter) {
  _inherits(Translator2, _EventEmitter);
  var _super = _createSuper$2(Translator2);
  function Translator2(services) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck(this, Translator2);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }
    copy(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], services, _assertThisInitialized(_this));
    _this.options = options;
    if (_this.options.keySeparator === void 0) {
      _this.options.keySeparator = ".";
    }
    _this.logger = baseLogger.create("translator");
    return _this;
  }
  _createClass(Translator2, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng)
        this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      };
      if (key === void 0 || key === null) {
        return false;
      }
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== void 0;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== void 0 ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === void 0)
        nsSeparator = ":";
      var keySeparator = options.keySeparator !== void 0 ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS || [];
      var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        var m2 = key.match(this.interpolator.nestingRegexp);
        if (m2 && m2.length > 0) {
          return {
            key,
            namespaces
          };
        }
        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1)
          namespaces = parts.shift();
        key = parts.join(keySeparator);
      }
      if (typeof namespaces === "string")
        namespaces = [namespaces];
      return {
        key,
        namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate2(keys2, options, lastKey) {
      var _this2 = this;
      if (_typeof$1(options) !== "object" && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }
      if (!options)
        options = {};
      if (keys2 === void 0 || keys2 === null)
        return "";
      if (!Array.isArray(keys2))
        keys2 = [String(keys2)];
      var returnDetails = options.returnDetails !== void 0 ? options.returnDetails : this.options.returnDetails;
      var keySeparator = options.keySeparator !== void 0 ? options.keySeparator : this.options.keySeparator;
      var _this$extractFromKey = this.extractFromKey(keys2[keys2.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
      if (lng && lng.toLowerCase() === "cimode") {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          if (returnDetails) {
            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
            return resolved;
          }
          return "".concat(namespace).concat(nsSeparator).concat(key);
        }
        if (returnDetails) {
          resolved.res = key;
          return resolved;
        }
        return key;
      }
      var resolved = this.resolve(keys2, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ["[object Number]", "[object Function]", "[object RegExp]"];
      var joinArrays = options.joinArrays !== void 0 ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn("accessing an object - but returnObjects options is not enabled!");
          }
          var r2 = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$4$1(_objectSpread$4$1({}, options), {}, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
          if (returnDetails) {
            resolved.res = r2;
            return resolved;
          }
          return r2;
        }
        if (keySeparator) {
          var resTypeIsArray = resType === "[object Array]";
          var copy2 = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
          for (var m2 in res) {
            if (Object.prototype.hasOwnProperty.call(res, m2)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m2);
              copy2[m2] = this.translate(deepKey, _objectSpread$4$1(_objectSpread$4$1({}, options), {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy2[m2] === deepKey)
                copy2[m2] = res[m2];
            }
          }
          res = copy2;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
        res = res.join(joinArrays);
        if (res)
          res = this.extendTranslation(res, keys2, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== void 0 && typeof options.count !== "string";
        var hasDefaultValue = Translator2.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }
        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }
        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? void 0 : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$4$1(_objectSpread$4$1({}, options), {}, {
              keySeparator: false
            }));
            if (fk && fk.res)
              this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
          }
          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
          if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) {
            for (var i2 = 0; i2 < fallbackLngs.length; i2++) {
              lngs.push(fallbackLngs[i2]);
            }
          } else if (this.options.saveMissingTo === "all") {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }
          var send = function send2(l2, k2, specificDefaultValue) {
            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l2, namespace, k2, defaultForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l2, namespace, k2, defaultForMissing, updateMissing, options);
            }
            _this2.emit("missingKey", l2, namespace, k2, res);
          };
          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function(language) {
                _this2.pluralResolver.getSuffixes(language, options).forEach(function(suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }
        res = this.extendTranslation(res, keys2, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey)
          res = "".concat(namespace, ":").concat(key);
        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== "v1") {
            res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : void 0);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }
      if (returnDetails) {
        resolved.res = res;
        return resolved;
      }
      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;
      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, _objectSpread$4$1(_objectSpread$4$1({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation)
          this.interpolator.init(_objectSpread$4$1(_objectSpread$4$1({}, options), {
            interpolation: _objectSpread$4$1(_objectSpread$4$1({}, this.options.interpolation), options.interpolation)
          }));
        var skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== void 0 ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        var nestBef;
        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }
        var data = options.replace && typeof options.replace !== "string" ? options.replace : options;
        if (this.options.interpolation.defaultVariables)
          data = _objectSpread$4$1(_objectSpread$4$1({}, this.options.interpolation.defaultVariables), data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft)
            options.nest = false;
        }
        if (options.nest !== false)
          res = this.interpolator.nest(res, function() {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            if (lastKey && lastKey[0] === args[0] && !options.context) {
              _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
              return null;
            }
            return _this3.translate.apply(_this3, args.concat([key]));
          }, options);
        if (options.interpolation)
          this.interpolator.reset();
      }
      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === "string" ? [postProcess] : postProcess;
      if (res !== void 0 && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$4$1({
          i18nResolved: resolved
        }, options) : options, this);
      }
      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys2) {
      var _this4 = this;
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys2 === "string")
        keys2 = [keys2];
      keys2.forEach(function(k2) {
        if (_this4.isValidLookup(found))
          return;
        var extracted = _this4.extractFromKey(k2, options);
        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS)
          namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== void 0 && typeof options.count !== "string";
        var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
        var needsContextHandling = options.context !== void 0 && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function(ns) {
          if (_this4.isValidLookup(found))
            return;
          usedNS = ns;
          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
            _this4.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(", "), `" won't get resolved as namespace "`).concat(usedNS, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
          }
          codes.forEach(function(code) {
            if (_this4.isValidLookup(found))
              return;
            usedLng = code;
            var finalKeys = [key];
            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling)
                pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
              var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);
                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }
              if (needsContextHandling) {
                var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                finalKeys.push(contextKey);
                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);
                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }
            var possibleKey;
            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey,
        exactUsedKey,
        usedLng,
        usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== void 0 && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource)
        return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = "defaultValue";
      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && void 0 !== options[option]) {
          return true;
        }
      }
      return false;
    }
  }]);
  return Translator2;
}(EventEmitter);
function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
var LanguageUtil = function() {
  function LanguageUtil2(options) {
    _classCallCheck(this, LanguageUtil2);
    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create("languageUtils");
  }
  _createClass(LanguageUtil2, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf("-") < 0)
        return null;
      var p2 = code.split("-");
      if (p2.length === 2)
        return null;
      p2.pop();
      if (p2[p2.length - 1].toLowerCase() === "x")
        return null;
      return this.formatLanguageCode(p2.join("-"));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf("-") < 0)
        return code;
      var p2 = code.split("-");
      return this.formatLanguageCode(p2[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === "string" && code.indexOf("-") > -1) {
        var specialCases = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
        var p2 = code.split("-");
        if (this.options.lowerCaseLng) {
          p2 = p2.map(function(part) {
            return part.toLowerCase();
          });
        } else if (p2.length === 2) {
          p2[0] = p2[0].toLowerCase();
          p2[1] = p2[1].toUpperCase();
          if (specialCases.indexOf(p2[1].toLowerCase()) > -1)
            p2[1] = capitalize(p2[1].toLowerCase());
        } else if (p2.length === 3) {
          p2[0] = p2[0].toLowerCase();
          if (p2[1].length === 2)
            p2[1] = p2[1].toUpperCase();
          if (p2[0] !== "sgn" && p2[2].length === 2)
            p2[2] = p2[2].toUpperCase();
          if (specialCases.indexOf(p2[1].toLowerCase()) > -1)
            p2[1] = capitalize(p2[1].toLowerCase());
          if (specialCases.indexOf(p2[2].toLowerCase()) > -1)
            p2[2] = capitalize(p2[2].toLowerCase());
        }
        return p2.join("-");
      }
      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }
      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;
      if (!codes)
        return null;
      var found;
      codes.forEach(function(code) {
        if (found)
          return;
        var cleanedLng = _this.formatLanguageCode(code);
        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng))
          found = cleanedLng;
      });
      if (!found && this.options.supportedLngs) {
        codes.forEach(function(code) {
          if (found)
            return;
          var lngOnly = _this.getLanguagePartFromCode(code);
          if (_this.isSupportedCode(lngOnly))
            return found = lngOnly;
          found = _this.options.supportedLngs.find(function(supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0)
              return supportedLng;
          });
        });
      }
      if (!found)
        found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks)
        return [];
      if (typeof fallbacks === "function")
        fallbacks = fallbacks(code);
      if (typeof fallbacks === "string")
        fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === "[object Array]")
        return fallbacks;
      if (!code)
        return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found)
        found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found)
        found = fallbacks[this.formatLanguageCode(code)];
      if (!found)
        found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found)
        found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;
      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];
      var addCode = function addCode2(c2) {
        if (!c2)
          return;
        if (_this2.isSupportedCode(c2)) {
          codes.push(c2);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c2));
        }
      };
      if (typeof code === "string" && code.indexOf("-") > -1) {
        if (this.options.load !== "languageOnly")
          addCode(this.formatLanguageCode(code));
        if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly")
          addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== "currentOnly")
          addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === "string") {
        addCode(this.formatLanguageCode(code));
      }
      fallbackCodes.forEach(function(fc) {
        if (codes.indexOf(fc) < 0)
          addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);
  return LanguageUtil2;
}();
var sets = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n2) {
    return Number(n2 > 1);
  },
  2: function _2(n2) {
    return Number(n2 != 1);
  },
  3: function _3(n2) {
    return 0;
  },
  4: function _4(n2) {
    return Number(n2 % 10 == 1 && n2 % 100 != 11 ? 0 : n2 % 10 >= 2 && n2 % 10 <= 4 && (n2 % 100 < 10 || n2 % 100 >= 20) ? 1 : 2);
  },
  5: function _5(n2) {
    return Number(n2 == 0 ? 0 : n2 == 1 ? 1 : n2 == 2 ? 2 : n2 % 100 >= 3 && n2 % 100 <= 10 ? 3 : n2 % 100 >= 11 ? 4 : 5);
  },
  6: function _6(n2) {
    return Number(n2 == 1 ? 0 : n2 >= 2 && n2 <= 4 ? 1 : 2);
  },
  7: function _7(n2) {
    return Number(n2 == 1 ? 0 : n2 % 10 >= 2 && n2 % 10 <= 4 && (n2 % 100 < 10 || n2 % 100 >= 20) ? 1 : 2);
  },
  8: function _8(n2) {
    return Number(n2 == 1 ? 0 : n2 == 2 ? 1 : n2 != 8 && n2 != 11 ? 2 : 3);
  },
  9: function _9(n2) {
    return Number(n2 >= 2);
  },
  10: function _10(n2) {
    return Number(n2 == 1 ? 0 : n2 == 2 ? 1 : n2 < 7 ? 2 : n2 < 11 ? 3 : 4);
  },
  11: function _11(n2) {
    return Number(n2 == 1 || n2 == 11 ? 0 : n2 == 2 || n2 == 12 ? 1 : n2 > 2 && n2 < 20 ? 2 : 3);
  },
  12: function _12(n2) {
    return Number(n2 % 10 != 1 || n2 % 100 == 11);
  },
  13: function _13(n2) {
    return Number(n2 !== 0);
  },
  14: function _14(n2) {
    return Number(n2 == 1 ? 0 : n2 == 2 ? 1 : n2 == 3 ? 2 : 3);
  },
  15: function _15(n2) {
    return Number(n2 % 10 == 1 && n2 % 100 != 11 ? 0 : n2 % 10 >= 2 && (n2 % 100 < 10 || n2 % 100 >= 20) ? 1 : 2);
  },
  16: function _16(n2) {
    return Number(n2 % 10 == 1 && n2 % 100 != 11 ? 0 : n2 !== 0 ? 1 : 2);
  },
  17: function _17(n2) {
    return Number(n2 == 1 || n2 % 10 == 1 && n2 % 100 != 11 ? 0 : 1);
  },
  18: function _18(n2) {
    return Number(n2 == 0 ? 0 : n2 == 1 ? 1 : 2);
  },
  19: function _19(n2) {
    return Number(n2 == 1 ? 0 : n2 == 0 || n2 % 100 > 1 && n2 % 100 < 11 ? 1 : n2 % 100 > 10 && n2 % 100 < 20 ? 2 : 3);
  },
  20: function _20(n2) {
    return Number(n2 == 1 ? 0 : n2 == 0 || n2 % 100 > 0 && n2 % 100 < 20 ? 1 : 2);
  },
  21: function _21(n2) {
    return Number(n2 % 100 == 1 ? 1 : n2 % 100 == 2 ? 2 : n2 % 100 == 3 || n2 % 100 == 4 ? 3 : 0);
  },
  22: function _22(n2) {
    return Number(n2 == 1 ? 0 : n2 == 2 ? 1 : (n2 < 0 || n2 > 10) && n2 % 10 == 0 ? 2 : 3);
  }
};
var deprecatedJsonVersions = ["v1", "v2", "v3"];
var suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function createRules() {
  var rules = {};
  sets.forEach(function(set) {
    set.lngs.forEach(function(l2) {
      rules[l2] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}
var PluralResolver = function() {
  function PluralResolver2(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck(this, PluralResolver2);
    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create("pluralResolver");
    if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl === "undefined" || !Intl.PluralRules)) {
      this.options.compatibilityJSON = "v3";
      this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
    }
    this.rules = createRules();
  }
  _createClass(PluralResolver2, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (this.shouldUseIntlApi()) {
        try {
          return new Intl.PluralRules(code, {
            type: options.ordinal ? "ordinal" : "cardinal"
          });
        } catch (_unused) {
          return;
        }
      }
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var rule = this.getRule(code, options);
      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return this.getSuffixes(code, options).map(function(suffix) {
        return "".concat(key).concat(suffix);
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var rule = this.getRule(code, options);
      if (!rule) {
        return [];
      }
      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
          return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
        }).map(function(pluralCategory) {
          return "".concat(_this.options.prepend).concat(pluralCategory);
        });
      }
      return rule.numbers.map(function(number) {
        return _this.getSuffix(code, number, options);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      var rule = this.getRule(code, options);
      if (rule) {
        if (this.shouldUseIntlApi()) {
          return "".concat(this.options.prepend).concat(rule.select(count));
        }
        return this.getSuffixRetroCompatible(rule, count);
      }
      this.logger.warn("no plural rule found for: ".concat(code));
      return "";
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function getSuffixRetroCompatible(rule, count) {
      var _this2 = this;
      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = "plural";
        } else if (suffix === 1) {
          suffix = "";
        }
      }
      var returnSuffix = function returnSuffix2() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };
      if (this.options.compatibilityJSON === "v1") {
        if (suffix === 1)
          return "";
        if (typeof suffix === "number")
          return "_plural_".concat(suffix.toString());
        return returnSuffix();
      } else if (this.options.compatibilityJSON === "v2") {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function shouldUseIntlApi() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]);
  return PluralResolver2;
}();
function ownKeys$3$1(object, enumerableOnly) {
  var keys2 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread$3$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$3$1(Object(source), true).forEach(function(key) {
      _defineProperty$2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3$1(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var Interpolator = function() {
  function Interpolator2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck(this, Interpolator2);
    this.logger = baseLogger.create("interpolator");
    this.options = options;
    this.format = options.interpolation && options.interpolation.format || function(value) {
      return value;
    };
    this.init(options);
  }
  _createClass(Interpolator2, [{
    key: "init",
    value: function init2() {
      var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (!options.interpolation)
        options.interpolation = {
          escapeValue: true
        };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== void 0 ? iOpts.escape : escape;
      this.escapeValue = iOpts.escapeValue !== void 0 ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== void 0 ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
      this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
      this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape("$t(");
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(")");
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1e3;
      this.alwaysFormat = iOpts.alwaysFormat !== void 0 ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options)
        this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, "g");
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;
      var match2;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
      function regexSafe(val) {
        return val.replace(/\$/g, "$$$$");
      }
      var handleFormat = function handleFormat2(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path2 = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path2, void 0, lng, _objectSpread$3$1(_objectSpread$3$1(_objectSpread$3$1({}, options), data), {}, {
            interpolationkey: key
          })) : path2;
        }
        var p2 = key.split(_this.formatSeparator);
        var k2 = p2.shift().trim();
        var f2 = p2.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k2), f2, lng, _objectSpread$3$1(_objectSpread$3$1(_objectSpread$3$1({}, options), data), {}, {
          interpolationkey: k2
        }));
      };
      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== void 0 ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function(todo) {
        replaces = 0;
        while (match2 = todo.regex.exec(str)) {
          var matchedVar = match2[1].trim();
          value = handleFormat(matchedVar);
          if (value === void 0) {
            if (typeof missingInterpolationHandler === "function") {
              var temp = missingInterpolationHandler(str, match2, options);
              value = typeof temp === "string" ? temp : "";
            } else if (options && options.hasOwnProperty(matchedVar)) {
              value = "";
            } else if (skipOnVariables) {
              value = match2[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
              value = "";
            }
          } else if (typeof value !== "string" && !_this.useRawValueToEscape) {
            value = makeString(value);
          }
          var safeValue = todo.safeValue(value);
          str = str.replace(match2[0], safeValue);
          if (skipOnVariables) {
            todo.regex.lastIndex += value.length;
            todo.regex.lastIndex -= match2[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }
          replaces++;
          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      var match2;
      var value;
      var clonedOptions;
      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0)
          return key;
        var c2 = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c2[1]);
        key = c2[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        var matchedSingleQuotes = optionsString.match(/'/g);
        var matchedDoubleQuotes = optionsString.match(/"/g);
        if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
          optionsString = optionsString.replace(/'/g, '"');
        }
        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions)
            clonedOptions = _objectSpread$3$1(_objectSpread$3$1({}, inheritedOptions), clonedOptions);
        } catch (e2) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e2);
          return "".concat(key).concat(sep).concat(optionsString);
        }
        delete clonedOptions.defaultValue;
        return key;
      }
      while (match2 = this.nestingRegexp.exec(str)) {
        var formatters = [];
        clonedOptions = _objectSpread$3$1({}, options);
        clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
        clonedOptions.applyPostProcessor = false;
        delete clonedOptions.defaultValue;
        var doReduce = false;
        if (match2[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match2[1])) {
          var r2 = match2[1].split(this.formatSeparator).map(function(elem) {
            return elem.trim();
          });
          match2[1] = r2.shift();
          formatters = r2;
          doReduce = true;
        }
        value = fc(handleHasOptions.call(this, match2[1].trim(), clonedOptions), clonedOptions);
        if (value && match2[0] === str && typeof value !== "string")
          return value;
        if (typeof value !== "string")
          value = makeString(value);
        if (!value) {
          this.logger.warn("missed to resolve ".concat(match2[1], " for nesting ").concat(str));
          value = "";
        }
        if (doReduce) {
          value = formatters.reduce(function(v2, f2) {
            return _this2.format(v2, f2, options.lng, _objectSpread$3$1(_objectSpread$3$1({}, options), {}, {
              interpolationkey: match2[1].trim()
            }));
          }, value.trim());
        }
        str = str.replace(match2[0], value);
        this.regexp.lastIndex = 0;
      }
      return str;
    }
  }]);
  return Interpolator2;
}();
function ownKeys$2$1(object, enumerableOnly) {
  var keys2 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread$2$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$2$1(Object(source), true).forEach(function(key) {
      _defineProperty$2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2$1(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function parseFormatStr(formatStr) {
  var formatName = formatStr.toLowerCase().trim();
  var formatOptions = {};
  if (formatStr.indexOf("(") > -1) {
    var p2 = formatStr.split("(");
    formatName = p2[0].toLowerCase().trim();
    var optStr = p2[1].substring(0, p2[1].length - 1);
    if (formatName === "currency" && optStr.indexOf(":") < 0) {
      if (!formatOptions.currency)
        formatOptions.currency = optStr.trim();
    } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
      if (!formatOptions.range)
        formatOptions.range = optStr.trim();
    } else {
      var opts = optStr.split(";");
      opts.forEach(function(opt) {
        if (!opt)
          return;
        var _opt$split = opt.split(":"), _opt$split2 = _toArray(_opt$split), key = _opt$split2[0], rest = _opt$split2.slice(1);
        var val = rest.join(":").trim().replace(/^'+|'+$/g, "");
        if (!formatOptions[key.trim()])
          formatOptions[key.trim()] = val;
        if (val === "false")
          formatOptions[key.trim()] = false;
        if (val === "true")
          formatOptions[key.trim()] = true;
        if (!isNaN(val))
          formatOptions[key.trim()] = parseInt(val, 10);
      });
    }
  }
  return {
    formatName,
    formatOptions
  };
}
function createCachedFormatter(fn) {
  var cache = {};
  return function invokeFormatter(val, lng, options) {
    var key = lng + JSON.stringify(options);
    var formatter2 = cache[key];
    if (!formatter2) {
      formatter2 = fn(lng, options);
      cache[key] = formatter2;
    }
    return formatter2(val);
  };
}
var Formatter$1 = function() {
  function Formatter2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck(this, Formatter2);
    this.logger = baseLogger.create("formatter");
    this.options = options;
    this.formats = {
      number: createCachedFormatter(function(lng, options2) {
        var formatter2 = new Intl.NumberFormat(lng, options2);
        return function(val) {
          return formatter2.format(val);
        };
      }),
      currency: createCachedFormatter(function(lng, options2) {
        var formatter2 = new Intl.NumberFormat(lng, _objectSpread$2$1(_objectSpread$2$1({}, options2), {}, {
          style: "currency"
        }));
        return function(val) {
          return formatter2.format(val);
        };
      }),
      datetime: createCachedFormatter(function(lng, options2) {
        var formatter2 = new Intl.DateTimeFormat(lng, _objectSpread$2$1({}, options2));
        return function(val) {
          return formatter2.format(val);
        };
      }),
      relativetime: createCachedFormatter(function(lng, options2) {
        var formatter2 = new Intl.RelativeTimeFormat(lng, _objectSpread$2$1({}, options2));
        return function(val) {
          return formatter2.format(val, options2.range || "day");
        };
      }),
      list: createCachedFormatter(function(lng, options2) {
        var formatter2 = new Intl.ListFormat(lng, _objectSpread$2$1({}, options2));
        return function(val) {
          return formatter2.format(val);
        };
      })
    };
    this.init(options);
  }
  _createClass(Formatter2, [{
    key: "init",
    value: function init2(services) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      };
      var iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
    }
  }, {
    key: "add",
    value: function add2(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
  }, {
    key: "addCached",
    value: function addCached(name, fc) {
      this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
    }
  }, {
    key: "format",
    value: function format(value, _format, lng, options) {
      var _this = this;
      var formats = _format.split(this.formatSeparator);
      var result = formats.reduce(function(mem, f2) {
        var _parseFormatStr = parseFormatStr(f2), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
        if (_this.formats[formatName]) {
          var formatted = mem;
          try {
            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            var l2 = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = _this.formats[formatName](mem, l2, _objectSpread$2$1(_objectSpread$2$1(_objectSpread$2$1({}, formatOptions), options), valOptions));
          } catch (error2) {
            _this.logger.warn(error2);
          }
          return formatted;
        } else {
          _this.logger.warn("there was no format function for ".concat(formatName));
        }
        return mem;
      }, value);
      return result;
    }
  }]);
  return Formatter2;
}();
function ownKeys$1$1(object, enumerableOnly) {
  var keys2 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread$1$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$1$1(Object(source), true).forEach(function(key) {
      _defineProperty$2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1$1(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
function removePending(q, name) {
  if (q.pending[name] !== void 0) {
    delete q.pending[name];
    q.pendingCount--;
  }
}
var Connector = function(_EventEmitter) {
  _inherits(Connector2, _EventEmitter);
  var _super = _createSuper$1(Connector2);
  function Connector2(backend, store, services) {
    var _this;
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    _classCallCheck(this, Connector2);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }
    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create("backendConnector");
    _this.waitingReads = [];
    _this.maxParallelReads = options.maxParallelReads || 10;
    _this.readingCalls = 0;
    _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    _this.state = {};
    _this.queue = [];
    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }
    return _this;
  }
  _createClass(Connector2, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;
      var toLoad = {};
      var pending = {};
      var toLoadLanguages = {};
      var toLoadNamespaces = {};
      languages.forEach(function(lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function(ns) {
          var name = "".concat(lng, "|").concat(ns);
          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0)
            ;
          else if (_this2.state[name] === 1) {
            if (pending[name] === void 0)
              pending[name] = true;
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending[name] === void 0)
              pending[name] = true;
            if (toLoad[name] === void 0)
              toLoad[name] = true;
            if (toLoadNamespaces[ns] === void 0)
              toLoadNamespaces[ns] = true;
          }
        });
        if (!hasAllNamespaces)
          toLoadLanguages[lng] = true;
      });
      if (Object.keys(toLoad).length || Object.keys(pending).length) {
        this.queue.push({
          pending,
          pendingCount: Object.keys(pending).length,
          loaded: {},
          errors: [],
          callback
        });
      }
      return {
        toLoad: Object.keys(toLoad),
        pending: Object.keys(pending),
        toLoadLanguages: Object.keys(toLoadLanguages),
        toLoadNamespaces: Object.keys(toLoadNamespaces)
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s2 = name.split("|");
      var lng = s2[0];
      var ns = s2[1];
      if (err)
        this.emit("failedLoading", lng, ns, err);
      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }
      this.state[name] = err ? -1 : 2;
      var loaded2 = {};
      this.queue.forEach(function(q) {
        pushPath(q.loaded, [lng], ns);
        removePending(q, name);
        if (err)
          q.errors.push(err);
        if (q.pendingCount === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function(l2) {
            if (!loaded2[l2])
              loaded2[l2] = {};
            var loadedKeys = q.loaded[l2];
            if (loadedKeys.length) {
              loadedKeys.forEach(function(ns2) {
                if (loaded2[l2][ns2] === void 0)
                  loaded2[l2][ns2] = true;
              });
            }
          });
          q.done = true;
          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit("loaded", loaded2);
      this.queue = this.queue.filter(function(q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read2(lng, ns, fcName) {
      var _this3 = this;
      var tried = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout;
      var callback = arguments.length > 5 ? arguments[5] : void 0;
      if (!lng.length)
        return callback(null, {});
      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng,
          ns,
          fcName,
          tried,
          wait,
          callback
        });
        return;
      }
      this.readingCalls++;
      var resolver = function resolver2(err, data) {
        _this3.readingCalls--;
        if (_this3.waitingReads.length > 0) {
          var next = _this3.waitingReads.shift();
          _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
        }
        if (err && data && tried < _this3.maxRetries) {
          setTimeout(function() {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }
        callback(err, data);
      };
      var fc = this.backend[fcName].bind(this.backend);
      if (fc.length === 2) {
        try {
          var r2 = fc(lng, ns);
          if (r2 && typeof r2.then === "function") {
            r2.then(function(data) {
              return resolver(null, data);
            })["catch"](resolver);
          } else {
            resolver(null, r2);
          }
        } catch (err) {
          resolver(err);
        }
        return;
      }
      return fc(lng, ns, resolver);
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : void 0;
      if (!this.backend) {
        this.logger.warn("No backend was added via i18next.use. Will not load resources.");
        return callback && callback();
      }
      if (typeof languages === "string")
        languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === "string")
        namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);
      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length)
          callback();
        return null;
      }
      toLoad.toLoad.forEach(function(name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;
      var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      var s2 = name.split("|");
      var lng = s2[0];
      var ns = s2[1];
      this.read(lng, ns, "read", void 0, void 0, function(err, data) {
        if (err)
          _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data)
          _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
      var clb = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : function() {
      };
      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
        return;
      }
      if (key === void 0 || key === null || key === "")
        return;
      if (this.backend && this.backend.create) {
        var opts = _objectSpread$1$1(_objectSpread$1$1({}, options), {}, {
          isUpdate
        });
        var fc = this.backend.create.bind(this.backend);
        if (fc.length < 6) {
          try {
            var r2;
            if (fc.length === 5) {
              r2 = fc(languages, namespace, key, fallbackValue, opts);
            } else {
              r2 = fc(languages, namespace, key, fallbackValue);
            }
            if (r2 && typeof r2.then === "function") {
              r2.then(function(data) {
                return clb(null, data);
              })["catch"](clb);
            } else {
              clb(null, r2);
            }
          } catch (err) {
            clb(err);
          }
        } else {
          fc(languages, namespace, key, fallbackValue, clb, opts);
        }
      }
      if (!languages || !languages[0])
        return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);
  return Connector2;
}(EventEmitter);
function get$2() {
  return {
    debug: false,
    initImmediate: true,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: "all",
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: "fallback",
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle2(args) {
      var ret = {};
      if (_typeof$1(args[1]) === "object")
        ret = args[1];
      if (typeof args[1] === "string")
        ret.defaultValue = args[1];
      if (typeof args[2] === "string")
        ret.tDescription = args[2];
      if (_typeof$1(args[2]) === "object" || _typeof$1(args[3]) === "object") {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function(key) {
          ret[key] = options[key];
        });
      }
      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === "string")
    options.ns = [options.ns];
  if (typeof options.fallbackLng === "string")
    options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === "string")
    options.fallbackNS = [options.fallbackNS];
  if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) {
    options.supportedLngs = options.supportedLngs.concat(["cimode"]);
  }
  return options;
}
function ownKeys$7(object, enumerableOnly) {
  var keys2 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread$7(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$7(Object(source), true).forEach(function(key) {
      _defineProperty$2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
function noop() {
}
function bindMemberFunctions(inst) {
  var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(function(mem) {
    if (typeof inst[mem] === "function") {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}
var I18n = function(_EventEmitter) {
  _inherits(I18n2, _EventEmitter);
  var _super = _createSuper(I18n2);
  function I18n2() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : void 0;
    _classCallCheck(this, I18n2);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }
    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };
    bindMemberFunctions(_assertThisInitialized(_this));
    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);
        return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
      }
      setTimeout(function() {
        _this.init(options, callback);
      }, 0);
    }
    return _this;
  }
  _createClass(I18n2, [{
    key: "init",
    value: function init2() {
      var _this2 = this;
      var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : void 0;
      if (typeof options === "function") {
        callback = options;
        options = {};
      }
      if (!options.defaultNS && options.defaultNS !== false && options.ns) {
        if (typeof options.ns === "string") {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf("translation") < 0) {
          options.defaultNS = options.ns[0];
        }
      }
      var defOpts = get$2();
      this.options = _objectSpread$7(_objectSpread$7(_objectSpread$7({}, defOpts), this.options), transformOptions(options));
      if (this.options.compatibilityAPI !== "v1") {
        this.options.interpolation = _objectSpread$7(_objectSpread$7({}, defOpts.interpolation), this.options.interpolation);
      }
      if (options.keySeparator !== void 0) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }
      if (options.nsSeparator !== void 0) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }
      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject)
          return null;
        if (typeof ClassOrObject === "function")
          return new ClassOrObject();
        return ClassOrObject;
      }
      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }
        var formatter2;
        if (this.modules.formatter) {
          formatter2 = this.modules.formatter;
        } else if (typeof Intl !== "undefined") {
          formatter2 = Formatter$1;
        }
        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s2 = this.services;
        s2.logger = baseLogger;
        s2.resourceStore = this.store;
        s2.languageUtils = lu;
        s2.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        if (formatter2 && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s2.formatter = createClassOnDemand(formatter2);
          s2.formatter.init(s2, this.options);
          this.options.interpolation.format = s2.formatter.format.bind(s2.formatter);
        }
        s2.interpolator = new Interpolator(this.options);
        s2.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s2.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s2.resourceStore, s2, this.options);
        s2.backendConnector.on("*", function(event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          _this2.emit.apply(_this2, [event].concat(args));
        });
        if (this.modules.languageDetector) {
          s2.languageDetector = createClassOnDemand(this.modules.languageDetector);
          if (s2.languageDetector.init)
            s2.languageDetector.init(s2, this.options.detection, this.options);
        }
        if (this.modules.i18nFormat) {
          s2.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s2.i18nFormat.init)
            s2.i18nFormat.init(this);
        }
        this.translator = new Translator(this.services, this.options);
        this.translator.on("*", function(event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function(m2) {
          if (m2.init)
            m2.init(_this2);
        });
      }
      this.format = this.options.interpolation.format;
      if (!callback)
        callback = noop;
      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== "dev")
          this.options.lng = codes[0];
      }
      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn("init: no languageDetector is used and no lng is defined");
      }
      var storeApi = ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"];
      storeApi.forEach(function(fcName) {
        _this2[fcName] = function() {
          var _this2$store;
          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"];
      storeApiChained.forEach(function(fcName) {
        _this2[fcName] = function() {
          var _this2$store2;
          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
          return _this2;
        };
      });
      var deferred = defer();
      var load = function load2() {
        var finish = function finish2(err, t2) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce)
            _this2.logger.warn("init: i18next is already initialized. You should call init just once!");
          _this2.isInitialized = true;
          if (!_this2.options.isClone)
            _this2.logger.log("initialized", _this2.options);
          _this2.emit("initialized", _this2.options);
          deferred.resolve(t2);
          callback(err, t2);
        };
        if (_this2.languages && _this2.options.compatibilityAPI !== "v1" && !_this2.isInitialized)
          return finish(null, _this2.t.bind(_this2));
        _this2.changeLanguage(_this2.options.lng, finish);
      };
      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }
      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;
      var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === "string" ? language : this.language;
      if (typeof language === "function")
        usedCallback = language;
      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === "cimode")
          return usedCallback();
        var toLoad = [];
        var append = function append2(lng) {
          if (!lng)
            return;
          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
          lngs.forEach(function(l2) {
            if (toLoad.indexOf(l2) < 0)
              toLoad.push(l2);
          });
        };
        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function(l2) {
            return append(l2);
          });
        } else {
          append(usedLng);
        }
        if (this.options.preload) {
          this.options.preload.forEach(function(l2) {
            return append(l2);
          });
        }
        this.services.backendConnector.load(toLoad, this.options.ns, function(e2) {
          if (!e2 && !_this3.resolvedLanguage && _this3.language)
            _this3.setResolvedLanguage(_this3.language);
          usedCallback(e2);
        });
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs)
        lngs = this.languages;
      if (!ns)
        ns = this.options.ns;
      if (!callback)
        callback = noop;
      this.services.backendConnector.reload(lngs, ns, function(err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module)
        throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
      if (!module.type)
        throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
      if (module.type === "backend") {
        this.modules.backend = module;
      }
      if (module.type === "logger" || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }
      if (module.type === "languageDetector") {
        this.modules.languageDetector = module;
      }
      if (module.type === "i18nFormat") {
        this.modules.i18nFormat = module;
      }
      if (module.type === "postProcessor") {
        postProcessor.addPostProcessor(module);
      }
      if (module.type === "formatter") {
        this.modules.formatter = module;
      }
      if (module.type === "3rdParty") {
        this.modules.external.push(module);
      }
      return this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function setResolvedLanguage(l2) {
      if (!l2 || !this.languages)
        return;
      if (["cimode", "dev"].indexOf(l2) > -1)
        return;
      for (var li = 0; li < this.languages.length; li++) {
        var lngInLngs = this.languages[li];
        if (["cimode", "dev"].indexOf(lngInLngs) > -1)
          continue;
        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;
      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit("languageChanging", lng);
      var setLngProps = function setLngProps2(l2) {
        _this4.language = l2;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l2);
        _this4.resolvedLanguage = void 0;
        _this4.setResolvedLanguage(l2);
      };
      var done = function done2(err, l2) {
        if (l2) {
          setLngProps(l2);
          _this4.translator.changeLanguage(l2);
          _this4.isLanguageChangingTo = void 0;
          _this4.emit("languageChanged", l2);
          _this4.logger.log("languageChanged", l2);
        } else {
          _this4.isLanguageChangingTo = void 0;
        }
        deferred.resolve(function() {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback)
          callback(err, function() {
            return _this4.t.apply(_this4, arguments);
          });
      };
      var setLng = function setLng2(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector)
          lngs = [];
        var l2 = typeof lngs === "string" ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
        if (l2) {
          if (!_this4.language) {
            setLngProps(l2);
          }
          if (!_this4.translator.language)
            _this4.translator.changeLanguage(l2);
          if (_this4.services.languageDetector && _this4.services.languageDetector.cacheUserLanguage)
            _this4.services.languageDetector.cacheUserLanguage(l2);
        }
        _this4.loadResources(l2, function(err) {
          done(err, l2);
        });
      };
      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        if (this.services.languageDetector.detect.length === 0) {
          this.services.languageDetector.detect().then(setLng);
        } else {
          this.services.languageDetector.detect(setLng);
        }
      } else {
        setLng(lng);
      }
      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;
      var fixedT = function fixedT2(key, opts) {
        var options;
        if (_typeof$1(opts) !== "object") {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }
          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread$7({}, opts);
        }
        options.lng = options.lng || fixedT2.lng;
        options.lngs = options.lngs || fixedT2.lngs;
        options.ns = options.ns || fixedT2.ns;
        options.keyPrefix = options.keyPrefix || keyPrefix || fixedT2.keyPrefix;
        var keySeparator = _this5.options.keySeparator || ".";
        var resultKey;
        if (options.keyPrefix && Array.isArray(key)) {
          resultKey = key.map(function(k2) {
            return "".concat(options.keyPrefix).concat(keySeparator).concat(k2);
          });
        } else {
          resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
        }
        return _this5.t(resultKey, options);
      };
      if (typeof lng === "string") {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }
      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t2() {
      var _this$translator;
      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;
      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace2(ns) {
      var _this6 = this;
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (!this.isInitialized) {
        this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
        return false;
      }
      if (!this.languages || !this.languages.length) {
        this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
        return false;
      }
      var lng = this.resolvedLanguage || this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === "cimode")
        return true;
      var loadNotPending = function loadNotPending2(l2, n2) {
        var loadState = _this6.services.backendConnector.state["".concat(l2, "|").concat(n2)];
        return loadState === -1 || loadState === 2;
      };
      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== void 0)
          return preResult;
      }
      if (this.hasResourceBundle(lng, ns))
        return true;
      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages)
        return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns)))
        return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces2(ns, callback) {
      var _this7 = this;
      var deferred = defer();
      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }
      if (typeof ns === "string")
        ns = [ns];
      ns.forEach(function(n2) {
        if (_this7.options.ns.indexOf(n2) < 0)
          _this7.options.ns.push(n2);
      });
      this.loadResources(function(err) {
        deferred.resolve();
        if (callback)
          callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === "string")
        lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function(lng) {
        return preloaded.indexOf(lng) < 0;
      });
      if (!newLngs.length) {
        if (callback)
          callback();
        return Promise.resolve();
      }
      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function(err) {
        deferred.resolve();
        if (callback)
          callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng)
        lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng)
        return "rtl";
      var rtlLngs = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"];
      var languageUtils = this.services && this.services.languageUtils || new LanguageUtil(get$2());
      return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;
      var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
      var mergedOptions = _objectSpread$7(_objectSpread$7(_objectSpread$7({}, this.options), options), {
        isClone: true
      });
      var clone2 = new I18n2(mergedOptions);
      if (options.debug !== void 0 || options.prefix !== void 0) {
        clone2.logger = clone2.logger.clone(options);
      }
      var membersToCopy = ["store", "services", "language"];
      membersToCopy.forEach(function(m2) {
        clone2[m2] = _this8[m2];
      });
      clone2.services = _objectSpread$7({}, this.services);
      clone2.services.utils = {
        hasLoadedNamespace: clone2.hasLoadedNamespace.bind(clone2)
      };
      clone2.translator = new Translator(clone2.services, clone2.options);
      clone2.translator.on("*", function(event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }
        clone2.emit.apply(clone2, [event].concat(args));
      });
      clone2.init(mergedOptions, callback);
      clone2.translator.options = clone2.options;
      clone2.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone2.hasLoadedNamespace.bind(clone2)
      };
      return clone2;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]);
  return I18n2;
}(EventEmitter);
_defineProperty$2(I18n, "createInstance", function() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : void 0;
  return new I18n(options, callback);
});
var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
instance.createInstance;
instance.dir;
instance.init;
instance.loadResources;
instance.reloadResources;
instance.use;
instance.changeLanguage;
instance.getFixedT;
instance.t;
instance.exists;
instance.setDefaultNamespace;
instance.hasLoadedNamespace;
instance.loadNamespaces;
instance.loadLanguages;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key = sourceSymbolKeys[i2];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var voidElements = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "link": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};
var t$1 = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function n$3(n2) {
  var r2 = { type: "tag", name: "", voidElement: false, attrs: {}, children: [] }, i2 = n2.match(/<\/?([^\s]+?)[/\s>]/);
  if (i2 && (r2.name = i2[1], (voidElements[i2[1]] || "/" === n2.charAt(n2.length - 2)) && (r2.voidElement = true), r2.name.startsWith("!--"))) {
    var s2 = n2.indexOf("-->");
    return { type: "comment", comment: -1 !== s2 ? n2.slice(4, s2) : "" };
  }
  for (var a2 = new RegExp(t$1), c2 = null; null !== (c2 = a2.exec(n2)); )
    if (c2[0].trim())
      if (c2[1]) {
        var o3 = c2[1].trim(), l2 = [o3, ""];
        o3.indexOf("=") > -1 && (l2 = o3.split("=")), r2.attrs[l2[0]] = l2[1], a2.lastIndex--;
      } else
        c2[2] && (r2.attrs[c2[2]] = c2[3].trim().substring(1, c2[3].length - 1));
  return r2;
}
var r$3 = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, i$4 = /^\s*$/, s$9 = /* @__PURE__ */ Object.create(null);
function a$2(e2, t2) {
  switch (t2.type) {
    case "text":
      return e2 + t2.content;
    case "tag":
      return e2 += "<" + t2.name + (t2.attrs ? function(e3) {
        var t3 = [];
        for (var n2 in e3)
          t3.push(n2 + '="' + e3[n2] + '"');
        return t3.length ? " " + t3.join(" ") : "";
      }(t2.attrs) : "") + (t2.voidElement ? "/>" : ">"), t2.voidElement ? e2 : e2 + t2.children.reduce(a$2, "") + "</" + t2.name + ">";
    case "comment":
      return e2 + "<!--" + t2.comment + "-->";
  }
}
var c = { parse: function(e2, t2) {
  t2 || (t2 = {}), t2.components || (t2.components = s$9);
  var a2, c2 = [], o3 = [], l2 = -1, m2 = false;
  if (0 !== e2.indexOf("<")) {
    var u2 = e2.indexOf("<");
    c2.push({ type: "text", content: -1 === u2 ? e2 : e2.substring(0, u2) });
  }
  return e2.replace(r$3, function(r2, s2) {
    if (m2) {
      if (r2 !== "</" + a2.name + ">")
        return;
      m2 = false;
    }
    var u3, f2 = "/" !== r2.charAt(1), h2 = r2.startsWith("<!--"), p2 = s2 + r2.length, d2 = e2.charAt(p2);
    if (h2) {
      var v2 = n$3(r2);
      return l2 < 0 ? (c2.push(v2), c2) : ((u3 = o3[l2]).children.push(v2), c2);
    }
    if (f2 && (l2++, "tag" === (a2 = n$3(r2)).type && t2.components[a2.name] && (a2.type = "component", m2 = true), a2.voidElement || m2 || !d2 || "<" === d2 || a2.children.push({ type: "text", content: e2.slice(p2, e2.indexOf("<", p2)) }), 0 === l2 && c2.push(a2), (u3 = o3[l2 - 1]) && u3.children.push(a2), o3[l2] = a2), (!f2 || a2.voidElement) && (l2 > -1 && (a2.voidElement || a2.name === r2.slice(2, -1)) && (l2--, a2 = -1 === l2 ? c2 : o3[l2]), !m2 && "<" !== d2 && d2)) {
      u3 = -1 === l2 ? c2 : o3[l2].children;
      var x2 = e2.indexOf("<", p2), g = e2.slice(p2, -1 === x2 ? void 0 : x2);
      i$4.test(g) && (g = " "), (x2 > -1 && l2 + u3.length >= 0 || " " !== g) && u3.push({ type: "text", content: g });
    }
  }), c2;
}, stringify: function(e2) {
  return e2.reduce(function(e3, t2) {
    return e3 + a$2("", t2);
  }, "");
} };
function warn$1() {
  if (console && console.warn) {
    var _console;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (typeof args[0] === "string")
      args[0] = "react-i18next:: ".concat(args[0]);
    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  if (typeof args[0] === "string" && alreadyWarned[args[0]])
    return;
  if (typeof args[0] === "string")
    alreadyWarned[args[0]] = new Date();
  warn$1.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function() {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized2() {
        setTimeout(function() {
          i18n.off("initialized", initialized2);
        }, 0);
        cb();
      };
      i18n.on("initialized", initialized);
    }
  });
}
function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === "cimode")
    return true;
  var loadNotPending = function loadNotPending2(l2, n2) {
    var loadState = i18n.services.backendConnector.state["".concat(l2, "|").concat(n2)];
    return loadState === -1 || loadState === 2;
  };
  if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns))
    return false;
  if (i18n.hasResourceBundle(lng, ns))
    return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages)
    return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns)))
    return true;
  return false;
}
function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (!i18n.languages || !i18n.languages.length) {
    warnOnce("i18n.languages were undefined or empty", i18n.languages);
    return true;
  }
  var isNewerI18next = i18n.options.ignoreJSONStructure !== void 0;
  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }
  return i18n.hasLoadedNamespace(ns, {
    precheck: function precheck(i18nInstance2, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance2.services.backendConnector.backend && i18nInstance2.isLanguageChangingTo && !loadNotPending(i18nInstance2.isLanguageChangingTo, ns))
        return false;
    }
  });
}
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}
var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
};
var unescapeHtmlEntity = function unescapeHtmlEntity2(m2) {
  return htmlEntities[m2];
};
var unescape = function unescape2(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};
function ownKeys$4(object, enumerableOnly) {
  var keys2 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread$4(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys$4(Object(source), true).forEach(function(key) {
        _defineProperty$2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$4(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var defaultOptions = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: true,
  unescape
};
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  defaultOptions = _objectSpread$4(_objectSpread$4({}, defaultOptions), options);
}
function getDefaults$1() {
  return defaultOptions;
}
var i18nInstance;
function setI18n(instance2) {
  i18nInstance = instance2;
}
function getI18n() {
  return i18nInstance;
}
var _excluded$2 = ["format"], _excluded2 = ["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"];
function ownKeys$3(object, enumerableOnly) {
  var keys2 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread$3(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys$3(Object(source), true).forEach(function(key) {
        _defineProperty$2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$3(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function hasChildren(node, checkLength) {
  if (!node)
    return false;
  var base = node.props ? node.props.children : node.children;
  if (checkLength)
    return base.length > 0;
  return !!base;
}
function getChildren$1(node) {
  if (!node)
    return [];
  return node.props ? node.props.children : node.children;
}
function hasValidReactChildren(children) {
  if (Object.prototype.toString.call(children) !== "[object Array]")
    return false;
  return children.every(function(child) {
    return isValidElement(child);
  });
}
function getAsArray(data) {
  return Array.isArray(data) ? data : [data];
}
function mergeProps(source, target) {
  var newTarget = _objectSpread$3({}, target);
  newTarget.props = Object.assign(source.props, target.props);
  return newTarget;
}
function nodesToString(children, i18nOptions) {
  if (!children)
    return "";
  var stringNode = "";
  var childrenArray = getAsArray(children);
  var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
  childrenArray.forEach(function(child, childIndex) {
    if (typeof child === "string") {
      stringNode += "".concat(child);
    } else if (isValidElement(child)) {
      var childPropsCount = Object.keys(child.props).length;
      var shouldKeepChild = keepArray.indexOf(child.type) > -1;
      var childChildren = child.props.children;
      if (!childChildren && shouldKeepChild && childPropsCount === 0) {
        stringNode += "<".concat(child.type, "/>");
      } else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (child.props.i18nIsDynamicList) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") {
        stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
      } else {
        var content = nodesToString(childChildren, i18nOptions);
        stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
      }
    } else if (child === null) {
      warn$1("Trans: the passed in value is invalid - seems you passed in a null child.");
    } else if (_typeof$1(child) === "object") {
      var format = child.format, clone2 = _objectWithoutProperties(child, _excluded$2);
      var keys2 = Object.keys(clone2);
      if (keys2.length === 1) {
        var value = format ? "".concat(keys2[0], ", ").concat(format) : keys2[0];
        stringNode += "{{".concat(value, "}}");
      } else {
        warn$1("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
      }
    } else {
      warn$1("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    }
  });
  return stringNode;
}
function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
  if (targetString === "")
    return [];
  var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join("|")).test(targetString);
  if (!children && !emptyChildrenButNeedsHandling)
    return [targetString];
  var data = {};
  function getData(childs) {
    var childrenArray = getAsArray(childs);
    childrenArray.forEach(function(child) {
      if (typeof child === "string")
        return;
      if (hasChildren(child))
        getData(getChildren$1(child));
      else if (_typeof$1(child) === "object" && !isValidElement(child))
        Object.assign(data, child);
    });
  }
  getData(children);
  var ast = c.parse("<0>".concat(targetString, "</0>"));
  var opts = _objectSpread$3(_objectSpread$3({}, data), combinedTOpts);
  function renderInner(child, node, rootReactNode) {
    var childs = getChildren$1(child);
    var mappedChildren = mapAST(childs, node.children, rootReactNode);
    return hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
  }
  function pushTranslatedJSX(child, inner, mem, i2, isVoid) {
    if (child.dummy)
      child.children = inner;
    mem.push(cloneElement(child, _objectSpread$3(_objectSpread$3({}, child.props), {}, {
      key: i2
    }), isVoid ? void 0 : inner));
  }
  function mapAST(reactNode, astNode, rootReactNode) {
    var reactNodes = getAsArray(reactNode);
    var astNodes = getAsArray(astNode);
    return astNodes.reduce(function(mem, node, i2) {
      var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
      if (node.type === "tag") {
        var tmp = reactNodes[parseInt(node.name, 10)];
        if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name])
          tmp = rootReactNode[0][node.name];
        if (!tmp)
          tmp = {};
        var child = Object.keys(node.attrs).length !== 0 ? mergeProps({
          props: node.attrs
        }, tmp) : tmp;
        var isElement = isValidElement(child);
        var isValidTranslationWithChildren = isElement && hasChildren(node, true) && !node.voidElement;
        var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && _typeof$1(child) === "object" && child.dummy && !isElement;
        var isKnownComponent = _typeof$1(children) === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
        if (typeof child === "string") {
          var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
          mem.push(value);
        } else if (hasChildren(child) || isValidTranslationWithChildren) {
          var inner = renderInner(child, node, rootReactNode);
          pushTranslatedJSX(child, inner, mem, i2);
        } else if (isEmptyTransWithHTML) {
          var _inner = mapAST(reactNodes, node.children, rootReactNode);
          mem.push(cloneElement(child, _objectSpread$3(_objectSpread$3({}, child.props), {}, {
            key: i2
          }), _inner));
        } else if (Number.isNaN(parseFloat(node.name))) {
          if (isKnownComponent) {
            var _inner2 = renderInner(child, node, rootReactNode);
            pushTranslatedJSX(child, _inner2, mem, i2, node.voidElement);
          } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
            if (node.voidElement) {
              mem.push(createElement$1(node.name, {
                key: "".concat(node.name, "-").concat(i2)
              }));
            } else {
              var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
              mem.push(createElement$1(node.name, {
                key: "".concat(node.name, "-").concat(i2)
              }, _inner3));
            }
          } else if (node.voidElement) {
            mem.push("<".concat(node.name, " />"));
          } else {
            var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
            mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
          }
        } else if (_typeof$1(child) === "object" && !isElement) {
          var content = node.children[0] ? translationContent : null;
          if (content)
            mem.push(content);
        } else if (node.children.length === 1 && translationContent) {
          mem.push(cloneElement(child, _objectSpread$3(_objectSpread$3({}, child.props), {}, {
            key: i2
          }), translationContent));
        } else {
          mem.push(cloneElement(child, _objectSpread$3(_objectSpread$3({}, child.props), {}, {
            key: i2
          })));
        }
      } else if (node.type === "text") {
        var wrapTextNodes = i18nOptions.transWrapTextNodes;
        var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
        if (wrapTextNodes) {
          mem.push(createElement$1(wrapTextNodes, {
            key: "".concat(node.name, "-").concat(i2)
          }, _content));
        } else {
          mem.push(_content);
        }
      }
      return mem;
    }, []);
  }
  var result = mapAST([{
    dummy: true,
    children: children || []
  }], ast, getAsArray(children || []));
  return getChildren$1(result[0]);
}
function Trans$1(_ref) {
  var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults2 = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = _objectWithoutProperties(_ref, _excluded2);
  var i18n = i18nFromProps || getI18n();
  if (!i18n) {
    warnOnce("You will need to pass in an i18next instance by using i18nextReactModule");
    return children;
  }
  var t2 = tFromProps || i18n.t.bind(i18n) || function(k2) {
    return k2;
  };
  if (context)
    tOptions.context = context;
  var reactI18nextOptions = _objectSpread$3(_objectSpread$3({}, getDefaults$1()), i18n.options && i18n.options.react);
  var namespaces = ns || t2.ns || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === "string" ? [namespaces] : namespaces || ["translation"];
  var defaultValue = defaults2 || nodesToString(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
  var hashTransKey = reactI18nextOptions.hashTransKey;
  var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
  var interpolationOverride = values ? tOptions.interpolation : {
    interpolation: _objectSpread$3(_objectSpread$3({}, tOptions.interpolation), {}, {
      prefix: "#$?",
      suffix: "?$#"
    })
  };
  var combinedTOpts = _objectSpread$3(_objectSpread$3(_objectSpread$3(_objectSpread$3({}, tOptions), {}, {
    count
  }, values), interpolationOverride), {}, {
    defaultValue,
    ns: namespaces
  });
  var translation = key ? t2(key, combinedTOpts) : defaultValue;
  var content = renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
  var useAsParent = parent !== void 0 ? parent : reactI18nextOptions.defaultTransParent;
  return useAsParent ? createElement$1(useAsParent, additionalProps, content) : content;
}
var initReactI18next = {
  type: "3rdParty",
  init: function init(instance2) {
    setDefaults(instance2.options.react);
    setI18n(instance2);
  }
};
var I18nContext = createContext();
var ReportNamespaces = function() {
  function ReportNamespaces2() {
    _classCallCheck(this, ReportNamespaces2);
    this.usedNamespaces = {};
  }
  _createClass(ReportNamespaces2, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;
      namespaces.forEach(function(ns) {
        if (!_this.usedNamespaces[ns])
          _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);
  return ReportNamespaces2;
}();
var _excluded$1 = ["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"];
function ownKeys$2(object, enumerableOnly) {
  var keys2 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread$2(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys$2(Object(source), true).forEach(function(key) {
        _defineProperty$2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function Trans(_ref) {
  var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults2 = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = _objectWithoutProperties(_ref, _excluded$1);
  var _ref2 = useContext(I18nContext) || {}, i18nFromContext = _ref2.i18n, defaultNSFromContext = _ref2.defaultNS;
  var i18n = i18nFromProps || i18nFromContext || getI18n();
  var t2 = tFromProps || i18n && i18n.t.bind(i18n);
  return Trans$1(_objectSpread$2({
    children,
    count,
    parent,
    i18nKey,
    context,
    tOptions,
    values,
    defaults: defaults2,
    components,
    ns: ns || t2 && t2.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
    i18n,
    t: tFromProps,
    shouldUnescape
  }, additionalProps));
}
function _iterableToArrayLimit(arr2, i2) {
  var _i = null == arr2 ? null : "undefined" != typeof Symbol && arr2[Symbol.iterator] || arr2["@@iterator"];
  if (null != _i) {
    var _s, _e2, _x, _r, _arr = [], _n = true, _d = false;
    try {
      if (_x = (_i = _i.call(arr2)).next, 0 === i2) {
        if (Object(_i) !== _i)
          return;
        _n = false;
      } else
        for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i2); _n = true)
          ;
    } catch (err) {
      _d = true, _e2 = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r))
          return;
      } finally {
        if (_d)
          throw _e2;
      }
    }
    return _arr;
  }
}
function _slicedToArray(arr2, i2) {
  return _arrayWithHoles(arr2) || _iterableToArrayLimit(arr2, i2) || _unsupportedIterableToArray(arr2, i2) || _nonIterableRest();
}
function ownKeys$1(object, enumerableOnly) {
  var keys2 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys$1(Object(source), true).forEach(function(key) {
        _defineProperty$2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var usePrevious = function usePrevious2(value, ignore) {
  var ref = useRef();
  useEffect$1(function() {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};
function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var i18nFromProps = props.i18n;
  var _ref = useContext(I18nContext) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces)
    i18n.reportNamespaces = new ReportNamespaces();
  if (!i18n) {
    warnOnce("You will need to pass in an i18next instance by using initReactI18next");
    var notReadyT = function notReadyT2(k2) {
      return Array.isArray(k2) ? k2[k2.length - 1] : k2;
    };
    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }
  if (i18n.options.react && i18n.options.react.wait !== void 0)
    warnOnce("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  var i18nOptions = _objectSpread$1(_objectSpread$1(_objectSpread$1({}, getDefaults$1()), i18n.options.react), props);
  var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === "string" ? [namespaces] : namespaces || ["translation"];
  if (i18n.reportNamespaces.addUsedNamespaces)
    i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n2) {
    return hasLoadedNamespace(n2, i18n, i18nOptions);
  });
  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
  }
  var _useState = useState$1(getT), _useState2 = _slicedToArray(_useState, 2), t2 = _useState2[0], setT = _useState2[1];
  var joinedNS = namespaces.join();
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = useRef(true);
  useEffect$1(function() {
    var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;
    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function() {
        if (isMounted.current)
          setT(getT);
      });
    }
    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }
    function boundReset() {
      if (isMounted.current)
        setT(getT);
    }
    if (bindI18n && i18n)
      i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n)
      i18n.store.on(bindI18nStore, boundReset);
    return function() {
      isMounted.current = false;
      if (bindI18n && i18n)
        bindI18n.split(" ").forEach(function(e2) {
          return i18n.off(e2, boundReset);
        });
      if (bindI18nStore && i18n)
        bindI18nStore.split(" ").forEach(function(e2) {
          return i18n.store.off(e2, boundReset);
        });
    };
  }, [i18n, joinedNS]);
  var isInitial = useRef(true);
  useEffect$1(function() {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }
    isInitial.current = false;
  }, [i18n, keyPrefix]);
  var ret = [t2, i18n, ready];
  ret.t = t2;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready)
    return ret;
  if (!ready && !useSuspense)
    return ret;
  throw new Promise(function(resolve) {
    loadNamespaces(i18n, namespaces, function() {
      resolve();
    });
  });
}
var _excluded = ["forwardedRef"];
function ownKeys(object, enumerableOnly) {
  var keys2 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty$2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function withTranslation(ns) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function Extend(WrappedComponent) {
    function I18nextWithTranslation(_ref) {
      var forwardedRef = _ref.forwardedRef, rest = _objectWithoutProperties(_ref, _excluded);
      var _useTranslation = useTranslation(ns, _objectSpread(_objectSpread({}, rest), {}, {
        keyPrefix: options.keyPrefix
      })), _useTranslation2 = _slicedToArray(_useTranslation, 3), t2 = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
      var passDownProps = _objectSpread(_objectSpread({}, rest), {}, {
        t: t2,
        i18n,
        tReady: ready
      });
      if (options.withRef && forwardedRef) {
        passDownProps.ref = forwardedRef;
      } else if (!options.withRef && forwardedRef) {
        passDownProps.forwardedRef = forwardedRef;
      }
      return createElement$1(WrappedComponent, passDownProps);
    }
    I18nextWithTranslation.displayName = "withI18nextTranslation(".concat(getDisplayName(WrappedComponent), ")");
    I18nextWithTranslation.WrappedComponent = WrappedComponent;
    var forwardRef$1 = function forwardRef2(props, ref) {
      return createElement$1(I18nextWithTranslation, Object.assign({}, props, {
        forwardedRef: ref
      }));
    };
    return options.withRef ? forwardRef(forwardRef$1) : I18nextWithTranslation;
  };
}
var arr = [];
var each = arr.forEach;
var slice = arr.slice;
function defaults$1(obj) {
  each.call(slice.call(arguments, 1), function(source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === void 0)
          obj[prop] = source[prop];
      }
    }
  });
  return obj;
}
var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var serializeCookie = function serializeCookie2(name, val, options) {
  var opt = options || {};
  opt.path = opt.path || "/";
  var value = encodeURIComponent(val);
  var str = "".concat(name, "=").concat(value);
  if (opt.maxAge > 0) {
    var maxAge = opt.maxAge - 0;
    if (Number.isNaN(maxAge))
      throw new Error("maxAge should be a Number");
    str += "; Max-Age=".concat(Math.floor(maxAge));
  }
  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError("option domain is invalid");
    }
    str += "; Domain=".concat(opt.domain);
  }
  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError("option path is invalid");
    }
    str += "; Path=".concat(opt.path);
  }
  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== "function") {
      throw new TypeError("option expires is invalid");
    }
    str += "; Expires=".concat(opt.expires.toUTCString());
  }
  if (opt.httpOnly)
    str += "; HttpOnly";
  if (opt.secure)
    str += "; Secure";
  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
    switch (sameSite) {
      case true:
        str += "; SameSite=Strict";
        break;
      case "lax":
        str += "; SameSite=Lax";
        break;
      case "strict":
        str += "; SameSite=Strict";
        break;
      case "none":
        str += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  }
  return str;
};
var cookie = {
  create: function create(name, value, minutes, domain) {
    var cookieOptions = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      path: "/",
      sameSite: "strict"
    };
    if (minutes) {
      cookieOptions.expires = new Date();
      cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60 * 1e3);
    }
    if (domain)
      cookieOptions.domain = domain;
    document.cookie = serializeCookie(name, encodeURIComponent(value), cookieOptions);
  },
  read: function read(name) {
    var nameEQ = "".concat(name, "=");
    var ca = document.cookie.split(";");
    for (var i2 = 0; i2 < ca.length; i2++) {
      var c2 = ca[i2];
      while (c2.charAt(0) === " ") {
        c2 = c2.substring(1, c2.length);
      }
      if (c2.indexOf(nameEQ) === 0)
        return c2.substring(nameEQ.length, c2.length);
    }
    return null;
  },
  remove: function remove(name) {
    this.create(name, "", -1);
  }
};
var cookie$1 = {
  name: "cookie",
  lookup: function lookup(options) {
    var found;
    if (options.lookupCookie && typeof document !== "undefined") {
      var c2 = cookie.read(options.lookupCookie);
      if (c2)
        found = c2;
    }
    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupCookie && typeof document !== "undefined") {
      cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
  }
};
var querystring = {
  name: "querystring",
  lookup: function lookup2(options) {
    var found;
    if (typeof window !== "undefined") {
      var search = window.location.search;
      if (!window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1) {
        search = window.location.hash.substring(window.location.hash.indexOf("?"));
      }
      var query = search.substring(1);
      var params = query.split("&");
      for (var i2 = 0; i2 < params.length; i2++) {
        var pos = params[i2].indexOf("=");
        if (pos > 0) {
          var key = params[i2].substring(0, pos);
          if (key === options.lookupQuerystring) {
            found = params[i2].substring(pos + 1);
          }
        }
      }
    }
    return found;
  }
};
var hasLocalStorageSupport = null;
var localStorageAvailable = function localStorageAvailable2() {
  if (hasLocalStorageSupport !== null)
    return hasLocalStorageSupport;
  try {
    hasLocalStorageSupport = window !== "undefined" && window.localStorage !== null;
    var testKey = "i18next.translate.boo";
    window.localStorage.setItem(testKey, "foo");
    window.localStorage.removeItem(testKey);
  } catch (e2) {
    hasLocalStorageSupport = false;
  }
  return hasLocalStorageSupport;
};
var localStorage = {
  name: "localStorage",
  lookup: function lookup3(options) {
    var found;
    if (options.lookupLocalStorage && localStorageAvailable()) {
      var lng = window.localStorage.getItem(options.lookupLocalStorage);
      if (lng)
        found = lng;
    }
    return found;
  },
  cacheUserLanguage: function cacheUserLanguage2(lng, options) {
    if (options.lookupLocalStorage && localStorageAvailable()) {
      window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
  }
};
var hasSessionStorageSupport = null;
var sessionStorageAvailable = function sessionStorageAvailable2() {
  if (hasSessionStorageSupport !== null)
    return hasSessionStorageSupport;
  try {
    hasSessionStorageSupport = window !== "undefined" && window.sessionStorage !== null;
    var testKey = "i18next.translate.boo";
    window.sessionStorage.setItem(testKey, "foo");
    window.sessionStorage.removeItem(testKey);
  } catch (e2) {
    hasSessionStorageSupport = false;
  }
  return hasSessionStorageSupport;
};
var sessionStorage$1 = {
  name: "sessionStorage",
  lookup: function lookup4(options) {
    var found;
    if (options.lookupSessionStorage && sessionStorageAvailable()) {
      var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
      if (lng)
        found = lng;
    }
    return found;
  },
  cacheUserLanguage: function cacheUserLanguage3(lng, options) {
    if (options.lookupSessionStorage && sessionStorageAvailable()) {
      window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
  }
};
var navigator$1 = {
  name: "navigator",
  lookup: function lookup5(options) {
    var found = [];
    if (typeof navigator !== "undefined") {
      if (navigator.languages) {
        for (var i2 = 0; i2 < navigator.languages.length; i2++) {
          found.push(navigator.languages[i2]);
        }
      }
      if (navigator.userLanguage) {
        found.push(navigator.userLanguage);
      }
      if (navigator.language) {
        found.push(navigator.language);
      }
    }
    return found.length > 0 ? found : void 0;
  }
};
var htmlTag = {
  name: "htmlTag",
  lookup: function lookup6(options) {
    var found;
    var htmlTag2 = options.htmlTag || (typeof document !== "undefined" ? document.documentElement : null);
    if (htmlTag2 && typeof htmlTag2.getAttribute === "function") {
      found = htmlTag2.getAttribute("lang");
    }
    return found;
  }
};
var path = {
  name: "path",
  lookup: function lookup7(options) {
    var found;
    if (typeof window !== "undefined") {
      var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
      if (language instanceof Array) {
        if (typeof options.lookupFromPathIndex === "number") {
          if (typeof language[options.lookupFromPathIndex] !== "string") {
            return void 0;
          }
          found = language[options.lookupFromPathIndex].replace("/", "");
        } else {
          found = language[0].replace("/", "");
        }
      }
    }
    return found;
  }
};
var subdomain = {
  name: "subdomain",
  lookup: function lookup8(options) {
    var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === "number" ? options.lookupFromSubdomainIndex + 1 : 1;
    var language = typeof window !== "undefined" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
    if (!language)
      return void 0;
    return language[lookupFromSubdomainIndex];
  }
};
function getDefaults() {
  return {
    order: ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"],
    lookupQuerystring: "lng",
    lookupCookie: "i18next",
    lookupLocalStorage: "i18nextLng",
    lookupSessionStorage: "i18nextLng",
    // cache user language
    caches: ["localStorage"],
    excludeCacheFor: ["cimode"]
    // cookieMinutes: 10,
    // cookieDomain: 'myDomain'
  };
}
var Browser = /* @__PURE__ */ function() {
  function Browser2(services) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck(this, Browser2);
    this.type = "languageDetector";
    this.detectors = {};
    this.init(services, options);
  }
  _createClass(Browser2, [{
    key: "init",
    value: function init2(services) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var i18nOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.services = services;
      this.options = defaults$1(options, this.options || {}, getDefaults());
      if (this.options.lookupFromUrlIndex)
        this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
      this.i18nOptions = i18nOptions;
      this.addDetector(cookie$1);
      this.addDetector(querystring);
      this.addDetector(localStorage);
      this.addDetector(sessionStorage$1);
      this.addDetector(navigator$1);
      this.addDetector(htmlTag);
      this.addDetector(path);
      this.addDetector(subdomain);
    }
  }, {
    key: "addDetector",
    value: function addDetector(detector) {
      this.detectors[detector.name] = detector;
    }
  }, {
    key: "detect",
    value: function detect(detectionOrder) {
      var _this = this;
      if (!detectionOrder)
        detectionOrder = this.options.order;
      var detected = [];
      detectionOrder.forEach(function(detectorName) {
        if (_this.detectors[detectorName]) {
          var lookup9 = _this.detectors[detectorName].lookup(_this.options);
          if (lookup9 && typeof lookup9 === "string")
            lookup9 = [lookup9];
          if (lookup9)
            detected = detected.concat(lookup9);
        }
      });
      if (this.services.languageUtils.getBestMatchFromCodes)
        return detected;
      return detected.length > 0 ? detected[0] : null;
    }
  }, {
    key: "cacheUserLanguage",
    value: function cacheUserLanguage4(lng, caches) {
      var _this2 = this;
      if (!caches)
        caches = this.options.caches;
      if (!caches)
        return;
      if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1)
        return;
      caches.forEach(function(cacheName) {
        if (_this2.detectors[cacheName])
          _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
      });
    }
  }]);
  return Browser2;
}();
Browser.type = "languageDetector";
const Bidding$2 = "Bidding";
const Blueprint$4 = "Blueprint";
const Building$2 = "Building";
const Close$2 = "Close (Esc)";
const Excellent$2 = "Excellent";
const Good$2 = "Good";
const Loft$2 = "Loft";
const Luhtitalo$2 = "Luhtitalo";
const Month$2 = "Month";
const Next$2 = "Next";
const New$2 = "New";
const Own$2 = "Own";
const Person$2 = "Person";
const Poor$2 = "Poor";
const Previous$2 = "Previous";
const Rent$2 = "Rent";
const Rowhouse$2 = "Rowhouse";
const Satisfactory$2 = "Satisfactory";
const Sold$2 = "Sold";
const TV$2 = "TV";
const Unknown$2 = "Unknown";
const Unlivable$2 = "Unlivable";
const Use$2 = "Use";
const Year$2 = "Year";
const accessible$2 = "Accessible";
const alternative_floorplan$2 = "Alternative floorplan";
const anonymized_info$2 = "Exact details such as address, housing company and costruction year have been hidden to protect the seller's privacy. We will share this information to interested buyers.";
const apartments_area$2 = "Apartments area";
const asbestos$2 = "Asbestos";
const association_fee$2 = "Association fee";
const association_fee_fraction$2 = "Share of the association fee";
const association_name$2 = "Housing association";
const association_ownership_fraction$2 = "Ownership of association";
const balcony$2 = "Balcony";
const balcony_direction$2 = "Balcony direction";
const balcony_type$2 = "Balcony type";
const basic_info$2 = "Apartment information";
const bearings$2 = "Bearings";
const bid$2 = "Bid";
const bidder$2 = "Bidder";
const bidding$2 = "Bidding";
const bidding_open$2 = "Bidding is in progress!";
const book_private_showing_1$2 = "Book a ";
const book_private_showing_2$2 = "private showing";
const book_showing__se$2 = "Register to a showing";
const bs_asking_price$2 = "Asking price";
const build_in$2 = "Built in";
const build_year$2 = "Build year";
const building_apartments$2 = "Building apartments";
const building_info$2 = "Building information";
const building_material$2 = "Building material";
const building_overnight_apartment$2 = "Overnight apartment in the association";
const building_sauna$2 = "Building sauna";
const building_spaces$2 = "Building spaces";
const building_yard$2 = "Yard";
const built_in$2 = "Built in";
const close$2 = "Close (Esc)";
const commercial_spaces$2 = "Commercial spaces";
const condition$2 = "Condition";
const contact_FI$2 = "Contact";
const contact_SE$2 = "Contact Blok";
const contact_title_FI$2 = "Contact";
const contact_title_SE$2 = "Questions about the listing?";
const create_account$2 = "Create an account";
const date$2 = "Date";
const debt$2 = "Debt";
const debt_deducted_price$2 = "Price with debt deducted";
const dishwasher$2 = "Diswasher";
const disponent$2 = "Disponent";
const documents$2 = "Documents";
const download_document$2 = "Download all the documents for this property";
const download_leaflet$2 = "Download brochure";
const download_leaflet_pdf$2 = "Download sales brochure of this property in PDF format";
const energy_cert$2 = "Energy certificate";
const energy_performance$2 = "Energy performance";
const equipment_bathroom$2 = "Bathroom equipment";
const equipment_bedroom$2 = "Bedroom equipment";
const equipment_kitchen$2 = "Kitchen equipment";
const equipment_living_room$2 = "Living room equipment";
const equipment_other$2 = "Other equipment";
const facade$2 = "Facade";
const fees_FI$2 = "Maintenance fee and other expenses";
const fees_SE$2 = "Association fee and other expenses";
const fireplace$2 = "Fireplace";
const floor$3 = "Floor";
const flooring$2 = "Flooring";
const heating$2 = "Heating";
const high_ceiling$2 = "Room height over 2,7 m";
const highest_bid$2 = "Highest bid";
const housing_company$2 = "Housing company";
const how_to_send_offer_FI$2 = "How do I send an offer?";
const how_to_send_offer_SE$2 = "How do I register for bidding?";
const important_renovation_info$2 = "Important renovations";
const indirect_net_debt$2 = "Apartment's indirect net debt";
const information_not_found$2 = "Information not found";
const internet$2 = "Internet";
const is_loaned$2 = "Is loaned (Pantsatt)";
const klo$2 = "at";
const leaflet$2 = "Brochure";
const lift$2 = "Lift";
const link_disabled_desc$2 = "Navigation to outside the listing page is disabled in the preview mode";
const link_listings_FI$2 = "https://blok.ai/en/apartments/";
const link_listings_SE$2 = "https://blok.se/en/apartments/";
const living_area$2 = "Living area";
const living_area_fi$2 = "Living area according to the association";
const living_area_fi_disclaimer$2 = "Area verification measurements have not been done. In apartments built before 1/1/1992 the announced area might differ from area measured by modern standards.";
const living_area_info$2 = "Living area information";
const loan_break_fee$2 = "Loan break fee (Pantsättningsavgift)";
const loan_promise_btn$2 = "Open calculator";
const loan_promise_heading$2 = "Do you need funding?";
const lot_FI$2 = "Lot";
const lot_SE$2 = "Form of lease";
const lot_owner$2 = "Lot owner";
const lot_owner_SE$2 = "Information about lot ownership";
const maintenance$2 = "Maintenance";
const maintenance_fee$2 = "Maintenance fee";
const make_a_booking$2 = "Make a booking";
const make_a_booking__se$2 = "Register";
const make_offer_FI$2 = "Make offer";
const make_offer_SE$2 = "Register for bidding";
const make_offer_desc$2 = "Sending an offer takes only couple of minutes";
const match_interested_FI$2 = "I'm interested";
const match_interested_SE$2 = "Yes, please tell me more";
const match_reject_FI$2 = "Not interested";
const match_reject_SE$2 = "No, next one please";
const neighborhood$2 = "Neighborhood";
const no$2 = "No";
const no_showing$2 = "Owner has not scheduled any showings at the moment";
const offer_step2_after_btn_FI$2 = "button on the house listing page";
const offer_step2_after_btn_SE$2 = "button on the house listing page";
const offer_step2_before_btn_FI$2 = "You’ll find the";
const offer_step2_before_btn_SE$2 = "You’ll find the";
const offer_step3_FI$2 = "Fill in the offer details, conditions and sign the offer electronically.";
const offer_step3_SE$2 = "Confirm that you have received information about the apartment, and fill in the offer details.";
const offer_step4_FI$2 = "The seller can accept your offer or make a counter-offer.";
const offer_step4_SE$2 = "Confirm your identity with e-ID for safe bidding.";
const offer_step5_FI$2 = "When the offer is accepted we’ll send all necessary documents and instructions to both parties of the transaction.";
const offer_step5_SE$2 = "Make bids online or with SMS once the bidding starts.";
const open_floorplan$2 = "Open floorplan";
const openhouse$2 = "Openhouse";
const other_details$2 = "Other details";
const own_yard$2 = "Own yard";
const owner_change_fee$2 = "Owner change fee (Överlåtelseavgift)";
const parking$2 = "Parking";
const parking_electric_vehicle$2 = "EV charging station";
const parking_powerplug$2 = "Parking space power outlet";
const past_renovations$2 = "Past renovations";
const pipes$2 = "Pipes";
const postcode$2 = "Postcode";
const pre_emption_rights$2 = "Pre-redemption rights";
const price_estimate__heading$2 = "Thinking of selling?";
const price_estimate__heading_SE$2 = "See immediately what your home is worth.";
const price_estimate__subheading$2 = "Get an estimation.";
const price_estimate__subheading_SE$2 = "Digital and free of charge.";
const price_estimate__valuate$2 = "Estimate";
const price_estimate__valuate_SE$2 = "Proceed";
const price_for_sale$2 = "Price for sale";
const price_for_sale_SE$2 = "Starting price";
const price_info$2 = "Price information";
const price_per_square$2 = "Price per square";
const read_description$2 = "Read apartment description";
const register_for_bidding$2 = "Register for bidding";
const register_for_bidding_btn$2 = "Register for bidding";
const register_for_bidding_desc$2 = "You can now register for bidding and make an offer";
const release$2 = "Release";
const release_SE$2 = "Release";
const responsible_broker$2 = "Responsible broker";
const rm$2 = "rm";
const roof$2 = "Roof";
const roofing$2 = "Roofing";
const room$2 = "room";
const rooms$2 = "Rooms";
const sauna$2 = "Sauna";
const scout_fees_FI$2 = "Association fee and other expenses";
const scout_fees_SE$2 = "Fees and other costs";
const scout_make_offer$2 = "Sending an offer only takes a couple of minutes";
const secondary_match_note$2 = "<0>Note!</0> This apartment matches partly your search criteria.";
const see_apartment_FI$2 = "Are you interested in seeing the apartment on the spot?";
const see_apartment_SE$2 = "Could this be your next home?";
const seller$2 = "Seller";
const send_customer_service_msg$2 = "Send message to Blok";
const share$2 = "Share";
const show_all_bids$2 = "Show all bids";
const show_document$2 = "Show documents";
const similar_apartments$2 = "Similar apartments";
const specifier$2 = "Specifier";
const street$2 = "Street";
const street_address$2 = "Street address";
const street_level$2 = "At street level";
const stucco$2 = "Stucco apartment";
const supplementary_info$2 = "Seller's comments";
const tag__balcony_type__2_plus_balconies$2 = "2+ balconies";
const tag__balcony_type__french$2 = "French balcony";
const tag__balcony_type__glazed$2 = "Glazed balcony";
const tag__balcony_type__king$2 = "King balcony";
const tag__balcony_type__open$2 = "Balcony";
const tag__balcony_type__patio$2 = "Own patio";
const tag__balcony_type__roof_terrace$2 = "Roof terrace";
const tag__balcony_type__traditional$2 = "Balcony";
const tag__elevator$2 = "Elevator";
const tag__fireplace$2 = "Fireplace";
const tag__high_ceiling$2 = "Room height +2,7m";
const tag__own_yard$2 = "Own yard";
const tag__sauna__common$2 = "Common sauna";
const tag__sauna__own$2 = "Own sauna";
const to_next$2 = "Next (arrow right)";
const to_previous$2 = "Previous (arrow left)";
const toggle_fullscreen$2 = "Toggle fullscreen";
const total_area$2 = "Total area";
const type$2 = "Type";
const upcoming_apartment$2 = "Well, the seller of the apartment is looking for a new apartment themselves and wants to test the public interest. Do you want to know more about the apartment, bid on it, or maybe you are interested in putting your own home on Pre Sale? Contact us at Blok.";
const upcoming_apartment_bold$2 = "This is a Pre Sale apartment. What is it?";
const upcoming_renovations$2 = "Upcoming renovations";
const ventilation_system$2 = "Ventilation system";
const view_3d$2 = "View 3D presentation";
const views_from_window$2 = "Views from window";
const want_to_know_more$2 = "Do you want to know more?";
const washing_machine$2 = "Washing machine";
const yes$2 = "Yes";
const zoning$2 = "Zoning";
const zoom_inout$2 = "Zoom in/out";
const en = {
  "/en/valuation": "/en/valuation",
  "/en/valuation-en": "/en/valuation-en",
  "/en/valuation-web": "/en/valuation-web",
  "Apartment building": "Apartment building",
  "Apartment house": "Apartment house",
  "Back to search": "Back to search",
  Bidding: Bidding$2,
  Blueprint: Blueprint$4,
  Building: Building$2,
  Close: Close$2,
  "Cubic meter": "Cubic meter",
  "Detached house": "Detached house",
  Excellent: Excellent$2,
  "Exclusively for you": "Exclusively for you",
  "Go to homepage": "Go to homepage",
  Good: Good$2,
  "However, you are the first in line so act fast": "However, you are the first in line so act fast",
  "Kilowatt hour": "Kilowatt hour",
  "Linked house": "Linked house",
  Loft: Loft$2,
  "Wooden house": "Wooden house",
  "Long lease": "Long lease",
  Luhtitalo: Luhtitalo$2,
  Month: Month$2,
  Next: Next$2,
  New: New$2,
  "Offer deadline": "Offer deadline",
  Own: Own$2,
  "Owns the land": "Owns the land",
  "Per person per month": "Per person per month",
  "Per use per month": "Per use per month",
  Person: Person$2,
  Poor: Poor$2,
  Previous: Previous$2,
  "Properties on sale": "Properties on sale",
  "Puutalo-osake": "Puutalo-osake",
  Rent: Rent$2,
  "Rent, optional": "Rent, optional",
  Rowhouse: Rowhouse$2,
  Satisfactory: Satisfactory$2,
  "Semi-detached": "Semi-detached",
  "Semi-detached house": "Semi-detached house",
  Sold: Sold$2,
  "Terraced house": "Terraced house",
  TV: TV$2,
  "Unfortunately, we couldn't find the page you were looking for.": "Unfortunately, we couldn't find the page you were looking for.",
  Unknown: Unknown$2,
  Unlivable: Unlivable$2,
  Use: Use$2,
  Year: Year$2,
  "Want to go on a showing?": "Want to go on a showing?",
  accessible: accessible$2,
  alternative_floorplan: alternative_floorplan$2,
  anonymized_info: anonymized_info$2,
  apartments_area: apartments_area$2,
  asbestos: asbestos$2,
  association_fee: association_fee$2,
  association_fee_fraction: association_fee_fraction$2,
  association_name: association_name$2,
  association_ownership_fraction: association_ownership_fraction$2,
  balcony: balcony$2,
  balcony_direction: balcony_direction$2,
  balcony_type: balcony_type$2,
  basic_info: basic_info$2,
  bearings: bearings$2,
  bid: bid$2,
  bidder: bidder$2,
  bidding: bidding$2,
  bidding_open: bidding_open$2,
  book_private_showing_1: book_private_showing_1$2,
  book_private_showing_2: book_private_showing_2$2,
  book_showing__se: book_showing__se$2,
  bs_asking_price: bs_asking_price$2,
  build_in: build_in$2,
  build_year: build_year$2,
  building_apartments: building_apartments$2,
  building_info: building_info$2,
  building_material: building_material$2,
  building_overnight_apartment: building_overnight_apartment$2,
  building_sauna: building_sauna$2,
  building_spaces: building_spaces$2,
  building_yard: building_yard$2,
  built_in: built_in$2,
  close: close$2,
  commercial_spaces: commercial_spaces$2,
  condition: condition$2,
  contact_FI: contact_FI$2,
  contact_SE: contact_SE$2,
  contact_title_FI: contact_title_FI$2,
  contact_title_SE: contact_title_SE$2,
  create_account: create_account$2,
  date: date$2,
  debt: debt$2,
  debt_deducted_price: debt_deducted_price$2,
  dishwasher: dishwasher$2,
  disponent: disponent$2,
  documents: documents$2,
  download_document: download_document$2,
  download_leaflet: download_leaflet$2,
  download_leaflet_pdf: download_leaflet_pdf$2,
  energy_cert: energy_cert$2,
  energy_performance: energy_performance$2,
  equipment_bathroom: equipment_bathroom$2,
  equipment_bedroom: equipment_bedroom$2,
  equipment_kitchen: equipment_kitchen$2,
  equipment_living_room: equipment_living_room$2,
  equipment_other: equipment_other$2,
  facade: facade$2,
  fees_FI: fees_FI$2,
  fees_SE: fees_SE$2,
  fireplace: fireplace$2,
  floor: floor$3,
  flooring: flooring$2,
  heating: heating$2,
  high_ceiling: high_ceiling$2,
  highest_bid: highest_bid$2,
  housing_company: housing_company$2,
  how_to_send_offer_FI: how_to_send_offer_FI$2,
  how_to_send_offer_SE: how_to_send_offer_SE$2,
  important_renovation_info: important_renovation_info$2,
  "in progress": "in progress",
  indirect_net_debt: indirect_net_debt$2,
  information_not_found: information_not_found$2,
  internet: internet$2,
  is_loaned: is_loaned$2,
  "kWh/m²/year": "kWh/m²/year",
  klo: klo$2,
  leaflet: leaflet$2,
  lift: lift$2,
  link_disabled_desc: link_disabled_desc$2,
  link_listings_FI: link_listings_FI$2,
  link_listings_SE: link_listings_SE$2,
  living_area: living_area$2,
  living_area_fi: living_area_fi$2,
  living_area_fi_disclaimer: living_area_fi_disclaimer$2,
  living_area_info: living_area_info$2,
  loan_break_fee: loan_break_fee$2,
  loan_promise_btn: loan_promise_btn$2,
  loan_promise_heading: loan_promise_heading$2,
  lot_FI: lot_FI$2,
  lot_SE: lot_SE$2,
  lot_owner: lot_owner$2,
  lot_owner_SE: lot_owner_SE$2,
  maintenance: maintenance$2,
  maintenance_fee: maintenance_fee$2,
  make_a_booking: make_a_booking$2,
  make_a_booking__se: make_a_booking__se$2,
  make_offer_FI: make_offer_FI$2,
  make_offer_SE: make_offer_SE$2,
  make_offer_desc: make_offer_desc$2,
  match_interested_FI: match_interested_FI$2,
  match_interested_SE: match_interested_SE$2,
  match_reject_FI: match_reject_FI$2,
  match_reject_SE: match_reject_SE$2,
  neighborhood: neighborhood$2,
  no: no$2,
  no_showing: no_showing$2,
  offer_step2_after_btn_FI: offer_step2_after_btn_FI$2,
  offer_step2_after_btn_SE: offer_step2_after_btn_SE$2,
  offer_step2_before_btn_FI: offer_step2_before_btn_FI$2,
  offer_step2_before_btn_SE: offer_step2_before_btn_SE$2,
  offer_step3_FI: offer_step3_FI$2,
  offer_step3_SE: offer_step3_SE$2,
  offer_step4_FI: offer_step4_FI$2,
  offer_step4_SE: offer_step4_SE$2,
  offer_step5_FI: offer_step5_FI$2,
  offer_step5_SE: offer_step5_SE$2,
  open_floorplan: open_floorplan$2,
  openhouse: openhouse$2,
  other_details: other_details$2,
  own_yard: own_yard$2,
  owner_change_fee: owner_change_fee$2,
  parking: parking$2,
  parking_electric_vehicle: parking_electric_vehicle$2,
  parking_powerplug: parking_powerplug$2,
  past_renovations: past_renovations$2,
  pipes: pipes$2,
  postcode: postcode$2,
  "potential buyers": "potential buyers",
  pre_emption_rights: pre_emption_rights$2,
  price_estimate__heading: price_estimate__heading$2,
  price_estimate__heading_SE: price_estimate__heading_SE$2,
  price_estimate__subheading: price_estimate__subheading$2,
  price_estimate__subheading_SE: price_estimate__subheading_SE$2,
  price_estimate__valuate: price_estimate__valuate$2,
  price_estimate__valuate_SE: price_estimate__valuate_SE$2,
  price_for_sale: price_for_sale$2,
  price_for_sale_SE: price_for_sale_SE$2,
  price_info: price_info$2,
  price_per_square: price_per_square$2,
  "promo-etsiva__btn_FI": "Blok Etsivä",
  "promo-etsiva__btn_SE": "Find your home",
  "promo-etsiva__description_FI": "Find an apartment outside the public market.",
  "promo-etsiva__description_SE": "Tell us about your dream home and we and our technology will find it for you - outside the official market.",
  "promo-etsiva__description__sold_FI": "With Blok Etsivä you can contact the owners of apartments that match your criteria.",
  "promo-etsiva__description__sold_SE": "Tell us about your dream home and we and our technology will find it for you - outside the official market.",
  "promo-etsiva__link_FI": "https://blok.ai/en/etsiva",
  "promo-etsiva__link_SE": "https://blok.se/en/scout",
  "promo-etsiva__title_FI": "Can't find?",
  "promo-etsiva__title_SE": "Blok Scout",
  "promo-etsiva__title__sold_FI": "This apartment has been sold. You can find similar apartments on Blok Etsivä!",
  "promo-etsiva__title__sold_SE": "This apartment has been sold! With Blok Scout you can find similar apartments.",
  read_description: read_description$2,
  register_for_bidding: register_for_bidding$2,
  register_for_bidding_btn: register_for_bidding_btn$2,
  register_for_bidding_desc: register_for_bidding_desc$2,
  release: release$2,
  release_SE: release_SE$2,
  responsible_broker: responsible_broker$2,
  rm: rm$2,
  roof: roof$2,
  roofing: roofing$2,
  room: room$2,
  rooms: rooms$2,
  sauna: sauna$2,
  scout_fees_FI: scout_fees_FI$2,
  scout_fees_SE: scout_fees_SE$2,
  scout_make_offer: scout_make_offer$2,
  secondary_match_note: secondary_match_note$2,
  see_apartment_FI: see_apartment_FI$2,
  see_apartment_SE: see_apartment_SE$2,
  seller: seller$2,
  send_customer_service_msg: send_customer_service_msg$2,
  share: share$2,
  show_all_bids: show_all_bids$2,
  show_document: show_document$2,
  similar_apartments: similar_apartments$2,
  specifier: specifier$2,
  street: street$2,
  street_address: street_address$2,
  street_level: street_level$2,
  stucco: stucco$2,
  supplementary_info: supplementary_info$2,
  tag__balcony_type__2_plus_balconies: tag__balcony_type__2_plus_balconies$2,
  tag__balcony_type__french: tag__balcony_type__french$2,
  tag__balcony_type__glazed: tag__balcony_type__glazed$2,
  tag__balcony_type__king: tag__balcony_type__king$2,
  tag__balcony_type__open: tag__balcony_type__open$2,
  tag__balcony_type__patio: tag__balcony_type__patio$2,
  tag__balcony_type__roof_terrace: tag__balcony_type__roof_terrace$2,
  tag__balcony_type__traditional: tag__balcony_type__traditional$2,
  tag__elevator: tag__elevator$2,
  tag__fireplace: tag__fireplace$2,
  tag__high_ceiling: tag__high_ceiling$2,
  tag__own_yard: tag__own_yard$2,
  tag__sauna__common: tag__sauna__common$2,
  tag__sauna__own: tag__sauna__own$2,
  to_next: to_next$2,
  to_previous: to_previous$2,
  toggle_fullscreen: toggle_fullscreen$2,
  total_area: total_area$2,
  type: type$2,
  upcoming_apartment: upcoming_apartment$2,
  upcoming_apartment_bold: upcoming_apartment_bold$2,
  upcoming_renovations: upcoming_renovations$2,
  ventilation_system: ventilation_system$2,
  view_3d: view_3d$2,
  views_from_window: views_from_window$2,
  want_to_know_more: want_to_know_more$2,
  washing_machine: washing_machine$2,
  yes: yes$2,
  zoning: zoning$2,
  zoom_inout: zoom_inout$2
};
const Bidding$1 = "";
const Blueprint$3 = "Pohjapiirros";
const Building$1 = "Rakennus";
const Close$1 = "Sulje (Esc)";
const Excellent$1 = "Erinomainen";
const Good$1 = "Hyvä";
const Loft$1 = "Luhtitalo";
const Luhtitalo$1 = "Luhtitalo";
const Month$1 = "kk";
const Next$1 = "Seuraava";
const New$1 = "Uusi";
const Own$1 = "Oma";
const Person$1 = "henkilö";
const Poor$1 = "Huono";
const Previous$1 = "Edellinen";
const Rent$1 = "Vuokra";
const Rowhouse$1 = "Rivitalo";
const Satisfactory$1 = "Tyydyttävä";
const Sold$1 = "Myyty";
const TV$1 = "TV";
const Unknown$1 = "Tuntematon";
const Unlivable$1 = "Asumiskelvoton";
const Use$1 = "kerta (kpl)";
const Year$1 = "vuodessa";
const accessible$1 = "Esteetön";
const alternative_floorplan$1 = "";
const anonymized_info$1 = "Yksilölliset tiedot kuten osoite, taloyhtiö sekä rakennusvuosi on piilotettu myyjän yksityyden varmistamiseksi. Nämä tiedot jaamme asunnosta kiinnostuville.";
const apartments_area$1 = "Asuinhuoneistoala";
const asbestos$1 = "Asbesti";
const association_fee$1 = "Association fee";
const association_fee_fraction$1 = "Osuus kuukausittaisesta maksusta";
const association_name$1 = "Housing association";
const association_ownership_fraction$1 = "Osuus yhtiöstä";
const balcony$1 = "Parveke";
const balcony_direction$1 = "Parvekkeen ilmansuunta";
const balcony_type$1 = "Parvekkeen tyyppi";
const basic_info$1 = "Asunnon tiedot";
const bearings$1 = "Ilmansuunnat";
const bid$1 = "";
const bidder$1 = "";
const bidding$1 = "";
const bidding_open$1 = "Bidding is in progress!";
const book_private_showing_1$1 = "Varaa ";
const book_private_showing_2$1 = "yksityisesittely";
const book_showing__se$1 = "Register to a showing";
const bs_asking_price$1 = "Pyyntihinta";
const build_in$1 = "Valmistunut";
const build_year$1 = "Rakennusvuosi";
const building_apartments$1 = "Taloyhtiön asunnot";
const building_info$1 = "Rakennuksen tiedot";
const building_material$1 = "Materiaali";
const building_overnight_apartment$1 = "";
const building_sauna$1 = "Taloyhtiön sauna";
const building_spaces$1 = "Taloyhtiön tilat";
const building_yard$1 = "Piha-alueet";
const built_in$1 = "Valmistunut";
const close$1 = "Sulje (Esc)";
const commercial_spaces$1 = "Liiketilat";
const condition$1 = "Kunto";
const contact_FI$1 = "Ota yhteyttä";
const contact_SE$1 = "Contact Blok";
const contact_title_FI$1 = "Ota yhteyttä";
const contact_title_SE$1 = "Questions about the listing?";
const create_account$1 = "Luo tunnus";
const date$1 = "";
const debt$1 = "Velka";
const debt_deducted_price$1 = "Myyntihinta";
const dishwasher$1 = "Tiskikone";
const disponent$1 = "Isännöitsijä";
const documents$1 = "Asiakirjat";
const download_document$1 = "Lataa kaikki kohteen asiakirjat";
const download_leaflet$1 = "Lataa esite";
const download_leaflet_pdf$1 = "Lataa kohteen myyntiesite PDF-muodossa";
const energy_cert$1 = "Energiatodistus";
const energy_performance$1 = "Energiankulutus";
const equipment_bathroom$1 = "Kylpyhuoneen varustelu";
const equipment_bedroom$1 = "Makuuhuoneen varustelu";
const equipment_kitchen$1 = "Keittiön varustelu";
const equipment_living_room$1 = "Olohuoneen varustelu";
const equipment_other$1 = "Muu varustelu";
const facade$1 = "Julkisivu";
const fees_FI$1 = "Vastikkeet ja muut maksut";
const fees_SE$1 = "";
const fireplace$1 = "Takka";
const floor$2 = "Kerros";
const flooring$1 = "Lattiamateriaalit";
const heating$1 = "Lämmitys";
const high_ceiling$1 = "Huonekorkeus yli 2,7 m";
const highest_bid$1 = "Highest bid";
const housing_company$1 = "Taloyhtiö";
const how_to_send_offer_FI$1 = "Kuinka teen ostotarjouksen?";
const how_to_send_offer_SE$1 = "Kuinka rekisteröidyn tarjouskauppaan?";
const important_renovation_info$1 = "Tärkeimmät remontit";
const indirect_net_debt$1 = "";
const information_not_found$1 = "Tietoa ei saatavilla";
const internet$1 = "Internet";
const is_loaned$1 = "Is loaned (pantsatt)";
const klo$1 = "klo";
const leaflet$1 = "Esite";
const lift$1 = "Hissi";
const link_disabled_desc$1 = "Kohdesivulta poistuminen esikatselutilassa on estetty.";
const link_listings_FI$1 = "https://blok.ai/asunnot/";
const link_listings_SE$1 = "https://blok.se/en/apartments/";
const living_area$1 = "Asumispinta-ala";
const living_area_fi$1 = "Yhtiöjärjestyksen mukainen asumispinta-ala";
const living_area_fi_disclaimer$1 = "Pinta-alaa ei tarkistusmitattu, ennen 1.1.1992 valmistuneissa asunnoissa nykyisen standardin mukaisesti mitattu pinta-ala voi poiketa ilmoitetusta.";
const living_area_info$1 = "";
const loan_break_fee$1 = "";
const loan_promise_btn$1 = "Open calculator";
const loan_promise_heading$1 = "Do you need funding?";
const lot_FI$1 = "Tontti";
const lot_SE$1 = "";
const lot_owner$1 = "Tontin omistaja";
const lot_owner_SE$1 = "Lisätietoja tontin omistuksesta";
const maintenance$1 = "Huoltoyhtiö";
const maintenance_fee$1 = "Hoitovastike";
const make_a_booking$1 = "Varaa aika";
const make_a_booking__se$1 = "Register";
const make_offer_FI$1 = "Tee tarjous";
const make_offer_SE$1 = "Rekisteröidy tarjouskauppaan";
const make_offer_desc$1 = "Kirjallinen ostotarjous onnistuu muutamassa minuutissa";
const match_interested_FI$1 = "Olen kiinnostunut";
const match_interested_SE$1 = "";
const match_reject_FI$1 = "En ole kiinnostunut";
const match_reject_SE$1 = "";
const neighborhood$1 = "Kaupunginosa";
const no$1 = "Ei";
const no_showing$1 = "Omistaja ei ole tällä hetkellä aikatauluttanut tulevia julkisia näyttöjä";
const offer_step2_after_btn_FI$1 = "nappulan";
const offer_step2_after_btn_SE$1 = "button on the house listing page";
const offer_step2_before_btn_FI$1 = "Kohteen sivulta löydät";
const offer_step2_before_btn_SE$1 = "You’ll find the";
const offer_step3_FI$1 = "Täytä tarjouksen tiedot sekä ehdot ja allekirjoita tarjous sähköisesti.";
const offer_step3_SE$1 = "Confirm that you have received inofrmation about the apartment, and fill in the offer details.";
const offer_step4_FI$1 = "Käy kauppaa. Myyjä voi hyväksyä tai tehdä vastatarjouksen.";
const offer_step4_SE$1 = "Confirm your identity with e-ID for safe bidding.";
const offer_step5_FI$1 = "Kun tarjouksesi on hyväksytty lähetämme tarvittavat paperit ja ohjeet kaupan molemmille osapuolille.";
const offer_step5_SE$1 = "Make bids online or with SMS once the bidding starts.";
const open_floorplan$1 = "";
const openhouse$1 = "Esittely";
const other_details$1 = "Muut tiedot";
const own_yard$1 = "Oma piha";
const owner_change_fee$1 = "";
const parking$1 = "Pysäköinti";
const parking_electric_vehicle$1 = "Sähköauton latauspiste";
const parking_powerplug$1 = "Autopaikan lämmitystolppa";
const past_renovations$1 = "Tehdyt remontit";
const pipes$1 = "Putket";
const postcode$1 = "Postinumeroalue";
const pre_emption_rights$1 = "Lunastusoikeus";
const price_estimate__heading$1 = "Oma asunto myymättä?";
const price_estimate__heading_SE$1 = "";
const price_estimate__subheading$1 = "Tee hinta-arvio.";
const price_estimate__subheading_SE$1 = "";
const price_estimate__valuate$1 = "Arvioi";
const price_estimate__valuate_SE$1 = "";
const price_for_sale$1 = "Velaton myyntihinta";
const price_for_sale_SE$1 = "Julkaisuhinta";
const price_info$1 = "Hintatiedot";
const price_per_square$1 = "Neliöhinta";
const read_description$1 = "Lue asunnon kuvaus";
const register_for_bidding$1 = "Register for bidding";
const register_for_bidding_btn$1 = "Register for bidding";
const register_for_bidding_desc$1 = "You can already register to be able to bid on the apartment when the bidding starts";
const release$1 = "Vapautuminen";
const release_SE$1 = "Vapautuminen";
const responsible_broker$1 = "Vastaava välittäjä";
const rm$1 = "h";
const roof$1 = "Katto";
const roofing$1 = "Katto";
const room$1 = "h";
const rooms$1 = "Huoneet";
const sauna$1 = "Sauna";
const scout_fees_FI$1 = "Vastikkeet ja muut maksut";
const scout_fees_SE$1 = "Vastikkeet ja muut maksut";
const scout_make_offer$1 = "Ostotarjouksen lähettäminen onnistuu muutamassa minuutissa";
const secondary_match_note$1 = "<0>Huom!</0> Tämä asunto vastaa vain osittain hakukriteereitäsi.";
const see_apartment_FI$1 = "Oletko kiinnostunut tutustumaan asuntoon paikan päällä?";
const see_apartment_SE$1 = "";
const seller$1 = "Myyjä";
const send_customer_service_msg$1 = "Lähetä viesti Blokille";
const share$1 = "Jaa";
const show_all_bids$1 = "";
const show_document$1 = "Näytä asiakirjat";
const similar_apartments$1 = "Samankaltaisia asuntoja";
const specifier$1 = "Asunnon numero";
const street$1 = "Katu";
const street_address$1 = "Katuosoite";
const street_level$1 = "Katutasossa";
const stucco$1 = "";
const supplementary_info$1 = "Omistajan ilmoittamaa";
const tag__balcony_type__2_plus_balconies$1 = "";
const tag__balcony_type__french$1 = "Ranskalainen parveke";
const tag__balcony_type__glazed$1 = "Lasitettu parveke";
const tag__balcony_type__king$1 = "";
const tag__balcony_type__open$1 = "Parveke";
const tag__balcony_type__patio$1 = "";
const tag__balcony_type__roof_terrace$1 = "";
const tag__balcony_type__traditional$1 = "";
const tag__elevator$1 = "Hissi";
const tag__fireplace$1 = "Takka";
const tag__high_ceiling$1 = "Huonekorkeus +2,7m";
const tag__own_yard$1 = "Oma piha";
const tag__sauna__common$1 = "Taloyhtiön sauna";
const tag__sauna__own$1 = "Oma sauna";
const to_next$1 = "Seuraava (nuoli oikealle)";
const to_previous$1 = "Edellinen (nuoli vasemmalle)";
const toggle_fullscreen$1 = "Kokoruututila";
const total_area$1 = "Kokonaispinta-ala";
const type$1 = "Tyyppi";
const upcoming_apartment$1 = "This apartment is coming to the market soon!";
const upcoming_apartment_bold$1 = "Pre-sale";
const upcoming_renovations$1 = "Tulevat remontit";
const ventilation_system$1 = "Ilmanvaihto";
const view_3d$1 = "Katso 3D-esittely";
const views_from_window$1 = "Näkymät ikkunasta";
const want_to_know_more$1 = "Haluatko tietää lisää kyseisestä asunnosta?";
const washing_machine$1 = "Pesukone";
const yes$1 = "Kyllä";
const zoning$1 = "Kaavoitus";
const zoom_inout$1 = "Tarkenna sisään/ulos";
const fi = {
  "/en/valuation": "/hinta-arvio",
  "/en/valuation-en": "",
  "/en/valuation-web": "",
  "Apartment building": "Kerrostalo",
  "Apartment house": "Kerrostalo",
  "Back to search": "Takaisin hakuun",
  Bidding: Bidding$1,
  Blueprint: Blueprint$3,
  Building: Building$1,
  Close: Close$1,
  "Cubic meter": "m³",
  "Detached house": "Erillistalo",
  Excellent: Excellent$1,
  "Exclusively for you": "Yksinoikeudella sinulle",
  "Go to homepage": "Siirry etusivulle",
  Good: Good$1,
  "However, you are the first in line so act fast": "Olet kuitenkin ensimmäisenä jonossa, joten toimi nopeasti!",
  "Kilowatt hour": "kWh",
  "Linked house": "Linked house",
  Loft: Loft$1,
  "Wooden house": "Puutalo-osake",
  "Long lease": "",
  Luhtitalo: Luhtitalo$1,
  Month: Month$1,
  Next: Next$1,
  New: New$1,
  "Offer deadline": "Jätä tarjous viimeistään",
  Own: Own$1,
  "Owns the land": "",
  "Per person per month": "hlö/kk",
  "Per use per month": "kuukaudessa käyttö (kpl/kk)",
  Person: Person$1,
  Poor: Poor$1,
  Previous: Previous$1,
  "Properties on sale": "Myytävät asunnot",
  "Puutalo-osake": "Puutalo-osake",
  Rent: Rent$1,
  "Rent, optional": "Valinnainen vuokratontti",
  Rowhouse: Rowhouse$1,
  Satisfactory: Satisfactory$1,
  "Semi-detached": "Paritalo",
  "Semi-detached house": "Paritalo",
  Sold: Sold$1,
  "Terraced house": "Rivitalo",
  TV: TV$1,
  "Unfortunately, we couldn't find the page you were looking for.": "Valitettavasti emme löytäneet etsimääsi sivua.",
  Unknown: Unknown$1,
  Unlivable: Unlivable$1,
  Use: Use$1,
  Year: Year$1,
  "Want to go on a showing?": "Haluatko asuntoesittelyyn?",
  accessible: accessible$1,
  alternative_floorplan: alternative_floorplan$1,
  anonymized_info: anonymized_info$1,
  apartments_area: apartments_area$1,
  asbestos: asbestos$1,
  association_fee: association_fee$1,
  association_fee_fraction: association_fee_fraction$1,
  association_name: association_name$1,
  association_ownership_fraction: association_ownership_fraction$1,
  balcony: balcony$1,
  balcony_direction: balcony_direction$1,
  balcony_type: balcony_type$1,
  basic_info: basic_info$1,
  bearings: bearings$1,
  bid: bid$1,
  bidder: bidder$1,
  bidding: bidding$1,
  bidding_open: bidding_open$1,
  book_private_showing_1: book_private_showing_1$1,
  book_private_showing_2: book_private_showing_2$1,
  book_showing__se: book_showing__se$1,
  bs_asking_price: bs_asking_price$1,
  build_in: build_in$1,
  build_year: build_year$1,
  building_apartments: building_apartments$1,
  building_info: building_info$1,
  building_material: building_material$1,
  building_overnight_apartment: building_overnight_apartment$1,
  building_sauna: building_sauna$1,
  building_spaces: building_spaces$1,
  building_yard: building_yard$1,
  built_in: built_in$1,
  close: close$1,
  commercial_spaces: commercial_spaces$1,
  condition: condition$1,
  contact_FI: contact_FI$1,
  contact_SE: contact_SE$1,
  contact_title_FI: contact_title_FI$1,
  contact_title_SE: contact_title_SE$1,
  create_account: create_account$1,
  date: date$1,
  debt: debt$1,
  debt_deducted_price: debt_deducted_price$1,
  dishwasher: dishwasher$1,
  disponent: disponent$1,
  documents: documents$1,
  download_document: download_document$1,
  download_leaflet: download_leaflet$1,
  download_leaflet_pdf: download_leaflet_pdf$1,
  energy_cert: energy_cert$1,
  energy_performance: energy_performance$1,
  equipment_bathroom: equipment_bathroom$1,
  equipment_bedroom: equipment_bedroom$1,
  equipment_kitchen: equipment_kitchen$1,
  equipment_living_room: equipment_living_room$1,
  equipment_other: equipment_other$1,
  facade: facade$1,
  fees_FI: fees_FI$1,
  fees_SE: fees_SE$1,
  fireplace: fireplace$1,
  floor: floor$2,
  flooring: flooring$1,
  heating: heating$1,
  high_ceiling: high_ceiling$1,
  highest_bid: highest_bid$1,
  housing_company: housing_company$1,
  how_to_send_offer_FI: how_to_send_offer_FI$1,
  how_to_send_offer_SE: how_to_send_offer_SE$1,
  important_renovation_info: important_renovation_info$1,
  "in progress": "",
  indirect_net_debt: indirect_net_debt$1,
  information_not_found: information_not_found$1,
  internet: internet$1,
  is_loaned: is_loaned$1,
  "kWh/m²/year": "kWh/m²/vuosi",
  klo: klo$1,
  leaflet: leaflet$1,
  lift: lift$1,
  link_disabled_desc: link_disabled_desc$1,
  link_listings_FI: link_listings_FI$1,
  link_listings_SE: link_listings_SE$1,
  living_area: living_area$1,
  living_area_fi: living_area_fi$1,
  living_area_fi_disclaimer: living_area_fi_disclaimer$1,
  living_area_info: living_area_info$1,
  loan_break_fee: loan_break_fee$1,
  loan_promise_btn: loan_promise_btn$1,
  loan_promise_heading: loan_promise_heading$1,
  lot_FI: lot_FI$1,
  lot_SE: lot_SE$1,
  lot_owner: lot_owner$1,
  lot_owner_SE: lot_owner_SE$1,
  maintenance: maintenance$1,
  maintenance_fee: maintenance_fee$1,
  make_a_booking: make_a_booking$1,
  make_a_booking__se: make_a_booking__se$1,
  make_offer_FI: make_offer_FI$1,
  make_offer_SE: make_offer_SE$1,
  make_offer_desc: make_offer_desc$1,
  match_interested_FI: match_interested_FI$1,
  match_interested_SE: match_interested_SE$1,
  match_reject_FI: match_reject_FI$1,
  match_reject_SE: match_reject_SE$1,
  neighborhood: neighborhood$1,
  no: no$1,
  no_showing: no_showing$1,
  offer_step2_after_btn_FI: offer_step2_after_btn_FI$1,
  offer_step2_after_btn_SE: offer_step2_after_btn_SE$1,
  offer_step2_before_btn_FI: offer_step2_before_btn_FI$1,
  offer_step2_before_btn_SE: offer_step2_before_btn_SE$1,
  offer_step3_FI: offer_step3_FI$1,
  offer_step3_SE: offer_step3_SE$1,
  offer_step4_FI: offer_step4_FI$1,
  offer_step4_SE: offer_step4_SE$1,
  offer_step5_FI: offer_step5_FI$1,
  offer_step5_SE: offer_step5_SE$1,
  open_floorplan: open_floorplan$1,
  openhouse: openhouse$1,
  other_details: other_details$1,
  own_yard: own_yard$1,
  owner_change_fee: owner_change_fee$1,
  parking: parking$1,
  parking_electric_vehicle: parking_electric_vehicle$1,
  parking_powerplug: parking_powerplug$1,
  past_renovations: past_renovations$1,
  pipes: pipes$1,
  postcode: postcode$1,
  "potential buyers": "potentiaalista ostajaa",
  pre_emption_rights: pre_emption_rights$1,
  price_estimate__heading: price_estimate__heading$1,
  price_estimate__heading_SE: price_estimate__heading_SE$1,
  price_estimate__subheading: price_estimate__subheading$1,
  price_estimate__subheading_SE: price_estimate__subheading_SE$1,
  price_estimate__valuate: price_estimate__valuate$1,
  price_estimate__valuate_SE: price_estimate__valuate_SE$1,
  price_for_sale: price_for_sale$1,
  price_for_sale_SE: price_for_sale_SE$1,
  price_info: price_info$1,
  price_per_square: price_per_square$1,
  "promo-etsiva__btn_FI": "Blok Etsivä",
  "promo-etsiva__btn_SE": "Find your home",
  "promo-etsiva__description_FI": "Löydä asunto julkisen markkinan ulkopuolelta.",
  "promo-etsiva__description_SE": "Tell us about your dream home and we and our technology will find it for you - outside the official market.",
  "promo-etsiva__description__sold_FI": "Blok Etsivän avulla voit kontaktoida kriteereihisi sopivien asuntojen omistajat.",
  "promo-etsiva__description__sold_SE": "Tell us about your dream home and we and our technology will find it for you - outside the official market.",
  "promo-etsiva__link_FI": "https://blok.ai/etsiva",
  "promo-etsiva__link_SE": "https://blok.se/en/scout",
  "promo-etsiva__title_FI": "Eikö löydy?",
  "promo-etsiva__title_SE": "Blok Scout",
  "promo-etsiva__title__sold_FI": "Tämä asunto on myyty. Löydä vastaava asunto Etsivällä!",
  "promo-etsiva__title__sold_SE": "This apartment has been sold! With Blok Scout you can find similar apartments.",
  read_description: read_description$1,
  register_for_bidding: register_for_bidding$1,
  register_for_bidding_btn: register_for_bidding_btn$1,
  register_for_bidding_desc: register_for_bidding_desc$1,
  release: release$1,
  release_SE: release_SE$1,
  responsible_broker: responsible_broker$1,
  rm: rm$1,
  roof: roof$1,
  roofing: roofing$1,
  room: room$1,
  rooms: rooms$1,
  sauna: sauna$1,
  scout_fees_FI: scout_fees_FI$1,
  scout_fees_SE: scout_fees_SE$1,
  scout_make_offer: scout_make_offer$1,
  secondary_match_note: secondary_match_note$1,
  see_apartment_FI: see_apartment_FI$1,
  see_apartment_SE: see_apartment_SE$1,
  seller: seller$1,
  send_customer_service_msg: send_customer_service_msg$1,
  share: share$1,
  show_all_bids: show_all_bids$1,
  show_document: show_document$1,
  similar_apartments: similar_apartments$1,
  specifier: specifier$1,
  street: street$1,
  street_address: street_address$1,
  street_level: street_level$1,
  stucco: stucco$1,
  supplementary_info: supplementary_info$1,
  tag__balcony_type__2_plus_balconies: tag__balcony_type__2_plus_balconies$1,
  tag__balcony_type__french: tag__balcony_type__french$1,
  tag__balcony_type__glazed: tag__balcony_type__glazed$1,
  tag__balcony_type__king: tag__balcony_type__king$1,
  tag__balcony_type__open: tag__balcony_type__open$1,
  tag__balcony_type__patio: tag__balcony_type__patio$1,
  tag__balcony_type__roof_terrace: tag__balcony_type__roof_terrace$1,
  tag__balcony_type__traditional: tag__balcony_type__traditional$1,
  tag__elevator: tag__elevator$1,
  tag__fireplace: tag__fireplace$1,
  tag__high_ceiling: tag__high_ceiling$1,
  tag__own_yard: tag__own_yard$1,
  tag__sauna__common: tag__sauna__common$1,
  tag__sauna__own: tag__sauna__own$1,
  to_next: to_next$1,
  to_previous: to_previous$1,
  toggle_fullscreen: toggle_fullscreen$1,
  total_area: total_area$1,
  type: type$1,
  upcoming_apartment: upcoming_apartment$1,
  upcoming_apartment_bold: upcoming_apartment_bold$1,
  upcoming_renovations: upcoming_renovations$1,
  ventilation_system: ventilation_system$1,
  view_3d: view_3d$1,
  views_from_window: views_from_window$1,
  want_to_know_more: want_to_know_more$1,
  washing_machine: washing_machine$1,
  yes: yes$1,
  zoning: zoning$1,
  zoom_inout: zoom_inout$1
};
const Bidding = "Budgivning";
const Blueprint$2 = "Bottenplan";
const Building = "Typ";
const Close = "Stäng (Esc)";
const Excellent = "Utmärkt";
const Good = "Bra";
const Loft = "Lägenhet";
const Luhtitalo = "Loftgångshus";
const Month = "månad";
const Next = "Nästa";
const New = "Ny";
const Own = "Egen";
const Person = "person";
const Poor = "Dåligt";
const Previous = "Tillbaka";
const Rent = "Hyra";
const Rowhouse = "Radhus";
const Satisfactory = "Helt okej";
const Sold = "Såld";
const TV = "TV";
const Unknown = "Okänd";
const Unlivable = "Obeboelig";
const Use = "gånger";
const Year = "år";
const accessible = "Tillgänglig";
const alternative_floorplan = "Alternativ planlösning";
const anonymized_info = "Exact details such as address, housing company and costruction year have been hidden to protect the seller's privacy. We will share this information to interested buyers.";
const apartments_area = "Boarea";
const asbestos = "Asbest";
const association_fee = "Månadsavgift";
const association_fee_fraction = "Andel av årsavgift";
const association_name = "Förening";
const association_ownership_fraction = "Andel av föreningen";
const balcony = "Balkong";
const balcony_direction = "Vädersträck på balkong";
const balcony_type = "Typ av balkong";
const basic_info = "Information om lägenheten";
const bearings = "Väderstreck";
const bid = "Bud";
const bidder = "Budgivare";
const bidding = "Budgivning";
const bidding_open = "Budgivning pågår!";
const book_private_showing_1 = "Reservera ";
const book_private_showing_2 = "en privatvisning";
const book_showing__se = "Anmäl dig till visning";
const bs_asking_price = "Estimerat pris";
const build_in = "Byggnadsår";
const build_year = "Byggnadsår";
const building_apartments = "Antal lägenheter";
const building_info = "Information om byggnaden";
const building_material = "Byggnadsmaterial";
const building_overnight_apartment = "Övernattningslägenhet i föreningen";
const building_sauna = "Bastu i huset";
const building_spaces = "Gemensamma utrymmen";
const building_yard = "Gård";
const built_in = "Byggnadsår";
const close = "Stäng (Esc)";
const commercial_spaces = "Kommersiella utrymmen";
const condition = "Kondition";
const contact_FI = "Kontakt";
const contact_SE = "Kontakta Blok";
const contact_title_FI = "Kontakt";
const contact_title_SE = "Frågor om bostaden?";
const create_account = "Skapa ett användarkonto";
const date = "Datum";
const debt = "Skuld";
const debt_deducted_price = "Försäljningspris";
const dishwasher = "Diskmaskin";
const disponent = "Disponent";
const documents = "Dokument";
const download_document = "Ladda ner alla dokument för det här objektet";
const download_leaflet = "Ladda ner broschyr";
const download_leaflet_pdf = "Ladda ner försäljningsbroschyr för det här objektet i PDF-format";
const energy_cert = "Energiklass";
const energy_performance = "Energiprestanda";
const equipment_bathroom = "Badrumsutrustning";
const equipment_bedroom = "Sovrumutrustning";
const equipment_kitchen = "Köksutrustning";
const equipment_living_room = "Vardagsrumutrustning";
const equipment_other = "Annan utrustning";
const facade = "Fasad";
const fees_FI = "Skötselvederlag och andra avgifter";
const fees_SE = "Månadsavgift och andra avgifter";
const fireplace = "Eldstad";
const floor$1 = "Våning";
const flooring = "Golvmaterial";
const heating = "Uppvärmning";
const high_ceiling = "Högt i tak över 2,7 m";
const highest_bid = "Högsta bud";
const housing_company = "Husbolag";
const how_to_send_offer_FI = "Hur skickar jag ett anbud?";
const how_to_send_offer_SE = "Hur registerar jag för att delta i budgivningen?";
const important_renovation_info = "Viktiga renoveringar";
const indirect_net_debt = "Bostadens indirekta nettoskuldsättning";
const information_not_found = "Uppgiften gick inte att få fram";
const internet = "Internet";
const is_loaned = "Pantsatt";
const klo = "kl";
const leaflet = "Broschyr";
const lift = "Hiss";
const link_disabled_desc = "Att lämna sidan i förhandsgranskningsläget är blockerat.";
const link_listings_FI = "https://blok.ai/sv/bostader/";
const link_listings_SE = "https://blok.se/bostader/";
const living_area = "Boyta";
const living_area_fi = "Boyta i enlighet med bolagsordningen";
const living_area_fi_disclaimer = "Lägenhetens yta har inte kontrollmätts. Ytan i lägenheter byggda innan 1.1.1992 kan vara annan än den i annonsen meddelade om mätt enligt dagens rådande standard.";
const living_area_info = "Information om boarea";
const loan_break_fee = "Pantsättningsavgift";
const loan_promise_btn = "Öppna Lånekalkylatorn";
const loan_promise_heading = "Behöver du lånelöfte?";
const lot_FI = "Tomt";
const lot_SE = "Upplåtelseform";
const lot_owner = "Tomtägartyp";
const lot_owner_SE = "Information om tomtägartyp";
const maintenance = "Servicebolag";
const maintenance_fee = "Skötselvederlag";
const make_a_booking = "Reservera";
const make_a_booking__se = "Föranmälan";
const make_offer_FI = "Skicka anbud";
const make_offer_SE = "Registrera dig för budgivning";
const make_offer_desc = "Det tar endast några minuter att skicka ett skriftligt anbud";
const match_interested_FI = "Jag är intresserad";
const match_interested_SE = "Ja, berätta mer!";
const match_reject_FI = "Inte intresserad";
const match_reject_SE = "Nej, nästa tack";
const neighborhood = "Stadsdel";
const no = "Nej";
const no_showing = "Kontakta oss för en privatvisning";
const offer_step2_after_btn_FI = "knappen på bostadssidan";
const offer_step2_after_btn_SE = "knappen på bostadssidan";
const offer_step2_before_btn_FI = "Du hittar";
const offer_step2_before_btn_SE = "Du hittar";
const offer_step3_FI = "Fyll i detaljerna samt vilkoren och anteckna anbudet elektroniskt.";
const offer_step3_SE = "Läs igenom och bekräfta att ni tagit del av prospektet, årsredovisning, stadgar och energideklaration digitalt.";
const offer_step4_FI = "Budgivning. Köparen kan antingen acceptera ditt anbud eller göra ett motbud.";
const offer_step4_SE = "Legitimera dig med BankID / Mobilt BankID för säker budgivning.";
const offer_step5_FI = "Då anbudet accepteras så skickar vi alla nödvändiga dokument och instruktioner till bägge parter.";
const offer_step5_SE = "Buda online eller via sms när budgivningen är igång.";
const open_floorplan = "Öppen planlösning";
const openhouse = "Visning";
const other_details = "Övrig information";
const own_yard = "Egen gård";
const owner_change_fee = "Överlåtelseavgift";
const parking = "Parkeringsplatser";
const parking_electric_vehicle = "Elbilsladdplats";
const parking_powerplug = "Bilplatsens strömuttag";
const past_renovations = "Gjorda renoveringar";
const pipes = "Rör";
const postcode = "Postkod";
const pre_emption_rights = "Förinlösningns rättigheter";
const price_estimate__heading = "Funderar du på att sälja?";
const price_estimate__heading_SE = "Se direkt vad din bostad är värd.";
const price_estimate__subheading = "Värdera din bostad.";
const price_estimate__subheading_SE = "Digitalt och kostnadsfritt.";
const price_estimate__valuate = "Värdera";
const price_estimate__valuate_SE = "Fortsätt";
const price_for_sale = "Skuldfritt pris";
const price_for_sale_SE = "Utgångpris";
const price_info = "Prisinformation";
const price_per_square = "Kvadratmeterpris";
const read_description = "Läs beskrivning av bostad";
const register_for_bidding = "Registrera dig för budgivning";
const register_for_bidding_btn = "Registrera dig";
const register_for_bidding_desc = "Du kan nu registrera dig för budgivning och lämna ett bud";
const release = "Ledig";
const release_SE = "Tillträde";
const responsible_broker = "Ansvarig mäklare";
const rm = "rum";
const roof = "Tak";
const roofing = "Tak";
const room = "h";
const rooms = "Rum";
const sauna = "Bastu";
const scout_fees_FI = "Skötselvederlag och andra avgifter";
const scout_fees_SE = "Avgifter och andra kostnader";
const scout_make_offer = "Det tar endast några minuter att skicka ett anbud";
const secondary_match_note = "<0>Obs!</0> Denna lägenhet endast delvis motsvarar de kriterier du angivit.";
const see_apartment_FI = "Är du intresserad av att se lägenheten på plats?";
const see_apartment_SE = "Kan detta vara ditt nästa hem?";
const seller = "Säljare";
const send_customer_service_msg = "Skicka ett meddelande till Blok";
const share = "Dela";
const show_all_bids = "Visa alla bud";
const show_document = "Visa dokument";
const similar_apartments = "Liknande bostäder";
const specifier = "Lägenhetsnummer";
const street = "Gata";
const street_address = "Gatuadress";
const street_level = "På gatunivå";
const stucco = "Stuckaturer";
const supplementary_info = "Säljarens kommentarer";
const tag__balcony_type__2_plus_balconies = "2+ balkonger";
const tag__balcony_type__french = "Fransk balkong";
const tag__balcony_type__glazed = "Inglasad balkong";
const tag__balcony_type__king = "Kungsbalkong";
const tag__balcony_type__open = "Balkong";
const tag__balcony_type__patio = "Egen uteplats";
const tag__balcony_type__roof_terrace = "Takterrass";
const tag__balcony_type__traditional = "Balkong";
const tag__elevator = "Hiss";
const tag__fireplace = "Eldstad";
const tag__high_ceiling = "Högt i tak +2,7m";
const tag__own_yard = "Egen gård";
const tag__sauna__common = "Gemensam sauna";
const tag__sauna__own = "Egen bastu";
const to_next = "Följande (höger musknapp)";
const to_previous = "Föregående (vänster musknapp)";
const toggle_fullscreen = "Visa i helskärmsläge";
const total_area = "Total yta";
const type = "Typ";
const upcoming_apartment = "Som köpare har du därmed en möjlighet köpa innan objektet kommer ut på öppna marknaden. Vill du veta mer om hemmet, lägga ett bud eller kanske själv är intresserad av att lägga ut din bostad på Pre-Sale? Hör av dig till oss.";
const upcoming_apartment_bold = "Det här är en Pre-Sale bostad.";
const upcoming_renovations = "Framtida renoveringar";
const ventilation_system = "Ventilation";
const view_3d = "Visa 3D presentation";
const views_from_window = "Vy från fönstret";
const want_to_know_more = "Do you want to know more?";
const washing_machine = "Tvättmaskin";
const yes = "Ja";
const zoning = "Detaljplan";
const zoom_inout = "Zooma in/ut";
const sv = {
  "/en/valuation": "",
  "/en/valuation-en": "",
  "/en/valuation-web": "/vardera-web",
  "Apartment building": "Lägenhet",
  "Apartment house": "Lägenhet",
  "Back to search": "Tillbaka",
  Bidding,
  Blueprint: Blueprint$2,
  Building,
  Close,
  "Cubic meter": "m³",
  "Detached house": "Fristående hus",
  Excellent,
  "Exclusively for you": "Exklusivt för dig",
  "Go to homepage": "Gå till framsidan",
  Good,
  "However, you are the first in line so act fast": "Men du står först i kön, så agera snabbt!",
  "Kilowatt hour": "kWh",
  "Linked house": "Kedjehus",
  Loft,
  "Long lease": "Tomträtt",
  Luhtitalo,
  "Wooden house": "Wooden house",
  Month,
  Next,
  New,
  "Offer deadline": "Deadline för anbud",
  Own,
  "Owns the land": "Äger marken",
  "Per person per month": "person/månad",
  "Per use per month": "användare/månad",
  Person,
  Poor,
  Previous,
  "Properties on sale": "Bostäder till salu",
  "Puutalo-osake": "Trähus-aktie",
  Rent,
  "Rent, optional": "Valfri hyrestomt",
  Rowhouse,
  Satisfactory,
  "Semi-detached": "Parhus",
  "Semi-detached house": "Parhus",
  Sold,
  "Terraced house": "Radhus",
  TV,
  "Unfortunately, we couldn't find the page you were looking for.": "Tyvärr kan vi inte hitta sidan du söker efter.",
  Unknown,
  Unlivable,
  Use,
  Year,
  "Want to go on a showing?": "Vill du gå på visning?",
  accessible,
  alternative_floorplan,
  anonymized_info,
  apartments_area,
  asbestos,
  association_fee,
  association_fee_fraction,
  association_name,
  association_ownership_fraction,
  balcony,
  balcony_direction,
  balcony_type,
  basic_info,
  bearings,
  bid,
  bidder,
  bidding,
  bidding_open,
  book_private_showing_1,
  book_private_showing_2,
  book_showing__se,
  bs_asking_price,
  build_in,
  build_year,
  building_apartments,
  building_info,
  building_material,
  building_overnight_apartment,
  building_sauna,
  building_spaces,
  building_yard,
  built_in,
  close,
  commercial_spaces,
  condition,
  contact_FI,
  contact_SE,
  contact_title_FI,
  contact_title_SE,
  create_account,
  date,
  debt,
  debt_deducted_price,
  dishwasher,
  disponent,
  documents,
  download_document,
  download_leaflet,
  download_leaflet_pdf,
  energy_cert,
  energy_performance,
  equipment_bathroom,
  equipment_bedroom,
  equipment_kitchen,
  equipment_living_room,
  equipment_other,
  facade,
  fees_FI,
  fees_SE,
  fireplace,
  floor: floor$1,
  flooring,
  heating,
  high_ceiling,
  highest_bid,
  housing_company,
  how_to_send_offer_FI,
  how_to_send_offer_SE,
  important_renovation_info,
  "in progress": "pågår",
  indirect_net_debt,
  information_not_found,
  internet,
  is_loaned,
  "kWh/m²/year": "kWh/m²/år",
  klo,
  leaflet,
  lift,
  link_disabled_desc,
  link_listings_FI,
  link_listings_SE,
  living_area,
  living_area_fi,
  living_area_fi_disclaimer,
  living_area_info,
  loan_break_fee,
  loan_promise_btn,
  loan_promise_heading,
  lot_FI,
  lot_SE,
  lot_owner,
  lot_owner_SE,
  maintenance,
  maintenance_fee,
  make_a_booking,
  make_a_booking__se,
  make_offer_FI,
  make_offer_SE,
  make_offer_desc,
  match_interested_FI,
  match_interested_SE,
  match_reject_FI,
  match_reject_SE,
  neighborhood,
  no,
  no_showing,
  offer_step2_after_btn_FI,
  offer_step2_after_btn_SE,
  offer_step2_before_btn_FI,
  offer_step2_before_btn_SE,
  offer_step3_FI,
  offer_step3_SE,
  offer_step4_FI,
  offer_step4_SE,
  offer_step5_FI,
  offer_step5_SE,
  open_floorplan,
  openhouse,
  other_details,
  own_yard,
  owner_change_fee,
  parking,
  parking_electric_vehicle,
  parking_powerplug,
  past_renovations,
  pipes,
  postcode,
  "potential buyers": "potentiella köpare",
  pre_emption_rights,
  price_estimate__heading,
  price_estimate__heading_SE,
  price_estimate__subheading,
  price_estimate__subheading_SE,
  price_estimate__valuate,
  price_estimate__valuate_SE,
  price_for_sale,
  price_for_sale_SE,
  price_info,
  price_per_square,
  "promo-etsiva__btn_FI": "Blok Etsivä",
  "promo-etsiva__btn_SE": "Sök bostad",
  "promo-etsiva__description_FI": "Hitta en bostad utanför den publika marknaden.",
  "promo-etsiva__description_SE": "Berätta om ditt drömhem och vi och vår teknologi söker upp det åt dig.",
  "promo-etsiva__description__sold_FI": "Hitta en bostad utanför den publika marknaden.",
  "promo-etsiva__description__sold_SE": "Berätta om ditt drömhem och vi och vår teknologi söker upp det åt dig.",
  "promo-etsiva__link_FI": "https://blok.ai/sv/etsiva",
  "promo-etsiva__link_SE": "https://blok.se/scout",
  "promo-etsiva__title_FI": "Inget passligt?",
  "promo-etsiva__title_SE": "Blok Scout",
  "promo-etsiva__title__sold_FI": "Detta hem har sålts. Med Blok Etsivä kan du hitta liknande bostadsrätter.",
  "promo-etsiva__title__sold_SE": "Detta hem har sålts. Med Bloks tjänst Scout kan du hitta liknande bostadsrätter.",
  read_description,
  register_for_bidding,
  register_for_bidding_btn,
  register_for_bidding_desc,
  release,
  release_SE,
  responsible_broker,
  rm,
  roof,
  roofing,
  room,
  rooms,
  sauna,
  scout_fees_FI,
  scout_fees_SE,
  scout_make_offer,
  secondary_match_note,
  see_apartment_FI,
  see_apartment_SE,
  seller,
  send_customer_service_msg,
  share,
  show_all_bids,
  show_document,
  similar_apartments,
  specifier,
  street,
  street_address,
  street_level,
  stucco,
  supplementary_info,
  tag__balcony_type__2_plus_balconies,
  tag__balcony_type__french,
  tag__balcony_type__glazed,
  tag__balcony_type__king,
  tag__balcony_type__open,
  tag__balcony_type__patio,
  tag__balcony_type__roof_terrace,
  tag__balcony_type__traditional,
  tag__elevator,
  tag__fireplace,
  tag__high_ceiling,
  tag__own_yard,
  tag__sauna__common,
  tag__sauna__own,
  to_next,
  to_previous,
  toggle_fullscreen,
  total_area,
  type,
  upcoming_apartment,
  upcoming_apartment_bold,
  upcoming_renovations,
  ventilation_system,
  view_3d,
  views_from_window,
  want_to_know_more,
  washing_machine,
  yes,
  zoning,
  zoom_inout
};
const resources = {
  fi: { translation: fi },
  en: { translation: en },
  sv: { translation: sv }
};
function setupI18Next() {
  instance.use(initReactI18next).use(Browser).init({
    detection: {
      // order and from where user language should be detected
      order: ["path", "querystring", "htmlTag"],
      // keys or params to lookup language from
      lookupQueryString: "lng",
      lookupFromPathIndex: 0
    },
    initImmediate: false,
    preload: ["en", "fi", "sv"],
    resources,
    supportedLngs: ["fi", "sv", "en"],
    fallbackLng: "fi",
    nsSeparator: ":",
    keySeparator: false,
    interpolation: {
      escapeValue: false
      // react already safes from xss
    },
    react: {
      useSuspense: false
    }
  });
  return instance;
}
var jsxRuntimeExports = {};
var jsxRuntime = {
  get exports() {
    return jsxRuntimeExports;
  },
  set exports(v2) {
    jsxRuntimeExports = v2;
  }
};
var reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign$1;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign)
    return objectAssign$1;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty2 = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i2 = 0; i2 < 10; i2++) {
        test2["_" + String.fromCharCode(i2)] = i2;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
        return test2[n2];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign$1 = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s2 = 1; s2 < arguments.length; s2++) {
      from = Object(arguments[s2]);
      for (var key in from) {
        if (hasOwnProperty2.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i2 = 0; i2 < symbols.length; i2++) {
          if (propIsEnumerable.call(from, symbols[i2])) {
            to[symbols[i2]] = from[symbols[i2]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign$1;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  requireObjectAssign();
  var f2 = React__default$1, g = 60103;
  reactJsxRuntime_production_min.Fragment = 60107;
  if ("function" === typeof Symbol && Symbol.for) {
    var h2 = Symbol.for;
    g = h2("react.element");
    reactJsxRuntime_production_min.Fragment = h2("react.fragment");
  }
  var m2 = f2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n2 = Object.prototype.hasOwnProperty, p2 = { key: true, ref: true, __self: true, __source: true };
  function q(c2, a2, k2) {
    var b, d2 = {}, e2 = null, l2 = null;
    void 0 !== k2 && (e2 = "" + k2);
    void 0 !== a2.key && (e2 = "" + a2.key);
    void 0 !== a2.ref && (l2 = a2.ref);
    for (b in a2)
      n2.call(a2, b) && !p2.hasOwnProperty(b) && (d2[b] = a2[b]);
    if (c2 && c2.defaultProps)
      for (b in a2 = c2.defaultProps, a2)
        void 0 === d2[b] && (d2[b] = a2[b]);
    return { $$typeof: g, type: c2, key: e2, ref: l2, props: d2, _owner: m2.current };
  }
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development)
    return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  (function(exports) {
    if (process.env.NODE_ENV !== "production") {
      (function() {
        var React2 = React__default$1;
        var _assign = requireObjectAssign();
        var REACT_ELEMENT_TYPE = 60103;
        var REACT_PORTAL_TYPE = 60106;
        exports.Fragment = 60107;
        var REACT_STRICT_MODE_TYPE = 60108;
        var REACT_PROFILER_TYPE = 60114;
        var REACT_PROVIDER_TYPE = 60109;
        var REACT_CONTEXT_TYPE = 60110;
        var REACT_FORWARD_REF_TYPE = 60112;
        var REACT_SUSPENSE_TYPE = 60113;
        var REACT_SUSPENSE_LIST_TYPE = 60120;
        var REACT_MEMO_TYPE = 60115;
        var REACT_LAZY_TYPE = 60116;
        var REACT_BLOCK_TYPE = 60121;
        var REACT_SERVER_BLOCK_TYPE = 60122;
        var REACT_FUNDAMENTAL_TYPE = 60117;
        var REACT_DEBUG_TRACING_MODE_TYPE = 60129;
        var REACT_LEGACY_HIDDEN_TYPE = 60131;
        if (typeof Symbol === "function" && Symbol.for) {
          var symbolFor = Symbol.for;
          REACT_ELEMENT_TYPE = symbolFor("react.element");
          REACT_PORTAL_TYPE = symbolFor("react.portal");
          exports.Fragment = symbolFor("react.fragment");
          REACT_STRICT_MODE_TYPE = symbolFor("react.strict_mode");
          REACT_PROFILER_TYPE = symbolFor("react.profiler");
          REACT_PROVIDER_TYPE = symbolFor("react.provider");
          REACT_CONTEXT_TYPE = symbolFor("react.context");
          REACT_FORWARD_REF_TYPE = symbolFor("react.forward_ref");
          REACT_SUSPENSE_TYPE = symbolFor("react.suspense");
          REACT_SUSPENSE_LIST_TYPE = symbolFor("react.suspense_list");
          REACT_MEMO_TYPE = symbolFor("react.memo");
          REACT_LAZY_TYPE = symbolFor("react.lazy");
          REACT_BLOCK_TYPE = symbolFor("react.block");
          REACT_SERVER_BLOCK_TYPE = symbolFor("react.server.block");
          REACT_FUNDAMENTAL_TYPE = symbolFor("react.fundamental");
          symbolFor("react.scope");
          symbolFor("react.opaque.id");
          REACT_DEBUG_TRACING_MODE_TYPE = symbolFor("react.debug_trace_mode");
          symbolFor("react.offscreen");
          REACT_LEGACY_HIDDEN_TYPE = symbolFor("react.legacy_hidden");
        }
        var MAYBE_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
        var FAUX_ITERATOR_SYMBOL = "@@iterator";
        function getIteratorFn(maybeIterable) {
          if (maybeIterable === null || typeof maybeIterable !== "object") {
            return null;
          }
          var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
          if (typeof maybeIterator === "function") {
            return maybeIterator;
          }
          return null;
        }
        var ReactSharedInternals = React2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        function error2(format) {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format, args);
          }
        }
        function printWarning(level, format, args) {
          {
            var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
            var stack = ReactDebugCurrentFrame2.getStackAddendum();
            if (stack !== "") {
              format += "%s";
              args = args.concat([stack]);
            }
            var argsWithFormat = args.map(function(item) {
              return "" + item;
            });
            argsWithFormat.unshift("Warning: " + format);
            Function.prototype.apply.call(console[level], console, argsWithFormat);
          }
        }
        var enableScopeAPI = false;
        function isValidElementType(type2) {
          if (typeof type2 === "string" || typeof type2 === "function") {
            return true;
          }
          if (type2 === exports.Fragment || type2 === REACT_PROFILER_TYPE || type2 === REACT_DEBUG_TRACING_MODE_TYPE || type2 === REACT_STRICT_MODE_TYPE || type2 === REACT_SUSPENSE_TYPE || type2 === REACT_SUSPENSE_LIST_TYPE || type2 === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
            return true;
          }
          if (typeof type2 === "object" && type2 !== null) {
            if (type2.$$typeof === REACT_LAZY_TYPE || type2.$$typeof === REACT_MEMO_TYPE || type2.$$typeof === REACT_PROVIDER_TYPE || type2.$$typeof === REACT_CONTEXT_TYPE || type2.$$typeof === REACT_FORWARD_REF_TYPE || type2.$$typeof === REACT_FUNDAMENTAL_TYPE || type2.$$typeof === REACT_BLOCK_TYPE || type2[0] === REACT_SERVER_BLOCK_TYPE) {
              return true;
            }
          }
          return false;
        }
        function getWrappedName(outerType, innerType, wrapperName) {
          var functionName = innerType.displayName || innerType.name || "";
          return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
        }
        function getContextName(type2) {
          return type2.displayName || "Context";
        }
        function getComponentName(type2) {
          if (type2 == null) {
            return null;
          }
          {
            if (typeof type2.tag === "number") {
              error2("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
            }
          }
          if (typeof type2 === "function") {
            return type2.displayName || type2.name || null;
          }
          if (typeof type2 === "string") {
            return type2;
          }
          switch (type2) {
            case exports.Fragment:
              return "Fragment";
            case REACT_PORTAL_TYPE:
              return "Portal";
            case REACT_PROFILER_TYPE:
              return "Profiler";
            case REACT_STRICT_MODE_TYPE:
              return "StrictMode";
            case REACT_SUSPENSE_TYPE:
              return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
              return "SuspenseList";
          }
          if (typeof type2 === "object") {
            switch (type2.$$typeof) {
              case REACT_CONTEXT_TYPE:
                var context = type2;
                return getContextName(context) + ".Consumer";
              case REACT_PROVIDER_TYPE:
                var provider = type2;
                return getContextName(provider._context) + ".Provider";
              case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type2, type2.render, "ForwardRef");
              case REACT_MEMO_TYPE:
                return getComponentName(type2.type);
              case REACT_BLOCK_TYPE:
                return getComponentName(type2._render);
              case REACT_LAZY_TYPE: {
                var lazyComponent = type2;
                var payload = lazyComponent._payload;
                var init2 = lazyComponent._init;
                try {
                  return getComponentName(init2(payload));
                } catch (x2) {
                  return null;
                }
              }
            }
          }
          return null;
        }
        var disabledDepth = 0;
        var prevLog;
        var prevInfo;
        var prevWarn;
        var prevError;
        var prevGroup;
        var prevGroupCollapsed;
        var prevGroupEnd;
        function disabledLog() {
        }
        disabledLog.__reactDisabledLog = true;
        function disableLogs() {
          {
            if (disabledDepth === 0) {
              prevLog = console.log;
              prevInfo = console.info;
              prevWarn = console.warn;
              prevError = console.error;
              prevGroup = console.group;
              prevGroupCollapsed = console.groupCollapsed;
              prevGroupEnd = console.groupEnd;
              var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
              };
              Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
              });
            }
            disabledDepth++;
          }
        }
        function reenableLogs() {
          {
            disabledDepth--;
            if (disabledDepth === 0) {
              var props = {
                configurable: true,
                enumerable: true,
                writable: true
              };
              Object.defineProperties(console, {
                log: _assign({}, props, {
                  value: prevLog
                }),
                info: _assign({}, props, {
                  value: prevInfo
                }),
                warn: _assign({}, props, {
                  value: prevWarn
                }),
                error: _assign({}, props, {
                  value: prevError
                }),
                group: _assign({}, props, {
                  value: prevGroup
                }),
                groupCollapsed: _assign({}, props, {
                  value: prevGroupCollapsed
                }),
                groupEnd: _assign({}, props, {
                  value: prevGroupEnd
                })
              });
            }
            if (disabledDepth < 0) {
              error2("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
            }
          }
        }
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        var prefix;
        function describeBuiltInComponentFrame(name, source, ownerFn) {
          {
            if (prefix === void 0) {
              try {
                throw Error();
              } catch (x2) {
                var match2 = x2.stack.trim().match(/\n( *(at )?)/);
                prefix = match2 && match2[1] || "";
              }
            }
            return "\n" + prefix + name;
          }
        }
        var reentry = false;
        var componentFrameCache;
        {
          var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
          componentFrameCache = new PossiblyWeakMap();
        }
        function describeNativeComponentFrame(fn, construct) {
          if (!fn || reentry) {
            return "";
          }
          {
            var frame = componentFrameCache.get(fn);
            if (frame !== void 0) {
              return frame;
            }
          }
          var control;
          reentry = true;
          var previousPrepareStackTrace = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          var previousDispatcher;
          {
            previousDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = null;
            disableLogs();
          }
          try {
            if (construct) {
              var Fake = function() {
                throw Error();
              };
              Object.defineProperty(Fake.prototype, "props", {
                set: function() {
                  throw Error();
                }
              });
              if (typeof Reflect === "object" && Reflect.construct) {
                try {
                  Reflect.construct(Fake, []);
                } catch (x2) {
                  control = x2;
                }
                Reflect.construct(fn, [], Fake);
              } else {
                try {
                  Fake.call();
                } catch (x2) {
                  control = x2;
                }
                fn.call(Fake.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (x2) {
                control = x2;
              }
              fn();
            }
          } catch (sample) {
            if (sample && control && typeof sample.stack === "string") {
              var sampleLines = sample.stack.split("\n");
              var controlLines = control.stack.split("\n");
              var s2 = sampleLines.length - 1;
              var c2 = controlLines.length - 1;
              while (s2 >= 1 && c2 >= 0 && sampleLines[s2] !== controlLines[c2]) {
                c2--;
              }
              for (; s2 >= 1 && c2 >= 0; s2--, c2--) {
                if (sampleLines[s2] !== controlLines[c2]) {
                  if (s2 !== 1 || c2 !== 1) {
                    do {
                      s2--;
                      c2--;
                      if (c2 < 0 || sampleLines[s2] !== controlLines[c2]) {
                        var _frame = "\n" + sampleLines[s2].replace(" at new ", " at ");
                        {
                          if (typeof fn === "function") {
                            componentFrameCache.set(fn, _frame);
                          }
                        }
                        return _frame;
                      }
                    } while (s2 >= 1 && c2 >= 0);
                  }
                  break;
                }
              }
            }
          } finally {
            reentry = false;
            {
              ReactCurrentDispatcher.current = previousDispatcher;
              reenableLogs();
            }
            Error.prepareStackTrace = previousPrepareStackTrace;
          }
          var name = fn ? fn.displayName || fn.name : "";
          var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
          {
            if (typeof fn === "function") {
              componentFrameCache.set(fn, syntheticFrame);
            }
          }
          return syntheticFrame;
        }
        function describeFunctionComponentFrame(fn, source, ownerFn) {
          {
            return describeNativeComponentFrame(fn, false);
          }
        }
        function shouldConstruct(Component) {
          var prototype = Component.prototype;
          return !!(prototype && prototype.isReactComponent);
        }
        function describeUnknownElementTypeFrameInDEV(type2, source, ownerFn) {
          if (type2 == null) {
            return "";
          }
          if (typeof type2 === "function") {
            {
              return describeNativeComponentFrame(type2, shouldConstruct(type2));
            }
          }
          if (typeof type2 === "string") {
            return describeBuiltInComponentFrame(type2);
          }
          switch (type2) {
            case REACT_SUSPENSE_TYPE:
              return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
              return describeBuiltInComponentFrame("SuspenseList");
          }
          if (typeof type2 === "object") {
            switch (type2.$$typeof) {
              case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type2.render);
              case REACT_MEMO_TYPE:
                return describeUnknownElementTypeFrameInDEV(type2.type, source, ownerFn);
              case REACT_BLOCK_TYPE:
                return describeFunctionComponentFrame(type2._render);
              case REACT_LAZY_TYPE: {
                var lazyComponent = type2;
                var payload = lazyComponent._payload;
                var init2 = lazyComponent._init;
                try {
                  return describeUnknownElementTypeFrameInDEV(init2(payload), source, ownerFn);
                } catch (x2) {
                }
              }
            }
          }
          return "";
        }
        var loggedTypeFailures = {};
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        function setCurrentlyValidatingElement(element) {
          {
            if (element) {
              var owner = element._owner;
              var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
              ReactDebugCurrentFrame.setExtraStackFrame(stack);
            } else {
              ReactDebugCurrentFrame.setExtraStackFrame(null);
            }
          }
        }
        function checkPropTypes(typeSpecs, values, location, componentName, element) {
          {
            var has2 = Function.call.bind(Object.prototype.hasOwnProperty);
            for (var typeSpecName in typeSpecs) {
              if (has2(typeSpecs, typeSpecName)) {
                var error$1 = void 0;
                try {
                  if (typeof typeSpecs[typeSpecName] !== "function") {
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                  }
                  error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
                } catch (ex) {
                  error$1 = ex;
                }
                if (error$1 && !(error$1 instanceof Error)) {
                  setCurrentlyValidatingElement(element);
                  error2("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                  setCurrentlyValidatingElement(null);
                }
                if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                  loggedTypeFailures[error$1.message] = true;
                  setCurrentlyValidatingElement(element);
                  error2("Failed %s type: %s", location, error$1.message);
                  setCurrentlyValidatingElement(null);
                }
              }
            }
          }
        }
        var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
        var hasOwnProperty2 = Object.prototype.hasOwnProperty;
        var RESERVED_PROPS = {
          key: true,
          ref: true,
          __self: true,
          __source: true
        };
        var specialPropKeyWarningShown;
        var specialPropRefWarningShown;
        var didWarnAboutStringRefs;
        {
          didWarnAboutStringRefs = {};
        }
        function hasValidRef(config2) {
          {
            if (hasOwnProperty2.call(config2, "ref")) {
              var getter = Object.getOwnPropertyDescriptor(config2, "ref").get;
              if (getter && getter.isReactWarning) {
                return false;
              }
            }
          }
          return config2.ref !== void 0;
        }
        function hasValidKey(config2) {
          {
            if (hasOwnProperty2.call(config2, "key")) {
              var getter = Object.getOwnPropertyDescriptor(config2, "key").get;
              if (getter && getter.isReactWarning) {
                return false;
              }
            }
          }
          return config2.key !== void 0;
        }
        function warnIfStringRefCannotBeAutoConverted(config2, self2) {
          {
            if (typeof config2.ref === "string" && ReactCurrentOwner.current && self2 && ReactCurrentOwner.current.stateNode !== self2) {
              var componentName = getComponentName(ReactCurrentOwner.current.type);
              if (!didWarnAboutStringRefs[componentName]) {
                error2('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config2.ref);
                didWarnAboutStringRefs[componentName] = true;
              }
            }
          }
        }
        function defineKeyPropWarningGetter(props, displayName) {
          {
            var warnAboutAccessingKey = function() {
              if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error2("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
              }
            };
            warnAboutAccessingKey.isReactWarning = true;
            Object.defineProperty(props, "key", {
              get: warnAboutAccessingKey,
              configurable: true
            });
          }
        }
        function defineRefPropWarningGetter(props, displayName) {
          {
            var warnAboutAccessingRef = function() {
              if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error2("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
              }
            };
            warnAboutAccessingRef.isReactWarning = true;
            Object.defineProperty(props, "ref", {
              get: warnAboutAccessingRef,
              configurable: true
            });
          }
        }
        var ReactElement = function(type2, key, ref, self2, source, owner, props) {
          var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type2,
            key,
            ref,
            props,
            // Record the component responsible for creating this element.
            _owner: owner
          };
          {
            element._store = {};
            Object.defineProperty(element._store, "validated", {
              configurable: false,
              enumerable: false,
              writable: true,
              value: false
            });
            Object.defineProperty(element, "_self", {
              configurable: false,
              enumerable: false,
              writable: false,
              value: self2
            });
            Object.defineProperty(element, "_source", {
              configurable: false,
              enumerable: false,
              writable: false,
              value: source
            });
            if (Object.freeze) {
              Object.freeze(element.props);
              Object.freeze(element);
            }
          }
          return element;
        };
        function jsxDEV(type2, config2, maybeKey, source, self2) {
          {
            var propName;
            var props = {};
            var key = null;
            var ref = null;
            if (maybeKey !== void 0) {
              key = "" + maybeKey;
            }
            if (hasValidKey(config2)) {
              key = "" + config2.key;
            }
            if (hasValidRef(config2)) {
              ref = config2.ref;
              warnIfStringRefCannotBeAutoConverted(config2, self2);
            }
            for (propName in config2) {
              if (hasOwnProperty2.call(config2, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                props[propName] = config2[propName];
              }
            }
            if (type2 && type2.defaultProps) {
              var defaultProps = type2.defaultProps;
              for (propName in defaultProps) {
                if (props[propName] === void 0) {
                  props[propName] = defaultProps[propName];
                }
              }
            }
            if (key || ref) {
              var displayName = typeof type2 === "function" ? type2.displayName || type2.name || "Unknown" : type2;
              if (key) {
                defineKeyPropWarningGetter(props, displayName);
              }
              if (ref) {
                defineRefPropWarningGetter(props, displayName);
              }
            }
            return ReactElement(type2, key, ref, self2, source, ReactCurrentOwner.current, props);
          }
        }
        var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
        var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
        function setCurrentlyValidatingElement$1(element) {
          {
            if (element) {
              var owner = element._owner;
              var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
              ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
            } else {
              ReactDebugCurrentFrame$1.setExtraStackFrame(null);
            }
          }
        }
        var propTypesMisspellWarningShown;
        {
          propTypesMisspellWarningShown = false;
        }
        function isValidElement2(object) {
          {
            return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
          }
        }
        function getDeclarationErrorAddendum() {
          {
            if (ReactCurrentOwner$1.current) {
              var name = getComponentName(ReactCurrentOwner$1.current.type);
              if (name) {
                return "\n\nCheck the render method of `" + name + "`.";
              }
            }
            return "";
          }
        }
        function getSourceInfoErrorAddendum(source) {
          {
            if (source !== void 0) {
              var fileName = source.fileName.replace(/^.*[\\\/]/, "");
              var lineNumber = source.lineNumber;
              return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
            }
            return "";
          }
        }
        var ownerHasKeyUseWarning = {};
        function getCurrentComponentErrorInfo(parentType) {
          {
            var info = getDeclarationErrorAddendum();
            if (!info) {
              var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
              if (parentName) {
                info = "\n\nCheck the top-level render call using <" + parentName + ">.";
              }
            }
            return info;
          }
        }
        function validateExplicitKey(element, parentType) {
          {
            if (!element._store || element._store.validated || element.key != null) {
              return;
            }
            element._store.validated = true;
            var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
            if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
              return;
            }
            ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
            var childOwner = "";
            if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
              childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
            }
            setCurrentlyValidatingElement$1(element);
            error2('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
            setCurrentlyValidatingElement$1(null);
          }
        }
        function validateChildKeys(node, parentType) {
          {
            if (typeof node !== "object") {
              return;
            }
            if (Array.isArray(node)) {
              for (var i2 = 0; i2 < node.length; i2++) {
                var child = node[i2];
                if (isValidElement2(child)) {
                  validateExplicitKey(child, parentType);
                }
              }
            } else if (isValidElement2(node)) {
              if (node._store) {
                node._store.validated = true;
              }
            } else if (node) {
              var iteratorFn = getIteratorFn(node);
              if (typeof iteratorFn === "function") {
                if (iteratorFn !== node.entries) {
                  var iterator = iteratorFn.call(node);
                  var step;
                  while (!(step = iterator.next()).done) {
                    if (isValidElement2(step.value)) {
                      validateExplicitKey(step.value, parentType);
                    }
                  }
                }
              }
            }
          }
        }
        function validatePropTypes(element) {
          {
            var type2 = element.type;
            if (type2 === null || type2 === void 0 || typeof type2 === "string") {
              return;
            }
            var propTypes2;
            if (typeof type2 === "function") {
              propTypes2 = type2.propTypes;
            } else if (typeof type2 === "object" && (type2.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
            // Inner props are checked in the reconciler.
            type2.$$typeof === REACT_MEMO_TYPE)) {
              propTypes2 = type2.propTypes;
            } else {
              return;
            }
            if (propTypes2) {
              var name = getComponentName(type2);
              checkPropTypes(propTypes2, element.props, "prop", name, element);
            } else if (type2.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
              propTypesMisspellWarningShown = true;
              var _name = getComponentName(type2);
              error2("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
            }
            if (typeof type2.getDefaultProps === "function" && !type2.getDefaultProps.isReactClassApproved) {
              error2("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
            }
          }
        }
        function validateFragmentProps(fragment) {
          {
            var keys2 = Object.keys(fragment.props);
            for (var i2 = 0; i2 < keys2.length; i2++) {
              var key = keys2[i2];
              if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error2("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
              }
            }
            if (fragment.ref !== null) {
              setCurrentlyValidatingElement$1(fragment);
              error2("Invalid attribute `ref` supplied to `React.Fragment`.");
              setCurrentlyValidatingElement$1(null);
            }
          }
        }
        function jsxWithValidation(type2, props, key, isStaticChildren, source, self2) {
          {
            var validType = isValidElementType(type2);
            if (!validType) {
              var info = "";
              if (type2 === void 0 || typeof type2 === "object" && type2 !== null && Object.keys(type2).length === 0) {
                info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
              }
              var sourceInfo = getSourceInfoErrorAddendum(source);
              if (sourceInfo) {
                info += sourceInfo;
              } else {
                info += getDeclarationErrorAddendum();
              }
              var typeString;
              if (type2 === null) {
                typeString = "null";
              } else if (Array.isArray(type2)) {
                typeString = "array";
              } else if (type2 !== void 0 && type2.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentName(type2.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
              } else {
                typeString = typeof type2;
              }
              error2("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
            }
            var element = jsxDEV(type2, props, key, source, self2);
            if (element == null) {
              return element;
            }
            if (validType) {
              var children = props.children;
              if (children !== void 0) {
                if (isStaticChildren) {
                  if (Array.isArray(children)) {
                    for (var i2 = 0; i2 < children.length; i2++) {
                      validateChildKeys(children[i2], type2);
                    }
                    if (Object.freeze) {
                      Object.freeze(children);
                    }
                  } else {
                    error2("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                  }
                } else {
                  validateChildKeys(children, type2);
                }
              }
            }
            if (type2 === exports.Fragment) {
              validateFragmentProps(element);
            } else {
              validatePropTypes(element);
            }
            return element;
          }
        }
        function jsxWithValidationStatic(type2, props, key) {
          {
            return jsxWithValidation(type2, props, key, true);
          }
        }
        function jsxWithValidationDynamic(type2, props, key) {
          {
            return jsxWithValidation(type2, props, key, false);
          }
        }
        var jsx2 = jsxWithValidationDynamic;
        var jsxs2 = jsxWithValidationStatic;
        exports.jsx = jsx2;
        exports.jsxs = jsxs2;
      })();
    }
  })(reactJsxRuntime_development);
  return reactJsxRuntime_development;
}
(function(module) {
  if (process.env.NODE_ENV === "production") {
    module.exports = requireReactJsxRuntime_production_min();
  } else {
    module.exports = requireReactJsxRuntime_development();
  }
})(jsxRuntime);
const Fragment = jsxRuntimeExports.Fragment;
const jsx = jsxRuntimeExports.jsx;
const jsxs = jsxRuntimeExports.jsxs;
var classnamesExports = {};
var classnames = {
  get exports() {
    return classnamesExports;
  },
  set exports(v2) {
    classnamesExports = v2;
  }
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(module) {
  (function() {
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
      var classes2 = [];
      for (var i2 = 0; i2 < arguments.length; i2++) {
        var arg = arguments[i2];
        if (!arg)
          continue;
        var argType = typeof arg;
        if (argType === "string" || argType === "number") {
          classes2.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner = classNames.apply(null, arg);
            if (inner) {
              classes2.push(inner);
            }
          }
        } else if (argType === "object") {
          if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
            classes2.push(arg.toString());
            continue;
          }
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes2.push(key);
            }
          }
        }
      }
      return classes2.join(" ");
    }
    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
})(classnames);
const cx = classnamesExports;
const SvgVideoPlayer = (props) => /* @__PURE__ */ React$3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 127 127", ...props }, /* @__PURE__ */ React$3.createElement("path", { d: "M63.5 127C28.4 127 0 98.6 0 63.5S28.4 0 63.5 0 127 28.4 127 63.5 98.6 127 63.5 127zm0-2c34 0 61.5-27.5 61.5-61.5S97.5 2 63.5 2 2 29.5 2 63.5 29.5 125 63.5 125z" }), /* @__PURE__ */ React$3.createElement("path", { d: "M86.2 63L47 35.9v54.2L86.2 63zm2.4.8l-42 29A1 1 0 0145 92V34c0-.8.9-1.3 1.6-.8l42 29c.5.4.5 1.2 0 1.6z" }));
var DefaultContext = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
};
var IconContext = React__default$1.createContext && React__default$1.createContext(DefaultContext);
var __assign$2 = globalThis && globalThis.__assign || function() {
  __assign$2 = Object.assign || function(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign$2.apply(this, arguments);
};
var __rest$2 = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
function Tree2Element(tree) {
  return tree && tree.map(function(node, i2) {
    return React__default$1.createElement(node.tag, __assign$2({
      key: i2
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon(data) {
  return function(props) {
    return React__default$1.createElement(IconBase, __assign$2({
      attr: __assign$2({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function(conf) {
    var attr = props.attr, size = props.size, title = props.title, svgProps = __rest$2(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className)
      className = conf.className;
    if (props.className)
      className = (className ? className + " " : "") + props.className;
    return React__default$1.createElement("svg", __assign$2({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className,
      style: __assign$2(__assign$2({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && React__default$1.createElement("title", null, title), props.children);
  };
  return IconContext !== void 0 ? React__default$1.createElement(IconContext.Consumer, null, function(conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
function AiOutlineMinus(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 1024 1024" }, "child": [{ "tag": "path", "attr": { "d": "M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] })(props);
}
function AiOutlinePlus(props) {
  return GenIcon({ "tag": "svg", "attr": { "t": "1551322312294", "style": "", "viewBox": "0 0 1024 1024", "version": "1.1" }, "child": [{ "tag": "defs", "attr": {}, "child": [] }, { "tag": "path", "attr": { "d": "M474 152m8 0l60 0q8 0 8 8l0 704q0 8-8 8l-60 0q-8 0-8-8l0-704q0-8 8-8Z" } }, { "tag": "path", "attr": { "d": "M168 474m8 0l672 0q8 0 8 8l0 60q0 8-8 8l-672 0q-8 0-8-8l0-60q0-8 8-8Z" } }] })(props);
}
function ListingTextDescription({ children }) {
  const { t: t2 } = useTranslation();
  const [expanded, setExpanded] = useState$1((children == null ? void 0 : children.length) <= 1e3);
  return /* @__PURE__ */ jsxs("div", { className: "mb-4 lg:mb-10", children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: cx(
          "relative md:pb-0",
          expanded ? "h-auto pb-10" : "h-64 overflow-hidden"
        ),
        children: [
          /* @__PURE__ */ jsx("div", { className: "prose", children: /* @__PURE__ */ jsx("p", { className: "whitespace-pre-wrap", children }) }),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: cx(
                expanded ? "hidden" : "absolute inset-x-0 bottom-0 h-20 bg-gradient-to-b from-transparent to-white"
              )
            }
          )
        ]
      }
    ),
    !expanded && /* @__PURE__ */ jsxs(
      "button",
      {
        className: "flex items-center w-full py-2 my-4",
        onClick: () => setExpanded(true),
        children: [
          /* @__PURE__ */ jsx(AiOutlinePlus, { className: "w-5 h-5 text-blue-500 fill-current" }),
          /* @__PURE__ */ jsx("span", { className: "ml-4 -mb-1 text-sm font-semibold tracking-widest text-blue-500 uppercase", children: t2("read_description") })
        ]
      }
    )
  ] });
}
const SvgMapMarker = (props) => /* @__PURE__ */ React$3.createElement("svg", { height: 41, width: 27, viewBox: "0 0 27 41", style: {
  transform: "translate(-18.6px,-37px)"
}, ...props }, /* @__PURE__ */ React$3.createElement("path", { d: "M27 13.5c0 5.575-6.75 13.5-12.25 21-.733 1-1.767 1-2.5 0C6.75 27 0 19.223 0 13.5 0 6.044 6.044 0 13.5 0S27 6.044 27 13.5Z", fill: "#F27E7D" }), /* @__PURE__ */ React$3.createElement("path", { d: "M13.5 0C6.044 0 0 6.044 0 13.5c0 5.723 6.75 13.5 12.25 21 .75 1.023 1.767 1 2.5 0C20.25 27 27 19.075 27 13.5 27 6.044 20.956 0 13.5 0Zm0 1C20.415 1 26 6.585 26 13.5c0 2.399-1.504 5.681-3.78 9.238-2.274 3.557-5.515 7.404-8.277 11.17-.2.273-.33.415-.443.533a4.934 4.934 0 0 1-.443-.533c-2.773-3.78-5.642-7.594-8.041-11.135C2.616 19.233 1 15.953 1 13.5 1 6.585 6.585 1 13.5 1Z", opacity: 0.25 }), /* @__PURE__ */ React$3.createElement("g", { transform: "translate(8 8)" }, /* @__PURE__ */ React$3.createElement("circle", { opacity: 0.25, cx: 5.5, cy: 5.5, r: 5.5 }), /* @__PURE__ */ React$3.createElement("circle", { fill: "#FFF", cx: 5.5, cy: 5.5, r: 5.5 })));
const mapboxGl = "";
const TOKEN = "pk.eyJ1IjoiYmxva2hxIiwiYSI6ImNqdjNsbno2MzF1ZTY0ZW80Z2RrZWNmZjAifQ.ighyZRkOm7SHxaLzm-gGoA";
const navStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  padding: "10px"
};
function ListingMap({
  latitude,
  longitude,
  width = "100%",
  height = "100%",
  fixed = false,
  satellite = false
}) {
  const [viewport, setViewport] = useState$1({
    zoom: 12,
    bearing: 0,
    pitch: 0,
    latitude,
    longitude
  });
  if (!latitude || !longitude)
    return null;
  const mapStyle = satellite ? "mapbox://styles/blokhq/ckx4pacdl6bt015nsqtodoebn" : "mapbox://styles/blokhq/cjvf4exno1hx91fp8p5kx4ll2";
  if (fixed) {
    return /* @__PURE__ */ jsx(
      "a",
      {
        className: "absolute z-0 w-full h-full",
        target: "_blank",
        rel: "noopener noreferrer",
        href: `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`,
        children: /* @__PURE__ */ jsx(
          StaticMap,
          {
            ...viewport,
            width,
            height,
            mapStyle,
            mapboxApiAccessToken: TOKEN,
            children: /* @__PURE__ */ jsx(Marker, { latitude, longitude, children: /* @__PURE__ */ jsx(SvgMapMarker, {}) })
          }
        )
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    ReactMapGL,
    {
      ...viewport,
      scrollZoom: true,
      touchZoom: true,
      width,
      height,
      mapStyle,
      mapboxApiAccessToken: TOKEN,
      onViewportChange: (viewport2) => setViewport(viewport2),
      children: [
        /* @__PURE__ */ jsx(Marker, { latitude, longitude, children: /* @__PURE__ */ jsx(SvgMapMarker, {}) }),
        /* @__PURE__ */ jsx("div", { className: "nav", style: navStyle, children: /* @__PURE__ */ jsx(
          NavigationControl,
          {
            onViewportChange: (viewport2) => setViewport(viewport2)
          }
        ) })
      ]
    }
  );
}
function isObject$a(obj) {
  return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function extend$2(target = {}, src = {}) {
  Object.keys(src).forEach((key) => {
    if (typeof target[key] === "undefined")
      target[key] = src[key];
    else if (isObject$a(src[key]) && isObject$a(target[key]) && Object.keys(src[key]).length > 0) {
      extend$2(target[key], src[key]);
    }
  });
}
const ssrDocument = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function getDocument() {
  const doc = typeof document !== "undefined" ? document : {};
  extend$2(doc, ssrDocument);
  return doc;
}
const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function CustomEvent() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(callback) {
    if (typeof setTimeout === "undefined") {
      callback();
      return null;
    }
    return setTimeout(callback, 0);
  },
  cancelAnimationFrame(id) {
    if (typeof setTimeout === "undefined") {
      return;
    }
    clearTimeout(id);
  }
};
function getWindow() {
  const win = typeof window !== "undefined" ? window : {};
  extend$2(win, ssrWindow);
  return win;
}
function deleteProps(obj) {
  const object = obj;
  Object.keys(object).forEach((key) => {
    try {
      object[key] = null;
    } catch (e2) {
    }
    try {
      delete object[key];
    } catch (e2) {
    }
  });
}
function nextTick(callback, delay = 0) {
  return setTimeout(callback, delay);
}
function now$4() {
  return Date.now();
}
function getComputedStyle$1(el) {
  const window2 = getWindow();
  let style;
  if (window2.getComputedStyle) {
    style = window2.getComputedStyle(el, null);
  }
  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }
  if (!style) {
    style = el.style;
  }
  return style;
}
function getTranslate(el, axis = "x") {
  const window2 = getWindow();
  let matrix;
  let curTransform;
  let transformMatrix;
  const curStyle = getComputedStyle$1(el);
  if (window2.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;
    if (curTransform.split(",").length > 6) {
      curTransform = curTransform.split(", ").map((a2) => a2.replace(",", ".")).join(", ");
    }
    transformMatrix = new window2.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
    matrix = transformMatrix.toString().split(",");
  }
  if (axis === "x") {
    if (window2.WebKitCSSMatrix)
      curTransform = transformMatrix.m41;
    else if (matrix.length === 16)
      curTransform = parseFloat(matrix[12]);
    else
      curTransform = parseFloat(matrix[4]);
  }
  if (axis === "y") {
    if (window2.WebKitCSSMatrix)
      curTransform = transformMatrix.m42;
    else if (matrix.length === 16)
      curTransform = parseFloat(matrix[13]);
    else
      curTransform = parseFloat(matrix[5]);
  }
  return curTransform || 0;
}
function isObject$9(o3) {
  return typeof o3 === "object" && o3 !== null && o3.constructor && Object.prototype.toString.call(o3).slice(8, -1) === "Object";
}
function isNode(node) {
  if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") {
    return node instanceof HTMLElement;
  }
  return node && (node.nodeType === 1 || node.nodeType === 11);
}
function extend$1(...args) {
  const to = Object(args[0]);
  const noExtend = ["__proto__", "constructor", "prototype"];
  for (let i2 = 1; i2 < args.length; i2 += 1) {
    const nextSource = args[i2];
    if (nextSource !== void 0 && nextSource !== null && !isNode(nextSource)) {
      const keysArray = Object.keys(Object(nextSource)).filter((key) => noExtend.indexOf(key) < 0);
      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        const nextKey = keysArray[nextIndex];
        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
        if (desc !== void 0 && desc.enumerable) {
          if (isObject$9(to[nextKey]) && isObject$9(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject$9(to[nextKey]) && isObject$9(nextSource[nextKey])) {
            to[nextKey] = {};
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }
  return to;
}
function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}
function animateCSSModeScroll({
  swiper,
  targetPosition,
  side
}) {
  const window2 = getWindow();
  const startPosition = -swiper.translate;
  let startTime = null;
  let time;
  const duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = "none";
  window2.cancelAnimationFrame(swiper.cssModeFrameID);
  const dir = targetPosition > startPosition ? "next" : "prev";
  const isOutOfBound = (current, target) => {
    return dir === "next" && current >= target || dir === "prev" && current <= target;
  };
  const animate = () => {
    time = new Date().getTime();
    if (startTime === null) {
      startTime = time;
    }
    const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }
    swiper.wrapperEl.scrollTo({
      [side]: currentPosition
    });
    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = "hidden";
      swiper.wrapperEl.style.scrollSnapType = "";
      setTimeout(() => {
        swiper.wrapperEl.style.overflow = "";
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
      });
      window2.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }
    swiper.cssModeFrameID = window2.requestAnimationFrame(animate);
  };
  animate();
}
function elementChildren(element, selector = "") {
  return [...element.children].filter((el) => el.matches(selector));
}
function createElement(tag2, classes2 = []) {
  const el = document.createElement(tag2);
  el.classList.add(...Array.isArray(classes2) ? classes2 : [classes2]);
  return el;
}
function elementOffset(el) {
  const window2 = getWindow();
  const document2 = getDocument();
  const box = el.getBoundingClientRect();
  const body = document2.body;
  const clientTop = el.clientTop || body.clientTop || 0;
  const clientLeft = el.clientLeft || body.clientLeft || 0;
  const scrollTop = el === window2 ? window2.scrollY : el.scrollTop;
  const scrollLeft = el === window2 ? window2.scrollX : el.scrollLeft;
  return {
    top: box.top + scrollTop - clientTop,
    left: box.left + scrollLeft - clientLeft
  };
}
function elementPrevAll(el, selector) {
  const prevEls = [];
  while (el.previousElementSibling) {
    const prev = el.previousElementSibling;
    if (selector) {
      if (prev.matches(selector))
        prevEls.push(prev);
    } else
      prevEls.push(prev);
    el = prev;
  }
  return prevEls;
}
function elementNextAll(el, selector) {
  const nextEls = [];
  while (el.nextElementSibling) {
    const next = el.nextElementSibling;
    if (selector) {
      if (next.matches(selector))
        nextEls.push(next);
    } else
      nextEls.push(next);
    el = next;
  }
  return nextEls;
}
function elementStyle(el, prop) {
  const window2 = getWindow();
  return window2.getComputedStyle(el, null).getPropertyValue(prop);
}
function elementIndex(el) {
  let child = el;
  let i2;
  if (child) {
    i2 = 0;
    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1)
        i2 += 1;
    }
    return i2;
  }
  return void 0;
}
function elementParents(el, selector) {
  const parents = [];
  let parent = el.parentElement;
  while (parent) {
    if (selector) {
      if (parent.matches(selector))
        parents.push(parent);
    } else {
      parents.push(parent);
    }
    parent = parent.parentElement;
  }
  return parents;
}
function elementOuterSize(el, size, includeMargins) {
  const window2 = getWindow();
  if (includeMargins) {
    return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window2.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window2.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
  }
  return el.offsetWidth;
}
let support;
function calcSupport() {
  const window2 = getWindow();
  const document2 = getDocument();
  return {
    smoothScroll: document2.documentElement && "scrollBehavior" in document2.documentElement.style,
    touch: !!("ontouchstart" in window2 || window2.DocumentTouch && document2 instanceof window2.DocumentTouch)
  };
}
function getSupport() {
  if (!support) {
    support = calcSupport();
  }
  return support;
}
let deviceCached;
function calcDevice({
  userAgent
} = {}) {
  const support2 = getSupport();
  const window2 = getWindow();
  const platform = window2.navigator.platform;
  const ua = userAgent || window2.navigator.userAgent;
  const device = {
    ios: false,
    android: false
  };
  const screenWidth = window2.screen.width;
  const screenHeight = window2.screen.height;
  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  const windows = platform === "Win32";
  let macos = platform === "MacIntel";
  const iPadScreens = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  if (!ipad && macos && support2.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad)
      ipad = [0, 1, "13_0_0"];
    macos = false;
  }
  if (android && !windows) {
    device.os = "android";
    device.android = true;
  }
  if (ipad || iphone || ipod) {
    device.os = "ios";
    device.ios = true;
  }
  return device;
}
function getDevice(overrides = {}) {
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }
  return deviceCached;
}
let browser;
function calcBrowser() {
  const window2 = getWindow();
  let needPerspectiveFix = false;
  function isSafari() {
    const ua = window2.navigator.userAgent.toLowerCase();
    return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
  }
  if (isSafari()) {
    const ua = String(window2.navigator.userAgent);
    if (ua.includes("Version/")) {
      const [major, minor] = ua.split("Version/")[1].split(" ")[0].split(".").map((num) => Number(num));
      needPerspectiveFix = major < 16 || major === 16 && minor < 2;
    }
  }
  return {
    isSafari: needPerspectiveFix || isSafari(),
    needPerspectiveFix,
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window2.navigator.userAgent)
  };
}
function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }
  return browser;
}
function Resize({
  swiper,
  on,
  emit
}) {
  const window2 = getWindow();
  let observer = null;
  let animationFrame = null;
  const resizeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized)
      return;
    emit("beforeResize");
    emit("resize");
  };
  const createObserver = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized)
      return;
    observer = new ResizeObserver((entries) => {
      animationFrame = window2.requestAnimationFrame(() => {
        const {
          width,
          height
        } = swiper;
        let newWidth = width;
        let newHeight = height;
        entries.forEach(({
          contentBoxSize,
          contentRect,
          target
        }) => {
          if (target && target !== swiper.el)
            return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });
        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };
  const removeObserver = () => {
    if (animationFrame) {
      window2.cancelAnimationFrame(animationFrame);
    }
    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };
  const orientationChangeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized)
      return;
    emit("orientationchange");
  };
  on("init", () => {
    if (swiper.params.resizeObserver && typeof window2.ResizeObserver !== "undefined") {
      createObserver();
      return;
    }
    window2.addEventListener("resize", resizeHandler);
    window2.addEventListener("orientationchange", orientationChangeHandler);
  });
  on("destroy", () => {
    removeObserver();
    window2.removeEventListener("resize", resizeHandler);
    window2.removeEventListener("orientationchange", orientationChangeHandler);
  });
}
function Observer({
  swiper,
  extendParams,
  on,
  emit
}) {
  const observers = [];
  const window2 = getWindow();
  const attach = (target, options = {}) => {
    const ObserverFunc = window2.MutationObserver || window2.WebkitMutationObserver;
    const observer = new ObserverFunc((mutations) => {
      if (mutations.length === 1) {
        emit("observerUpdate", mutations[0]);
        return;
      }
      const observerUpdate = function observerUpdate2() {
        emit("observerUpdate", mutations[0]);
      };
      if (window2.requestAnimationFrame) {
        window2.requestAnimationFrame(observerUpdate);
      } else {
        window2.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === "undefined" ? true : options.attributes,
      childList: typeof options.childList === "undefined" ? true : options.childList,
      characterData: typeof options.characterData === "undefined" ? true : options.characterData
    });
    observers.push(observer);
  };
  const init2 = () => {
    if (!swiper.params.observer)
      return;
    if (swiper.params.observeParents) {
      const containerParents = elementParents(swiper.el);
      for (let i2 = 0; i2 < containerParents.length; i2 += 1) {
        attach(containerParents[i2]);
      }
    }
    attach(swiper.el, {
      childList: swiper.params.observeSlideChildren
    });
    attach(swiper.wrapperEl, {
      attributes: false
    });
  };
  const destroy = () => {
    observers.forEach((observer) => {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };
  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on("init", init2);
  on("destroy", destroy);
}
const eventsEmitter = {
  on(events2, handler, priority) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed)
      return self2;
    if (typeof handler !== "function")
      return self2;
    const method = priority ? "unshift" : "push";
    events2.split(" ").forEach((event) => {
      if (!self2.eventsListeners[event])
        self2.eventsListeners[event] = [];
      self2.eventsListeners[event][method](handler);
    });
    return self2;
  },
  once(events2, handler, priority) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed)
      return self2;
    if (typeof handler !== "function")
      return self2;
    function onceHandler(...args) {
      self2.off(events2, onceHandler);
      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }
      handler.apply(self2, args);
    }
    onceHandler.__emitterProxy = handler;
    return self2.on(events2, onceHandler, priority);
  },
  onAny(handler, priority) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed)
      return self2;
    if (typeof handler !== "function")
      return self2;
    const method = priority ? "unshift" : "push";
    if (self2.eventsAnyListeners.indexOf(handler) < 0) {
      self2.eventsAnyListeners[method](handler);
    }
    return self2;
  },
  offAny(handler) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed)
      return self2;
    if (!self2.eventsAnyListeners)
      return self2;
    const index = self2.eventsAnyListeners.indexOf(handler);
    if (index >= 0) {
      self2.eventsAnyListeners.splice(index, 1);
    }
    return self2;
  },
  off(events2, handler) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed)
      return self2;
    if (!self2.eventsListeners)
      return self2;
    events2.split(" ").forEach((event) => {
      if (typeof handler === "undefined") {
        self2.eventsListeners[event] = [];
      } else if (self2.eventsListeners[event]) {
        self2.eventsListeners[event].forEach((eventHandler, index) => {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self2.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self2;
  },
  emit(...args) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed)
      return self2;
    if (!self2.eventsListeners)
      return self2;
    let events2;
    let data;
    let context;
    if (typeof args[0] === "string" || Array.isArray(args[0])) {
      events2 = args[0];
      data = args.slice(1, args.length);
      context = self2;
    } else {
      events2 = args[0].events;
      data = args[0].data;
      context = args[0].context || self2;
    }
    data.unshift(context);
    const eventsArray = Array.isArray(events2) ? events2 : events2.split(" ");
    eventsArray.forEach((event) => {
      if (self2.eventsAnyListeners && self2.eventsAnyListeners.length) {
        self2.eventsAnyListeners.forEach((eventHandler) => {
          eventHandler.apply(context, [event, ...data]);
        });
      }
      if (self2.eventsListeners && self2.eventsListeners[event]) {
        self2.eventsListeners[event].forEach((eventHandler) => {
          eventHandler.apply(context, data);
        });
      }
    });
    return self2;
  }
};
function updateSize() {
  const swiper = this;
  let width;
  let height;
  const el = swiper.el;
  if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = el.clientWidth;
  }
  if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = el.clientHeight;
  }
  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  }
  width = width - parseInt(elementStyle(el, "padding-left") || 0, 10) - parseInt(elementStyle(el, "padding-right") || 0, 10);
  height = height - parseInt(elementStyle(el, "padding-top") || 0, 10) - parseInt(elementStyle(el, "padding-bottom") || 0, 10);
  if (Number.isNaN(width))
    width = 0;
  if (Number.isNaN(height))
    height = 0;
  Object.assign(swiper, {
    width,
    height,
    size: swiper.isHorizontal() ? width : height
  });
}
function updateSlides() {
  const swiper = this;
  function getDirectionLabel(property2) {
    if (swiper.isHorizontal()) {
      return property2;
    }
    return {
      "width": "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      "marginRight": "marginBottom"
    }[property2];
  }
  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }
  const params = swiper.params;
  const {
    wrapperEl,
    slidesEl,
    size: swiperSize,
    rtlTranslate: rtl,
    wrongRTL
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  const slides = elementChildren(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  let snapGrid = [];
  const slidesGrid = [];
  const slidesSizesGrid = [];
  let offsetBefore = params.slidesOffsetBefore;
  if (typeof offsetBefore === "function") {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }
  let offsetAfter = params.slidesOffsetAfter;
  if (typeof offsetAfter === "function") {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }
  const previousSnapGridLength = swiper.snapGrid.length;
  const previousSlidesGridLength = swiper.slidesGrid.length;
  let spaceBetween = params.spaceBetween;
  let slidePosition = -offsetBefore;
  let prevSlideSize = 0;
  let index = 0;
  if (typeof swiperSize === "undefined") {
    return;
  }
  if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
  }
  swiper.virtualSize = -spaceBetween;
  slides.forEach((slideEl) => {
    if (rtl) {
      slideEl.style.marginLeft = "";
    } else {
      slideEl.style.marginRight = "";
    }
    slideEl.style.marginBottom = "";
    slideEl.style.marginTop = "";
  });
  if (params.centeredSlides && params.cssMode) {
    setCSSProperty(wrapperEl, "--swiper-centered-offset-before", "");
    setCSSProperty(wrapperEl, "--swiper-centered-offset-after", "");
  }
  const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
  if (gridEnabled) {
    swiper.grid.initSlides(slidesLength);
  }
  let slideSize;
  const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key) => {
    return typeof params.breakpoints[key].slidesPerView !== "undefined";
  }).length > 0;
  for (let i2 = 0; i2 < slidesLength; i2 += 1) {
    slideSize = 0;
    let slide2;
    if (slides[i2])
      slide2 = slides[i2];
    if (gridEnabled) {
      swiper.grid.updateSlide(i2, slide2, slidesLength, getDirectionLabel);
    }
    if (slides[i2] && elementStyle(slide2, "display") === "none")
      continue;
    if (params.slidesPerView === "auto") {
      if (shouldResetSlideSize) {
        slides[i2].style[getDirectionLabel("width")] = ``;
      }
      const slideStyles = getComputedStyle(slide2);
      const currentTransform = slide2.style.transform;
      const currentWebKitTransform = slide2.style.webkitTransform;
      if (currentTransform) {
        slide2.style.transform = "none";
      }
      if (currentWebKitTransform) {
        slide2.style.webkitTransform = "none";
      }
      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? elementOuterSize(slide2, "width", true) : elementOuterSize(slide2, "height", true);
      } else {
        const width = getDirectionPropertyValue(slideStyles, "width");
        const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
        const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
        const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
        const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
        const boxSizing = slideStyles.getPropertyValue("box-sizing");
        if (boxSizing && boxSizing === "border-box") {
          slideSize = width + marginLeft + marginRight;
        } else {
          const {
            clientWidth,
            offsetWidth
          } = slide2;
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }
      if (currentTransform) {
        slide2.style.transform = currentTransform;
      }
      if (currentWebKitTransform) {
        slide2.style.webkitTransform = currentWebKitTransform;
      }
      if (params.roundLengths)
        slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths)
        slideSize = Math.floor(slideSize);
      if (slides[i2]) {
        slides[i2].style[getDirectionLabel("width")] = `${slideSize}px`;
      }
    }
    if (slides[i2]) {
      slides[i2].swiperSlideSize = slideSize;
    }
    slidesSizesGrid.push(slideSize);
    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i2 !== 0)
        slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i2 === 0)
        slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1e3)
        slidePosition = 0;
      if (params.roundLengths)
        slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0)
        snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths)
        slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0)
        snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }
    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }
  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) {
    wrapperEl.style.width = `${swiper.virtualSize + params.spaceBetween}px`;
  }
  if (params.setWrapperSize) {
    wrapperEl.style[getDirectionLabel("width")] = `${swiper.virtualSize + params.spaceBetween}px`;
  }
  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
  }
  if (!params.centeredSlides) {
    const newSlidesGrid = [];
    for (let i2 = 0; i2 < snapGrid.length; i2 += 1) {
      let slidesGridItem = snapGrid[i2];
      if (params.roundLengths)
        slidesGridItem = Math.floor(slidesGridItem);
      if (snapGrid[i2] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }
    snapGrid = newSlidesGrid;
    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }
  if (isVirtual && params.loop) {
    const size = slidesSizesGrid[0] + spaceBetween;
    if (params.slidesPerGroup > 1) {
      const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
      const groupSize = size * params.slidesPerGroup;
      for (let i2 = 0; i2 < groups; i2 += 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
      }
    }
    for (let i2 = 0; i2 < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i2 += 1) {
      if (params.slidesPerGroup === 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + size);
      }
      slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
      swiper.virtualSize += size;
    }
  }
  if (snapGrid.length === 0)
    snapGrid = [0];
  if (params.spaceBetween !== 0) {
    const key = swiper.isHorizontal() && rtl ? "marginLeft" : getDirectionLabel("marginRight");
    slides.filter((_24, slideIndex) => {
      if (!params.cssMode || params.loop)
        return true;
      if (slideIndex === slides.length - 1) {
        return false;
      }
      return true;
    }).forEach((slideEl) => {
      slideEl.style[key] = `${spaceBetween}px`;
    });
  }
  if (params.centeredSlides && params.centeredSlidesBounds) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach((slideSizeValue) => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    const maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map((snap) => {
      if (snap < 0)
        return -offsetBefore;
      if (snap > maxSnap)
        return maxSnap + offsetAfter;
      return snap;
    });
  }
  if (params.centerInsufficientSlides) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach((slideSizeValue) => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    if (allSlidesSize < swiperSize) {
      const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }
  Object.assign(swiper, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid
  });
  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    setCSSProperty(wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
    setCSSProperty(wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
    const addToSnapGrid = -swiper.snapGrid[0];
    const addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map((v2) => v2 + addToSnapGrid);
    swiper.slidesGrid = swiper.slidesGrid.map((v2) => v2 + addToSlidesGrid);
  }
  if (slidesLength !== previousSlidesLength) {
    swiper.emit("slidesLengthChange");
  }
  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow)
      swiper.checkOverflow();
    swiper.emit("snapGridLengthChange");
  }
  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit("slidesGridLengthChange");
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
    const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded)
        swiper.el.classList.add(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.el.classList.remove(backFaceHiddenClass);
    }
  }
}
function updateAutoHeight(speed) {
  const swiper = this;
  const activeSlides = [];
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  let newHeight = 0;
  let i2;
  if (typeof speed === "number") {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }
  const getSlideByIndex = (index) => {
    if (isVirtual) {
      return swiper.slides.filter((el) => parseInt(el.getAttribute("data-swiper-slide-index"), 10) === index)[0];
    }
    return swiper.slides[index];
  };
  if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      (swiper.visibleSlides || []).forEach((slide2) => {
        activeSlides.push(slide2);
      });
    } else {
      for (i2 = 0; i2 < Math.ceil(swiper.params.slidesPerView); i2 += 1) {
        const index = swiper.activeIndex + i2;
        if (index > swiper.slides.length && !isVirtual)
          break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  }
  for (i2 = 0; i2 < activeSlides.length; i2 += 1) {
    if (typeof activeSlides[i2] !== "undefined") {
      const height = activeSlides[i2].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  }
  if (newHeight || newHeight === 0)
    swiper.wrapperEl.style.height = `${newHeight}px`;
}
function updateSlidesOffset() {
  const swiper = this;
  const slides = swiper.slides;
  const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
  for (let i2 = 0; i2 < slides.length; i2 += 1) {
    slides[i2].swiperSlideOffset = (swiper.isHorizontal() ? slides[i2].offsetLeft : slides[i2].offsetTop) - minusOffset;
  }
}
function updateSlidesProgress(translate2 = this && this.translate || 0) {
  const swiper = this;
  const params = swiper.params;
  const {
    slides,
    rtlTranslate: rtl,
    snapGrid
  } = swiper;
  if (slides.length === 0)
    return;
  if (typeof slides[0].swiperSlideOffset === "undefined")
    swiper.updateSlidesOffset();
  let offsetCenter = -translate2;
  if (rtl)
    offsetCenter = translate2;
  slides.forEach((slideEl) => {
    slideEl.classList.remove(params.slideVisibleClass);
  });
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];
  for (let i2 = 0; i2 < slides.length; i2 += 1) {
    const slide2 = slides[i2];
    let slideOffset = slide2.swiperSlideOffset;
    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }
    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + params.spaceBetween);
    const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + params.spaceBetween);
    const slideBefore = -(offsetCenter - slideOffset);
    const slideAfter = slideBefore + swiper.slidesSizesGrid[i2];
    const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
    if (isVisible) {
      swiper.visibleSlides.push(slide2);
      swiper.visibleSlidesIndexes.push(i2);
      slides[i2].classList.add(params.slideVisibleClass);
    }
    slide2.progress = rtl ? -slideProgress : slideProgress;
    slide2.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }
}
function updateProgress(translate2) {
  const swiper = this;
  if (typeof translate2 === "undefined") {
    const multiplier = swiper.rtlTranslate ? -1 : 1;
    translate2 = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }
  const params = swiper.params;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  let {
    progress,
    isBeginning,
    isEnd,
    progressLoop
  } = swiper;
  const wasBeginning = isBeginning;
  const wasEnd = isEnd;
  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate2 - swiper.minTranslate()) / translatesDiff;
    const isBeginningRounded = Math.abs(translate2 - swiper.minTranslate()) < 1;
    const isEndRounded = Math.abs(translate2 - swiper.maxTranslate()) < 1;
    isBeginning = isBeginningRounded || progress <= 0;
    isEnd = isEndRounded || progress >= 1;
    if (isBeginningRounded)
      progress = 0;
    if (isEndRounded)
      progress = 1;
  }
  if (params.loop) {
    const firstSlideIndex = elementIndex(swiper.slides.filter((el) => el.getAttribute("data-swiper-slide-index") === "0")[0]);
    const lastSlideIndex = elementIndex(swiper.slides.filter((el) => el.getAttribute("data-swiper-slide-index") * 1 === swiper.slides.length - 1)[0]);
    const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
    const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
    const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
    const translateAbs = Math.abs(translate2);
    if (translateAbs >= firstSlideTranslate) {
      progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
    } else {
      progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
    }
    if (progressLoop > 1)
      progressLoop -= 1;
  }
  Object.assign(swiper, {
    progress,
    progressLoop,
    isBeginning,
    isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight)
    swiper.updateSlidesProgress(translate2);
  if (isBeginning && !wasBeginning) {
    swiper.emit("reachBeginning toEdge");
  }
  if (isEnd && !wasEnd) {
    swiper.emit("reachEnd toEdge");
  }
  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit("fromEdge");
  }
  swiper.emit("progress", progress);
}
function updateSlidesClasses() {
  const swiper = this;
  const {
    slides,
    params,
    slidesEl,
    activeIndex
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const getFilteredSlide = (selector) => {
    return elementChildren(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
  };
  slides.forEach((slideEl) => {
    slideEl.classList.remove(params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
  });
  let activeSlide;
  if (isVirtual) {
    if (params.loop) {
      let slideIndex = activeIndex - swiper.virtual.slidesBefore;
      if (slideIndex < 0)
        slideIndex = swiper.virtual.slides.length + slideIndex;
      if (slideIndex >= swiper.virtual.slides.length)
        slideIndex -= swiper.virtual.slides.length;
      activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
    } else {
      activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    }
  } else {
    activeSlide = slides[activeIndex];
  }
  if (activeSlide) {
    activeSlide.classList.add(params.slideActiveClass);
    let nextSlide = elementNextAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
    if (params.loop && !nextSlide) {
      nextSlide = slides[0];
    }
    if (nextSlide) {
      nextSlide.classList.add(params.slideNextClass);
    }
    let prevSlide = elementPrevAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
    if (params.loop && !prevSlide === 0) {
      prevSlide = slides[slides.length - 1];
    }
    if (prevSlide) {
      prevSlide.classList.add(params.slidePrevClass);
    }
  }
  swiper.emitSlidesClasses();
}
function getActiveIndexByTranslate(swiper) {
  const {
    slidesGrid,
    params
  } = swiper;
  const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  let activeIndex;
  for (let i2 = 0; i2 < slidesGrid.length; i2 += 1) {
    if (typeof slidesGrid[i2 + 1] !== "undefined") {
      if (translate2 >= slidesGrid[i2] && translate2 < slidesGrid[i2 + 1] - (slidesGrid[i2 + 1] - slidesGrid[i2]) / 2) {
        activeIndex = i2;
      } else if (translate2 >= slidesGrid[i2] && translate2 < slidesGrid[i2 + 1]) {
        activeIndex = i2 + 1;
      }
    } else if (translate2 >= slidesGrid[i2]) {
      activeIndex = i2;
    }
  }
  if (params.normalizeSlideIndex) {
    if (activeIndex < 0 || typeof activeIndex === "undefined")
      activeIndex = 0;
  }
  return activeIndex;
}
function updateActiveIndex(newActiveIndex) {
  const swiper = this;
  const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  const {
    snapGrid,
    params,
    activeIndex: previousIndex,
    realIndex: previousRealIndex,
    snapIndex: previousSnapIndex
  } = swiper;
  let activeIndex = newActiveIndex;
  let snapIndex;
  const getVirtualRealIndex = (aIndex) => {
    let realIndex2 = aIndex - swiper.virtual.slidesBefore;
    if (realIndex2 < 0) {
      realIndex2 = swiper.virtual.slides.length + realIndex2;
    }
    if (realIndex2 >= swiper.virtual.slides.length) {
      realIndex2 -= swiper.virtual.slides.length;
    }
    return realIndex2;
  };
  if (typeof activeIndex === "undefined") {
    activeIndex = getActiveIndexByTranslate(swiper);
  }
  if (snapGrid.indexOf(translate2) >= 0) {
    snapIndex = snapGrid.indexOf(translate2);
  } else {
    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }
  if (snapIndex >= snapGrid.length)
    snapIndex = snapGrid.length - 1;
  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit("snapIndexChange");
    }
    if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
      swiper.realIndex = getVirtualRealIndex(activeIndex);
    }
    return;
  }
  let realIndex;
  if (swiper.virtual && params.virtual.enabled && params.loop) {
    realIndex = getVirtualRealIndex(activeIndex);
  } else if (swiper.slides[activeIndex]) {
    realIndex = parseInt(swiper.slides[activeIndex].getAttribute("data-swiper-slide-index") || activeIndex, 10);
  } else {
    realIndex = activeIndex;
  }
  Object.assign(swiper, {
    snapIndex,
    realIndex,
    previousIndex,
    activeIndex
  });
  swiper.emit("activeIndexChange");
  swiper.emit("snapIndexChange");
  if (previousRealIndex !== realIndex) {
    swiper.emit("realIndexChange");
  }
  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit("slideChange");
  }
}
function updateClickedSlide(e2) {
  const swiper = this;
  const params = swiper.params;
  const slide2 = e2.closest(`.${params.slideClass}, swiper-slide`);
  let slideFound = false;
  let slideIndex;
  if (slide2) {
    for (let i2 = 0; i2 < swiper.slides.length; i2 += 1) {
      if (swiper.slides[i2] === slide2) {
        slideFound = true;
        slideIndex = i2;
        break;
      }
    }
  }
  if (slide2 && slideFound) {
    swiper.clickedSlide = slide2;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt(slide2.getAttribute("data-swiper-slide-index"), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = void 0;
    swiper.clickedIndex = void 0;
    return;
  }
  if (params.slideToClickedSlide && swiper.clickedIndex !== void 0 && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}
const update = {
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  updateSlidesProgress,
  updateProgress,
  updateSlidesClasses,
  updateActiveIndex,
  updateClickedSlide
};
function getSwiperTranslate(axis = this.isHorizontal() ? "x" : "y") {
  const swiper = this;
  const {
    params,
    rtlTranslate: rtl,
    translate: translate2,
    wrapperEl
  } = swiper;
  if (params.virtualTranslate) {
    return rtl ? -translate2 : translate2;
  }
  if (params.cssMode) {
    return translate2;
  }
  let currentTranslate = getTranslate(wrapperEl, axis);
  if (rtl)
    currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}
function setTranslate(translate2, byController) {
  const swiper = this;
  const {
    rtlTranslate: rtl,
    params,
    wrapperEl,
    progress
  } = swiper;
  let x2 = 0;
  let y2 = 0;
  const z2 = 0;
  if (swiper.isHorizontal()) {
    x2 = rtl ? -translate2 : translate2;
  } else {
    y2 = translate2;
  }
  if (params.roundLengths) {
    x2 = Math.floor(x2);
    y2 = Math.floor(y2);
  }
  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x2 : -y2;
  } else if (!params.virtualTranslate) {
    wrapperEl.style.transform = `translate3d(${x2}px, ${y2}px, ${z2}px)`;
  }
  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x2 : y2;
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate2 - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== progress) {
    swiper.updateProgress(translate2);
  }
  swiper.emit("setTranslate", swiper.translate, byController);
}
function minTranslate() {
  return -this.snapGrid[0];
}
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function translateTo(translate2 = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
  const swiper = this;
  const {
    params,
    wrapperEl
  } = swiper;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }
  const minTranslate2 = swiper.minTranslate();
  const maxTranslate2 = swiper.maxTranslate();
  let newTranslate;
  if (translateBounds && translate2 > minTranslate2)
    newTranslate = minTranslate2;
  else if (translateBounds && translate2 < maxTranslate2)
    newTranslate = maxTranslate2;
  else
    newTranslate = translate2;
  swiper.updateProgress(newTranslate);
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    if (speed === 0) {
      wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: -newTranslate,
          side: isH ? "left" : "top"
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? "left" : "top"]: -newTranslate,
        behavior: "smooth"
      });
    }
    return true;
  }
  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit("beforeTransitionStart", speed, internal);
      swiper.emit("transitionEnd");
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit("beforeTransitionStart", speed, internal);
      swiper.emit("transitionStart");
    }
    if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd2(e2) {
          if (!swiper || swiper.destroyed)
            return;
          if (e2.target !== this)
            return;
          swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;
          if (runCallbacks) {
            swiper.emit("transitionEnd");
          }
        };
      }
      swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
    }
  }
  return true;
}
const translate = {
  getTranslate: getSwiperTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo
};
function setTransition(duration, byController) {
  const swiper = this;
  if (!swiper.params.cssMode) {
    swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
  }
  swiper.emit("setTransition", duration, byController);
}
function transitionEmit({
  swiper,
  runCallbacks,
  direction,
  step
}) {
  const {
    activeIndex,
    previousIndex
  } = swiper;
  let dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex)
      dir = "next";
    else if (activeIndex < previousIndex)
      dir = "prev";
    else
      dir = "reset";
  }
  swiper.emit(`transition${step}`);
  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === "reset") {
      swiper.emit(`slideResetTransition${step}`);
      return;
    }
    swiper.emit(`slideChangeTransition${step}`);
    if (dir === "next") {
      swiper.emit(`slideNextTransition${step}`);
    } else {
      swiper.emit(`slidePrevTransition${step}`);
    }
  }
}
function transitionStart(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  if (params.cssMode)
    return;
  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: "Start"
  });
}
function transitionEnd(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.animating = false;
  if (params.cssMode)
    return;
  swiper.setTransition(0);
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: "End"
  });
}
const transition = {
  setTransition,
  transitionStart,
  transitionEnd
};
function slideTo(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
  if (typeof index === "string") {
    index = parseInt(index, 10);
  }
  const swiper = this;
  let slideIndex = index;
  if (slideIndex < 0)
    slideIndex = 0;
  const {
    params,
    snapGrid,
    slidesGrid,
    previousIndex,
    activeIndex,
    rtlTranslate: rtl,
    wrapperEl,
    enabled
  } = swiper;
  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }
  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length)
    snapIndex = snapGrid.length - 1;
  const translate2 = -snapGrid[snapIndex];
  if (params.normalizeSlideIndex) {
    for (let i2 = 0; i2 < slidesGrid.length; i2 += 1) {
      const normalizedTranslate = -Math.floor(translate2 * 100);
      const normalizedGrid = Math.floor(slidesGrid[i2] * 100);
      const normalizedGridNext = Math.floor(slidesGrid[i2 + 1] * 100);
      if (typeof slidesGrid[i2 + 1] !== "undefined") {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i2;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i2 + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i2;
      }
    }
  }
  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate2 < swiper.translate && translate2 < swiper.minTranslate()) {
      return false;
    }
    if (!swiper.allowSlidePrev && translate2 > swiper.translate && translate2 > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) {
        return false;
      }
    }
  }
  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
    swiper.emit("beforeSlideChangeStart");
  }
  swiper.updateProgress(translate2);
  let direction;
  if (slideIndex > activeIndex)
    direction = "next";
  else if (slideIndex < activeIndex)
    direction = "prev";
  else
    direction = "reset";
  if (rtl && -translate2 === swiper.translate || !rtl && translate2 === swiper.translate) {
    swiper.updateActiveIndex(slideIndex);
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    swiper.updateSlidesClasses();
    if (params.effect !== "slide") {
      swiper.setTranslate(translate2);
    }
    if (direction !== "reset") {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }
    return false;
  }
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    const t2 = rtl ? translate2 : -translate2;
    if (speed === 0) {
      const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = "none";
        swiper._immediateVirtual = true;
      }
      if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
        swiper._cssModeVirtualInitialSet = true;
        requestAnimationFrame(() => {
          wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t2;
        });
      } else {
        wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t2;
      }
      if (isVirtual) {
        requestAnimationFrame(() => {
          swiper.wrapperEl.style.scrollSnapType = "";
          swiper._immediateVirtual = false;
        });
      }
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: t2,
          side: isH ? "left" : "top"
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? "left" : "top"]: t2,
        behavior: "smooth"
      });
    }
    return true;
  }
  swiper.setTransition(speed);
  swiper.setTranslate(translate2);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit("beforeTransitionStart", speed, internal);
  swiper.transitionStart(runCallbacks, direction);
  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;
    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd2(e2) {
        if (!swiper || swiper.destroyed)
          return;
        if (e2.target !== this)
          return;
        swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }
    swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
  }
  return true;
}
function slideToLoop(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
  if (typeof index === "string") {
    const indexAsNumber = parseInt(index, 10);
    index = indexAsNumber;
  }
  const swiper = this;
  let newIndex = index;
  if (swiper.params.loop) {
    if (swiper.virtual && swiper.params.virtual.enabled) {
      newIndex = newIndex + swiper.virtual.slidesBefore;
    } else {
      newIndex = elementIndex(swiper.slides.filter((slideEl) => slideEl.getAttribute("data-swiper-slide-index") * 1 === newIndex)[0]);
    }
  }
  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}
function slideNext(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    enabled,
    params,
    animating
  } = swiper;
  if (!enabled)
    return swiper;
  let perGroup = params.slidesPerGroup;
  if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
  }
  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding)
      return false;
    swiper.loopFix({
      direction: "next"
    });
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
  }
  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }
  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
function slidePrev(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    params,
    snapGrid,
    slidesGrid,
    rtlTranslate,
    enabled,
    animating
  } = swiper;
  if (!enabled)
    return swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding)
      return false;
    swiper.loopFix({
      direction: "prev"
    });
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
  }
  const translate2 = rtlTranslate ? swiper.translate : -swiper.translate;
  function normalize(val) {
    if (val < 0)
      return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }
  const normalizedTranslate = normalize(translate2);
  const normalizedSnapGrid = snapGrid.map((val) => normalize(val));
  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  if (typeof prevSnap === "undefined" && params.cssMode) {
    let prevSnapIndex;
    snapGrid.forEach((snap, snapIndex) => {
      if (normalizedTranslate >= snap) {
        prevSnapIndex = snapIndex;
      }
    });
    if (typeof prevSnapIndex !== "undefined") {
      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }
  let prevIndex = 0;
  if (typeof prevSnap !== "undefined") {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0)
      prevIndex = swiper.activeIndex - 1;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }
  if (params.rewind && swiper.isBeginning) {
    const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  }
  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
function slideReset(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
function slideToClosest(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
  const swiper = this;
  let index = swiper.activeIndex;
  const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  if (translate2 >= swiper.snapGrid[snapIndex]) {
    const currentSnap = swiper.snapGrid[snapIndex];
    const nextSnap = swiper.snapGrid[snapIndex + 1];
    if (translate2 - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    const prevSnap = swiper.snapGrid[snapIndex - 1];
    const currentSnap = swiper.snapGrid[snapIndex];
    if (translate2 - prevSnap <= (currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }
  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}
function slideToClickedSlide() {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  let slideToIndex = swiper.clickedIndex;
  let realIndex;
  const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
  if (params.loop) {
    if (swiper.animating)
      return;
    realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = elementIndex(elementChildren(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
        nextTick(() => {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = elementIndex(elementChildren(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
      nextTick(() => {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}
const slide = {
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide
};
function loopCreate(slideRealIndex) {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  if (!params.loop || swiper.virtual && swiper.params.virtual.enabled)
    return;
  const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
  slides.forEach((el, index) => {
    el.setAttribute("data-swiper-slide-index", index);
  });
  swiper.loopFix({
    slideRealIndex,
    direction: params.centeredSlides ? void 0 : "next"
  });
}
function loopFix({
  slideRealIndex,
  slideTo: slideTo2 = true,
  direction,
  setTranslate: setTranslate2,
  activeSlideIndex,
  byController
} = {}) {
  const swiper = this;
  if (!swiper.params.loop)
    return;
  swiper.emit("beforeLoopFix");
  const {
    slides,
    allowSlidePrev,
    allowSlideNext,
    slidesEl,
    params
  } = swiper;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  if (swiper.virtual && params.virtual.enabled) {
    if (slideTo2) {
      if (!params.centeredSlides && swiper.snapIndex === 0) {
        swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
      } else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) {
        swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
      } else if (swiper.snapIndex === swiper.snapGrid.length - 1) {
        swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit("loopFix");
    return;
  }
  const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10));
  let loopedSlides = params.loopedSlides || slidesPerView;
  if (loopedSlides % params.slidesPerGroup !== 0) {
    loopedSlides += params.slidesPerGroup - loopedSlides % params.slidesPerGroup;
  }
  swiper.loopedSlides = loopedSlides;
  const prependSlidesIndexes = [];
  const appendSlidesIndexes = [];
  let activeIndex = swiper.activeIndex;
  if (typeof activeSlideIndex === "undefined") {
    activeSlideIndex = elementIndex(swiper.slides.filter((el) => el.classList.contains("swiper-slide-active"))[0]);
  } else {
    activeIndex = activeSlideIndex;
  }
  const isNext = direction === "next" || !direction;
  const isPrev = direction === "prev" || !direction;
  let slidesPrepended = 0;
  let slidesAppended = 0;
  if (activeSlideIndex < loopedSlides) {
    slidesPrepended = loopedSlides - activeSlideIndex;
    for (let i2 = 0; i2 < loopedSlides - activeSlideIndex; i2 += 1) {
      const index = i2 - Math.floor(i2 / slides.length) * slides.length;
      prependSlidesIndexes.push(slides.length - index - 1);
    }
  } else if (activeSlideIndex > swiper.slides.length - loopedSlides * 2) {
    slidesAppended = activeSlideIndex - (swiper.slides.length - loopedSlides * 2);
    for (let i2 = 0; i2 < slidesAppended; i2 += 1) {
      const index = i2 - Math.floor(i2 / slides.length) * slides.length;
      appendSlidesIndexes.push(index);
    }
  }
  if (isPrev) {
    prependSlidesIndexes.forEach((index) => {
      slidesEl.prepend(swiper.slides[index]);
    });
  }
  if (isNext) {
    appendSlidesIndexes.forEach((index) => {
      slidesEl.append(swiper.slides[index]);
    });
  }
  swiper.recalcSlides();
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  if (slideTo2) {
    if (prependSlidesIndexes.length > 0 && isPrev) {
      if (typeof slideRealIndex === "undefined") {
        const currentSlideTranslate = swiper.slidesGrid[activeIndex];
        const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
        const diff2 = newSlideTranslate - currentSlideTranslate;
        swiper.slideTo(activeIndex + slidesPrepended, 0, false, true);
        if (setTranslate2) {
          swiper.touches[swiper.isHorizontal() ? "startX" : "startY"] += diff2;
        }
      } else {
        if (setTranslate2) {
          swiper.slideToLoop(slideRealIndex, 0, false, true);
        }
      }
    } else if (appendSlidesIndexes.length > 0 && isNext) {
      if (typeof slideRealIndex === "undefined") {
        const currentSlideTranslate = swiper.slidesGrid[activeIndex];
        const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
        const diff2 = newSlideTranslate - currentSlideTranslate;
        swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
        if (setTranslate2) {
          swiper.touches[swiper.isHorizontal() ? "startX" : "startY"] += diff2;
        }
      } else {
        swiper.slideToLoop(slideRealIndex, 0, false, true);
      }
    }
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.controller && swiper.controller.control && !byController) {
    const loopParams = {
      slideRealIndex,
      slideTo: false,
      direction,
      setTranslate: setTranslate2,
      activeSlideIndex,
      byController: true
    };
    if (Array.isArray(swiper.controller.control)) {
      swiper.controller.control.forEach((c2) => {
        if (c2.params.loop)
          c2.loopFix(loopParams);
      });
    } else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) {
      swiper.controller.control.loopFix(loopParams);
    }
  }
  swiper.emit("loopFix");
}
function loopDestroy() {
  const swiper = this;
  const {
    slides,
    params,
    slidesEl
  } = swiper;
  if (!params.loop || swiper.virtual && swiper.params.virtual.enabled)
    return;
  swiper.recalcSlides();
  const newSlidesOrder = [];
  slides.forEach((slideEl) => {
    const index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
    newSlidesOrder[index] = slideEl;
  });
  slides.forEach((slideEl) => {
    slideEl.removeAttribute("data-swiper-slide-index");
  });
  newSlidesOrder.forEach((slideEl) => {
    slidesEl.append(slideEl);
  });
  swiper.recalcSlides();
  swiper.slideTo(swiper.realIndex, 0);
}
const loop = {
  loopCreate,
  loopFix,
  loopDestroy
};
function setGrabCursor(moving) {
  const swiper = this;
  if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode)
    return;
  const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
  el.style.cursor = "move";
  el.style.cursor = moving ? "grabbing" : "grab";
}
function unsetGrabCursor() {
  const swiper = this;
  if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }
  swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
}
const grabCursor = {
  setGrabCursor,
  unsetGrabCursor
};
function closestElement(selector, base = this) {
  function __closestFrom(el) {
    if (!el || el === getDocument() || el === getWindow())
      return null;
    if (el.assignedSlot)
      el = el.assignedSlot;
    const found = el.closest(selector);
    if (!found && !el.getRootNode) {
      return null;
    }
    return found || __closestFrom(el.getRootNode().host);
  }
  return __closestFrom(base);
}
function onTouchStart(event) {
  const swiper = this;
  const document2 = getDocument();
  const window2 = getWindow();
  const data = swiper.touchEventsData;
  data.evCache.push(event);
  const {
    params,
    touches,
    enabled
  } = swiper;
  if (!enabled)
    return;
  if (!params.simulateTouch && event.pointerType === "mouse")
    return;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }
  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }
  let e2 = event;
  if (e2.originalEvent)
    e2 = e2.originalEvent;
  let targetEl = e2.target;
  if (params.touchEventsTarget === "wrapper") {
    if (!swiper.wrapperEl.contains(targetEl))
      return;
  }
  if ("which" in e2 && e2.which === 3)
    return;
  if ("button" in e2 && e2.button > 0)
    return;
  if (data.isTouched && data.isMoved)
    return;
  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
  const eventPath = event.composedPath ? event.composedPath() : event.path;
  if (swipingClassHasValue && e2.target && e2.target.shadowRoot && eventPath) {
    targetEl = eventPath[0];
  }
  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
  const isTargetShadow = !!(e2.target && e2.target.shadowRoot);
  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
    swiper.allowClick = true;
    return;
  }
  if (params.swipeHandler) {
    if (!targetEl.closest(params.swipeHandler))
      return;
  }
  touches.currentX = e2.pageX;
  touches.currentY = e2.pageY;
  const startX = touches.currentX;
  const startY = touches.currentY;
  const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window2.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === "prevent") {
      event.preventDefault();
    } else {
      return;
    }
  }
  Object.assign(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: void 0,
    startMoving: void 0
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = now$4();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = void 0;
  if (params.threshold > 0)
    data.allowThresholdMove = false;
  let preventDefault = true;
  if (targetEl.matches(data.focusableElements)) {
    preventDefault = false;
    if (targetEl.nodeName === "SELECT") {
      data.isTouched = false;
    }
  }
  if (document2.activeElement && document2.activeElement.matches(data.focusableElements) && document2.activeElement !== targetEl) {
    document2.activeElement.blur();
  }
  const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
  if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) {
    e2.preventDefault();
  }
  if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }
  swiper.emit("touchStart", e2);
}
function onTouchMove(event) {
  const document2 = getDocument();
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    enabled
  } = swiper;
  if (!enabled)
    return;
  if (!params.simulateTouch && event.pointerType === "mouse")
    return;
  let e2 = event;
  if (e2.originalEvent)
    e2 = e2.originalEvent;
  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit("touchMoveOpposite", e2);
    }
    return;
  }
  const pointerIndex = data.evCache.findIndex((cachedEv) => cachedEv.pointerId === e2.pointerId);
  if (pointerIndex >= 0)
    data.evCache[pointerIndex] = e2;
  const targetTouch = data.evCache.length > 1 ? data.evCache[0] : e2;
  const pageX = targetTouch.pageX;
  const pageY = targetTouch.pageY;
  if (e2.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }
  if (!swiper.allowTouchMove) {
    if (!e2.target.matches(data.focusableElements)) {
      swiper.allowClick = false;
    }
    if (data.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        prevX: swiper.touches.currentX,
        prevY: swiper.touches.currentY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = now$4();
    }
    return;
  }
  if (params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }
  if (document2.activeElement) {
    if (e2.target === document2.activeElement && e2.target.matches(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }
  if (data.allowTouchCallbacks) {
    swiper.emit("touchMove", e2);
  }
  if (e2.targetTouches && e2.targetTouches.length > 1)
    return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  const diffX = touches.currentX - touches.startX;
  const diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold)
    return;
  if (typeof data.isScrolling === "undefined") {
    let touchAngle;
    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }
  if (data.isScrolling) {
    swiper.emit("touchMoveOpposite", e2);
  }
  if (typeof data.startMoving === "undefined") {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }
  if (data.isScrolling || swiper.zoom && swiper.params.zoom && swiper.params.zoom.enabled && data.evCache.length > 1) {
    data.isTouched = false;
    return;
  }
  if (!data.startMoving) {
    return;
  }
  swiper.allowClick = false;
  if (!params.cssMode && e2.cancelable) {
    e2.preventDefault();
  }
  if (params.touchMoveStopPropagation && !params.nested) {
    e2.stopPropagation();
  }
  let diff2 = swiper.isHorizontal() ? diffX : diffY;
  let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
  if (params.oneWayMovement) {
    diff2 = Math.abs(diff2) * (rtl ? 1 : -1);
    touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
  }
  touches.diff = diff2;
  diff2 *= params.touchRatio;
  if (rtl) {
    diff2 = -diff2;
    touchesDiff = -touchesDiff;
  }
  const prevTouchesDirection = swiper.touchesDirection;
  swiper.swipeDirection = diff2 > 0 ? "prev" : "next";
  swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
  const isLoop = swiper.params.loop && !(swiper.virtual && swiper.params.virtual.enabled) && !params.cssMode;
  if (!data.isMoved) {
    if (isLoop) {
      swiper.loopFix({
        direction: swiper.swipeDirection
      });
    }
    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);
    if (swiper.animating) {
      const evt = new window.CustomEvent("transitionend", {
        bubbles: true,
        cancelable: true
      });
      swiper.wrapperEl.dispatchEvent(evt);
    }
    data.allowMomentumBounce = false;
    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }
    swiper.emit("sliderFirstMove", e2);
  }
  let loopFixed;
  if (data.isMoved && prevTouchesDirection !== swiper.touchesDirection && isLoop && Math.abs(diff2) >= 1) {
    swiper.loopFix({
      direction: swiper.swipeDirection,
      setTranslate: true
    });
    loopFixed = true;
  }
  swiper.emit("sliderMove", e2);
  data.isMoved = true;
  data.currentTranslate = diff2 + data.startTranslate;
  let disableParentSwiper = true;
  let resistanceRatio = params.resistanceRatio;
  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }
  if (diff2 > 0) {
    if (isLoop && !loopFixed && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.size / 2 : swiper.minTranslate())) {
      swiper.loopFix({
        direction: "prev",
        setTranslate: true,
        activeSlideIndex: 0
      });
    }
    if (data.currentTranslate > swiper.minTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff2) ** resistanceRatio;
      }
    }
  } else if (diff2 < 0) {
    if (isLoop && !loopFixed && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.size / 2 : swiper.maxTranslate())) {
      swiper.loopFix({
        direction: "next",
        setTranslate: true,
        activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
      });
    }
    if (data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff2) ** resistanceRatio;
      }
    }
  }
  if (disableParentSwiper) {
    e2.preventedByNestedSwiper = true;
  }
  if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  }
  if (params.threshold > 0) {
    if (Math.abs(diff2) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }
  if (!params.followFinger || params.cssMode)
    return;
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  }
  swiper.updateProgress(data.currentTranslate);
  swiper.setTranslate(data.currentTranslate);
}
function onTouchEnd(event) {
  const swiper = this;
  const data = swiper.touchEventsData;
  const pointerIndex = data.evCache.findIndex((cachedEv) => cachedEv.pointerId === event.pointerId);
  if (pointerIndex >= 0) {
    data.evCache.splice(pointerIndex, 1);
  }
  if (["pointercancel", "pointerout", "pointerleave"].includes(event.type))
    return;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    slidesGrid,
    enabled
  } = swiper;
  if (!enabled)
    return;
  if (!params.simulateTouch && event.pointerType === "mouse")
    return;
  let e2 = event;
  if (e2.originalEvent)
    e2 = e2.originalEvent;
  if (data.allowTouchCallbacks) {
    swiper.emit("touchEnd", e2);
  }
  data.allowTouchCallbacks = false;
  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  }
  const touchEndTime = now$4();
  const timeDiff = touchEndTime - data.touchStartTime;
  if (swiper.allowClick) {
    const pathTree = e2.path || e2.composedPath && e2.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e2.target);
    swiper.emit("tap click", e2);
    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit("doubleTap doubleClick", e2);
    }
  }
  data.lastClickTime = now$4();
  nextTick(() => {
    if (!swiper.destroyed)
      swiper.allowClick = true;
  });
  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  let currentPos;
  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }
  if (params.cssMode) {
    return;
  }
  if (swiper.params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos
    });
    return;
  }
  let stopIndex = 0;
  let groupSize = swiper.slidesSizesGrid[0];
  for (let i2 = 0; i2 < slidesGrid.length; i2 += i2 < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    const increment2 = i2 < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (typeof slidesGrid[i2 + increment2] !== "undefined") {
      if (currentPos >= slidesGrid[i2] && currentPos < slidesGrid[i2 + increment2]) {
        stopIndex = i2;
        groupSize = slidesGrid[i2 + increment2] - slidesGrid[i2];
      }
    } else if (currentPos >= slidesGrid[i2]) {
      stopIndex = i2;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }
  let rewindFirstIndex = null;
  let rewindLastIndex = null;
  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  }
  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
  if (timeDiff > params.longSwipesMs) {
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === "next") {
      if (ratio >= params.longSwipesRatio)
        swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
      else
        swiper.slideTo(stopIndex);
    }
    if (swiper.swipeDirection === "prev") {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    const isNavButtonTarget = swiper.navigation && (e2.target === swiper.navigation.nextEl || e2.target === swiper.navigation.prevEl);
    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === "next") {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }
      if (swiper.swipeDirection === "prev") {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e2.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}
let timeout;
function onResize() {
  const swiper = this;
  const {
    params,
    el
  } = swiper;
  if (el && el.offsetWidth === 0)
    return;
  if (params.breakpoints) {
    swiper.setBreakpoint();
  }
  const {
    allowSlideNext,
    allowSlidePrev,
    snapGrid
  } = swiper;
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();
  const isVirtualLoop = isVirtual && params.loop;
  if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    if (swiper.params.loop && !isVirtual) {
      swiper.slideToLoop(swiper.realIndex, 0, false, true);
    } else {
      swiper.slideTo(swiper.activeIndex, 0, false, true);
    }
  }
  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      swiper.autoplay.resume();
    }, 500);
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}
function onClick(e2) {
  const swiper = this;
  if (!swiper.enabled)
    return;
  if (!swiper.allowClick) {
    if (swiper.params.preventClicks)
      e2.preventDefault();
    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e2.stopPropagation();
      e2.stopImmediatePropagation();
    }
  }
}
function onScroll() {
  const swiper = this;
  const {
    wrapperEl,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled)
    return;
  swiper.previousTranslate = swiper.translate;
  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  }
  if (swiper.translate === 0)
    swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }
  swiper.emit("setTranslate", swiper.translate, false);
}
const processLazyPreloader = (swiper, imageEl) => {
  const slideSelector = () => swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
  const slideEl = imageEl.closest(slideSelector());
  if (slideEl) {
    const lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
    if (lazyEl)
      lazyEl.remove();
  }
};
function onLoad(e2) {
  const swiper = this;
  processLazyPreloader(swiper, e2.target);
  swiper.update();
}
let dummyEventAttached = false;
function dummyEventListener() {
}
const events = (swiper, method) => {
  const document2 = getDocument();
  const {
    params,
    el,
    wrapperEl,
    device
  } = swiper;
  const capture = !!params.nested;
  const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
  const swiperMethod = method;
  el[domMethod]("pointerdown", swiper.onTouchStart, {
    passive: false
  });
  document2[domMethod]("pointermove", swiper.onTouchMove, {
    passive: false,
    capture
  });
  document2[domMethod]("pointerup", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("pointercancel", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("pointerout", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("pointerleave", swiper.onTouchEnd, {
    passive: true
  });
  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]("click", swiper.onClick, true);
  }
  if (params.cssMode) {
    wrapperEl[domMethod]("scroll", swiper.onScroll);
  }
  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", onResize, true);
  } else {
    swiper[swiperMethod]("observerUpdate", onResize, true);
  }
  el[domMethod]("load", swiper.onLoad, {
    capture: true
  });
};
function attachEvents() {
  const swiper = this;
  const document2 = getDocument();
  const {
    params
  } = swiper;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);
  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }
  swiper.onClick = onClick.bind(swiper);
  swiper.onLoad = onLoad.bind(swiper);
  if (!dummyEventAttached) {
    document2.addEventListener("touchstart", dummyEventListener);
    dummyEventAttached = true;
  }
  events(swiper, "on");
}
function detachEvents() {
  const swiper = this;
  events(swiper, "off");
}
const events$1 = {
  attachEvents,
  detachEvents
};
const isGridEnabled = (swiper, params) => {
  return swiper.grid && params.grid && params.grid.rows > 1;
};
function setBreakpoint() {
  const swiper = this;
  const {
    realIndex,
    initialized,
    params,
    el
  } = swiper;
  const breakpoints2 = params.breakpoints;
  if (!breakpoints2 || breakpoints2 && Object.keys(breakpoints2).length === 0)
    return;
  const breakpoint = swiper.getBreakpoint(breakpoints2, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint)
    return;
  const breakpointOnlyParams = breakpoint in breakpoints2 ? breakpoints2[breakpoint] : void 0;
  const breakpointParams = breakpointOnlyParams || swiper.originalParams;
  const wasMultiRow = isGridEnabled(swiper, params);
  const isMultiRow = isGridEnabled(swiper, breakpointParams);
  const wasEnabled = params.enabled;
  if (wasMultiRow && !isMultiRow) {
    el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    el.classList.add(`${params.containerModifierClass}grid`);
    if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") {
      el.classList.add(`${params.containerModifierClass}grid-column`);
    }
    swiper.emitContainerClasses();
  }
  ["navigation", "pagination", "scrollbar"].forEach((prop) => {
    const wasModuleEnabled = params[prop] && params[prop].enabled;
    const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
    if (wasModuleEnabled && !isModuleEnabled) {
      swiper[prop].disable();
    }
    if (!wasModuleEnabled && isModuleEnabled) {
      swiper[prop].enable();
    }
  });
  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
  if (directionChanged && initialized) {
    swiper.changeDirection();
  }
  extend$1(swiper.params, breakpointParams);
  const isEnabled = swiper.params.enabled;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });
  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }
  swiper.currentBreakpoint = breakpoint;
  swiper.emit("_beforeBreakpoint", breakpointParams);
  if (needsReLoop && initialized) {
    swiper.loopDestroy();
    swiper.loopCreate(realIndex);
    swiper.updateSlides();
  }
  swiper.emit("breakpoint", breakpointParams);
}
function getBreakpoint(breakpoints2, base = "window", containerEl) {
  if (!breakpoints2 || base === "container" && !containerEl)
    return void 0;
  let breakpoint = false;
  const window2 = getWindow();
  const currentHeight = base === "window" ? window2.innerHeight : containerEl.clientHeight;
  const points = Object.keys(breakpoints2).map((point) => {
    if (typeof point === "string" && point.indexOf("@") === 0) {
      const minRatio = parseFloat(point.substr(1));
      const value = currentHeight * minRatio;
      return {
        value,
        point
      };
    }
    return {
      value: point,
      point
    };
  });
  points.sort((a2, b) => parseInt(a2.value, 10) - parseInt(b.value, 10));
  for (let i2 = 0; i2 < points.length; i2 += 1) {
    const {
      point,
      value
    } = points[i2];
    if (base === "window") {
      if (window2.matchMedia(`(min-width: ${value}px)`).matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }
  return breakpoint || "max";
}
const breakpoints = {
  setBreakpoint,
  getBreakpoint
};
function prepareClasses(entries, prefix) {
  const resultClasses = [];
  entries.forEach((item) => {
    if (typeof item === "object") {
      Object.keys(item).forEach((classNames) => {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === "string") {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}
function addClasses() {
  const swiper = this;
  const {
    classNames,
    params,
    rtl,
    el,
    device
  } = swiper;
  const suffixes = prepareClasses(["initialized", params.direction, {
    "free-mode": swiper.params.freeMode && params.freeMode.enabled
  }, {
    "autoheight": params.autoHeight
  }, {
    "rtl": rtl
  }, {
    "grid": params.grid && params.grid.rows > 1
  }, {
    "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
  }, {
    "android": device.android
  }, {
    "ios": device.ios
  }, {
    "css-mode": params.cssMode
  }, {
    "centered": params.cssMode && params.centeredSlides
  }, {
    "watch-progress": params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames.push(...suffixes);
  el.classList.add(...classNames);
  swiper.emitContainerClasses();
}
function removeClasses() {
  const swiper = this;
  const {
    el,
    classNames
  } = swiper;
  el.classList.remove(...classNames);
  swiper.emitContainerClasses();
}
const classes = {
  addClasses,
  removeClasses
};
function checkOverflow() {
  const swiper = this;
  const {
    isLocked: wasLocked,
    params
  } = swiper;
  const {
    slidesOffsetBefore
  } = params;
  if (slidesOffsetBefore) {
    const lastSlideIndex = swiper.slides.length - 1;
    const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }
  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }
  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }
  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }
  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? "lock" : "unlock");
  }
}
const checkOverflow$1 = {
  checkOverflow
};
const defaults = {
  init: true,
  direction: "horizontal",
  oneWayMovement: false,
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 5,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // loop
  loop: false,
  loopedSlides: null,
  loopPreventsSliding: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};
function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj = {}) {
    const moduleParamName = Object.keys(obj)[0];
    const moduleParams = obj[moduleParamName];
    if (typeof moduleParams !== "object" || moduleParams === null) {
      extend$1(allModulesParams, obj);
      return;
    }
    if (["navigation", "pagination", "scrollbar"].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
      params[moduleParamName] = {
        auto: true
      };
    }
    if (!(moduleParamName in params && "enabled" in moduleParams)) {
      extend$1(allModulesParams, obj);
      return;
    }
    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }
    if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }
    if (!params[moduleParamName])
      params[moduleParamName] = {
        enabled: false
      };
    extend$1(allModulesParams, obj);
  };
}
const prototypes = {
  eventsEmitter,
  update,
  translate,
  transition,
  slide,
  loop,
  grabCursor,
  events: events$1,
  breakpoints,
  checkOverflow: checkOverflow$1,
  classes
};
const extendedDefaults = {};
let Swiper$1 = class Swiper {
  constructor(...args) {
    let el;
    let params;
    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") {
      params = args[0];
    } else {
      [el, params] = args;
    }
    if (!params)
      params = {};
    params = extend$1({}, params);
    if (el && !params.el)
      params.el = el;
    const document2 = getDocument();
    if (params.el && typeof params.el === "string" && document2.querySelectorAll(params.el).length > 1) {
      const swipers = [];
      document2.querySelectorAll(params.el).forEach((containerEl) => {
        const newParams = extend$1({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper$1(newParams));
      });
      return swipers;
    }
    const swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = [...swiper.__modules__];
    if (params.modules && Array.isArray(params.modules)) {
      swiper.modules.push(...params.modules);
    }
    const allModulesParams = {};
    swiper.modules.forEach((mod2) => {
      mod2({
        params,
        swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    });
    const swiperParams = extend$1({}, defaults, allModulesParams);
    swiper.params = extend$1({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = extend$1({}, swiper.params);
    swiper.passedParams = extend$1({}, params);
    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach((eventName) => {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }
    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    }
    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return swiper.params.direction === "horizontal";
      },
      isVertical() {
        return swiper.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: now$4(),
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        evCache: []
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit("_swiper");
    if (swiper.params.init) {
      swiper.init();
    }
    return swiper;
  }
  recalcSlides() {
    const swiper = this;
    const {
      slidesEl,
      params
    } = swiper;
    swiper.slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
  }
  enable() {
    const swiper = this;
    if (swiper.enabled)
      return;
    swiper.enabled = true;
    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }
    swiper.emit("enable");
  }
  disable() {
    const swiper = this;
    if (!swiper.enabled)
      return;
    swiper.enabled = false;
    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }
    swiper.emit("disable");
  }
  setProgress(progress, speed) {
    const swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    const min2 = swiper.minTranslate();
    const max2 = swiper.maxTranslate();
    const current = (max2 - min2) * progress + min2;
    swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  emitContainerClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el)
      return;
    const cls = swiper.el.className.split(" ").filter((className) => {
      return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit("_containerClasses", cls.join(" "));
  }
  getSlideClasses(slideEl) {
    const swiper = this;
    if (swiper.destroyed)
      return "";
    return slideEl.className.split(" ").filter((className) => {
      return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(" ");
  }
  emitSlidesClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el)
      return;
    const updates = [];
    swiper.slides.forEach((slideEl) => {
      const classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl,
        classNames
      });
      swiper.emit("_slideClass", slideEl, classNames);
    });
    swiper.emit("_slideClasses", updates);
  }
  slidesPerViewDynamic(view = "current", exact = false) {
    const swiper = this;
    const {
      params,
      slides,
      slidesGrid,
      slidesSizesGrid,
      size: swiperSize,
      activeIndex
    } = swiper;
    let spv = 1;
    if (params.centeredSlides) {
      let slideSize = slides[activeIndex].swiperSlideSize;
      let breakLoop;
      for (let i2 = activeIndex + 1; i2 < slides.length; i2 += 1) {
        if (slides[i2] && !breakLoop) {
          slideSize += slides[i2].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize)
            breakLoop = true;
        }
      }
      for (let i2 = activeIndex - 1; i2 >= 0; i2 -= 1) {
        if (slides[i2] && !breakLoop) {
          slideSize += slides[i2].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize)
            breakLoop = true;
        }
      }
    } else {
      if (view === "current") {
        for (let i2 = activeIndex + 1; i2 < slides.length; i2 += 1) {
          const slideInView = exact ? slidesGrid[i2] + slidesSizesGrid[i2] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i2] - slidesGrid[activeIndex] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      } else {
        for (let i2 = activeIndex - 1; i2 >= 0; i2 -= 1) {
          const slideInView = slidesGrid[activeIndex] - slidesGrid[i2] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      }
    }
    return spv;
  }
  update() {
    const swiper = this;
    if (!swiper || swiper.destroyed)
      return;
    const {
      snapGrid,
      params
    } = swiper;
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }
    [...swiper.el.querySelectorAll('[loading="lazy"]')].forEach((imageEl) => {
      if (imageEl.complete) {
        processLazyPreloader(swiper, imageEl);
      }
    });
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();
    function setTranslate2() {
      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    let translated;
    if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
      setTranslate2();
      if (swiper.params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((swiper.params.slidesPerView === "auto" || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
      if (!translated) {
        setTranslate2();
      }
    }
    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
    swiper.emit("update");
  }
  changeDirection(newDirection, needUpdate = true) {
    const swiper = this;
    const currentDirection = swiper.params.direction;
    if (!newDirection) {
      newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
    }
    if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") {
      return swiper;
    }
    swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
    swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.forEach((slideEl) => {
      if (newDirection === "vertical") {
        slideEl.style.width = "";
      } else {
        slideEl.style.height = "";
      }
    });
    swiper.emit("changeDirection");
    if (needUpdate)
      swiper.update();
    return swiper;
  }
  changeLanguageDirection(direction) {
    const swiper = this;
    if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr")
      return;
    swiper.rtl = direction === "rtl";
    swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
    if (swiper.rtl) {
      swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = "rtl";
    } else {
      swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = "ltr";
    }
    swiper.update();
  }
  mount(element) {
    const swiper = this;
    if (swiper.mounted)
      return true;
    let el = element || swiper.params.el;
    if (typeof el === "string") {
      el = document.querySelector(el);
    }
    if (!el) {
      return false;
    }
    el.swiper = swiper;
    if (el.shadowEl) {
      swiper.isElement = true;
    }
    const getWrapperSelector = () => {
      return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
    };
    const getWrapper = () => {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        const res = el.shadowRoot.querySelector(getWrapperSelector());
        return res;
      }
      return elementChildren(el, getWrapperSelector())[0];
    };
    let wrapperEl = getWrapper();
    if (!wrapperEl && swiper.params.createElements) {
      wrapperEl = createElement("div", swiper.params.wrapperClass);
      el.append(wrapperEl);
      elementChildren(el, `.${swiper.params.slideClass}`).forEach((slideEl) => {
        wrapperEl.append(slideEl);
      });
    }
    Object.assign(swiper, {
      el,
      wrapperEl,
      slidesEl: swiper.isElement ? el : wrapperEl,
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === "rtl" || elementStyle(el, "direction") === "rtl",
      rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || elementStyle(el, "direction") === "rtl"),
      wrongRTL: elementStyle(wrapperEl, "display") === "-webkit-box"
    });
    return true;
  }
  init(el) {
    const swiper = this;
    if (swiper.initialized)
      return swiper;
    const mounted = swiper.mount(el);
    if (mounted === false)
      return swiper;
    swiper.emit("beforeInit");
    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    }
    swiper.addClasses();
    swiper.updateSize();
    swiper.updateSlides();
    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    }
    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }
    if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
      swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    }
    if (swiper.params.loop) {
      swiper.loopCreate();
    }
    swiper.attachEvents();
    [...swiper.el.querySelectorAll('[loading="lazy"]')].forEach((imageEl) => {
      if (imageEl.complete) {
        processLazyPreloader(swiper, imageEl);
      } else {
        imageEl.addEventListener("load", (e2) => {
          processLazyPreloader(swiper, e2.target);
        });
      }
    });
    swiper.initialized = true;
    swiper.emit("init");
    swiper.emit("afterInit");
    return swiper;
  }
  destroy(deleteInstance = true, cleanStyles = true) {
    const swiper = this;
    const {
      params,
      el,
      wrapperEl,
      slides
    } = swiper;
    if (typeof swiper.params === "undefined" || swiper.destroyed) {
      return null;
    }
    swiper.emit("beforeDestroy");
    swiper.initialized = false;
    swiper.detachEvents();
    if (params.loop) {
      swiper.loopDestroy();
    }
    if (cleanStyles) {
      swiper.removeClasses();
      el.removeAttribute("style");
      wrapperEl.removeAttribute("style");
      if (slides && slides.length) {
        slides.forEach((slideEl) => {
          slideEl.classList.remove(params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
          slideEl.removeAttribute("style");
          slideEl.removeAttribute("data-swiper-slide-index");
        });
      }
    }
    swiper.emit("destroy");
    Object.keys(swiper.eventsListeners).forEach((eventName) => {
      swiper.off(eventName);
    });
    if (deleteInstance !== false) {
      swiper.el.swiper = null;
      deleteProps(swiper);
    }
    swiper.destroyed = true;
    return null;
  }
  static extendDefaults(newDefaults) {
    extend$1(extendedDefaults, newDefaults);
  }
  static get extendedDefaults() {
    return extendedDefaults;
  }
  static get defaults() {
    return defaults;
  }
  static installModule(mod2) {
    if (!Swiper$1.prototype.__modules__)
      Swiper$1.prototype.__modules__ = [];
    const modules = Swiper$1.prototype.__modules__;
    if (typeof mod2 === "function" && modules.indexOf(mod2) < 0) {
      modules.push(mod2);
    }
  }
  static use(module) {
    if (Array.isArray(module)) {
      module.forEach((m2) => Swiper$1.installModule(m2));
      return Swiper$1;
    }
    Swiper$1.installModule(module);
    return Swiper$1;
  }
};
Object.keys(prototypes).forEach((prototypeGroup) => {
  Object.keys(prototypes[prototypeGroup]).forEach((protoMethod) => {
    Swiper$1.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper$1.use([Resize, Observer]);
function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
  if (swiper.params.createElements) {
    Object.keys(checkProps).forEach((key) => {
      if (!params[key] && params.auto === true) {
        let element = elementChildren(swiper.el, `.${checkProps[key]}`)[0];
        if (!element) {
          element = createElement("div", checkProps[key]);
          element.className = checkProps[key];
          swiper.el.append(element);
        }
        params[key] = element;
        originalParams[key] = element;
      }
    });
  }
  return params;
}
function Navigation({
  swiper,
  extendParams,
  on,
  emit
}) {
  extendParams({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  });
  swiper.navigation = {
    nextEl: null,
    prevEl: null
  };
  const makeElementsArray = (el) => {
    if (!Array.isArray(el))
      el = [el].filter((e2) => !!e2);
    return el;
  };
  function getEl(el) {
    let res;
    if (el && typeof el === "string" && swiper.isElement) {
      res = swiper.el.shadowRoot.querySelector(el);
      if (res)
        return res;
    }
    if (el) {
      if (typeof el === "string")
        res = [...document.querySelectorAll(el)];
      if (swiper.params.uniqueNavElements && typeof el === "string" && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) {
        res = swiper.el.querySelector(el);
      }
    }
    if (el && !res)
      return el;
    return res;
  }
  function toggleEl(el, disabled) {
    const params = swiper.params.navigation;
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      if (subEl) {
        subEl.classList[disabled ? "add" : "remove"](params.disabledClass);
        if (subEl.tagName === "BUTTON")
          subEl.disabled = disabled;
        if (swiper.params.watchOverflow && swiper.enabled) {
          subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
        }
      }
    });
  }
  function update2() {
    const {
      nextEl,
      prevEl
    } = swiper.navigation;
    if (swiper.params.loop) {
      toggleEl(prevEl, false);
      toggleEl(nextEl, false);
      return;
    }
    toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
    toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
  }
  function onPrevClick(e2) {
    e2.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind)
      return;
    swiper.slidePrev();
    emit("navigationPrev");
  }
  function onNextClick(e2) {
    e2.preventDefault();
    if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind)
      return;
    swiper.slideNext();
    emit("navigationNext");
  }
  function init2() {
    const params = swiper.params.navigation;
    swiper.params.navigation = createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    });
    if (!(params.nextEl || params.prevEl))
      return;
    let nextEl = getEl(params.nextEl);
    let prevEl = getEl(params.prevEl);
    Object.assign(swiper.navigation, {
      nextEl,
      prevEl
    });
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    const initButton = (el, dir) => {
      if (el) {
        el.addEventListener("click", dir === "next" ? onNextClick : onPrevClick);
      }
      if (!swiper.enabled && el) {
        el.classList.add(params.lockClass);
      }
    };
    nextEl.forEach((el) => initButton(el, "next"));
    prevEl.forEach((el) => initButton(el, "prev"));
  }
  function destroy() {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    const destroyButton = (el, dir) => {
      el.removeEventListener("click", dir === "next" ? onNextClick : onPrevClick);
      el.classList.remove(swiper.params.navigation.disabledClass);
    };
    nextEl.forEach((el) => destroyButton(el, "next"));
    prevEl.forEach((el) => destroyButton(el, "prev"));
  }
  on("init", () => {
    if (swiper.params.navigation.enabled === false) {
      disable();
    } else {
      init2();
      update2();
    }
  });
  on("toEdge fromEdge lock unlock", () => {
    update2();
  });
  on("destroy", () => {
    destroy();
  });
  on("enable disable", () => {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    [...nextEl, ...prevEl].filter((el) => !!el).forEach((el) => el.classList[swiper.enabled ? "remove" : "add"](swiper.params.navigation.lockClass));
  });
  on("click", (_s, e2) => {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    const targetEl = e2.target;
    if (swiper.params.navigation.hideOnClick && !prevEl.includes(targetEl) && !nextEl.includes(targetEl)) {
      if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl)))
        return;
      let isHidden;
      if (nextEl.length) {
        isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
      } else if (prevEl.length) {
        isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
      }
      if (isHidden === true) {
        emit("navigationShow");
      } else {
        emit("navigationHide");
      }
      [...nextEl, ...prevEl].filter((el) => !!el).forEach((el) => el.classList.toggle(swiper.params.navigation.hiddenClass));
    }
  });
  const enable = () => {
    swiper.el.classList.remove(swiper.params.navigation.navigationDisabledClass);
    init2();
    update2();
  };
  const disable = () => {
    swiper.el.classList.add(swiper.params.navigation.navigationDisabledClass);
    destroy();
  };
  Object.assign(swiper.navigation, {
    enable,
    disable,
    update: update2,
    init: init2,
    destroy
  });
}
function Scrollbar({
  swiper,
  extendParams,
  on,
  emit
}) {
  const document2 = getDocument();
  let isTouched = false;
  let timeout2 = null;
  let dragTimeout = null;
  let dragStartPos;
  let dragSize;
  let trackSize;
  let divider;
  extendParams({
    scrollbar: {
      el: null,
      dragSize: "auto",
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: "swiper-scrollbar-lock",
      dragClass: "swiper-scrollbar-drag",
      scrollbarDisabledClass: "swiper-scrollbar-disabled",
      horizontalClass: `swiper-scrollbar-horizontal`,
      verticalClass: `swiper-scrollbar-vertical`
    }
  });
  swiper.scrollbar = {
    el: null,
    dragEl: null
  };
  function setTranslate2() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el)
      return;
    const {
      scrollbar,
      rtlTranslate: rtl
    } = swiper;
    const {
      dragEl,
      el
    } = scrollbar;
    const params = swiper.params.scrollbar;
    const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
    let newSize = dragSize;
    let newPos = (trackSize - dragSize) * progress;
    if (rtl) {
      newPos = -newPos;
      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }
    if (swiper.isHorizontal()) {
      dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
      dragEl.style.width = `${newSize}px`;
    } else {
      dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
      dragEl.style.height = `${newSize}px`;
    }
    if (params.hide) {
      clearTimeout(timeout2);
      el.style.opacity = 1;
      timeout2 = setTimeout(() => {
        el.style.opacity = 0;
        el.style.transitionDuration = "400ms";
      }, 1e3);
    }
  }
  function setTransition2(duration) {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el)
      return;
    swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
  }
  function updateSize2() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el)
      return;
    const {
      scrollbar
    } = swiper;
    const {
      dragEl,
      el
    } = scrollbar;
    dragEl.style.width = "";
    dragEl.style.height = "";
    trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
    divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
    if (swiper.params.scrollbar.dragSize === "auto") {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }
    if (swiper.isHorizontal()) {
      dragEl.style.width = `${dragSize}px`;
    } else {
      dragEl.style.height = `${dragSize}px`;
    }
    if (divider >= 1) {
      el.style.display = "none";
    } else {
      el.style.display = "";
    }
    if (swiper.params.scrollbar.hide) {
      el.style.opacity = 0;
    }
    if (swiper.params.watchOverflow && swiper.enabled) {
      scrollbar.el.classList[swiper.isLocked ? "add" : "remove"](swiper.params.scrollbar.lockClass);
    }
  }
  function getPointerPosition(e2) {
    return swiper.isHorizontal() ? e2.clientX : e2.clientY;
  }
  function setDragPosition(e2) {
    const {
      scrollbar,
      rtlTranslate: rtl
    } = swiper;
    const {
      el
    } = scrollbar;
    let positionRatio;
    positionRatio = (getPointerPosition(e2) - elementOffset(el)[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);
    if (rtl) {
      positionRatio = 1 - positionRatio;
    }
    const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  function onDragStart(e2) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      wrapperEl
    } = swiper;
    const {
      el,
      dragEl
    } = scrollbar;
    isTouched = true;
    dragStartPos = e2.target === dragEl ? getPointerPosition(e2) - e2.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
    e2.preventDefault();
    e2.stopPropagation();
    wrapperEl.style.transitionDuration = "100ms";
    dragEl.style.transitionDuration = "100ms";
    setDragPosition(e2);
    clearTimeout(dragTimeout);
    el.style.transitionDuration = "0ms";
    if (params.hide) {
      el.style.opacity = 1;
    }
    if (swiper.params.cssMode) {
      swiper.wrapperEl.style["scroll-snap-type"] = "none";
    }
    emit("scrollbarDragStart", e2);
  }
  function onDragMove(e2) {
    const {
      scrollbar,
      wrapperEl
    } = swiper;
    const {
      el,
      dragEl
    } = scrollbar;
    if (!isTouched)
      return;
    if (e2.preventDefault)
      e2.preventDefault();
    else
      e2.returnValue = false;
    setDragPosition(e2);
    wrapperEl.style.transitionDuration = "0ms";
    el.style.transitionDuration = "0ms";
    dragEl.style.transitionDuration = "0ms";
    emit("scrollbarDragMove", e2);
  }
  function onDragEnd(e2) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      wrapperEl
    } = swiper;
    const {
      el
    } = scrollbar;
    if (!isTouched)
      return;
    isTouched = false;
    if (swiper.params.cssMode) {
      swiper.wrapperEl.style["scroll-snap-type"] = "";
      wrapperEl.style.transitionDuration = "";
    }
    if (params.hide) {
      clearTimeout(dragTimeout);
      dragTimeout = nextTick(() => {
        el.style.opacity = 0;
        el.style.transitionDuration = "400ms";
      }, 1e3);
    }
    emit("scrollbarDragEnd", e2);
    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  }
  function events2(method) {
    const {
      scrollbar,
      params
    } = swiper;
    const el = scrollbar.el;
    if (!el)
      return;
    const target = el;
    const activeListener = params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    const passiveListener = params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    if (!target)
      return;
    const eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
    target[eventMethod]("pointerdown", onDragStart, activeListener);
    document2[eventMethod]("pointermove", onDragMove, activeListener);
    document2[eventMethod]("pointerup", onDragEnd, passiveListener);
  }
  function enableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el)
      return;
    events2("on");
  }
  function disableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el)
      return;
    events2("off");
  }
  function init2() {
    const {
      scrollbar,
      el: swiperEl
    } = swiper;
    swiper.params.scrollbar = createElementIfNotDefined(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
      el: "swiper-scrollbar"
    });
    const params = swiper.params.scrollbar;
    if (!params.el)
      return;
    let el;
    if (typeof params.el === "string" && swiper.isElement) {
      el = swiper.el.shadowRoot.querySelector(params.el);
    }
    if (!el && typeof params.el === "string") {
      el = document2.querySelectorAll(params.el);
    } else if (!el) {
      el = params.el;
    }
    if (swiper.params.uniqueNavElements && typeof params.el === "string" && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) {
      el = swiperEl.querySelector(params.el);
    }
    if (el.length > 0)
      el = el[0];
    el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    let dragEl;
    if (el) {
      el.querySelector(`.${swiper.params.scrollbar.dragClass}`);
      if (!dragEl) {
        dragEl = createElement("div", swiper.params.scrollbar.dragClass);
        el.append(dragEl);
      }
    }
    Object.assign(scrollbar, {
      el,
      dragEl
    });
    if (params.draggable) {
      enableDraggable();
    }
    if (el) {
      el.classList[swiper.enabled ? "remove" : "add"](swiper.params.scrollbar.lockClass);
    }
  }
  function destroy() {
    const params = swiper.params.scrollbar;
    const el = swiper.scrollbar.el;
    if (el) {
      el.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    }
    disableDraggable();
  }
  on("init", () => {
    if (swiper.params.scrollbar.enabled === false) {
      disable();
    } else {
      init2();
      updateSize2();
      setTranslate2();
    }
  });
  on("update resize observerUpdate lock unlock", () => {
    updateSize2();
  });
  on("setTranslate", () => {
    setTranslate2();
  });
  on("setTransition", (_s, duration) => {
    setTransition2(duration);
  });
  on("enable disable", () => {
    const {
      el
    } = swiper.scrollbar;
    if (el) {
      el.classList[swiper.enabled ? "remove" : "add"](swiper.params.scrollbar.lockClass);
    }
  });
  on("destroy", () => {
    destroy();
  });
  const enable = () => {
    swiper.el.classList.remove(swiper.params.scrollbar.scrollbarDisabledClass);
    if (swiper.scrollbar.el) {
      swiper.scrollbar.el.classList.remove(swiper.params.scrollbar.scrollbarDisabledClass);
    }
    init2();
    updateSize2();
    setTranslate2();
  };
  const disable = () => {
    swiper.el.classList.add(swiper.params.scrollbar.scrollbarDisabledClass);
    if (swiper.scrollbar.el) {
      swiper.scrollbar.el.classList.add(swiper.params.scrollbar.scrollbarDisabledClass);
    }
    destroy();
  };
  Object.assign(swiper.scrollbar, {
    enable,
    disable,
    updateSize: updateSize2,
    setTranslate: setTranslate2,
    init: init2,
    destroy
  });
}
function isObject$8(o3) {
  return typeof o3 === "object" && o3 !== null && o3.constructor && Object.prototype.toString.call(o3).slice(8, -1) === "Object";
}
function extend(target, src) {
  const noExtend = ["__proto__", "constructor", "prototype"];
  Object.keys(src).filter((key) => noExtend.indexOf(key) < 0).forEach((key) => {
    if (typeof target[key] === "undefined")
      target[key] = src[key];
    else if (isObject$8(src[key]) && isObject$8(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__)
        target[key] = src[key];
      else
        extend(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}
function needsNavigation(params = {}) {
  return params.navigation && typeof params.navigation.nextEl === "undefined" && typeof params.navigation.prevEl === "undefined";
}
function needsPagination(params = {}) {
  return params.pagination && typeof params.pagination.el === "undefined";
}
function needsScrollbar(params = {}) {
  return params.scrollbar && typeof params.scrollbar.el === "undefined";
}
function uniqueClasses(classNames = "") {
  const classes2 = classNames.split(" ").map((c2) => c2.trim()).filter((c2) => !!c2);
  const unique = [];
  classes2.forEach((c2) => {
    if (unique.indexOf(c2) < 0)
      unique.push(c2);
  });
  return unique.join(" ");
}
function wrapperClass(className = "") {
  if (!className)
    return "swiper-wrapper";
  if (!className.includes("swiper-wrapper"))
    return `swiper-wrapper ${className}`;
  return className;
}
const paramsList = [
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopedSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control",
  "injectStyles",
  "injectStylesUrls"
];
function getParams(obj = {}, splitEvents = true) {
  const params = {
    on: {}
  };
  const events2 = {};
  const passedParams = {};
  extend(params, Swiper$1.defaults);
  extend(params, Swiper$1.extendedDefaults);
  params._emitClasses = true;
  params.init = false;
  const rest = {};
  const allowedParams = paramsList.map((key) => key.replace(/_/, ""));
  const plainObj = Object.assign({}, obj);
  Object.keys(plainObj).forEach((key) => {
    if (typeof obj[key] === "undefined")
      return;
    if (allowedParams.indexOf(key) >= 0) {
      if (isObject$8(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        extend(params[key], obj[key]);
        extend(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === "function") {
      if (splitEvents) {
        events2[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      } else {
        params.on[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      }
    } else {
      rest[key] = obj[key];
    }
  });
  ["navigation", "pagination", "scrollbar"].forEach((key) => {
    if (params[key] === true)
      params[key] = {};
    if (params[key] === false)
      delete params[key];
  });
  return {
    params,
    passedParams,
    rest,
    events: events2
  };
}
function mountSwiper({
  el,
  nextEl,
  prevEl,
  paginationEl,
  scrollbarEl,
  swiper
}, swiperParams) {
  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }
  if (needsPagination(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }
  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }
  swiper.init(el);
}
function getChangedParams(swiperParams, oldParams, children, oldChildren, getKey) {
  const keys2 = [];
  if (!oldParams)
    return keys2;
  const addKey = (key) => {
    if (keys2.indexOf(key) < 0)
      keys2.push(key);
  };
  if (children && oldChildren) {
    const oldChildrenKeys = oldChildren.map(getKey);
    const childrenKeys = children.map(getKey);
    if (oldChildrenKeys.join("") !== childrenKeys.join(""))
      addKey("children");
    if (oldChildren.length !== children.length)
      addKey("children");
  }
  const watchParams = paramsList.filter((key) => key[0] === "_").map((key) => key.replace(/_/, ""));
  watchParams.forEach((key) => {
    if (key in swiperParams && key in oldParams) {
      if (isObject$8(swiperParams[key]) && isObject$8(oldParams[key])) {
        const newKeys = Object.keys(swiperParams[key]);
        const oldKeys = Object.keys(oldParams[key]);
        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach((newKey) => {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach((oldKey) => {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey])
              addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys2;
}
function isChildSwiperSlide(child) {
  return child.type && child.type.displayName && child.type.displayName.includes("SwiperSlide");
}
function processChildren(c2) {
  const slides = [];
  React__default$1.Children.toArray(c2).forEach((child) => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach((slide2) => slides.push(slide2));
    }
  });
  return slides;
}
function getChildren(c2) {
  const slides = [];
  const slots = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  };
  React__default$1.Children.toArray(c2).forEach((child) => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      const foundSlides = processChildren(child.props.children);
      if (foundSlides.length > 0) {
        foundSlides.forEach((slide2) => slides.push(slide2));
      } else {
        slots["container-end"].push(child);
      }
    } else {
      slots["container-end"].push(child);
    }
  });
  return {
    slides,
    slots
  };
}
function updateSwiper({
  swiper,
  slides,
  passedParams,
  changedParams,
  nextEl,
  prevEl,
  scrollbarEl,
  paginationEl
}) {
  const updateParams = changedParams.filter((key) => key !== "children" && key !== "direction" && key !== "wrapperClass");
  const {
    params: currentParams,
    pagination,
    navigation,
    scrollbar,
    virtual,
    thumbs
  } = swiper;
  let needThumbsInit;
  let needControllerInit;
  let needPaginationInit;
  let needScrollbarInit;
  let needNavigationInit;
  let loopNeedDestroy;
  let loopNeedEnable;
  let loopNeedReloop;
  if (changedParams.includes("thumbs") && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
    needThumbsInit = true;
  }
  if (changedParams.includes("controller") && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }
  if (changedParams.includes("pagination") && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }
  if (changedParams.includes("scrollbar") && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }
  if (changedParams.includes("navigation") && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }
  const destroyModule = (mod2) => {
    if (!swiper[mod2])
      return;
    swiper[mod2].destroy();
    if (mod2 === "navigation") {
      if (swiper.isElement) {
        swiper[mod2].prevEl.remove();
        swiper[mod2].nextEl.remove();
      }
      currentParams[mod2].prevEl = void 0;
      currentParams[mod2].nextEl = void 0;
      swiper[mod2].prevEl = void 0;
      swiper[mod2].nextEl = void 0;
    } else {
      if (swiper.isElement) {
        swiper[mod2].el.remove();
      }
      currentParams[mod2].el = void 0;
      swiper[mod2].el = void 0;
    }
  };
  if (changedParams.includes("loop") && swiper.isElement) {
    if (currentParams.loop && !passedParams.loop) {
      loopNeedDestroy = true;
    } else if (!currentParams.loop && passedParams.loop) {
      loopNeedEnable = true;
    } else {
      loopNeedReloop = true;
    }
  }
  updateParams.forEach((key) => {
    if (isObject$8(currentParams[key]) && isObject$8(passedParams[key])) {
      extend(currentParams[key], passedParams[key]);
    } else {
      const newValue = passedParams[key];
      if ((newValue === true || newValue === false) && (key === "navigation" || key === "pagination" || key === "scrollbar")) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });
  if (updateParams.includes("controller") && !needControllerInit && swiper.controller && swiper.controller.control && currentParams.controller && currentParams.controller.control) {
    swiper.controller.control = currentParams.controller.control;
  }
  if (changedParams.includes("children") && slides && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  }
  if (changedParams.includes("children") && slides && currentParams.loop) {
    loopNeedReloop = true;
  }
  if (needThumbsInit) {
    const initialized = thumbs.init();
    if (initialized)
      thumbs.update(true);
  }
  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }
  if (needPaginationInit) {
    if (swiper.isElement && (!paginationEl || typeof paginationEl === "string")) {
      paginationEl = document.createElement("div");
      paginationEl.classList.add("swiper-pagination");
      swiper.el.shadowEl.appendChild(paginationEl);
    }
    if (paginationEl)
      currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }
  if (needScrollbarInit) {
    if (swiper.isElement && (!scrollbarEl || typeof scrollbarEl === "string")) {
      scrollbarEl = document.createElement("div");
      scrollbarEl.classList.add("swiper-scrollbar");
      swiper.el.shadowEl.appendChild(scrollbarEl);
    }
    if (scrollbarEl)
      currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }
  if (needNavigationInit) {
    if (swiper.isElement) {
      if (!nextEl || typeof nextEl === "string") {
        nextEl = document.createElement("div");
        nextEl.classList.add("swiper-button-next");
        swiper.el.shadowEl.appendChild(nextEl);
      }
      if (!prevEl || typeof prevEl === "string") {
        prevEl = document.createElement("div");
        prevEl.classList.add("swiper-button-prev");
        swiper.el.shadowEl.appendChild(prevEl);
      }
    }
    if (nextEl)
      currentParams.navigation.nextEl = nextEl;
    if (prevEl)
      currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }
  if (changedParams.includes("allowSlideNext")) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }
  if (changedParams.includes("allowSlidePrev")) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }
  if (changedParams.includes("direction")) {
    swiper.changeDirection(passedParams.direction, false);
  }
  if (loopNeedDestroy || loopNeedReloop) {
    swiper.loopDestroy();
  }
  if (loopNeedEnable || loopNeedReloop) {
    swiper.loopCreate();
  }
  swiper.update();
}
function renderVirtual(swiper, slides, virtualData) {
  if (!virtualData)
    return null;
  const getSlideIndex = (index) => {
    let slideIndex = index;
    if (index < 0) {
      slideIndex = slides.length + index;
    } else if (slideIndex >= slides.length) {
      slideIndex = slideIndex - slides.length;
    }
    return slideIndex;
  };
  const style = swiper.isHorizontal() ? {
    [swiper.rtlTranslate ? "right" : "left"]: `${virtualData.offset}px`
  } : {
    top: `${virtualData.offset}px`
  };
  const {
    from,
    to
  } = virtualData;
  const loopFrom = swiper.params.loop ? -slides.length : 0;
  const loopTo = swiper.params.loop ? slides.length * 2 : slides.length;
  const slidesToRender = [];
  for (let i2 = loopFrom; i2 < loopTo; i2 += 1) {
    if (i2 >= from && i2 <= to) {
      slidesToRender.push(slides[getSlideIndex(i2)]);
    }
  }
  return slidesToRender.map((child) => {
    return /* @__PURE__ */ React__default$1.cloneElement(child, {
      swiper,
      style
    });
  });
}
const updateOnVirtualData = (swiper) => {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled)
    return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();
  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
};
function useIsomorphicLayoutEffect(callback, deps) {
  if (typeof window === "undefined")
    return useEffect$1(callback, deps);
  return useLayoutEffect$1(callback, deps);
}
const SwiperSlideContext = /* @__PURE__ */ createContext(null);
const SwiperContext = /* @__PURE__ */ createContext(null);
function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$3.apply(this, arguments);
}
const Swiper2 = /* @__PURE__ */ forwardRef(function(_temp, externalElRef) {
  let {
    className,
    tag: Tag = "div",
    wrapperTag: WrapperTag = "div",
    children,
    onSwiper,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  let eventsAssigned = false;
  const [containerClasses, setContainerClasses] = useState$1("swiper");
  const [virtualData, setVirtualData] = useState$1(null);
  const [breakpointChanged, setBreakpointChanged] = useState$1(false);
  const initializedRef = useRef(false);
  const swiperElRef = useRef(null);
  const swiperRef = useRef(null);
  const oldPassedParamsRef = useRef(null);
  const oldSlides = useRef(null);
  const nextElRef = useRef(null);
  const prevElRef = useRef(null);
  const paginationElRef = useRef(null);
  const scrollbarElRef = useRef(null);
  const {
    params: swiperParams,
    passedParams,
    rest: restProps,
    events: events2
  } = getParams(rest);
  const {
    slides,
    slots
  } = getChildren(children);
  const onBeforeBreakpoint = () => {
    setBreakpointChanged(!breakpointChanged);
  };
  Object.assign(swiperParams.on, {
    _containerClasses(swiper, classes2) {
      setContainerClasses(classes2);
    }
  });
  const initSwiper = () => {
    Object.assign(swiperParams.on, events2);
    eventsAssigned = true;
    const passParams = {
      ...swiperParams
    };
    delete passParams.wrapperClass;
    swiperRef.current = new Swiper$1(passParams);
    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      const extendWith = {
        cache: false,
        slides,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      extend(swiperRef.current.params.virtual, extendWith);
      extend(swiperRef.current.originalParams.virtual, extendWith);
    }
  };
  if (!swiperElRef.current) {
    initSwiper();
  }
  if (swiperRef.current) {
    swiperRef.current.on("_beforeBreakpoint", onBeforeBreakpoint);
  }
  const attachEvents2 = () => {
    if (eventsAssigned || !events2 || !swiperRef.current)
      return;
    Object.keys(events2).forEach((eventName) => {
      swiperRef.current.on(eventName, events2[eventName]);
    });
  };
  const detachEvents2 = () => {
    if (!events2 || !swiperRef.current)
      return;
    Object.keys(events2).forEach((eventName) => {
      swiperRef.current.off(eventName, events2[eventName]);
    });
  };
  useEffect$1(() => {
    return () => {
      if (swiperRef.current)
        swiperRef.current.off("_beforeBreakpoint", onBeforeBreakpoint);
    };
  });
  useEffect$1(() => {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  });
  useIsomorphicLayoutEffect(() => {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }
    if (!swiperElRef.current)
      return;
    if (swiperRef.current.destroyed) {
      initSwiper();
    }
    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper)
      onSwiper(swiperRef.current);
    return () => {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []);
  useIsomorphicLayoutEffect(() => {
    attachEvents2();
    const changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current, (c2) => c2.key);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;
    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides,
        passedParams,
        changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }
    return () => {
      detachEvents2();
    };
  });
  useIsomorphicLayoutEffect(() => {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]);
  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }
    return slides.map((child, index) => {
      return /* @__PURE__ */ React__default$1.cloneElement(child, {
        swiper: swiperRef.current,
        swiperSlideIndex: index
      });
    });
  }
  return /* @__PURE__ */ React__default$1.createElement(Tag, _extends$3({
    ref: swiperElRef,
    className: uniqueClasses(`${containerClasses}${className ? ` ${className}` : ""}`)
  }, restProps), /* @__PURE__ */ React__default$1.createElement(SwiperContext.Provider, {
    value: swiperRef.current
  }, slots["container-start"], /* @__PURE__ */ React__default$1.createElement(WrapperTag, {
    className: wrapperClass(swiperParams.wrapperClass)
  }, slots["wrapper-start"], renderSlides(), slots["wrapper-end"]), needsNavigation(swiperParams) && /* @__PURE__ */ React__default$1.createElement(React__default$1.Fragment, null, /* @__PURE__ */ React__default$1.createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /* @__PURE__ */ React__default$1.createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /* @__PURE__ */ React__default$1.createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /* @__PURE__ */ React__default$1.createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), slots["container-end"]));
});
Swiper2.displayName = "Swiper";
function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
const SwiperSlide = /* @__PURE__ */ forwardRef(function(_temp, externalRef) {
  let {
    tag: Tag = "div",
    children,
    className = "",
    swiper,
    zoom,
    lazy,
    virtualIndex,
    swiperSlideIndex,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  const slideElRef = useRef(null);
  const [slideClasses, setSlideClasses] = useState$1("swiper-slide");
  const [lazyLoaded, setLazyLoaded] = useState$1(false);
  function updateClasses(_s, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }
  useIsomorphicLayoutEffect(() => {
    if (typeof swiperSlideIndex !== "undefined") {
      slideElRef.current.swiperSlideIndex = swiperSlideIndex;
    }
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }
    if (!slideElRef.current || !swiper) {
      return;
    }
    if (swiper.destroyed) {
      if (slideClasses !== "swiper-slide") {
        setSlideClasses("swiper-slide");
      }
      return;
    }
    swiper.on("_slideClass", updateClasses);
    return () => {
      if (!swiper)
        return;
      swiper.off("_slideClass", updateClasses);
    };
  });
  useIsomorphicLayoutEffect(() => {
    if (swiper && slideElRef.current && !swiper.destroyed) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  const slideData = {
    isActive: slideClasses.indexOf("swiper-slide-active") >= 0,
    isVisible: slideClasses.indexOf("swiper-slide-visible") >= 0,
    isPrev: slideClasses.indexOf("swiper-slide-prev") >= 0,
    isNext: slideClasses.indexOf("swiper-slide-next") >= 0
  };
  const renderChildren = () => {
    return typeof children === "function" ? children(slideData) : children;
  };
  const onLoad2 = () => {
    setLazyLoaded(true);
  };
  return /* @__PURE__ */ React__default$1.createElement(Tag, _extends$2({
    ref: slideElRef,
    className: uniqueClasses(`${slideClasses}${className ? ` ${className}` : ""}`),
    "data-swiper-slide-index": virtualIndex,
    onLoad: onLoad2
  }, rest), zoom && /* @__PURE__ */ React__default$1.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, /* @__PURE__ */ React__default$1.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === "number" ? zoom : void 0
  }, renderChildren(), lazy && !lazyLoaded && /* @__PURE__ */ React__default$1.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !zoom && /* @__PURE__ */ React__default$1.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, renderChildren(), lazy && !lazyLoaded && /* @__PURE__ */ React__default$1.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
SwiperSlide.displayName = "SwiperSlide";
var photoswipeExports = {};
var photoswipe$1 = {
  get exports() {
    return photoswipeExports;
  },
  set exports(v2) {
    photoswipeExports = v2;
  }
};
/*! PhotoSwipe - v4.1.3 - 2019-01-08
* http://photoswipe.com
* Copyright (c) 2019 Dmitry Semenov; */
(function(module, exports) {
  (function(root2, factory) {
    {
      module.exports = factory();
    }
  })(commonjsGlobal, function() {
    var PhotoSwipe2 = function(template, UiClass, items, options) {
      var framework = {
        features: null,
        bind: function(target, type2, listener, unbind) {
          var methodName = (unbind ? "remove" : "add") + "EventListener";
          type2 = type2.split(" ");
          for (var i2 = 0; i2 < type2.length; i2++) {
            if (type2[i2]) {
              target[methodName](type2[i2], listener, false);
            }
          }
        },
        isArray: function(obj) {
          return obj instanceof Array;
        },
        createEl: function(classes2, tag2) {
          var el = document.createElement(tag2 || "div");
          if (classes2) {
            el.className = classes2;
          }
          return el;
        },
        getScrollY: function() {
          var yOffset = window.pageYOffset;
          return yOffset !== void 0 ? yOffset : document.documentElement.scrollTop;
        },
        unbind: function(target, type2, listener) {
          framework.bind(target, type2, listener, true);
        },
        removeClass: function(el, className) {
          var reg = new RegExp("(\\s|^)" + className + "(\\s|$)");
          el.className = el.className.replace(reg, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
        },
        addClass: function(el, className) {
          if (!framework.hasClass(el, className)) {
            el.className += (el.className ? " " : "") + className;
          }
        },
        hasClass: function(el, className) {
          return el.className && new RegExp("(^|\\s)" + className + "(\\s|$)").test(el.className);
        },
        getChildByClass: function(parentEl, childClassName) {
          var node = parentEl.firstChild;
          while (node) {
            if (framework.hasClass(node, childClassName)) {
              return node;
            }
            node = node.nextSibling;
          }
        },
        arraySearch: function(array, value, key) {
          var i2 = array.length;
          while (i2--) {
            if (array[i2][key] === value) {
              return i2;
            }
          }
          return -1;
        },
        extend: function(o1, o22, preventOverwrite) {
          for (var prop in o22) {
            if (o22.hasOwnProperty(prop)) {
              if (preventOverwrite && o1.hasOwnProperty(prop)) {
                continue;
              }
              o1[prop] = o22[prop];
            }
          }
        },
        easing: {
          sine: {
            out: function(k2) {
              return Math.sin(k2 * (Math.PI / 2));
            },
            inOut: function(k2) {
              return -(Math.cos(Math.PI * k2) - 1) / 2;
            }
          },
          cubic: {
            out: function(k2) {
              return --k2 * k2 * k2 + 1;
            }
          }
          /*
          				elastic: {
          					out: function ( k ) {
          
          						var s, a = 0.1, p = 0.4;
          						if ( k === 0 ) return 0;
          						if ( k === 1 ) return 1;
          						if ( !a || a < 1 ) { a = 1; s = p / 4; }
          						else s = p * Math.asin( 1 / a ) / ( 2 * Math.PI );
          						return ( a * Math.pow( 2, - 10 * k) * Math.sin( ( k - s ) * ( 2 * Math.PI ) / p ) + 1 );
          
          					},
          				},
          				back: {
          					out: function ( k ) {
          						var s = 1.70158;
          						return --k * k * ( ( s + 1 ) * k + s ) + 1;
          					}
          				}
          			*/
        },
        /**
         * 
         * @return {object}
         * 
         * {
         *  raf : request animation frame function
         *  caf : cancel animation frame function
         *  transfrom : transform property key (with vendor), or null if not supported
         *  oldIE : IE8 or below
         * }
         * 
         */
        detectFeatures: function() {
          if (framework.features) {
            return framework.features;
          }
          var helperEl = framework.createEl(), helperStyle = helperEl.style, vendor = "", features = {};
          features.oldIE = document.all && !document.addEventListener;
          features.touch = "ontouchstart" in window;
          if (window.requestAnimationFrame) {
            features.raf = window.requestAnimationFrame;
            features.caf = window.cancelAnimationFrame;
          }
          features.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled;
          if (!features.pointerEvent) {
            var ua = navigator.userAgent;
            if (/iP(hone|od)/.test(navigator.platform)) {
              var v2 = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
              if (v2 && v2.length > 0) {
                v2 = parseInt(v2[1], 10);
                if (v2 >= 1 && v2 < 8) {
                  features.isOldIOSPhone = true;
                }
              }
            }
            var match2 = ua.match(/Android\s([0-9\.]*)/);
            var androidversion = match2 ? match2[1] : 0;
            androidversion = parseFloat(androidversion);
            if (androidversion >= 1) {
              if (androidversion < 4.4) {
                features.isOldAndroid = true;
              }
              features.androidVersion = androidversion;
            }
            features.isMobileOpera = /opera mini|opera mobi/i.test(ua);
          }
          var styleChecks = ["transform", "perspective", "animationName"], vendors = ["", "webkit", "Moz", "ms", "O"], styleCheckItem, styleName;
          for (var i2 = 0; i2 < 4; i2++) {
            vendor = vendors[i2];
            for (var a2 = 0; a2 < 3; a2++) {
              styleCheckItem = styleChecks[a2];
              styleName = vendor + (vendor ? styleCheckItem.charAt(0).toUpperCase() + styleCheckItem.slice(1) : styleCheckItem);
              if (!features[styleCheckItem] && styleName in helperStyle) {
                features[styleCheckItem] = styleName;
              }
            }
            if (vendor && !features.raf) {
              vendor = vendor.toLowerCase();
              features.raf = window[vendor + "RequestAnimationFrame"];
              if (features.raf) {
                features.caf = window[vendor + "CancelAnimationFrame"] || window[vendor + "CancelRequestAnimationFrame"];
              }
            }
          }
          if (!features.raf) {
            var lastTime = 0;
            features.raf = function(fn) {
              var currTime = new Date().getTime();
              var timeToCall = Math.max(0, 16 - (currTime - lastTime));
              var id = window.setTimeout(function() {
                fn(currTime + timeToCall);
              }, timeToCall);
              lastTime = currTime + timeToCall;
              return id;
            };
            features.caf = function(id) {
              clearTimeout(id);
            };
          }
          features.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect;
          framework.features = features;
          return features;
        }
      };
      framework.detectFeatures();
      if (framework.features.oldIE) {
        framework.bind = function(target, type2, listener, unbind) {
          type2 = type2.split(" ");
          var methodName = (unbind ? "detach" : "attach") + "Event", evName, _handleEv = function() {
            listener.handleEvent.call(listener);
          };
          for (var i2 = 0; i2 < type2.length; i2++) {
            evName = type2[i2];
            if (evName) {
              if (typeof listener === "object" && listener.handleEvent) {
                if (!unbind) {
                  listener["oldIE" + evName] = _handleEv;
                } else {
                  if (!listener["oldIE" + evName]) {
                    return false;
                  }
                }
                target[methodName]("on" + evName, listener["oldIE" + evName]);
              } else {
                target[methodName]("on" + evName, listener);
              }
            }
          }
        };
      }
      var self2 = this;
      var DOUBLE_TAP_RADIUS = 25, NUM_HOLDERS = 3;
      var _options = {
        allowPanToNext: true,
        spacing: 0.12,
        bgOpacity: 1,
        mouseUsed: false,
        loop: true,
        pinchToClose: true,
        closeOnScroll: true,
        closeOnVerticalDrag: true,
        verticalDragRange: 0.75,
        hideAnimationDuration: 333,
        showAnimationDuration: 333,
        showHideOpacity: false,
        focus: true,
        escKey: true,
        arrowKeys: true,
        mainScrollEndFriction: 0.35,
        panEndFriction: 0.35,
        isClickableElement: function(el) {
          return el.tagName === "A";
        },
        getDoubleTapZoom: function(isMouseClick, item) {
          if (isMouseClick) {
            return 1;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        maxSpreadZoom: 1.33,
        modal: true,
        // not fully implemented yet
        scaleMode: "fit"
        // TODO
      };
      framework.extend(_options, options);
      var _getEmptyPoint = function() {
        return { x: 0, y: 0 };
      };
      var _isOpen, _isDestroying, _closedByScroll, _currentItemIndex, _containerStyle, _containerShiftIndex, _currPanDist = _getEmptyPoint(), _startPanOffset = _getEmptyPoint(), _panOffset = _getEmptyPoint(), _upMoveEvents, _downEvents, _globalEventHandlers, _viewportSize = {}, _currZoomLevel, _startZoomLevel, _translatePrefix, _translateSufix, _updateSizeInterval, _itemsNeedUpdate, _currPositionIndex = 0, _offset = {}, _slideSize = _getEmptyPoint(), _itemHolders, _prevItemIndex, _indexDiff = 0, _dragStartEvent, _dragMoveEvent, _dragEndEvent, _dragCancelEvent, _transformKey, _pointerEventEnabled, _isFixedPosition = true, _likelyTouchDevice, _modules = [], _requestAF, _cancelAF, _initalClassName, _initalWindowScrollY, _oldIE, _currentWindowScrollY, _features, _windowVisibleSize = {}, _renderMaxResolution = false, _orientationChangeTimeout, _registerModule = function(name, module2) {
        framework.extend(self2, module2.publicMethods);
        _modules.push(name);
      }, _getLoopedId = function(index) {
        var numSlides = _getNumItems();
        if (index > numSlides - 1) {
          return index - numSlides;
        } else if (index < 0) {
          return numSlides + index;
        }
        return index;
      }, _listeners = {}, _listen = function(name, fn) {
        if (!_listeners[name]) {
          _listeners[name] = [];
        }
        return _listeners[name].push(fn);
      }, _shout = function(name) {
        var listeners = _listeners[name];
        if (listeners) {
          var args = Array.prototype.slice.call(arguments);
          args.shift();
          for (var i2 = 0; i2 < listeners.length; i2++) {
            listeners[i2].apply(self2, args);
          }
        }
      }, _getCurrentTime = function() {
        return new Date().getTime();
      }, _applyBgOpacity = function(opacity) {
        _bgOpacity = opacity;
        self2.bg.style.opacity = opacity * _options.bgOpacity;
      }, _applyZoomTransform = function(styleObj, x2, y2, zoom, item) {
        if (!_renderMaxResolution || item && item !== self2.currItem) {
          zoom = zoom / (item ? item.fitRatio : self2.currItem.fitRatio);
        }
        styleObj[_transformKey] = _translatePrefix + x2 + "px, " + y2 + "px" + _translateSufix + " scale(" + zoom + ")";
      }, _applyCurrentZoomPan = function(allowRenderResolution) {
        if (_currZoomElementStyle) {
          if (allowRenderResolution) {
            if (_currZoomLevel > self2.currItem.fitRatio) {
              if (!_renderMaxResolution) {
                _setImageSize(self2.currItem, false, true);
                _renderMaxResolution = true;
              }
            } else {
              if (_renderMaxResolution) {
                _setImageSize(self2.currItem);
                _renderMaxResolution = false;
              }
            }
          }
          _applyZoomTransform(_currZoomElementStyle, _panOffset.x, _panOffset.y, _currZoomLevel);
        }
      }, _applyZoomPanToItem = function(item) {
        if (item.container) {
          _applyZoomTransform(
            item.container.style,
            item.initialPosition.x,
            item.initialPosition.y,
            item.initialZoomLevel,
            item
          );
        }
      }, _setTranslateX = function(x2, elStyle) {
        elStyle[_transformKey] = _translatePrefix + x2 + "px, 0px" + _translateSufix;
      }, _moveMainScroll = function(x2, dragging) {
        if (!_options.loop && dragging) {
          var newSlideIndexOffset = _currentItemIndex + (_slideSize.x * _currPositionIndex - x2) / _slideSize.x, delta2 = Math.round(x2 - _mainScrollPos.x);
          if (newSlideIndexOffset < 0 && delta2 > 0 || newSlideIndexOffset >= _getNumItems() - 1 && delta2 < 0) {
            x2 = _mainScrollPos.x + delta2 * _options.mainScrollEndFriction;
          }
        }
        _mainScrollPos.x = x2;
        _setTranslateX(x2, _containerStyle);
      }, _calculatePanOffset = function(axis, zoomLevel) {
        var m2 = _midZoomPoint[axis] - _offset[axis];
        return _startPanOffset[axis] + _currPanDist[axis] + m2 - m2 * (zoomLevel / _startZoomLevel);
      }, _equalizePoints = function(p1, p23) {
        p1.x = p23.x;
        p1.y = p23.y;
        if (p23.id) {
          p1.id = p23.id;
        }
      }, _roundPoint = function(p3) {
        p3.x = Math.round(p3.x);
        p3.y = Math.round(p3.y);
      }, _mouseMoveTimeout = null, _onFirstMouseMove = function() {
        if (_mouseMoveTimeout) {
          framework.unbind(document, "mousemove", _onFirstMouseMove);
          framework.addClass(template, "pswp--has_mouse");
          _options.mouseUsed = true;
          _shout("mouseUsed");
        }
        _mouseMoveTimeout = setTimeout(function() {
          _mouseMoveTimeout = null;
        }, 100);
      }, _bindEvents = function() {
        framework.bind(document, "keydown", self2);
        if (_features.transform) {
          framework.bind(self2.scrollWrap, "click", self2);
        }
        if (!_options.mouseUsed) {
          framework.bind(document, "mousemove", _onFirstMouseMove);
        }
        framework.bind(window, "resize scroll orientationchange", self2);
        _shout("bindEvents");
      }, _unbindEvents = function() {
        framework.unbind(window, "resize scroll orientationchange", self2);
        framework.unbind(window, "scroll", _globalEventHandlers.scroll);
        framework.unbind(document, "keydown", self2);
        framework.unbind(document, "mousemove", _onFirstMouseMove);
        if (_features.transform) {
          framework.unbind(self2.scrollWrap, "click", self2);
        }
        if (_isDragging) {
          framework.unbind(window, _upMoveEvents, self2);
        }
        clearTimeout(_orientationChangeTimeout);
        _shout("unbindEvents");
      }, _calculatePanBounds = function(zoomLevel, update2) {
        var bounds = _calculateItemSize(self2.currItem, _viewportSize, zoomLevel);
        if (update2) {
          _currPanBounds = bounds;
        }
        return bounds;
      }, _getMinZoomLevel = function(item) {
        if (!item) {
          item = self2.currItem;
        }
        return item.initialZoomLevel;
      }, _getMaxZoomLevel = function(item) {
        if (!item) {
          item = self2.currItem;
        }
        return item.w > 0 ? _options.maxSpreadZoom : 1;
      }, _modifyDestPanOffset = function(axis, destPanBounds, destPanOffset, destZoomLevel) {
        if (destZoomLevel === self2.currItem.initialZoomLevel) {
          destPanOffset[axis] = self2.currItem.initialPosition[axis];
          return true;
        } else {
          destPanOffset[axis] = _calculatePanOffset(axis, destZoomLevel);
          if (destPanOffset[axis] > destPanBounds.min[axis]) {
            destPanOffset[axis] = destPanBounds.min[axis];
            return true;
          } else if (destPanOffset[axis] < destPanBounds.max[axis]) {
            destPanOffset[axis] = destPanBounds.max[axis];
            return true;
          }
        }
        return false;
      }, _setupTransforms = function() {
        if (_transformKey) {
          var allow3dTransform = _features.perspective && !_likelyTouchDevice;
          _translatePrefix = "translate" + (allow3dTransform ? "3d(" : "(");
          _translateSufix = _features.perspective ? ", 0px)" : ")";
          return;
        }
        _transformKey = "left";
        framework.addClass(template, "pswp--ie");
        _setTranslateX = function(x2, elStyle) {
          elStyle.left = x2 + "px";
        };
        _applyZoomPanToItem = function(item) {
          var zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio, s2 = item.container.style, w2 = zoomRatio * item.w, h2 = zoomRatio * item.h;
          s2.width = w2 + "px";
          s2.height = h2 + "px";
          s2.left = item.initialPosition.x + "px";
          s2.top = item.initialPosition.y + "px";
        };
        _applyCurrentZoomPan = function() {
          if (_currZoomElementStyle) {
            var s2 = _currZoomElementStyle, item = self2.currItem, zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio, w2 = zoomRatio * item.w, h2 = zoomRatio * item.h;
            s2.width = w2 + "px";
            s2.height = h2 + "px";
            s2.left = _panOffset.x + "px";
            s2.top = _panOffset.y + "px";
          }
        };
      }, _onKeyDown = function(e2) {
        var keydownAction = "";
        if (_options.escKey && e2.keyCode === 27) {
          keydownAction = "close";
        } else if (_options.arrowKeys) {
          if (e2.keyCode === 37) {
            keydownAction = "prev";
          } else if (e2.keyCode === 39) {
            keydownAction = "next";
          }
        }
        if (keydownAction) {
          if (!e2.ctrlKey && !e2.altKey && !e2.shiftKey && !e2.metaKey) {
            if (e2.preventDefault) {
              e2.preventDefault();
            } else {
              e2.returnValue = false;
            }
            self2[keydownAction]();
          }
        }
      }, _onGlobalClick = function(e2) {
        if (!e2) {
          return;
        }
        if (_moved || _zoomStarted || _mainScrollAnimating || _verticalDragInitiated) {
          e2.preventDefault();
          e2.stopPropagation();
        }
      }, _updatePageScrollOffset = function() {
        self2.setScrollOffset(0, framework.getScrollY());
      };
      var _animations = {}, _numAnimations = 0, _stopAnimation = function(name) {
        if (_animations[name]) {
          if (_animations[name].raf) {
            _cancelAF(_animations[name].raf);
          }
          _numAnimations--;
          delete _animations[name];
        }
      }, _registerStartAnimation = function(name) {
        if (_animations[name]) {
          _stopAnimation(name);
        }
        if (!_animations[name]) {
          _numAnimations++;
          _animations[name] = {};
        }
      }, _stopAllAnimations = function() {
        for (var prop in _animations) {
          if (_animations.hasOwnProperty(prop)) {
            _stopAnimation(prop);
          }
        }
      }, _animateProp = function(name, b, endProp, d2, easingFn, onUpdate, onComplete) {
        var startAnimTime = _getCurrentTime(), t2;
        _registerStartAnimation(name);
        var animloop = function() {
          if (_animations[name]) {
            t2 = _getCurrentTime() - startAnimTime;
            if (t2 >= d2) {
              _stopAnimation(name);
              onUpdate(endProp);
              if (onComplete) {
                onComplete();
              }
              return;
            }
            onUpdate((endProp - b) * easingFn(t2 / d2) + b);
            _animations[name].raf = _requestAF(animloop);
          }
        };
        animloop();
      };
      var publicMethods = {
        // make a few local variables and functions public
        shout: _shout,
        listen: _listen,
        viewportSize: _viewportSize,
        options: _options,
        isMainScrollAnimating: function() {
          return _mainScrollAnimating;
        },
        getZoomLevel: function() {
          return _currZoomLevel;
        },
        getCurrentIndex: function() {
          return _currentItemIndex;
        },
        isDragging: function() {
          return _isDragging;
        },
        isZooming: function() {
          return _isZooming;
        },
        setScrollOffset: function(x2, y2) {
          _offset.x = x2;
          _currentWindowScrollY = _offset.y = y2;
          _shout("updateScrollOffset", _offset);
        },
        applyZoomPan: function(zoomLevel, panX, panY, allowRenderResolution) {
          _panOffset.x = panX;
          _panOffset.y = panY;
          _currZoomLevel = zoomLevel;
          _applyCurrentZoomPan(allowRenderResolution);
        },
        init: function() {
          if (_isOpen || _isDestroying) {
            return;
          }
          var i2;
          self2.framework = framework;
          self2.template = template;
          self2.bg = framework.getChildByClass(template, "pswp__bg");
          _initalClassName = template.className;
          _isOpen = true;
          _features = framework.detectFeatures();
          _requestAF = _features.raf;
          _cancelAF = _features.caf;
          _transformKey = _features.transform;
          _oldIE = _features.oldIE;
          self2.scrollWrap = framework.getChildByClass(template, "pswp__scroll-wrap");
          self2.container = framework.getChildByClass(self2.scrollWrap, "pswp__container");
          _containerStyle = self2.container.style;
          self2.itemHolders = _itemHolders = [
            { el: self2.container.children[0], wrap: 0, index: -1 },
            { el: self2.container.children[1], wrap: 0, index: -1 },
            { el: self2.container.children[2], wrap: 0, index: -1 }
          ];
          _itemHolders[0].el.style.display = _itemHolders[2].el.style.display = "none";
          _setupTransforms();
          _globalEventHandlers = {
            resize: self2.updateSize,
            // Fixes: iOS 10.3 resize event
            // does not update scrollWrap.clientWidth instantly after resize
            // https://github.com/dimsemenov/PhotoSwipe/issues/1315
            orientationchange: function() {
              clearTimeout(_orientationChangeTimeout);
              _orientationChangeTimeout = setTimeout(function() {
                if (_viewportSize.x !== self2.scrollWrap.clientWidth) {
                  self2.updateSize();
                }
              }, 500);
            },
            scroll: _updatePageScrollOffset,
            keydown: _onKeyDown,
            click: _onGlobalClick
          };
          var oldPhone = _features.isOldIOSPhone || _features.isOldAndroid || _features.isMobileOpera;
          if (!_features.animationName || !_features.transform || oldPhone) {
            _options.showAnimationDuration = _options.hideAnimationDuration = 0;
          }
          for (i2 = 0; i2 < _modules.length; i2++) {
            self2["init" + _modules[i2]]();
          }
          if (UiClass) {
            var ui = self2.ui = new UiClass(self2, framework);
            ui.init();
          }
          _shout("firstUpdate");
          _currentItemIndex = _currentItemIndex || _options.index || 0;
          if (isNaN(_currentItemIndex) || _currentItemIndex < 0 || _currentItemIndex >= _getNumItems()) {
            _currentItemIndex = 0;
          }
          self2.currItem = _getItemAt(_currentItemIndex);
          if (_features.isOldIOSPhone || _features.isOldAndroid) {
            _isFixedPosition = false;
          }
          template.setAttribute("aria-hidden", "false");
          if (_options.modal) {
            if (!_isFixedPosition) {
              template.style.position = "absolute";
              template.style.top = framework.getScrollY() + "px";
            } else {
              template.style.position = "fixed";
            }
          }
          if (_currentWindowScrollY === void 0) {
            _shout("initialLayout");
            _currentWindowScrollY = _initalWindowScrollY = framework.getScrollY();
          }
          var rootClasses = "pswp--open ";
          if (_options.mainClass) {
            rootClasses += _options.mainClass + " ";
          }
          if (_options.showHideOpacity) {
            rootClasses += "pswp--animate_opacity ";
          }
          rootClasses += _likelyTouchDevice ? "pswp--touch" : "pswp--notouch";
          rootClasses += _features.animationName ? " pswp--css_animation" : "";
          rootClasses += _features.svg ? " pswp--svg" : "";
          framework.addClass(template, rootClasses);
          self2.updateSize();
          _containerShiftIndex = -1;
          _indexDiff = null;
          for (i2 = 0; i2 < NUM_HOLDERS; i2++) {
            _setTranslateX((i2 + _containerShiftIndex) * _slideSize.x, _itemHolders[i2].el.style);
          }
          if (!_oldIE) {
            framework.bind(self2.scrollWrap, _downEvents, self2);
          }
          _listen("initialZoomInEnd", function() {
            self2.setContent(_itemHolders[0], _currentItemIndex - 1);
            self2.setContent(_itemHolders[2], _currentItemIndex + 1);
            _itemHolders[0].el.style.display = _itemHolders[2].el.style.display = "block";
            if (_options.focus) {
              template.focus();
            }
            _bindEvents();
          });
          self2.setContent(_itemHolders[1], _currentItemIndex);
          self2.updateCurrItem();
          _shout("afterInit");
          if (!_isFixedPosition) {
            _updateSizeInterval = setInterval(function() {
              if (!_numAnimations && !_isDragging && !_isZooming && _currZoomLevel === self2.currItem.initialZoomLevel) {
                self2.updateSize();
              }
            }, 1e3);
          }
          framework.addClass(template, "pswp--visible");
        },
        // Close the gallery, then destroy it
        close: function() {
          if (!_isOpen) {
            return;
          }
          _isOpen = false;
          _isDestroying = true;
          _shout("close");
          _unbindEvents();
          _showOrHide(self2.currItem, null, true, self2.destroy);
        },
        // destroys the gallery (unbinds events, cleans up intervals and timeouts to avoid memory leaks)
        destroy: function() {
          _shout("destroy");
          if (_showOrHideTimeout) {
            clearTimeout(_showOrHideTimeout);
          }
          template.setAttribute("aria-hidden", "true");
          template.className = _initalClassName;
          if (_updateSizeInterval) {
            clearInterval(_updateSizeInterval);
          }
          framework.unbind(self2.scrollWrap, _downEvents, self2);
          framework.unbind(window, "scroll", self2);
          _stopDragUpdateLoop();
          _stopAllAnimations();
          _listeners = null;
        },
        /**
         * Pan image to position
         * @param {Number} x     
         * @param {Number} y     
         * @param {Boolean} force Will ignore bounds if set to true.
         */
        panTo: function(x2, y2, force) {
          if (!force) {
            if (x2 > _currPanBounds.min.x) {
              x2 = _currPanBounds.min.x;
            } else if (x2 < _currPanBounds.max.x) {
              x2 = _currPanBounds.max.x;
            }
            if (y2 > _currPanBounds.min.y) {
              y2 = _currPanBounds.min.y;
            } else if (y2 < _currPanBounds.max.y) {
              y2 = _currPanBounds.max.y;
            }
          }
          _panOffset.x = x2;
          _panOffset.y = y2;
          _applyCurrentZoomPan();
        },
        handleEvent: function(e2) {
          e2 = e2 || window.event;
          if (_globalEventHandlers[e2.type]) {
            _globalEventHandlers[e2.type](e2);
          }
        },
        goTo: function(index) {
          index = _getLoopedId(index);
          var diff2 = index - _currentItemIndex;
          _indexDiff = diff2;
          _currentItemIndex = index;
          self2.currItem = _getItemAt(_currentItemIndex);
          _currPositionIndex -= diff2;
          _moveMainScroll(_slideSize.x * _currPositionIndex);
          _stopAllAnimations();
          _mainScrollAnimating = false;
          self2.updateCurrItem();
        },
        next: function() {
          self2.goTo(_currentItemIndex + 1);
        },
        prev: function() {
          self2.goTo(_currentItemIndex - 1);
        },
        // update current zoom/pan objects
        updateCurrZoomItem: function(emulateSetContent) {
          if (emulateSetContent) {
            _shout("beforeChange", 0);
          }
          if (_itemHolders[1].el.children.length) {
            var zoomElement = _itemHolders[1].el.children[0];
            if (framework.hasClass(zoomElement, "pswp__zoom-wrap")) {
              _currZoomElementStyle = zoomElement.style;
            } else {
              _currZoomElementStyle = null;
            }
          } else {
            _currZoomElementStyle = null;
          }
          _currPanBounds = self2.currItem.bounds;
          _startZoomLevel = _currZoomLevel = self2.currItem.initialZoomLevel;
          _panOffset.x = _currPanBounds.center.x;
          _panOffset.y = _currPanBounds.center.y;
          if (emulateSetContent) {
            _shout("afterChange");
          }
        },
        invalidateCurrItems: function() {
          _itemsNeedUpdate = true;
          for (var i2 = 0; i2 < NUM_HOLDERS; i2++) {
            if (_itemHolders[i2].item) {
              _itemHolders[i2].item.needsUpdate = true;
            }
          }
        },
        updateCurrItem: function(beforeAnimation) {
          if (_indexDiff === 0) {
            return;
          }
          var diffAbs = Math.abs(_indexDiff), tempHolder;
          if (beforeAnimation && diffAbs < 2) {
            return;
          }
          self2.currItem = _getItemAt(_currentItemIndex);
          _renderMaxResolution = false;
          _shout("beforeChange", _indexDiff);
          if (diffAbs >= NUM_HOLDERS) {
            _containerShiftIndex += _indexDiff + (_indexDiff > 0 ? -NUM_HOLDERS : NUM_HOLDERS);
            diffAbs = NUM_HOLDERS;
          }
          for (var i2 = 0; i2 < diffAbs; i2++) {
            if (_indexDiff > 0) {
              tempHolder = _itemHolders.shift();
              _itemHolders[NUM_HOLDERS - 1] = tempHolder;
              _containerShiftIndex++;
              _setTranslateX((_containerShiftIndex + 2) * _slideSize.x, tempHolder.el.style);
              self2.setContent(tempHolder, _currentItemIndex - diffAbs + i2 + 1 + 1);
            } else {
              tempHolder = _itemHolders.pop();
              _itemHolders.unshift(tempHolder);
              _containerShiftIndex--;
              _setTranslateX(_containerShiftIndex * _slideSize.x, tempHolder.el.style);
              self2.setContent(tempHolder, _currentItemIndex + diffAbs - i2 - 1 - 1);
            }
          }
          if (_currZoomElementStyle && Math.abs(_indexDiff) === 1) {
            var prevItem = _getItemAt(_prevItemIndex);
            if (prevItem.initialZoomLevel !== _currZoomLevel) {
              _calculateItemSize(prevItem, _viewportSize);
              _setImageSize(prevItem);
              _applyZoomPanToItem(prevItem);
            }
          }
          _indexDiff = 0;
          self2.updateCurrZoomItem();
          _prevItemIndex = _currentItemIndex;
          _shout("afterChange");
        },
        updateSize: function(force) {
          if (!_isFixedPosition && _options.modal) {
            var windowScrollY = framework.getScrollY();
            if (_currentWindowScrollY !== windowScrollY) {
              template.style.top = windowScrollY + "px";
              _currentWindowScrollY = windowScrollY;
            }
            if (!force && _windowVisibleSize.x === window.innerWidth && _windowVisibleSize.y === window.innerHeight) {
              return;
            }
            _windowVisibleSize.x = window.innerWidth;
            _windowVisibleSize.y = window.innerHeight;
            template.style.height = _windowVisibleSize.y + "px";
          }
          _viewportSize.x = self2.scrollWrap.clientWidth;
          _viewportSize.y = self2.scrollWrap.clientHeight;
          _updatePageScrollOffset();
          _slideSize.x = _viewportSize.x + Math.round(_viewportSize.x * _options.spacing);
          _slideSize.y = _viewportSize.y;
          _moveMainScroll(_slideSize.x * _currPositionIndex);
          _shout("beforeResize");
          if (_containerShiftIndex !== void 0) {
            var holder, item, hIndex;
            for (var i2 = 0; i2 < NUM_HOLDERS; i2++) {
              holder = _itemHolders[i2];
              _setTranslateX((i2 + _containerShiftIndex) * _slideSize.x, holder.el.style);
              hIndex = _currentItemIndex + i2 - 1;
              if (_options.loop && _getNumItems() > 2) {
                hIndex = _getLoopedId(hIndex);
              }
              item = _getItemAt(hIndex);
              if (item && (_itemsNeedUpdate || item.needsUpdate || !item.bounds)) {
                self2.cleanSlide(item);
                self2.setContent(holder, hIndex);
                if (i2 === 1) {
                  self2.currItem = item;
                  self2.updateCurrZoomItem(true);
                }
                item.needsUpdate = false;
              } else if (holder.index === -1 && hIndex >= 0) {
                self2.setContent(holder, hIndex);
              }
              if (item && item.container) {
                _calculateItemSize(item, _viewportSize);
                _setImageSize(item);
                _applyZoomPanToItem(item);
              }
            }
            _itemsNeedUpdate = false;
          }
          _startZoomLevel = _currZoomLevel = self2.currItem.initialZoomLevel;
          _currPanBounds = self2.currItem.bounds;
          if (_currPanBounds) {
            _panOffset.x = _currPanBounds.center.x;
            _panOffset.y = _currPanBounds.center.y;
            _applyCurrentZoomPan(true);
          }
          _shout("resize");
        },
        // Zoom current item to
        zoomTo: function(destZoomLevel, centerPoint, speed, easingFn, updateFn) {
          if (centerPoint) {
            _startZoomLevel = _currZoomLevel;
            _midZoomPoint.x = Math.abs(centerPoint.x) - _panOffset.x;
            _midZoomPoint.y = Math.abs(centerPoint.y) - _panOffset.y;
            _equalizePoints(_startPanOffset, _panOffset);
          }
          var destPanBounds = _calculatePanBounds(destZoomLevel, false), destPanOffset = {};
          _modifyDestPanOffset("x", destPanBounds, destPanOffset, destZoomLevel);
          _modifyDestPanOffset("y", destPanBounds, destPanOffset, destZoomLevel);
          var initialZoomLevel = _currZoomLevel;
          var initialPanOffset = {
            x: _panOffset.x,
            y: _panOffset.y
          };
          _roundPoint(destPanOffset);
          var onUpdate = function(now2) {
            if (now2 === 1) {
              _currZoomLevel = destZoomLevel;
              _panOffset.x = destPanOffset.x;
              _panOffset.y = destPanOffset.y;
            } else {
              _currZoomLevel = (destZoomLevel - initialZoomLevel) * now2 + initialZoomLevel;
              _panOffset.x = (destPanOffset.x - initialPanOffset.x) * now2 + initialPanOffset.x;
              _panOffset.y = (destPanOffset.y - initialPanOffset.y) * now2 + initialPanOffset.y;
            }
            if (updateFn) {
              updateFn(now2);
            }
            _applyCurrentZoomPan(now2 === 1);
          };
          if (speed) {
            _animateProp("customZoomTo", 0, 1, speed, easingFn || framework.easing.sine.inOut, onUpdate);
          } else {
            onUpdate(1);
          }
        }
      };
      var MIN_SWIPE_DISTANCE = 30, DIRECTION_CHECK_OFFSET = 10;
      var _gestureStartTime, _gestureCheckSpeedTime, p2 = {}, p22 = {}, delta = {}, _currPoint = {}, _startPoint = {}, _currPointers = [], _startMainScrollPos = {}, _releaseAnimData, _posPoints = [], _tempPoint = {}, _isZoomingIn, _verticalDragInitiated, _oldAndroidTouchEndTimeout, _currZoomedItemIndex = 0, _centerPoint = _getEmptyPoint(), _lastReleaseTime = 0, _isDragging, _isMultitouch, _zoomStarted, _moved, _dragAnimFrame, _mainScrollShifted, _currentPoints, _isZooming, _startPointsDistance, _currPanBounds, _mainScrollPos = _getEmptyPoint(), _currZoomElementStyle, _mainScrollAnimating, _midZoomPoint = _getEmptyPoint(), _currCenterPoint = _getEmptyPoint(), _direction, _isFirstMove, _opacityChanged, _bgOpacity, _wasOverInitialZoom, _isEqualPoints = function(p1, p23) {
        return p1.x === p23.x && p1.y === p23.y;
      }, _isNearbyPoints = function(touch0, touch1) {
        return Math.abs(touch0.x - touch1.x) < DOUBLE_TAP_RADIUS && Math.abs(touch0.y - touch1.y) < DOUBLE_TAP_RADIUS;
      }, _calculatePointsDistance = function(p1, p23) {
        _tempPoint.x = Math.abs(p1.x - p23.x);
        _tempPoint.y = Math.abs(p1.y - p23.y);
        return Math.sqrt(_tempPoint.x * _tempPoint.x + _tempPoint.y * _tempPoint.y);
      }, _stopDragUpdateLoop = function() {
        if (_dragAnimFrame) {
          _cancelAF(_dragAnimFrame);
          _dragAnimFrame = null;
        }
      }, _dragUpdateLoop = function() {
        if (_isDragging) {
          _dragAnimFrame = _requestAF(_dragUpdateLoop);
          _renderMovement();
        }
      }, _canPan = function() {
        return !(_options.scaleMode === "fit" && _currZoomLevel === self2.currItem.initialZoomLevel);
      }, _closestElement = function(el, fn) {
        if (!el || el === document) {
          return false;
        }
        if (el.getAttribute("class") && el.getAttribute("class").indexOf("pswp__scroll-wrap") > -1) {
          return false;
        }
        if (fn(el)) {
          return el;
        }
        return _closestElement(el.parentNode, fn);
      }, _preventObj = {}, _preventDefaultEventBehaviour = function(e2, isDown) {
        _preventObj.prevent = !_closestElement(e2.target, _options.isClickableElement);
        _shout("preventDragEvent", e2, isDown, _preventObj);
        return _preventObj.prevent;
      }, _convertTouchToPoint = function(touch, p3) {
        p3.x = touch.pageX;
        p3.y = touch.pageY;
        p3.id = touch.identifier;
        return p3;
      }, _findCenterOfPoints = function(p1, p23, pCenter) {
        pCenter.x = (p1.x + p23.x) * 0.5;
        pCenter.y = (p1.y + p23.y) * 0.5;
      }, _pushPosPoint = function(time, x2, y2) {
        if (time - _gestureCheckSpeedTime > 50) {
          var o3 = _posPoints.length > 2 ? _posPoints.shift() : {};
          o3.x = x2;
          o3.y = y2;
          _posPoints.push(o3);
          _gestureCheckSpeedTime = time;
        }
      }, _calculateVerticalDragOpacityRatio = function() {
        var yOffset = _panOffset.y - self2.currItem.initialPosition.y;
        return 1 - Math.abs(yOffset / (_viewportSize.y / 2));
      }, _ePoint1 = {}, _ePoint2 = {}, _tempPointsArr = [], _tempCounter, _getTouchPoints = function(e2) {
        while (_tempPointsArr.length > 0) {
          _tempPointsArr.pop();
        }
        if (!_pointerEventEnabled) {
          if (e2.type.indexOf("touch") > -1) {
            if (e2.touches && e2.touches.length > 0) {
              _tempPointsArr[0] = _convertTouchToPoint(e2.touches[0], _ePoint1);
              if (e2.touches.length > 1) {
                _tempPointsArr[1] = _convertTouchToPoint(e2.touches[1], _ePoint2);
              }
            }
          } else {
            _ePoint1.x = e2.pageX;
            _ePoint1.y = e2.pageY;
            _ePoint1.id = "";
            _tempPointsArr[0] = _ePoint1;
          }
        } else {
          _tempCounter = 0;
          _currPointers.forEach(function(p3) {
            if (_tempCounter === 0) {
              _tempPointsArr[0] = p3;
            } else if (_tempCounter === 1) {
              _tempPointsArr[1] = p3;
            }
            _tempCounter++;
          });
        }
        return _tempPointsArr;
      }, _panOrMoveMainScroll = function(axis, delta2) {
        var panFriction, newOffset = _panOffset[axis] + delta2[axis], startOverDiff, dir = delta2[axis] > 0, newMainScrollPosition = _mainScrollPos.x + delta2.x, mainScrollDiff = _mainScrollPos.x - _startMainScrollPos.x, newPanPos, newMainScrollPos;
        if (newOffset > _currPanBounds.min[axis] || newOffset < _currPanBounds.max[axis]) {
          panFriction = _options.panEndFriction;
        } else {
          panFriction = 1;
        }
        newOffset = _panOffset[axis] + delta2[axis] * panFriction;
        if (_options.allowPanToNext || _currZoomLevel === self2.currItem.initialZoomLevel) {
          if (!_currZoomElementStyle) {
            newMainScrollPos = newMainScrollPosition;
          } else if (_direction === "h" && axis === "x" && !_zoomStarted) {
            if (dir) {
              if (newOffset > _currPanBounds.min[axis]) {
                panFriction = _options.panEndFriction;
                _currPanBounds.min[axis] - newOffset;
                startOverDiff = _currPanBounds.min[axis] - _startPanOffset[axis];
              }
              if ((startOverDiff <= 0 || mainScrollDiff < 0) && _getNumItems() > 1) {
                newMainScrollPos = newMainScrollPosition;
                if (mainScrollDiff < 0 && newMainScrollPosition > _startMainScrollPos.x) {
                  newMainScrollPos = _startMainScrollPos.x;
                }
              } else {
                if (_currPanBounds.min.x !== _currPanBounds.max.x) {
                  newPanPos = newOffset;
                }
              }
            } else {
              if (newOffset < _currPanBounds.max[axis]) {
                panFriction = _options.panEndFriction;
                newOffset - _currPanBounds.max[axis];
                startOverDiff = _startPanOffset[axis] - _currPanBounds.max[axis];
              }
              if ((startOverDiff <= 0 || mainScrollDiff > 0) && _getNumItems() > 1) {
                newMainScrollPos = newMainScrollPosition;
                if (mainScrollDiff > 0 && newMainScrollPosition < _startMainScrollPos.x) {
                  newMainScrollPos = _startMainScrollPos.x;
                }
              } else {
                if (_currPanBounds.min.x !== _currPanBounds.max.x) {
                  newPanPos = newOffset;
                }
              }
            }
          }
          if (axis === "x") {
            if (newMainScrollPos !== void 0) {
              _moveMainScroll(newMainScrollPos, true);
              if (newMainScrollPos === _startMainScrollPos.x) {
                _mainScrollShifted = false;
              } else {
                _mainScrollShifted = true;
              }
            }
            if (_currPanBounds.min.x !== _currPanBounds.max.x) {
              if (newPanPos !== void 0) {
                _panOffset.x = newPanPos;
              } else if (!_mainScrollShifted) {
                _panOffset.x += delta2.x * panFriction;
              }
            }
            return newMainScrollPos !== void 0;
          }
        }
        if (!_mainScrollAnimating) {
          if (!_mainScrollShifted) {
            if (_currZoomLevel > self2.currItem.fitRatio) {
              _panOffset[axis] += delta2[axis] * panFriction;
            }
          }
        }
      }, _onDragStart = function(e2) {
        if (e2.type === "mousedown" && e2.button > 0) {
          return;
        }
        if (_initialZoomRunning) {
          e2.preventDefault();
          return;
        }
        if (_oldAndroidTouchEndTimeout && e2.type === "mousedown") {
          return;
        }
        if (_preventDefaultEventBehaviour(e2, true)) {
          e2.preventDefault();
        }
        _shout("pointerDown");
        if (_pointerEventEnabled) {
          var pointerIndex = framework.arraySearch(_currPointers, e2.pointerId, "id");
          if (pointerIndex < 0) {
            pointerIndex = _currPointers.length;
          }
          _currPointers[pointerIndex] = { x: e2.pageX, y: e2.pageY, id: e2.pointerId };
        }
        var startPointsList = _getTouchPoints(e2), numPoints = startPointsList.length;
        _currentPoints = null;
        _stopAllAnimations();
        if (!_isDragging || numPoints === 1) {
          _isDragging = _isFirstMove = true;
          framework.bind(window, _upMoveEvents, self2);
          _isZoomingIn = _wasOverInitialZoom = _opacityChanged = _verticalDragInitiated = _mainScrollShifted = _moved = _isMultitouch = _zoomStarted = false;
          _direction = null;
          _shout("firstTouchStart", startPointsList);
          _equalizePoints(_startPanOffset, _panOffset);
          _currPanDist.x = _currPanDist.y = 0;
          _equalizePoints(_currPoint, startPointsList[0]);
          _equalizePoints(_startPoint, _currPoint);
          _startMainScrollPos.x = _slideSize.x * _currPositionIndex;
          _posPoints = [{
            x: _currPoint.x,
            y: _currPoint.y
          }];
          _gestureCheckSpeedTime = _gestureStartTime = _getCurrentTime();
          _calculatePanBounds(_currZoomLevel, true);
          _stopDragUpdateLoop();
          _dragUpdateLoop();
        }
        if (!_isZooming && numPoints > 1 && !_mainScrollAnimating && !_mainScrollShifted) {
          _startZoomLevel = _currZoomLevel;
          _zoomStarted = false;
          _isZooming = _isMultitouch = true;
          _currPanDist.y = _currPanDist.x = 0;
          _equalizePoints(_startPanOffset, _panOffset);
          _equalizePoints(p2, startPointsList[0]);
          _equalizePoints(p22, startPointsList[1]);
          _findCenterOfPoints(p2, p22, _currCenterPoint);
          _midZoomPoint.x = Math.abs(_currCenterPoint.x) - _panOffset.x;
          _midZoomPoint.y = Math.abs(_currCenterPoint.y) - _panOffset.y;
          _startPointsDistance = _calculatePointsDistance(p2, p22);
        }
      }, _onDragMove = function(e2) {
        e2.preventDefault();
        if (_pointerEventEnabled) {
          var pointerIndex = framework.arraySearch(_currPointers, e2.pointerId, "id");
          if (pointerIndex > -1) {
            var p3 = _currPointers[pointerIndex];
            p3.x = e2.pageX;
            p3.y = e2.pageY;
          }
        }
        if (_isDragging) {
          var touchesList = _getTouchPoints(e2);
          if (!_direction && !_moved && !_isZooming) {
            if (_mainScrollPos.x !== _slideSize.x * _currPositionIndex) {
              _direction = "h";
            } else {
              var diff2 = Math.abs(touchesList[0].x - _currPoint.x) - Math.abs(touchesList[0].y - _currPoint.y);
              if (Math.abs(diff2) >= DIRECTION_CHECK_OFFSET) {
                _direction = diff2 > 0 ? "h" : "v";
                _currentPoints = touchesList;
              }
            }
          } else {
            _currentPoints = touchesList;
          }
        }
      }, _renderMovement = function() {
        if (!_currentPoints) {
          return;
        }
        var numPoints = _currentPoints.length;
        if (numPoints === 0) {
          return;
        }
        _equalizePoints(p2, _currentPoints[0]);
        delta.x = p2.x - _currPoint.x;
        delta.y = p2.y - _currPoint.y;
        if (_isZooming && numPoints > 1) {
          _currPoint.x = p2.x;
          _currPoint.y = p2.y;
          if (!delta.x && !delta.y && _isEqualPoints(_currentPoints[1], p22)) {
            return;
          }
          _equalizePoints(p22, _currentPoints[1]);
          if (!_zoomStarted) {
            _zoomStarted = true;
            _shout("zoomGestureStarted");
          }
          var pointsDistance = _calculatePointsDistance(p2, p22);
          var zoomLevel = _calculateZoomLevel(pointsDistance);
          if (zoomLevel > self2.currItem.initialZoomLevel + self2.currItem.initialZoomLevel / 15) {
            _wasOverInitialZoom = true;
          }
          var zoomFriction = 1, minZoomLevel = _getMinZoomLevel(), maxZoomLevel = _getMaxZoomLevel();
          if (zoomLevel < minZoomLevel) {
            if (_options.pinchToClose && !_wasOverInitialZoom && _startZoomLevel <= self2.currItem.initialZoomLevel) {
              var minusDiff = minZoomLevel - zoomLevel;
              var percent = 1 - minusDiff / (minZoomLevel / 1.2);
              _applyBgOpacity(percent);
              _shout("onPinchClose", percent);
              _opacityChanged = true;
            } else {
              zoomFriction = (minZoomLevel - zoomLevel) / minZoomLevel;
              if (zoomFriction > 1) {
                zoomFriction = 1;
              }
              zoomLevel = minZoomLevel - zoomFriction * (minZoomLevel / 3);
            }
          } else if (zoomLevel > maxZoomLevel) {
            zoomFriction = (zoomLevel - maxZoomLevel) / (minZoomLevel * 6);
            if (zoomFriction > 1) {
              zoomFriction = 1;
            }
            zoomLevel = maxZoomLevel + zoomFriction * minZoomLevel;
          }
          if (zoomFriction < 0) {
            zoomFriction = 0;
          }
          _findCenterOfPoints(p2, p22, _centerPoint);
          _currPanDist.x += _centerPoint.x - _currCenterPoint.x;
          _currPanDist.y += _centerPoint.y - _currCenterPoint.y;
          _equalizePoints(_currCenterPoint, _centerPoint);
          _panOffset.x = _calculatePanOffset("x", zoomLevel);
          _panOffset.y = _calculatePanOffset("y", zoomLevel);
          _isZoomingIn = zoomLevel > _currZoomLevel;
          _currZoomLevel = zoomLevel;
          _applyCurrentZoomPan();
        } else {
          if (!_direction) {
            return;
          }
          if (_isFirstMove) {
            _isFirstMove = false;
            if (Math.abs(delta.x) >= DIRECTION_CHECK_OFFSET) {
              delta.x -= _currentPoints[0].x - _startPoint.x;
            }
            if (Math.abs(delta.y) >= DIRECTION_CHECK_OFFSET) {
              delta.y -= _currentPoints[0].y - _startPoint.y;
            }
          }
          _currPoint.x = p2.x;
          _currPoint.y = p2.y;
          if (delta.x === 0 && delta.y === 0) {
            return;
          }
          if (_direction === "v" && _options.closeOnVerticalDrag) {
            if (!_canPan()) {
              _currPanDist.y += delta.y;
              _panOffset.y += delta.y;
              var opacityRatio = _calculateVerticalDragOpacityRatio();
              _verticalDragInitiated = true;
              _shout("onVerticalDrag", opacityRatio);
              _applyBgOpacity(opacityRatio);
              _applyCurrentZoomPan();
              return;
            }
          }
          _pushPosPoint(_getCurrentTime(), p2.x, p2.y);
          _moved = true;
          _currPanBounds = self2.currItem.bounds;
          var mainScrollChanged = _panOrMoveMainScroll("x", delta);
          if (!mainScrollChanged) {
            _panOrMoveMainScroll("y", delta);
            _roundPoint(_panOffset);
            _applyCurrentZoomPan();
          }
        }
      }, _onDragRelease = function(e2) {
        if (_features.isOldAndroid) {
          if (_oldAndroidTouchEndTimeout && e2.type === "mouseup") {
            return;
          }
          if (e2.type.indexOf("touch") > -1) {
            clearTimeout(_oldAndroidTouchEndTimeout);
            _oldAndroidTouchEndTimeout = setTimeout(function() {
              _oldAndroidTouchEndTimeout = 0;
            }, 600);
          }
        }
        _shout("pointerUp");
        if (_preventDefaultEventBehaviour(e2, false)) {
          e2.preventDefault();
        }
        var releasePoint;
        if (_pointerEventEnabled) {
          var pointerIndex = framework.arraySearch(_currPointers, e2.pointerId, "id");
          if (pointerIndex > -1) {
            releasePoint = _currPointers.splice(pointerIndex, 1)[0];
            if (navigator.msPointerEnabled) {
              var MSPOINTER_TYPES = {
                4: "mouse",
                // event.MSPOINTER_TYPE_MOUSE
                2: "touch",
                // event.MSPOINTER_TYPE_TOUCH 
                3: "pen"
                // event.MSPOINTER_TYPE_PEN
              };
              releasePoint.type = MSPOINTER_TYPES[e2.pointerType];
              if (!releasePoint.type) {
                releasePoint.type = e2.pointerType || "mouse";
              }
            } else {
              releasePoint.type = e2.pointerType || "mouse";
            }
          }
        }
        var touchList = _getTouchPoints(e2), gestureType, numPoints = touchList.length;
        if (e2.type === "mouseup") {
          numPoints = 0;
        }
        if (numPoints === 2) {
          _currentPoints = null;
          return true;
        }
        if (numPoints === 1) {
          _equalizePoints(_startPoint, touchList[0]);
        }
        if (numPoints === 0 && !_direction && !_mainScrollAnimating) {
          if (!releasePoint) {
            if (e2.type === "mouseup") {
              releasePoint = { x: e2.pageX, y: e2.pageY, type: "mouse" };
            } else if (e2.changedTouches && e2.changedTouches[0]) {
              releasePoint = { x: e2.changedTouches[0].pageX, y: e2.changedTouches[0].pageY, type: "touch" };
            }
          }
          _shout("touchRelease", e2, releasePoint);
        }
        var releaseTimeDiff = -1;
        if (numPoints === 0) {
          _isDragging = false;
          framework.unbind(window, _upMoveEvents, self2);
          _stopDragUpdateLoop();
          if (_isZooming) {
            releaseTimeDiff = 0;
          } else if (_lastReleaseTime !== -1) {
            releaseTimeDiff = _getCurrentTime() - _lastReleaseTime;
          }
        }
        _lastReleaseTime = numPoints === 1 ? _getCurrentTime() : -1;
        if (releaseTimeDiff !== -1 && releaseTimeDiff < 150) {
          gestureType = "zoom";
        } else {
          gestureType = "swipe";
        }
        if (_isZooming && numPoints < 2) {
          _isZooming = false;
          if (numPoints === 1) {
            gestureType = "zoomPointerUp";
          }
          _shout("zoomGestureEnded");
        }
        _currentPoints = null;
        if (!_moved && !_zoomStarted && !_mainScrollAnimating && !_verticalDragInitiated) {
          return;
        }
        _stopAllAnimations();
        if (!_releaseAnimData) {
          _releaseAnimData = _initDragReleaseAnimationData();
        }
        _releaseAnimData.calculateSwipeSpeed("x");
        if (_verticalDragInitiated) {
          var opacityRatio = _calculateVerticalDragOpacityRatio();
          if (opacityRatio < _options.verticalDragRange) {
            self2.close();
          } else {
            var initalPanY = _panOffset.y, initialBgOpacity = _bgOpacity;
            _animateProp("verticalDrag", 0, 1, 300, framework.easing.cubic.out, function(now2) {
              _panOffset.y = (self2.currItem.initialPosition.y - initalPanY) * now2 + initalPanY;
              _applyBgOpacity((1 - initialBgOpacity) * now2 + initialBgOpacity);
              _applyCurrentZoomPan();
            });
            _shout("onVerticalDrag", 1);
          }
          return;
        }
        if ((_mainScrollShifted || _mainScrollAnimating) && numPoints === 0) {
          var itemChanged = _finishSwipeMainScrollGesture(gestureType, _releaseAnimData);
          if (itemChanged) {
            return;
          }
          gestureType = "zoomPointerUp";
        }
        if (_mainScrollAnimating) {
          return;
        }
        if (gestureType !== "swipe") {
          _completeZoomGesture();
          return;
        }
        if (!_mainScrollShifted && _currZoomLevel > self2.currItem.fitRatio) {
          _completePanGesture(_releaseAnimData);
        }
      }, _initDragReleaseAnimationData = function() {
        var lastFlickDuration, tempReleasePos;
        var s2 = {
          lastFlickOffset: {},
          lastFlickDist: {},
          lastFlickSpeed: {},
          slowDownRatio: {},
          slowDownRatioReverse: {},
          speedDecelerationRatio: {},
          speedDecelerationRatioAbs: {},
          distanceOffset: {},
          backAnimDestination: {},
          backAnimStarted: {},
          calculateSwipeSpeed: function(axis) {
            if (_posPoints.length > 1) {
              lastFlickDuration = _getCurrentTime() - _gestureCheckSpeedTime + 50;
              tempReleasePos = _posPoints[_posPoints.length - 2][axis];
            } else {
              lastFlickDuration = _getCurrentTime() - _gestureStartTime;
              tempReleasePos = _startPoint[axis];
            }
            s2.lastFlickOffset[axis] = _currPoint[axis] - tempReleasePos;
            s2.lastFlickDist[axis] = Math.abs(s2.lastFlickOffset[axis]);
            if (s2.lastFlickDist[axis] > 20) {
              s2.lastFlickSpeed[axis] = s2.lastFlickOffset[axis] / lastFlickDuration;
            } else {
              s2.lastFlickSpeed[axis] = 0;
            }
            if (Math.abs(s2.lastFlickSpeed[axis]) < 0.1) {
              s2.lastFlickSpeed[axis] = 0;
            }
            s2.slowDownRatio[axis] = 0.95;
            s2.slowDownRatioReverse[axis] = 1 - s2.slowDownRatio[axis];
            s2.speedDecelerationRatio[axis] = 1;
          },
          calculateOverBoundsAnimOffset: function(axis, speed) {
            if (!s2.backAnimStarted[axis]) {
              if (_panOffset[axis] > _currPanBounds.min[axis]) {
                s2.backAnimDestination[axis] = _currPanBounds.min[axis];
              } else if (_panOffset[axis] < _currPanBounds.max[axis]) {
                s2.backAnimDestination[axis] = _currPanBounds.max[axis];
              }
              if (s2.backAnimDestination[axis] !== void 0) {
                s2.slowDownRatio[axis] = 0.7;
                s2.slowDownRatioReverse[axis] = 1 - s2.slowDownRatio[axis];
                if (s2.speedDecelerationRatioAbs[axis] < 0.05) {
                  s2.lastFlickSpeed[axis] = 0;
                  s2.backAnimStarted[axis] = true;
                  _animateProp(
                    "bounceZoomPan" + axis,
                    _panOffset[axis],
                    s2.backAnimDestination[axis],
                    speed || 300,
                    framework.easing.sine.out,
                    function(pos) {
                      _panOffset[axis] = pos;
                      _applyCurrentZoomPan();
                    }
                  );
                }
              }
            }
          },
          // Reduces the speed by slowDownRatio (per 10ms)
          calculateAnimOffset: function(axis) {
            if (!s2.backAnimStarted[axis]) {
              s2.speedDecelerationRatio[axis] = s2.speedDecelerationRatio[axis] * (s2.slowDownRatio[axis] + s2.slowDownRatioReverse[axis] - s2.slowDownRatioReverse[axis] * s2.timeDiff / 10);
              s2.speedDecelerationRatioAbs[axis] = Math.abs(s2.lastFlickSpeed[axis] * s2.speedDecelerationRatio[axis]);
              s2.distanceOffset[axis] = s2.lastFlickSpeed[axis] * s2.speedDecelerationRatio[axis] * s2.timeDiff;
              _panOffset[axis] += s2.distanceOffset[axis];
            }
          },
          panAnimLoop: function() {
            if (_animations.zoomPan) {
              _animations.zoomPan.raf = _requestAF(s2.panAnimLoop);
              s2.now = _getCurrentTime();
              s2.timeDiff = s2.now - s2.lastNow;
              s2.lastNow = s2.now;
              s2.calculateAnimOffset("x");
              s2.calculateAnimOffset("y");
              _applyCurrentZoomPan();
              s2.calculateOverBoundsAnimOffset("x");
              s2.calculateOverBoundsAnimOffset("y");
              if (s2.speedDecelerationRatioAbs.x < 0.05 && s2.speedDecelerationRatioAbs.y < 0.05) {
                _panOffset.x = Math.round(_panOffset.x);
                _panOffset.y = Math.round(_panOffset.y);
                _applyCurrentZoomPan();
                _stopAnimation("zoomPan");
                return;
              }
            }
          }
        };
        return s2;
      }, _completePanGesture = function(animData) {
        animData.calculateSwipeSpeed("y");
        _currPanBounds = self2.currItem.bounds;
        animData.backAnimDestination = {};
        animData.backAnimStarted = {};
        if (Math.abs(animData.lastFlickSpeed.x) <= 0.05 && Math.abs(animData.lastFlickSpeed.y) <= 0.05) {
          animData.speedDecelerationRatioAbs.x = animData.speedDecelerationRatioAbs.y = 0;
          animData.calculateOverBoundsAnimOffset("x");
          animData.calculateOverBoundsAnimOffset("y");
          return true;
        }
        _registerStartAnimation("zoomPan");
        animData.lastNow = _getCurrentTime();
        animData.panAnimLoop();
      }, _finishSwipeMainScrollGesture = function(gestureType, _releaseAnimData2) {
        var itemChanged;
        if (!_mainScrollAnimating) {
          _currZoomedItemIndex = _currentItemIndex;
        }
        var itemsDiff;
        if (gestureType === "swipe") {
          var totalShiftDist = _currPoint.x - _startPoint.x, isFastLastFlick = _releaseAnimData2.lastFlickDist.x < 10;
          if (totalShiftDist > MIN_SWIPE_DISTANCE && (isFastLastFlick || _releaseAnimData2.lastFlickOffset.x > 20)) {
            itemsDiff = -1;
          } else if (totalShiftDist < -MIN_SWIPE_DISTANCE && (isFastLastFlick || _releaseAnimData2.lastFlickOffset.x < -20)) {
            itemsDiff = 1;
          }
        }
        var nextCircle;
        if (itemsDiff) {
          _currentItemIndex += itemsDiff;
          if (_currentItemIndex < 0) {
            _currentItemIndex = _options.loop ? _getNumItems() - 1 : 0;
            nextCircle = true;
          } else if (_currentItemIndex >= _getNumItems()) {
            _currentItemIndex = _options.loop ? 0 : _getNumItems() - 1;
            nextCircle = true;
          }
          if (!nextCircle || _options.loop) {
            _indexDiff += itemsDiff;
            _currPositionIndex -= itemsDiff;
            itemChanged = true;
          }
        }
        var animateToX = _slideSize.x * _currPositionIndex;
        var animateToDist = Math.abs(animateToX - _mainScrollPos.x);
        var finishAnimDuration;
        if (!itemChanged && animateToX > _mainScrollPos.x !== _releaseAnimData2.lastFlickSpeed.x > 0) {
          finishAnimDuration = 333;
        } else {
          finishAnimDuration = Math.abs(_releaseAnimData2.lastFlickSpeed.x) > 0 ? animateToDist / Math.abs(_releaseAnimData2.lastFlickSpeed.x) : 333;
          finishAnimDuration = Math.min(finishAnimDuration, 400);
          finishAnimDuration = Math.max(finishAnimDuration, 250);
        }
        if (_currZoomedItemIndex === _currentItemIndex) {
          itemChanged = false;
        }
        _mainScrollAnimating = true;
        _shout("mainScrollAnimStart");
        _animateProp(
          "mainScroll",
          _mainScrollPos.x,
          animateToX,
          finishAnimDuration,
          framework.easing.cubic.out,
          _moveMainScroll,
          function() {
            _stopAllAnimations();
            _mainScrollAnimating = false;
            _currZoomedItemIndex = -1;
            if (itemChanged || _currZoomedItemIndex !== _currentItemIndex) {
              self2.updateCurrItem();
            }
            _shout("mainScrollAnimComplete");
          }
        );
        if (itemChanged) {
          self2.updateCurrItem(true);
        }
        return itemChanged;
      }, _calculateZoomLevel = function(touchesDistance) {
        return 1 / _startPointsDistance * touchesDistance * _startZoomLevel;
      }, _completeZoomGesture = function() {
        var destZoomLevel = _currZoomLevel, minZoomLevel = _getMinZoomLevel(), maxZoomLevel = _getMaxZoomLevel();
        if (_currZoomLevel < minZoomLevel) {
          destZoomLevel = minZoomLevel;
        } else if (_currZoomLevel > maxZoomLevel) {
          destZoomLevel = maxZoomLevel;
        }
        var destOpacity = 1, onUpdate, initialOpacity = _bgOpacity;
        if (_opacityChanged && !_isZoomingIn && !_wasOverInitialZoom && _currZoomLevel < minZoomLevel) {
          self2.close();
          return true;
        }
        if (_opacityChanged) {
          onUpdate = function(now2) {
            _applyBgOpacity((destOpacity - initialOpacity) * now2 + initialOpacity);
          };
        }
        self2.zoomTo(destZoomLevel, 0, 200, framework.easing.cubic.out, onUpdate);
        return true;
      };
      _registerModule("Gestures", {
        publicMethods: {
          initGestures: function() {
            var addEventNames = function(pref, down, move, up, cancel) {
              _dragStartEvent = pref + down;
              _dragMoveEvent = pref + move;
              _dragEndEvent = pref + up;
              if (cancel) {
                _dragCancelEvent = pref + cancel;
              } else {
                _dragCancelEvent = "";
              }
            };
            _pointerEventEnabled = _features.pointerEvent;
            if (_pointerEventEnabled && _features.touch) {
              _features.touch = false;
            }
            if (_pointerEventEnabled) {
              if (navigator.msPointerEnabled) {
                addEventNames("MSPointer", "Down", "Move", "Up", "Cancel");
              } else {
                addEventNames("pointer", "down", "move", "up", "cancel");
              }
            } else if (_features.touch) {
              addEventNames("touch", "start", "move", "end", "cancel");
              _likelyTouchDevice = true;
            } else {
              addEventNames("mouse", "down", "move", "up");
            }
            _upMoveEvents = _dragMoveEvent + " " + _dragEndEvent + " " + _dragCancelEvent;
            _downEvents = _dragStartEvent;
            if (_pointerEventEnabled && !_likelyTouchDevice) {
              _likelyTouchDevice = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1;
            }
            self2.likelyTouchDevice = _likelyTouchDevice;
            _globalEventHandlers[_dragStartEvent] = _onDragStart;
            _globalEventHandlers[_dragMoveEvent] = _onDragMove;
            _globalEventHandlers[_dragEndEvent] = _onDragRelease;
            if (_dragCancelEvent) {
              _globalEventHandlers[_dragCancelEvent] = _globalEventHandlers[_dragEndEvent];
            }
            if (_features.touch) {
              _downEvents += " mousedown";
              _upMoveEvents += " mousemove mouseup";
              _globalEventHandlers.mousedown = _globalEventHandlers[_dragStartEvent];
              _globalEventHandlers.mousemove = _globalEventHandlers[_dragMoveEvent];
              _globalEventHandlers.mouseup = _globalEventHandlers[_dragEndEvent];
            }
            if (!_likelyTouchDevice) {
              _options.allowPanToNext = false;
            }
          }
        }
      });
      var _showOrHideTimeout, _showOrHide = function(item, img, out, completeFn) {
        if (_showOrHideTimeout) {
          clearTimeout(_showOrHideTimeout);
        }
        _initialZoomRunning = true;
        _initialContentSet = true;
        var thumbBounds;
        if (item.initialLayout) {
          thumbBounds = item.initialLayout;
          item.initialLayout = null;
        } else {
          thumbBounds = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
        }
        var duration = out ? _options.hideAnimationDuration : _options.showAnimationDuration;
        var onComplete = function() {
          _stopAnimation("initialZoom");
          if (!out) {
            _applyBgOpacity(1);
            if (img) {
              img.style.display = "block";
            }
            framework.addClass(template, "pswp--animated-in");
            _shout("initialZoom" + (out ? "OutEnd" : "InEnd"));
          } else {
            self2.template.removeAttribute("style");
            self2.bg.removeAttribute("style");
          }
          if (completeFn) {
            completeFn();
          }
          _initialZoomRunning = false;
        };
        if (!duration || !thumbBounds || thumbBounds.x === void 0) {
          _shout("initialZoom" + (out ? "Out" : "In"));
          _currZoomLevel = item.initialZoomLevel;
          _equalizePoints(_panOffset, item.initialPosition);
          _applyCurrentZoomPan();
          template.style.opacity = out ? 0 : 1;
          _applyBgOpacity(1);
          if (duration) {
            setTimeout(function() {
              onComplete();
            }, duration);
          } else {
            onComplete();
          }
          return;
        }
        var startAnimation = function() {
          var closeWithRaf = _closedByScroll, fadeEverything = !self2.currItem.src || self2.currItem.loadError || _options.showHideOpacity;
          if (item.miniImg) {
            item.miniImg.style.webkitBackfaceVisibility = "hidden";
          }
          if (!out) {
            _currZoomLevel = thumbBounds.w / item.w;
            _panOffset.x = thumbBounds.x;
            _panOffset.y = thumbBounds.y - _initalWindowScrollY;
            self2[fadeEverything ? "template" : "bg"].style.opacity = 1e-3;
            _applyCurrentZoomPan();
          }
          _registerStartAnimation("initialZoom");
          if (out && !closeWithRaf) {
            framework.removeClass(template, "pswp--animated-in");
          }
          if (fadeEverything) {
            if (out) {
              framework[(closeWithRaf ? "remove" : "add") + "Class"](template, "pswp--animate_opacity");
            } else {
              setTimeout(function() {
                framework.addClass(template, "pswp--animate_opacity");
              }, 30);
            }
          }
          _showOrHideTimeout = setTimeout(function() {
            _shout("initialZoom" + (out ? "Out" : "In"));
            if (!out) {
              _currZoomLevel = item.initialZoomLevel;
              _equalizePoints(_panOffset, item.initialPosition);
              _applyCurrentZoomPan();
              _applyBgOpacity(1);
              if (fadeEverything) {
                template.style.opacity = 1;
              } else {
                _applyBgOpacity(1);
              }
              _showOrHideTimeout = setTimeout(onComplete, duration + 20);
            } else {
              var destZoomLevel = thumbBounds.w / item.w, initialPanOffset = {
                x: _panOffset.x,
                y: _panOffset.y
              }, initialZoomLevel = _currZoomLevel, initalBgOpacity = _bgOpacity, onUpdate = function(now2) {
                if (now2 === 1) {
                  _currZoomLevel = destZoomLevel;
                  _panOffset.x = thumbBounds.x;
                  _panOffset.y = thumbBounds.y - _currentWindowScrollY;
                } else {
                  _currZoomLevel = (destZoomLevel - initialZoomLevel) * now2 + initialZoomLevel;
                  _panOffset.x = (thumbBounds.x - initialPanOffset.x) * now2 + initialPanOffset.x;
                  _panOffset.y = (thumbBounds.y - _currentWindowScrollY - initialPanOffset.y) * now2 + initialPanOffset.y;
                }
                _applyCurrentZoomPan();
                if (fadeEverything) {
                  template.style.opacity = 1 - now2;
                } else {
                  _applyBgOpacity(initalBgOpacity - now2 * initalBgOpacity);
                }
              };
              if (closeWithRaf) {
                _animateProp("initialZoom", 0, 1, duration, framework.easing.cubic.out, onUpdate, onComplete);
              } else {
                onUpdate(1);
                _showOrHideTimeout = setTimeout(onComplete, duration + 20);
              }
            }
          }, out ? 25 : 90);
        };
        startAnimation();
      };
      var _items, _tempPanAreaSize = {}, _imagesToAppendPool = [], _initialContentSet, _initialZoomRunning, _controllerDefaultOptions = {
        index: 0,
        errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
        forceProgressiveLoading: false,
        // TODO
        preload: [1, 1],
        getNumItemsFn: function() {
          return _items.length;
        }
      };
      var _getItemAt, _getNumItems, _getZeroBounds = function() {
        return {
          center: { x: 0, y: 0 },
          max: { x: 0, y: 0 },
          min: { x: 0, y: 0 }
        };
      }, _calculateSingleItemPanBounds = function(item, realPanElementW, realPanElementH) {
        var bounds = item.bounds;
        bounds.center.x = Math.round((_tempPanAreaSize.x - realPanElementW) / 2);
        bounds.center.y = Math.round((_tempPanAreaSize.y - realPanElementH) / 2) + item.vGap.top;
        bounds.max.x = realPanElementW > _tempPanAreaSize.x ? Math.round(_tempPanAreaSize.x - realPanElementW) : bounds.center.x;
        bounds.max.y = realPanElementH > _tempPanAreaSize.y ? Math.round(_tempPanAreaSize.y - realPanElementH) + item.vGap.top : bounds.center.y;
        bounds.min.x = realPanElementW > _tempPanAreaSize.x ? 0 : bounds.center.x;
        bounds.min.y = realPanElementH > _tempPanAreaSize.y ? item.vGap.top : bounds.center.y;
      }, _calculateItemSize = function(item, viewportSize, zoomLevel) {
        if (item.src && !item.loadError) {
          var isInitial = !zoomLevel;
          if (isInitial) {
            if (!item.vGap) {
              item.vGap = { top: 0, bottom: 0 };
            }
            _shout("parseVerticalMargin", item);
          }
          _tempPanAreaSize.x = viewportSize.x;
          _tempPanAreaSize.y = viewportSize.y - item.vGap.top - item.vGap.bottom;
          if (isInitial) {
            var hRatio = _tempPanAreaSize.x / item.w;
            var vRatio = _tempPanAreaSize.y / item.h;
            item.fitRatio = hRatio < vRatio ? hRatio : vRatio;
            var scaleMode = _options.scaleMode;
            if (scaleMode === "orig") {
              zoomLevel = 1;
            } else if (scaleMode === "fit") {
              zoomLevel = item.fitRatio;
            }
            if (zoomLevel > 1) {
              zoomLevel = 1;
            }
            item.initialZoomLevel = zoomLevel;
            if (!item.bounds) {
              item.bounds = _getZeroBounds();
            }
          }
          if (!zoomLevel) {
            return;
          }
          _calculateSingleItemPanBounds(item, item.w * zoomLevel, item.h * zoomLevel);
          if (isInitial && zoomLevel === item.initialZoomLevel) {
            item.initialPosition = item.bounds.center;
          }
          return item.bounds;
        } else {
          item.w = item.h = 0;
          item.initialZoomLevel = item.fitRatio = 1;
          item.bounds = _getZeroBounds();
          item.initialPosition = item.bounds.center;
          return item.bounds;
        }
      }, _appendImage = function(index, item, baseDiv, img, preventAnimation, keepPlaceholder) {
        if (item.loadError) {
          return;
        }
        if (img) {
          item.imageAppended = true;
          _setImageSize(item, img, item === self2.currItem && _renderMaxResolution);
          baseDiv.appendChild(img);
          if (keepPlaceholder) {
            setTimeout(function() {
              if (item && item.loaded && item.placeholder) {
                item.placeholder.style.display = "none";
                item.placeholder = null;
              }
            }, 500);
          }
        }
      }, _preloadImage = function(item) {
        item.loading = true;
        item.loaded = false;
        var img = item.img = framework.createEl("pswp__img", "img");
        var onComplete = function() {
          item.loading = false;
          item.loaded = true;
          if (item.loadComplete) {
            item.loadComplete(item);
          } else {
            item.img = null;
          }
          img.onload = img.onerror = null;
          img = null;
        };
        img.onload = onComplete;
        img.onerror = function() {
          item.loadError = true;
          onComplete();
        };
        img.src = item.src;
        return img;
      }, _checkForError = function(item, cleanUp) {
        if (item.src && item.loadError && item.container) {
          if (cleanUp) {
            item.container.innerHTML = "";
          }
          item.container.innerHTML = _options.errorMsg.replace("%url%", item.src);
          return true;
        }
      }, _setImageSize = function(item, img, maxRes) {
        if (!item.src) {
          return;
        }
        if (!img) {
          img = item.container.lastChild;
        }
        var w2 = maxRes ? item.w : Math.round(item.w * item.fitRatio), h2 = maxRes ? item.h : Math.round(item.h * item.fitRatio);
        if (item.placeholder && !item.loaded) {
          item.placeholder.style.width = w2 + "px";
          item.placeholder.style.height = h2 + "px";
        }
        img.style.width = w2 + "px";
        img.style.height = h2 + "px";
      }, _appendImagesPool = function() {
        if (_imagesToAppendPool.length) {
          var poolItem;
          for (var i2 = 0; i2 < _imagesToAppendPool.length; i2++) {
            poolItem = _imagesToAppendPool[i2];
            if (poolItem.holder.index === poolItem.index) {
              _appendImage(poolItem.index, poolItem.item, poolItem.baseDiv, poolItem.img, false, poolItem.clearPlaceholder);
            }
          }
          _imagesToAppendPool = [];
        }
      };
      _registerModule("Controller", {
        publicMethods: {
          lazyLoadItem: function(index) {
            index = _getLoopedId(index);
            var item = _getItemAt(index);
            if (!item || (item.loaded || item.loading) && !_itemsNeedUpdate) {
              return;
            }
            _shout("gettingData", index, item);
            if (!item.src) {
              return;
            }
            _preloadImage(item);
          },
          initController: function() {
            framework.extend(_options, _controllerDefaultOptions, true);
            self2.items = _items = items;
            _getItemAt = self2.getItemAt;
            _getNumItems = _options.getNumItemsFn;
            _options.loop;
            if (_getNumItems() < 3) {
              _options.loop = false;
            }
            _listen("beforeChange", function(diff2) {
              var p3 = _options.preload, isNext = diff2 === null ? true : diff2 >= 0, preloadBefore = Math.min(p3[0], _getNumItems()), preloadAfter = Math.min(p3[1], _getNumItems()), i2;
              for (i2 = 1; i2 <= (isNext ? preloadAfter : preloadBefore); i2++) {
                self2.lazyLoadItem(_currentItemIndex + i2);
              }
              for (i2 = 1; i2 <= (isNext ? preloadBefore : preloadAfter); i2++) {
                self2.lazyLoadItem(_currentItemIndex - i2);
              }
            });
            _listen("initialLayout", function() {
              self2.currItem.initialLayout = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
            });
            _listen("mainScrollAnimComplete", _appendImagesPool);
            _listen("initialZoomInEnd", _appendImagesPool);
            _listen("destroy", function() {
              var item;
              for (var i2 = 0; i2 < _items.length; i2++) {
                item = _items[i2];
                if (item.container) {
                  item.container = null;
                }
                if (item.placeholder) {
                  item.placeholder = null;
                }
                if (item.img) {
                  item.img = null;
                }
                if (item.preloader) {
                  item.preloader = null;
                }
                if (item.loadError) {
                  item.loaded = item.loadError = false;
                }
              }
              _imagesToAppendPool = null;
            });
          },
          getItemAt: function(index) {
            if (index >= 0) {
              return _items[index] !== void 0 ? _items[index] : false;
            }
            return false;
          },
          allowProgressiveImg: function() {
            return _options.forceProgressiveLoading || !_likelyTouchDevice || _options.mouseUsed || screen.width > 1200;
          },
          setContent: function(holder, index) {
            if (_options.loop) {
              index = _getLoopedId(index);
            }
            var prevItem = self2.getItemAt(holder.index);
            if (prevItem) {
              prevItem.container = null;
            }
            var item = self2.getItemAt(index), img;
            if (!item) {
              holder.el.innerHTML = "";
              return;
            }
            _shout("gettingData", index, item);
            holder.index = index;
            holder.item = item;
            var baseDiv = item.container = framework.createEl("pswp__zoom-wrap");
            if (!item.src && item.html) {
              if (item.html.tagName) {
                baseDiv.appendChild(item.html);
              } else {
                baseDiv.innerHTML = item.html;
              }
            }
            _checkForError(item);
            _calculateItemSize(item, _viewportSize);
            if (item.src && !item.loadError && !item.loaded) {
              item.loadComplete = function(item2) {
                if (!_isOpen) {
                  return;
                }
                if (holder && holder.index === index) {
                  if (_checkForError(item2, true)) {
                    item2.loadComplete = item2.img = null;
                    _calculateItemSize(item2, _viewportSize);
                    _applyZoomPanToItem(item2);
                    if (holder.index === _currentItemIndex) {
                      self2.updateCurrZoomItem();
                    }
                    return;
                  }
                  if (!item2.imageAppended) {
                    if (_features.transform && (_mainScrollAnimating || _initialZoomRunning)) {
                      _imagesToAppendPool.push({
                        item: item2,
                        baseDiv,
                        img: item2.img,
                        index,
                        holder,
                        clearPlaceholder: true
                      });
                    } else {
                      _appendImage(index, item2, baseDiv, item2.img, _mainScrollAnimating || _initialZoomRunning, true);
                    }
                  } else {
                    if (!_initialZoomRunning && item2.placeholder) {
                      item2.placeholder.style.display = "none";
                      item2.placeholder = null;
                    }
                  }
                }
                item2.loadComplete = null;
                item2.img = null;
                _shout("imageLoadComplete", index, item2);
              };
              if (framework.features.transform) {
                var placeholderClassName = "pswp__img pswp__img--placeholder";
                placeholderClassName += item.msrc ? "" : " pswp__img--placeholder--blank";
                var placeholder = framework.createEl(placeholderClassName, item.msrc ? "img" : "");
                if (item.msrc) {
                  placeholder.src = item.msrc;
                }
                _setImageSize(item, placeholder);
                baseDiv.appendChild(placeholder);
                item.placeholder = placeholder;
              }
              if (!item.loading) {
                _preloadImage(item);
              }
              if (self2.allowProgressiveImg()) {
                if (!_initialContentSet && _features.transform) {
                  _imagesToAppendPool.push({
                    item,
                    baseDiv,
                    img: item.img,
                    index,
                    holder
                  });
                } else {
                  _appendImage(index, item, baseDiv, item.img, true, true);
                }
              }
            } else if (item.src && !item.loadError) {
              img = framework.createEl("pswp__img", "img");
              img.style.opacity = 1;
              img.src = item.src;
              _setImageSize(item, img);
              _appendImage(index, item, baseDiv, img);
            }
            if (!_initialContentSet && index === _currentItemIndex) {
              _currZoomElementStyle = baseDiv.style;
              _showOrHide(item, img || item.img);
            } else {
              _applyZoomPanToItem(item);
            }
            holder.el.innerHTML = "";
            holder.el.appendChild(baseDiv);
          },
          cleanSlide: function(item) {
            if (item.img) {
              item.img.onload = item.img.onerror = null;
            }
            item.loaded = item.loading = item.img = item.imageAppended = false;
          }
        }
      });
      var tapTimer, tapReleasePoint = {}, _dispatchTapEvent = function(origEvent, releasePoint, pointerType) {
        var e2 = document.createEvent("CustomEvent"), eDetail = {
          origEvent,
          target: origEvent.target,
          releasePoint,
          pointerType: pointerType || "touch"
        };
        e2.initCustomEvent("pswpTap", true, true, eDetail);
        origEvent.target.dispatchEvent(e2);
      };
      _registerModule("Tap", {
        publicMethods: {
          initTap: function() {
            _listen("firstTouchStart", self2.onTapStart);
            _listen("touchRelease", self2.onTapRelease);
            _listen("destroy", function() {
              tapReleasePoint = {};
              tapTimer = null;
            });
          },
          onTapStart: function(touchList) {
            if (touchList.length > 1) {
              clearTimeout(tapTimer);
              tapTimer = null;
            }
          },
          onTapRelease: function(e2, releasePoint) {
            if (!releasePoint) {
              return;
            }
            if (!_moved && !_isMultitouch && !_numAnimations) {
              var p0 = releasePoint;
              if (tapTimer) {
                clearTimeout(tapTimer);
                tapTimer = null;
                if (_isNearbyPoints(p0, tapReleasePoint)) {
                  _shout("doubleTap", p0);
                  return;
                }
              }
              if (releasePoint.type === "mouse") {
                _dispatchTapEvent(e2, releasePoint, "mouse");
                return;
              }
              var clickedTagName = e2.target.tagName.toUpperCase();
              if (clickedTagName === "BUTTON" || framework.hasClass(e2.target, "pswp__single-tap")) {
                _dispatchTapEvent(e2, releasePoint);
                return;
              }
              _equalizePoints(tapReleasePoint, p0);
              tapTimer = setTimeout(function() {
                _dispatchTapEvent(e2, releasePoint);
                tapTimer = null;
              }, 300);
            }
          }
        }
      });
      var _wheelDelta;
      _registerModule("DesktopZoom", {
        publicMethods: {
          initDesktopZoom: function() {
            if (_oldIE) {
              return;
            }
            if (_likelyTouchDevice) {
              _listen("mouseUsed", function() {
                self2.setupDesktopZoom();
              });
            } else {
              self2.setupDesktopZoom(true);
            }
          },
          setupDesktopZoom: function(onInit) {
            _wheelDelta = {};
            var events2 = "wheel mousewheel DOMMouseScroll";
            _listen("bindEvents", function() {
              framework.bind(template, events2, self2.handleMouseWheel);
            });
            _listen("unbindEvents", function() {
              if (_wheelDelta) {
                framework.unbind(template, events2, self2.handleMouseWheel);
              }
            });
            self2.mouseZoomedIn = false;
            var hasDraggingClass, updateZoomable = function() {
              if (self2.mouseZoomedIn) {
                framework.removeClass(template, "pswp--zoomed-in");
                self2.mouseZoomedIn = false;
              }
              if (_currZoomLevel < 1) {
                framework.addClass(template, "pswp--zoom-allowed");
              } else {
                framework.removeClass(template, "pswp--zoom-allowed");
              }
              removeDraggingClass();
            }, removeDraggingClass = function() {
              if (hasDraggingClass) {
                framework.removeClass(template, "pswp--dragging");
                hasDraggingClass = false;
              }
            };
            _listen("resize", updateZoomable);
            _listen("afterChange", updateZoomable);
            _listen("pointerDown", function() {
              if (self2.mouseZoomedIn) {
                hasDraggingClass = true;
                framework.addClass(template, "pswp--dragging");
              }
            });
            _listen("pointerUp", removeDraggingClass);
            if (!onInit) {
              updateZoomable();
            }
          },
          handleMouseWheel: function(e2) {
            if (_currZoomLevel <= self2.currItem.fitRatio) {
              if (_options.modal) {
                if (!_options.closeOnScroll || _numAnimations || _isDragging) {
                  e2.preventDefault();
                } else if (_transformKey && Math.abs(e2.deltaY) > 2) {
                  _closedByScroll = true;
                  self2.close();
                }
              }
              return true;
            }
            e2.stopPropagation();
            _wheelDelta.x = 0;
            if ("deltaX" in e2) {
              if (e2.deltaMode === 1) {
                _wheelDelta.x = e2.deltaX * 18;
                _wheelDelta.y = e2.deltaY * 18;
              } else {
                _wheelDelta.x = e2.deltaX;
                _wheelDelta.y = e2.deltaY;
              }
            } else if ("wheelDelta" in e2) {
              if (e2.wheelDeltaX) {
                _wheelDelta.x = -0.16 * e2.wheelDeltaX;
              }
              if (e2.wheelDeltaY) {
                _wheelDelta.y = -0.16 * e2.wheelDeltaY;
              } else {
                _wheelDelta.y = -0.16 * e2.wheelDelta;
              }
            } else if ("detail" in e2) {
              _wheelDelta.y = e2.detail;
            } else {
              return;
            }
            _calculatePanBounds(_currZoomLevel, true);
            var newPanX = _panOffset.x - _wheelDelta.x, newPanY = _panOffset.y - _wheelDelta.y;
            if (_options.modal || newPanX <= _currPanBounds.min.x && newPanX >= _currPanBounds.max.x && newPanY <= _currPanBounds.min.y && newPanY >= _currPanBounds.max.y) {
              e2.preventDefault();
            }
            self2.panTo(newPanX, newPanY);
          },
          toggleDesktopZoom: function(centerPoint) {
            centerPoint = centerPoint || { x: _viewportSize.x / 2 + _offset.x, y: _viewportSize.y / 2 + _offset.y };
            var doubleTapZoomLevel = _options.getDoubleTapZoom(true, self2.currItem);
            var zoomOut = _currZoomLevel === doubleTapZoomLevel;
            self2.mouseZoomedIn = !zoomOut;
            self2.zoomTo(zoomOut ? self2.currItem.initialZoomLevel : doubleTapZoomLevel, centerPoint, 333);
            framework[(!zoomOut ? "add" : "remove") + "Class"](template, "pswp--zoomed-in");
          }
        }
      });
      var _historyDefaultOptions = {
        history: true,
        galleryUID: 1
      };
      var _historyUpdateTimeout, _hashChangeTimeout, _hashAnimCheckTimeout, _hashChangedByScript, _hashChangedByHistory, _hashReseted, _initialHash, _historyChanged, _closedFromURL, _urlChangedOnce, _windowLoc, _supportsPushState, _getHash = function() {
        return _windowLoc.hash.substring(1);
      }, _cleanHistoryTimeouts = function() {
        if (_historyUpdateTimeout) {
          clearTimeout(_historyUpdateTimeout);
        }
        if (_hashAnimCheckTimeout) {
          clearTimeout(_hashAnimCheckTimeout);
        }
      }, _parseItemIndexFromURL = function() {
        var hash = _getHash(), params = {};
        if (hash.length < 5) {
          return params;
        }
        var i2, vars = hash.split("&");
        for (i2 = 0; i2 < vars.length; i2++) {
          if (!vars[i2]) {
            continue;
          }
          var pair = vars[i2].split("=");
          if (pair.length < 2) {
            continue;
          }
          params[pair[0]] = pair[1];
        }
        if (_options.galleryPIDs) {
          var searchfor = params.pid;
          params.pid = 0;
          for (i2 = 0; i2 < _items.length; i2++) {
            if (_items[i2].pid === searchfor) {
              params.pid = i2;
              break;
            }
          }
        } else {
          params.pid = parseInt(params.pid, 10) - 1;
        }
        if (params.pid < 0) {
          params.pid = 0;
        }
        return params;
      }, _updateHash = function() {
        if (_hashAnimCheckTimeout) {
          clearTimeout(_hashAnimCheckTimeout);
        }
        if (_numAnimations || _isDragging) {
          _hashAnimCheckTimeout = setTimeout(_updateHash, 500);
          return;
        }
        if (_hashChangedByScript) {
          clearTimeout(_hashChangeTimeout);
        } else {
          _hashChangedByScript = true;
        }
        var pid = _currentItemIndex + 1;
        var item = _getItemAt(_currentItemIndex);
        if (item.hasOwnProperty("pid")) {
          pid = item.pid;
        }
        var newHash = _initialHash + "&gid=" + _options.galleryUID + "&pid=" + pid;
        if (!_historyChanged) {
          if (_windowLoc.hash.indexOf(newHash) === -1) {
            _urlChangedOnce = true;
          }
        }
        var newURL = _windowLoc.href.split("#")[0] + "#" + newHash;
        if (_supportsPushState) {
          if ("#" + newHash !== window.location.hash) {
            history[_historyChanged ? "replaceState" : "pushState"]("", document.title, newURL);
          }
        } else {
          if (_historyChanged) {
            _windowLoc.replace(newURL);
          } else {
            _windowLoc.hash = newHash;
          }
        }
        _historyChanged = true;
        _hashChangeTimeout = setTimeout(function() {
          _hashChangedByScript = false;
        }, 60);
      };
      _registerModule("History", {
        publicMethods: {
          initHistory: function() {
            framework.extend(_options, _historyDefaultOptions, true);
            if (!_options.history) {
              return;
            }
            _windowLoc = window.location;
            _urlChangedOnce = false;
            _closedFromURL = false;
            _historyChanged = false;
            _initialHash = _getHash();
            _supportsPushState = "pushState" in history;
            if (_initialHash.indexOf("gid=") > -1) {
              _initialHash = _initialHash.split("&gid=")[0];
              _initialHash = _initialHash.split("?gid=")[0];
            }
            _listen("afterChange", self2.updateURL);
            _listen("unbindEvents", function() {
              framework.unbind(window, "hashchange", self2.onHashChange);
            });
            var returnToOriginal = function() {
              _hashReseted = true;
              if (!_closedFromURL) {
                if (_urlChangedOnce) {
                  history.back();
                } else {
                  if (_initialHash) {
                    _windowLoc.hash = _initialHash;
                  } else {
                    if (_supportsPushState) {
                      history.pushState("", document.title, _windowLoc.pathname + _windowLoc.search);
                    } else {
                      _windowLoc.hash = "";
                    }
                  }
                }
              }
              _cleanHistoryTimeouts();
            };
            _listen("unbindEvents", function() {
              if (_closedByScroll) {
                returnToOriginal();
              }
            });
            _listen("destroy", function() {
              if (!_hashReseted) {
                returnToOriginal();
              }
            });
            _listen("firstUpdate", function() {
              _currentItemIndex = _parseItemIndexFromURL().pid;
            });
            var index = _initialHash.indexOf("pid=");
            if (index > -1) {
              _initialHash = _initialHash.substring(0, index);
              if (_initialHash.slice(-1) === "&") {
                _initialHash = _initialHash.slice(0, -1);
              }
            }
            setTimeout(function() {
              if (_isOpen) {
                framework.bind(window, "hashchange", self2.onHashChange);
              }
            }, 40);
          },
          onHashChange: function() {
            if (_getHash() === _initialHash) {
              _closedFromURL = true;
              self2.close();
              return;
            }
            if (!_hashChangedByScript) {
              _hashChangedByHistory = true;
              self2.goTo(_parseItemIndexFromURL().pid);
              _hashChangedByHistory = false;
            }
          },
          updateURL: function() {
            _cleanHistoryTimeouts();
            if (_hashChangedByHistory) {
              return;
            }
            if (!_historyChanged) {
              _updateHash();
            } else {
              _historyUpdateTimeout = setTimeout(_updateHash, 800);
            }
          }
        }
      });
      framework.extend(self2, publicMethods);
    };
    return PhotoSwipe2;
  });
})(photoswipe$1);
const PhotoSwipe = photoswipeExports;
var photoswipeUiDefaultExports = {};
var photoswipeUiDefault = {
  get exports() {
    return photoswipeUiDefaultExports;
  },
  set exports(v2) {
    photoswipeUiDefaultExports = v2;
  }
};
/*! PhotoSwipe Default UI - 4.1.3 - 2019-01-08
* http://photoswipe.com
* Copyright (c) 2019 Dmitry Semenov; */
(function(module, exports) {
  (function(root2, factory) {
    {
      module.exports = factory();
    }
  })(commonjsGlobal, function() {
    var PhotoSwipeUI_Default2 = function(pswp, framework) {
      var ui = this;
      var _overlayUIUpdated = false, _controlsVisible = true, _fullscrenAPI, _controls, _captionContainer, _fakeCaptionContainer, _indexIndicator, _shareButton, _shareModal, _shareModalHidden = true, _initalCloseOnScrollValue, _isIdle, _listen, _loadingIndicator, _loadingIndicatorHidden, _loadingIndicatorTimeout, _galleryHasOneSlide, _options, _defaultUIOptions = {
        barsSize: { top: 44, bottom: "auto" },
        closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
        timeToIdle: 4e3,
        timeToIdleOutside: 1e3,
        loadingIndicatorDelay: 1e3,
        // 2s
        addCaptionHTMLFn: function(item, captionEl) {
          if (!item.title) {
            captionEl.children[0].innerHTML = "";
            return false;
          }
          captionEl.children[0].innerHTML = item.title;
          return true;
        },
        closeEl: true,
        captionEl: true,
        fullscreenEl: true,
        zoomEl: true,
        shareEl: true,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        tapToClose: false,
        tapToToggleControls: true,
        clickToCloseNonZoomable: true,
        shareButtons: [
          { id: "facebook", label: "Share on Facebook", url: "https://www.facebook.com/sharer/sharer.php?u={{url}}" },
          { id: "twitter", label: "Tweet", url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}" },
          { id: "pinterest", label: "Pin it", url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}" },
          { id: "download", label: "Download image", url: "{{raw_image_url}}", download: true }
        ],
        getImageURLForShare: function() {
          return pswp.currItem.src || "";
        },
        getPageURLForShare: function() {
          return window.location.href;
        },
        getTextForShare: function() {
          return pswp.currItem.title || "";
        },
        indexIndicatorSep: " / ",
        fitControlsWidth: 1200
      }, _blockControlsTap;
      var _onControlsTap = function(e2) {
        if (_blockControlsTap) {
          return true;
        }
        e2 = e2 || window.event;
        if (_options.timeToIdle && _options.mouseUsed && !_isIdle) {
          _onIdleMouseMove();
        }
        var target = e2.target || e2.srcElement, uiElement, clickedClass = target.getAttribute("class") || "", found;
        for (var i2 = 0; i2 < _uiElements.length; i2++) {
          uiElement = _uiElements[i2];
          if (uiElement.onTap && clickedClass.indexOf("pswp__" + uiElement.name) > -1) {
            uiElement.onTap();
            found = true;
          }
        }
        if (found) {
          if (e2.stopPropagation) {
            e2.stopPropagation();
          }
          _blockControlsTap = true;
          var tapDelay = framework.features.isOldAndroid ? 600 : 30;
          setTimeout(function() {
            _blockControlsTap = false;
          }, tapDelay);
        }
      }, _fitControlsInViewport = function() {
        return !pswp.likelyTouchDevice || _options.mouseUsed || screen.width > _options.fitControlsWidth;
      }, _togglePswpClass = function(el, cName, add2) {
        framework[(add2 ? "add" : "remove") + "Class"](el, "pswp__" + cName);
      }, _countNumItems = function() {
        var hasOneSlide = _options.getNumItemsFn() === 1;
        if (hasOneSlide !== _galleryHasOneSlide) {
          _togglePswpClass(_controls, "ui--one-slide", hasOneSlide);
          _galleryHasOneSlide = hasOneSlide;
        }
      }, _toggleShareModalClass = function() {
        _togglePswpClass(_shareModal, "share-modal--hidden", _shareModalHidden);
      }, _toggleShareModal = function() {
        _shareModalHidden = !_shareModalHidden;
        if (!_shareModalHidden) {
          _toggleShareModalClass();
          setTimeout(function() {
            if (!_shareModalHidden) {
              framework.addClass(_shareModal, "pswp__share-modal--fade-in");
            }
          }, 30);
        } else {
          framework.removeClass(_shareModal, "pswp__share-modal--fade-in");
          setTimeout(function() {
            if (_shareModalHidden) {
              _toggleShareModalClass();
            }
          }, 300);
        }
        if (!_shareModalHidden) {
          _updateShareURLs();
        }
        return false;
      }, _openWindowPopup = function(e2) {
        e2 = e2 || window.event;
        var target = e2.target || e2.srcElement;
        pswp.shout("shareLinkClick", e2, target);
        if (!target.href) {
          return false;
        }
        if (target.hasAttribute("download")) {
          return true;
        }
        window.open(target.href, "pswp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100));
        if (!_shareModalHidden) {
          _toggleShareModal();
        }
        return false;
      }, _updateShareURLs = function() {
        var shareButtonOut = "", shareButtonData, shareURL, image_url, page_url, share_text;
        for (var i2 = 0; i2 < _options.shareButtons.length; i2++) {
          shareButtonData = _options.shareButtons[i2];
          image_url = _options.getImageURLForShare(shareButtonData);
          page_url = _options.getPageURLForShare(shareButtonData);
          share_text = _options.getTextForShare(shareButtonData);
          shareURL = shareButtonData.url.replace("{{url}}", encodeURIComponent(page_url)).replace("{{image_url}}", encodeURIComponent(image_url)).replace("{{raw_image_url}}", image_url).replace("{{text}}", encodeURIComponent(share_text));
          shareButtonOut += '<a href="' + shareURL + '" target="_blank" class="pswp__share--' + shareButtonData.id + '"' + (shareButtonData.download ? "download" : "") + ">" + shareButtonData.label + "</a>";
          if (_options.parseShareButtonOut) {
            shareButtonOut = _options.parseShareButtonOut(shareButtonData, shareButtonOut);
          }
        }
        _shareModal.children[0].innerHTML = shareButtonOut;
        _shareModal.children[0].onclick = _openWindowPopup;
      }, _hasCloseClass = function(target) {
        for (var i2 = 0; i2 < _options.closeElClasses.length; i2++) {
          if (framework.hasClass(target, "pswp__" + _options.closeElClasses[i2])) {
            return true;
          }
        }
      }, _idleInterval, _idleTimer, _idleIncrement = 0, _onIdleMouseMove = function() {
        clearTimeout(_idleTimer);
        _idleIncrement = 0;
        if (_isIdle) {
          ui.setIdle(false);
        }
      }, _onMouseLeaveWindow = function(e2) {
        e2 = e2 ? e2 : window.event;
        var from = e2.relatedTarget || e2.toElement;
        if (!from || from.nodeName === "HTML") {
          clearTimeout(_idleTimer);
          _idleTimer = setTimeout(function() {
            ui.setIdle(true);
          }, _options.timeToIdleOutside);
        }
      }, _setupFullscreenAPI = function() {
        if (_options.fullscreenEl && !framework.features.isOldAndroid) {
          if (!_fullscrenAPI) {
            _fullscrenAPI = ui.getFullscreenAPI();
          }
          if (_fullscrenAPI) {
            framework.bind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
            ui.updateFullscreen();
            framework.addClass(pswp.template, "pswp--supports-fs");
          } else {
            framework.removeClass(pswp.template, "pswp--supports-fs");
          }
        }
      }, _setupLoadingIndicator = function() {
        if (_options.preloaderEl) {
          _toggleLoadingIndicator(true);
          _listen("beforeChange", function() {
            clearTimeout(_loadingIndicatorTimeout);
            _loadingIndicatorTimeout = setTimeout(function() {
              if (pswp.currItem && pswp.currItem.loading) {
                if (!pswp.allowProgressiveImg() || pswp.currItem.img && !pswp.currItem.img.naturalWidth) {
                  _toggleLoadingIndicator(false);
                }
              } else {
                _toggleLoadingIndicator(true);
              }
            }, _options.loadingIndicatorDelay);
          });
          _listen("imageLoadComplete", function(index, item) {
            if (pswp.currItem === item) {
              _toggleLoadingIndicator(true);
            }
          });
        }
      }, _toggleLoadingIndicator = function(hide) {
        if (_loadingIndicatorHidden !== hide) {
          _togglePswpClass(_loadingIndicator, "preloader--active", !hide);
          _loadingIndicatorHidden = hide;
        }
      }, _applyNavBarGaps = function(item) {
        var gap = item.vGap;
        if (_fitControlsInViewport()) {
          var bars = _options.barsSize;
          if (_options.captionEl && bars.bottom === "auto") {
            if (!_fakeCaptionContainer) {
              _fakeCaptionContainer = framework.createEl("pswp__caption pswp__caption--fake");
              _fakeCaptionContainer.appendChild(framework.createEl("pswp__caption__center"));
              _controls.insertBefore(_fakeCaptionContainer, _captionContainer);
              framework.addClass(_controls, "pswp__ui--fit");
            }
            if (_options.addCaptionHTMLFn(item, _fakeCaptionContainer, true)) {
              var captionSize = _fakeCaptionContainer.clientHeight;
              gap.bottom = parseInt(captionSize, 10) || 44;
            } else {
              gap.bottom = bars.top;
            }
          } else {
            gap.bottom = bars.bottom === "auto" ? 0 : bars.bottom;
          }
          gap.top = bars.top;
        } else {
          gap.top = gap.bottom = 0;
        }
      }, _setupIdle = function() {
        if (_options.timeToIdle) {
          _listen("mouseUsed", function() {
            framework.bind(document, "mousemove", _onIdleMouseMove);
            framework.bind(document, "mouseout", _onMouseLeaveWindow);
            _idleInterval = setInterval(function() {
              _idleIncrement++;
              if (_idleIncrement === 2) {
                ui.setIdle(true);
              }
            }, _options.timeToIdle / 2);
          });
        }
      }, _setupHidingControlsDuringGestures = function() {
        _listen("onVerticalDrag", function(now2) {
          if (_controlsVisible && now2 < 0.95) {
            ui.hideControls();
          } else if (!_controlsVisible && now2 >= 0.95) {
            ui.showControls();
          }
        });
        var pinchControlsHidden;
        _listen("onPinchClose", function(now2) {
          if (_controlsVisible && now2 < 0.9) {
            ui.hideControls();
            pinchControlsHidden = true;
          } else if (pinchControlsHidden && !_controlsVisible && now2 > 0.9) {
            ui.showControls();
          }
        });
        _listen("zoomGestureEnded", function() {
          pinchControlsHidden = false;
          if (pinchControlsHidden && !_controlsVisible) {
            ui.showControls();
          }
        });
      };
      var _uiElements = [
        {
          name: "caption",
          option: "captionEl",
          onInit: function(el) {
            _captionContainer = el;
          }
        },
        {
          name: "share-modal",
          option: "shareEl",
          onInit: function(el) {
            _shareModal = el;
          },
          onTap: function() {
            _toggleShareModal();
          }
        },
        {
          name: "button--share",
          option: "shareEl",
          onInit: function(el) {
            _shareButton = el;
          },
          onTap: function() {
            _toggleShareModal();
          }
        },
        {
          name: "button--zoom",
          option: "zoomEl",
          onTap: pswp.toggleDesktopZoom
        },
        {
          name: "counter",
          option: "counterEl",
          onInit: function(el) {
            _indexIndicator = el;
          }
        },
        {
          name: "button--close",
          option: "closeEl",
          onTap: pswp.close
        },
        {
          name: "button--arrow--left",
          option: "arrowEl",
          onTap: pswp.prev
        },
        {
          name: "button--arrow--right",
          option: "arrowEl",
          onTap: pswp.next
        },
        {
          name: "button--fs",
          option: "fullscreenEl",
          onTap: function() {
            if (_fullscrenAPI.isFullscreen()) {
              _fullscrenAPI.exit();
            } else {
              _fullscrenAPI.enter();
            }
          }
        },
        {
          name: "preloader",
          option: "preloaderEl",
          onInit: function(el) {
            _loadingIndicator = el;
          }
        }
      ];
      var _setupUIElements = function() {
        var item, classAttr, uiElement;
        var loopThroughChildElements = function(sChildren) {
          if (!sChildren) {
            return;
          }
          var l2 = sChildren.length;
          for (var i2 = 0; i2 < l2; i2++) {
            item = sChildren[i2];
            classAttr = item.className;
            for (var a2 = 0; a2 < _uiElements.length; a2++) {
              uiElement = _uiElements[a2];
              if (classAttr.indexOf("pswp__" + uiElement.name) > -1) {
                if (_options[uiElement.option]) {
                  framework.removeClass(item, "pswp__element--disabled");
                  if (uiElement.onInit) {
                    uiElement.onInit(item);
                  }
                } else {
                  framework.addClass(item, "pswp__element--disabled");
                }
              }
            }
          }
        };
        loopThroughChildElements(_controls.children);
        var topBar = framework.getChildByClass(_controls, "pswp__top-bar");
        if (topBar) {
          loopThroughChildElements(topBar.children);
        }
      };
      ui.init = function() {
        framework.extend(pswp.options, _defaultUIOptions, true);
        _options = pswp.options;
        _controls = framework.getChildByClass(pswp.scrollWrap, "pswp__ui");
        _listen = pswp.listen;
        _setupHidingControlsDuringGestures();
        _listen("beforeChange", ui.update);
        _listen("doubleTap", function(point) {
          var initialZoomLevel = pswp.currItem.initialZoomLevel;
          if (pswp.getZoomLevel() !== initialZoomLevel) {
            pswp.zoomTo(initialZoomLevel, point, 333);
          } else {
            pswp.zoomTo(_options.getDoubleTapZoom(false, pswp.currItem), point, 333);
          }
        });
        _listen("preventDragEvent", function(e2, isDown, preventObj) {
          var t2 = e2.target || e2.srcElement;
          if (t2 && t2.getAttribute("class") && e2.type.indexOf("mouse") > -1 && (t2.getAttribute("class").indexOf("__caption") > 0 || /(SMALL|STRONG|EM)/i.test(t2.tagName))) {
            preventObj.prevent = false;
          }
        });
        _listen("bindEvents", function() {
          framework.bind(_controls, "pswpTap click", _onControlsTap);
          framework.bind(pswp.scrollWrap, "pswpTap", ui.onGlobalTap);
          if (!pswp.likelyTouchDevice) {
            framework.bind(pswp.scrollWrap, "mouseover", ui.onMouseOver);
          }
        });
        _listen("unbindEvents", function() {
          if (!_shareModalHidden) {
            _toggleShareModal();
          }
          if (_idleInterval) {
            clearInterval(_idleInterval);
          }
          framework.unbind(document, "mouseout", _onMouseLeaveWindow);
          framework.unbind(document, "mousemove", _onIdleMouseMove);
          framework.unbind(_controls, "pswpTap click", _onControlsTap);
          framework.unbind(pswp.scrollWrap, "pswpTap", ui.onGlobalTap);
          framework.unbind(pswp.scrollWrap, "mouseover", ui.onMouseOver);
          if (_fullscrenAPI) {
            framework.unbind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
            if (_fullscrenAPI.isFullscreen()) {
              _options.hideAnimationDuration = 0;
              _fullscrenAPI.exit();
            }
            _fullscrenAPI = null;
          }
        });
        _listen("destroy", function() {
          if (_options.captionEl) {
            if (_fakeCaptionContainer) {
              _controls.removeChild(_fakeCaptionContainer);
            }
            framework.removeClass(_captionContainer, "pswp__caption--empty");
          }
          if (_shareModal) {
            _shareModal.children[0].onclick = null;
          }
          framework.removeClass(_controls, "pswp__ui--over-close");
          framework.addClass(_controls, "pswp__ui--hidden");
          ui.setIdle(false);
        });
        if (!_options.showAnimationDuration) {
          framework.removeClass(_controls, "pswp__ui--hidden");
        }
        _listen("initialZoomIn", function() {
          if (_options.showAnimationDuration) {
            framework.removeClass(_controls, "pswp__ui--hidden");
          }
        });
        _listen("initialZoomOut", function() {
          framework.addClass(_controls, "pswp__ui--hidden");
        });
        _listen("parseVerticalMargin", _applyNavBarGaps);
        _setupUIElements();
        if (_options.shareEl && _shareButton && _shareModal) {
          _shareModalHidden = true;
        }
        _countNumItems();
        _setupIdle();
        _setupFullscreenAPI();
        _setupLoadingIndicator();
      };
      ui.setIdle = function(isIdle) {
        _isIdle = isIdle;
        _togglePswpClass(_controls, "ui--idle", isIdle);
      };
      ui.update = function() {
        if (_controlsVisible && pswp.currItem) {
          ui.updateIndexIndicator();
          if (_options.captionEl) {
            _options.addCaptionHTMLFn(pswp.currItem, _captionContainer);
            _togglePswpClass(_captionContainer, "caption--empty", !pswp.currItem.title);
          }
          _overlayUIUpdated = true;
        } else {
          _overlayUIUpdated = false;
        }
        if (!_shareModalHidden) {
          _toggleShareModal();
        }
        _countNumItems();
      };
      ui.updateFullscreen = function(e2) {
        if (e2) {
          setTimeout(function() {
            pswp.setScrollOffset(0, framework.getScrollY());
          }, 50);
        }
        framework[(_fullscrenAPI.isFullscreen() ? "add" : "remove") + "Class"](pswp.template, "pswp--fs");
      };
      ui.updateIndexIndicator = function() {
        if (_options.counterEl) {
          _indexIndicator.innerHTML = pswp.getCurrentIndex() + 1 + _options.indexIndicatorSep + _options.getNumItemsFn();
        }
      };
      ui.onGlobalTap = function(e2) {
        e2 = e2 || window.event;
        var target = e2.target || e2.srcElement;
        if (_blockControlsTap) {
          return;
        }
        if (e2.detail && e2.detail.pointerType === "mouse") {
          if (_hasCloseClass(target)) {
            pswp.close();
            return;
          }
          if (framework.hasClass(target, "pswp__img")) {
            if (pswp.getZoomLevel() === 1 && pswp.getZoomLevel() <= pswp.currItem.fitRatio) {
              if (_options.clickToCloseNonZoomable) {
                pswp.close();
              }
            } else {
              pswp.toggleDesktopZoom(e2.detail.releasePoint);
            }
          }
        } else {
          if (_options.tapToToggleControls) {
            if (_controlsVisible) {
              ui.hideControls();
            } else {
              ui.showControls();
            }
          }
          if (_options.tapToClose && (framework.hasClass(target, "pswp__img") || _hasCloseClass(target))) {
            pswp.close();
            return;
          }
        }
      };
      ui.onMouseOver = function(e2) {
        e2 = e2 || window.event;
        var target = e2.target || e2.srcElement;
        _togglePswpClass(_controls, "ui--over-close", _hasCloseClass(target));
      };
      ui.hideControls = function() {
        framework.addClass(_controls, "pswp__ui--hidden");
        _controlsVisible = false;
      };
      ui.showControls = function() {
        _controlsVisible = true;
        if (!_overlayUIUpdated) {
          ui.update();
        }
        framework.removeClass(_controls, "pswp__ui--hidden");
      };
      ui.supportsFullscreen = function() {
        var d2 = document;
        return !!(d2.exitFullscreen || d2.mozCancelFullScreen || d2.webkitExitFullscreen || d2.msExitFullscreen);
      };
      ui.getFullscreenAPI = function() {
        var dE = document.documentElement, api, tF = "fullscreenchange";
        if (dE.requestFullscreen) {
          api = {
            enterK: "requestFullscreen",
            exitK: "exitFullscreen",
            elementK: "fullscreenElement",
            eventK: tF
          };
        } else if (dE.mozRequestFullScreen) {
          api = {
            enterK: "mozRequestFullScreen",
            exitK: "mozCancelFullScreen",
            elementK: "mozFullScreenElement",
            eventK: "moz" + tF
          };
        } else if (dE.webkitRequestFullscreen) {
          api = {
            enterK: "webkitRequestFullscreen",
            exitK: "webkitExitFullscreen",
            elementK: "webkitFullscreenElement",
            eventK: "webkit" + tF
          };
        } else if (dE.msRequestFullscreen) {
          api = {
            enterK: "msRequestFullscreen",
            exitK: "msExitFullscreen",
            elementK: "msFullscreenElement",
            eventK: "MSFullscreenChange"
          };
        }
        if (api) {
          api.enter = function() {
            _initalCloseOnScrollValue = _options.closeOnScroll;
            _options.closeOnScroll = false;
            if (this.enterK === "webkitRequestFullscreen") {
              pswp.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT);
            } else {
              return pswp.template[this.enterK]();
            }
          };
          api.exit = function() {
            _options.closeOnScroll = _initalCloseOnScrollValue;
            return document[this.exitK]();
          };
          api.isFullscreen = function() {
            return document[this.elementK];
          };
        }
        return api;
      };
    };
    return PhotoSwipeUI_Default2;
  });
})(photoswipeUiDefault);
const PhotoSwipeUI_Default = photoswipeUiDefaultExports;
const PhotoSwipeUI_Default$1 = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: PhotoSwipeUI_Default
}, [photoswipeUiDefaultExports]);
const photoswipe = "";
const defaultSkin = "";
const swiper_min = "";
const SvgSwipe = (props) => /* @__PURE__ */ React$3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 113 47.7", ...props }, /* @__PURE__ */ React$3.createElement("path", { d: "M3.6 14.7l13-13c.4-.4.4-1 0-1.4s-1-.4-1.4 0L.4 15.1c-.4.4-.4 1 0 1.4L15.1 32c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L3.1 16.7H31c.6 0 1-.4 1-1s-.4-1-1-1H3.6zm106.2 2L96.4 30.6c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l14.9-15.5c.4-.4.4-1 0-1.4L97.9.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l13 13H82c-.6 0-1 .4-1 1s.4 1 1 1h27.8zM68.9 35.4L67 45.6H52.3L44.5 34c-.3-.5-.5-1.2-.4-1.8.1-.5.3-.6.7-.6 2.1 0 4 1.4 7.3 6.5.5.8 1.8.4 1.8-.5v-22c0-1.1.9-2 2-2s2 .9 2 2v12c0 .4.3.8.7.9l9 3c1.2.5 1.7 2.1 1.3 3.9zm-17-19.8v18.8c-2.7-3.6-4.8-4.8-7.2-4.8-1.5 0-2.4.9-2.6 2.3-.2 1.1.1 2.3.7 3.2l8.1 12c.2.3.5.4.8.4h16.1c.5 0 .9-.3 1-.8l2.1-11c.6-2.7-.2-5.4-2.6-6.2L60 26.7v-11c0-2.2-1.8-4-4-4-2.3 0-4.1 1.7-4.1 3.9z", fill: "#fff" }));
const Pswp = () => {
  const { t: t2 } = useTranslation();
  return /* @__PURE__ */ jsxs("div", { className: "pswp", tabIndex: "-1", role: "dialog", "aria-hidden": "true", children: [
    /* @__PURE__ */ jsx("div", { className: "pswp__bg" }),
    /* @__PURE__ */ jsxs("div", { className: "pswp__scroll-wrap", children: [
      /* @__PURE__ */ jsxs("div", { className: "pswp__container", children: [
        /* @__PURE__ */ jsx("div", { className: "pswp__item" }),
        /* @__PURE__ */ jsx("div", { className: "pswp__item" }),
        /* @__PURE__ */ jsx("div", { className: "pswp__item" })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "pswp__ui pswp__ui--hidden", children: [
        /* @__PURE__ */ jsxs("div", { className: "pswp__top-bar", children: [
          /* @__PURE__ */ jsx("div", { className: "pswp__counter" }),
          /* @__PURE__ */ jsx(
            "button",
            {
              className: "pswp__button pswp__button--close",
              title: t2("close")
            }
          ),
          /* @__PURE__ */ jsx(
            "button",
            {
              className: "pswp__button pswp__button--share",
              title: t2("share")
            }
          ),
          /* @__PURE__ */ jsx(
            "button",
            {
              className: "pswp__button pswp__button--fs",
              title: t2("toggle_fullscreen")
            }
          ),
          /* @__PURE__ */ jsx(
            "button",
            {
              className: "pswp__button pswp__button--zoom",
              title: t2("zoom_inout")
            }
          ),
          /* @__PURE__ */ jsx("div", { className: "pswp__preloader", children: /* @__PURE__ */ jsx("div", { className: "pswp__preloader__icn", children: /* @__PURE__ */ jsx("div", { className: "pswp__preloader__cut", children: /* @__PURE__ */ jsx("div", { className: "pswp__preloader__donut" }) }) }) })
        ] }),
        /* @__PURE__ */ jsx("div", { className: "pswp__share-modal pswp__share-modal--hidden pswp__single-tap", children: /* @__PURE__ */ jsx("div", { className: "pswp__share-tooltip" }) }),
        /* @__PURE__ */ jsx(
          "button",
          {
            className: "pswp__button pswp__button--arrow--left",
            title: t2("to_previous")
          }
        ),
        /* @__PURE__ */ jsx(
          "button",
          {
            className: "pswp__button pswp__button--arrow--right",
            title: t2("to_next")
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "pswp__caption", children: /* @__PURE__ */ jsx("div", { className: "pswp__caption__center" }) }),
        /* @__PURE__ */ jsx("div", { className: "absolute transform -translate-x-1/2 bottom-12 left-1/2 md:hidden", children: /* @__PURE__ */ jsx(SvgSwipe, { className: "w-24" }) })
      ] })
    ] })
  ] });
};
const SvgExpand = (props) => /* @__PURE__ */ React$3.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 117 117", style: {
  enableBackground: "new 0 0 117 117"
}, xmlSpace: "preserve", ...props }, /* @__PURE__ */ React$3.createElement("g", null, /* @__PURE__ */ React$3.createElement("path", { fill: "#FFFFFF", d: "M41.3,74.3L2,113.6V91c0-0.6-0.4-1-1-1s-1,0.4-1,1v25c0,0,0,0,0,0c0,0.1,0,0.3,0.1,0.4 c0.1,0.2,0.3,0.4,0.5,0.5c0.1,0,0.2,0.1,0.4,0.1c0,0,0,0,0,0h25c0.6,0,1-0.4,1-1s-0.4-1-1-1H3.4l39.3-39.3c0.4-0.4,0.4-1,0-1.4 C42.3,73.9,41.7,73.9,41.3,74.3z" }), /* @__PURE__ */ React$3.createElement("path", { fill: "#FFFFFF", d: "M116.9,0.6c-0.1-0.2-0.3-0.4-0.5-0.5C116.3,0,116.1,0,116,0H91c-0.6,0-1,0.4-1,1s0.4,1,1,1h22.6L74.3,41.3 c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0L115,3.4V26c0,0.6,0.4,1,1,1s1-0.4,1-1V1C117,0.9,117,0.7,116.9,0.6z" })));
const Overlay = () => /* @__PURE__ */ jsx("div", { className: "absolute inset-0 flex items-center justify-center transition duration-200 cursor-pointer group-hover:bg-blue-500 group-hover:bg-opacity-80", children: /* @__PURE__ */ jsx(SvgExpand, { className: "w-12 h-12 transition duration-200 transform scale-0 group-hover:scale-100" }) });
function PhotoSlider({ blueprint, hero, hero_thumbnail, photos, map = null }) {
  const { t: t2 } = useTranslation();
  const [lightbox, setLightbox] = useState$1(null);
  useEffect$1(() => {
    let lightboxArr = [];
    if (blueprint) {
      lightboxArr.push({
        src: blueprint,
        w: 0,
        h: 0
      });
    }
    if (hero) {
      lightboxArr.push({
        src: hero,
        w: 0,
        h: 0
      });
    }
    photos.forEach((photo) => {
      lightboxArr.push({
        src: photo.file,
        w: 0,
        h: 0
      });
    });
    lightboxArr.forEach((item, i2) => {
      const img = new Image();
      img.src = item.src;
      img.id = i2;
      img.onload = function() {
        lightboxArr[parseInt(img.id)].w = img.width;
        lightboxArr[parseInt(img.id)].h = img.height;
      };
    });
    setLightbox(lightboxArr);
  }, []);
  function openLightbox(index) {
    const pswpElement = document.querySelectorAll(".pswp")[0];
    const options = {
      history: false,
      focus: false,
      showAnimationDuration: 0,
      hideAnimationDuration: 0,
      fullscreenEl: false,
      zoomEl: false,
      shareEl: false
    };
    const gallery = new PhotoSwipe(
      pswpElement,
      PhotoSwipeUI_Default,
      lightbox,
      options
    );
    gallery.init();
    if (0 <= index) {
      gallery.goTo(index);
    }
  }
  let carouselItems = [];
  if (blueprint) {
    carouselItems.push(
      /* @__PURE__ */ jsxs(
        SwiperSlide,
        {
          onClick: () => openLightbox(0),
          className: "group !h-[120px] p-4",
          style: { backgroundColor: "#e8f6f7" },
          children: [
            /* @__PURE__ */ jsx(Overlay, {}),
            /* @__PURE__ */ jsx(
              "img",
              {
                className: "object-contain w-full h-full",
                src: blueprint,
                alt: t2("Blueprint")
              }
            )
          ]
        },
        "item-blueprint"
      )
    );
  }
  if (hero_thumbnail) {
    carouselItems.push(
      /* @__PURE__ */ jsxs(
        SwiperSlide,
        {
          onClick: () => openLightbox(1),
          className: "group !h-[120px]",
          children: [
            /* @__PURE__ */ jsx(Overlay, {}),
            /* @__PURE__ */ jsx("img", { className: "object-cover w-full h-full", src: hero_thumbnail, alt: "" })
          ]
        },
        "item-hero"
      )
    );
  }
  if (map) {
    carouselItems.push(
      /* @__PURE__ */ jsx(SwiperSlide, { children: /* @__PURE__ */ jsxs(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: `https://www.google.com/maps/search/?api=1&query=${map.props.latitude},${map.props.longitude}`,
          className: "relative block group !h-[120px]",
          children: [
            /* @__PURE__ */ jsx("div", { className: "w-full h-full", children: map }),
            /* @__PURE__ */ jsx(Overlay, {})
          ]
        },
        "item-map"
      ) })
    );
  }
  photos.forEach((photo, i2) => {
    let additionalImages = 0;
    blueprint && additionalImages++;
    hero && additionalImages++;
    carouselItems.push(
      /* @__PURE__ */ jsxs(
        SwiperSlide,
        {
          onClick: () => openLightbox(i2 + additionalImages),
          className: "group !h-[120px]",
          children: [
            /* @__PURE__ */ jsx(
              "img",
              {
                className: "object-cover w-full h-full",
                src: photo.file_thumbnail,
                alt: photo.title
              }
            ),
            /* @__PURE__ */ jsx(Overlay, {})
          ]
        },
        i2
      )
    );
  });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Swiper2,
      {
        spaceBetween: 15,
        slidesPerView: 2.5,
        centeredSlides: false,
        slidesOffsetBefore: 15,
        slidesOffsetAfter: 15,
        loop: true,
        breakpoints: {
          500: {
            slidesPerView: 3.5
          },
          700: {
            slidesPerView: 4.5
          },
          1e3: {
            slidesPerView: 5.5
          },
          1200: {
            slidesPerView: 7.5
          }
        },
        children: carouselItems
      }
    ),
    /* @__PURE__ */ jsx(Pswp, {})
  ] });
}
function ScoutPhotoSlider({
  blueprint,
  hero,
  hero_thumbnail,
  hasVirtualPresentation,
  photos,
  map,
  openIndex = null,
  setOpenIndex
}) {
  const { t: t2 } = useTranslation();
  const [lightbox, setLightbox] = useState$1([]);
  useEffect$1(() => {
    const lightboxArray = [];
    if (hero) {
      lightboxArray.push({
        src: hero,
        w: 0,
        h: 0
      });
    }
    if (blueprint) {
      lightboxArray.push({
        src: blueprint,
        w: 0,
        h: 0
      });
    }
    if (photos) {
      photos.forEach((photo) => {
        lightboxArray.push({
          src: photo.file,
          w: 0,
          h: 0
        });
      });
    }
    if (hasVirtualPresentation && hero && blueprint) {
      const tmp = lightboxArray[0];
      lightboxArray[0] = lightboxArray[1];
      lightboxArray[1] = tmp;
    }
    lightboxArray.forEach((item, i2) => {
      const img = new Image();
      img.src = item.src;
      img.id = i2;
      img.onload = () => {
        lightboxArray[parseInt(img.id)].w = img.width;
        lightboxArray[parseInt(img.id)].h = img.height;
      };
    });
    setLightbox(lightboxArray);
  }, []);
  const options = {
    history: false,
    focus: false,
    showAnimationDuration: 0,
    hideAnimationDuration: 0,
    fullscreenEl: false,
    zoomEl: false,
    shareEl: false
  };
  useEffect$1(() => {
    const pswpElement = document.querySelectorAll(".pswp")[0];
    if (openIndex !== null) {
      const gallery = new PhotoSwipe(
        pswpElement,
        PhotoSwipeUI_Default,
        lightbox,
        options
      );
      gallery.init();
      if (0 <= openIndex) {
        gallery.goTo(openIndex);
      }
      gallery.listen("close", () => {
        setOpenIndex(null);
      });
    }
  }, [openIndex]);
  const carouselItems = [];
  if (hasVirtualPresentation && map) {
    carouselItems.push(
      /* @__PURE__ */ jsx(SwiperSlide, { children: /* @__PURE__ */ jsxs(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: `https://www.google.com/maps/search/?api=1&query=${map.props.latitude},${map.props.longitude}`,
          className: "relative block group !h-[120px]",
          children: [
            /* @__PURE__ */ jsx("div", { className: "w-full h-full", children: map }),
            /* @__PURE__ */ jsx(Overlay, {})
          ]
        },
        "item-map"
      ) }, "item-map")
    );
  }
  if (hasVirtualPresentation && blueprint) {
    carouselItems.push(
      /* @__PURE__ */ jsxs(
        SwiperSlide,
        {
          onClick: () => setOpenIndex(0),
          className: "group !h-[120px] p-4",
          style: { backgroundColor: "#e8f6f7" },
          children: [
            /* @__PURE__ */ jsx(Overlay, {}),
            /* @__PURE__ */ jsx(
              "img",
              {
                className: "object-contain w-full h-full",
                src: blueprint,
                alt: t2("Blueprint")
              }
            )
          ]
        },
        "item-blueprint"
      )
    );
  }
  if (hasVirtualPresentation && hero) {
    carouselItems.push(
      /* @__PURE__ */ jsxs(
        SwiperSlide,
        {
          onClick: () => setOpenIndex(blueprint ? 1 : 0),
          className: "group !h-[120px]",
          children: [
            /* @__PURE__ */ jsx(Overlay, {}),
            /* @__PURE__ */ jsx("img", { className: "object-cover w-full h-full", src: hero_thumbnail, alt: "" })
          ]
        },
        "item-hero"
      )
    );
  }
  if (photos) {
    photos.forEach((photo, i2) => {
      let additionalImages = 0;
      hero && additionalImages++;
      blueprint && additionalImages++;
      const key = photo.file_thumbnail.split("/").pop();
      carouselItems.push(
        /* @__PURE__ */ jsxs(
          SwiperSlide,
          {
            onClick: () => setOpenIndex(i2 + additionalImages),
            className: "group !h-[120px]",
            children: [
              /* @__PURE__ */ jsx(
                "img",
                {
                  className: "object-cover w-full h-full",
                  src: photo.file_thumbnail,
                  alt: photo.title
                }
              ),
              /* @__PURE__ */ jsx(Overlay, {})
            ]
          },
          key
        )
      );
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Swiper2,
      {
        spaceBetween: 15,
        slidesPerView: 2.5,
        centeredSlides: false,
        slidesOffsetBefore: 15,
        slidesOffsetAfter: 15,
        breakpoints: {
          500: {
            slidesPerView: 3.5
          },
          700: {
            slidesPerView: 4.5
          },
          1e3: {
            slidesPerView: 5.5
          },
          1200: {
            slidesPerView: 7.5
          }
        },
        children: carouselItems
      }
    ),
    /* @__PURE__ */ jsx(Pswp, {})
  ] });
}
const SvgHousetype = (props) => /* @__PURE__ */ React$3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", x: 0, y: 0, viewBox: "0 0 64 70", xmlSpace: "preserve", ...props }, /* @__PURE__ */ React$3.createElement("path", { d: "M63 68h-7.8V13.8h2c.6 0 1-.4 1-1v-3c0-.4-.3-.8-.7-.9L32.3.1c-.2-.1-.5-.1-.7 0L6.5 8.9c-.4.2-.6.5-.6 1v3c0 .6.4 1 1 1h2V68H1c-.6 0-1 .4-1 1s.4 1 1 1H63c.6 0 1-.4 1-1s-.5-1-1-1zM7.9 10.6L32 2.1l24.1 8.5v1.2H7.8v-1.2zM28.5 68V55.2h6.9V68h-6.9zm8.9 0V54.2c0-.6-.4-1-1-1h-8.9c-.6 0-1 .4-1 1V68H10.8V13.8h42.3V68H37.4z" }), /* @__PURE__ */ React$3.createElement("path", { d: "M21.6 17.7h-5.9c-.6 0-1 .4-1 1v5.9c0 .6.4 1 1 1h5.9c.6 0 1-.4 1-1v-5.9c0-.5-.4-1-1-1zm-1 5.9h-3.9v-3.9h3.9v3.9zM36.4 17.7h-8.9c-.6 0-1 .4-1 1v5.9c0 .6.4 1 1 1h8.9c.6 0 1-.4 1-1v-5.9c0-.5-.4-1-1-1zm-1 5.9h-6.9v-3.9h6.9v3.9zM48.2 17.7h-5.9c-.6 0-1 .4-1 1v5.9c0 .6.4 1 1 1h5.9c.6 0 1-.4 1-1v-5.9c0-.5-.4-1-1-1zm-1 5.9h-3.9v-3.9h3.9v3.9zM21.6 29.5h-5.9c-.6 0-1 .4-1 1v5.9c0 .6.4 1 1 1h5.9c.6 0 1-.4 1-1v-5.9c0-.5-.4-1-1-1zm-1 6h-3.9v-3.9h3.9v3.9zM36.4 29.5h-8.9c-.6 0-1 .4-1 1v5.9c0 .6.4 1 1 1h8.9c.6 0 1-.4 1-1v-5.9c0-.5-.4-1-1-1zm-1 6h-6.9v-3.9h6.9v3.9zM48.2 29.5h-5.9c-.6 0-1 .4-1 1v5.9c0 .6.4 1 1 1h5.9c.6 0 1-.4 1-1v-5.9c0-.5-.4-1-1-1zm-1 6h-3.9v-3.9h3.9v3.9zM21.6 41.4h-5.9c-.6 0-1 .4-1 1v5.9c0 .6.4 1 1 1h5.9c.6 0 1-.4 1-1v-5.9c0-.6-.4-1-1-1zm-1 5.9h-3.9v-3.9h3.9v3.9zM36.4 41.4h-8.9c-.6 0-1 .4-1 1v5.9c0 .6.4 1 1 1h8.9c.6 0 1-.4 1-1v-5.9c0-.6-.4-1-1-1zm-1 5.9h-6.9v-3.9h6.9v3.9zM48.2 41.4h-5.9c-.6 0-1 .4-1 1v5.9c0 .6.4 1 1 1h5.9c.6 0 1-.4 1-1v-5.9c0-.6-.4-1-1-1zm-1 5.9h-3.9v-3.9h3.9v3.9zM21.6 53.2h-5.9c-.6 0-1 .4-1 1v5.9c0 .6.4 1 1 1h5.9c.6 0 1-.4 1-1v-5.9c0-.6-.4-1-1-1zm-1 5.9h-3.9v-3.9h3.9v3.9zM48.2 53.2h-5.9c-.6 0-1 .4-1 1v5.9c0 .6.4 1 1 1h5.9c.6 0 1-.4 1-1v-5.9c0-.6-.4-1-1-1zm-1 5.9h-3.9v-3.9h3.9v3.9z" }));
const SvgBuilt = (props) => /* @__PURE__ */ React$3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", x: 0, y: 0, viewBox: "0 0 66 66", xmlSpace: "preserve", ...props }, /* @__PURE__ */ React$3.createElement("path", { d: "M65 11.1h-7.4V1c0-.3-.1-.6-.4-.8-.2-.2-.5-.2-.8-.2L36.9 5.6c-.4.1-.7.5-.7 1v4.6H1c-.6 0-1 .4-1 1v8.4c0 .6.4 1 1 1h7.4v10.6c-2.9.5-5 3.2-5 6.5 0 3.5 3.3 6.6 7.1 6.6 3.5 0 6.2-2.8 6.2-6.6 0-.6-.4-1-1-1s-1 .4-1 1c0 2.6-1.8 4.6-4.2 4.6-2.7 0-5.1-2.2-5.1-4.6 0-2.5 1.8-4.6 4-4.6.6 0 1-.4 1-1V21.5h31.4V65c0 .6.4 1 1 1h11.1c.6 0 1-.4 1-1V21.5H65c.6 0 1-.4 1-1v-8.4c0-.5-.4-1-1-1zm-63 2h34.2v6.4H2v-6.4zm36.2-1V7.3l17.5-5V19.5H38.2v-7.4zM52.9 64h-9.1V21.5h9.1V64zM64 19.5h-6.4v-6.4H64v6.4z" }), /* @__PURE__ */ React$3.createElement("path", { d: "M34.4 50.1H1c-.6 0-1 .4-1 1V65c0 .6.4 1 1 1h33.4c.6 0 1-.4 1-1V51.1c0-.5-.4-1-1-1zm-1 13.9H2V52.1h31.4V64z" }));
const SvgLot = (props) => /* @__PURE__ */ React$3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 38 36.5", ...props }, /* @__PURE__ */ React$3.createElement("path", { d: "M13.8 27.7c.9 0 1.7-.7 1.8-1.7l-1.5-4.9c-1.3-.1-2.5.4-3.5 1.2-1 .9-1.7 2.2-1.7 3.6v1.7h4.9zm-10.9 0h4.9V26c0-1.4-.6-2.7-1.7-3.6-1-.8-2.2-1.3-3.5-1.2L1.2 26c0 .9.8 1.7 1.7 1.7zM8.4 2.5L4.6 14.6c1 0 2 .4 2.7 1.1.2.1.3.3.4.4v-4.8c0-.3.3-.6.6-.6s.6.3.6.6v4.8l.4-.4c.8-.7 1.7-1 2.7-1.1L8.4 2.5zM8.9 19v3.4c.3-.4.6-.7.9-1 1.1-.9 2.5-1.5 3.9-1.5l-1.3-4.3c-.8 0-1.7.2-2.3.8-.8.7-1.2 1.6-1.2 2.6zm-4.6-3.3L3 20c1.4 0 2.8.5 3.9 1.5.3.3.6.6.9 1V19c0-1-.4-1.9-1.2-2.5-.6-.5-1.4-.8-2.3-.8zM8.9.4l7.8 25.4v.2c0 1.6-1.3 2.9-2.9 2.9H8.9V36c0 .3-.3.6-.6.6s-.6-.3-.6-.6v-7.1H2.9C1.3 28.9 0 27.6 0 26v-.2l1.6-5.3L7.7.5c.2-.3.4-.5.7-.5.2 0 .4.2.5.4zm19.2 24.9c4.9-.3 8.8-4.4 8.8-9.4 0-5.2-4.2-9.4-9.4-9.4s-9.4 4.2-9.4 9.4c0 5 3.9 9.1 8.8 9.4v-5.5c0-1.8-1.5-3.3-3.3-3.3-.3 0-.6-.2-.6-.6 0-.3.2-.6.6-.6 1.3 0 2.5.6 3.3 1.5v-4c0-.3.2-.6.6-.6s.6.2.6.6V20c.8-1.1 1.8-2 3.1-2.4.3-.1.6.1.7.4.1.3-.1.6-.4.7-2 .6-3.4 2.7-3.4 4.8v1.8zM38 16c0 5.6-4.4 10.2-9.9 10.5v9.4c0 .3-.2.6-.6.6s-.5-.3-.5-.6v-9.4c-5.6-.3-10-4.9-10-10.5 0-5.8 4.7-10.5 10.5-10.5S38 10.2 38 16z", fillRule: "evenodd", clipRule: "evenodd" }));
const SvgMaintenance = (props) => /* @__PURE__ */ React$3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 29.7 29.2", ...props }, /* @__PURE__ */ React$3.createElement("path", { d: "M9.908 17.562l-7.8 7.7c-.3.3-.4.6-.4.9 0 .4.1.7.4.9.3.3.6.4 1 .4s.7-.1 1-.4l7.8-7.7m15.3-18.2l-3.6 2.4 1.2 1.2 1.1 1 2.6-3.4-1.3-1.2zm-15.3 17l2.3 2.2c.2.2.2.5 0 .7-.1.1-.2.1-.4.1-.1 0-.3 0-.4-.1l-.9-.9-7.8 7.7c-.4.4-1 .7-1.7.7-.6 0-1.2-.2-1.7-.7-.4-.4-.7-1-.7-1.6 0-.6.2-1.2.7-1.7l7.8-7.7-1-.9c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0l2.3 2.2 12.7-12.4-1.3-1.2c-.1-.1-.2-.3-.1-.4 0-.1.1-.3.2-.4l4.4-3c.2-.1.5-.1.6.1l1.9 1.8c.2.2.2.5 0 .7l-3.2 4.2c-.1.1-.2.2-.4.2-.1 0-.3-.1-.4-.1l-1-1.2-12.6 12.4zm-4.6-7.7c-2 .7-4.2.2-5.7-1.3-1.6-1.6-2-3.9-1.2-5.9.1 0 .2-.1.4-.2.2 0 .3 0 .5.1l2.4 2.3h2v-1.8l-2.4-2.4c-.2-.1-.2-.3-.2-.5s.1-.3.3-.4c2.1-.8 4.4-.3 5.9 1.2s2 3.6 1.3 5.6l4.4 4.4c.2.2.2.5 0 .7-.2.2-.5.2-.7 0l-4.7-4.6c-.1-.1-.1-.4 0-.5.7-1.7.3-3.6-1-4.8-1.1-1.2-2.6-1.6-4.1-1.2l2 2c.1.1.1.2.1.3v2.5c0 .3-.2.5-.5.5h-2.6c-.1 0-.3 0-.4-.1l-2-1.9c-.3 1.4.1 3 1.2 4.1 1.3 1.3 3.2 1.6 4.9.9.2-.1.4 0 .6.1l4.7 4.6c.2.2.2.5 0 .7-.1.1-.2.1-.4.1s-.3 0-.4-.1l-4.4-4.4zm15 8.2c2-.7 4.2-.2 5.7 1.3 1.6 1.6 2 3.9 1.2 5.9-.1.2-.2.3-.4.3s-.3 0-.5-.1l-2.5-2.3h-1.8v1.7l2.4 2.4c.1.1.2.3.1.4 0 .2-.1.3-.3.4-.7.3-1.4.4-2.1.4-1.4 0-2.8-.5-3.9-1.6-1.5-1.5-2-3.6-1.3-5.6l-4.4-4.4c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0l4.7 4.6c.1.1.2.4.1.5-.7 1.7-.3 3.5 1 4.8 1.1 1.1 2.7 1.5 4.2 1.2l-2-2c-.1-.1-.1-.2-.1-.3v-2.4c0-.3.2-.5.5-.5h2.5c.1 0 .3 0 .3.1l2.1 1.9c.4-1.5-.1-3-1.2-4.1-1.3-1.3-3.2-1.6-4.9-.9-.2.1-.4 0-.6-.1l-4.7-4.6c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0l4.5 4.4z", fillRule: "evenodd", clipRule: "evenodd" }));
const SvgMonthlyFeeSe = (props) => /* @__PURE__ */ React$3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", x: 0, y: 0, viewBox: "0 0 36.7 36.7", xmlSpace: "preserve", enableBackground: "new 0 0 36.7 36.7", ...props }, /* @__PURE__ */ React$3.createElement("g", { id: "Kohdesivu-v2-desktop", transform: "translate(-1011 -554)" }, /* @__PURE__ */ React$3.createElement("g", { id: "Group-8", transform: "translate(1011 554)" }, /* @__PURE__ */ React$3.createElement("g", { id: "Group-3" }, /* @__PURE__ */ React$3.createElement("defs", null, /* @__PURE__ */ React$3.createElement("filter", { id: "Adobe_OpacityMaskFilter", filterUnits: "userSpaceOnUse", x: 0, y: 0, width: 36.7, height: 36.7 }, /* @__PURE__ */ React$3.createElement("feColorMatrix", { values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" }))), /* @__PURE__ */ React$3.createElement("mask", { maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 36.7, height: 36.7, id: "mask-2_1_" }, /* @__PURE__ */ React$3.createElement("g", { filter: "url(#Adobe_OpacityMaskFilter)" }, /* @__PURE__ */ React$3.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#fff", d: "M0 0h36.7v36.7H0z" }))), /* @__PURE__ */ React$3.createElement("path", { d: "M18.4 1.1C8.9 1.1 1.1 8.9 1.1 18.4s7.7 17.2 17.2 17.2 17.2-7.7 17.2-17.2S27.9 1.1 18.4 1.1m0 35.6C8.2 36.7 0 28.5 0 18.4 0 8.2 8.2 0 18.4 0s18.4 8.2 18.4 18.4c-.1 10.1-8.3 18.3-18.4 18.3", mask: "url(#mask-2_1_)", fillRule: "evenodd", clipRule: "evenodd", fill: "#022640" })), /* @__PURE__ */ React$3.createElement("path", { id: "Fill-4", className: "st3", d: "M10 13.7h1.6v3.4l3.1-3.4h2L13 17.5l4 4.2h-2.1l-3.3-3.5v3.5H10z" }), /* @__PURE__ */ React$3.createElement("path", { id: "Fill-6", className: "st3", d: "M21.5 17.6h.7c1 0 1.6-.4 1.6-1.3 0-.4-.1-.7-.4-.9s-.7-.4-1.2-.4h-.8v2.6zM20 13.7h2.5c.9 0 1.5.2 2 .7.5.5.7 1.1.7 1.9 0 .5-.1.9-.3 1.3-.2.4-.5.7-.9.9l2 3.3h-1.7l-1.6-2.9h-1.2v2.9H20v-8.1z" }))));
const FI = {
  show_postcode: true,
  operational_areas: [
    "Helsinki",
    "Kauniainen",
    "Espoo",
    "Vantaa"
  ]
};
const SE = {
  show_postcode: false,
  operational_areas: [
    "Botkyrka",
    "Danderyd",
    "Ekerö",
    "Haninge",
    "Huddinge",
    "Järfälla",
    "Lidingö",
    "Nacka",
    "Salem",
    "Sigtuna",
    "Sollentuna",
    "Solna",
    "Stockholm",
    "Sundbyberg",
    "Tyresö",
    "Täby",
    "Upplands Väsby",
    "Upplands-Bro",
    "Vallentuna",
    "Vaxholm",
    "Värmdö",
    "Österåker"
  ]
};
const NO = {
  show_postcode: false
};
const bsConfig = {
  FI,
  SE,
  NO
};
var freeGlobal$2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$2;
var freeGlobal$1 = _freeGlobal;
var freeSelf$1 = typeof self == "object" && self && self.Object === Object && self;
var root$b = freeGlobal$1 || freeSelf$1 || Function("return this")();
var _root = root$b;
var reWhitespace = /\s/;
function trimmedEndIndex$1(string) {
  var index = string.length;
  while (index-- && reWhitespace.test(string.charAt(index))) {
  }
  return index;
}
var _trimmedEndIndex = trimmedEndIndex$1;
var trimmedEndIndex = _trimmedEndIndex;
var reTrimStart = /^\s+/;
function baseTrim$1(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
}
var _baseTrim = baseTrim$1;
function isObject$7(value) {
  var type2 = typeof value;
  return value != null && (type2 == "object" || type2 == "function");
}
var isObject_1 = isObject$7;
var root$a = _root;
var Symbol$6 = root$a.Symbol;
var _Symbol = Symbol$6;
var Symbol$5 = _Symbol;
var objectProto$c = Object.prototype;
var hasOwnProperty$9 = objectProto$c.hasOwnProperty;
var nativeObjectToString$1 = objectProto$c.toString;
var symToStringTag$1 = Symbol$5 ? Symbol$5.toStringTag : void 0;
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$9.call(value, symToStringTag$1), tag2 = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e2) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag2;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag$1;
var objectProto$b = Object.prototype;
var nativeObjectToString = objectProto$b.toString;
function objectToString$2(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$2;
var Symbol$4 = _Symbol, getRawTag = _getRawTag, objectToString$1 = _objectToString;
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$4 ? Symbol$4.toStringTag : void 0;
function baseGetTag$5(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString$1(value);
}
var _baseGetTag = baseGetTag$5;
function isObjectLike$6(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_1 = isObjectLike$6;
var baseGetTag$4 = _baseGetTag, isObjectLike$5 = isObjectLike_1;
var symbolTag$2 = "[object Symbol]";
function isSymbol$6(value) {
  return typeof value == "symbol" || isObjectLike$5(value) && baseGetTag$4(value) == symbolTag$2;
}
var isSymbol_1 = isSymbol$6;
var baseTrim = _baseTrim, isObject$6 = isObject_1, isSymbol$5 = isSymbol_1;
var NAN$1 = 0 / 0;
var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary$1 = /^0b[01]+$/i;
var reIsOctal$1 = /^0o[0-7]+$/i;
var freeParseInt$1 = parseInt;
function toNumber$4(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol$5(value)) {
    return NAN$1;
  }
  if (isObject$6(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$6(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary2 = reIsBinary$1.test(value);
  return isBinary2 || reIsOctal$1.test(value) ? freeParseInt$1(value.slice(2), isBinary2 ? 2 : 8) : reIsBadHex$1.test(value) ? NAN$1 : +value;
}
var toNumber_1 = toNumber$4;
var toNumber$3 = toNumber_1;
var INFINITY$2 = 1 / 0, MAX_INTEGER = 17976931348623157e292;
function toFinite$1(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber$3(value);
  if (value === INFINITY$2 || value === -INFINITY$2) {
    var sign2 = value < 0 ? -1 : 1;
    return sign2 * MAX_INTEGER;
  }
  return value === value ? value : 0;
}
var toFinite_1 = toFinite$1;
var toFinite = toFinite_1;
function toInteger$1(value) {
  var result = toFinite(value), remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}
var toInteger_1 = toInteger$1;
function arrayMap$2(array, iteratee) {
  var index = -1, length = array == null ? 0 : array.length, result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}
var _arrayMap = arrayMap$2;
var isArray$a = Array.isArray;
var isArray_1 = isArray$a;
var Symbol$3 = _Symbol, arrayMap$1 = _arrayMap, isArray$9 = isArray_1, isSymbol$4 = isSymbol_1;
var INFINITY$1 = 1 / 0;
var symbolProto$1 = Symbol$3 ? Symbol$3.prototype : void 0, symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString$1(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray$9(value)) {
    return arrayMap$1(value, baseToString$1) + "";
  }
  if (isSymbol$4(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$1 ? "-0" : result;
}
var _baseToString = baseToString$1;
var baseToString = _baseToString;
function toString$2(value) {
  return value == null ? "" : baseToString(value);
}
var toString_1 = toString$2;
var root$9 = _root, toInteger = toInteger_1, toNumber$2 = toNumber_1, toString$1 = toString_1;
var nativeIsFinite = root$9.isFinite, nativeMin$2 = Math.min;
function createRound$1(methodName) {
  var func = Math[methodName];
  return function(number, precision) {
    number = toNumber$2(number);
    precision = precision == null ? 0 : nativeMin$2(toInteger(precision), 292);
    if (precision && nativeIsFinite(number)) {
      var pair = (toString$1(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
      pair = (toString$1(value) + "e").split("e");
      return +(pair[0] + "e" + (+pair[1] - precision));
    }
    return func(number);
  };
}
var _createRound = createRound$1;
var createRound = _createRound;
var round$1 = createRound("round");
var round_1 = round$1;
function formatCurrency(price, currency, shouldRound = true, minimumFractionDigits = 2) {
  if (shouldRound) {
    price = round_1(price);
  }
  const value = new Intl.NumberFormat("fi-FI", { minimumFractionDigits, style: "decimal" }).format(price);
  if (currency)
    return `${value} ${currency}`;
  return value;
}
function getLanguageCode() {
  return document.documentElement.lang;
}
function luxonDateFormat(languageCode) {
  return {
    en: "yyyy-MM-dd",
    fi: "dd.MM.yyyy",
    sv: "yyyy-MM-dd"
  }[languageCode] || "dd.MM.yyyy";
}
function luxonShortDateFormat(languageCode) {
  return {
    en: "MM/dd",
    fi: "dd.MM",
    sv: "MM/dd"
  }[languageCode] || "dd.MM";
}
function getLuxonDateFormat() {
  return luxonDateFormat(getLanguageCode());
}
function getLuxonShortDateFormat() {
  return luxonShortDateFormat(getLanguageCode());
}
function getCategoryDisplay(category) {
  return {
    "apartment_house": instance.t("Apartment house"),
    "terraced_house": instance.t("Terraced house"),
    "semidetached_house": instance.t("Semi-detached house"),
    "detached_house": instance.t("Detached house"),
    "linked_house": instance.t("Linked house"),
    "loft": instance.t("Loft"),
    "wooden_house": instance.t("Wooden house")
  }[category];
}
function getLotOwnershipDisplay(country, lot_ownership_type) {
  return {
    "FI": {
      "own": instance.t("Own"),
      "rent": instance.t("Rent"),
      "redeemable": instance.t("Rent, optional")
    },
    "SE": {
      "own": instance.t("Owns the land"),
      "rent": instance.t("Long lease")
    }
  }[country][lot_ownership_type];
}
function getCurrencyDisplay(currency) {
  return {
    "EUR": "€",
    "SEK": "kr",
    "NOK": "kr",
    "DKK": "kr"
  }[currency];
}
function getCurrencyDisplayFromCountry(country) {
  return getCurrencyDisplay({
    "FI": "EUR",
    "SE": "SEK",
    "NO": "NOK"
  }[country]);
}
function _getFeeUnitDisplay(fee_unit) {
  return {
    "per_month": instance.t("Month"),
    "per_cubic_meter": instance.t("Cubic meter"),
    "per_person": instance.t("Person"),
    "per_person_per_month": instance.t("Per person per month"),
    "per_use": instance.t("Use"),
    "per_use_per_month": instance.t("Per use per month"),
    "per_year": instance.t("Year"),
    "per_kilowatt_hour": instance.t("Kilowatt hour"),
    "per_kilowatt_hour_per_square_meter_per_year": instance.t("kWh/m²/year")
  }[fee_unit];
}
function _getFeeDisplay(fee, currency) {
  const amount = Number(fee.amount);
  return {
    "name": fee.name,
    "value": `${formatCurrency(amount, getCurrencyDisplay(currency), false)} / ${_getFeeUnitDisplay(fee.unit)}`,
    "description": fee.description
  };
}
function getFeesDisplay(fees, currency) {
  let feesDisplay = [];
  fees.forEach((fee) => {
    const formattedFee = _getFeeDisplay(fee, currency);
    feesDisplay.push(formattedFee);
  });
  return feesDisplay;
}
function getMaintenanceFeeDisplay(fees, currency) {
  fees = fees || [];
  for (const fee of fees) {
    if (fee.category === "maintenance") {
      const maintenanceFee = _getFeeDisplay(fee, currency);
      return `${maintenanceFee.value} ${maintenanceFee.description ? `- ${maintenanceFee.description}` : ""}`;
    }
  }
  return "-";
}
function getAssociationFeeDisplay(fees, currency) {
  fees = fees || [];
  for (const fee of fees) {
    if (fee.category === "association") {
      const associationFee = _getFeeDisplay(fee, currency);
      return `${associationFee.value} ${associationFee.description ? `(${associationFee.description})` : ""}`;
    }
  }
  return "-";
}
function getConditionDisplay(condition2) {
  return {
    "new": instance.t("New"),
    "excellent": instance.t("Excellent"),
    "good": instance.t("Good"),
    "satisfactory": instance.t("Satisfactory"),
    "poor": instance.t("Poor"),
    "unlivable": instance.t("Unlivable"),
    "unknown": instance.t("Unknown")
  }[condition2];
}
function getPriceDisplay(listingInfo, listingSold, price) {
  var _a;
  let priceDisplay = price;
  if (listingSold) {
    priceDisplay = instance.t("Sold");
  } else if (((_a = listingInfo.apartment_se) == null ? void 0 : _a.listing_market_state) === "upcoming") {
    priceDisplay = "Pre Sale";
  }
  return priceDisplay;
}
function getRoomDisplay(room_count) {
  room_count = Number(room_count);
  if (Number.isInteger(room_count)) {
    return `${room_count.toFixed()} ${instance.t("rm")}`;
  }
  return `${room_count.toString().replaceAll(".", ",")} ${instance.t("rm")}`;
}
function getAreaDisplay(area_living, area_unit) {
  area_living = Number(area_living);
  if (Number.isInteger(area_living)) {
    return `${area_living.toFixed()} ${area_unit ? area_unit : "m²"}`;
  }
  return `${area_living.toFixed(2).toString().replaceAll(".", ",")} ${area_unit ? area_unit : "m²"}`;
}
const ScoutHeader = ({ listingInfo, country }) => {
  const { t: t2 } = useTranslation();
  const {
    building_construction_year,
    category,
    currency,
    fees,
    location_street_address,
    location_specifier,
    location_postcode,
    location_municipality,
    location_neighborhood,
    location_neighborhood_other,
    lot_ownership_type,
    case_type,
    price_display,
    area_living,
    floorplan_description
  } = listingInfo;
  const priceDisplay = getPriceDisplay(listingInfo, false, price_display);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: "text-gray-800", children: [
      /* @__PURE__ */ jsxs("h1", { className: "mb-4 text-blue-500 h3", children: [
        location_street_address ? /* @__PURE__ */ jsxs(Fragment, { children: [
          location_street_address,
          " ",
          location_specifier
        ] }) : /* @__PURE__ */ jsx(Fragment, { children: location_neighborhood_other || location_neighborhood || location_municipality }),
        /* @__PURE__ */ jsx("br", {}),
        bsConfig[country].show_postcode && /* @__PURE__ */ jsxs(Fragment, { children: [
          location_postcode,
          " "
        ] }),
        location_municipality
      ] }),
      /* @__PURE__ */ jsxs("div", { children: [
        case_type === "realty" && price_display && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("p", { children: t2("bs_asking_price") }),
          /* @__PURE__ */ jsx("h4", { className: "mb-4 text-blue-500", children: priceDisplay })
        ] }),
        /* @__PURE__ */ jsx("p", { className: "text-[17px] leading-relaxed", children: floorplan_description }),
        /* @__PURE__ */ jsx("p", { children: getAreaDisplay(area_living) })
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "grid text-gray-800 max-w-md grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-2", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-center space-x-2", children: [
        /* @__PURE__ */ jsx(SvgHousetype, { className: "flex-shrink-0 text-blue-500 fill-current w-11" }),
        /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("p", { className: "mb-1 text-sm", children: t2("type") }),
          /* @__PURE__ */ jsx("b", { className: "text-blue-500", children: getCategoryDisplay(category) })
        ] })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "flex items-center space-x-2", children: [
        /* @__PURE__ */ jsx(SvgBuilt, { className: "flex-shrink-0 text-blue-500 fill-current w-11" }),
        /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("p", { className: "mb-1 text-sm", children: t2("build_in") }),
          /* @__PURE__ */ jsx("b", { className: "text-blue-500", children: building_construction_year ? building_construction_year : "-" })
        ] })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "flex items-center space-x-2", children: [
        country === "FI" && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(SvgMaintenance, { className: "flex-shrink-0 text-blue-500 fill-current w-11" }),
          /* @__PURE__ */ jsxs("div", { children: [
            /* @__PURE__ */ jsx("p", { className: "mb-1 text-sm", children: t2("maintenance_fee") }),
            /* @__PURE__ */ jsx("b", { className: "text-blue-500", children: getMaintenanceFeeDisplay(fees, currency) })
          ] })
        ] }),
        country === "SE" && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(SvgMonthlyFeeSe, { className: "flex-shrink-0 text-blue-500 fill-current w-11" }),
          /* @__PURE__ */ jsxs("div", { children: [
            /* @__PURE__ */ jsx("p", { className: "mb-1 text-sm", children: t2("association_fee") }),
            /* @__PURE__ */ jsx("b", { className: "text-blue-500", children: getAssociationFeeDisplay(fees, currency) })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "flex items-center space-x-2", children: [
        /* @__PURE__ */ jsx(SvgLot, { className: "flex-shrink-0 text-blue-500 fill-current w-11" }),
        /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("p", { className: "mb-1 text-sm", children: t2(`lot_${country}`) }),
          /* @__PURE__ */ jsx("b", { className: "text-blue-500", children: getLotOwnershipDisplay(country, lot_ownership_type) })
        ] })
      ] })
    ] })
  ] });
};
function useWindowSize() {
  const [windowSize, setWindowSize] = useState$1({
    width: void 0,
    height: void 0
  });
  useEffect$1(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowSize;
}
var latinizeExports = {};
var latinize$1 = {
  get exports() {
    return latinizeExports;
  },
  set exports(v2) {
    latinizeExports = v2;
  }
};
(function(module, exports) {
  (function(root2, factory) {
    {
      module.exports = factory();
    }
  })(commonjsGlobal, function() {
    function latinize2(str) {
      if (typeof str === "string") {
        return str.replace(/[^A-Za-z0-9]/g, function(x2) {
          return latinize2.characters[x2] || x2;
        });
      } else {
        return str;
      }
    }
    latinize2.characters = {
      "Á": "A",
      "Ă": "A",
      "Ắ": "A",
      "Ặ": "A",
      "Ằ": "A",
      "Ẳ": "A",
      "Ẵ": "A",
      "Ǎ": "A",
      "Â": "A",
      "Ấ": "A",
      "Ậ": "A",
      "Ầ": "A",
      "Ẩ": "A",
      "Ẫ": "A",
      "Ä": "A",
      "Ǟ": "A",
      "Ȧ": "A",
      "Ǡ": "A",
      "Ạ": "A",
      "Ȁ": "A",
      "À": "A",
      "Ả": "A",
      "Ȃ": "A",
      "Ā": "A",
      "Ą": "A",
      "Å": "A",
      "Ǻ": "A",
      "Ḁ": "A",
      "Ⱥ": "A",
      "Ã": "A",
      "Ꜳ": "AA",
      "Æ": "AE",
      "Ǽ": "AE",
      "Ǣ": "AE",
      "Ꜵ": "AO",
      "Ꜷ": "AU",
      "Ꜹ": "AV",
      "Ꜻ": "AV",
      "Ꜽ": "AY",
      "Ḃ": "B",
      "Ḅ": "B",
      "Ɓ": "B",
      "Ḇ": "B",
      "Ƀ": "B",
      "Ƃ": "B",
      "Ć": "C",
      "Č": "C",
      "Ç": "C",
      "Ḉ": "C",
      "Ĉ": "C",
      "Ċ": "C",
      "Ƈ": "C",
      "Ȼ": "C",
      "Ď": "D",
      "Ḑ": "D",
      "Ḓ": "D",
      "Ḋ": "D",
      "Ḍ": "D",
      "Ɗ": "D",
      "Ḏ": "D",
      "ǲ": "D",
      "ǅ": "D",
      "Đ": "D",
      "Ð": "D",
      "Ƌ": "D",
      "Ǳ": "DZ",
      "Ǆ": "DZ",
      "É": "E",
      "Ĕ": "E",
      "Ě": "E",
      "Ȩ": "E",
      "Ḝ": "E",
      "Ê": "E",
      "Ế": "E",
      "Ệ": "E",
      "Ề": "E",
      "Ể": "E",
      "Ễ": "E",
      "Ḙ": "E",
      "Ë": "E",
      "Ė": "E",
      "Ẹ": "E",
      "Ȅ": "E",
      "È": "E",
      "Ẻ": "E",
      "Ȇ": "E",
      "Ē": "E",
      "Ḗ": "E",
      "Ḕ": "E",
      "Ę": "E",
      "Ɇ": "E",
      "Ẽ": "E",
      "Ḛ": "E",
      "Ꝫ": "ET",
      "Ḟ": "F",
      "Ƒ": "F",
      "Ǵ": "G",
      "Ğ": "G",
      "Ǧ": "G",
      "Ģ": "G",
      "Ĝ": "G",
      "Ġ": "G",
      "Ɠ": "G",
      "Ḡ": "G",
      "Ǥ": "G",
      "Ḫ": "H",
      "Ȟ": "H",
      "Ḩ": "H",
      "Ĥ": "H",
      "Ⱨ": "H",
      "Ḧ": "H",
      "Ḣ": "H",
      "Ḥ": "H",
      "Ħ": "H",
      "Í": "I",
      "Ĭ": "I",
      "Ǐ": "I",
      "Î": "I",
      "Ï": "I",
      "Ḯ": "I",
      "İ": "I",
      "Ị": "I",
      "Ȉ": "I",
      "Ì": "I",
      "Ỉ": "I",
      "Ȋ": "I",
      "Ī": "I",
      "Į": "I",
      "Ɨ": "I",
      "Ĩ": "I",
      "Ḭ": "I",
      "І": "I",
      "Ꝺ": "D",
      "Ꝼ": "F",
      "Ᵹ": "G",
      "Ꞃ": "R",
      "Ꞅ": "S",
      "Ꞇ": "T",
      "Ꝭ": "IS",
      "Ĵ": "J",
      "Ɉ": "J",
      "Ḱ": "K",
      "Ǩ": "K",
      "Ķ": "K",
      "Ⱪ": "K",
      "Ꝃ": "K",
      "Ḳ": "K",
      "Ƙ": "K",
      "Ḵ": "K",
      "Ꝁ": "K",
      "Ꝅ": "K",
      "Ĺ": "L",
      "Ƚ": "L",
      "Ľ": "L",
      "Ļ": "L",
      "Ḽ": "L",
      "Ḷ": "L",
      "Ḹ": "L",
      "Ⱡ": "L",
      "Ꝉ": "L",
      "Ḻ": "L",
      "Ŀ": "L",
      "Ɫ": "L",
      "ǈ": "L",
      "Ł": "L",
      "Ǉ": "LJ",
      "Ḿ": "M",
      "Ṁ": "M",
      "Ṃ": "M",
      "Ɱ": "M",
      "Ń": "N",
      "Ň": "N",
      "Ņ": "N",
      "Ṋ": "N",
      "Ṅ": "N",
      "Ṇ": "N",
      "Ǹ": "N",
      "Ɲ": "N",
      "Ṉ": "N",
      "Ƞ": "N",
      "ǋ": "N",
      "Ñ": "N",
      "Ǌ": "NJ",
      "Ó": "O",
      "Ŏ": "O",
      "Ǒ": "O",
      "Ô": "O",
      "Ố": "O",
      "Ộ": "O",
      "Ồ": "O",
      "Ổ": "O",
      "Ỗ": "O",
      "Ö": "O",
      "Ȫ": "O",
      "Ȯ": "O",
      "Ȱ": "O",
      "Ọ": "O",
      "Ő": "O",
      "Ȍ": "O",
      "Ò": "O",
      "Ỏ": "O",
      "Ơ": "O",
      "Ớ": "O",
      "Ợ": "O",
      "Ờ": "O",
      "Ở": "O",
      "Ỡ": "O",
      "Ȏ": "O",
      "Ꝋ": "O",
      "Ꝍ": "O",
      "Ō": "O",
      "Ṓ": "O",
      "Ṑ": "O",
      "Ɵ": "O",
      "Ǫ": "O",
      "Ǭ": "O",
      "Ø": "O",
      "Ǿ": "O",
      "Õ": "O",
      "Ṍ": "O",
      "Ṏ": "O",
      "Ȭ": "O",
      "Ƣ": "OI",
      "Ꝏ": "OO",
      "Ɛ": "E",
      "Ɔ": "O",
      "Ȣ": "OU",
      "Ṕ": "P",
      "Ṗ": "P",
      "Ꝓ": "P",
      "Ƥ": "P",
      "Ꝕ": "P",
      "Ᵽ": "P",
      "Ꝑ": "P",
      "Ꝙ": "Q",
      "Ꝗ": "Q",
      "Ŕ": "R",
      "Ř": "R",
      "Ŗ": "R",
      "Ṙ": "R",
      "Ṛ": "R",
      "Ṝ": "R",
      "Ȑ": "R",
      "Ȓ": "R",
      "Ṟ": "R",
      "Ɍ": "R",
      "Ɽ": "R",
      "Ꜿ": "C",
      "Ǝ": "E",
      "Ś": "S",
      "Ṥ": "S",
      "Š": "S",
      "Ṧ": "S",
      "Ş": "S",
      "Ŝ": "S",
      "Ș": "S",
      "Ṡ": "S",
      "Ṣ": "S",
      "Ṩ": "S",
      "ß": "ss",
      "Ť": "T",
      "Ţ": "T",
      "Ṱ": "T",
      "Ț": "T",
      "Ⱦ": "T",
      "Ṫ": "T",
      "Ṭ": "T",
      "Ƭ": "T",
      "Ṯ": "T",
      "Ʈ": "T",
      "Ŧ": "T",
      "Ɐ": "A",
      "Ꞁ": "L",
      "Ɯ": "M",
      "Ʌ": "V",
      "Ꜩ": "TZ",
      "Ú": "U",
      "Ŭ": "U",
      "Ǔ": "U",
      "Û": "U",
      "Ṷ": "U",
      "Ü": "U",
      "Ǘ": "U",
      "Ǚ": "U",
      "Ǜ": "U",
      "Ǖ": "U",
      "Ṳ": "U",
      "Ụ": "U",
      "Ű": "U",
      "Ȕ": "U",
      "Ù": "U",
      "Ủ": "U",
      "Ư": "U",
      "Ứ": "U",
      "Ự": "U",
      "Ừ": "U",
      "Ử": "U",
      "Ữ": "U",
      "Ȗ": "U",
      "Ū": "U",
      "Ṻ": "U",
      "Ų": "U",
      "Ů": "U",
      "Ũ": "U",
      "Ṹ": "U",
      "Ṵ": "U",
      "Ꝟ": "V",
      "Ṿ": "V",
      "Ʋ": "V",
      "Ṽ": "V",
      "Ꝡ": "VY",
      "Ẃ": "W",
      "Ŵ": "W",
      "Ẅ": "W",
      "Ẇ": "W",
      "Ẉ": "W",
      "Ẁ": "W",
      "Ⱳ": "W",
      "Ẍ": "X",
      "Ẋ": "X",
      "Ý": "Y",
      "Ŷ": "Y",
      "Ÿ": "Y",
      "Ẏ": "Y",
      "Ỵ": "Y",
      "Ỳ": "Y",
      "Ƴ": "Y",
      "Ỷ": "Y",
      "Ỿ": "Y",
      "Ȳ": "Y",
      "Ɏ": "Y",
      "Ỹ": "Y",
      "Ї": "YI",
      "Ź": "Z",
      "Ž": "Z",
      "Ẑ": "Z",
      "Ⱬ": "Z",
      "Ż": "Z",
      "Ẓ": "Z",
      "Ȥ": "Z",
      "Ẕ": "Z",
      "Ƶ": "Z",
      "Þ": "TH",
      "Ĳ": "IJ",
      "Œ": "OE",
      "ᴀ": "A",
      "ᴁ": "AE",
      "ʙ": "B",
      "ᴃ": "B",
      "ᴄ": "C",
      "ᴅ": "D",
      "ᴇ": "E",
      "ꜰ": "F",
      "ɢ": "G",
      "ʛ": "G",
      "ʜ": "H",
      "ɪ": "I",
      "ʁ": "R",
      "ᴊ": "J",
      "ᴋ": "K",
      "ʟ": "L",
      "ᴌ": "L",
      "ᴍ": "M",
      "ɴ": "N",
      "ᴏ": "O",
      "ɶ": "OE",
      "ᴐ": "O",
      "ᴕ": "OU",
      "ᴘ": "P",
      "ʀ": "R",
      "ᴎ": "N",
      "ᴙ": "R",
      "ꜱ": "S",
      "ᴛ": "T",
      "ⱻ": "E",
      "ᴚ": "R",
      "ᴜ": "U",
      "ᴠ": "V",
      "ᴡ": "W",
      "ʏ": "Y",
      "ᴢ": "Z",
      "á": "a",
      "ă": "a",
      "ắ": "a",
      "ặ": "a",
      "ằ": "a",
      "ẳ": "a",
      "ẵ": "a",
      "ǎ": "a",
      "â": "a",
      "ấ": "a",
      "ậ": "a",
      "ầ": "a",
      "ẩ": "a",
      "ẫ": "a",
      "ä": "a",
      "ǟ": "a",
      "ȧ": "a",
      "ǡ": "a",
      "ạ": "a",
      "ȁ": "a",
      "à": "a",
      "ả": "a",
      "ȃ": "a",
      "ā": "a",
      "ą": "a",
      "ᶏ": "a",
      "ẚ": "a",
      "å": "a",
      "ǻ": "a",
      "ḁ": "a",
      "ⱥ": "a",
      "ã": "a",
      "ꜳ": "aa",
      "æ": "ae",
      "ǽ": "ae",
      "ǣ": "ae",
      "ꜵ": "ao",
      "ꜷ": "au",
      "ꜹ": "av",
      "ꜻ": "av",
      "ꜽ": "ay",
      "ḃ": "b",
      "ḅ": "b",
      "ɓ": "b",
      "ḇ": "b",
      "ᵬ": "b",
      "ᶀ": "b",
      "ƀ": "b",
      "ƃ": "b",
      "ɵ": "o",
      "ć": "c",
      "č": "c",
      "ç": "c",
      "ḉ": "c",
      "ĉ": "c",
      "ɕ": "c",
      "ċ": "c",
      "ƈ": "c",
      "ȼ": "c",
      "ď": "d",
      "ḑ": "d",
      "ḓ": "d",
      "ȡ": "d",
      "ḋ": "d",
      "ḍ": "d",
      "ɗ": "d",
      "ᶑ": "d",
      "ḏ": "d",
      "ᵭ": "d",
      "ᶁ": "d",
      "đ": "d",
      "ɖ": "d",
      "ƌ": "d",
      "ð": "d",
      "ı": "i",
      "ȷ": "j",
      "ɟ": "j",
      "ʄ": "j",
      "ǳ": "dz",
      "ǆ": "dz",
      "é": "e",
      "ĕ": "e",
      "ě": "e",
      "ȩ": "e",
      "ḝ": "e",
      "ê": "e",
      "ế": "e",
      "ệ": "e",
      "ề": "e",
      "ể": "e",
      "ễ": "e",
      "ḙ": "e",
      "ë": "e",
      "ė": "e",
      "ẹ": "e",
      "ȅ": "e",
      "è": "e",
      "ẻ": "e",
      "ȇ": "e",
      "ē": "e",
      "ḗ": "e",
      "ḕ": "e",
      "ⱸ": "e",
      "ę": "e",
      "ᶒ": "e",
      "ɇ": "e",
      "ẽ": "e",
      "ḛ": "e",
      "ꝫ": "et",
      "ḟ": "f",
      "ƒ": "f",
      "ᵮ": "f",
      "ᶂ": "f",
      "ǵ": "g",
      "ğ": "g",
      "ǧ": "g",
      "ģ": "g",
      "ĝ": "g",
      "ġ": "g",
      "ɠ": "g",
      "ḡ": "g",
      "ᶃ": "g",
      "ǥ": "g",
      "ḫ": "h",
      "ȟ": "h",
      "ḩ": "h",
      "ĥ": "h",
      "ⱨ": "h",
      "ḧ": "h",
      "ḣ": "h",
      "ḥ": "h",
      "ɦ": "h",
      "ẖ": "h",
      "ħ": "h",
      "ƕ": "hv",
      "í": "i",
      "ĭ": "i",
      "ǐ": "i",
      "î": "i",
      "ï": "i",
      "ḯ": "i",
      "ị": "i",
      "ȉ": "i",
      "ì": "i",
      "ỉ": "i",
      "ȋ": "i",
      "ī": "i",
      "į": "i",
      "ᶖ": "i",
      "ɨ": "i",
      "ĩ": "i",
      "ḭ": "i",
      "і": "i",
      "ꝺ": "d",
      "ꝼ": "f",
      "ᵹ": "g",
      "ꞃ": "r",
      "ꞅ": "s",
      "ꞇ": "t",
      "ꝭ": "is",
      "ǰ": "j",
      "ĵ": "j",
      "ʝ": "j",
      "ɉ": "j",
      "ḱ": "k",
      "ǩ": "k",
      "ķ": "k",
      "ⱪ": "k",
      "ꝃ": "k",
      "ḳ": "k",
      "ƙ": "k",
      "ḵ": "k",
      "ᶄ": "k",
      "ꝁ": "k",
      "ꝅ": "k",
      "ĺ": "l",
      "ƚ": "l",
      "ɬ": "l",
      "ľ": "l",
      "ļ": "l",
      "ḽ": "l",
      "ȴ": "l",
      "ḷ": "l",
      "ḹ": "l",
      "ⱡ": "l",
      "ꝉ": "l",
      "ḻ": "l",
      "ŀ": "l",
      "ɫ": "l",
      "ᶅ": "l",
      "ɭ": "l",
      "ł": "l",
      "ǉ": "lj",
      "ſ": "s",
      "ẜ": "s",
      "ẛ": "s",
      "ẝ": "s",
      "ḿ": "m",
      "ṁ": "m",
      "ṃ": "m",
      "ɱ": "m",
      "ᵯ": "m",
      "ᶆ": "m",
      "ń": "n",
      "ň": "n",
      "ņ": "n",
      "ṋ": "n",
      "ȵ": "n",
      "ṅ": "n",
      "ṇ": "n",
      "ǹ": "n",
      "ɲ": "n",
      "ṉ": "n",
      "ƞ": "n",
      "ᵰ": "n",
      "ᶇ": "n",
      "ɳ": "n",
      "ñ": "n",
      "ǌ": "nj",
      "ó": "o",
      "ŏ": "o",
      "ǒ": "o",
      "ô": "o",
      "ố": "o",
      "ộ": "o",
      "ồ": "o",
      "ổ": "o",
      "ỗ": "o",
      "ö": "o",
      "ȫ": "o",
      "ȯ": "o",
      "ȱ": "o",
      "ọ": "o",
      "ő": "o",
      "ȍ": "o",
      "ò": "o",
      "ỏ": "o",
      "ơ": "o",
      "ớ": "o",
      "ợ": "o",
      "ờ": "o",
      "ở": "o",
      "ỡ": "o",
      "ȏ": "o",
      "ꝋ": "o",
      "ꝍ": "o",
      "ⱺ": "o",
      "ō": "o",
      "ṓ": "o",
      "ṑ": "o",
      "ǫ": "o",
      "ǭ": "o",
      "ø": "o",
      "ǿ": "o",
      "õ": "o",
      "ṍ": "o",
      "ṏ": "o",
      "ȭ": "o",
      "ƣ": "oi",
      "ꝏ": "oo",
      "ɛ": "e",
      "ᶓ": "e",
      "ɔ": "o",
      "ᶗ": "o",
      "ȣ": "ou",
      "ṕ": "p",
      "ṗ": "p",
      "ꝓ": "p",
      "ƥ": "p",
      "ᵱ": "p",
      "ᶈ": "p",
      "ꝕ": "p",
      "ᵽ": "p",
      "ꝑ": "p",
      "ꝙ": "q",
      "ʠ": "q",
      "ɋ": "q",
      "ꝗ": "q",
      "ŕ": "r",
      "ř": "r",
      "ŗ": "r",
      "ṙ": "r",
      "ṛ": "r",
      "ṝ": "r",
      "ȑ": "r",
      "ɾ": "r",
      "ᵳ": "r",
      "ȓ": "r",
      "ṟ": "r",
      "ɼ": "r",
      "ᵲ": "r",
      "ᶉ": "r",
      "ɍ": "r",
      "ɽ": "r",
      "ↄ": "c",
      "ꜿ": "c",
      "ɘ": "e",
      "ɿ": "r",
      "ś": "s",
      "ṥ": "s",
      "š": "s",
      "ṧ": "s",
      "ş": "s",
      "ŝ": "s",
      "ș": "s",
      "ṡ": "s",
      "ṣ": "s",
      "ṩ": "s",
      "ʂ": "s",
      "ᵴ": "s",
      "ᶊ": "s",
      "ȿ": "s",
      "ɡ": "g",
      "ᴑ": "o",
      "ᴓ": "o",
      "ᴝ": "u",
      "ť": "t",
      "ţ": "t",
      "ṱ": "t",
      "ț": "t",
      "ȶ": "t",
      "ẗ": "t",
      "ⱦ": "t",
      "ṫ": "t",
      "ṭ": "t",
      "ƭ": "t",
      "ṯ": "t",
      "ᵵ": "t",
      "ƫ": "t",
      "ʈ": "t",
      "ŧ": "t",
      "ᵺ": "th",
      "ɐ": "a",
      "ᴂ": "ae",
      "ǝ": "e",
      "ᵷ": "g",
      "ɥ": "h",
      "ʮ": "h",
      "ʯ": "h",
      "ᴉ": "i",
      "ʞ": "k",
      "ꞁ": "l",
      "ɯ": "m",
      "ɰ": "m",
      "ᴔ": "oe",
      "ɹ": "r",
      "ɻ": "r",
      "ɺ": "r",
      "ⱹ": "r",
      "ʇ": "t",
      "ʌ": "v",
      "ʍ": "w",
      "ʎ": "y",
      "ꜩ": "tz",
      "ú": "u",
      "ŭ": "u",
      "ǔ": "u",
      "û": "u",
      "ṷ": "u",
      "ü": "u",
      "ǘ": "u",
      "ǚ": "u",
      "ǜ": "u",
      "ǖ": "u",
      "ṳ": "u",
      "ụ": "u",
      "ű": "u",
      "ȕ": "u",
      "ù": "u",
      "ủ": "u",
      "ư": "u",
      "ứ": "u",
      "ự": "u",
      "ừ": "u",
      "ử": "u",
      "ữ": "u",
      "ȗ": "u",
      "ū": "u",
      "ṻ": "u",
      "ų": "u",
      "ᶙ": "u",
      "ů": "u",
      "ũ": "u",
      "ṹ": "u",
      "ṵ": "u",
      "ᵫ": "ue",
      "ꝸ": "um",
      "ⱴ": "v",
      "ꝟ": "v",
      "ṿ": "v",
      "ʋ": "v",
      "ᶌ": "v",
      "ⱱ": "v",
      "ṽ": "v",
      "ꝡ": "vy",
      "ẃ": "w",
      "ŵ": "w",
      "ẅ": "w",
      "ẇ": "w",
      "ẉ": "w",
      "ẁ": "w",
      "ⱳ": "w",
      "ẘ": "w",
      "ẍ": "x",
      "ẋ": "x",
      "ᶍ": "x",
      "ý": "y",
      "ŷ": "y",
      "ÿ": "y",
      "ẏ": "y",
      "ỵ": "y",
      "ỳ": "y",
      "ƴ": "y",
      "ỷ": "y",
      "ỿ": "y",
      "ȳ": "y",
      "ẙ": "y",
      "ɏ": "y",
      "ỹ": "y",
      "ї": "yi",
      "ź": "z",
      "ž": "z",
      "ẑ": "z",
      "ʑ": "z",
      "ⱬ": "z",
      "ż": "z",
      "ẓ": "z",
      "ȥ": "z",
      "ẕ": "z",
      "ᵶ": "z",
      "ᶎ": "z",
      "ʐ": "z",
      "ƶ": "z",
      "ɀ": "z",
      "þ": "th",
      "ﬀ": "ff",
      "ﬃ": "ffi",
      "ﬄ": "ffl",
      "ﬁ": "fi",
      "ﬂ": "fl",
      "ĳ": "ij",
      "œ": "oe",
      "ﬆ": "st",
      "ₐ": "a",
      "ₑ": "e",
      "ᵢ": "i",
      "ⱼ": "j",
      "ₒ": "o",
      "ᵣ": "r",
      "ᵤ": "u",
      "ᵥ": "v",
      "ₓ": "x",
      "Ё": "YO",
      "Й": "I",
      "Ц": "TS",
      "У": "U",
      "К": "K",
      "Е": "E",
      "Н": "N",
      "Г": "G",
      "Ґ": "G",
      "Ш": "SH",
      "Щ": "SCH",
      "З": "Z",
      "Х": "H",
      "Ъ": "'",
      "ё": "yo",
      "й": "i",
      "ц": "ts",
      "у": "u",
      "к": "k",
      "е": "e",
      "н": "n",
      "г": "g",
      "ґ": "g",
      "ш": "sh",
      "щ": "sch",
      "з": "z",
      "х": "h",
      "ъ": "'",
      "Ф": "F",
      "Ы": "I",
      "В": "V",
      "А": "a",
      "П": "P",
      "Р": "R",
      "О": "O",
      "Л": "L",
      "Д": "D",
      "Ж": "ZH",
      "Э": "E",
      "ф": "f",
      "ы": "i",
      "в": "v",
      "а": "a",
      "п": "p",
      "р": "r",
      "о": "o",
      "л": "l",
      "д": "d",
      "ж": "zh",
      "э": "e",
      "Я": "Ya",
      "Ч": "CH",
      "С": "S",
      "М": "M",
      "И": "I",
      "Т": "T",
      "Ь": "'",
      "Б": "B",
      "Ю": "YU",
      "я": "ya",
      "ч": "ch",
      "с": "s",
      "м": "m",
      "и": "i",
      "т": "t",
      "ь": "'",
      "б": "b",
      "ю": "yu"
    };
    return latinize2;
  });
})(latinize$1);
const latinize = latinizeExports;
const getAreaInfo$1 = (listingInfo) => {
  const total_area2 = listingInfo.area_total ? `${getAreaDisplay(listingInfo.area_total, listingInfo.area_unit_display)}` : "-";
  return [
    {
      [instance.t("living_area_fi")]: {
        value: `${getAreaDisplay(listingInfo.area_living, listingInfo.area_unit_display)}`,
        hover: instance.t("living_area_fi_disclaimer")
      }
    },
    { [instance.t("total_area")]: total_area2 }
  ];
};
const getExtraInfo1$1 = (listingInfo) => {
  return [
    {
      [instance.t("asbestos")]: listingInfo.asbestos_info ? listingInfo.asbestos_info : "-"
    },
    { [instance.t("condition")]: getConditionDisplay(listingInfo.condition_general) }
  ];
};
const getExtraInfo2$1 = (listingInfo) => {
  if (listingInfo.sauna_display) {
    return [{ [instance.t("sauna")]: listingInfo.sauna_display }];
  }
  return [
    {
      [instance.t("sauna")]: listingInfo.sauna_exists ? instance.t("yes") : instance.t("no")
    }
  ];
};
const getExtraInfo3$1 = (listingInfo) => {
  return [
    {
      [instance.t("pre_emption_rights")]: listingInfo.apartment_fi.stock_pre_emption_rights_info
    },
    {
      [instance.t("release")]: listingInfo.listing_release_available_info
    }
  ];
};
const getEquipmentInfo$1 = (listingInfo) => {
  var _a, _b, _c, _d;
  const language = instance.language;
  let equipmentInfo = [];
  if ((_a = listingInfo.equipment_bathroom_trans) == null ? void 0 : _a[language]) {
    equipmentInfo.push(
      {
        [instance.t("equipment_bathroom")]: listingInfo.equipment_bathroom_trans[language]
      }
    );
  }
  if ((_b = listingInfo.equipment_bedroom_trans) == null ? void 0 : _b[language]) {
    equipmentInfo.push(
      {
        [instance.t("equipment_bedroom")]: listingInfo.equipment_bedroom_trans[language]
      }
    );
  }
  if ((_c = listingInfo.equipment_living_room_trans) == null ? void 0 : _c[language]) {
    equipmentInfo.push(
      {
        [instance.t("equipment_living_room")]: listingInfo.equipment_living_room_trans[language]
      }
    );
  }
  if ((_d = listingInfo.equipment_other_trans) == null ? void 0 : _d[language]) {
    equipmentInfo.push(
      {
        [instance.t("equipment_other")]: listingInfo.equipment_other_trans[language]
      }
    );
  }
  return equipmentInfo;
};
const getBuildingExtraInfo1$1 = (listingInfo) => {
  return [
    {
      [instance.t("housing_company")]: listingInfo.apartment_fi.company_name
    }
  ];
};
const getBuildingExtraInfo2$1 = (listingInfo) => {
  return [
    {
      [instance.t("building_apartments")]: `${listingInfo.apartment_fi.company_apartments_count ? listingInfo.apartment_fi.company_apartments_count : "-"}`
    },
    {
      [instance.t("apartments_area")]: listingInfo.apartment_fi.company_apartments_area ? `${getAreaDisplay(listingInfo.apartment_fi.company_apartments_area, listingInfo.area_unit_display)}` : "-"
    },
    {
      [instance.t("disponent")]: listingInfo.apartment_fi.company_manager_info
    },
    {
      [instance.t("maintenance")]: listingInfo.apartment_fi.company_maintenance_info ? listingInfo.apartment_fi.company_maintenance_info : "-"
    },
    { [instance.t("zoning")]: `${listingInfo.lot_zoning_info || "-"}` },
    {
      [instance.t("energy_cert")]: `${listingInfo.building_energy_certificate || "-"}`
    },
    {
      [instance.t("lot_owner")]: `${listingInfo.lot_ownership_info || "-"}`
    }
  ];
};
const getBuildingConstructionDetails$1 = (listingInfo) => {
  const roofing2 = listingInfo.building_roof_material_info && listingInfo.building_roof_type ? `${listingInfo.building_roof_material_info}, ${listingInfo.building_roof_type}` : listingInfo.building_roof_material_info || listingInfo.building_roof_type || "-";
  return [
    ...listingInfo.case_type !== "realty" ? [
      {
        [instance.t("building_sauna")]: listingInfo.apartment_fi.company_sauna_exists ? instance.t("yes") : instance.t("no")
      }
    ] : [],
    {
      [instance.t("building_material")]: listingInfo.building_material_info || ""
    },
    { [instance.t("roofing")]: roofing2 },
    {
      [instance.t("heating")]: `${listingInfo.building_heating_info || "-"}`
    },
    {
      [instance.t("ventilation_system")]: `${listingInfo.building_ventilation_info || "-"}`
    }
  ];
};
const getAddressInfo = (listingInfo) => {
  return [
    {
      [instance.t("specifier")]: listingInfo.apartment_se.apartment_association_id
    }
  ];
};
const getAreaInfo = (listingInfo) => {
  return [
    {
      [instance.t("living_area")]: listingInfo.area_living ? `${getAreaDisplay(listingInfo.area_living, listingInfo.area_unit_display)}` : "-"
    },
    {
      [instance.t("living_area_info")]: listingInfo.area_info ? listingInfo.area_info : "-"
    }
  ];
};
const getExtraInfo1 = (listingInfo) => {
  return [];
};
const getExtraInfo2 = (listingInfo) => {
  return [];
};
const getExtraInfo3 = (listingInfo) => {
  return [
    {
      [instance.t("release_SE")]: listingInfo.listing_release_available_info
    },
    {
      [instance.t("association_ownership_fraction")]: listingInfo.apartment_se.association_ownership_fraction ? `${listingInfo.apartment_se.association_ownership_fraction} %` : instance.t("information_not_found")
    },
    {
      [instance.t("association_fee_fraction")]: listingInfo.apartment_se.association_fee_fraction ? `${listingInfo.apartment_se.association_fee_fraction} %` : instance.t("information_not_found")
    },
    {
      [instance.t("indirect_net_debt")]: listingInfo.apartment_se.indirect_net_debt ? `${listingInfo.apartment_se.indirect_net_debt} kr` : instance.t("information_not_found")
    }
  ];
};
const getEquipmentInfo = (listingInfo) => {
  var _a, _b, _c, _d;
  const language = instance.language;
  let equipmentInfo = [
    {
      [instance.t("equipment_bathroom")]: ((_a = listingInfo.equipment_bathroom_trans) == null ? void 0 : _a[language]) || "-"
    }
  ];
  if ((_b = listingInfo.equipment_bedroom_trans) == null ? void 0 : _b[language]) {
    equipmentInfo.push(
      {
        [instance.t("equipment_bedroom")]: listingInfo.equipment_bedroom_trans[language]
      }
    );
  }
  if ((_c = listingInfo.equipment_living_room_trans) == null ? void 0 : _c[language]) {
    equipmentInfo.push(
      {
        [instance.t("equipment_living_room")]: listingInfo.equipment_living_room_trans[language]
      }
    );
  }
  if ((_d = listingInfo.equipment_other_trans) == null ? void 0 : _d[language]) {
    equipmentInfo.push(
      {
        [instance.t("equipment_other")]: listingInfo.equipment_other_trans[language]
      }
    );
  }
  return equipmentInfo;
};
const getBuildingExtraInfo1 = (listingInfo) => {
  return [
    {
      [instance.t("association_name")]: listingInfo.apartment_se.association_name || "-"
    }
  ];
};
const getBuildingConstructionDetails = (listingInfo) => {
  return [
    {
      [instance.t("heating")]: `${listingInfo.building_heating_info || "-"}`
    },
    ...listingInfo.building_ventilation_info ? [
      {
        [instance.t("ventilation_system")]: listingInfo.building_ventilation_info
      }
    ] : []
  ];
};
const getBuildingExtraInfo2 = (listingInfo) => {
  return [
    {
      [instance.t("building_apartments")]: `${listingInfo.apartment_se.association_apartments_count || "-"}`
    },
    {
      [instance.t("energy_performance")]: listingInfo.building_energy_certificate ? `${listingInfo.building_energy_certificate} kWh/m² och år` : instance.t("information_not_found")
    },
    {
      [instance.t("lot_owner_SE")]: `${listingInfo.lot_ownership_info || "-"}`
    }
  ];
};
const filter_empty = (arr2) => {
  return arr2.filter((item) => {
    let value = Object.values(item)[0];
    if (value && typeof value === "object")
      value = value.value;
    return value && value !== "-" && value !== instance.t("information_not_found");
  });
};
const getBasicInfoArr = (listingInfo) => {
  var _a;
  let addressInfo = [];
  let areaInfo = [];
  let extraInfo1 = [];
  let extraInfo2 = [];
  let extraInfo3 = [];
  let equipmentInfo = [];
  let country;
  if (listingInfo.type === "apartment_fi") {
    areaInfo = getAreaInfo$1(listingInfo);
    extraInfo1 = getExtraInfo1$1(listingInfo);
    extraInfo2 = getExtraInfo2$1(listingInfo);
    extraInfo3 = getExtraInfo3$1(listingInfo);
    equipmentInfo = getEquipmentInfo$1(listingInfo);
    country = "FI";
  } else if (listingInfo.type === "apartment_se") {
    addressInfo = getAddressInfo(listingInfo);
    areaInfo = getAreaInfo(listingInfo);
    extraInfo1 = getExtraInfo1();
    extraInfo2 = getExtraInfo2();
    extraInfo3 = getExtraInfo3(listingInfo);
    equipmentInfo = getEquipmentInfo(listingInfo);
    country = "SE";
  }
  let basicInfoArr = [
    {
      [instance.t("street_address")]: `${listingInfo.location_street_address}${listingInfo.listing_display_specifier && listingInfo.location_specifier ? " " + listingInfo.location_specifier : ""}, ${listingInfo.location_postcode} ${listingInfo.location_municipality}`
    },
    ...listingInfo.location_neighborhood ? [
      {
        [instance.t("neighborhood")]: {
          value: `${listingInfo.location_neighborhood} ${listingInfo.location_neighborhood_other || ""}`,
          link: `${instance.t("link_listings", {
            context: country
          })}?neighborhood=${latinize(
            listingInfo.location_neighborhood
          )}`
        }
      }
    ] : [],
    ...addressInfo,
    {
      [instance.t("rooms")]: {
        value: Number(listingInfo.room_count),
        link: `${instance.t("link_listings", {
          context: country
        })}?room=${latinize(
          Number(listingInfo.room_count)
        )}`
      }
    },
    ...areaInfo,
    ...extraInfo1,
    {
      [instance.t("floor")]: `${listingInfo.floor_number} ${listingInfo.floor_count !== 1 ? `- ${listingInfo.floor_number + listingInfo.floor_count - 1}` : ""} / ${listingInfo.building_floor_count}`
    },
    {
      [instance.t("lift")]: listingInfo.building_elevator_exists ? instance.t("yes") : instance.t("no")
    },
    ...extraInfo2,
    {
      [instance.t("balcony")]: listingInfo.balcony_exists ? instance.t("yes") : instance.t("no")
    },
    ...listingInfo.balcony_type_display ? [
      {
        [instance.t("balcony_type")]: listingInfo.balcony_type_display
      }
    ] : [],
    ...listingInfo.balcony_direction ? [
      {
        [instance.t("balcony_direction")]: listingInfo.balcony_direction
      }
    ] : [],
    { [instance.t("flooring")]: listingInfo.floor_material || "-" },
    ...extraInfo3,
    { [instance.t("bearings")]: listingInfo.bearings_info || "-" },
    { [instance.t("equipment_kitchen")]: ((_a = listingInfo.equipment_kitchen_trans) == null ? void 0 : _a[instance.language]) || "-" },
    ...equipmentInfo,
    ...listingInfo.views_from_window ? [
      {
        [instance.t("views_from_window")]: listingInfo.views_from_window
      }
    ] : [],
    ...[
      "own_yard",
      "fireplace",
      "high_ceiling",
      "street_level",
      "accessible",
      "dishwasher",
      "washing_machine",
      "stucco",
      "alternative_floorplan",
      "open_floorplan"
    ].filter((key) => typeof listingInfo[key] === "boolean").map((key) => ({
      // i18next-extract-disable
      [instance.t(key)]: (
        // i18next-extract-enable
        listingInfo[key] ? instance.t("yes") : instance.t("no")
      )
    })),
    ...listingInfo.listing_supplementary_staff_info ? [
      {
        [instance.t("other_details")]: listingInfo.listing_supplementary_staff_info
      }
    ] : [],
    ...listingInfo.listing_supplementary_info ? [
      {
        [instance.t("supplementary_info")]: listingInfo.listing_supplementary_info
      }
    ] : []
  ];
  if (listingInfo.case_type === "realty") {
    basicInfoArr = filter_empty(basicInfoArr);
  }
  return basicInfoArr;
};
const getBuildingInfoArr = (listingInfo) => {
  let buildingExtraInfo1 = {};
  let buildingExtraInfo2 = {};
  let buildingConstructionDetails = {};
  if (listingInfo.type === "apartment_fi") {
    buildingExtraInfo1 = getBuildingExtraInfo1$1(listingInfo);
    buildingExtraInfo2 = getBuildingExtraInfo2$1(listingInfo);
    buildingConstructionDetails = getBuildingConstructionDetails$1(listingInfo);
  } else if (listingInfo.type === "apartment_se") {
    buildingExtraInfo1 = getBuildingExtraInfo1(listingInfo);
    buildingExtraInfo2 = getBuildingExtraInfo2(listingInfo);
    buildingConstructionDetails = getBuildingConstructionDetails(listingInfo);
  }
  let buildingInfoArr = [
    { [instance.t("build_year")]: listingInfo.building_construction_year },
    ...buildingExtraInfo1,
    { [instance.t("Building")]: getCategoryDisplay(listingInfo.category) },
    ...buildingConstructionDetails,
    ...listingInfo.building_tv_info ? [{ [instance.t("TV")]: listingInfo.building_tv_info }] : [],
    {
      [instance.t("internet")]: `${listingInfo.building_internet_info || "-"}`
    },
    ...buildingExtraInfo2,
    { [instance.t("parking")]: listingInfo.spaces_parking_info || "-" },
    ...listingInfo.case_type === "realty" ? [
      {
        [instance.t("parking_electric_vehicle")]: listingInfo.spaces_parking_electric_vehicle_charger_exists ? instance.t("yes") : instance.t("no")
      },
      {
        [instance.t("parking_powerplug")]: listingInfo.spaces_parking_powerplug_exists ? instance.t("yes") : instance.t("no")
      }
    ] : [],
    {
      [instance.t("building_spaces")]: listingInfo.spaces_miscellaneous_info || "-"
    },
    {
      [instance.t("commercial_spaces")]: listingInfo.spaces_commercial_info || "-"
    },
    ...listingInfo.spaces_yard_info ? [{ [instance.t("building_yard")]: listingInfo.spaces_yard_info }] : [],
    ...listingInfo.building_overnight_apartment_exists ? [
      {
        [instance.t("building_overnight_apartment")]: listingInfo.building_overnight_apartment_exists
      }
    ] : []
  ];
  if (listingInfo.case_type === "realty") {
    buildingInfoArr = filter_empty(buildingInfoArr);
  }
  return buildingInfoArr;
};
function FaAngleLeft(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 256 512" }, "child": [{ "tag": "path", "attr": { "d": "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z" } }] })(props);
}
function FaAngleRight(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 256 512" }, "child": [{ "tag": "path", "attr": { "d": "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z" } }] })(props);
}
function FaChevronLeft(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 320 512" }, "child": [{ "tag": "path", "attr": { "d": "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z" } }] })(props);
}
function FaChevronRight(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 320 512" }, "child": [{ "tag": "path", "attr": { "d": "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" } }] })(props);
}
function FaHammer(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 576 512" }, "child": [{ "tag": "path", "attr": { "d": "M571.31 193.94l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31-28.9-28.9c5.63-21.31.36-44.9-16.35-61.61l-45.25-45.25c-62.48-62.48-163.79-62.48-226.28 0l90.51 45.25v18.75c0 16.97 6.74 33.25 18.75 45.25l49.14 49.14c16.71 16.71 40.3 21.98 61.61 16.35l28.9 28.9-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l90.51-90.51c6.23-6.24 6.23-16.37-.02-22.62zm-286.72-15.2c-3.7-3.7-6.84-7.79-9.85-11.95L19.64 404.96c-25.57 23.88-26.26 64.19-1.53 88.93s65.05 24.05 88.93-1.53l238.13-255.07c-3.96-2.91-7.9-5.87-11.44-9.41l-49.14-49.14z" } }] })(props);
}
function FaSearch(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 512 512" }, "child": [{ "tag": "path", "attr": { "d": "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z" } }] })(props);
}
function FaRegBell(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 448 512" }, "child": [{ "tag": "path", "attr": { "d": "M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42 0-.2-.06-.38-.06-.58 0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z" } }] })(props);
}
function FaRegQuestionCircle(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 512 512" }, "child": [{ "tag": "path", "attr": { "d": "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z" } }] })(props);
}
var i$3 = Object.defineProperty;
var d$2 = (t2, e2, n2) => e2 in t2 ? i$3(t2, e2, { enumerable: true, configurable: true, writable: true, value: n2 }) : t2[e2] = n2;
var r$2 = (t2, e2, n2) => (d$2(t2, typeof e2 != "symbol" ? e2 + "" : e2, n2), n2);
let o$5 = class o {
  constructor() {
    r$2(this, "current", this.detect());
    r$2(this, "handoffState", "pending");
    r$2(this, "currentId", 0);
  }
  set(e2) {
    this.current !== e2 && (this.handoffState = "pending", this.currentId = 0, this.current = e2);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
};
let s$8 = new o$5();
let l$5 = (e2, f2) => {
  s$8.isServer ? useEffect$1(e2, f2) : useLayoutEffect$1(e2, f2);
};
function s$7(e2) {
  let r2 = useRef(e2);
  return l$5(() => {
    r2.current = e2;
  }, [e2]), r2;
}
function t(e2) {
  typeof queueMicrotask == "function" ? queueMicrotask(e2) : Promise.resolve().then(e2).catch((o3) => setTimeout(() => {
    throw o3;
  }));
}
function m$2() {
  let n2 = [], i2 = [], r2 = { enqueue(e2) {
    i2.push(e2);
  }, addEventListener(e2, t2, a2, o3) {
    return e2.addEventListener(t2, a2, o3), r2.add(() => e2.removeEventListener(t2, a2, o3));
  }, requestAnimationFrame(...e2) {
    let t2 = requestAnimationFrame(...e2);
    return r2.add(() => cancelAnimationFrame(t2));
  }, nextFrame(...e2) {
    return r2.requestAnimationFrame(() => r2.requestAnimationFrame(...e2));
  }, setTimeout(...e2) {
    let t2 = setTimeout(...e2);
    return r2.add(() => clearTimeout(t2));
  }, microTask(...e2) {
    let t$12 = { current: true };
    return t(() => {
      t$12.current && e2[0]();
    }), r2.add(() => {
      t$12.current = false;
    });
  }, add(e2) {
    return n2.push(e2), () => {
      let t2 = n2.indexOf(e2);
      if (t2 >= 0) {
        let [a2] = n2.splice(t2, 1);
        a2();
      }
    };
  }, dispose() {
    for (let e2 of n2.splice(0))
      e2();
  }, async workQueue() {
    for (let e2 of i2.splice(0))
      await e2();
  } };
  return r2;
}
function p$1() {
  let [e2] = useState$1(m$2);
  return useEffect$1(() => () => e2.dispose(), [e2]), e2;
}
let o$4 = function(t2) {
  let e2 = s$7(t2);
  return React__default$1.useCallback((...r2) => e2.current(...r2), [e2]);
};
function l$4() {
  let [e2, f2] = useState$1(s$8.isHandoffComplete);
  return e2 && s$8.isHandoffComplete === false && f2(false), useEffect$1(() => {
    e2 !== true && f2(true);
  }, [e2]), useEffect$1(() => s$8.handoff(), []), e2;
}
var o$3;
let I$2 = (o$3 = React__default$1.useId) != null ? o$3 : function() {
  let n2 = l$4(), [e2, u2] = React__default$1.useState(n2 ? () => s$8.nextId() : null);
  return l$5(() => {
    e2 === null && u2(s$8.nextId());
  }, [e2]), e2 != null ? "" + e2 : void 0;
};
function u$3(r2, n2, ...a2) {
  if (r2 in n2) {
    let e2 = n2[r2];
    return typeof e2 == "function" ? e2(...a2) : e2;
  }
  let t2 = new Error(`Tried to handle "${r2}" but there is no handler defined. Only defined handlers are: ${Object.keys(n2).map((e2) => `"${e2}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(t2, u$3), t2;
}
function e$2(r2) {
  return s$8.isServer ? null : r2 instanceof Node ? r2.ownerDocument : r2 != null && r2.hasOwnProperty("current") && r2.current instanceof Node ? r2.current.ownerDocument : document;
}
let f$2 = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e2) => `${e2}:not([tabindex='-1'])`).join(",");
var L$1 = ((r2) => (r2[r2.First = 1] = "First", r2[r2.Previous = 2] = "Previous", r2[r2.Next = 4] = "Next", r2[r2.Last = 8] = "Last", r2[r2.WrapAround = 16] = "WrapAround", r2[r2.NoScroll = 32] = "NoScroll", r2))(L$1 || {}), N = ((o3) => (o3[o3.Error = 0] = "Error", o3[o3.Overflow = 1] = "Overflow", o3[o3.Success = 2] = "Success", o3[o3.Underflow = 3] = "Underflow", o3))(N || {}), T$2 = ((n2) => (n2[n2.Previous = -1] = "Previous", n2[n2.Next = 1] = "Next", n2))(T$2 || {});
function E$1(e2 = document.body) {
  return e2 == null ? [] : Array.from(e2.querySelectorAll(f$2)).sort((t2, n2) => Math.sign((t2.tabIndex || Number.MAX_SAFE_INTEGER) - (n2.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var F$3 = ((n2) => (n2[n2.Strict = 0] = "Strict", n2[n2.Loose = 1] = "Loose", n2))(F$3 || {});
function h$4(e2, t2 = 0) {
  var n2;
  return e2 === ((n2 = e$2(e2)) == null ? void 0 : n2.body) ? false : u$3(t2, { [0]() {
    return e2.matches(f$2);
  }, [1]() {
    let l2 = e2;
    for (; l2 !== null; ) {
      if (l2.matches(f$2))
        return true;
      l2 = l2.parentElement;
    }
    return false;
  } });
}
function S$1(e2) {
  e2 == null || e2.focus({ preventScroll: true });
}
let H$2 = ["textarea", "input"].join(",");
function w$1(e2) {
  var t2, n2;
  return (n2 = (t2 = e2 == null ? void 0 : e2.matches) == null ? void 0 : t2.call(e2, H$2)) != null ? n2 : false;
}
function A$3(e2, t2 = (n2) => n2) {
  return e2.slice().sort((n2, l2) => {
    let o3 = t2(n2), i2 = t2(l2);
    if (o3 === null || i2 === null)
      return 0;
    let r2 = o3.compareDocumentPosition(i2);
    return r2 & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : r2 & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function I$1(e2, t2, { sorted: n2 = true, relativeTo: l2 = null, skipElements: o3 = [] } = {}) {
  let i2 = Array.isArray(e2) ? e2.length > 0 ? e2[0].ownerDocument : document : e2.ownerDocument, r2 = Array.isArray(e2) ? n2 ? A$3(e2) : e2 : E$1(e2);
  o3.length > 0 && r2.length > 1 && (r2 = r2.filter((s2) => !o3.includes(s2))), l2 = l2 != null ? l2 : i2.activeElement;
  let d2 = (() => {
    if (t2 & 5)
      return 1;
    if (t2 & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), x2 = (() => {
    if (t2 & 1)
      return 0;
    if (t2 & 2)
      return Math.max(0, r2.indexOf(l2)) - 1;
    if (t2 & 4)
      return Math.max(0, r2.indexOf(l2)) + 1;
    if (t2 & 8)
      return r2.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), p2 = t2 & 32 ? { preventScroll: true } : {}, c2 = 0, a2 = r2.length, u2;
  do {
    if (c2 >= a2 || c2 + a2 <= 0)
      return 0;
    let s2 = x2 + c2;
    if (t2 & 16)
      s2 = (s2 + a2) % a2;
    else {
      if (s2 < 0)
        return 3;
      if (s2 >= a2)
        return 1;
    }
    u2 = r2[s2], u2 == null || u2.focus(p2), c2 += d2;
  } while (u2 !== i2.activeElement);
  return t2 & 6 && w$1(u2) && u2.select(), u2.hasAttribute("tabindex") || u2.setAttribute("tabindex", "0"), 2;
}
function d$1(e2, r2, n2) {
  let o3 = s$7(r2);
  useEffect$1(() => {
    function t2(u2) {
      o3.current(u2);
    }
    return document.addEventListener(e2, t2, n2), () => document.removeEventListener(e2, t2, n2);
  }, [e2, n2]);
}
function L(m2, E2, c2 = true) {
  let i2 = useRef(false);
  useEffect$1(() => {
    requestAnimationFrame(() => {
      i2.current = c2;
    });
  }, [c2]);
  function f2(e2, o3) {
    if (!i2.current || e2.defaultPrevented)
      return;
    let l2 = function r2(t2) {
      return typeof t2 == "function" ? r2(t2()) : Array.isArray(t2) || t2 instanceof Set ? t2 : [t2];
    }(m2), n2 = o3(e2);
    if (n2 !== null && !!n2.getRootNode().contains(n2)) {
      for (let r2 of l2) {
        if (r2 === null)
          continue;
        let t2 = r2 instanceof HTMLElement ? r2 : r2.current;
        if (t2 != null && t2.contains(n2) || e2.composed && e2.composedPath().includes(t2))
          return;
      }
      return !h$4(n2, F$3.Loose) && n2.tabIndex !== -1 && e2.preventDefault(), E2(e2, n2);
    }
  }
  let u2 = useRef(null);
  d$1("mousedown", (e2) => {
    var o3, l2;
    i2.current && (u2.current = ((l2 = (o3 = e2.composedPath) == null ? void 0 : o3.call(e2)) == null ? void 0 : l2[0]) || e2.target);
  }, true), d$1("click", (e2) => {
    !u2.current || (f2(e2, () => u2.current), u2.current = null);
  }, true), d$1("blur", (e2) => f2(e2, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), true);
}
function i$2(t2) {
  var n2;
  if (t2.type)
    return t2.type;
  let e2 = (n2 = t2.as) != null ? n2 : "button";
  if (typeof e2 == "string" && e2.toLowerCase() === "button")
    return "button";
}
function s$6(t2, e2) {
  let [n2, u2] = useState$1(() => i$2(t2));
  return l$5(() => {
    u2(i$2(t2));
  }, [t2.type, t2.as]), l$5(() => {
    n2 || !e2.current || e2.current instanceof HTMLButtonElement && !e2.current.hasAttribute("type") && u2("button");
  }, [n2, e2]), n2;
}
let u$2 = Symbol();
function T$1(t2, n2 = true) {
  return Object.assign(t2, { [u$2]: n2 });
}
function y(...t2) {
  let n2 = useRef(t2);
  useEffect$1(() => {
    n2.current = t2;
  }, [t2]);
  let c2 = o$4((e2) => {
    for (let o3 of n2.current)
      o3 != null && (typeof o3 == "function" ? o3(e2) : o3.current = e2);
  });
  return t2.every((e2) => e2 == null || (e2 == null ? void 0 : e2[u$2])) ? void 0 : c2;
}
function e$1(...n2) {
  return n2.filter(Boolean).join(" ");
}
var j$1 = ((a2) => (a2[a2.None = 0] = "None", a2[a2.RenderStrategy = 1] = "RenderStrategy", a2[a2.Static = 2] = "Static", a2))(j$1 || {}), w = ((e2) => (e2[e2.Unmount = 0] = "Unmount", e2[e2.Hidden = 1] = "Hidden", e2))(w || {});
function X$2({ ourProps: r2, theirProps: t2, slot: e2, defaultTag: a2, features: s2, visible: n2 = true, name: l2 }) {
  let o3 = h$3(t2, r2);
  if (n2)
    return m$1(o3, e2, a2, l2);
  let u2 = s2 != null ? s2 : 0;
  if (u2 & 2) {
    let { static: i2 = false, ...d2 } = o3;
    if (i2)
      return m$1(d2, e2, a2, l2);
  }
  if (u2 & 1) {
    let { unmount: i2 = true, ...d2 } = o3;
    return u$3(i2 ? 0 : 1, { [0]() {
      return null;
    }, [1]() {
      return m$1({ ...d2, hidden: true, style: { display: "none" } }, e2, a2, l2);
    } });
  }
  return m$1(o3, e2, a2, l2);
}
function m$1(r2, t2 = {}, e2, a2) {
  var y2;
  let { as: s2 = e2, children: n2, refName: l2 = "ref", ...o3 } = T(r2, ["unmount", "static"]), u2 = r2.ref !== void 0 ? { [l2]: r2.ref } : {}, i2 = typeof n2 == "function" ? n2(t2) : n2;
  o3.className && typeof o3.className == "function" && (o3.className = o3.className(t2));
  let d2 = {};
  if (t2) {
    let f2 = false, c2 = [];
    for (let [p2, F2] of Object.entries(t2))
      typeof F2 == "boolean" && (f2 = true), F2 === true && c2.push(p2);
    f2 && (d2["data-headlessui-state"] = c2.join(" "));
  }
  if (s2 === Fragment$1 && Object.keys(P$3(o3)).length > 0) {
    if (!isValidElement(i2) || Array.isArray(i2) && i2.length > 1)
      throw new Error(['Passing props on "Fragment"!', "", `The current component <${a2} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(o3).map((p2) => `  - ${p2}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((p2) => `  - ${p2}`).join(`
`)].join(`
`));
    let f2 = e$1((y2 = i2.props) == null ? void 0 : y2.className, o3.className), c2 = f2 ? { className: f2 } : {};
    return cloneElement(i2, Object.assign({}, h$3(i2.props, P$3(T(o3, ["ref"]))), d2, u2, O(i2.ref, u2.ref), c2));
  }
  return createElement$1(s2, Object.assign({}, T(o3, ["ref"]), s2 !== Fragment$1 && u2, s2 !== Fragment$1 && d2), i2);
}
function O(...r2) {
  return { ref: r2.every((t2) => t2 == null) ? void 0 : (t2) => {
    for (let e2 of r2)
      e2 != null && (typeof e2 == "function" ? e2(t2) : e2.current = t2);
  } };
}
function h$3(...r2) {
  if (r2.length === 0)
    return {};
  if (r2.length === 1)
    return r2[0];
  let t2 = {}, e2 = {};
  for (let s2 of r2)
    for (let n2 in s2)
      n2.startsWith("on") && typeof s2[n2] == "function" ? (e2[n2] != null || (e2[n2] = []), e2[n2].push(s2[n2])) : t2[n2] = s2[n2];
  if (t2.disabled || t2["aria-disabled"])
    return Object.assign(t2, Object.fromEntries(Object.keys(e2).map((s2) => [s2, void 0])));
  for (let s2 in e2)
    Object.assign(t2, { [s2](n2, ...l2) {
      let o3 = e2[s2];
      for (let u2 of o3) {
        if ((n2 instanceof Event || (n2 == null ? void 0 : n2.nativeEvent) instanceof Event) && n2.defaultPrevented)
          return;
        u2(n2, ...l2);
      }
    } });
  return t2;
}
function V$1(r2) {
  var t2;
  return Object.assign(forwardRef(r2), { displayName: (t2 = r2.displayName) != null ? t2 : r2.name });
}
function P$3(r2) {
  let t2 = Object.assign({}, r2);
  for (let e2 in t2)
    t2[e2] === void 0 && delete t2[e2];
  return t2;
}
function T(r2, t2 = []) {
  let e2 = Object.assign({}, r2);
  for (let a2 of t2)
    a2 in e2 && delete e2[a2];
  return e2;
}
function r$1(n2) {
  let e2 = n2.parentElement, l2 = null;
  for (; e2 && !(e2 instanceof HTMLFieldSetElement); )
    e2 instanceof HTMLLegendElement && (l2 = e2), e2 = e2.parentElement;
  let t2 = (e2 == null ? void 0 : e2.getAttribute("disabled")) === "";
  return t2 && i$1(l2) ? false : t2;
}
function i$1(n2) {
  if (!n2)
    return false;
  let e2 = n2.previousElementSibling;
  for (; e2 !== null; ) {
    if (e2 instanceof HTMLLegendElement)
      return false;
    e2 = e2.previousElementSibling;
  }
  return true;
}
let a$1 = "div";
var s$5 = ((e2) => (e2[e2.None = 1] = "None", e2[e2.Focusable = 2] = "Focusable", e2[e2.Hidden = 4] = "Hidden", e2))(s$5 || {});
let h$2 = V$1(function(t2, o3) {
  let { features: e2 = 1, ...r2 } = t2, d2 = { ref: o3, "aria-hidden": (e2 & 2) === 2 ? true : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(e2 & 4) === 4 && (e2 & 2) !== 2 && { display: "none" } } };
  return X$2({ ourProps: d2, theirProps: r2, slot: {}, defaultTag: a$1, name: "Hidden" });
});
let o$2 = createContext(null);
o$2.displayName = "OpenClosedContext";
var p = ((e2) => (e2[e2.Open = 0] = "Open", e2[e2.Closed = 1] = "Closed", e2))(p || {});
function s$4() {
  return useContext(o$2);
}
function C({ value: t2, children: n2 }) {
  return React__default$1.createElement(o$2.Provider, { value: t2 }, n2);
}
var o$1 = ((r2) => (r2.Space = " ", r2.Enter = "Enter", r2.Escape = "Escape", r2.Backspace = "Backspace", r2.Delete = "Delete", r2.ArrowLeft = "ArrowLeft", r2.ArrowUp = "ArrowUp", r2.ArrowRight = "ArrowRight", r2.ArrowDown = "ArrowDown", r2.Home = "Home", r2.End = "End", r2.PageUp = "PageUp", r2.PageDown = "PageDown", r2.Tab = "Tab", r2))(o$1 || {});
function m(u2, t2) {
  let e2 = useRef([]), r2 = o$4(u2);
  useEffect$1(() => {
    let o3 = [...e2.current];
    for (let [n2, a2] of t2.entries())
      if (e2.current[n2] !== a2) {
        let l2 = r2(t2, o3);
        return e2.current = t2, l2;
      }
  }, [r2, ...t2]);
}
function s$3(e2, r2, n2) {
  let o3 = s$7(r2);
  useEffect$1(() => {
    function t2(i2) {
      o3.current(i2);
    }
    return window.addEventListener(e2, t2, n2), () => window.removeEventListener(e2, t2, n2);
  }, [e2, n2]);
}
var s$2 = ((r2) => (r2[r2.Forwards = 0] = "Forwards", r2[r2.Backwards = 1] = "Backwards", r2))(s$2 || {});
function n$2() {
  let e2 = useRef(0);
  return s$3("keydown", (o3) => {
    o3.key === "Tab" && (e2.current = o3.shiftKey ? 1 : 0);
  }, true), e2;
}
function f$1() {
  let e2 = useRef(false);
  return l$5(() => (e2.current = true, () => {
    e2.current = false;
  }), []), e2;
}
function n$1(...e2) {
  return useMemo(() => e$2(...e2), [...e2]);
}
function E(n2, e2, a2, t2) {
  let i2 = s$7(a2);
  useEffect$1(() => {
    n2 = n2 != null ? n2 : window;
    function r2(o3) {
      i2.current(o3);
    }
    return n2.addEventListener(e2, r2, t2), () => n2.removeEventListener(e2, r2, t2);
  }, [n2, e2, t2]);
}
let z = "div";
var A$2 = ((t2) => (t2[t2.None = 1] = "None", t2[t2.InitialFocus = 2] = "InitialFocus", t2[t2.TabLock = 4] = "TabLock", t2[t2.FocusLock = 8] = "FocusLock", t2[t2.RestoreFocus = 16] = "RestoreFocus", t2[t2.All = 30] = "All", t2))(A$2 || {});
let de = Object.assign(V$1(function(u2, e2) {
  let l2 = useRef(null), a2 = y(l2, e2), { initialFocus: m2, containers: t2, features: n2 = 30, ...E2 } = u2;
  l$4() || (n2 = 1);
  let s2 = n$1(l2);
  J$2({ ownerDocument: s2 }, Boolean(n2 & 16));
  let S2 = Q$1({ ownerDocument: s2, container: l2, initialFocus: m2 }, Boolean(n2 & 2));
  X$1({ ownerDocument: s2, container: l2, containers: t2, previousActiveElement: S2 }, Boolean(n2 & 8));
  let H2 = n$2(), R = o$4((o3) => {
    let c2 = l2.current;
    if (!c2)
      return;
    ((_24) => _24())(() => {
      u$3(H2.current, { [s$2.Forwards]: () => {
        I$1(c2, L$1.First, { skipElements: [o3.relatedTarget] });
      }, [s$2.Backwards]: () => {
        I$1(c2, L$1.Last, { skipElements: [o3.relatedTarget] });
      } });
    });
  }), B2 = p$1(), L2 = useRef(false), P2 = { ref: a2, onKeyDown(o3) {
    o3.key == "Tab" && (L2.current = true, B2.requestAnimationFrame(() => {
      L2.current = false;
    }));
  }, onBlur(o3) {
    let c2 = new Set(t2 == null ? void 0 : t2.current);
    c2.add(l2);
    let p2 = o3.relatedTarget;
    p2 instanceof HTMLElement && p2.dataset.headlessuiFocusGuard !== "true" && (h$1(c2, p2) || (L2.current ? I$1(l2.current, u$3(H2.current, { [s$2.Forwards]: () => L$1.Next, [s$2.Backwards]: () => L$1.Previous }) | L$1.WrapAround, { relativeTo: o3.target }) : o3.target instanceof HTMLElement && S$1(o3.target)));
  } };
  return React__default$1.createElement(React__default$1.Fragment, null, Boolean(n2 & 4) && React__default$1.createElement(h$2, { as: "button", type: "button", "data-headlessui-focus-guard": true, onFocus: R, features: s$5.Focusable }), X$2({ ourProps: P2, theirProps: E2, defaultTag: z, name: "FocusTrap" }), Boolean(n2 & 4) && React__default$1.createElement(h$2, { as: "button", type: "button", "data-headlessui-focus-guard": true, onFocus: R, features: s$5.Focusable }));
}), { features: A$2 });
function J$2({ ownerDocument: r2 }, u2) {
  let e2 = useRef(null);
  E(r2 == null ? void 0 : r2.defaultView, "focusout", (a2) => {
    !u2 || e2.current || (e2.current = a2.target);
  }, true), m(() => {
    u2 || ((r2 == null ? void 0 : r2.activeElement) === (r2 == null ? void 0 : r2.body) && S$1(e2.current), e2.current = null);
  }, [u2]);
  let l2 = useRef(false);
  useEffect$1(() => (l2.current = false, () => {
    l2.current = true, t(() => {
      !l2.current || (S$1(e2.current), e2.current = null);
    });
  }), []);
}
function Q$1({ ownerDocument: r2, container: u2, initialFocus: e2 }, l2) {
  let a2 = useRef(null), m$12 = f$1();
  return m(() => {
    if (!l2)
      return;
    let t$12 = u2.current;
    !t$12 || t(() => {
      if (!m$12.current)
        return;
      let n2 = r2 == null ? void 0 : r2.activeElement;
      if (e2 != null && e2.current) {
        if ((e2 == null ? void 0 : e2.current) === n2) {
          a2.current = n2;
          return;
        }
      } else if (t$12.contains(n2)) {
        a2.current = n2;
        return;
      }
      e2 != null && e2.current ? S$1(e2.current) : I$1(t$12, L$1.First) === N.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), a2.current = r2 == null ? void 0 : r2.activeElement;
    });
  }, [l2]), a2;
}
function X$1({ ownerDocument: r2, container: u2, containers: e2, previousActiveElement: l2 }, a2) {
  let m2 = f$1();
  E(r2 == null ? void 0 : r2.defaultView, "focus", (t2) => {
    if (!a2 || !m2.current)
      return;
    let n2 = new Set(e2 == null ? void 0 : e2.current);
    n2.add(u2);
    let E2 = l2.current;
    if (!E2)
      return;
    let s2 = t2.target;
    s2 && s2 instanceof HTMLElement ? h$1(n2, s2) ? (l2.current = s2, S$1(s2)) : (t2.preventDefault(), t2.stopPropagation(), S$1(E2)) : S$1(l2.current);
  }, true);
}
function h$1(r2, u2) {
  var e2;
  for (let l2 of r2)
    if ((e2 = l2.current) != null && e2.contains(u2))
      return true;
  return false;
}
let i = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Map();
function u$1(t2) {
  t2.setAttribute("aria-hidden", "true"), t2.inert = true;
}
function l$3(t2) {
  let n2 = r.get(t2);
  !n2 || (n2["aria-hidden"] === null ? t2.removeAttribute("aria-hidden") : t2.setAttribute("aria-hidden", n2["aria-hidden"]), t2.inert = n2.inert);
}
function M$3(t2, n2 = true) {
  l$5(() => {
    if (!n2 || !t2.current)
      return;
    let o3 = t2.current, a2 = e$2(o3);
    if (!!a2) {
      i.add(o3);
      for (let e2 of r.keys())
        e2.contains(o3) && (l$3(e2), r.delete(e2));
      return a2.querySelectorAll("body > *").forEach((e2) => {
        if (e2 instanceof HTMLElement) {
          for (let f2 of i)
            if (e2.contains(f2))
              return;
          i.size === 1 && (r.set(e2, { "aria-hidden": e2.getAttribute("aria-hidden"), inert: e2.inert }), u$1(e2));
        }
      }), () => {
        if (i.delete(o3), i.size > 0)
          a2.querySelectorAll("body > *").forEach((e2) => {
            if (e2 instanceof HTMLElement && !r.has(e2)) {
              for (let f2 of i)
                if (e2.contains(f2))
                  return;
              r.set(e2, { "aria-hidden": e2.getAttribute("aria-hidden"), inert: e2.inert }), u$1(e2);
            }
          });
        else
          for (let e2 of r.keys())
            l$3(e2), r.delete(e2);
      };
    }
  }, [n2]);
}
let e = createContext(false);
function l$2() {
  return useContext(e);
}
function P$2(o3) {
  return React__default$1.createElement(e.Provider, { value: o3.force }, o3.children);
}
function x$1(i2) {
  let u2 = l$2(), o3 = useContext(A$1), e2 = n$1(i2), [r2, f2] = useState$1(() => {
    if (!u2 && o3 !== null || s$8.isServer)
      return null;
    let n2 = e2 == null ? void 0 : e2.getElementById("headlessui-portal-root");
    if (n2)
      return n2;
    if (e2 === null)
      return null;
    let t2 = e2.createElement("div");
    return t2.setAttribute("id", "headlessui-portal-root"), e2.body.appendChild(t2);
  });
  return useEffect$1(() => {
    r2 !== null && (e2 != null && e2.body.contains(r2) || e2 == null || e2.body.appendChild(r2));
  }, [r2, e2]), useEffect$1(() => {
    u2 || o3 !== null && f2(o3.current);
  }, [o3, f2, u2]), r2;
}
let _23 = Fragment$1, U = V$1(function(u2, o3) {
  let e2 = u2, r2 = useRef(null), f2 = y(T$1((a2) => {
    r2.current = a2;
  }), o3), n2 = n$1(r2), t$12 = x$1(r2), [l2] = useState$1(() => {
    var a2;
    return s$8.isServer ? null : (a2 = n2 == null ? void 0 : n2.createElement("div")) != null ? a2 : null;
  }), b = l$4(), p2 = useRef(false);
  return l$5(() => {
    if (p2.current = false, !(!t$12 || !l2))
      return t$12.contains(l2) || (l2.setAttribute("data-headlessui-portal", ""), t$12.appendChild(l2)), () => {
        p2.current = true, t(() => {
          var a2;
          !p2.current || !t$12 || !l2 || (l2 instanceof Node && t$12.contains(l2) && t$12.removeChild(l2), t$12.childNodes.length <= 0 && ((a2 = t$12.parentElement) == null || a2.removeChild(t$12)));
        });
      };
  }, [t$12, l2]), b ? !t$12 || !l2 ? null : createPortal(X$2({ ourProps: { ref: f2 }, theirProps: e2, defaultTag: _23, name: "Portal" }), l2) : null;
}), j = Fragment$1, A$1 = createContext(null), F$2 = V$1(function(u2, o3) {
  let { target: e2, ...r2 } = u2, n2 = { ref: y(o3) };
  return React__default$1.createElement(A$1.Provider, { value: e2 }, X$2({ ourProps: n2, theirProps: r2, defaultTag: j, name: "Popover.Group" }));
}), $ = Object.assign(U, { Group: F$2 });
let d = createContext(null);
function u() {
  let n2 = useContext(d);
  if (n2 === null) {
    let t2 = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t2, u), t2;
  }
  return n2;
}
function k$1() {
  let [n2, t2] = useState$1([]);
  return [n2.length > 0 ? n2.join(" ") : void 0, useMemo(() => function(e2) {
    let i2 = o$4((r2) => (t2((o3) => [...o3, r2]), () => t2((o3) => {
      let s2 = o3.slice(), p2 = s2.indexOf(r2);
      return p2 !== -1 && s2.splice(p2, 1), s2;
    }))), a2 = useMemo(() => ({ register: i2, slot: e2.slot, name: e2.name, props: e2.props }), [i2, e2.slot, e2.name, e2.props]);
    return React__default$1.createElement(d.Provider, { value: a2 }, e2.children);
  }, [t2])];
}
let S = "p", F$1 = V$1(function(t2, c2) {
  let e2 = I$2(), { id: i2 = `headlessui-description-${e2}`, ...a2 } = t2, r2 = u(), o3 = y(c2);
  l$5(() => r2.register(i2), [i2, r2.register]);
  let s2 = { ref: o3, ...r2.props, id: i2 };
  return X$2({ ourProps: s2, theirProps: a2, slot: r2.slot || {}, defaultTag: S, name: r2.name || "Description" });
});
let a = createContext(() => {
});
a.displayName = "StackContext";
var s$1 = ((e2) => (e2[e2.Add = 0] = "Add", e2[e2.Remove = 1] = "Remove", e2))(s$1 || {});
function x() {
  return useContext(a);
}
function M$2({ children: i2, onUpdate: r2, type: e2, element: n2, enabled: u2 }) {
  let l2 = x(), o3 = o$4((...t2) => {
    r2 == null || r2(...t2), l2(...t2);
  });
  return l$5(() => {
    let t2 = u2 === void 0 || u2 === true;
    return t2 && o3(0, e2, n2), () => {
      t2 && o3(1, e2, n2);
    };
  }, [o3, e2, n2, u2]), React__default$1.createElement(a.Provider, { value: o3 }, i2);
}
function o2() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
var be$1 = ((r2) => (r2[r2.Open = 0] = "Open", r2[r2.Closed = 1] = "Closed", r2))(be$1 || {}), ve = ((e2) => (e2[e2.SetTitleId = 0] = "SetTitleId", e2))(ve || {});
let Ae = { [0](t2, e2) {
  return t2.titleId === e2.id ? t2 : { ...t2, titleId: e2.id };
} }, H$1 = createContext(null);
H$1.displayName = "DialogContext";
function k(t2) {
  let e2 = useContext(H$1);
  if (e2 === null) {
    let r2 = new Error(`<${t2} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r2, k), r2;
  }
  return e2;
}
function Oe(t2, e2, r2 = () => [document.body]) {
  useEffect$1(() => {
    var c2;
    if (!e2 || !t2)
      return;
    let s2 = m$2(), d2 = window.pageYOffset;
    function a2(n2, i2, l2) {
      let y2 = n2.style.getPropertyValue(i2);
      return Object.assign(n2.style, { [i2]: l2 }), s2.add(() => {
        Object.assign(n2.style, { [i2]: y2 });
      });
    }
    let o$12 = t2.documentElement, f2 = ((c2 = t2.defaultView) != null ? c2 : window).innerWidth - o$12.clientWidth;
    if (a2(o$12, "overflow", "hidden"), f2 > 0) {
      let n2 = o$12.clientWidth - o$12.offsetWidth, i2 = f2 - n2;
      a2(o$12, "paddingRight", `${i2}px`);
    }
    if (o2()) {
      a2(t2.body, "marginTop", `-${d2}px`), window.scrollTo(0, 0);
      let n2 = null;
      s2.addEventListener(t2, "click", (i2) => {
        if (i2.target instanceof HTMLElement)
          try {
            let l2 = i2.target.closest("a");
            if (!l2)
              return;
            let { hash: y2 } = new URL(l2.href), u2 = t2.querySelector(y2);
            u2 && !r2().some((_24) => _24.contains(u2)) && (n2 = u2);
          } catch {
          }
      }, true), s2.addEventListener(t2, "touchmove", (i2) => {
        i2.target instanceof HTMLElement && !r2().some((l2) => l2.contains(i2.target)) && i2.preventDefault();
      }, { passive: false }), s2.add(() => {
        window.scrollTo(0, window.pageYOffset + d2), n2 && n2.isConnected && (n2.scrollIntoView({ block: "nearest" }), n2 = null);
      });
    }
    return s2.dispose;
  }, [t2, e2]);
}
function Ce(t2, e2) {
  return u$3(e2.type, Ae, t2, e2);
}
let Se$1 = "div", Le$1 = j$1.RenderStrategy | j$1.Static, Me = V$1(function(e2, r2) {
  let s2 = I$2(), { id: d2 = `headlessui-dialog-${s2}`, open: a2, onClose: o3, initialFocus: p$12, __demoMode: f2 = false, ...c2 } = e2, [n2, i2] = useState$1(0), l2 = s$4();
  a2 === void 0 && l2 !== null && (a2 = u$3(l2, { [p.Open]: true, [p.Closed]: false }));
  let y$1 = useRef(/* @__PURE__ */ new Set()), u2 = useRef(null), _24 = y(u2, r2), U2 = useRef(null), E$12 = n$1(u2), $$1 = e2.hasOwnProperty("open") || l2 !== null, Y2 = e2.hasOwnProperty("onClose");
  if (!$$1 && !Y2)
    throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
  if (!$$1)
    throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
  if (!Y2)
    throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
  if (typeof a2 != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${a2}`);
  if (typeof o3 != "function")
    throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${o3}`);
  let g = a2 ? 0 : 1, [h2, Q2] = useReducer(Ce, { titleId: null, descriptionId: null, panelRef: createRef() }), R = o$4(() => o3(false)), j2 = o$4((T2) => Q2({ type: 0, id: T2 })), x2 = l$4() ? f2 ? false : g === 0 : false, w2 = n2 > 1, X2 = useContext(H$1) !== null, Z2 = w2 ? "parent" : "leaf";
  M$3(u2, w2 ? x2 : false);
  let N2 = o$4(() => {
    var b, D2;
    return [...Array.from((b = E$12 == null ? void 0 : E$12.querySelectorAll("html > *, body > *, [data-headlessui-portal]")) != null ? b : []).filter((P2) => !(P2 === document.body || P2 === document.head || !(P2 instanceof HTMLElement) || P2.contains(U2.current) || h2.panelRef.current && P2.contains(h2.panelRef.current))), (D2 = h2.panelRef.current) != null ? D2 : u2.current];
  });
  L(() => N2(), R, x2 && !w2), E(E$12 == null ? void 0 : E$12.defaultView, "keydown", (T2) => {
    T2.defaultPrevented || T2.key === o$1.Escape && g === 0 && (w2 || (T2.preventDefault(), T2.stopPropagation(), R()));
  }), Oe(E$12, g === 0 && !X2, N2), useEffect$1(() => {
    if (g !== 0 || !u2.current)
      return;
    let T2 = new IntersectionObserver((b) => {
      for (let D2 of b)
        D2.boundingClientRect.x === 0 && D2.boundingClientRect.y === 0 && D2.boundingClientRect.width === 0 && D2.boundingClientRect.height === 0 && R();
    });
    return T2.observe(u2.current), () => T2.disconnect();
  }, [g, u2, R]);
  let [ee2, te2] = k$1(), oe2 = useMemo(() => [{ dialogState: g, close: R, setTitleId: j2 }, h2], [g, h2, R, j2]), V2 = useMemo(() => ({ open: g === 0 }), [g]), re2 = { ref: _24, id: d2, role: "dialog", "aria-modal": g === 0 ? true : void 0, "aria-labelledby": h2.titleId, "aria-describedby": ee2 };
  return React__default$1.createElement(M$2, { type: "Dialog", enabled: g === 0, element: u2, onUpdate: o$4((T2, b, D2) => {
    b === "Dialog" && u$3(T2, { [s$1.Add]() {
      y$1.current.add(D2), i2((P2) => P2 + 1);
    }, [s$1.Remove]() {
      y$1.current.add(D2), i2((P2) => P2 - 1);
    } });
  }) }, React__default$1.createElement(P$2, { force: true }, React__default$1.createElement($, null, React__default$1.createElement(H$1.Provider, { value: oe2 }, React__default$1.createElement($.Group, { target: u2 }, React__default$1.createElement(P$2, { force: false }, React__default$1.createElement(te2, { slot: V2, name: "Dialog.Description" }, React__default$1.createElement(de, { initialFocus: p$12, containers: y$1, features: x2 ? u$3(Z2, { parent: de.features.RestoreFocus, leaf: de.features.All & ~de.features.FocusLock }) : de.features.None }, X$2({ ourProps: re2, theirProps: c2, slot: V2, defaultTag: Se$1, features: Le$1, visible: g === 0, name: "Dialog" })))))))), React__default$1.createElement(h$2, { features: s$5.Hidden, ref: U2 }));
}), ke = "div", we = V$1(function(e2, r2) {
  let s2 = I$2(), { id: d2 = `headlessui-dialog-overlay-${s2}`, ...a2 } = e2, [{ dialogState: o3, close: p2 }] = k("Dialog.Overlay"), f2 = y(r2), c2 = o$4((l2) => {
    if (l2.target === l2.currentTarget) {
      if (r$1(l2.currentTarget))
        return l2.preventDefault();
      l2.preventDefault(), l2.stopPropagation(), p2();
    }
  }), n2 = useMemo(() => ({ open: o3 === 0 }), [o3]);
  return X$2({ ourProps: { ref: f2, id: d2, "aria-hidden": true, onClick: c2 }, theirProps: a2, slot: n2, defaultTag: ke, name: "Dialog.Overlay" });
}), Fe = "div", Ie = V$1(function(e2, r2) {
  let s2 = I$2(), { id: d2 = `headlessui-dialog-backdrop-${s2}`, ...a2 } = e2, [{ dialogState: o3 }, p2] = k("Dialog.Backdrop"), f2 = y(r2);
  useEffect$1(() => {
    if (p2.panelRef.current === null)
      throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
  }, [p2.panelRef]);
  let c2 = useMemo(() => ({ open: o3 === 0 }), [o3]);
  return React__default$1.createElement(P$2, { force: true }, React__default$1.createElement($, null, X$2({ ourProps: { ref: f2, id: d2, "aria-hidden": true }, theirProps: a2, slot: c2, defaultTag: Fe, name: "Dialog.Backdrop" })));
}), He$1 = "div", _e = V$1(function(e2, r2) {
  let s2 = I$2(), { id: d2 = `headlessui-dialog-panel-${s2}`, ...a2 } = e2, [{ dialogState: o3 }, p2] = k("Dialog.Panel"), f2 = y(r2, p2.panelRef), c2 = useMemo(() => ({ open: o3 === 0 }), [o3]), n2 = o$4((l2) => {
    l2.stopPropagation();
  });
  return X$2({ ourProps: { ref: f2, id: d2, onClick: n2 }, theirProps: a2, slot: c2, defaultTag: He$1, name: "Dialog.Panel" });
}), xe$1 = "h2", We = V$1(function(e2, r2) {
  let s2 = I$2(), { id: d2 = `headlessui-dialog-title-${s2}`, ...a2 } = e2, [{ dialogState: o3, setTitleId: p2 }] = k("Dialog.Title"), f2 = y(r2);
  useEffect$1(() => (p2(d2), () => p2(null)), [d2, p2]);
  let c2 = useMemo(() => ({ open: o3 === 0 }), [o3]);
  return X$2({ ourProps: { ref: f2, id: d2 }, theirProps: a2, slot: c2, defaultTag: xe$1, name: "Dialog.Title" });
}), mt = Object.assign(Me, { Backdrop: Ie, Panel: _e, Overlay: we, Title: We, Description: F$1 });
var J$1 = ((l2) => (l2[l2.Open = 0] = "Open", l2[l2.Closed = 1] = "Closed", l2))(J$1 || {}), Q = ((t2) => (t2[t2.ToggleDisclosure = 0] = "ToggleDisclosure", t2[t2.CloseDisclosure = 1] = "CloseDisclosure", t2[t2.SetButtonId = 2] = "SetButtonId", t2[t2.SetPanelId = 3] = "SetPanelId", t2[t2.LinkPanel = 4] = "LinkPanel", t2[t2.UnlinkPanel = 5] = "UnlinkPanel", t2))(Q || {});
let V = { [0]: (e2) => ({ ...e2, disclosureState: u$3(e2.disclosureState, { [0]: 1, [1]: 0 }) }), [1]: (e2) => e2.disclosureState === 1 ? e2 : { ...e2, disclosureState: 1 }, [4](e2) {
  return e2.linkedPanel === true ? e2 : { ...e2, linkedPanel: true };
}, [5](e2) {
  return e2.linkedPanel === false ? e2 : { ...e2, linkedPanel: false };
}, [2](e2, n2) {
  return e2.buttonId === n2.buttonId ? e2 : { ...e2, buttonId: n2.buttonId };
}, [3](e2, n2) {
  return e2.panelId === n2.panelId ? e2 : { ...e2, panelId: n2.panelId };
} }, B = createContext(null);
B.displayName = "DisclosureContext";
function v$1(e2) {
  let n2 = useContext(B);
  if (n2 === null) {
    let l2 = new Error(`<${e2} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(l2, v$1), l2;
  }
  return n2;
}
let h = createContext(null);
h.displayName = "DisclosureAPIContext";
function K(e2) {
  let n2 = useContext(h);
  if (n2 === null) {
    let l2 = new Error(`<${e2} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(l2, K), l2;
  }
  return n2;
}
let H = createContext(null);
H.displayName = "DisclosurePanelContext";
function X() {
  return useContext(H);
}
function Y(e2, n2) {
  return u$3(n2.type, V, e2, n2);
}
let Z = Fragment$1, ee = V$1(function(n2, l2) {
  let { defaultOpen: y$1 = false, ...u2 } = n2, T2 = useRef(null), t2 = y(l2, T$1((a2) => {
    T2.current = a2;
  }, n2.as === void 0 || n2.as === Fragment$1)), o3 = useRef(null), f2 = useRef(null), s2 = useReducer(Y, { disclosureState: y$1 ? 0 : 1, linkedPanel: false, buttonRef: f2, panelRef: o3, buttonId: null, panelId: null }), [{ disclosureState: i2, buttonId: p$12 }, D2] = s2, d2 = o$4((a2) => {
    D2({ type: 1 });
    let r2 = e$2(T2);
    if (!r2 || !p$12)
      return;
    let c2 = (() => a2 ? a2 instanceof HTMLElement ? a2 : a2.current instanceof HTMLElement ? a2.current : r2.getElementById(p$12) : r2.getElementById(p$12))();
    c2 == null || c2.focus();
  }), P2 = useMemo(() => ({ close: d2 }), [d2]), A2 = useMemo(() => ({ open: i2 === 0, close: d2 }), [i2, d2]), S2 = { ref: t2 };
  return React__default$1.createElement(B.Provider, { value: s2 }, React__default$1.createElement(h.Provider, { value: P2 }, React__default$1.createElement(C, { value: u$3(i2, { [0]: p.Open, [1]: p.Closed }) }, X$2({ ourProps: S2, theirProps: u2, slot: A2, defaultTag: Z, name: "Disclosure" }))));
}), te = "button", ne$1 = V$1(function(n2, l2) {
  let y$1 = I$2(), { id: u2 = `headlessui-disclosure-button-${y$1}`, ...T2 } = n2, [t2, o3] = v$1("Disclosure.Button"), f2 = X(), s2 = f2 === null ? false : f2 === t2.panelId, i2 = useRef(null), p2 = y(i2, l2, s2 ? null : t2.buttonRef);
  useEffect$1(() => {
    if (!s2)
      return o3({ type: 2, buttonId: u2 }), () => {
        o3({ type: 2, buttonId: null });
      };
  }, [u2, o3, s2]);
  let D2 = o$4((r2) => {
    var c2;
    if (s2) {
      if (t2.disclosureState === 1)
        return;
      switch (r2.key) {
        case o$1.Space:
        case o$1.Enter:
          r2.preventDefault(), r2.stopPropagation(), o3({ type: 0 }), (c2 = t2.buttonRef.current) == null || c2.focus();
          break;
      }
    } else
      switch (r2.key) {
        case o$1.Space:
        case o$1.Enter:
          r2.preventDefault(), r2.stopPropagation(), o3({ type: 0 });
          break;
      }
  }), d2 = o$4((r2) => {
    switch (r2.key) {
      case o$1.Space:
        r2.preventDefault();
        break;
    }
  }), P2 = o$4((r2) => {
    var c2;
    r$1(r2.currentTarget) || n2.disabled || (s2 ? (o3({ type: 0 }), (c2 = t2.buttonRef.current) == null || c2.focus()) : o3({ type: 0 }));
  }), A2 = useMemo(() => ({ open: t2.disclosureState === 0 }), [t2]), S2 = s$6(n2, i2), a2 = s2 ? { ref: p2, type: S2, onKeyDown: D2, onClick: P2 } : { ref: p2, id: u2, type: S2, "aria-expanded": n2.disabled ? void 0 : t2.disclosureState === 0, "aria-controls": t2.linkedPanel ? t2.panelId : void 0, onKeyDown: D2, onKeyUp: d2, onClick: P2 };
  return X$2({ ourProps: a2, theirProps: T2, slot: A2, defaultTag: te, name: "Disclosure.Button" });
}), le = "div", re$1 = j$1.RenderStrategy | j$1.Static, oe$1 = V$1(function(n2, l2) {
  let y$1 = I$2(), { id: u2 = `headlessui-disclosure-panel-${y$1}`, ...T2 } = n2, [t2, o3] = v$1("Disclosure.Panel"), { close: f2 } = K("Disclosure.Panel"), s2 = y(l2, t2.panelRef, (P2) => {
    o3({ type: P2 ? 4 : 5 });
  });
  useEffect$1(() => (o3({ type: 3, panelId: u2 }), () => {
    o3({ type: 3, panelId: null });
  }), [u2, o3]);
  let i2 = s$4(), p$12 = (() => i2 !== null ? i2 === p.Open : t2.disclosureState === 0)(), D2 = useMemo(() => ({ open: t2.disclosureState === 0, close: f2 }), [t2, f2]), d2 = { ref: s2, id: u2 };
  return React__default$1.createElement(H.Provider, { value: t2.panelId }, X$2({ ourProps: d2, theirProps: T2, slot: D2, defaultTag: le, features: re$1, visible: p$12, name: "Disclosure.Panel" }));
}), Le = Object.assign(ee, { Button: ne$1, Panel: oe$1 });
function l$1(r2) {
  let e2 = { called: false };
  return (...t2) => {
    if (!e2.called)
      return e2.called = true, r2(...t2);
  };
}
function v(t2, ...e2) {
  t2 && e2.length > 0 && t2.classList.add(...e2);
}
function f(t2, ...e2) {
  t2 && e2.length > 0 && t2.classList.remove(...e2);
}
function F(t2, e2) {
  let n2 = m$2();
  if (!t2)
    return n2.dispose;
  let { transitionDuration: a2, transitionDelay: i2 } = getComputedStyle(t2), [m2, d2] = [a2, i2].map((o3) => {
    let [r2 = 0] = o3.split(",").filter(Boolean).map((l2) => l2.includes("ms") ? parseFloat(l2) : parseFloat(l2) * 1e3).sort((l2, g) => g - l2);
    return r2;
  });
  if (m2 + d2 !== 0) {
    let o3 = n2.addEventListener(t2, "transitionend", (r2) => {
      r2.target === r2.currentTarget && (e2(), o3());
    });
  } else
    e2();
  return n2.add(() => e2()), n2.dispose;
}
function M$1(t2, e2, n2, a2) {
  let i2 = n2 ? "enter" : "leave", m2 = m$2(), d2 = a2 !== void 0 ? l$1(a2) : () => {
  };
  i2 === "enter" && (t2.removeAttribute("hidden"), t2.style.display = "");
  let u2 = u$3(i2, { enter: () => e2.enter, leave: () => e2.leave }), o3 = u$3(i2, { enter: () => e2.enterTo, leave: () => e2.leaveTo }), r2 = u$3(i2, { enter: () => e2.enterFrom, leave: () => e2.leaveFrom });
  return f(t2, ...e2.enter, ...e2.enterTo, ...e2.enterFrom, ...e2.leave, ...e2.leaveFrom, ...e2.leaveTo, ...e2.entered), v(t2, ...u2, ...r2), m2.nextFrame(() => {
    f(t2, ...r2), v(t2, ...o3), F(t2, () => (f(t2, ...u2), v(t2, ...e2.entered), d2()));
  }), m2.dispose;
}
function D({ container: i2, direction: t2, classes: o3, onStart: s2, onStop: u2 }) {
  let a2 = f$1(), c2 = p$1(), r2 = s$7(t2);
  l$5(() => {
    let e2 = m$2();
    c2.add(e2.dispose);
    let n2 = i2.current;
    if (!!n2 && r2.current !== "idle" && !!a2.current)
      return e2.dispose(), s2.current(r2.current), e2.add(M$1(n2, o3.current, r2.current === "enter", () => {
        e2.dispose(), u2.current(r2.current);
      })), e2.dispose;
  }, [t2]);
}
function P$1(i2 = "") {
  return i2.split(" ").filter((e2) => e2.trim().length > 1);
}
let A = createContext(null);
A.displayName = "TransitionContext";
var ge = ((s2) => (s2.Visible = "visible", s2.Hidden = "hidden", s2))(ge || {});
function be() {
  let i2 = useContext(A);
  if (i2 === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return i2;
}
function Ee() {
  let i2 = useContext(M);
  if (i2 === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return i2;
}
let M = createContext(null);
M.displayName = "NestingContext";
function I(i2) {
  return "children" in i2 ? I(i2.children) : i2.current.filter(({ el: e2 }) => e2.current !== null).filter(({ state: e2 }) => e2 === "visible").length > 0;
}
function ne(i2, e2) {
  let s2 = s$7(i2), n2 = useRef([]), m2 = f$1(), y2 = p$1(), b = o$4((l2, r2 = w.Hidden) => {
    let t2 = n2.current.findIndex(({ el: o3 }) => o3 === l2);
    t2 !== -1 && (u$3(r2, { [w.Unmount]() {
      n2.current.splice(t2, 1);
    }, [w.Hidden]() {
      n2.current[t2].state = "hidden";
    } }), y2.microTask(() => {
      var o3;
      !I(n2) && m2.current && ((o3 = s2.current) == null || o3.call(s2));
    }));
  }), E2 = o$4((l2) => {
    let r2 = n2.current.find(({ el: t2 }) => t2 === l2);
    return r2 ? r2.state !== "visible" && (r2.state = "visible") : n2.current.push({ el: l2, state: "visible" }), () => b(l2, w.Unmount);
  }), S2 = useRef([]), u2 = useRef(Promise.resolve()), p2 = useRef({ enter: [], leave: [], idle: [] }), d2 = o$4((l2, r2, t2) => {
    S2.current.splice(0), e2 && (e2.chains.current[r2] = e2.chains.current[r2].filter(([o3]) => o3 !== l2)), e2 == null || e2.chains.current[r2].push([l2, new Promise((o3) => {
      S2.current.push(o3);
    })]), e2 == null || e2.chains.current[r2].push([l2, new Promise((o3) => {
      Promise.all(p2.current[r2].map(([f2, a2]) => a2)).then(() => o3());
    })]), r2 === "enter" ? u2.current = u2.current.then(() => e2 == null ? void 0 : e2.wait.current).then(() => t2(r2)) : t2(r2);
  }), v2 = o$4((l2, r2, t2) => {
    Promise.all(p2.current[r2].splice(0).map(([o3, f2]) => f2)).then(() => {
      var o3;
      (o3 = S2.current.shift()) == null || o3();
    }).then(() => t2(r2));
  });
  return useMemo(() => ({ children: n2, register: E2, unregister: b, onStart: d2, onStop: v2, wait: u2, chains: p2 }), [E2, b, n2, d2, v2, p2, u2]);
}
function Se() {
}
let xe = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];
function re(i2) {
  var s2;
  let e2 = {};
  for (let n2 of xe)
    e2[n2] = (s2 = i2[n2]) != null ? s2 : Se;
  return e2;
}
function Pe(i2) {
  let e2 = useRef(re(i2));
  return useEffect$1(() => {
    e2.current = re(i2);
  }, [i2]), e2;
}
let He = "div", ie = j$1.RenderStrategy, oe = V$1(function(e2, s2) {
  let { beforeEnter: n2, afterEnter: m2, beforeLeave: y$1, afterLeave: b, enter: E2, enterFrom: S2, enterTo: u2, entered: p$12, leave: d2, leaveFrom: v2, leaveTo: l2, ...r2 } = e2, t2 = useRef(null), o3 = y(t2, s2), f2 = r2.unmount ? w.Unmount : w.Hidden, { show: a2, appear: x2, initial: se } = be(), [h2, _24] = useState$1(a2 ? "visible" : "hidden"), K2 = Ee(), { register: D$1, unregister: V2 } = K2, j2 = useRef(null);
  useEffect$1(() => D$1(t2), [D$1, t2]), useEffect$1(() => {
    if (f2 === w.Hidden && !!t2.current) {
      if (a2 && h2 !== "visible") {
        _24("visible");
        return;
      }
      return u$3(h2, { ["hidden"]: () => V2(t2), ["visible"]: () => D$1(t2) });
    }
  }, [h2, t2, D$1, V2, a2, f2]);
  let U2 = s$7({ enter: P$1(E2), enterFrom: P$1(S2), enterTo: P$1(u2), entered: P$1(p$12), leave: P$1(d2), leaveFrom: P$1(v2), leaveTo: P$1(l2) }), L2 = Pe({ beforeEnter: n2, afterEnter: m2, beforeLeave: y$1, afterLeave: b }), k2 = l$4();
  useEffect$1(() => {
    if (k2 && h2 === "visible" && t2.current === null)
      throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [t2, h2, k2]);
  let G = se && !x2, le2 = (() => !k2 || G || j2.current === a2 ? "idle" : a2 ? "enter" : "leave")(), ae = o$4((C2) => u$3(C2, { enter: () => L2.current.beforeEnter(), leave: () => L2.current.beforeLeave(), idle: () => {
  } })), ue = o$4((C2) => u$3(C2, { enter: () => L2.current.afterEnter(), leave: () => L2.current.afterLeave(), idle: () => {
  } })), w$12 = ne(() => {
    _24("hidden"), V2(t2);
  }, K2);
  D({ container: t2, classes: U2, direction: le2, onStart: s$7((C2) => {
    w$12.onStart(t2, C2, ae);
  }), onStop: s$7((C2) => {
    w$12.onStop(t2, C2, ue), C2 === "leave" && !I(w$12) && (_24("hidden"), V2(t2));
  }) }), useEffect$1(() => {
    !G || (f2 === w.Hidden ? j2.current = null : j2.current = a2);
  }, [a2, G, h2]);
  let B2 = r2, de2 = { ref: o3 };
  return x2 && a2 && s$8.isServer && (B2 = { ...B2, className: e$1(r2.className, ...U2.current.enter, ...U2.current.enterFrom) }), React__default$1.createElement(M.Provider, { value: w$12 }, React__default$1.createElement(C, { value: u$3(h2, { ["visible"]: p.Open, ["hidden"]: p.Closed }) }, X$2({ ourProps: de2, theirProps: B2, defaultTag: He, features: ie, visible: h2 === "visible", name: "Transition.Child" })));
}), J = V$1(function(e2, s2) {
  let { show: n2, appear: m2 = false, unmount: y$1, ...b } = e2, E2 = useRef(null), S2 = y(E2, s2);
  l$4();
  let u2 = s$4();
  if (n2 === void 0 && u2 !== null && (n2 = u$3(u2, { [p.Open]: true, [p.Closed]: false })), ![true, false].includes(n2))
    throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  let [p$12, d2] = useState$1(n2 ? "visible" : "hidden"), v2 = ne(() => {
    d2("hidden");
  }), [l2, r2] = useState$1(true), t2 = useRef([n2]);
  l$5(() => {
    l2 !== false && t2.current[t2.current.length - 1] !== n2 && (t2.current.push(n2), r2(false));
  }, [t2, n2]);
  let o3 = useMemo(() => ({ show: n2, appear: m2, initial: l2 }), [n2, m2, l2]);
  useEffect$1(() => {
    if (n2)
      d2("visible");
    else if (!I(v2))
      d2("hidden");
    else {
      let a2 = E2.current;
      if (!a2)
        return;
      let x2 = a2.getBoundingClientRect();
      x2.x === 0 && x2.y === 0 && x2.width === 0 && x2.height === 0 && d2("hidden");
    }
  }, [n2, v2]);
  let f2 = { unmount: y$1 };
  return React__default$1.createElement(M.Provider, { value: v2 }, React__default$1.createElement(A.Provider, { value: o3 }, X$2({ ourProps: { ...f2, as: Fragment$1, children: React__default$1.createElement(oe, { ref: S2, ...f2, ...b }) }, theirProps: {}, defaultTag: Fragment$1, features: ie, visible: p$12 === "visible", name: "Transition" })));
}), Ne = V$1(function(e2, s2) {
  let n2 = useContext(A) !== null, m2 = s$4() !== null;
  return React__default$1.createElement(React__default$1.Fragment, null, !n2 && m2 ? React__default$1.createElement(J, { ref: s2, ...e2 }) : React__default$1.createElement(oe, { ref: s2, ...e2 }));
}), Ke = Object.assign(J, { Child: Ne, Root: J });
var PulseLoader$1 = {};
var unitConverter = {};
Object.defineProperty(unitConverter, "__esModule", { value: true });
unitConverter.cssValue = unitConverter.parseLengthAndUnit = void 0;
var cssUnit = {
  cm: true,
  mm: true,
  in: true,
  px: true,
  pt: true,
  pc: true,
  em: true,
  ex: true,
  ch: true,
  rem: true,
  vw: true,
  vh: true,
  vmin: true,
  vmax: true,
  "%": true
};
function parseLengthAndUnit(size) {
  if (typeof size === "number") {
    return {
      value: size,
      unit: "px"
    };
  }
  var value;
  var valueString = (size.match(/^[0-9.]*/) || "").toString();
  if (valueString.includes(".")) {
    value = parseFloat(valueString);
  } else {
    value = parseInt(valueString, 10);
  }
  var unit = (size.match(/[^0-9]*$/) || "").toString();
  if (cssUnit[unit]) {
    return {
      value,
      unit
    };
  }
  console.warn("React Spinners: ".concat(size, " is not a valid css value. Defaulting to ").concat(value, "px."));
  return {
    value,
    unit: "px"
  };
}
unitConverter.parseLengthAndUnit = parseLengthAndUnit;
function cssValue(value) {
  var lengthWithunit = parseLengthAndUnit(value);
  return "".concat(lengthWithunit.value).concat(lengthWithunit.unit);
}
unitConverter.cssValue = cssValue;
var animation = {};
Object.defineProperty(animation, "__esModule", { value: true });
animation.createAnimation = void 0;
var createAnimation = function(loaderName, frames, suffix) {
  var animationName = "react-spinners-".concat(loaderName, "-").concat(suffix);
  if (typeof window == "undefined" || !window.document) {
    return animationName;
  }
  var styleEl = document.createElement("style");
  document.head.appendChild(styleEl);
  var styleSheet = styleEl.sheet;
  var keyFrames = "\n    @keyframes ".concat(animationName, " {\n      ").concat(frames, "\n    }\n  ");
  if (styleSheet) {
    styleSheet.insertRule(keyFrames, 0);
  }
  return animationName;
};
animation.createAnimation = createAnimation;
var __assign$1 = commonjsGlobal && commonjsGlobal.__assign || function() {
  __assign$1 = Object.assign || function(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign$1.apply(this, arguments);
};
var __createBinding$1 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o3, m2, k2, k22) {
  if (k22 === void 0)
    k22 = k2;
  var desc = Object.getOwnPropertyDescriptor(m2, k2);
  if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) {
    desc = { enumerable: true, get: function() {
      return m2[k2];
    } };
  }
  Object.defineProperty(o3, k22, desc);
} : function(o3, m2, k2, k22) {
  if (k22 === void 0)
    k22 = k2;
  o3[k22] = m2[k2];
});
var __setModuleDefault$1 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o3, v2) {
  Object.defineProperty(o3, "default", { enumerable: true, value: v2 });
} : function(o3, v2) {
  o3["default"] = v2;
});
var __importStar$1 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
  if (mod2 && mod2.__esModule)
    return mod2;
  var result = {};
  if (mod2 != null) {
    for (var k2 in mod2)
      if (k2 !== "default" && Object.prototype.hasOwnProperty.call(mod2, k2))
        __createBinding$1(result, mod2, k2);
  }
  __setModuleDefault$1(result, mod2);
  return result;
};
var __rest$1 = commonjsGlobal && commonjsGlobal.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
Object.defineProperty(PulseLoader$1, "__esModule", { value: true });
var React$2 = __importStar$1(React__default$1);
var unitConverter_1$1 = unitConverter;
var animation_1$1 = animation;
var pulse = (0, animation_1$1.createAnimation)("PulseLoader", "0% {transform: scale(1); opacity: 1} 45% {transform: scale(0.1); opacity: 0.7} 80% {transform: scale(1); opacity: 1}", "pulse");
function PulseLoader(_a) {
  var _b = _a.loading, loading = _b === void 0 ? true : _b, _c = _a.color, color = _c === void 0 ? "#000000" : _c, _d = _a.speedMultiplier, speedMultiplier = _d === void 0 ? 1 : _d, _e2 = _a.cssOverride, cssOverride = _e2 === void 0 ? {} : _e2, _f = _a.size, size = _f === void 0 ? 15 : _f, _g = _a.margin, margin = _g === void 0 ? 2 : _g, additionalprops = __rest$1(_a, ["loading", "color", "speedMultiplier", "cssOverride", "size", "margin"]);
  var wrapper = __assign$1({ display: "inherit" }, cssOverride);
  var style = function(i2) {
    return {
      backgroundColor: color,
      width: (0, unitConverter_1$1.cssValue)(size),
      height: (0, unitConverter_1$1.cssValue)(size),
      margin: (0, unitConverter_1$1.cssValue)(margin),
      borderRadius: "100%",
      display: "inline-block",
      animation: "".concat(pulse, " ").concat(0.75 / speedMultiplier, "s ").concat(i2 * 0.12 / speedMultiplier, "s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08)"),
      animationFillMode: "both"
    };
  };
  if (!loading) {
    return null;
  }
  return React$2.createElement(
    "span",
    __assign$1({ style: wrapper }, additionalprops),
    React$2.createElement("span", { style: style(1) }),
    React$2.createElement("span", { style: style(2) }),
    React$2.createElement("span", { style: style(3) })
  );
}
var _default$2 = PulseLoader$1.default = PulseLoader;
const ListingContext = createContext();
function Link({ url, children, tag: tag2 = "a", ...rest }) {
  const { linkComponent } = useContext(ListingContext);
  const internal = /^\/(?!\/)/.test(url) && (rest == null ? void 0 : rest.target) !== "_blank" && linkComponent;
  const Tag = internal ? linkComponent : tag2;
  return /* @__PURE__ */ jsx(Tag, { ...internal ? { to: url } : { href: url }, ...rest, children });
}
function Button({
  buttonLabel,
  buttonLink,
  buttonStyle,
  onClick: onClick2,
  size,
  customId,
  includeConsent,
  scrollToTop,
  className,
  children,
  loading,
  disabled,
  tag: propTag,
  ...rest
}) {
  let buttonClass = "btn-pink";
  switch (buttonStyle) {
    case "white":
      buttonClass = "btn-white";
      break;
    case "blue":
      buttonClass = "btn-blue";
      break;
    case "light blue":
      buttonClass = "btn-bluelight";
      break;
    case "link":
      buttonClass = "btn-link-caret";
      break;
    case "link-underline":
      buttonClass = "btn-link-underline";
      break;
    case "back":
      buttonClass = "btn-back";
      break;
    case "back-charcoal":
      buttonClass = "btn-back-charcoal";
      break;
    case "transparent":
      buttonClass = "btn-transparent";
      break;
    case "lime":
      buttonClass = "btn-lime";
      break;
    case "pink":
    default:
      buttonClass = "btn-pink";
  }
  const classes2 = cx(
    {
      btn: !["link", "link-underline"].includes(buttonStyle),
      "cursor-not-allowed": disabled,
      "btn-sm": size === "sm",
      group: buttonStyle === "link"
    },
    buttonClass,
    className
  );
  const id = customId || null;
  const buttonChildren = children || buttonLabel;
  const tag2 = propTag ? propTag : onClick2 ? "button" : "a";
  const textColor = ["btn-blue", "btn-pink", void 0].includes(buttonStyle) ? "light" : "dark";
  if (scrollToTop) {
    return /* @__PURE__ */ jsx(
      "button",
      {
        className: classes2,
        disabled,
        id,
        ...rest,
        onClick: () => {
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
        },
        children: buttonChildren
      }
    );
  }
  if (onClick2 && !buttonLink) {
    return /* @__PURE__ */ jsx(
      "button",
      {
        className: classes2,
        disabled,
        id,
        ...rest,
        onClick: onClick2,
        children: buttonChildren
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    Link,
    {
      url: buttonLink,
      tag: tag2,
      className: classes2,
      id,
      disabled,
      onClick: onClick2,
      ...rest,
      children: [
        loading ? /* @__PURE__ */ jsx(
          _default$2,
          {
            size: 5,
            color: textColor === "light" ? "#FFFFFF" : "#022640"
          }
        ) : buttonChildren,
        buttonStyle === "link" ? /* @__PURE__ */ jsx(
          "svg",
          {
            className: "w-3 h-3 mb-0.5 ml-1 transition transform fill-current group-hover:translate-x-1",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 129 129",
            children: /* @__PURE__ */ jsx("path", { d: "M40.4 121.3c-.8.8-1.8 1.2-2.9 1.2s-2.1-.4-2.9-1.2c-1.6-1.6-1.6-4.2 0-5.8l51-51-51-51c-1.6-1.6-1.6-4.2 0-5.8 1.6-1.6 4.2-1.6 5.8 0l53.9 53.9c1.6 1.6 1.6 4.2 0 5.8l-53.9 53.9z" })
          }
        ) : null
      ]
    }
  );
}
function ListingInfoItem({ label, value, link, hover }) {
  const [hoverOpen, setHoverOpen] = useState$1(false);
  function renderMultiLineString2(multiLineString) {
    if (!multiLineString || typeof multiLineString !== "string" || !multiLineString.includes("\n")) {
      return multiLineString;
    }
    return /* @__PURE__ */ jsx(Fragment, { children: multiLineString.split("\n").map((i2, key) => {
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        i2,
        /* @__PURE__ */ jsx("br", {})
      ] });
    }) });
  }
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "flex flex-col py-2 mb-3 lg:mb-0 lg:flex-row text-[17px]",
      children: [
        /* @__PURE__ */ jsxs("span", { className: "pr-4 mb-3 text-blue-500 break-words lg:mb-0 lg:w-2/5", children: [
          label,
          " ",
          hover ? /* @__PURE__ */ jsx("button", { onClick: () => setHoverOpen(true), children: /* @__PURE__ */ jsx(FaRegQuestionCircle, { className: "-mb-0.5 ml-1 text-pink-500 fill-current" }) }) : null
        ] }),
        /* @__PURE__ */ jsx("span", { className: "text-gray-800 lg:w-3/5", children: link ? /* @__PURE__ */ jsx(Link, { className: "underline", url: link, children: value }) : renderMultiLineString2(value) || "-" }),
        /* @__PURE__ */ jsxs(
          Ke,
          {
            show: hoverOpen,
            as: "div",
            enter: "transform ease-out duration-300 transition",
            enterFrom: "translate-y-2 opacity-0",
            enterTo: "translate-y-0 opacity-100",
            leave: "transition ease-in duration-100",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            className: "fixed max-w-md ml-3 bg-white border border-gray-500 rounded shadow-xl lg:ml-5 lg:bottom-5 lg:right-5 bottom-3 right-3",
            children: [
              /* @__PURE__ */ jsx("div", { className: "px-8 py-4 text-gray-800", children: hover }),
              /* @__PURE__ */ jsx("div", { className: "flex justify-end p-4 border-t border-gray-500", children: /* @__PURE__ */ jsx(Button, { onClick: () => setHoverOpen(false), size: "sm", children: "OK" }) })
            ]
          }
        )
      ]
    },
    label
  );
}
function ListingInfoTable({ infoArray }) {
  return /* @__PURE__ */ jsx(Fragment, { children: infoArray.map((item, i2) => {
    const [label, content] = Object.entries(item)[0];
    let value, hover, link;
    if (typeof content === "undefined" || typeof content === "string" || typeof content === "number" || content === null) {
      value = content;
    } else {
      value = content.value;
      hover = content.hover;
      link = content.link;
    }
    return /* @__PURE__ */ jsx(
      ListingInfoItem,
      {
        label,
        value,
        link,
        hover
      },
      `${label}-${content}-${i2}`
    );
  }) });
}
function ListingInfo({ headline, children, className }) {
  const { width } = useWindowSize();
  const onMobile = width < 992;
  const HeadlineTag = "h4";
  return /* @__PURE__ */ jsx(Fragment, { children: onMobile ? /* @__PURE__ */ jsx(
    Le,
    {
      as: "div",
      className: cx("lg:mb-10 lg:hidden", className),
      children: ({ open }) => /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxs(Le.Button, { className: "flex items-center w-full px-4 pb-6 text-left text-blue-500 pt-7 h4 focus:outline-none webkit-tab-highlight-color-transparent", children: [
          open ? /* @__PURE__ */ jsx(AiOutlineMinus, { className: "mr-3 text-blue-500 fill-current w-7 h-7" }) : /* @__PURE__ */ jsx(AiOutlinePlus, { className: "mr-3 text-blue-500 fill-current w-7 h-7" }),
          /* @__PURE__ */ jsx(HeadlineTag, { children: headline })
        ] }),
        /* @__PURE__ */ jsx(
          Ke,
          {
            show: open,
            enter: "transition-all duration-200 ease-in-out",
            enterFrom: "transform opacity-0 -translate-y-2",
            enterTo: "transform opacity-100 translate-y-0",
            leave: "transition-all duration-75 ease-in-out",
            leaveFrom: "transform opacity-100 translate-y-0",
            leaveTo: "transform opacity-0 -translate-y-2",
            children: /* @__PURE__ */ jsx(Le.Panel, { static: true, children: /* @__PURE__ */ jsx("div", { className: "pr-4 mb-6 pl-14 lg:pl-0 lg:pr-0", children }) })
          }
        )
      ] })
    }
  ) : /* @__PURE__ */ jsxs("div", { className: cx("lg:mb-10 hidden lg:block", className), children: [
    /* @__PURE__ */ jsx("h3", { className: "mb-5 text-blue-500", children: headline }),
    /* @__PURE__ */ jsx("div", { className: "pr-4 mb-6 pl-14 lg:pl-0 lg:pr-0", children })
  ] }) });
}
function ListingBasicInfo({ listingInfo }) {
  const { t: t2 } = useTranslation();
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col divide-y divide-gray-500 lg:flex-row lg:space-x-7 lg:divide-y-0", children: [
    /* @__PURE__ */ jsx(ListingInfo, { headline: t2("basic_info"), className: "lg:w-1/2", children: /* @__PURE__ */ jsx(ListingInfoTable, { infoArray: getBasicInfoArr(listingInfo) }) }),
    /* @__PURE__ */ jsx(ListingInfo, { headline: t2("building_info"), className: "lg:w-1/2", children: /* @__PURE__ */ jsx(ListingInfoTable, { infoArray: getBuildingInfoArr(listingInfo) }) })
  ] });
}
function arrayPush$2(array, values) {
  var index = -1, length = values.length, offset2 = array.length;
  while (++index < length) {
    array[offset2 + index] = values[index];
  }
  return array;
}
var _arrayPush = arrayPush$2;
var baseGetTag$3 = _baseGetTag, isObjectLike$4 = isObjectLike_1;
var argsTag$2 = "[object Arguments]";
function baseIsArguments$1(value) {
  return isObjectLike$4(value) && baseGetTag$3(value) == argsTag$2;
}
var _baseIsArguments = baseIsArguments$1;
var baseIsArguments = _baseIsArguments, isObjectLike$3 = isObjectLike_1;
var objectProto$a = Object.prototype;
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;
var propertyIsEnumerable$1 = objectProto$a.propertyIsEnumerable;
var isArguments$3 = baseIsArguments(function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike$3(value) && hasOwnProperty$8.call(value, "callee") && !propertyIsEnumerable$1.call(value, "callee");
};
var isArguments_1 = isArguments$3;
var Symbol$2 = _Symbol, isArguments$2 = isArguments_1, isArray$8 = isArray_1;
var spreadableSymbol = Symbol$2 ? Symbol$2.isConcatSpreadable : void 0;
function isFlattenable$1(value) {
  return isArray$8(value) || isArguments$2(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
var _isFlattenable = isFlattenable$1;
var arrayPush$1 = _arrayPush, isFlattenable = _isFlattenable;
function baseFlatten$1(array, depth, predicate, isStrict, result) {
  var index = -1, length = array.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);
  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        baseFlatten$1(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush$1(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}
var _baseFlatten = baseFlatten$1;
var isArray$7 = isArray_1, isSymbol$3 = isSymbol_1;
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey$3(value, object) {
  if (isArray$7(value)) {
    return false;
  }
  var type2 = typeof value;
  if (type2 == "number" || type2 == "symbol" || type2 == "boolean" || value == null || isSymbol$3(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
var _isKey = isKey$3;
var baseGetTag$2 = _baseGetTag, isObject$5 = isObject_1;
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$2(value) {
  if (!isObject$5(value)) {
    return false;
  }
  var tag2 = baseGetTag$2(value);
  return tag2 == funcTag$1 || tag2 == genTag || tag2 == asyncTag || tag2 == proxyTag;
}
var isFunction_1 = isFunction$2;
var root$8 = _root;
var coreJsData$1 = root$8["__core-js_shared__"];
var _coreJsData = coreJsData$1;
var coreJsData = _coreJsData;
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked$1;
var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e2) {
    }
    try {
      return func + "";
    } catch (e2) {
    }
  }
  return "";
}
var _toSource = toSource$2;
var isFunction$1 = isFunction_1, isMasked = _isMasked, isObject$4 = isObject_1, toSource$1 = _toSource;
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype, objectProto$9 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty$7).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$1(value) {
  if (!isObject$4(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}
var _baseIsNative = baseIsNative$1;
function getValue$1(object, key) {
  return object == null ? void 0 : object[key];
}
var _getValue = getValue$1;
var baseIsNative = _baseIsNative, getValue = _getValue;
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : void 0;
}
var _getNative = getNative$7;
var getNative$6 = _getNative;
var nativeCreate$4 = getNative$6(Object, "create");
var _nativeCreate = nativeCreate$4;
var nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}
var _hashClear = hashClear$1;
function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete$1;
var nativeCreate$2 = _nativeCreate;
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$8 = Object.prototype;
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$6.call(data, key) ? data[key] : void 0;
}
var _hashGet = hashGet$1;
var nativeCreate$1 = _nativeCreate;
var objectProto$7 = Object.prototype;
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== void 0 : hasOwnProperty$5.call(data, key);
}
var _hashHas = hashHas$1;
var nativeCreate = _nativeCreate;
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
var _hashSet = hashSet$1;
var hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
function Hash$1(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
Hash$1.prototype.clear = hashClear;
Hash$1.prototype["delete"] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear$1;
function eq$3(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq$3;
var eq$2 = eq_1;
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$2(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf$4;
var assocIndexOf$3 = _assocIndexOf;
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete$1(key) {
  var data = this.__data__, index = assocIndexOf$3(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete$1;
var assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(key) {
  var data = this.__data__, index = assocIndexOf$2(data, key);
  return index < 0 ? void 0 : data[index][1];
}
var _listCacheGet = listCacheGet$1;
var assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas$1;
var assocIndexOf = _assocIndexOf;
function listCacheSet$1(key, value) {
  var data = this.__data__, index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet$1;
var listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
function ListCache$4(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype["delete"] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4;
var getNative$5 = _getNative, root$7 = _root;
var Map$4 = getNative$5(root$7, "Map");
var _Map = Map$4;
var Hash = _Hash, ListCache$3 = _ListCache, Map$3 = _Map;
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$3 || ListCache$3)(),
    "string": new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(value) {
  var type2 = typeof value;
  return type2 == "string" || type2 == "number" || type2 == "symbol" || type2 == "boolean" ? value !== "__proto__" : value === null;
}
var _isKeyable = isKeyable$1;
var isKeyable = _isKeyable;
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var _getMapData = getMapData$4;
var getMapData$3 = _getMapData;
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete$1;
var getMapData$2 = _getMapData;
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}
var _mapCacheGet = mapCacheGet$1;
var getMapData$1 = _getMapData;
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}
var _mapCacheHas = mapCacheHas$1;
var getMapData = _getMapData;
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key), size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet$1;
var mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
function MapCache$3(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype["delete"] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3;
var MapCache$2 = _MapCache;
var FUNC_ERROR_TEXT$2 = "Expected a function";
function memoize$1(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache$2)();
  return memoized;
}
memoize$1.Cache = MapCache$2;
var memoize_1 = memoize$1;
var memoize = memoize_1;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped$1(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}
var _memoizeCapped = memoizeCapped$1;
var memoizeCapped = _memoizeCapped;
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath$1 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46) {
    result.push("");
  }
  string.replace(rePropName, function(match2, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match2);
  });
  return result;
});
var _stringToPath = stringToPath$1;
var isArray$6 = isArray_1, isKey$2 = _isKey, stringToPath = _stringToPath, toString = toString_1;
function castPath$2(value, object) {
  if (isArray$6(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath(toString(value));
}
var _castPath = castPath$2;
var isSymbol$2 = isSymbol_1;
var INFINITY = 1 / 0;
function toKey$4(value) {
  if (typeof value == "string" || isSymbol$2(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
var _toKey = toKey$4;
var castPath$1 = _castPath, toKey$3 = _toKey;
function baseGet$3(object, path2) {
  path2 = castPath$1(path2, object);
  var index = 0, length = path2.length;
  while (object != null && index < length) {
    object = object[toKey$3(path2[index++])];
  }
  return index && index == length ? object : void 0;
}
var _baseGet = baseGet$3;
var ListCache$2 = _ListCache;
function stackClear$1() {
  this.__data__ = new ListCache$2();
  this.size = 0;
}
var _stackClear = stackClear$1;
function stackDelete$1(key) {
  var data = this.__data__, result = data["delete"](key);
  this.size = data.size;
  return result;
}
var _stackDelete = stackDelete$1;
function stackGet$1(key) {
  return this.__data__.get(key);
}
var _stackGet = stackGet$1;
function stackHas$1(key) {
  return this.__data__.has(key);
}
var _stackHas = stackHas$1;
var ListCache$1 = _ListCache, Map$2 = _Map, MapCache$1 = _MapCache;
var LARGE_ARRAY_SIZE = 200;
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$1(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
var _stackSet = stackSet$1;
var ListCache = _ListCache, stackClear = _stackClear, stackDelete = _stackDelete, stackGet = _stackGet, stackHas = _stackHas, stackSet = _stackSet;
function Stack$2(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}
Stack$2.prototype.clear = stackClear;
Stack$2.prototype["delete"] = stackDelete;
Stack$2.prototype.get = stackGet;
Stack$2.prototype.has = stackHas;
Stack$2.prototype.set = stackSet;
var _Stack = Stack$2;
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
var _setCacheAdd = setCacheAdd$1;
function setCacheHas$1(value) {
  return this.__data__.has(value);
}
var _setCacheHas = setCacheHas$1;
var MapCache = _MapCache, setCacheAdd = _setCacheAdd, setCacheHas = _setCacheHas;
function SetCache$1(values) {
  var index = -1, length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;
var _SetCache = SetCache$1;
function arraySome$1(array, predicate) {
  var index = -1, length = array == null ? 0 : array.length;
  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}
var _arraySome = arraySome$1;
function cacheHas$1(cache, key) {
  return cache.has(key);
}
var _cacheHas = cacheHas$1;
var SetCache = _SetCache, arraySome = _arraySome, cacheHas = _cacheHas;
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  stack.set(array, other);
  stack.set(other, array);
  while (++index < arrLength) {
    var arrValue = array[index], othValue = other[index];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack["delete"](array);
  stack["delete"](other);
  return result;
}
var _equalArrays = equalArrays$2;
var root$6 = _root;
var Uint8Array$1 = root$6.Uint8Array;
var _Uint8Array = Uint8Array$1;
function mapToArray$1(map) {
  var index = -1, result = Array(map.size);
  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}
var _mapToArray = mapToArray$1;
function setToArray$1(set) {
  var index = -1, result = Array(set.size);
  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}
var _setToArray = setToArray$1;
var Symbol$1 = _Symbol, Uint8Array = _Uint8Array, eq$1 = eq_1, equalArrays$1 = _equalArrays, mapToArray = _mapToArray, setToArray = _setToArray;
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
var boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", symbolTag$1 = "[object Symbol]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]";
var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag$1(object, other, tag2, bitmask, customizer, equalFunc, stack) {
  switch (tag2) {
    case dataViewTag$2:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag$1:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;
    case boolTag$1:
    case dateTag$1:
    case numberTag$1:
      return eq$1(+object, +other);
    case errorTag$1:
      return object.name == other.name && object.message == other.message;
    case regexpTag$1:
    case stringTag$1:
      return object == other + "";
    case mapTag$2:
      var convert2 = mapToArray;
    case setTag$2:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert2 || (convert2 = setToArray);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;
      stack.set(object, other);
      var result = equalArrays$1(convert2(object), convert2(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object);
      return result;
    case symbolTag$1:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}
var _equalByTag = equalByTag$1;
var arrayPush = _arrayPush, isArray$5 = isArray_1;
function baseGetAllKeys$1(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$5(object) ? result : arrayPush(result, symbolsFunc(object));
}
var _baseGetAllKeys = baseGetAllKeys$1;
function arrayFilter$1(array, predicate) {
  var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
var _arrayFilter = arrayFilter$1;
function stubArray$1() {
  return [];
}
var stubArray_1 = stubArray$1;
var arrayFilter = _arrayFilter, stubArray = stubArray_1;
var objectProto$6 = Object.prototype;
var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbols$1 = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var _getSymbols = getSymbols$1;
function baseTimes$1(n2, iteratee) {
  var index = -1, result = Array(n2);
  while (++index < n2) {
    result[index] = iteratee(index);
  }
  return result;
}
var _baseTimes = baseTimes$1;
var isBufferExports = {};
var isBuffer$2 = {
  get exports() {
    return isBufferExports;
  },
  set exports(v2) {
    isBufferExports = v2;
  }
};
function stubFalse() {
  return false;
}
var stubFalse_1 = stubFalse;
(function(module, exports) {
  var root2 = _root, stubFalse2 = stubFalse_1;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer = moduleExports ? root2.Buffer : void 0;
  var nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0;
  var isBuffer2 = nativeIsBuffer || stubFalse2;
  module.exports = isBuffer2;
})(isBuffer$2, isBufferExports);
var MAX_SAFE_INTEGER$2 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$3(value, length) {
  var type2 = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$2 : length;
  return !!length && (type2 == "number" || type2 != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
}
var _isIndex = isIndex$3;
var MAX_SAFE_INTEGER$1 = 9007199254740991;
function isLength$3(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}
var isLength_1 = isLength$3;
var baseGetTag$1 = _baseGetTag, isLength$2 = isLength_1, isObjectLike$2 = isObjectLike_1;
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag$1 = "[object Map]", numberTag = "[object Number]", objectTag$2 = "[object Object]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", weakMapTag$1 = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag] = typedArrayTags[setTag$1] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag$1] = false;
function baseIsTypedArray$1(value) {
  return isObjectLike$2(value) && isLength$2(value.length) && !!typedArrayTags[baseGetTag$1(value)];
}
var _baseIsTypedArray = baseIsTypedArray$1;
function baseUnary$2(func) {
  return function(value) {
    return func(value);
  };
}
var _baseUnary = baseUnary$2;
var _nodeUtilExports = {};
var _nodeUtil = {
  get exports() {
    return _nodeUtilExports;
  },
  set exports(v2) {
    _nodeUtilExports = v2;
  }
};
(function(module, exports) {
  var freeGlobal2 = _freeGlobal;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil2 = function() {
    try {
      var types = freeModule && freeModule.require && freeModule.require("util").types;
      if (types) {
        return types;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e2) {
    }
  }();
  module.exports = nodeUtil2;
})(_nodeUtil, _nodeUtilExports);
var baseIsTypedArray = _baseIsTypedArray, baseUnary$1 = _baseUnary, nodeUtil = _nodeUtilExports;
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
var isTypedArray$2 = nodeIsTypedArray ? baseUnary$1(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray$2;
var baseTimes = _baseTimes, isArguments$1 = isArguments_1, isArray$4 = isArray_1, isBuffer$1 = isBufferExports, isIndex$2 = _isIndex, isTypedArray$1 = isTypedArray_1;
var objectProto$5 = Object.prototype;
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
function arrayLikeKeys$1(value, inherited) {
  var isArr = isArray$4(value), isArg = !isArr && isArguments$1(value), isBuff = !isArr && !isArg && isBuffer$1(value), isType = !isArr && !isArg && !isBuff && isTypedArray$1(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$4.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex$2(key, length)))) {
      result.push(key);
    }
  }
  return result;
}
var _arrayLikeKeys = arrayLikeKeys$1;
var objectProto$4 = Object.prototype;
function isPrototype$1(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$4;
  return value === proto;
}
var _isPrototype = isPrototype$1;
function overArg$1(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var _overArg = overArg$1;
var overArg = _overArg;
var nativeKeys$1 = overArg(Object.keys, Object);
var _nativeKeys = nativeKeys$1;
var isPrototype = _isPrototype, nativeKeys = _nativeKeys;
var objectProto$3 = Object.prototype;
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;
function baseKeys$1(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$3.call(object, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
var _baseKeys = baseKeys$1;
var isFunction = isFunction_1, isLength$1 = isLength_1;
function isArrayLike$4(value) {
  return value != null && isLength$1(value.length) && !isFunction(value);
}
var isArrayLike_1 = isArrayLike$4;
var arrayLikeKeys = _arrayLikeKeys, baseKeys = _baseKeys, isArrayLike$3 = isArrayLike_1;
function keys$3(object) {
  return isArrayLike$3(object) ? arrayLikeKeys(object) : baseKeys(object);
}
var keys_1 = keys$3;
var baseGetAllKeys = _baseGetAllKeys, getSymbols = _getSymbols, keys$2 = keys_1;
function getAllKeys$1(object) {
  return baseGetAllKeys(object, keys$2, getSymbols);
}
var _getAllKeys = getAllKeys$1;
var getAllKeys = _getAllKeys;
var COMPARE_PARTIAL_FLAG$3 = 1;
var objectProto$2 = Object.prototype;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$2.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key], othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack["delete"](object);
  stack["delete"](other);
  return result;
}
var _equalObjects = equalObjects$1;
var getNative$4 = _getNative, root$5 = _root;
var DataView$1 = getNative$4(root$5, "DataView");
var _DataView = DataView$1;
var getNative$3 = _getNative, root$4 = _root;
var Promise$2 = getNative$3(root$4, "Promise");
var _Promise = Promise$2;
var getNative$2 = _getNative, root$3 = _root;
var Set$2 = getNative$2(root$3, "Set");
var _Set = Set$2;
var getNative$1 = _getNative, root$2 = _root;
var WeakMap$2 = getNative$1(root$2, "WeakMap");
var _WeakMap = WeakMap$2;
var DataView = _DataView, Map$1 = _Map, Promise$1 = _Promise, Set$1 = _Set, WeakMap$1 = _WeakMap, baseGetTag = _baseGetTag, toSource = _toSource;
var mapTag = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1);
var getTag$1 = baseGetTag;
if (DataView && getTag$1(new DataView(new ArrayBuffer(1))) != dataViewTag || Map$1 && getTag$1(new Map$1()) != mapTag || Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag || Set$1 && getTag$1(new Set$1()) != setTag || WeakMap$1 && getTag$1(new WeakMap$1()) != weakMapTag) {
  getTag$1 = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag$1 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;
        case mapCtorString:
          return mapTag;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}
var _getTag = getTag$1;
var Stack$1 = _Stack, equalArrays = _equalArrays, equalByTag = _equalByTag, equalObjects = _equalObjects, getTag = _getTag, isArray$3 = isArray_1, isBuffer = isBufferExports, isTypedArray = isTypedArray_1;
var COMPARE_PARTIAL_FLAG$2 = 1;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$3(object), othIsArr = isArray$3(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$1());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$1.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty$1.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack$1());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$1());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
var _baseIsEqualDeep = baseIsEqualDeep$1;
var baseIsEqualDeep = _baseIsEqualDeep, isObjectLike$1 = isObjectLike_1;
function baseIsEqual$2(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike$1(value) && !isObjectLike$1(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$2, stack);
}
var _baseIsEqual = baseIsEqual$2;
var Stack = _Stack, baseIsEqual$1 = _baseIsEqual;
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch$1(object, source, matchData, customizer) {
  var index = matchData.length, length = index, noCustomizer = !customizer;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0], objValue = object[key], srcValue = data[1];
    if (noCustomizer && data[2]) {
      if (objValue === void 0 && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === void 0 ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}
var _baseIsMatch = baseIsMatch$1;
var isObject$3 = isObject_1;
function isStrictComparable$2(value) {
  return value === value && !isObject$3(value);
}
var _isStrictComparable = isStrictComparable$2;
var isStrictComparable$1 = _isStrictComparable, keys$1 = keys_1;
function getMatchData$1(object) {
  var result = keys$1(object), length = result.length;
  while (length--) {
    var key = result[length], value = object[key];
    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}
var _getMatchData = getMatchData$1;
function matchesStrictComparable$2(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
  };
}
var _matchesStrictComparable = matchesStrictComparable$2;
var baseIsMatch = _baseIsMatch, getMatchData = _getMatchData, matchesStrictComparable$1 = _matchesStrictComparable;
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}
var _baseMatches = baseMatches$1;
var baseGet$2 = _baseGet;
function get$1(object, path2, defaultValue) {
  var result = object == null ? void 0 : baseGet$2(object, path2);
  return result === void 0 ? defaultValue : result;
}
var get_1 = get$1;
function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}
var _baseHasIn = baseHasIn$1;
var castPath = _castPath, isArguments = isArguments_1, isArray$2 = isArray_1, isIndex$1 = _isIndex, isLength = isLength_1, toKey$2 = _toKey;
function hasPath$1(object, path2, hasFunc) {
  path2 = castPath(path2, object);
  var index = -1, length = path2.length, result = false;
  while (++index < length) {
    var key = toKey$2(path2[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex$1(key, length) && (isArray$2(object) || isArguments(object));
}
var _hasPath = hasPath$1;
var baseHasIn = _baseHasIn, hasPath = _hasPath;
function hasIn$1(object, path2) {
  return object != null && hasPath(object, path2, baseHasIn);
}
var hasIn_1 = hasIn$1;
var baseIsEqual = _baseIsEqual, get = get_1, hasIn = hasIn_1, isKey$1 = _isKey, isStrictComparable = _isStrictComparable, matchesStrictComparable = _matchesStrictComparable, toKey$1 = _toKey;
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty$1(path2, srcValue) {
  if (isKey$1(path2) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$1(path2), srcValue);
  }
  return function(object) {
    var objValue = get(object, path2);
    return objValue === void 0 && objValue === srcValue ? hasIn(object, path2) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
var _baseMatchesProperty = baseMatchesProperty$1;
function identity$4(value) {
  return value;
}
var identity_1 = identity$4;
function baseProperty$1(key) {
  return function(object) {
    return object == null ? void 0 : object[key];
  };
}
var _baseProperty = baseProperty$1;
var baseGet$1 = _baseGet;
function basePropertyDeep$1(path2) {
  return function(object) {
    return baseGet$1(object, path2);
  };
}
var _basePropertyDeep = basePropertyDeep$1;
var baseProperty = _baseProperty, basePropertyDeep = _basePropertyDeep, isKey = _isKey, toKey = _toKey;
function property$1(path2) {
  return isKey(path2) ? baseProperty(toKey(path2)) : basePropertyDeep(path2);
}
var property_1 = property$1;
var baseMatches = _baseMatches, baseMatchesProperty = _baseMatchesProperty, identity$3 = identity_1, isArray$1 = isArray_1, property = property_1;
function baseIteratee$1(value) {
  if (typeof value == "function") {
    return value;
  }
  if (value == null) {
    return identity$3;
  }
  if (typeof value == "object") {
    return isArray$1(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}
var _baseIteratee = baseIteratee$1;
function createBaseFor$1(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}
var _createBaseFor = createBaseFor$1;
var createBaseFor = _createBaseFor;
var baseFor$1 = createBaseFor();
var _baseFor = baseFor$1;
var baseFor = _baseFor, keys = keys_1;
function baseForOwn$1(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}
var _baseForOwn = baseForOwn$1;
var isArrayLike$2 = isArrayLike_1;
function createBaseEach$1(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike$2(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}
var _createBaseEach = createBaseEach$1;
var baseForOwn = _baseForOwn, createBaseEach = _createBaseEach;
var baseEach$1 = createBaseEach(baseForOwn);
var _baseEach = baseEach$1;
var baseEach = _baseEach, isArrayLike$1 = isArrayLike_1;
function baseMap$1(collection, iteratee) {
  var index = -1, result = isArrayLike$1(collection) ? Array(collection.length) : [];
  baseEach(collection, function(value, key, collection2) {
    result[++index] = iteratee(value, key, collection2);
  });
  return result;
}
var _baseMap = baseMap$1;
function baseSortBy$1(array, comparer) {
  var length = array.length;
  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}
var _baseSortBy = baseSortBy$1;
var isSymbol$1 = isSymbol_1;
function compareAscending$1(value, other) {
  if (value !== other) {
    var valIsDefined = value !== void 0, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol$1(value);
    var othIsDefined = other !== void 0, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol$1(other);
    if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
      return 1;
    }
    if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}
var _compareAscending = compareAscending$1;
var compareAscending = _compareAscending;
function compareMultiple$1(object, other, orders) {
  var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == "desc" ? -1 : 1);
    }
  }
  return object.index - other.index;
}
var _compareMultiple = compareMultiple$1;
var arrayMap = _arrayMap, baseGet = _baseGet, baseIteratee = _baseIteratee, baseMap = _baseMap, baseSortBy = _baseSortBy, baseUnary = _baseUnary, compareMultiple = _compareMultiple, identity$2 = identity_1, isArray = isArray_1;
function baseOrderBy$1(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
      }
      return iteratee;
    });
  } else {
    iteratees = [identity$2];
  }
  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
  var result = baseMap(collection, function(value, key, collection2) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { "criteria": criteria, "index": ++index, "value": value };
  });
  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}
var _baseOrderBy = baseOrderBy$1;
function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
var _apply = apply$1;
var apply = _apply;
var nativeMax$2 = Math.max;
function overRest$1(func, start, transform) {
  start = nativeMax$2(start === void 0 ? func.length - 1 : start, 0);
  return function() {
    var args = arguments, index = -1, length = nativeMax$2(args.length - start, 0), array = Array(length);
    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}
var _overRest = overRest$1;
function constant$1(value) {
  return function() {
    return value;
  };
}
var constant_1 = constant$1;
var getNative = _getNative;
var defineProperty$1 = function() {
  try {
    var func = getNative(Object, "defineProperty");
    func({}, "", {});
    return func;
  } catch (e2) {
  }
}();
var _defineProperty$1 = defineProperty$1;
var constant = constant_1, defineProperty = _defineProperty$1, identity$1 = identity_1;
var baseSetToString$1 = !defineProperty ? identity$1 : function(func, string) {
  return defineProperty(func, "toString", {
    "configurable": true,
    "enumerable": false,
    "value": constant(string),
    "writable": true
  });
};
var _baseSetToString = baseSetToString$1;
var HOT_COUNT = 800, HOT_SPAN = 16;
var nativeNow = Date.now;
function shortOut$1(func) {
  var count = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(void 0, arguments);
  };
}
var _shortOut = shortOut$1;
var baseSetToString = _baseSetToString, shortOut = _shortOut;
var setToString$1 = shortOut(baseSetToString);
var _setToString = setToString$1;
var identity = identity_1, overRest = _overRest, setToString = _setToString;
function baseRest$1(func, start) {
  return setToString(overRest(func, start, identity), func + "");
}
var _baseRest = baseRest$1;
var eq = eq_1, isArrayLike = isArrayLike_1, isIndex = _isIndex, isObject$2 = isObject_1;
function isIterateeCall$1(value, index, object) {
  if (!isObject$2(object)) {
    return false;
  }
  var type2 = typeof index;
  if (type2 == "number" ? isArrayLike(object) && isIndex(index, object.length) : type2 == "string" && index in object) {
    return eq(object[index], value);
  }
  return false;
}
var _isIterateeCall = isIterateeCall$1;
var baseFlatten = _baseFlatten, baseOrderBy = _baseOrderBy, baseRest = _baseRest, isIterateeCall = _isIterateeCall;
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});
var sortBy_1 = sortBy;
function renderMultiLineString(multiLineString) {
  if (!multiLineString || typeof multiLineString !== "string" || !multiLineString.includes("\n") || !multiLineString.includes("\\n")) {
    return multiLineString;
  }
  return /* @__PURE__ */ jsx(Fragment, { children: multiLineString.split("\n").map((i2, key) => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      i2,
      /* @__PURE__ */ jsx("br", {})
    ] });
  }) });
}
function renderRenovation(i2, renovation, prevRenovation = null) {
  let prevTime = null;
  if (prevRenovation) {
    prevTime = `${prevRenovation.year_start}${prevRenovation.year_end ? ` - ${prevRenovation.year_end}` : ""}`;
  }
  const currentTime = `${renovation.year_start}${renovation.year_end ? ` - ${renovation.year_end}` : ""}`;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "flex flex-col py-2 mb-3 lg:mb-0 lg:flex-row text-[17px]",
      children: [
        /* @__PURE__ */ jsx("span", { className: "pr-4 mb-3 text-blue-500 break-words lg:mb-0 lg:w-2/5", children: prevTime !== currentTime && currentTime }),
        /* @__PURE__ */ jsx("span", { className: "w-3/5 text-gray-800", children: renderMultiLineString(renovation.description) })
      ]
    },
    i2
  );
}
function ListingRenovationInfo({ pastRenovations, upcomingRenovations }) {
  const { t: t2 } = useTranslation();
  if (!pastRenovations.length && !upcomingRenovations.length)
    return null;
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col divide-y divide-gray-500 lg:flex-row lg:space-x-7 lg:divide-y-0", children: [
    pastRenovations && pastRenovations.length > 0 && /* @__PURE__ */ jsx(ListingInfo, { headline: t2("past_renovations"), className: "lg:w-1/2", children: sortBy_1(pastRenovations, "year_start").map(
      (renovation, i2) => renderRenovation(
        i2,
        renovation,
        i2 > 0 ? sortBy_1(pastRenovations, "year_start")[i2 - 1] : null
      )
    ) }),
    upcomingRenovations && upcomingRenovations.length > 0 && /* @__PURE__ */ jsx(ListingInfo, { headline: t2("upcoming_renovations"), className: "lg:w-1/2", children: sortBy_1(upcomingRenovations, "year_start").map(
      (renovation, i2) => renderRenovation(
        i2,
        renovation,
        i2 > 0 ? sortBy_1(upcomingRenovations, "year_start")[i2 - 1] : null
      )
    ) })
  ] });
}
class LuxonError extends Error {
}
class InvalidDateTimeError extends LuxonError {
  constructor(reason) {
    super(`Invalid DateTime: ${reason.toMessage()}`);
  }
}
class InvalidIntervalError extends LuxonError {
  constructor(reason) {
    super(`Invalid Interval: ${reason.toMessage()}`);
  }
}
class InvalidDurationError extends LuxonError {
  constructor(reason) {
    super(`Invalid Duration: ${reason.toMessage()}`);
  }
}
class ConflictingSpecificationError extends LuxonError {
}
class InvalidUnitError extends LuxonError {
  constructor(unit) {
    super(`Invalid unit ${unit}`);
  }
}
class InvalidArgumentError extends LuxonError {
}
class ZoneIsAbstractError extends LuxonError {
  constructor() {
    super("Zone is an abstract class");
  }
}
const n = "numeric", s = "short", l = "long";
const DATE_SHORT = {
  year: n,
  month: n,
  day: n
};
const DATE_MED = {
  year: n,
  month: s,
  day: n
};
const DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s
};
const DATE_FULL = {
  year: n,
  month: l,
  day: n
};
const DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l
};
const TIME_SIMPLE = {
  hour: n,
  minute: n
};
const TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n
};
const TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
const TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
const TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hourCycle: "h23"
};
const TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23"
};
const TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: s
};
const TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: l
};
const DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n
};
const DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n
};
const DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n
};
const DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n
};
const DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n
};
const DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s
};
const DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
const DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l
};
const DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
class Zone {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new ZoneIsAbstractError();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new ZoneIsAbstractError();
  }
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new ZoneIsAbstractError();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new ZoneIsAbstractError();
  }
}
let singleton$1 = null;
class SystemZone extends Zone {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    if (singleton$1 === null) {
      singleton$1 = new SystemZone();
    }
    return singleton$1;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale);
  }
  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /** @override **/
  offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }
  /** @override **/
  equals(otherZone) {
    return otherZone.type === "system";
  }
  /** @override **/
  get isValid() {
    return true;
  }
}
let dtfCache = {};
function makeDTF(zone) {
  if (!dtfCache[zone]) {
    dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      era: "short"
    });
  }
  return dtfCache[zone];
}
const typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function hackyOffset(dtf, date2) {
  const formatted = dtf.format(date2).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
  return [fYear, fMonth, fDay, fadOrBc, fHour, fMinute, fSecond];
}
function partsOffset(dtf, date2) {
  const formatted = dtf.formatToParts(date2);
  const filled = [];
  for (let i2 = 0; i2 < formatted.length; i2++) {
    const { type: type2, value } = formatted[i2];
    const pos = typeToPos[type2];
    if (type2 === "era") {
      filled[pos] = value;
    } else if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }
  return filled;
}
let ianaZoneCache = {};
class IANAZone extends Zone {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(name) {
    if (!ianaZoneCache[name]) {
      ianaZoneCache[name] = new IANAZone(name);
    }
    return ianaZoneCache[name];
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    ianaZoneCache = {};
    dtfCache = {};
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated This method returns false for some valid IANA names. Use isValidZone instead.
   * @return {boolean}
   */
  static isValidSpecifier(s2) {
    return this.isValidZone(s2);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(zone) {
    if (!zone) {
      return false;
    }
    try {
      new Intl.DateTimeFormat("en-US", { timeZone: zone }).format();
      return true;
    } catch (e2) {
      return false;
    }
  }
  constructor(name) {
    super();
    this.zoneName = name;
    this.valid = IANAZone.isValidZone(name);
  }
  /** @override **/
  get type() {
    return "iana";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale, this.name);
  }
  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /** @override **/
  offset(ts) {
    const date2 = new Date(ts);
    if (isNaN(date2))
      return NaN;
    const dtf = makeDTF(this.name);
    let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts ? partsOffset(dtf, date2) : hackyOffset(dtf, date2);
    if (adOrBc === "BC") {
      year = -Math.abs(year) + 1;
    }
    const adjustedHour = hour === 24 ? 0 : hour;
    const asUTC = objToLocalTS({
      year,
      month,
      day,
      hour: adjustedHour,
      minute,
      second,
      millisecond: 0
    });
    let asTS = +date2;
    const over = asTS % 1e3;
    asTS -= over >= 0 ? over : 1e3 + over;
    return (asUTC - asTS) / (60 * 1e3);
  }
  /** @override **/
  equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }
  /** @override **/
  get isValid() {
    return this.valid;
  }
}
let intlLFCache = {};
function getCachedLF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlLFCache[key];
  if (!dtf) {
    dtf = new Intl.ListFormat(locString, opts);
    intlLFCache[key] = dtf;
  }
  return dtf;
}
let intlDTCache = {};
function getCachedDTF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlDTCache[key];
  if (!dtf) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache[key] = dtf;
  }
  return dtf;
}
let intlNumCache = {};
function getCachedINF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let inf = intlNumCache[key];
  if (!inf) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache[key] = inf;
  }
  return inf;
}
let intlRelCache = {};
function getCachedRTF(locString, opts = {}) {
  const { base, ...cacheKeyOpts } = opts;
  const key = JSON.stringify([locString, cacheKeyOpts]);
  let inf = intlRelCache[key];
  if (!inf) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache[key] = inf;
  }
  return inf;
}
let sysLocaleCache = null;
function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else {
    sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
    return sysLocaleCache;
  }
}
function parseLocaleString(localeStr) {
  const xIndex = localeStr.indexOf("-x-");
  if (xIndex !== -1) {
    localeStr = localeStr.substring(0, xIndex);
  }
  const uIndex = localeStr.indexOf("-u-");
  if (uIndex === -1) {
    return [localeStr];
  } else {
    let options;
    let selectedStr;
    try {
      options = getCachedDTF(localeStr).resolvedOptions();
      selectedStr = localeStr;
    } catch (e2) {
      const smaller = localeStr.substring(0, uIndex);
      options = getCachedDTF(smaller).resolvedOptions();
      selectedStr = smaller;
    }
    const { numberingSystem, calendar } = options;
    return [selectedStr, numberingSystem, calendar];
  }
}
function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (outputCalendar || numberingSystem) {
    if (!localeStr.includes("-u-")) {
      localeStr += "-u";
    }
    if (outputCalendar) {
      localeStr += `-ca-${outputCalendar}`;
    }
    if (numberingSystem) {
      localeStr += `-nu-${numberingSystem}`;
    }
    return localeStr;
  } else {
    return localeStr;
  }
}
function mapMonths(f2) {
  const ms = [];
  for (let i2 = 1; i2 <= 12; i2++) {
    const dt = DateTime.utc(2016, i2, 1);
    ms.push(f2(dt));
  }
  return ms;
}
function mapWeekdays(f2) {
  const ms = [];
  for (let i2 = 1; i2 <= 7; i2++) {
    const dt = DateTime.utc(2016, 11, 13 + i2);
    ms.push(f2(dt));
  }
  return ms;
}
function listStuff(loc, length, defaultOK, englishFn, intlFn) {
  const mode = loc.listingMode(defaultOK);
  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}
function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
  }
}
class PolyNumberFormatter {
  constructor(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;
    const { padTo, floor: floor2, ...otherOpts } = opts;
    if (!forceSimple || Object.keys(otherOpts).length > 0) {
      const intlOpts = { useGrouping: false, ...opts };
      if (opts.padTo > 0)
        intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }
  format(i2) {
    if (this.inf) {
      const fixed = this.floor ? Math.floor(i2) : i2;
      return this.inf.format(fixed);
    } else {
      const fixed = this.floor ? Math.floor(i2) : roundTo(i2, 3);
      return padStart(fixed, this.padTo);
    }
  }
}
class PolyDateFormatter {
  constructor(dt, intl, opts) {
    this.opts = opts;
    let z2 = void 0;
    if (dt.zone.isUniversal) {
      const gmtOffset = -1 * (dt.offset / 60);
      const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
      if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
        z2 = offsetZ;
        this.dt = dt;
      } else {
        z2 = "UTC";
        if (opts.timeZoneName) {
          this.dt = dt;
        } else {
          this.dt = dt.offset === 0 ? dt : DateTime.fromMillis(dt.ts + dt.offset * 60 * 1e3);
        }
      }
    } else if (dt.zone.type === "system") {
      this.dt = dt;
    } else {
      this.dt = dt;
      z2 = dt.zone.name;
    }
    const intlOpts = { ...this.opts };
    intlOpts.timeZone = intlOpts.timeZone || z2;
    this.dtf = getCachedDTF(intl, intlOpts);
  }
  format() {
    return this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    return this.dtf.formatToParts(this.dt.toJSDate());
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class PolyRelFormatter {
  constructor(intl, isEnglish, opts) {
    this.opts = { style: "long", ...opts };
    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }
  format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  }
  formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  }
}
class Locale {
  static fromOpts(opts) {
    return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
  }
  static create(locale, numberingSystem, outputCalendar, defaultToEN = false) {
    const specifiedLocale = locale || Settings.defaultLocale;
    const localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
    const numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
    const outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    return new Locale(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
  }
  static resetCache() {
    sysLocaleCache = null;
    intlDTCache = {};
    intlNumCache = {};
    intlRelCache = {};
  }
  static fromObject({ locale, numberingSystem, outputCalendar } = {}) {
    return Locale.create(locale, numberingSystem, outputCalendar);
  }
  constructor(locale, numbering, outputCalendar, specifiedLocale) {
    const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = parseLocaleString(locale);
    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
    this.weekdaysCache = { format: {}, standalone: {} };
    this.monthsCache = { format: {}, standalone: {} };
    this.meridiemCache = null;
    this.eraCache = {};
    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }
  get fastNumbers() {
    if (this.fastNumbersCached == null) {
      this.fastNumbersCached = supportsFastNumbers(this);
    }
    return this.fastNumbersCached;
  }
  listingMode() {
    const isActuallyEn = this.isEnglish();
    const hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return isActuallyEn && hasNoWeirdness ? "en" : "intl";
  }
  clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return Locale.create(
        alts.locale || this.specifiedLocale,
        alts.numberingSystem || this.numberingSystem,
        alts.outputCalendar || this.outputCalendar,
        alts.defaultToEN || false
      );
    }
  }
  redefaultToEN(alts = {}) {
    return this.clone({ ...alts, defaultToEN: true });
  }
  redefaultToSystem(alts = {}) {
    return this.clone({ ...alts, defaultToEN: false });
  }
  months(length, format = false, defaultOK = true) {
    return listStuff(this, length, defaultOK, months, () => {
      const intl = format ? { month: length, day: "numeric" } : { month: length }, formatStr = format ? "format" : "standalone";
      if (!this.monthsCache[formatStr][length]) {
        this.monthsCache[formatStr][length] = mapMonths((dt) => this.extract(dt, intl, "month"));
      }
      return this.monthsCache[formatStr][length];
    });
  }
  weekdays(length, format = false, defaultOK = true) {
    return listStuff(this, length, defaultOK, weekdays, () => {
      const intl = format ? { weekday: length, year: "numeric", month: "long", day: "numeric" } : { weekday: length }, formatStr = format ? "format" : "standalone";
      if (!this.weekdaysCache[formatStr][length]) {
        this.weekdaysCache[formatStr][length] = mapWeekdays(
          (dt) => this.extract(dt, intl, "weekday")
        );
      }
      return this.weekdaysCache[formatStr][length];
    });
  }
  meridiems(defaultOK = true) {
    return listStuff(
      this,
      void 0,
      defaultOK,
      () => meridiems,
      () => {
        if (!this.meridiemCache) {
          const intl = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(
            (dt) => this.extract(dt, intl, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(length, defaultOK = true) {
    return listStuff(this, length, defaultOK, eras, () => {
      const intl = { era: length };
      if (!this.eraCache[length]) {
        this.eraCache[length] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map(
          (dt) => this.extract(dt, intl, "era")
        );
      }
      return this.eraCache[length];
    });
  }
  extract(dt, intlOpts, field) {
    const df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find((m2) => m2.type.toLowerCase() === field);
    return matching ? matching.value : null;
  }
  numberFormatter(opts = {}) {
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  }
  dtFormatter(dt, intlOpts = {}) {
    return new PolyDateFormatter(dt, this.intl, intlOpts);
  }
  relFormatter(opts = {}) {
    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  }
  listFormatter(opts = {}) {
    return getCachedLF(this.intl, opts);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  equals(other) {
    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
  }
}
let singleton = null;
class FixedOffsetZone extends Zone {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    if (singleton === null) {
      singleton = new FixedOffsetZone(0);
    }
    return singleton;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(offset2) {
    return offset2 === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset2);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(s2) {
    if (s2) {
      const r2 = s2.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r2) {
        return new FixedOffsetZone(signedOffset(r2[1], r2[2]));
      }
    }
    return null;
  }
  constructor(offset2) {
    super();
    this.fixed = offset2;
  }
  /** @override **/
  get type() {
    return "fixed";
  }
  /** @override **/
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${formatOffset(this.fixed, "narrow")}`;
  }
  get ianaName() {
    if (this.fixed === 0) {
      return "Etc/UTC";
    } else {
      return `Etc/GMT${formatOffset(-this.fixed, "narrow")}`;
    }
  }
  /** @override **/
  offsetName() {
    return this.name;
  }
  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.fixed, format);
  }
  /** @override **/
  get isUniversal() {
    return true;
  }
  /** @override **/
  offset() {
    return this.fixed;
  }
  /** @override **/
  equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }
  /** @override **/
  get isValid() {
    return true;
  }
}
class InvalidZone extends Zone {
  constructor(zoneName) {
    super();
    this.zoneName = zoneName;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return false;
  }
  /** @override **/
  get isValid() {
    return false;
  }
}
function normalizeZone(input, defaultZone2) {
  if (isUndefined(input) || input === null) {
    return defaultZone2;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString(input)) {
    const lowered = input.toLowerCase();
    if (lowered === "default")
      return defaultZone2;
    else if (lowered === "local" || lowered === "system")
      return SystemZone.instance;
    else if (lowered === "utc" || lowered === "gmt")
      return FixedOffsetZone.utcInstance;
    else
      return FixedOffsetZone.parseSpecifier(lowered) || IANAZone.create(input);
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if (typeof input === "object" && input.offset && typeof input.offset === "number") {
    return input;
  } else {
    return new InvalidZone(input);
  }
}
let now$3 = () => Date.now(), defaultZone = "system", defaultLocale = null, defaultNumberingSystem = null, defaultOutputCalendar = null, twoDigitCutoffYear = 60, throwOnInvalid;
class Settings {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return now$3;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(n2) {
    now$3 = n2;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(zone) {
    defaultZone = zone;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return normalizeZone(defaultZone, SystemZone.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return defaultLocale;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(locale) {
    defaultLocale = locale;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return defaultNumberingSystem;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(numberingSystem) {
    defaultNumberingSystem = numberingSystem;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return defaultOutputCalendar;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(outputCalendar) {
    defaultOutputCalendar = outputCalendar;
  }
  /**
   * Get the cutoff year after which a string encoding a year as two digits is interpreted to occur in the current century.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return twoDigitCutoffYear;
  }
  /**
   * Set the cutoff year after which a string encoding a year as two digits is interpreted to occur in the current century.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // cut-off year is 0, so all 'yy' are interpretted as current century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 1949; '50' -> 2050
   * @example Settings.twoDigitCutoffYear = 1950 // interpretted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpretted as 50
   */
  static set twoDigitCutoffYear(cutoffYear) {
    twoDigitCutoffYear = cutoffYear % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return throwOnInvalid;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t2) {
    throwOnInvalid = t2;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    Locale.resetCache();
    IANAZone.resetCache();
  }
}
function isUndefined(o3) {
  return typeof o3 === "undefined";
}
function isNumber(o3) {
  return typeof o3 === "number";
}
function isInteger(o3) {
  return typeof o3 === "number" && o3 % 1 === 0;
}
function isString(o3) {
  return typeof o3 === "string";
}
function isDate(o3) {
  return Object.prototype.toString.call(o3) === "[object Date]";
}
function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e2) {
    return false;
  }
}
function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [thing];
}
function bestBy(arr2, by, compare) {
  if (arr2.length === 0) {
    return void 0;
  }
  return arr2.reduce((best, next) => {
    const pair = [by(next), next];
    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}
function pick(obj, keys2) {
  return keys2.reduce((a2, k2) => {
    a2[k2] = obj[k2];
    return a2;
  }, {});
}
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
}
function floorMod(x2, n2) {
  return x2 - n2 * Math.floor(x2 / n2);
}
function padStart(input, n2 = 2) {
  const isNeg = input < 0;
  let padded;
  if (isNeg) {
    padded = "-" + ("" + -input).padStart(n2, "0");
  } else {
    padded = ("" + input).padStart(n2, "0");
  }
  return padded;
}
function parseInteger(string) {
  if (isUndefined(string) || string === null || string === "") {
    return void 0;
  } else {
    return parseInt(string, 10);
  }
}
function parseFloating(string) {
  if (isUndefined(string) || string === null || string === "") {
    return void 0;
  } else {
    return parseFloat(string);
  }
}
function parseMillis(fraction) {
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return void 0;
  } else {
    const f2 = parseFloat("0." + fraction) * 1e3;
    return Math.floor(f2);
  }
}
function roundTo(number, digits, towardZero = false) {
  const factor = 10 ** digits, rounder = towardZero ? Math.trunc : Math.round;
  return rounder(number * factor) / factor;
}
function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
function daysInMonth(year, month) {
  const modMonth = floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
  }
}
function objToLocalTS(obj) {
  let d2 = Date.UTC(
    obj.year,
    obj.month - 1,
    obj.day,
    obj.hour,
    obj.minute,
    obj.second,
    obj.millisecond
  );
  if (obj.year < 100 && obj.year >= 0) {
    d2 = new Date(d2);
    d2.setUTCFullYear(d2.getUTCFullYear() - 1900);
  }
  return +d2;
}
function weeksInWeekYear(weekYear) {
  const p1 = (weekYear + Math.floor(weekYear / 4) - Math.floor(weekYear / 100) + Math.floor(weekYear / 400)) % 7, last = weekYear - 1, p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
  return p1 === 4 || p2 === 3 ? 53 : 52;
}
function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else
    return year > Settings.twoDigitCutoffYear ? 1900 + year : 2e3 + year;
}
function parseZoneInfo(ts, offsetFormat, locale, timeZone = null) {
  const date2 = new Date(ts), intlOpts = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }
  const modified = { timeZoneName: offsetFormat, ...intlOpts };
  const parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date2).find((m2) => m2.type.toLowerCase() === "timezonename");
  return parsed ? parsed.value : null;
}
function signedOffset(offHourStr, offMinuteStr) {
  let offHour = parseInt(offHourStr, 10);
  if (Number.isNaN(offHour)) {
    offHour = 0;
  }
  const offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}
function asNumber(value) {
  const numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue))
    throw new InvalidArgumentError(`Invalid unit value ${value}`);
  return numericValue;
}
function normalizeObject(obj, normalizer) {
  const normalized = {};
  for (const u2 in obj) {
    if (hasOwnProperty(obj, u2)) {
      const v2 = obj[u2];
      if (v2 === void 0 || v2 === null)
        continue;
      normalized[normalizer(u2)] = asNumber(v2);
    }
  }
  return normalized;
}
function formatOffset(offset2, format) {
  const hours = Math.trunc(Math.abs(offset2 / 60)), minutes = Math.trunc(Math.abs(offset2 % 60)), sign2 = offset2 >= 0 ? "+" : "-";
  switch (format) {
    case "short":
      return `${sign2}${padStart(hours, 2)}:${padStart(minutes, 2)}`;
    case "narrow":
      return `${sign2}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
    case "techie":
      return `${sign2}${padStart(hours, 2)}${padStart(minutes, 2)}`;
    default:
      throw new RangeError(`Value format ${format} is out of range for property format`);
  }
}
function timeObject(obj) {
  return pick(obj, ["hour", "minute", "second", "millisecond"]);
}
const monthsLong = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
const monthsShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
const monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function months(length) {
  switch (length) {
    case "narrow":
      return [...monthsNarrow];
    case "short":
      return [...monthsShort];
    case "long":
      return [...monthsLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const weekdaysLong = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];
const weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];
function weekdays(length) {
  switch (length) {
    case "narrow":
      return [...weekdaysNarrow];
    case "short":
      return [...weekdaysShort];
    case "long":
      return [...weekdaysLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const meridiems = ["AM", "PM"];
const erasLong = ["Before Christ", "Anno Domini"];
const erasShort = ["BC", "AD"];
const erasNarrow = ["B", "A"];
function eras(length) {
  switch (length) {
    case "narrow":
      return [...erasNarrow];
    case "short":
      return [...erasShort];
    case "long":
      return [...erasLong];
    default:
      return null;
  }
}
function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}
function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}
function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}
function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}
function formatRelativeTime(unit, count, numeric = "always", narrow = false) {
  const units = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  };
  const lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;
  if (numeric === "auto" && lastable) {
    const isDay = unit === "days";
    switch (count) {
      case 1:
        return isDay ? "tomorrow" : `next ${units[unit][0]}`;
      case -1:
        return isDay ? "yesterday" : `last ${units[unit][0]}`;
      case 0:
        return isDay ? "today" : `this ${units[unit][0]}`;
    }
  }
  const isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
  return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}
function stringifyTokens(splits, tokenToString) {
  let s2 = "";
  for (const token of splits) {
    if (token.literal) {
      s2 += token.val;
    } else {
      s2 += tokenToString(token.val);
    }
  }
  return s2;
}
const macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS
};
class Formatter {
  static create(locale, opts = {}) {
    return new Formatter(locale, opts);
  }
  static parseFormat(fmt) {
    let current = null, currentFull = "", bracketed = false;
    const splits = [];
    for (let i2 = 0; i2 < fmt.length; i2++) {
      const c2 = fmt.charAt(i2);
      if (c2 === "'") {
        if (currentFull.length > 0) {
          splits.push({ literal: bracketed, val: currentFull });
        }
        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c2;
      } else if (c2 === current) {
        currentFull += c2;
      } else {
        if (currentFull.length > 0) {
          splits.push({ literal: false, val: currentFull });
        }
        currentFull = c2;
        current = c2;
      }
    }
    if (currentFull.length > 0) {
      splits.push({ literal: bracketed, val: currentFull });
    }
    return splits;
  }
  static macroTokenToFormatOpts(token) {
    return macroTokenToFormatOpts[token];
  }
  constructor(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }
  formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }
    const df = this.systemLoc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.format();
  }
  formatDateTime(dt, opts = {}) {
    const df = this.loc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.format();
  }
  formatDateTimeParts(dt, opts = {}) {
    const df = this.loc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.formatToParts();
  }
  formatInterval(interval, opts = {}) {
    const df = this.loc.dtFormatter(interval.start, { ...this.opts, ...opts });
    return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
  }
  resolvedOptions(dt, opts = {}) {
    const df = this.loc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.resolvedOptions();
  }
  num(n2, p2 = 0) {
    if (this.opts.forceSimple) {
      return padStart(n2, p2);
    }
    const opts = { ...this.opts };
    if (p2 > 0) {
      opts.padTo = p2;
    }
    return this.loc.numberFormatter(opts).format(n2);
  }
  formatDateTimeFromString(dt, fmt) {
    const knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = (opts, extract) => this.loc.extract(dt, opts, extract), formatOffset2 = (opts) => {
      if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
        return "Z";
      }
      return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
    }, meridiem = () => knownEnglish ? meridiemForDateTime(dt) : string({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), month = (length, standalone) => knownEnglish ? monthForDateTime(dt, length) : string(standalone ? { month: length } : { month: length, day: "numeric" }, "month"), weekday = (length, standalone) => knownEnglish ? weekdayForDateTime(dt, length) : string(
      standalone ? { weekday: length } : { weekday: length, month: "long", day: "numeric" },
      "weekday"
    ), maybeMacro = (token) => {
      const formatOpts = Formatter.macroTokenToFormatOpts(token);
      if (formatOpts) {
        return this.formatWithSystemDefault(dt, formatOpts);
      } else {
        return token;
      }
    }, era = (length) => knownEnglish ? eraForDateTime(dt, length) : string({ era: length }, "era"), tokenToString = (token) => {
      switch (token) {
        case "S":
          return this.num(dt.millisecond);
        case "u":
        case "SSS":
          return this.num(dt.millisecond, 3);
        case "s":
          return this.num(dt.second);
        case "ss":
          return this.num(dt.second, 2);
        case "uu":
          return this.num(Math.floor(dt.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(dt.millisecond / 100));
        case "m":
          return this.num(dt.minute);
        case "mm":
          return this.num(dt.minute, 2);
        case "h":
          return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
        case "hh":
          return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
        case "H":
          return this.num(dt.hour);
        case "HH":
          return this.num(dt.hour, 2);
        case "Z":
          return formatOffset2({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return formatOffset2({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return formatOffset2({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return dt.zone.offsetName(dt.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return dt.zone.offsetName(dt.ts, { format: "long", locale: this.loc.locale });
        case "z":
          return dt.zoneName;
        case "a":
          return meridiem();
        case "d":
          return useDateTimeFormatter ? string({ day: "numeric" }, "day") : this.num(dt.day);
        case "dd":
          return useDateTimeFormatter ? string({ day: "2-digit" }, "day") : this.num(dt.day, 2);
        case "c":
          return this.num(dt.weekday);
        case "ccc":
          return weekday("short", true);
        case "cccc":
          return weekday("long", true);
        case "ccccc":
          return weekday("narrow", true);
        case "E":
          return this.num(dt.weekday);
        case "EEE":
          return weekday("short", false);
        case "EEEE":
          return weekday("long", false);
        case "EEEEE":
          return weekday("narrow", false);
        case "L":
          return useDateTimeFormatter ? string({ month: "numeric", day: "numeric" }, "month") : this.num(dt.month);
        case "LL":
          return useDateTimeFormatter ? string({ month: "2-digit", day: "numeric" }, "month") : this.num(dt.month, 2);
        case "LLL":
          return month("short", true);
        case "LLLL":
          return month("long", true);
        case "LLLLL":
          return month("narrow", true);
        case "M":
          return useDateTimeFormatter ? string({ month: "numeric" }, "month") : this.num(dt.month);
        case "MM":
          return useDateTimeFormatter ? string({ month: "2-digit" }, "month") : this.num(dt.month, 2);
        case "MMM":
          return month("short", false);
        case "MMMM":
          return month("long", false);
        case "MMMMM":
          return month("narrow", false);
        case "y":
          return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year);
        case "yy":
          return useDateTimeFormatter ? string({ year: "2-digit" }, "year") : this.num(dt.year.toString().slice(-2), 2);
        case "yyyy":
          return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year, 4);
        case "yyyyyy":
          return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year, 6);
        case "G":
          return era("short");
        case "GG":
          return era("long");
        case "GGGGG":
          return era("narrow");
        case "kk":
          return this.num(dt.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(dt.weekYear, 4);
        case "W":
          return this.num(dt.weekNumber);
        case "WW":
          return this.num(dt.weekNumber, 2);
        case "o":
          return this.num(dt.ordinal);
        case "ooo":
          return this.num(dt.ordinal, 3);
        case "q":
          return this.num(dt.quarter);
        case "qq":
          return this.num(dt.quarter, 2);
        case "X":
          return this.num(Math.floor(dt.ts / 1e3));
        case "x":
          return this.num(dt.ts);
        default:
          return maybeMacro(token);
      }
    };
    return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
  }
  formatDurationFromString(dur, fmt) {
    const tokenToField = (token) => {
      switch (token[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, tokenToString = (lildur) => (token) => {
      const mapped = tokenToField(token);
      if (mapped) {
        return this.num(lildur.get(mapped), token.length);
      } else {
        return token;
      }
    }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(
      (found, { literal, val }) => literal ? found : found.concat(val),
      []
    ), collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t2) => t2));
    return stringifyTokens(tokens, tokenToString(collapsed));
  }
}
class Invalid {
  constructor(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }
  toMessage() {
    if (this.explanation) {
      return `${this.reason}: ${this.explanation}`;
    } else {
      return this.reason;
    }
  }
}
const ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes(...regexes) {
  const full = regexes.reduce((f2, r2) => f2 + r2.source, "");
  return RegExp(`^${full}$`);
}
function combineExtractors(...extractors) {
  return (m2) => extractors.reduce(
    ([mergedVals, mergedZone, cursor], ex) => {
      const [val, zone, next] = ex(m2, cursor);
      return [{ ...mergedVals, ...val }, zone || mergedZone, next];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function parse(s2, ...patterns) {
  if (s2 == null) {
    return [null, null];
  }
  for (const [regex, extractor] of patterns) {
    const m2 = regex.exec(s2);
    if (m2) {
      return extractor(m2);
    }
  }
  return [null, null];
}
function simpleParse(...keys2) {
  return (match2, cursor) => {
    const ret = {};
    let i2;
    for (i2 = 0; i2 < keys2.length; i2++) {
      ret[keys2[i2]] = parseInteger(match2[cursor + i2]);
    }
    return [ret, null, cursor + i2];
  };
}
const offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
const isoExtendedZone = `(?:${offsetRegex.source}?(?:\\[(${ianaRegex.source})\\])?)?`;
const isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
const isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${isoExtendedZone}`);
const isoTimeExtensionRegex = RegExp(`(?:T${isoTimeRegex.source})?`);
const isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
const isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
const isoOrdinalRegex = /(\d{4})-?(\d{3})/;
const extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
const extractISOOrdinalData = simpleParse("year", "ordinal");
const sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/;
const sqlTimeRegex = RegExp(
  `${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`
);
const sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);
function int(match2, pos, fallback) {
  const m2 = match2[pos];
  return isUndefined(m2) ? fallback : parseInteger(m2);
}
function extractISOYmd(match2, cursor) {
  const item = {
    year: int(match2, cursor),
    month: int(match2, cursor + 1, 1),
    day: int(match2, cursor + 2, 1)
  };
  return [item, null, cursor + 3];
}
function extractISOTime(match2, cursor) {
  const item = {
    hours: int(match2, cursor, 0),
    minutes: int(match2, cursor + 1, 0),
    seconds: int(match2, cursor + 2, 0),
    milliseconds: parseMillis(match2[cursor + 3])
  };
  return [item, null, cursor + 4];
}
function extractISOOffset(match2, cursor) {
  const local = !match2[cursor] && !match2[cursor + 1], fullOffset = signedOffset(match2[cursor + 1], match2[cursor + 2]), zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [{}, zone, cursor + 3];
}
function extractIANAZone(match2, cursor) {
  const zone = match2[cursor] ? IANAZone.create(match2[cursor]) : null;
  return [{}, zone, cursor + 1];
}
const isoTimeOnly = RegExp(`^T?${isoTimeBaseRegex.source}$`);
const isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function extractISODuration(match2) {
  const [s2, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] = match2;
  const hasNegativePrefix = s2[0] === "-";
  const negativeSeconds = secondStr && secondStr[0] === "-";
  const maybeNegate = (num, force = false) => num !== void 0 && (force || num && hasNegativePrefix) ? -num : num;
  return [
    {
      years: maybeNegate(parseFloating(yearStr)),
      months: maybeNegate(parseFloating(monthStr)),
      weeks: maybeNegate(parseFloating(weekStr)),
      days: maybeNegate(parseFloating(dayStr)),
      hours: maybeNegate(parseFloating(hourStr)),
      minutes: maybeNegate(parseFloating(minuteStr)),
      seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
      milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds)
    }
  ];
}
const obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  const result = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr)
  };
  if (secondStr)
    result.second = parseInteger(secondStr);
  if (weekdayStr) {
    result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
  }
  return result;
}
const rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function extractRFC2822(match2) {
  const [
    ,
    weekdayStr,
    dayStr,
    monthStr,
    yearStr,
    hourStr,
    minuteStr,
    secondStr,
    obsOffset,
    milOffset,
    offHourStr,
    offMinuteStr
  ] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  let offset2;
  if (obsOffset) {
    offset2 = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset2 = 0;
  } else {
    offset2 = signedOffset(offHourStr, offMinuteStr);
  }
  return [result, new FixedOffsetZone(offset2)];
}
function preprocessRFC2822(s2) {
  return s2.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function extractRFC1123Or850(match2) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}
function extractASCII(match2) {
  const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}
const isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
const isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
const isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
const isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
const extractISOYmdTimeAndOffset = combineExtractors(
  extractISOYmd,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOWeekTimeAndOffset = combineExtractors(
  extractISOWeekData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOOrdinalDateAndTime = combineExtractors(
  extractISOOrdinalData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOTimeAndOffset = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
function parseISODate(s2) {
  return parse(
    s2,
    [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset],
    [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDateAndTime],
    [isoTimeCombinedRegex, extractISOTimeAndOffset]
  );
}
function parseRFC2822Date(s2) {
  return parse(preprocessRFC2822(s2), [rfc2822, extractRFC2822]);
}
function parseHTTPDate(s2) {
  return parse(
    s2,
    [rfc1123, extractRFC1123Or850],
    [rfc850, extractRFC1123Or850],
    [ascii, extractASCII]
  );
}
function parseISODuration(s2) {
  return parse(s2, [isoDuration, extractISODuration]);
}
const extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s2) {
  return parse(s2, [isoTimeOnly, extractISOTimeOnly]);
}
const sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
const sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
const extractISOTimeOffsetAndIANAZone = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
function parseSQL(s2) {
  return parse(
    s2,
    [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]
  );
}
const INVALID$2 = "Invalid Duration";
const lowOrderMatrix = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, casualMatrix = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...lowOrderMatrix
}, daysInYearAccurate = 146097 / 400, daysInMonthAccurate = 146097 / 4800, accurateMatrix = {
  years: {
    quarters: 4,
    months: 12,
    weeks: daysInYearAccurate / 7,
    days: daysInYearAccurate,
    hours: daysInYearAccurate * 24,
    minutes: daysInYearAccurate * 24 * 60,
    seconds: daysInYearAccurate * 24 * 60 * 60,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: daysInYearAccurate / 28,
    days: daysInYearAccurate / 4,
    hours: daysInYearAccurate * 24 / 4,
    minutes: daysInYearAccurate * 24 * 60 / 4,
    seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: daysInMonthAccurate / 7,
    days: daysInMonthAccurate,
    hours: daysInMonthAccurate * 24,
    minutes: daysInMonthAccurate * 24 * 60,
    seconds: daysInMonthAccurate * 24 * 60 * 60,
    milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1e3
  },
  ...lowOrderMatrix
};
const orderedUnits$1 = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
];
const reverseUnits = orderedUnits$1.slice(0).reverse();
function clone$2(dur, alts, clear = false) {
  const conf = {
    values: clear ? alts.values : { ...dur.values, ...alts.values || {} },
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
    matrix: alts.matrix || dur.matrix
  };
  return new Duration(conf);
}
function antiTrunc(n2) {
  return n2 < 0 ? Math.floor(n2) : Math.ceil(n2);
}
function convert(matrix, fromMap, fromUnit, toMap, toUnit) {
  const conv = matrix[toUnit][fromUnit], raw = fromMap[fromUnit] / conv, sameSign = Math.sign(raw) === Math.sign(toMap[toUnit]), added = !sameSign && toMap[toUnit] !== 0 && Math.abs(raw) <= 1 ? antiTrunc(raw) : Math.trunc(raw);
  toMap[toUnit] += added;
  fromMap[fromUnit] -= added * conv;
}
function normalizeValues(matrix, vals) {
  reverseUnits.reduce((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        convert(matrix, vals, previous, vals, current);
      }
      return current;
    } else {
      return previous;
    }
  }, null);
}
function removeZeroes(vals) {
  const newVals = {};
  for (const [key, value] of Object.entries(vals)) {
    if (value !== 0) {
      newVals[key] = value;
    }
  }
  return newVals;
}
class Duration {
  /**
   * @private
   */
  constructor(config2) {
    const accurate = config2.conversionAccuracy === "longterm" || false;
    let matrix = accurate ? accurateMatrix : casualMatrix;
    if (config2.matrix) {
      matrix = config2.matrix;
    }
    this.values = config2.values;
    this.loc = config2.loc || Locale.create();
    this.conversionAccuracy = accurate ? "longterm" : "casual";
    this.invalid = config2.invalid || null;
    this.matrix = matrix;
    this.isLuxonDuration = true;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(count, opts) {
    return Duration.fromObject({ milliseconds: count }, opts);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(obj, opts = {}) {
    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError(
        `Duration.fromObject: argument expected to be an object, got ${obj === null ? "null" : typeof obj}`
      );
    }
    return new Duration({
      values: normalizeObject(obj, Duration.normalizeUnit),
      loc: Locale.fromObject(opts),
      conversionAccuracy: opts.conversionAccuracy,
      matrix: opts.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(durationLike) {
    if (isNumber(durationLike)) {
      return Duration.fromMillis(durationLike);
    } else if (Duration.isDuration(durationLike)) {
      return durationLike;
    } else if (typeof durationLike === "object") {
      return Duration.fromObject(durationLike);
    } else {
      throw new InvalidArgumentError(
        `Unknown duration argument ${durationLike} of type ${typeof durationLike}`
      );
    }
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(text, opts) {
    const [parsed] = parseISODuration(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(text, opts) {
    const [parsed] = parseISOTimeOnly(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(invalid);
    } else {
      return new Duration({ invalid });
    }
  }
  /**
   * @private
   */
  static normalizeUnit(unit) {
    const normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[unit ? unit.toLowerCase() : unit];
    if (!normalized)
      throw new InvalidUnitError(unit);
    return normalized;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(o3) {
    return o3 && o3.isLuxonDuration || false;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    const fmtOpts = {
      ...opts,
      floor: opts.round !== false && opts.floor !== false
    };
    return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID$2;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior use the `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
   * @param opts - On option object to override the formatting. Accepts the same keys as the options parameter of the native `Int.NumberFormat` constructor, as well as `listStyle`.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(opts = {}) {
    const l2 = orderedUnits$1.map((unit) => {
      const val = this.values[unit];
      if (isUndefined(val)) {
        return null;
      }
      return this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...opts, unit: unit.slice(0, -1) }).format(val);
    }).filter((n2) => n2);
    return this.loc.listFormatter({ type: "conjunction", style: opts.listStyle || "narrow", ...opts }).format(l2);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    if (!this.isValid)
      return {};
    return { ...this.values };
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid)
      return null;
    let s2 = "P";
    if (this.years !== 0)
      s2 += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0)
      s2 += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0)
      s2 += this.weeks + "W";
    if (this.days !== 0)
      s2 += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0)
      s2 += "T";
    if (this.hours !== 0)
      s2 += this.hours + "H";
    if (this.minutes !== 0)
      s2 += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0)
      s2 += roundTo(this.seconds + this.milliseconds / 1e3, 3) + "S";
    if (s2 === "P")
      s2 += "T0S";
    return s2;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(opts = {}) {
    if (!this.isValid)
      return null;
    const millis = this.toMillis();
    if (millis < 0 || millis >= 864e5)
      return null;
    opts = {
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended",
      ...opts
    };
    const value = this.shiftTo("hours", "minutes", "seconds", "milliseconds");
    let fmt = opts.format === "basic" ? "hhmm" : "hh:mm";
    if (!opts.suppressSeconds || value.seconds !== 0 || value.milliseconds !== 0) {
      fmt += opts.format === "basic" ? "ss" : ":ss";
      if (!opts.suppressMilliseconds || value.milliseconds !== 0) {
        fmt += ".SSS";
      }
    }
    let str = value.toFormat(fmt);
    if (opts.includePrefix) {
      str = "T" + str;
    }
    return str;
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.as("milliseconds");
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(duration) {
    if (!this.isValid)
      return this;
    const dur = Duration.fromDurationLike(duration), result = {};
    for (const k2 of orderedUnits$1) {
      if (hasOwnProperty(dur.values, k2) || hasOwnProperty(this.values, k2)) {
        result[k2] = dur.get(k2) + this.get(k2);
      }
    }
    return clone$2(this, { values: result }, true);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(duration) {
    if (!this.isValid)
      return this;
    const dur = Duration.fromDurationLike(duration);
    return this.plus(dur.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(fn) {
    if (!this.isValid)
      return this;
    const result = {};
    for (const k2 of Object.keys(this.values)) {
      result[k2] = asNumber(fn(this.values[k2], k2));
    }
    return clone$2(this, { values: result }, true);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(unit) {
    return this[Duration.normalizeUnit(unit)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(values) {
    if (!this.isValid)
      return this;
    const mixed = { ...this.values, ...normalizeObject(values, Duration.normalizeUnit) };
    return clone$2(this, { values: mixed });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale, numberingSystem, conversionAccuracy, matrix } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem });
    const opts = { loc, matrix, conversionAccuracy };
    return clone$2(this, opts);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid)
      return this;
    const vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone$2(this, { values: vals }, true);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid)
      return this;
    const vals = removeZeroes(this.normalize().shiftToAll().toObject());
    return clone$2(this, { values: vals }, true);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...units) {
    if (!this.isValid)
      return this;
    if (units.length === 0) {
      return this;
    }
    units = units.map((u2) => Duration.normalizeUnit(u2));
    const built = {}, accumulated = {}, vals = this.toObject();
    let lastUnit;
    for (const k2 of orderedUnits$1) {
      if (units.indexOf(k2) >= 0) {
        lastUnit = k2;
        let own = 0;
        for (const ak in accumulated) {
          own += this.matrix[ak][k2] * accumulated[ak];
          accumulated[ak] = 0;
        }
        if (isNumber(vals[k2])) {
          own += vals[k2];
        }
        const i2 = Math.trunc(own);
        built[k2] = i2;
        accumulated[k2] = (own * 1e3 - i2 * 1e3) / 1e3;
        for (const down in vals) {
          if (orderedUnits$1.indexOf(down) > orderedUnits$1.indexOf(k2)) {
            convert(this.matrix, vals, down, built, k2);
          }
        }
      } else if (isNumber(vals[k2])) {
        accumulated[k2] = vals[k2];
      }
    }
    for (const key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }
    return clone$2(this, { values: built }, true).normalize();
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    if (!this.isValid)
      return this;
    return this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    );
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid)
      return this;
    const negated = {};
    for (const k2 of Object.keys(this.values)) {
      negated[k2] = this.values[k2] === 0 ? 0 : -this.values[k2];
    }
    return clone$2(this, { values: negated }, true);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    if (!this.loc.equals(other.loc)) {
      return false;
    }
    function eq2(v1, v2) {
      if (v1 === void 0 || v1 === 0)
        return v2 === void 0 || v2 === 0;
      return v1 === v2;
    }
    for (const u2 of orderedUnits$1) {
      if (!eq2(this.values[u2], other.values[u2])) {
        return false;
      }
    }
    return true;
  }
}
const INVALID$1 = "Invalid Interval";
function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid(
      "end before start",
      `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`
    );
  } else {
    return null;
  }
}
class Interval {
  /**
   * @private
   */
  constructor(config2) {
    this.s = config2.start;
    this.e = config2.end;
    this.invalid = config2.invalid || null;
    this.isLuxonInterval = true;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(invalid);
    } else {
      return new Interval({ invalid });
    }
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(start, end) {
    const builtStart = friendlyDateTime(start), builtEnd = friendlyDateTime(end);
    const validateError = validateStartEnd(builtStart, builtEnd);
    if (validateError == null) {
      return new Interval({
        start: builtStart,
        end: builtEnd
      });
    } else {
      return validateError;
    }
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(start, duration) {
    const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(start);
    return Interval.fromDateTimes(dt, dt.plus(dur));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(end, duration) {
    const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(end);
    return Interval.fromDateTimes(dt.minus(dur), dt);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(text, opts) {
    const [s2, e2] = (text || "").split("/", 2);
    if (s2 && e2) {
      let start, startIsValid;
      try {
        start = DateTime.fromISO(s2, opts);
        startIsValid = start.isValid;
      } catch (e3) {
        startIsValid = false;
      }
      let end, endIsValid;
      try {
        end = DateTime.fromISO(e2, opts);
        endIsValid = end.isValid;
      } catch (e3) {
        endIsValid = false;
      }
      if (startIsValid && endIsValid) {
        return Interval.fromDateTimes(start, end);
      }
      if (startIsValid) {
        const dur = Duration.fromISO(e2, opts);
        if (dur.isValid) {
          return Interval.after(start, dur);
        }
      } else if (endIsValid) {
        const dur = Duration.fromISO(s2, opts);
        if (dur.isValid) {
          return Interval.before(end, dur);
        }
      }
    }
    return Interval.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(o3) {
    return o3 && o3.isLuxonInterval || false;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(unit = "milliseconds") {
    return this.isValid ? this.toDuration(...[unit]).get(unit) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @return {number}
   */
  count(unit = "milliseconds") {
    if (!this.isValid)
      return NaN;
    const start = this.start.startOf(unit), end = this.end.startOf(unit);
    return Math.floor(end.diff(start, unit).get(unit)) + 1;
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(dateTime) {
    if (!this.isValid)
      return false;
    return this.s > dateTime;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(dateTime) {
    if (!this.isValid)
      return false;
    return this.e <= dateTime;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(dateTime) {
    if (!this.isValid)
      return false;
    return this.s <= dateTime && this.e > dateTime;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start, end } = {}) {
    if (!this.isValid)
      return this;
    return Interval.fromDateTimes(start || this.s, end || this.e);
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...dateTimes) {
    if (!this.isValid)
      return [];
    const sorted = dateTimes.map(friendlyDateTime).filter((d2) => this.contains(d2)).sort(), results = [];
    let { s: s2 } = this, i2 = 0;
    while (s2 < this.e) {
      const added = sorted[i2] || this.e, next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s2, next));
      s2 = next;
      i2 += 1;
    }
    return results;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(duration) {
    const dur = Duration.fromDurationLike(duration);
    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }
    let { s: s2 } = this, idx = 1, next;
    const results = [];
    while (s2 < this.e) {
      const added = this.start.plus(dur.mapUnits((x2) => x2 * idx));
      next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s2, next));
      s2 = next;
      idx += 1;
    }
    return results;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(numberOfParts) {
    if (!this.isValid)
      return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(other) {
    if (!this.isValid)
      return false;
    return +this.e === +other.s;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(other) {
    if (!this.isValid)
      return false;
    return +other.e === +this.s;
  }
  /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(other) {
    if (!this.isValid)
      return false;
    return this.s <= other.s && this.e >= other.e;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    return this.s.equals(other.s) && this.e.equals(other.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(other) {
    if (!this.isValid)
      return this;
    const s2 = this.s > other.s ? this.s : other.s, e2 = this.e < other.e ? this.e : other.e;
    if (s2 >= e2) {
      return null;
    } else {
      return Interval.fromDateTimes(s2, e2);
    }
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(other) {
    if (!this.isValid)
      return this;
    const s2 = this.s < other.s ? this.s : other.s, e2 = this.e > other.e ? this.e : other.e;
    return Interval.fromDateTimes(s2, e2);
  }
  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(intervals) {
    const [found, final] = intervals.sort((a2, b) => a2.s - b.s).reduce(
      ([sofar, current], item) => {
        if (!current) {
          return [sofar, item];
        } else if (current.overlaps(item) || current.abutsStart(item)) {
          return [sofar, current.union(item)];
        } else {
          return [sofar.concat([current]), item];
        }
      },
      [[], null]
    );
    if (final) {
      found.push(final);
    }
    return found;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(intervals) {
    let start = null, currentCount = 0;
    const results = [], ends = intervals.map((i2) => [
      { time: i2.s, type: "s" },
      { time: i2.e, type: "e" }
    ]), flattened = Array.prototype.concat(...ends), arr2 = flattened.sort((a2, b) => a2.time - b.time);
    for (const i2 of arr2) {
      currentCount += i2.type === "s" ? 1 : -1;
      if (currentCount === 1) {
        start = i2.time;
      } else {
        if (start && +start !== +i2.time) {
          results.push(Interval.fromDateTimes(start, i2.time));
        }
        start = null;
      }
    }
    return Interval.merge(results);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...intervals) {
    return Interval.xor([this].concat(intervals)).map((i2) => this.intersection(i2)).filter((i2) => i2 && !i2.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    if (!this.isValid)
      return INVALID$1;
    return `[${this.s.toISO()} – ${this.e.toISO()})`;
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : INVALID$1;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(opts) {
    if (!this.isValid)
      return INVALID$1;
    return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    if (!this.isValid)
      return INVALID$1;
    return `${this.s.toISODate()}/${this.e.toISODate()}`;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(opts) {
    if (!this.isValid)
      return INVALID$1;
    return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(dateFormat, { separator = " – " } = {}) {
    if (!this.isValid)
      return INVALID$1;
    return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }
    return this.e.diff(this.s, unit, opts);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(mapFn) {
    return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  }
}
class Info {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(zone = Settings.defaultZone) {
    const proto = DateTime.now().setZone(zone).set({ month: 12 });
    return !zone.isUniversal && proto.offset !== proto.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(zone) {
    return IANAZone.isValidZone(zone);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(input) {
    return normalizeZone(input, Settings.defaultZone);
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale = null } = {}) {
    return Locale.create(locale).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(length = "short", { locale = null } = {}) {
    return Locale.create(locale, null, "gregory").eras(length);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * @example Info.features() //=> { relative: false }
   * @return {Object}
   */
  static features() {
    return { relative: hasRelative() };
  }
}
function dayDiff(earlier, later) {
  const utcDayStart = (dt) => dt.toUTC(0, { keepLocalTime: true }).startOf("day").valueOf(), ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration.fromMillis(ms).as("days"));
}
function highOrderDiffs(cursor, later, units) {
  const differs = [
    ["years", (a2, b) => b.year - a2.year],
    ["quarters", (a2, b) => b.quarter - a2.quarter + (b.year - a2.year) * 4],
    ["months", (a2, b) => b.month - a2.month + (b.year - a2.year) * 12],
    [
      "weeks",
      (a2, b) => {
        const days = dayDiff(a2, b);
        return (days - days % 7) / 7;
      }
    ],
    ["days", dayDiff]
  ];
  const results = {};
  const earlier = cursor;
  let lowestOrder, highWater;
  for (const [unit, differ] of differs) {
    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;
      results[unit] = differ(cursor, later);
      highWater = earlier.plus(results);
      if (highWater > later) {
        results[unit]--;
        cursor = earlier.plus(results);
      } else {
        cursor = highWater;
      }
    }
  }
  return [cursor, results, highWater, lowestOrder];
}
function diff(earlier, later, units, opts) {
  let [cursor, results, highWater, lowestOrder] = highOrderDiffs(earlier, later, units);
  const remainingMillis = later - cursor;
  const lowerOrderUnits = units.filter(
    (u2) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(u2) >= 0
  );
  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      highWater = cursor.plus({ [lowestOrder]: 1 });
    }
    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }
  const duration = Duration.fromObject(results, opts);
  if (lowerOrderUnits.length > 0) {
    return Duration.fromMillis(remainingMillis, opts).shiftTo(...lowerOrderUnits).plus(duration);
  } else {
    return duration;
  }
}
const numberingSystems = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
};
const numberingSystemsUTF16 = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
};
const hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
  let value = parseInt(str, 10);
  if (isNaN(value)) {
    value = "";
    for (let i2 = 0; i2 < str.length; i2++) {
      const code = str.charCodeAt(i2);
      if (str[i2].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i2]);
      } else {
        for (const key in numberingSystemsUTF16) {
          const [min2, max2] = numberingSystemsUTF16[key];
          if (code >= min2 && code <= max2) {
            value += code - min2;
          }
        }
      }
    }
    return parseInt(value, 10);
  } else {
    return value;
  }
}
function digitRegex({ numberingSystem }, append = "") {
  return new RegExp(`${numberingSystems[numberingSystem || "latn"]}${append}`);
}
const MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function intUnit(regex, post = (i2) => i2) {
  return { regex, deser: ([s2]) => post(parseDigits(s2)) };
}
const NBSP = String.fromCharCode(160);
const spaceOrNBSP = `[ ${NBSP}]`;
const spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");
function fixListRegex(s2) {
  return s2.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}
function stripInsensitivities(s2) {
  return s2.replace(/\./g, "").replace(spaceOrNBSPRegExp, " ").toLowerCase();
}
function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: ([s2]) => strings.findIndex((i2) => stripInsensitivities(s2) === stripInsensitivities(i2)) + startIndex
    };
  }
}
function offset(regex, groups) {
  return { regex, deser: ([, h2, m2]) => signedOffset(h2, m2), groups };
}
function simple(regex) {
  return { regex, deser: ([s2]) => s2 };
}
function escapeToken(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function unitForToken(token, loc) {
  const one = digitRegex(loc), two = digitRegex(loc, "{2}"), three = digitRegex(loc, "{3}"), four = digitRegex(loc, "{4}"), six = digitRegex(loc, "{6}"), oneOrTwo = digitRegex(loc, "{1,2}"), oneToThree = digitRegex(loc, "{1,3}"), oneToSix = digitRegex(loc, "{1,6}"), oneToNine = digitRegex(loc, "{1,9}"), twoToFour = digitRegex(loc, "{2,4}"), fourToSix = digitRegex(loc, "{4,6}"), literal = (t2) => ({ regex: RegExp(escapeToken(t2.val)), deser: ([s2]) => s2, literal: true }), unitate = (t2) => {
    if (token.literal) {
      return literal(t2);
    }
    switch (t2.val) {
      case "G":
        return oneOf(loc.eras("short", false), 0);
      case "GG":
        return oneOf(loc.eras("long", false), 0);
      case "y":
        return intUnit(oneToSix);
      case "yy":
        return intUnit(twoToFour, untruncateYear);
      case "yyyy":
        return intUnit(four);
      case "yyyyy":
        return intUnit(fourToSix);
      case "yyyyyy":
        return intUnit(six);
      case "M":
        return intUnit(oneOrTwo);
      case "MM":
        return intUnit(two);
      case "MMM":
        return oneOf(loc.months("short", true, false), 1);
      case "MMMM":
        return oneOf(loc.months("long", true, false), 1);
      case "L":
        return intUnit(oneOrTwo);
      case "LL":
        return intUnit(two);
      case "LLL":
        return oneOf(loc.months("short", false, false), 1);
      case "LLLL":
        return oneOf(loc.months("long", false, false), 1);
      case "d":
        return intUnit(oneOrTwo);
      case "dd":
        return intUnit(two);
      case "o":
        return intUnit(oneToThree);
      case "ooo":
        return intUnit(three);
      case "HH":
        return intUnit(two);
      case "H":
        return intUnit(oneOrTwo);
      case "hh":
        return intUnit(two);
      case "h":
        return intUnit(oneOrTwo);
      case "mm":
        return intUnit(two);
      case "m":
        return intUnit(oneOrTwo);
      case "q":
        return intUnit(oneOrTwo);
      case "qq":
        return intUnit(two);
      case "s":
        return intUnit(oneOrTwo);
      case "ss":
        return intUnit(two);
      case "S":
        return intUnit(oneToThree);
      case "SSS":
        return intUnit(three);
      case "u":
        return simple(oneToNine);
      case "uu":
        return simple(oneOrTwo);
      case "uuu":
        return intUnit(one);
      case "a":
        return oneOf(loc.meridiems(), 0);
      case "kkkk":
        return intUnit(four);
      case "kk":
        return intUnit(twoToFour, untruncateYear);
      case "W":
        return intUnit(oneOrTwo);
      case "WW":
        return intUnit(two);
      case "E":
      case "c":
        return intUnit(one);
      case "EEE":
        return oneOf(loc.weekdays("short", false, false), 1);
      case "EEEE":
        return oneOf(loc.weekdays("long", false, false), 1);
      case "ccc":
        return oneOf(loc.weekdays("short", true, false), 1);
      case "cccc":
        return oneOf(loc.weekdays("long", true, false), 1);
      case "Z":
      case "ZZ":
        return offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
      case "ZZZ":
        return offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
      case "z":
        return simple(/[a-z_+-/]{1,256}?/i);
      default:
        return literal(t2);
    }
  };
  const unit = unitate(token) || {
    invalidReason: MISSING_FTP
  };
  unit.token = token;
  return unit;
}
const partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour: {
    numeric: "h",
    "2-digit": "hh"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function tokenForPart(part, formatOpts) {
  const { type: type2, value } = part;
  if (type2 === "literal") {
    return {
      literal: true,
      val: value
    };
  }
  const style = formatOpts[type2];
  let val = partTypeStyleToTokenVal[type2];
  if (typeof val === "object") {
    val = val[style];
  }
  if (val) {
    return {
      literal: false,
      val
    };
  }
  return void 0;
}
function buildRegex(units) {
  const re2 = units.map((u2) => u2.regex).reduce((f2, r2) => `${f2}(${r2.source})`, "");
  return [`^${re2}$`, units];
}
function match(input, regex, handlers) {
  const matches = input.match(regex);
  if (matches) {
    const all = {};
    let matchIndex = 1;
    for (const i2 in handlers) {
      if (hasOwnProperty(handlers, i2)) {
        const h2 = handlers[i2], groups = h2.groups ? h2.groups + 1 : 1;
        if (!h2.literal && h2.token) {
          all[h2.token.val[0]] = h2.deser(matches.slice(matchIndex, matchIndex + groups));
        }
        matchIndex += groups;
      }
    }
    return [matches, all];
  } else {
    return [matches, {}];
  }
}
function dateTimeFromMatches(matches) {
  const toField = (token) => {
    switch (token) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let zone = null;
  let specificOffset;
  if (!isUndefined(matches.z)) {
    zone = IANAZone.create(matches.z);
  }
  if (!isUndefined(matches.Z)) {
    if (!zone) {
      zone = new FixedOffsetZone(matches.Z);
    }
    specificOffset = matches.Z;
  }
  if (!isUndefined(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }
  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }
  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }
  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }
  const vals = Object.keys(matches).reduce((r2, k2) => {
    const f2 = toField(k2);
    if (f2) {
      r2[f2] = matches[k2];
    }
    return r2;
  }, {});
  return [vals, zone, specificOffset];
}
let dummyDateTimeCache = null;
function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }
  return dummyDateTimeCache;
}
function maybeExpandMacroToken(token, locale) {
  if (token.literal) {
    return token;
  }
  const formatOpts = Formatter.macroTokenToFormatOpts(token.val);
  const tokens = formatOptsToTokens(formatOpts, locale);
  if (tokens == null || tokens.includes(void 0)) {
    return token;
  }
  return tokens;
}
function expandMacroTokens(tokens, locale) {
  return Array.prototype.concat(...tokens.map((t2) => maybeExpandMacroToken(t2, locale)));
}
function explainFromTokens(locale, input, format) {
  const tokens = expandMacroTokens(Formatter.parseFormat(format), locale), units = tokens.map((t2) => unitForToken(t2, locale)), disqualifyingUnit = units.find((t2) => t2.invalidReason);
  if (disqualifyingUnit) {
    return { input, tokens, invalidReason: disqualifyingUnit.invalidReason };
  } else {
    const [regexString, handlers] = buildRegex(units), regex = RegExp(regexString, "i"), [rawMatches, matches] = match(input, regex, handlers), [result, zone, specificOffset] = matches ? dateTimeFromMatches(matches) : [null, null, void 0];
    if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) {
      throw new ConflictingSpecificationError(
        "Can't include meridiem when specifying 24-hour format"
      );
    }
    return { input, tokens, regex, rawMatches, matches, result, zone, specificOffset };
  }
}
function parseFromTokens(locale, input, format) {
  const { result, zone, specificOffset, invalidReason } = explainFromTokens(locale, input, format);
  return [result, zone, specificOffset, invalidReason];
}
function formatOptsToTokens(formatOpts, locale) {
  if (!formatOpts) {
    return null;
  }
  const formatter2 = Formatter.create(locale, formatOpts);
  const parts = formatter2.formatDateTimeParts(getDummyDateTime());
  return parts.map((p2) => tokenForPart(p2, formatOpts));
}
const nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function unitOutOfRange(unit, value) {
  return new Invalid(
    "unit out of range",
    `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`
  );
}
function dayOfWeek(year, month, day) {
  const d2 = new Date(Date.UTC(year, month - 1, day));
  if (year < 100 && year >= 0) {
    d2.setUTCFullYear(d2.getUTCFullYear() - 1900);
  }
  const js = d2.getUTCDay();
  return js === 0 ? 7 : js;
}
function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}
function uncomputeOrdinal(year, ordinal) {
  const table = isLeapYear(year) ? leapLadder : nonLeapLadder, month0 = table.findIndex((i2) => i2 < ordinal), day = ordinal - table[month0];
  return { month: month0 + 1, day };
}
function gregorianToWeek(gregObj) {
  const { year, month, day } = gregObj, ordinal = computeOrdinal(year, month, day), weekday = dayOfWeek(year, month, day);
  let weekNumber = Math.floor((ordinal - weekday + 10) / 7), weekYear;
  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear);
  } else if (weekNumber > weeksInWeekYear(year)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }
  return { weekYear, weekNumber, weekday, ...timeObject(gregObj) };
}
function weekToGregorian(weekData) {
  const { weekYear, weekNumber, weekday } = weekData, weekdayOfJan4 = dayOfWeek(weekYear, 1, 4), yearInDays = daysInYear(weekYear);
  let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3, year;
  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(weekData) };
}
function gregorianToOrdinal(gregData) {
  const { year, month, day } = gregData;
  const ordinal = computeOrdinal(year, month, day);
  return { year, ordinal, ...timeObject(gregData) };
}
function ordinalToGregorian(ordinalData) {
  const { year, ordinal } = ordinalData;
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(ordinalData) };
}
function hasInvalidWeekData(obj) {
  const validYear = isInteger(obj.weekYear), validWeek = integerBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear)), validWeekday = integerBetween(obj.weekday, 1, 7);
  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.week);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else
    return false;
}
function hasInvalidOrdinalData(obj) {
  const validYear = isInteger(obj.year), validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else
    return false;
}
function hasInvalidGregorianData(obj) {
  const validYear = isInteger(obj.year), validMonth = integerBetween(obj.month, 1, 12), validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else
    return false;
}
function hasInvalidTimeData(obj) {
  const { hour, minute, second, millisecond } = obj;
  const validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = integerBetween(minute, 0, 59), validSecond = integerBetween(second, 0, 59), validMillisecond = integerBetween(millisecond, 0, 999);
  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else
    return false;
}
const INVALID = "Invalid DateTime";
const MAX_DATE = 864e13;
function unsupportedZone(zone) {
  return new Invalid("unsupported zone", `the zone "${zone.name}" is not supported`);
}
function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }
  return dt.weekData;
}
function clone$1(inst, alts) {
  const current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid
  };
  return new DateTime({ ...current, ...alts, old: current });
}
function fixOffset(localTS, o3, tz) {
  let utcGuess = localTS - o3 * 60 * 1e3;
  const o22 = tz.offset(utcGuess);
  if (o3 === o22) {
    return [utcGuess, o3];
  }
  utcGuess -= (o22 - o3) * 60 * 1e3;
  const o32 = tz.offset(utcGuess);
  if (o22 === o32) {
    return [utcGuess, o22];
  }
  return [localTS - Math.min(o22, o32) * 60 * 1e3, Math.max(o22, o32)];
}
function tsToObj(ts, offset2) {
  ts += offset2 * 60 * 1e3;
  const d2 = new Date(ts);
  return {
    year: d2.getUTCFullYear(),
    month: d2.getUTCMonth() + 1,
    day: d2.getUTCDate(),
    hour: d2.getUTCHours(),
    minute: d2.getUTCMinutes(),
    second: d2.getUTCSeconds(),
    millisecond: d2.getUTCMilliseconds()
  };
}
function objToTS(obj, offset2, zone) {
  return fixOffset(objToLocalTS(obj), offset2, zone);
}
function adjustTime(inst, dur) {
  const oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c2 = {
    ...inst.c,
    year,
    month,
    day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
  }, millisToAdd = Duration.fromObject({
    years: dur.years - Math.trunc(dur.years),
    quarters: dur.quarters - Math.trunc(dur.quarters),
    months: dur.months - Math.trunc(dur.months),
    weeks: dur.weeks - Math.trunc(dur.weeks),
    days: dur.days - Math.trunc(dur.days),
    hours: dur.hours,
    minutes: dur.minutes,
    seconds: dur.seconds,
    milliseconds: dur.milliseconds
  }).as("milliseconds"), localTS = objToLocalTS(c2);
  let [ts, o3] = fixOffset(localTS, oPre, inst.zone);
  if (millisToAdd !== 0) {
    ts += millisToAdd;
    o3 = inst.zone.offset(ts);
  }
  return { ts, o: o3 };
}
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
  const { setZone, zone } = opts;
  if (parsed && Object.keys(parsed).length !== 0) {
    const interpretationZone = parsedZone || zone, inst = DateTime.fromObject(parsed, {
      ...opts,
      zone: interpretationZone,
      specificOffset
    });
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(
      new Invalid("unparsable", `the input "${text}" can't be parsed as ${format}`)
    );
  }
}
function toTechFormat(dt, format, allowZ = true) {
  return dt.isValid ? Formatter.create(Locale.create("en-US"), {
    allowZ,
    forceSimple: true
  }).formatDateTimeFromString(dt, format) : null;
}
function toISODate(o3, extended) {
  const longFormat = o3.c.year > 9999 || o3.c.year < 0;
  let c2 = "";
  if (longFormat && o3.c.year >= 0)
    c2 += "+";
  c2 += padStart(o3.c.year, longFormat ? 6 : 4);
  if (extended) {
    c2 += "-";
    c2 += padStart(o3.c.month);
    c2 += "-";
    c2 += padStart(o3.c.day);
  } else {
    c2 += padStart(o3.c.month);
    c2 += padStart(o3.c.day);
  }
  return c2;
}
function toISOTime(o3, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
  let c2 = padStart(o3.c.hour);
  if (extended) {
    c2 += ":";
    c2 += padStart(o3.c.minute);
    if (o3.c.second !== 0 || !suppressSeconds) {
      c2 += ":";
    }
  } else {
    c2 += padStart(o3.c.minute);
  }
  if (o3.c.second !== 0 || !suppressSeconds) {
    c2 += padStart(o3.c.second);
    if (o3.c.millisecond !== 0 || !suppressMilliseconds) {
      c2 += ".";
      c2 += padStart(o3.c.millisecond, 3);
    }
  }
  if (includeOffset) {
    if (o3.isOffsetFixed && o3.offset === 0 && !extendedZone) {
      c2 += "Z";
    } else if (o3.o < 0) {
      c2 += "-";
      c2 += padStart(Math.trunc(-o3.o / 60));
      c2 += ":";
      c2 += padStart(Math.trunc(-o3.o % 60));
    } else {
      c2 += "+";
      c2 += padStart(Math.trunc(o3.o / 60));
      c2 += ":";
      c2 += padStart(Math.trunc(o3.o % 60));
    }
  }
  if (extendedZone) {
    c2 += "[" + o3.zone.ianaName + "]";
  }
  return c2;
}
const defaultUnitValues = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, defaultWeekUnitValues = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, defaultOrdinalUnitValues = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
const orderedUnits = ["year", "month", "day", "hour", "minute", "second", "millisecond"], orderedWeekUnits = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function normalizeUnit(unit) {
  const normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[unit.toLowerCase()];
  if (!normalized)
    throw new InvalidUnitError(unit);
  return normalized;
}
function quickDT(obj, opts) {
  const zone = normalizeZone(opts.zone, Settings.defaultZone), loc = Locale.fromObject(opts), tsNow = Settings.now();
  let ts, o3;
  if (!isUndefined(obj.year)) {
    for (const u2 of orderedUnits) {
      if (isUndefined(obj[u2])) {
        obj[u2] = defaultUnitValues[u2];
      }
    }
    const invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
    if (invalid) {
      return DateTime.invalid(invalid);
    }
    const offsetProvis = zone.offset(tsNow);
    [ts, o3] = objToTS(obj, offsetProvis, zone);
  } else {
    ts = tsNow;
  }
  return new DateTime({ ts, zone, loc, o: o3 });
}
function diffRelative(start, end, opts) {
  const round2 = isUndefined(opts.round) ? true : opts.round, format = (c2, unit) => {
    c2 = roundTo(c2, round2 || opts.calendary ? 0 : 2, true);
    const formatter2 = end.loc.clone(opts).relFormatter(opts);
    return formatter2.format(c2, unit);
  }, differ = (unit) => {
    if (opts.calendary) {
      if (!end.hasSame(start, unit)) {
        return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
      } else
        return 0;
    } else {
      return end.diff(start, unit).get(unit);
    }
  };
  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }
  for (const unit of opts.units) {
    const count = differ(unit);
    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }
  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function lastOpts(argList) {
  let opts = {}, args;
  if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
    opts = argList[argList.length - 1];
    args = Array.from(argList).slice(0, argList.length - 1);
  } else {
    args = Array.from(argList);
  }
  return [opts, args];
}
class DateTime {
  /**
   * @access private
   */
  constructor(config2) {
    const zone = config2.zone || Settings.defaultZone;
    let invalid = config2.invalid || (Number.isNaN(config2.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
    this.ts = isUndefined(config2.ts) ? Settings.now() : config2.ts;
    let c2 = null, o3 = null;
    if (!invalid) {
      const unchanged = config2.old && config2.old.ts === this.ts && config2.old.zone.equals(zone);
      if (unchanged) {
        [c2, o3] = [config2.old.c, config2.old.o];
      } else {
        const ot = zone.offset(this.ts);
        c2 = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c2.year) ? new Invalid("invalid input") : null;
        c2 = invalid ? null : c2;
        o3 = invalid ? null : ot;
      }
    }
    this._zone = zone;
    this.loc = config2.loc || Locale.create();
    this.invalid = invalid;
    this.weekData = null;
    this.c = c2;
    this.o = o3;
    this.isLuxonDateTime = true;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new DateTime({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
    opts.zone = FixedOffsetZone.utcInstance;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(date2, options = {}) {
    const ts = isDate(date2) ? date2.valueOf() : NaN;
    if (Number.isNaN(ts)) {
      return DateTime.invalid("invalid input");
    }
    const zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }
    return new DateTime({
      ts,
      zone: zoneToUse,
      loc: Locale.fromObject(options)
    });
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(milliseconds, options = {}) {
    if (!isNumber(milliseconds)) {
      throw new InvalidArgumentError(
        `fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`
      );
    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
      return DateTime.invalid("Timestamp out of range");
    } else {
      return new DateTime({
        ts: milliseconds,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(seconds, options = {}) {
    if (!isNumber(seconds)) {
      throw new InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new DateTime({
        ts: seconds * 1e3,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @return {DateTime}
   */
  static fromObject(obj, opts = {}) {
    obj = obj || {};
    const zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }
    const tsNow = Settings.now(), offsetProvis = !isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), normalized = normalizeObject(obj, normalizeUnit), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber, loc = Locale.fromObject(opts);
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    const useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
    let units, defaultValues, objNow = tsToObj(tsNow, offsetProvis);
    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = orderedUnits;
      defaultValues = defaultUnitValues;
    }
    let foundFirst = false;
    for (const u2 of units) {
      const v2 = normalized[u2];
      if (!isUndefined(v2)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u2] = defaultValues[u2];
      } else {
        normalized[u2] = objNow[u2];
      }
    }
    const higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || hasInvalidTimeData(normalized);
    if (invalid) {
      return DateTime.invalid(invalid);
    }
    const gregorian = useWeekData ? weekToGregorian(normalized) : containsOrdinal ? ordinalToGregorian(normalized) : normalized, [tsFinal, offsetFinal] = objToTS(gregorian, offsetProvis, zoneToUse), inst = new DateTime({
      ts: tsFinal,
      zone: zoneToUse,
      o: offsetFinal,
      loc
    });
    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return DateTime.invalid(
        "mismatched weekday",
        `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`
      );
    }
    return inst;
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(text, opts = {}) {
    const [vals, parsedZone] = parseISODate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(text, opts = {}) {
    const [vals, parsedZone] = parseRFC2822Date(text);
    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(text, opts = {}) {
    const [vals, parsedZone] = parseHTTPDate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(text, fmt, opts = {}) {
    if (isUndefined(text) || isUndefined(fmt)) {
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    }
    const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    }), [vals, parsedZone, specificOffset, invalid] = parseFromTokens(localeToUse, text, fmt);
    if (invalid) {
      return DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(text, fmt, opts = {}) {
    return DateTime.fromFormat(text, fmt, opts);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(text, opts = {}) {
    const [vals, parsedZone] = parseSQL(text);
    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }
  /**
   * Create an invalid DateTime.
   * @param {DateTime} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(invalid);
    } else {
      return new DateTime({ invalid });
    }
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(o3) {
    return o3 && o3.isLuxonDateTime || false;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(formatOpts, localeOpts = {}) {
    const tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
    return !tokenList ? null : tokenList.map((t2) => t2 ? t2.val : null).join("");
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(fmt, localeOpts = {}) {
    const expanded = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
    return expanded.map((t2) => t2.val).join("");
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(unit) {
    return this[unit];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Info.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Info.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Info.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Info.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "short",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "long",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    if (this.isOffsetFixed) {
      return false;
    } else {
      return this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
    }
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return isLeapYear(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return daysInMonth(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? daysInYear(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(opts = {}) {
    const { locale, numberingSystem, calendar } = Formatter.create(
      this.loc.clone(opts),
      opts
    ).resolvedOptions(this);
    return { locale, numberingSystem, outputCalendar: calendar };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(offset2 = 0, opts = {}) {
    return this.setZone(FixedOffsetZone.instance(offset2), opts);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(Settings.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(zone, { keepLocalTime = false, keepCalendarTime = false } = {}) {
    zone = normalizeZone(zone, Settings.defaultZone);
    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return DateTime.invalid(unsupportedZone(zone));
    } else {
      let newTS = this.ts;
      if (keepLocalTime || keepCalendarTime) {
        const offsetGuess = zone.offset(this.ts);
        const asObj = this.toObject();
        [newTS] = objToTS(asObj, offsetGuess, zone);
      }
      return clone$1(this, { ts: newTS, zone });
    }
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale, numberingSystem, outputCalendar } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem, outputCalendar });
    return clone$1(this, { loc });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(locale) {
    return this.reconfigure({ locale });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(values) {
    if (!this.isValid)
      return this;
    const normalized = normalizeObject(values, normalizeUnit), settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    let mixed;
    if (settingWeekStuff) {
      mixed = weekToGregorian({ ...gregorianToWeek(this.c), ...normalized });
    } else if (!isUndefined(normalized.ordinal)) {
      mixed = ordinalToGregorian({ ...gregorianToOrdinal(this.c), ...normalized });
    } else {
      mixed = { ...this.toObject(), ...normalized };
      if (isUndefined(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }
    const [ts, o3] = objToTS(mixed, this.o, this.zone);
    return clone$1(this, { ts, o: o3 });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(duration) {
    if (!this.isValid)
      return this;
    const dur = Duration.fromDurationLike(duration);
    return clone$1(this, adjustTime(this, dur));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(duration) {
    if (!this.isValid)
      return this;
    const dur = Duration.fromDurationLike(duration).negate();
    return clone$1(this, adjustTime(this, dur));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(unit) {
    if (!this.isValid)
      return this;
    const o3 = {}, normalizedUnit = Duration.normalizeUnit(unit);
    switch (normalizedUnit) {
      case "years":
        o3.month = 1;
      case "quarters":
      case "months":
        o3.day = 1;
      case "weeks":
      case "days":
        o3.hour = 0;
      case "hours":
        o3.minute = 0;
      case "minutes":
        o3.second = 0;
      case "seconds":
        o3.millisecond = 0;
        break;
    }
    if (normalizedUnit === "weeks") {
      o3.weekday = 1;
    }
    if (normalizedUnit === "quarters") {
      const q = Math.ceil(this.month / 3);
      o3.month = (q - 1) * 3 + 1;
    }
    return this.set(o3);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(unit) {
    return this.isValid ? this.plus({ [unit]: 1 }).startOf(unit).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : INVALID;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO({
    format = "extended",
    suppressSeconds = false,
    suppressMilliseconds = false,
    includeOffset = true,
    extendedZone = false
  } = {}) {
    if (!this.isValid) {
      return null;
    }
    const ext = format === "extended";
    let c2 = toISODate(this, ext);
    c2 += "T";
    c2 += toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    return c2;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({ format = "extended" } = {}) {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, format === "extended");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds = false,
    suppressSeconds = false,
    includeOffset = true,
    includePrefix = false,
    extendedZone = false,
    format = "extended"
  } = {}) {
    if (!this.isValid) {
      return null;
    }
    let c2 = includePrefix ? "T" : "";
    return c2 + toISOTime(
      this,
      format === "extended",
      suppressSeconds,
      suppressMilliseconds,
      includeOffset,
      extendedZone
    );
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, true);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset = true, includeZone = false, includeOffsetSpace = true } = {}) {
    let fmt = "HH:mm:ss.SSS";
    if (includeZone || includeOffset) {
      if (includeOffsetSpace) {
        fmt += " ";
      }
      if (includeZone) {
        fmt += "z";
      } else if (includeOffset) {
        fmt += "ZZ";
      }
    }
    return toTechFormat(this, fmt, true);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(opts = {}) {
    if (!this.isValid) {
      return null;
    }
    return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : INVALID;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(opts = {}) {
    if (!this.isValid)
      return {};
    const base = { ...this.c };
    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(otherDateTime, unit = "milliseconds", opts = {}) {
    if (!this.isValid || !otherDateTime.isValid) {
      return Duration.invalid("created by diffing an invalid DateTime");
    }
    const durOpts = { locale: this.locale, numberingSystem: this.numberingSystem, ...opts };
    const units = maybeArray(unit).map(Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = diff(earlier, later, units, durOpts);
    return otherIsLater ? diffed.negate() : diffed;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(unit = "milliseconds", opts = {}) {
    return this.diff(DateTime.now(), unit, opts);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(otherDateTime, unit) {
    if (!this.isValid)
      return false;
    const inputMs = otherDateTime.valueOf();
    const adjustedToZone = this.setZone(otherDateTime.zone, { keepLocalTime: true });
    return adjustedToZone.startOf(unit) <= inputMs && inputMs <= adjustedToZone.endOf(unit);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(other) {
    return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(options = {}) {
    if (!this.isValid)
      return null;
    const base = options.base || DateTime.fromObject({}, { zone: this.zone }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
    let units = ["years", "months", "days", "hours", "minutes", "seconds"];
    let unit = options.unit;
    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = void 0;
    }
    return diffRelative(base, this.plus(padding), {
      ...options,
      numeric: "always",
      units,
      unit
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(options = {}) {
    if (!this.isValid)
      return null;
    return diffRelative(options.base || DateTime.fromObject({}, { zone: this.zone }), this, {
      ...options,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: true
    });
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i2) => i2.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i2) => i2.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(text, fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    return explainFromTokens(localeToUse, text, fmt);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(text, fmt, options = {}) {
    return DateTime.fromFormatExplain(text, fmt, options);
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return DATE_SHORT;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return DATE_MED;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return DATE_MED_WITH_WEEKDAY;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return DATE_FULL;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return DATE_HUGE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return TIME_SIMPLE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return TIME_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return TIME_WITH_SHORT_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return TIME_WITH_LONG_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return TIME_24_SIMPLE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return TIME_24_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return TIME_24_WITH_SHORT_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return TIME_24_WITH_LONG_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return DATETIME_SHORT;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return DATETIME_SHORT_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return DATETIME_MED;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return DATETIME_MED_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return DATETIME_MED_WITH_WEEKDAY;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return DATETIME_FULL;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return DATETIME_FULL_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return DATETIME_HUGE;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return DATETIME_HUGE_WITH_SECONDS;
  }
}
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError(
      `Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`
    );
  }
}
/*!
 *  decimal.js v10.4.3
 *  An arbitrary-precision Decimal type for JavaScript.
 *  https://github.com/MikeMcl/decimal.js
 *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *  MIT Licence
 */
var EXP_LIMIT = 9e15, MAX_DIGITS = 1e9, NUMERALS = "0123456789abcdef", LN10 = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", PI = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", DEFAULTS = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed at run-time using the `Decimal.config` method.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used when rounding to `precision`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The modulo mode used when calculating the modulus: a mod n.
  // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
  // The remainder (r) is calculated as: r = a - n * q.
  //
  // UP         0 The remainder is positive if the dividend is negative, else is negative.
  // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
  // FLOOR      3 The remainder has the same sign as the divisor (Python %).
  // HALF_EVEN  6 The IEEE 754 remainder function.
  // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
  //
  // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
  // division (9) are commonly used for the modulus operation. The other rounding modes can also
  // be used, but they may not give useful results.
  modulo: 1,
  // 0 to 9
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -EXP_LIMIT
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to EXP_LIMIT
  // The minimum exponent value, beneath which underflow to zero occurs.
  // JavaScript numbers: -324  (5e-324)
  minE: -EXP_LIMIT,
  // -1 to -EXP_LIMIT
  // The maximum exponent value, above which overflow to Infinity occurs.
  // JavaScript numbers: 308  (1.7976931348623157e+308)
  maxE: EXP_LIMIT,
  // 1 to EXP_LIMIT
  // Whether to use cryptographically-secure random number generation, if available.
  crypto: false
  // true/false
}, inexact, quadrant, external = true, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", precisionLimitExceeded = decimalError + "Precision limit exceeded", cryptoUnavailable = decimalError + "crypto unavailable", tag = "[object Decimal]", mathfloor = Math.floor, mathpow = Math.pow, isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, LN10_PRECISION = LN10.length - 1, PI_PRECISION = PI.length - 1, P = { toStringTag: tag };
P.absoluteValue = P.abs = function() {
  var x2 = new this.constructor(this);
  if (x2.s < 0)
    x2.s = 1;
  return finalise(x2);
};
P.ceil = function() {
  return finalise(new this.constructor(this), this.e + 1, 2);
};
P.clampedTo = P.clamp = function(min2, max2) {
  var k2, x2 = this, Ctor = x2.constructor;
  min2 = new Ctor(min2);
  max2 = new Ctor(max2);
  if (!min2.s || !max2.s)
    return new Ctor(NaN);
  if (min2.gt(max2))
    throw Error(invalidArgument + max2);
  k2 = x2.cmp(min2);
  return k2 < 0 ? min2 : x2.cmp(max2) > 0 ? max2 : new Ctor(x2);
};
P.comparedTo = P.cmp = function(y2) {
  var i2, j2, xdL, ydL, x2 = this, xd = x2.d, yd = (y2 = new x2.constructor(y2)).d, xs = x2.s, ys = y2.s;
  if (!xd || !yd) {
    return !xs || !ys ? NaN : xs !== ys ? xs : xd === yd ? 0 : !xd ^ xs < 0 ? 1 : -1;
  }
  if (!xd[0] || !yd[0])
    return xd[0] ? xs : yd[0] ? -ys : 0;
  if (xs !== ys)
    return xs;
  if (x2.e !== y2.e)
    return x2.e > y2.e ^ xs < 0 ? 1 : -1;
  xdL = xd.length;
  ydL = yd.length;
  for (i2 = 0, j2 = xdL < ydL ? xdL : ydL; i2 < j2; ++i2) {
    if (xd[i2] !== yd[i2])
      return xd[i2] > yd[i2] ^ xs < 0 ? 1 : -1;
  }
  return xdL === ydL ? 0 : xdL > ydL ^ xs < 0 ? 1 : -1;
};
P.cosine = P.cos = function() {
  var pr, rm2, x2 = this, Ctor = x2.constructor;
  if (!x2.d)
    return new Ctor(NaN);
  if (!x2.d[0])
    return new Ctor(1);
  pr = Ctor.precision;
  rm2 = Ctor.rounding;
  Ctor.precision = pr + Math.max(x2.e, x2.sd()) + LOG_BASE;
  Ctor.rounding = 1;
  x2 = cosine(Ctor, toLessThanHalfPi(Ctor, x2));
  Ctor.precision = pr;
  Ctor.rounding = rm2;
  return finalise(quadrant == 2 || quadrant == 3 ? x2.neg() : x2, pr, rm2, true);
};
P.cubeRoot = P.cbrt = function() {
  var e2, m2, n2, r2, rep, s2, sd, t2, t3, t3plusx, x2 = this, Ctor = x2.constructor;
  if (!x2.isFinite() || x2.isZero())
    return new Ctor(x2);
  external = false;
  s2 = x2.s * mathpow(x2.s * x2, 1 / 3);
  if (!s2 || Math.abs(s2) == 1 / 0) {
    n2 = digitsToString(x2.d);
    e2 = x2.e;
    if (s2 = (e2 - n2.length + 1) % 3)
      n2 += s2 == 1 || s2 == -2 ? "0" : "00";
    s2 = mathpow(n2, 1 / 3);
    e2 = mathfloor((e2 + 1) / 3) - (e2 % 3 == (e2 < 0 ? -1 : 2));
    if (s2 == 1 / 0) {
      n2 = "5e" + e2;
    } else {
      n2 = s2.toExponential();
      n2 = n2.slice(0, n2.indexOf("e") + 1) + e2;
    }
    r2 = new Ctor(n2);
    r2.s = x2.s;
  } else {
    r2 = new Ctor(s2.toString());
  }
  sd = (e2 = Ctor.precision) + 3;
  for (; ; ) {
    t2 = r2;
    t3 = t2.times(t2).times(t2);
    t3plusx = t3.plus(x2);
    r2 = divide(t3plusx.plus(x2).times(t2), t3plusx.plus(t3), sd + 2, 1);
    if (digitsToString(t2.d).slice(0, sd) === (n2 = digitsToString(r2.d)).slice(0, sd)) {
      n2 = n2.slice(sd - 3, sd + 1);
      if (n2 == "9999" || !rep && n2 == "4999") {
        if (!rep) {
          finalise(t2, e2 + 1, 0);
          if (t2.times(t2).times(t2).eq(x2)) {
            r2 = t2;
            break;
          }
        }
        sd += 4;
        rep = 1;
      } else {
        if (!+n2 || !+n2.slice(1) && n2.charAt(0) == "5") {
          finalise(r2, e2 + 1, 1);
          m2 = !r2.times(r2).times(r2).eq(x2);
        }
        break;
      }
    }
  }
  external = true;
  return finalise(r2, e2, Ctor.rounding, m2);
};
P.decimalPlaces = P.dp = function() {
  var w2, d2 = this.d, n2 = NaN;
  if (d2) {
    w2 = d2.length - 1;
    n2 = (w2 - mathfloor(this.e / LOG_BASE)) * LOG_BASE;
    w2 = d2[w2];
    if (w2)
      for (; w2 % 10 == 0; w2 /= 10)
        n2--;
    if (n2 < 0)
      n2 = 0;
  }
  return n2;
};
P.dividedBy = P.div = function(y2) {
  return divide(this, new this.constructor(y2));
};
P.dividedToIntegerBy = P.divToInt = function(y2) {
  var x2 = this, Ctor = x2.constructor;
  return finalise(divide(x2, new Ctor(y2), 0, 1, 1), Ctor.precision, Ctor.rounding);
};
P.equals = P.eq = function(y2) {
  return this.cmp(y2) === 0;
};
P.floor = function() {
  return finalise(new this.constructor(this), this.e + 1, 3);
};
P.greaterThan = P.gt = function(y2) {
  return this.cmp(y2) > 0;
};
P.greaterThanOrEqualTo = P.gte = function(y2) {
  var k2 = this.cmp(y2);
  return k2 == 1 || k2 === 0;
};
P.hyperbolicCosine = P.cosh = function() {
  var k2, n2, pr, rm2, len, x2 = this, Ctor = x2.constructor, one = new Ctor(1);
  if (!x2.isFinite())
    return new Ctor(x2.s ? 1 / 0 : NaN);
  if (x2.isZero())
    return one;
  pr = Ctor.precision;
  rm2 = Ctor.rounding;
  Ctor.precision = pr + Math.max(x2.e, x2.sd()) + 4;
  Ctor.rounding = 1;
  len = x2.d.length;
  if (len < 32) {
    k2 = Math.ceil(len / 3);
    n2 = (1 / tinyPow(4, k2)).toString();
  } else {
    k2 = 16;
    n2 = "2.3283064365386962890625e-10";
  }
  x2 = taylorSeries(Ctor, 1, x2.times(n2), new Ctor(1), true);
  var cosh2_x, i2 = k2, d8 = new Ctor(8);
  for (; i2--; ) {
    cosh2_x = x2.times(x2);
    x2 = one.minus(cosh2_x.times(d8.minus(cosh2_x.times(d8))));
  }
  return finalise(x2, Ctor.precision = pr, Ctor.rounding = rm2, true);
};
P.hyperbolicSine = P.sinh = function() {
  var k2, pr, rm2, len, x2 = this, Ctor = x2.constructor;
  if (!x2.isFinite() || x2.isZero())
    return new Ctor(x2);
  pr = Ctor.precision;
  rm2 = Ctor.rounding;
  Ctor.precision = pr + Math.max(x2.e, x2.sd()) + 4;
  Ctor.rounding = 1;
  len = x2.d.length;
  if (len < 3) {
    x2 = taylorSeries(Ctor, 2, x2, x2, true);
  } else {
    k2 = 1.4 * Math.sqrt(len);
    k2 = k2 > 16 ? 16 : k2 | 0;
    x2 = x2.times(1 / tinyPow(5, k2));
    x2 = taylorSeries(Ctor, 2, x2, x2, true);
    var sinh2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
    for (; k2--; ) {
      sinh2_x = x2.times(x2);
      x2 = x2.times(d5.plus(sinh2_x.times(d16.times(sinh2_x).plus(d20))));
    }
  }
  Ctor.precision = pr;
  Ctor.rounding = rm2;
  return finalise(x2, pr, rm2, true);
};
P.hyperbolicTangent = P.tanh = function() {
  var pr, rm2, x2 = this, Ctor = x2.constructor;
  if (!x2.isFinite())
    return new Ctor(x2.s);
  if (x2.isZero())
    return new Ctor(x2);
  pr = Ctor.precision;
  rm2 = Ctor.rounding;
  Ctor.precision = pr + 7;
  Ctor.rounding = 1;
  return divide(x2.sinh(), x2.cosh(), Ctor.precision = pr, Ctor.rounding = rm2);
};
P.inverseCosine = P.acos = function() {
  var halfPi, x2 = this, Ctor = x2.constructor, k2 = x2.abs().cmp(1), pr = Ctor.precision, rm2 = Ctor.rounding;
  if (k2 !== -1) {
    return k2 === 0 ? x2.isNeg() ? getPi(Ctor, pr, rm2) : new Ctor(0) : new Ctor(NaN);
  }
  if (x2.isZero())
    return getPi(Ctor, pr + 4, rm2).times(0.5);
  Ctor.precision = pr + 6;
  Ctor.rounding = 1;
  x2 = x2.asin();
  halfPi = getPi(Ctor, pr + 4, rm2).times(0.5);
  Ctor.precision = pr;
  Ctor.rounding = rm2;
  return halfPi.minus(x2);
};
P.inverseHyperbolicCosine = P.acosh = function() {
  var pr, rm2, x2 = this, Ctor = x2.constructor;
  if (x2.lte(1))
    return new Ctor(x2.eq(1) ? 0 : NaN);
  if (!x2.isFinite())
    return new Ctor(x2);
  pr = Ctor.precision;
  rm2 = Ctor.rounding;
  Ctor.precision = pr + Math.max(Math.abs(x2.e), x2.sd()) + 4;
  Ctor.rounding = 1;
  external = false;
  x2 = x2.times(x2).minus(1).sqrt().plus(x2);
  external = true;
  Ctor.precision = pr;
  Ctor.rounding = rm2;
  return x2.ln();
};
P.inverseHyperbolicSine = P.asinh = function() {
  var pr, rm2, x2 = this, Ctor = x2.constructor;
  if (!x2.isFinite() || x2.isZero())
    return new Ctor(x2);
  pr = Ctor.precision;
  rm2 = Ctor.rounding;
  Ctor.precision = pr + 2 * Math.max(Math.abs(x2.e), x2.sd()) + 6;
  Ctor.rounding = 1;
  external = false;
  x2 = x2.times(x2).plus(1).sqrt().plus(x2);
  external = true;
  Ctor.precision = pr;
  Ctor.rounding = rm2;
  return x2.ln();
};
P.inverseHyperbolicTangent = P.atanh = function() {
  var pr, rm2, wpr, xsd, x2 = this, Ctor = x2.constructor;
  if (!x2.isFinite())
    return new Ctor(NaN);
  if (x2.e >= 0)
    return new Ctor(x2.abs().eq(1) ? x2.s / 0 : x2.isZero() ? x2 : NaN);
  pr = Ctor.precision;
  rm2 = Ctor.rounding;
  xsd = x2.sd();
  if (Math.max(xsd, pr) < 2 * -x2.e - 1)
    return finalise(new Ctor(x2), pr, rm2, true);
  Ctor.precision = wpr = xsd - x2.e;
  x2 = divide(x2.plus(1), new Ctor(1).minus(x2), wpr + pr, 1);
  Ctor.precision = pr + 4;
  Ctor.rounding = 1;
  x2 = x2.ln();
  Ctor.precision = pr;
  Ctor.rounding = rm2;
  return x2.times(0.5);
};
P.inverseSine = P.asin = function() {
  var halfPi, k2, pr, rm2, x2 = this, Ctor = x2.constructor;
  if (x2.isZero())
    return new Ctor(x2);
  k2 = x2.abs().cmp(1);
  pr = Ctor.precision;
  rm2 = Ctor.rounding;
  if (k2 !== -1) {
    if (k2 === 0) {
      halfPi = getPi(Ctor, pr + 4, rm2).times(0.5);
      halfPi.s = x2.s;
      return halfPi;
    }
    return new Ctor(NaN);
  }
  Ctor.precision = pr + 6;
  Ctor.rounding = 1;
  x2 = x2.div(new Ctor(1).minus(x2.times(x2)).sqrt().plus(1)).atan();
  Ctor.precision = pr;
  Ctor.rounding = rm2;
  return x2.times(2);
};
P.inverseTangent = P.atan = function() {
  var i2, j2, k2, n2, px, t2, r2, wpr, x2, x3 = this, Ctor = x3.constructor, pr = Ctor.precision, rm2 = Ctor.rounding;
  if (!x3.isFinite()) {
    if (!x3.s)
      return new Ctor(NaN);
    if (pr + 4 <= PI_PRECISION) {
      r2 = getPi(Ctor, pr + 4, rm2).times(0.5);
      r2.s = x3.s;
      return r2;
    }
  } else if (x3.isZero()) {
    return new Ctor(x3);
  } else if (x3.abs().eq(1) && pr + 4 <= PI_PRECISION) {
    r2 = getPi(Ctor, pr + 4, rm2).times(0.25);
    r2.s = x3.s;
    return r2;
  }
  Ctor.precision = wpr = pr + 10;
  Ctor.rounding = 1;
  k2 = Math.min(28, wpr / LOG_BASE + 2 | 0);
  for (i2 = k2; i2; --i2)
    x3 = x3.div(x3.times(x3).plus(1).sqrt().plus(1));
  external = false;
  j2 = Math.ceil(wpr / LOG_BASE);
  n2 = 1;
  x2 = x3.times(x3);
  r2 = new Ctor(x3);
  px = x3;
  for (; i2 !== -1; ) {
    px = px.times(x2);
    t2 = r2.minus(px.div(n2 += 2));
    px = px.times(x2);
    r2 = t2.plus(px.div(n2 += 2));
    if (r2.d[j2] !== void 0)
      for (i2 = j2; r2.d[i2] === t2.d[i2] && i2--; )
        ;
  }
  if (k2)
    r2 = r2.times(2 << k2 - 1);
  external = true;
  return finalise(r2, Ctor.precision = pr, Ctor.rounding = rm2, true);
};
P.isFinite = function() {
  return !!this.d;
};
P.isInteger = P.isInt = function() {
  return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
};
P.isNaN = function() {
  return !this.s;
};
P.isNegative = P.isNeg = function() {
  return this.s < 0;
};
P.isPositive = P.isPos = function() {
  return this.s > 0;
};
P.isZero = function() {
  return !!this.d && this.d[0] === 0;
};
P.lessThan = P.lt = function(y2) {
  return this.cmp(y2) < 0;
};
P.lessThanOrEqualTo = P.lte = function(y2) {
  return this.cmp(y2) < 1;
};
P.logarithm = P.log = function(base) {
  var isBase10, d2, denominator, k2, inf, num, sd, r2, arg = this, Ctor = arg.constructor, pr = Ctor.precision, rm2 = Ctor.rounding, guard = 5;
  if (base == null) {
    base = new Ctor(10);
    isBase10 = true;
  } else {
    base = new Ctor(base);
    d2 = base.d;
    if (base.s < 0 || !d2 || !d2[0] || base.eq(1))
      return new Ctor(NaN);
    isBase10 = base.eq(10);
  }
  d2 = arg.d;
  if (arg.s < 0 || !d2 || !d2[0] || arg.eq(1)) {
    return new Ctor(d2 && !d2[0] ? -1 / 0 : arg.s != 1 ? NaN : d2 ? 0 : 1 / 0);
  }
  if (isBase10) {
    if (d2.length > 1) {
      inf = true;
    } else {
      for (k2 = d2[0]; k2 % 10 === 0; )
        k2 /= 10;
      inf = k2 !== 1;
    }
  }
  external = false;
  sd = pr + guard;
  num = naturalLogarithm(arg, sd);
  denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
  r2 = divide(num, denominator, sd, 1);
  if (checkRoundingDigits(r2.d, k2 = pr, rm2)) {
    do {
      sd += 10;
      num = naturalLogarithm(arg, sd);
      denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
      r2 = divide(num, denominator, sd, 1);
      if (!inf) {
        if (+digitsToString(r2.d).slice(k2 + 1, k2 + 15) + 1 == 1e14) {
          r2 = finalise(r2, pr + 1, 0);
        }
        break;
      }
    } while (checkRoundingDigits(r2.d, k2 += 10, rm2));
  }
  external = true;
  return finalise(r2, pr, rm2);
};
P.minus = P.sub = function(y2) {
  var d2, e2, i2, j2, k2, len, pr, rm2, xd, xe2, xLTy, yd, x2 = this, Ctor = x2.constructor;
  y2 = new Ctor(y2);
  if (!x2.d || !y2.d) {
    if (!x2.s || !y2.s)
      y2 = new Ctor(NaN);
    else if (x2.d)
      y2.s = -y2.s;
    else
      y2 = new Ctor(y2.d || x2.s !== y2.s ? x2 : NaN);
    return y2;
  }
  if (x2.s != y2.s) {
    y2.s = -y2.s;
    return x2.plus(y2);
  }
  xd = x2.d;
  yd = y2.d;
  pr = Ctor.precision;
  rm2 = Ctor.rounding;
  if (!xd[0] || !yd[0]) {
    if (yd[0])
      y2.s = -y2.s;
    else if (xd[0])
      y2 = new Ctor(x2);
    else
      return new Ctor(rm2 === 3 ? -0 : 0);
    return external ? finalise(y2, pr, rm2) : y2;
  }
  e2 = mathfloor(y2.e / LOG_BASE);
  xe2 = mathfloor(x2.e / LOG_BASE);
  xd = xd.slice();
  k2 = xe2 - e2;
  if (k2) {
    xLTy = k2 < 0;
    if (xLTy) {
      d2 = xd;
      k2 = -k2;
      len = yd.length;
    } else {
      d2 = yd;
      e2 = xe2;
      len = xd.length;
    }
    i2 = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
    if (k2 > i2) {
      k2 = i2;
      d2.length = 1;
    }
    d2.reverse();
    for (i2 = k2; i2--; )
      d2.push(0);
    d2.reverse();
  } else {
    i2 = xd.length;
    len = yd.length;
    xLTy = i2 < len;
    if (xLTy)
      len = i2;
    for (i2 = 0; i2 < len; i2++) {
      if (xd[i2] != yd[i2]) {
        xLTy = xd[i2] < yd[i2];
        break;
      }
    }
    k2 = 0;
  }
  if (xLTy) {
    d2 = xd;
    xd = yd;
    yd = d2;
    y2.s = -y2.s;
  }
  len = xd.length;
  for (i2 = yd.length - len; i2 > 0; --i2)
    xd[len++] = 0;
  for (i2 = yd.length; i2 > k2; ) {
    if (xd[--i2] < yd[i2]) {
      for (j2 = i2; j2 && xd[--j2] === 0; )
        xd[j2] = BASE - 1;
      --xd[j2];
      xd[i2] += BASE;
    }
    xd[i2] -= yd[i2];
  }
  for (; xd[--len] === 0; )
    xd.pop();
  for (; xd[0] === 0; xd.shift())
    --e2;
  if (!xd[0])
    return new Ctor(rm2 === 3 ? -0 : 0);
  y2.d = xd;
  y2.e = getBase10Exponent(xd, e2);
  return external ? finalise(y2, pr, rm2) : y2;
};
P.modulo = P.mod = function(y2) {
  var q, x2 = this, Ctor = x2.constructor;
  y2 = new Ctor(y2);
  if (!x2.d || !y2.s || y2.d && !y2.d[0])
    return new Ctor(NaN);
  if (!y2.d || x2.d && !x2.d[0]) {
    return finalise(new Ctor(x2), Ctor.precision, Ctor.rounding);
  }
  external = false;
  if (Ctor.modulo == 9) {
    q = divide(x2, y2.abs(), 0, 3, 1);
    q.s *= y2.s;
  } else {
    q = divide(x2, y2, 0, Ctor.modulo, 1);
  }
  q = q.times(y2);
  external = true;
  return x2.minus(q);
};
P.naturalExponential = P.exp = function() {
  return naturalExponential(this);
};
P.naturalLogarithm = P.ln = function() {
  return naturalLogarithm(this);
};
P.negated = P.neg = function() {
  var x2 = new this.constructor(this);
  x2.s = -x2.s;
  return finalise(x2);
};
P.plus = P.add = function(y2) {
  var carry, d2, e2, i2, k2, len, pr, rm2, xd, yd, x2 = this, Ctor = x2.constructor;
  y2 = new Ctor(y2);
  if (!x2.d || !y2.d) {
    if (!x2.s || !y2.s)
      y2 = new Ctor(NaN);
    else if (!x2.d)
      y2 = new Ctor(y2.d || x2.s === y2.s ? x2 : NaN);
    return y2;
  }
  if (x2.s != y2.s) {
    y2.s = -y2.s;
    return x2.minus(y2);
  }
  xd = x2.d;
  yd = y2.d;
  pr = Ctor.precision;
  rm2 = Ctor.rounding;
  if (!xd[0] || !yd[0]) {
    if (!yd[0])
      y2 = new Ctor(x2);
    return external ? finalise(y2, pr, rm2) : y2;
  }
  k2 = mathfloor(x2.e / LOG_BASE);
  e2 = mathfloor(y2.e / LOG_BASE);
  xd = xd.slice();
  i2 = k2 - e2;
  if (i2) {
    if (i2 < 0) {
      d2 = xd;
      i2 = -i2;
      len = yd.length;
    } else {
      d2 = yd;
      e2 = k2;
      len = xd.length;
    }
    k2 = Math.ceil(pr / LOG_BASE);
    len = k2 > len ? k2 + 1 : len + 1;
    if (i2 > len) {
      i2 = len;
      d2.length = 1;
    }
    d2.reverse();
    for (; i2--; )
      d2.push(0);
    d2.reverse();
  }
  len = xd.length;
  i2 = yd.length;
  if (len - i2 < 0) {
    i2 = len;
    d2 = yd;
    yd = xd;
    xd = d2;
  }
  for (carry = 0; i2; ) {
    carry = (xd[--i2] = xd[i2] + yd[i2] + carry) / BASE | 0;
    xd[i2] %= BASE;
  }
  if (carry) {
    xd.unshift(carry);
    ++e2;
  }
  for (len = xd.length; xd[--len] == 0; )
    xd.pop();
  y2.d = xd;
  y2.e = getBase10Exponent(xd, e2);
  return external ? finalise(y2, pr, rm2) : y2;
};
P.precision = P.sd = function(z2) {
  var k2, x2 = this;
  if (z2 !== void 0 && z2 !== !!z2 && z2 !== 1 && z2 !== 0)
    throw Error(invalidArgument + z2);
  if (x2.d) {
    k2 = getPrecision(x2.d);
    if (z2 && x2.e + 1 > k2)
      k2 = x2.e + 1;
  } else {
    k2 = NaN;
  }
  return k2;
};
P.round = function() {
  var x2 = this, Ctor = x2.constructor;
  return finalise(new Ctor(x2), x2.e + 1, Ctor.rounding);
};
P.sine = P.sin = function() {
  var pr, rm2, x2 = this, Ctor = x2.constructor;
  if (!x2.isFinite())
    return new Ctor(NaN);
  if (x2.isZero())
    return new Ctor(x2);
  pr = Ctor.precision;
  rm2 = Ctor.rounding;
  Ctor.precision = pr + Math.max(x2.e, x2.sd()) + LOG_BASE;
  Ctor.rounding = 1;
  x2 = sine(Ctor, toLessThanHalfPi(Ctor, x2));
  Ctor.precision = pr;
  Ctor.rounding = rm2;
  return finalise(quadrant > 2 ? x2.neg() : x2, pr, rm2, true);
};
P.squareRoot = P.sqrt = function() {
  var m2, n2, sd, r2, rep, t2, x2 = this, d2 = x2.d, e2 = x2.e, s2 = x2.s, Ctor = x2.constructor;
  if (s2 !== 1 || !d2 || !d2[0]) {
    return new Ctor(!s2 || s2 < 0 && (!d2 || d2[0]) ? NaN : d2 ? x2 : 1 / 0);
  }
  external = false;
  s2 = Math.sqrt(+x2);
  if (s2 == 0 || s2 == 1 / 0) {
    n2 = digitsToString(d2);
    if ((n2.length + e2) % 2 == 0)
      n2 += "0";
    s2 = Math.sqrt(n2);
    e2 = mathfloor((e2 + 1) / 2) - (e2 < 0 || e2 % 2);
    if (s2 == 1 / 0) {
      n2 = "5e" + e2;
    } else {
      n2 = s2.toExponential();
      n2 = n2.slice(0, n2.indexOf("e") + 1) + e2;
    }
    r2 = new Ctor(n2);
  } else {
    r2 = new Ctor(s2.toString());
  }
  sd = (e2 = Ctor.precision) + 3;
  for (; ; ) {
    t2 = r2;
    r2 = t2.plus(divide(x2, t2, sd + 2, 1)).times(0.5);
    if (digitsToString(t2.d).slice(0, sd) === (n2 = digitsToString(r2.d)).slice(0, sd)) {
      n2 = n2.slice(sd - 3, sd + 1);
      if (n2 == "9999" || !rep && n2 == "4999") {
        if (!rep) {
          finalise(t2, e2 + 1, 0);
          if (t2.times(t2).eq(x2)) {
            r2 = t2;
            break;
          }
        }
        sd += 4;
        rep = 1;
      } else {
        if (!+n2 || !+n2.slice(1) && n2.charAt(0) == "5") {
          finalise(r2, e2 + 1, 1);
          m2 = !r2.times(r2).eq(x2);
        }
        break;
      }
    }
  }
  external = true;
  return finalise(r2, e2, Ctor.rounding, m2);
};
P.tangent = P.tan = function() {
  var pr, rm2, x2 = this, Ctor = x2.constructor;
  if (!x2.isFinite())
    return new Ctor(NaN);
  if (x2.isZero())
    return new Ctor(x2);
  pr = Ctor.precision;
  rm2 = Ctor.rounding;
  Ctor.precision = pr + 10;
  Ctor.rounding = 1;
  x2 = x2.sin();
  x2.s = 1;
  x2 = divide(x2, new Ctor(1).minus(x2.times(x2)).sqrt(), pr + 10, 0);
  Ctor.precision = pr;
  Ctor.rounding = rm2;
  return finalise(quadrant == 2 || quadrant == 4 ? x2.neg() : x2, pr, rm2, true);
};
P.times = P.mul = function(y2) {
  var carry, e2, i2, k2, r2, rL, t2, xdL, ydL, x2 = this, Ctor = x2.constructor, xd = x2.d, yd = (y2 = new Ctor(y2)).d;
  y2.s *= x2.s;
  if (!xd || !xd[0] || !yd || !yd[0]) {
    return new Ctor(!y2.s || xd && !xd[0] && !yd || yd && !yd[0] && !xd ? NaN : !xd || !yd ? y2.s / 0 : y2.s * 0);
  }
  e2 = mathfloor(x2.e / LOG_BASE) + mathfloor(y2.e / LOG_BASE);
  xdL = xd.length;
  ydL = yd.length;
  if (xdL < ydL) {
    r2 = xd;
    xd = yd;
    yd = r2;
    rL = xdL;
    xdL = ydL;
    ydL = rL;
  }
  r2 = [];
  rL = xdL + ydL;
  for (i2 = rL; i2--; )
    r2.push(0);
  for (i2 = ydL; --i2 >= 0; ) {
    carry = 0;
    for (k2 = xdL + i2; k2 > i2; ) {
      t2 = r2[k2] + yd[i2] * xd[k2 - i2 - 1] + carry;
      r2[k2--] = t2 % BASE | 0;
      carry = t2 / BASE | 0;
    }
    r2[k2] = (r2[k2] + carry) % BASE | 0;
  }
  for (; !r2[--rL]; )
    r2.pop();
  if (carry)
    ++e2;
  else
    r2.shift();
  y2.d = r2;
  y2.e = getBase10Exponent(r2, e2);
  return external ? finalise(y2, Ctor.precision, Ctor.rounding) : y2;
};
P.toBinary = function(sd, rm2) {
  return toStringBinary(this, 2, sd, rm2);
};
P.toDecimalPlaces = P.toDP = function(dp, rm2) {
  var x2 = this, Ctor = x2.constructor;
  x2 = new Ctor(x2);
  if (dp === void 0)
    return x2;
  checkInt32(dp, 0, MAX_DIGITS);
  if (rm2 === void 0)
    rm2 = Ctor.rounding;
  else
    checkInt32(rm2, 0, 8);
  return finalise(x2, dp + x2.e + 1, rm2);
};
P.toExponential = function(dp, rm2) {
  var str, x2 = this, Ctor = x2.constructor;
  if (dp === void 0) {
    str = finiteToString(x2, true);
  } else {
    checkInt32(dp, 0, MAX_DIGITS);
    if (rm2 === void 0)
      rm2 = Ctor.rounding;
    else
      checkInt32(rm2, 0, 8);
    x2 = finalise(new Ctor(x2), dp + 1, rm2);
    str = finiteToString(x2, true, dp + 1);
  }
  return x2.isNeg() && !x2.isZero() ? "-" + str : str;
};
P.toFixed = function(dp, rm2) {
  var str, y2, x2 = this, Ctor = x2.constructor;
  if (dp === void 0) {
    str = finiteToString(x2);
  } else {
    checkInt32(dp, 0, MAX_DIGITS);
    if (rm2 === void 0)
      rm2 = Ctor.rounding;
    else
      checkInt32(rm2, 0, 8);
    y2 = finalise(new Ctor(x2), dp + x2.e + 1, rm2);
    str = finiteToString(y2, false, dp + y2.e + 1);
  }
  return x2.isNeg() && !x2.isZero() ? "-" + str : str;
};
P.toFraction = function(maxD) {
  var d2, d0, d1, d22, e2, k2, n2, n0, n1, pr, q, r2, x2 = this, xd = x2.d, Ctor = x2.constructor;
  if (!xd)
    return new Ctor(x2);
  n1 = d0 = new Ctor(1);
  d1 = n0 = new Ctor(0);
  d2 = new Ctor(d1);
  e2 = d2.e = getPrecision(xd) - x2.e - 1;
  k2 = e2 % LOG_BASE;
  d2.d[0] = mathpow(10, k2 < 0 ? LOG_BASE + k2 : k2);
  if (maxD == null) {
    maxD = e2 > 0 ? d2 : n1;
  } else {
    n2 = new Ctor(maxD);
    if (!n2.isInt() || n2.lt(n1))
      throw Error(invalidArgument + n2);
    maxD = n2.gt(d2) ? e2 > 0 ? d2 : n1 : n2;
  }
  external = false;
  n2 = new Ctor(digitsToString(xd));
  pr = Ctor.precision;
  Ctor.precision = e2 = xd.length * LOG_BASE * 2;
  for (; ; ) {
    q = divide(n2, d2, 0, 1, 1);
    d22 = d0.plus(q.times(d1));
    if (d22.cmp(maxD) == 1)
      break;
    d0 = d1;
    d1 = d22;
    d22 = n1;
    n1 = n0.plus(q.times(d22));
    n0 = d22;
    d22 = d2;
    d2 = n2.minus(q.times(d22));
    n2 = d22;
  }
  d22 = divide(maxD.minus(d0), d1, 0, 1, 1);
  n0 = n0.plus(d22.times(n1));
  d0 = d0.plus(d22.times(d1));
  n0.s = n1.s = x2.s;
  r2 = divide(n1, d1, e2, 1).minus(x2).abs().cmp(divide(n0, d0, e2, 1).minus(x2).abs()) < 1 ? [n1, d1] : [n0, d0];
  Ctor.precision = pr;
  external = true;
  return r2;
};
P.toHexadecimal = P.toHex = function(sd, rm2) {
  return toStringBinary(this, 16, sd, rm2);
};
P.toNearest = function(y2, rm2) {
  var x2 = this, Ctor = x2.constructor;
  x2 = new Ctor(x2);
  if (y2 == null) {
    if (!x2.d)
      return x2;
    y2 = new Ctor(1);
    rm2 = Ctor.rounding;
  } else {
    y2 = new Ctor(y2);
    if (rm2 === void 0) {
      rm2 = Ctor.rounding;
    } else {
      checkInt32(rm2, 0, 8);
    }
    if (!x2.d)
      return y2.s ? x2 : y2;
    if (!y2.d) {
      if (y2.s)
        y2.s = x2.s;
      return y2;
    }
  }
  if (y2.d[0]) {
    external = false;
    x2 = divide(x2, y2, 0, rm2, 1).times(y2);
    external = true;
    finalise(x2);
  } else {
    y2.s = x2.s;
    x2 = y2;
  }
  return x2;
};
P.toNumber = function() {
  return +this;
};
P.toOctal = function(sd, rm2) {
  return toStringBinary(this, 8, sd, rm2);
};
P.toPower = P.pow = function(y2) {
  var e2, k2, pr, r2, rm2, s2, x2 = this, Ctor = x2.constructor, yn = +(y2 = new Ctor(y2));
  if (!x2.d || !y2.d || !x2.d[0] || !y2.d[0])
    return new Ctor(mathpow(+x2, yn));
  x2 = new Ctor(x2);
  if (x2.eq(1))
    return x2;
  pr = Ctor.precision;
  rm2 = Ctor.rounding;
  if (y2.eq(1))
    return finalise(x2, pr, rm2);
  e2 = mathfloor(y2.e / LOG_BASE);
  if (e2 >= y2.d.length - 1 && (k2 = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
    r2 = intPow(Ctor, x2, k2, pr);
    return y2.s < 0 ? new Ctor(1).div(r2) : finalise(r2, pr, rm2);
  }
  s2 = x2.s;
  if (s2 < 0) {
    if (e2 < y2.d.length - 1)
      return new Ctor(NaN);
    if ((y2.d[e2] & 1) == 0)
      s2 = 1;
    if (x2.e == 0 && x2.d[0] == 1 && x2.d.length == 1) {
      x2.s = s2;
      return x2;
    }
  }
  k2 = mathpow(+x2, yn);
  e2 = k2 == 0 || !isFinite(k2) ? mathfloor(yn * (Math.log("0." + digitsToString(x2.d)) / Math.LN10 + x2.e + 1)) : new Ctor(k2 + "").e;
  if (e2 > Ctor.maxE + 1 || e2 < Ctor.minE - 1)
    return new Ctor(e2 > 0 ? s2 / 0 : 0);
  external = false;
  Ctor.rounding = x2.s = 1;
  k2 = Math.min(12, (e2 + "").length);
  r2 = naturalExponential(y2.times(naturalLogarithm(x2, pr + k2)), pr);
  if (r2.d) {
    r2 = finalise(r2, pr + 5, 1);
    if (checkRoundingDigits(r2.d, pr, rm2)) {
      e2 = pr + 10;
      r2 = finalise(naturalExponential(y2.times(naturalLogarithm(x2, e2 + k2)), e2), e2 + 5, 1);
      if (+digitsToString(r2.d).slice(pr + 1, pr + 15) + 1 == 1e14) {
        r2 = finalise(r2, pr + 1, 0);
      }
    }
  }
  r2.s = s2;
  external = true;
  Ctor.rounding = rm2;
  return finalise(r2, pr, rm2);
};
P.toPrecision = function(sd, rm2) {
  var str, x2 = this, Ctor = x2.constructor;
  if (sd === void 0) {
    str = finiteToString(x2, x2.e <= Ctor.toExpNeg || x2.e >= Ctor.toExpPos);
  } else {
    checkInt32(sd, 1, MAX_DIGITS);
    if (rm2 === void 0)
      rm2 = Ctor.rounding;
    else
      checkInt32(rm2, 0, 8);
    x2 = finalise(new Ctor(x2), sd, rm2);
    str = finiteToString(x2, sd <= x2.e || x2.e <= Ctor.toExpNeg, sd);
  }
  return x2.isNeg() && !x2.isZero() ? "-" + str : str;
};
P.toSignificantDigits = P.toSD = function(sd, rm2) {
  var x2 = this, Ctor = x2.constructor;
  if (sd === void 0) {
    sd = Ctor.precision;
    rm2 = Ctor.rounding;
  } else {
    checkInt32(sd, 1, MAX_DIGITS);
    if (rm2 === void 0)
      rm2 = Ctor.rounding;
    else
      checkInt32(rm2, 0, 8);
  }
  return finalise(new Ctor(x2), sd, rm2);
};
P.toString = function() {
  var x2 = this, Ctor = x2.constructor, str = finiteToString(x2, x2.e <= Ctor.toExpNeg || x2.e >= Ctor.toExpPos);
  return x2.isNeg() && !x2.isZero() ? "-" + str : str;
};
P.truncated = P.trunc = function() {
  return finalise(new this.constructor(this), this.e + 1, 1);
};
P.valueOf = P.toJSON = function() {
  var x2 = this, Ctor = x2.constructor, str = finiteToString(x2, x2.e <= Ctor.toExpNeg || x2.e >= Ctor.toExpPos);
  return x2.isNeg() ? "-" + str : str;
};
function digitsToString(d2) {
  var i2, k2, ws, indexOfLastWord = d2.length - 1, str = "", w2 = d2[0];
  if (indexOfLastWord > 0) {
    str += w2;
    for (i2 = 1; i2 < indexOfLastWord; i2++) {
      ws = d2[i2] + "";
      k2 = LOG_BASE - ws.length;
      if (k2)
        str += getZeroString(k2);
      str += ws;
    }
    w2 = d2[i2];
    ws = w2 + "";
    k2 = LOG_BASE - ws.length;
    if (k2)
      str += getZeroString(k2);
  } else if (w2 === 0) {
    return "0";
  }
  for (; w2 % 10 === 0; )
    w2 /= 10;
  return str + w2;
}
function checkInt32(i2, min2, max2) {
  if (i2 !== ~~i2 || i2 < min2 || i2 > max2) {
    throw Error(invalidArgument + i2);
  }
}
function checkRoundingDigits(d2, i2, rm2, repeating) {
  var di, k2, r2, rd;
  for (k2 = d2[0]; k2 >= 10; k2 /= 10)
    --i2;
  if (--i2 < 0) {
    i2 += LOG_BASE;
    di = 0;
  } else {
    di = Math.ceil((i2 + 1) / LOG_BASE);
    i2 %= LOG_BASE;
  }
  k2 = mathpow(10, LOG_BASE - i2);
  rd = d2[di] % k2 | 0;
  if (repeating == null) {
    if (i2 < 3) {
      if (i2 == 0)
        rd = rd / 100 | 0;
      else if (i2 == 1)
        rd = rd / 10 | 0;
      r2 = rm2 < 4 && rd == 99999 || rm2 > 3 && rd == 49999 || rd == 5e4 || rd == 0;
    } else {
      r2 = (rm2 < 4 && rd + 1 == k2 || rm2 > 3 && rd + 1 == k2 / 2) && (d2[di + 1] / k2 / 100 | 0) == mathpow(10, i2 - 2) - 1 || (rd == k2 / 2 || rd == 0) && (d2[di + 1] / k2 / 100 | 0) == 0;
    }
  } else {
    if (i2 < 4) {
      if (i2 == 0)
        rd = rd / 1e3 | 0;
      else if (i2 == 1)
        rd = rd / 100 | 0;
      else if (i2 == 2)
        rd = rd / 10 | 0;
      r2 = (repeating || rm2 < 4) && rd == 9999 || !repeating && rm2 > 3 && rd == 4999;
    } else {
      r2 = ((repeating || rm2 < 4) && rd + 1 == k2 || !repeating && rm2 > 3 && rd + 1 == k2 / 2) && (d2[di + 1] / k2 / 1e3 | 0) == mathpow(10, i2 - 3) - 1;
    }
  }
  return r2;
}
function convertBase(str, baseIn, baseOut) {
  var j2, arr2 = [0], arrL, i2 = 0, strL = str.length;
  for (; i2 < strL; ) {
    for (arrL = arr2.length; arrL--; )
      arr2[arrL] *= baseIn;
    arr2[0] += NUMERALS.indexOf(str.charAt(i2++));
    for (j2 = 0; j2 < arr2.length; j2++) {
      if (arr2[j2] > baseOut - 1) {
        if (arr2[j2 + 1] === void 0)
          arr2[j2 + 1] = 0;
        arr2[j2 + 1] += arr2[j2] / baseOut | 0;
        arr2[j2] %= baseOut;
      }
    }
  }
  return arr2.reverse();
}
function cosine(Ctor, x2) {
  var k2, len, y2;
  if (x2.isZero())
    return x2;
  len = x2.d.length;
  if (len < 32) {
    k2 = Math.ceil(len / 3);
    y2 = (1 / tinyPow(4, k2)).toString();
  } else {
    k2 = 16;
    y2 = "2.3283064365386962890625e-10";
  }
  Ctor.precision += k2;
  x2 = taylorSeries(Ctor, 1, x2.times(y2), new Ctor(1));
  for (var i2 = k2; i2--; ) {
    var cos2x = x2.times(x2);
    x2 = cos2x.times(cos2x).minus(cos2x).times(8).plus(1);
  }
  Ctor.precision -= k2;
  return x2;
}
var divide = function() {
  function multiplyInteger(x2, k2, base) {
    var temp, carry = 0, i2 = x2.length;
    for (x2 = x2.slice(); i2--; ) {
      temp = x2[i2] * k2 + carry;
      x2[i2] = temp % base | 0;
      carry = temp / base | 0;
    }
    if (carry)
      x2.unshift(carry);
    return x2;
  }
  function compare(a2, b, aL, bL) {
    var i2, r2;
    if (aL != bL) {
      r2 = aL > bL ? 1 : -1;
    } else {
      for (i2 = r2 = 0; i2 < aL; i2++) {
        if (a2[i2] != b[i2]) {
          r2 = a2[i2] > b[i2] ? 1 : -1;
          break;
        }
      }
    }
    return r2;
  }
  function subtract(a2, b, aL, base) {
    var i2 = 0;
    for (; aL--; ) {
      a2[aL] -= i2;
      i2 = a2[aL] < b[aL] ? 1 : 0;
      a2[aL] = i2 * base + a2[aL] - b[aL];
    }
    for (; !a2[0] && a2.length > 1; )
      a2.shift();
  }
  return function(x2, y2, pr, rm2, dp, base) {
    var cmp, e2, i2, k2, logBase, more, prod, prodL, q, qd, rem, remL, rem0, sd, t2, xi, xL, yd0, yL, yz, Ctor = x2.constructor, sign2 = x2.s == y2.s ? 1 : -1, xd = x2.d, yd = y2.d;
    if (!xd || !xd[0] || !yd || !yd[0]) {
      return new Ctor(
        // Return NaN if either NaN, or both Infinity or 0.
        !x2.s || !y2.s || (xd ? yd && xd[0] == yd[0] : !yd) ? NaN : (
          // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
          xd && xd[0] == 0 || !yd ? sign2 * 0 : sign2 / 0
        )
      );
    }
    if (base) {
      logBase = 1;
      e2 = x2.e - y2.e;
    } else {
      base = BASE;
      logBase = LOG_BASE;
      e2 = mathfloor(x2.e / logBase) - mathfloor(y2.e / logBase);
    }
    yL = yd.length;
    xL = xd.length;
    q = new Ctor(sign2);
    qd = q.d = [];
    for (i2 = 0; yd[i2] == (xd[i2] || 0); i2++)
      ;
    if (yd[i2] > (xd[i2] || 0))
      e2--;
    if (pr == null) {
      sd = pr = Ctor.precision;
      rm2 = Ctor.rounding;
    } else if (dp) {
      sd = pr + (x2.e - y2.e) + 1;
    } else {
      sd = pr;
    }
    if (sd < 0) {
      qd.push(1);
      more = true;
    } else {
      sd = sd / logBase + 2 | 0;
      i2 = 0;
      if (yL == 1) {
        k2 = 0;
        yd = yd[0];
        sd++;
        for (; (i2 < xL || k2) && sd--; i2++) {
          t2 = k2 * base + (xd[i2] || 0);
          qd[i2] = t2 / yd | 0;
          k2 = t2 % yd | 0;
        }
        more = k2 || i2 < xL;
      } else {
        k2 = base / (yd[0] + 1) | 0;
        if (k2 > 1) {
          yd = multiplyInteger(yd, k2, base);
          xd = multiplyInteger(xd, k2, base);
          yL = yd.length;
          xL = xd.length;
        }
        xi = yL;
        rem = xd.slice(0, yL);
        remL = rem.length;
        for (; remL < yL; )
          rem[remL++] = 0;
        yz = yd.slice();
        yz.unshift(0);
        yd0 = yd[0];
        if (yd[1] >= base / 2)
          ++yd0;
        do {
          k2 = 0;
          cmp = compare(yd, rem, yL, remL);
          if (cmp < 0) {
            rem0 = rem[0];
            if (yL != remL)
              rem0 = rem0 * base + (rem[1] || 0);
            k2 = rem0 / yd0 | 0;
            if (k2 > 1) {
              if (k2 >= base)
                k2 = base - 1;
              prod = multiplyInteger(yd, k2, base);
              prodL = prod.length;
              remL = rem.length;
              cmp = compare(prod, rem, prodL, remL);
              if (cmp == 1) {
                k2--;
                subtract(prod, yL < prodL ? yz : yd, prodL, base);
              }
            } else {
              if (k2 == 0)
                cmp = k2 = 1;
              prod = yd.slice();
            }
            prodL = prod.length;
            if (prodL < remL)
              prod.unshift(0);
            subtract(rem, prod, remL, base);
            if (cmp == -1) {
              remL = rem.length;
              cmp = compare(yd, rem, yL, remL);
              if (cmp < 1) {
                k2++;
                subtract(rem, yL < remL ? yz : yd, remL, base);
              }
            }
            remL = rem.length;
          } else if (cmp === 0) {
            k2++;
            rem = [0];
          }
          qd[i2++] = k2;
          if (cmp && rem[0]) {
            rem[remL++] = xd[xi] || 0;
          } else {
            rem = [xd[xi]];
            remL = 1;
          }
        } while ((xi++ < xL || rem[0] !== void 0) && sd--);
        more = rem[0] !== void 0;
      }
      if (!qd[0])
        qd.shift();
    }
    if (logBase == 1) {
      q.e = e2;
      inexact = more;
    } else {
      for (i2 = 1, k2 = qd[0]; k2 >= 10; k2 /= 10)
        i2++;
      q.e = i2 + e2 * logBase - 1;
      finalise(q, dp ? pr + q.e + 1 : pr, rm2, more);
    }
    return q;
  };
}();
function finalise(x2, sd, rm2, isTruncated) {
  var digits, i2, j2, k2, rd, roundUp, w2, xd, xdi, Ctor = x2.constructor;
  out:
    if (sd != null) {
      xd = x2.d;
      if (!xd)
        return x2;
      for (digits = 1, k2 = xd[0]; k2 >= 10; k2 /= 10)
        digits++;
      i2 = sd - digits;
      if (i2 < 0) {
        i2 += LOG_BASE;
        j2 = sd;
        w2 = xd[xdi = 0];
        rd = w2 / mathpow(10, digits - j2 - 1) % 10 | 0;
      } else {
        xdi = Math.ceil((i2 + 1) / LOG_BASE);
        k2 = xd.length;
        if (xdi >= k2) {
          if (isTruncated) {
            for (; k2++ <= xdi; )
              xd.push(0);
            w2 = rd = 0;
            digits = 1;
            i2 %= LOG_BASE;
            j2 = i2 - LOG_BASE + 1;
          } else {
            break out;
          }
        } else {
          w2 = k2 = xd[xdi];
          for (digits = 1; k2 >= 10; k2 /= 10)
            digits++;
          i2 %= LOG_BASE;
          j2 = i2 - LOG_BASE + digits;
          rd = j2 < 0 ? 0 : w2 / mathpow(10, digits - j2 - 1) % 10 | 0;
        }
      }
      isTruncated = isTruncated || sd < 0 || xd[xdi + 1] !== void 0 || (j2 < 0 ? w2 : w2 % mathpow(10, digits - j2 - 1));
      roundUp = rm2 < 4 ? (rd || isTruncated) && (rm2 == 0 || rm2 == (x2.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm2 == 4 || isTruncated || rm2 == 6 && // Check whether the digit to the left of the rounding digit is odd.
      (i2 > 0 ? j2 > 0 ? w2 / mathpow(10, digits - j2) : 0 : xd[xdi - 1]) % 10 & 1 || rm2 == (x2.s < 0 ? 8 : 7));
      if (sd < 1 || !xd[0]) {
        xd.length = 0;
        if (roundUp) {
          sd -= x2.e + 1;
          xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
          x2.e = -sd || 0;
        } else {
          xd[0] = x2.e = 0;
        }
        return x2;
      }
      if (i2 == 0) {
        xd.length = xdi;
        k2 = 1;
        xdi--;
      } else {
        xd.length = xdi + 1;
        k2 = mathpow(10, LOG_BASE - i2);
        xd[xdi] = j2 > 0 ? (w2 / mathpow(10, digits - j2) % mathpow(10, j2) | 0) * k2 : 0;
      }
      if (roundUp) {
        for (; ; ) {
          if (xdi == 0) {
            for (i2 = 1, j2 = xd[0]; j2 >= 10; j2 /= 10)
              i2++;
            j2 = xd[0] += k2;
            for (k2 = 1; j2 >= 10; j2 /= 10)
              k2++;
            if (i2 != k2) {
              x2.e++;
              if (xd[0] == BASE)
                xd[0] = 1;
            }
            break;
          } else {
            xd[xdi] += k2;
            if (xd[xdi] != BASE)
              break;
            xd[xdi--] = 0;
            k2 = 1;
          }
        }
      }
      for (i2 = xd.length; xd[--i2] === 0; )
        xd.pop();
    }
  if (external) {
    if (x2.e > Ctor.maxE) {
      x2.d = null;
      x2.e = NaN;
    } else if (x2.e < Ctor.minE) {
      x2.e = 0;
      x2.d = [0];
    }
  }
  return x2;
}
function finiteToString(x2, isExp, sd) {
  if (!x2.isFinite())
    return nonFiniteToString(x2);
  var k2, e2 = x2.e, str = digitsToString(x2.d), len = str.length;
  if (isExp) {
    if (sd && (k2 = sd - len) > 0) {
      str = str.charAt(0) + "." + str.slice(1) + getZeroString(k2);
    } else if (len > 1) {
      str = str.charAt(0) + "." + str.slice(1);
    }
    str = str + (x2.e < 0 ? "e" : "e+") + x2.e;
  } else if (e2 < 0) {
    str = "0." + getZeroString(-e2 - 1) + str;
    if (sd && (k2 = sd - len) > 0)
      str += getZeroString(k2);
  } else if (e2 >= len) {
    str += getZeroString(e2 + 1 - len);
    if (sd && (k2 = sd - e2 - 1) > 0)
      str = str + "." + getZeroString(k2);
  } else {
    if ((k2 = e2 + 1) < len)
      str = str.slice(0, k2) + "." + str.slice(k2);
    if (sd && (k2 = sd - len) > 0) {
      if (e2 + 1 === len)
        str += ".";
      str += getZeroString(k2);
    }
  }
  return str;
}
function getBase10Exponent(digits, e2) {
  var w2 = digits[0];
  for (e2 *= LOG_BASE; w2 >= 10; w2 /= 10)
    e2++;
  return e2;
}
function getLn10(Ctor, sd, pr) {
  if (sd > LN10_PRECISION) {
    external = true;
    if (pr)
      Ctor.precision = pr;
    throw Error(precisionLimitExceeded);
  }
  return finalise(new Ctor(LN10), sd, 1, true);
}
function getPi(Ctor, sd, rm2) {
  if (sd > PI_PRECISION)
    throw Error(precisionLimitExceeded);
  return finalise(new Ctor(PI), sd, rm2, true);
}
function getPrecision(digits) {
  var w2 = digits.length - 1, len = w2 * LOG_BASE + 1;
  w2 = digits[w2];
  if (w2) {
    for (; w2 % 10 == 0; w2 /= 10)
      len--;
    for (w2 = digits[0]; w2 >= 10; w2 /= 10)
      len++;
  }
  return len;
}
function getZeroString(k2) {
  var zs = "";
  for (; k2--; )
    zs += "0";
  return zs;
}
function intPow(Ctor, x2, n2, pr) {
  var isTruncated, r2 = new Ctor(1), k2 = Math.ceil(pr / LOG_BASE + 4);
  external = false;
  for (; ; ) {
    if (n2 % 2) {
      r2 = r2.times(x2);
      if (truncate(r2.d, k2))
        isTruncated = true;
    }
    n2 = mathfloor(n2 / 2);
    if (n2 === 0) {
      n2 = r2.d.length - 1;
      if (isTruncated && r2.d[n2] === 0)
        ++r2.d[n2];
      break;
    }
    x2 = x2.times(x2);
    truncate(x2.d, k2);
  }
  external = true;
  return r2;
}
function isOdd(n2) {
  return n2.d[n2.d.length - 1] & 1;
}
function maxOrMin(Ctor, args, ltgt) {
  var y2, x2 = new Ctor(args[0]), i2 = 0;
  for (; ++i2 < args.length; ) {
    y2 = new Ctor(args[i2]);
    if (!y2.s) {
      x2 = y2;
      break;
    } else if (x2[ltgt](y2)) {
      x2 = y2;
    }
  }
  return x2;
}
function naturalExponential(x2, sd) {
  var denominator, guard, j2, pow2, sum2, t2, wpr, rep = 0, i2 = 0, k2 = 0, Ctor = x2.constructor, rm2 = Ctor.rounding, pr = Ctor.precision;
  if (!x2.d || !x2.d[0] || x2.e > 17) {
    return new Ctor(x2.d ? !x2.d[0] ? 1 : x2.s < 0 ? 0 : 1 / 0 : x2.s ? x2.s < 0 ? 0 : x2 : 0 / 0);
  }
  if (sd == null) {
    external = false;
    wpr = pr;
  } else {
    wpr = sd;
  }
  t2 = new Ctor(0.03125);
  while (x2.e > -2) {
    x2 = x2.times(t2);
    k2 += 5;
  }
  guard = Math.log(mathpow(2, k2)) / Math.LN10 * 2 + 5 | 0;
  wpr += guard;
  denominator = pow2 = sum2 = new Ctor(1);
  Ctor.precision = wpr;
  for (; ; ) {
    pow2 = finalise(pow2.times(x2), wpr, 1);
    denominator = denominator.times(++i2);
    t2 = sum2.plus(divide(pow2, denominator, wpr, 1));
    if (digitsToString(t2.d).slice(0, wpr) === digitsToString(sum2.d).slice(0, wpr)) {
      j2 = k2;
      while (j2--)
        sum2 = finalise(sum2.times(sum2), wpr, 1);
      if (sd == null) {
        if (rep < 3 && checkRoundingDigits(sum2.d, wpr - guard, rm2, rep)) {
          Ctor.precision = wpr += 10;
          denominator = pow2 = t2 = new Ctor(1);
          i2 = 0;
          rep++;
        } else {
          return finalise(sum2, Ctor.precision = pr, rm2, external = true);
        }
      } else {
        Ctor.precision = pr;
        return sum2;
      }
    }
    sum2 = t2;
  }
}
function naturalLogarithm(y2, sd) {
  var c2, c0, denominator, e2, numerator, rep, sum2, t2, wpr, x1, x2, n2 = 1, guard = 10, x3 = y2, xd = x3.d, Ctor = x3.constructor, rm2 = Ctor.rounding, pr = Ctor.precision;
  if (x3.s < 0 || !xd || !xd[0] || !x3.e && xd[0] == 1 && xd.length == 1) {
    return new Ctor(xd && !xd[0] ? -1 / 0 : x3.s != 1 ? NaN : xd ? 0 : x3);
  }
  if (sd == null) {
    external = false;
    wpr = pr;
  } else {
    wpr = sd;
  }
  Ctor.precision = wpr += guard;
  c2 = digitsToString(xd);
  c0 = c2.charAt(0);
  if (Math.abs(e2 = x3.e) < 15e14) {
    while (c0 < 7 && c0 != 1 || c0 == 1 && c2.charAt(1) > 3) {
      x3 = x3.times(y2);
      c2 = digitsToString(x3.d);
      c0 = c2.charAt(0);
      n2++;
    }
    e2 = x3.e;
    if (c0 > 1) {
      x3 = new Ctor("0." + c2);
      e2++;
    } else {
      x3 = new Ctor(c0 + "." + c2.slice(1));
    }
  } else {
    t2 = getLn10(Ctor, wpr + 2, pr).times(e2 + "");
    x3 = naturalLogarithm(new Ctor(c0 + "." + c2.slice(1)), wpr - guard).plus(t2);
    Ctor.precision = pr;
    return sd == null ? finalise(x3, pr, rm2, external = true) : x3;
  }
  x1 = x3;
  sum2 = numerator = x3 = divide(x3.minus(1), x3.plus(1), wpr, 1);
  x2 = finalise(x3.times(x3), wpr, 1);
  denominator = 3;
  for (; ; ) {
    numerator = finalise(numerator.times(x2), wpr, 1);
    t2 = sum2.plus(divide(numerator, new Ctor(denominator), wpr, 1));
    if (digitsToString(t2.d).slice(0, wpr) === digitsToString(sum2.d).slice(0, wpr)) {
      sum2 = sum2.times(2);
      if (e2 !== 0)
        sum2 = sum2.plus(getLn10(Ctor, wpr + 2, pr).times(e2 + ""));
      sum2 = divide(sum2, new Ctor(n2), wpr, 1);
      if (sd == null) {
        if (checkRoundingDigits(sum2.d, wpr - guard, rm2, rep)) {
          Ctor.precision = wpr += guard;
          t2 = numerator = x3 = divide(x1.minus(1), x1.plus(1), wpr, 1);
          x2 = finalise(x3.times(x3), wpr, 1);
          denominator = rep = 1;
        } else {
          return finalise(sum2, Ctor.precision = pr, rm2, external = true);
        }
      } else {
        Ctor.precision = pr;
        return sum2;
      }
    }
    sum2 = t2;
    denominator += 2;
  }
}
function nonFiniteToString(x2) {
  return String(x2.s * x2.s / 0);
}
function parseDecimal(x2, str) {
  var e2, i2, len;
  if ((e2 = str.indexOf(".")) > -1)
    str = str.replace(".", "");
  if ((i2 = str.search(/e/i)) > 0) {
    if (e2 < 0)
      e2 = i2;
    e2 += +str.slice(i2 + 1);
    str = str.substring(0, i2);
  } else if (e2 < 0) {
    e2 = str.length;
  }
  for (i2 = 0; str.charCodeAt(i2) === 48; i2++)
    ;
  for (len = str.length; str.charCodeAt(len - 1) === 48; --len)
    ;
  str = str.slice(i2, len);
  if (str) {
    len -= i2;
    x2.e = e2 = e2 - i2 - 1;
    x2.d = [];
    i2 = (e2 + 1) % LOG_BASE;
    if (e2 < 0)
      i2 += LOG_BASE;
    if (i2 < len) {
      if (i2)
        x2.d.push(+str.slice(0, i2));
      for (len -= LOG_BASE; i2 < len; )
        x2.d.push(+str.slice(i2, i2 += LOG_BASE));
      str = str.slice(i2);
      i2 = LOG_BASE - str.length;
    } else {
      i2 -= len;
    }
    for (; i2--; )
      str += "0";
    x2.d.push(+str);
    if (external) {
      if (x2.e > x2.constructor.maxE) {
        x2.d = null;
        x2.e = NaN;
      } else if (x2.e < x2.constructor.minE) {
        x2.e = 0;
        x2.d = [0];
      }
    }
  } else {
    x2.e = 0;
    x2.d = [0];
  }
  return x2;
}
function parseOther(x2, str) {
  var base, Ctor, divisor, i2, isFloat, len, p2, xd, xe2;
  if (str.indexOf("_") > -1) {
    str = str.replace(/(\d)_(?=\d)/g, "$1");
    if (isDecimal.test(str))
      return parseDecimal(x2, str);
  } else if (str === "Infinity" || str === "NaN") {
    if (!+str)
      x2.s = NaN;
    x2.e = NaN;
    x2.d = null;
    return x2;
  }
  if (isHex.test(str)) {
    base = 16;
    str = str.toLowerCase();
  } else if (isBinary.test(str)) {
    base = 2;
  } else if (isOctal.test(str)) {
    base = 8;
  } else {
    throw Error(invalidArgument + str);
  }
  i2 = str.search(/p/i);
  if (i2 > 0) {
    p2 = +str.slice(i2 + 1);
    str = str.substring(2, i2);
  } else {
    str = str.slice(2);
  }
  i2 = str.indexOf(".");
  isFloat = i2 >= 0;
  Ctor = x2.constructor;
  if (isFloat) {
    str = str.replace(".", "");
    len = str.length;
    i2 = len - i2;
    divisor = intPow(Ctor, new Ctor(base), i2, i2 * 2);
  }
  xd = convertBase(str, base, BASE);
  xe2 = xd.length - 1;
  for (i2 = xe2; xd[i2] === 0; --i2)
    xd.pop();
  if (i2 < 0)
    return new Ctor(x2.s * 0);
  x2.e = getBase10Exponent(xd, xe2);
  x2.d = xd;
  external = false;
  if (isFloat)
    x2 = divide(x2, divisor, len * 4);
  if (p2)
    x2 = x2.times(Math.abs(p2) < 54 ? mathpow(2, p2) : Decimal.pow(2, p2));
  external = true;
  return x2;
}
function sine(Ctor, x2) {
  var k2, len = x2.d.length;
  if (len < 3) {
    return x2.isZero() ? x2 : taylorSeries(Ctor, 2, x2, x2);
  }
  k2 = 1.4 * Math.sqrt(len);
  k2 = k2 > 16 ? 16 : k2 | 0;
  x2 = x2.times(1 / tinyPow(5, k2));
  x2 = taylorSeries(Ctor, 2, x2, x2);
  var sin2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
  for (; k2--; ) {
    sin2_x = x2.times(x2);
    x2 = x2.times(d5.plus(sin2_x.times(d16.times(sin2_x).minus(d20))));
  }
  return x2;
}
function taylorSeries(Ctor, n2, x2, y2, isHyperbolic) {
  var j2, t2, u2, x22, pr = Ctor.precision, k2 = Math.ceil(pr / LOG_BASE);
  external = false;
  x22 = x2.times(x2);
  u2 = new Ctor(y2);
  for (; ; ) {
    t2 = divide(u2.times(x22), new Ctor(n2++ * n2++), pr, 1);
    u2 = isHyperbolic ? y2.plus(t2) : y2.minus(t2);
    y2 = divide(t2.times(x22), new Ctor(n2++ * n2++), pr, 1);
    t2 = u2.plus(y2);
    if (t2.d[k2] !== void 0) {
      for (j2 = k2; t2.d[j2] === u2.d[j2] && j2--; )
        ;
      if (j2 == -1)
        break;
    }
    j2 = u2;
    u2 = y2;
    y2 = t2;
    t2 = j2;
  }
  external = true;
  t2.d.length = k2 + 1;
  return t2;
}
function tinyPow(b, e2) {
  var n2 = b;
  while (--e2)
    n2 *= b;
  return n2;
}
function toLessThanHalfPi(Ctor, x2) {
  var t2, isNeg = x2.s < 0, pi = getPi(Ctor, Ctor.precision, 1), halfPi = pi.times(0.5);
  x2 = x2.abs();
  if (x2.lte(halfPi)) {
    quadrant = isNeg ? 4 : 1;
    return x2;
  }
  t2 = x2.divToInt(pi);
  if (t2.isZero()) {
    quadrant = isNeg ? 3 : 2;
  } else {
    x2 = x2.minus(t2.times(pi));
    if (x2.lte(halfPi)) {
      quadrant = isOdd(t2) ? isNeg ? 2 : 3 : isNeg ? 4 : 1;
      return x2;
    }
    quadrant = isOdd(t2) ? isNeg ? 1 : 4 : isNeg ? 3 : 2;
  }
  return x2.minus(pi).abs();
}
function toStringBinary(x2, baseOut, sd, rm2) {
  var base, e2, i2, k2, len, roundUp, str, xd, y2, Ctor = x2.constructor, isExp = sd !== void 0;
  if (isExp) {
    checkInt32(sd, 1, MAX_DIGITS);
    if (rm2 === void 0)
      rm2 = Ctor.rounding;
    else
      checkInt32(rm2, 0, 8);
  } else {
    sd = Ctor.precision;
    rm2 = Ctor.rounding;
  }
  if (!x2.isFinite()) {
    str = nonFiniteToString(x2);
  } else {
    str = finiteToString(x2);
    i2 = str.indexOf(".");
    if (isExp) {
      base = 2;
      if (baseOut == 16) {
        sd = sd * 4 - 3;
      } else if (baseOut == 8) {
        sd = sd * 3 - 2;
      }
    } else {
      base = baseOut;
    }
    if (i2 >= 0) {
      str = str.replace(".", "");
      y2 = new Ctor(1);
      y2.e = str.length - i2;
      y2.d = convertBase(finiteToString(y2), 10, base);
      y2.e = y2.d.length;
    }
    xd = convertBase(str, 10, base);
    e2 = len = xd.length;
    for (; xd[--len] == 0; )
      xd.pop();
    if (!xd[0]) {
      str = isExp ? "0p+0" : "0";
    } else {
      if (i2 < 0) {
        e2--;
      } else {
        x2 = new Ctor(x2);
        x2.d = xd;
        x2.e = e2;
        x2 = divide(x2, y2, sd, rm2, 0, base);
        xd = x2.d;
        e2 = x2.e;
        roundUp = inexact;
      }
      i2 = xd[sd];
      k2 = base / 2;
      roundUp = roundUp || xd[sd + 1] !== void 0;
      roundUp = rm2 < 4 ? (i2 !== void 0 || roundUp) && (rm2 === 0 || rm2 === (x2.s < 0 ? 3 : 2)) : i2 > k2 || i2 === k2 && (rm2 === 4 || roundUp || rm2 === 6 && xd[sd - 1] & 1 || rm2 === (x2.s < 0 ? 8 : 7));
      xd.length = sd;
      if (roundUp) {
        for (; ++xd[--sd] > base - 1; ) {
          xd[sd] = 0;
          if (!sd) {
            ++e2;
            xd.unshift(1);
          }
        }
      }
      for (len = xd.length; !xd[len - 1]; --len)
        ;
      for (i2 = 0, str = ""; i2 < len; i2++)
        str += NUMERALS.charAt(xd[i2]);
      if (isExp) {
        if (len > 1) {
          if (baseOut == 16 || baseOut == 8) {
            i2 = baseOut == 16 ? 4 : 3;
            for (--len; len % i2; len++)
              str += "0";
            xd = convertBase(str, base, baseOut);
            for (len = xd.length; !xd[len - 1]; --len)
              ;
            for (i2 = 1, str = "1."; i2 < len; i2++)
              str += NUMERALS.charAt(xd[i2]);
          } else {
            str = str.charAt(0) + "." + str.slice(1);
          }
        }
        str = str + (e2 < 0 ? "p" : "p+") + e2;
      } else if (e2 < 0) {
        for (; ++e2; )
          str = "0" + str;
        str = "0." + str;
      } else {
        if (++e2 > len)
          for (e2 -= len; e2--; )
            str += "0";
        else if (e2 < len)
          str = str.slice(0, e2) + "." + str.slice(e2);
      }
    }
    str = (baseOut == 16 ? "0x" : baseOut == 2 ? "0b" : baseOut == 8 ? "0o" : "") + str;
  }
  return x2.s < 0 ? "-" + str : str;
}
function truncate(arr2, len) {
  if (arr2.length > len) {
    arr2.length = len;
    return true;
  }
}
function abs(x2) {
  return new this(x2).abs();
}
function acos(x2) {
  return new this(x2).acos();
}
function acosh(x2) {
  return new this(x2).acosh();
}
function add(x2, y2) {
  return new this(x2).plus(y2);
}
function asin(x2) {
  return new this(x2).asin();
}
function asinh(x2) {
  return new this(x2).asinh();
}
function atan(x2) {
  return new this(x2).atan();
}
function atanh(x2) {
  return new this(x2).atanh();
}
function atan2(y2, x2) {
  y2 = new this(y2);
  x2 = new this(x2);
  var r2, pr = this.precision, rm2 = this.rounding, wpr = pr + 4;
  if (!y2.s || !x2.s) {
    r2 = new this(NaN);
  } else if (!y2.d && !x2.d) {
    r2 = getPi(this, wpr, 1).times(x2.s > 0 ? 0.25 : 0.75);
    r2.s = y2.s;
  } else if (!x2.d || y2.isZero()) {
    r2 = x2.s < 0 ? getPi(this, pr, rm2) : new this(0);
    r2.s = y2.s;
  } else if (!y2.d || x2.isZero()) {
    r2 = getPi(this, wpr, 1).times(0.5);
    r2.s = y2.s;
  } else if (x2.s < 0) {
    this.precision = wpr;
    this.rounding = 1;
    r2 = this.atan(divide(y2, x2, wpr, 1));
    x2 = getPi(this, wpr, 1);
    this.precision = pr;
    this.rounding = rm2;
    r2 = y2.s < 0 ? r2.minus(x2) : r2.plus(x2);
  } else {
    r2 = this.atan(divide(y2, x2, wpr, 1));
  }
  return r2;
}
function cbrt(x2) {
  return new this(x2).cbrt();
}
function ceil(x2) {
  return finalise(x2 = new this(x2), x2.e + 1, 2);
}
function clamp(x2, min2, max2) {
  return new this(x2).clamp(min2, max2);
}
function config(obj) {
  if (!obj || typeof obj !== "object")
    throw Error(decimalError + "Object expected");
  var i2, p2, v2, useDefaults = obj.defaults === true, ps = [
    "precision",
    1,
    MAX_DIGITS,
    "rounding",
    0,
    8,
    "toExpNeg",
    -EXP_LIMIT,
    0,
    "toExpPos",
    0,
    EXP_LIMIT,
    "maxE",
    0,
    EXP_LIMIT,
    "minE",
    -EXP_LIMIT,
    0,
    "modulo",
    0,
    9
  ];
  for (i2 = 0; i2 < ps.length; i2 += 3) {
    if (p2 = ps[i2], useDefaults)
      this[p2] = DEFAULTS[p2];
    if ((v2 = obj[p2]) !== void 0) {
      if (mathfloor(v2) === v2 && v2 >= ps[i2 + 1] && v2 <= ps[i2 + 2])
        this[p2] = v2;
      else
        throw Error(invalidArgument + p2 + ": " + v2);
    }
  }
  if (p2 = "crypto", useDefaults)
    this[p2] = DEFAULTS[p2];
  if ((v2 = obj[p2]) !== void 0) {
    if (v2 === true || v2 === false || v2 === 0 || v2 === 1) {
      if (v2) {
        if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) {
          this[p2] = true;
        } else {
          throw Error(cryptoUnavailable);
        }
      } else {
        this[p2] = false;
      }
    } else {
      throw Error(invalidArgument + p2 + ": " + v2);
    }
  }
  return this;
}
function cos(x2) {
  return new this(x2).cos();
}
function cosh(x2) {
  return new this(x2).cosh();
}
function clone(obj) {
  var i2, p2, ps;
  function Decimal2(v2) {
    var e2, i3, t2, x2 = this;
    if (!(x2 instanceof Decimal2))
      return new Decimal2(v2);
    x2.constructor = Decimal2;
    if (isDecimalInstance(v2)) {
      x2.s = v2.s;
      if (external) {
        if (!v2.d || v2.e > Decimal2.maxE) {
          x2.e = NaN;
          x2.d = null;
        } else if (v2.e < Decimal2.minE) {
          x2.e = 0;
          x2.d = [0];
        } else {
          x2.e = v2.e;
          x2.d = v2.d.slice();
        }
      } else {
        x2.e = v2.e;
        x2.d = v2.d ? v2.d.slice() : v2.d;
      }
      return;
    }
    t2 = typeof v2;
    if (t2 === "number") {
      if (v2 === 0) {
        x2.s = 1 / v2 < 0 ? -1 : 1;
        x2.e = 0;
        x2.d = [0];
        return;
      }
      if (v2 < 0) {
        v2 = -v2;
        x2.s = -1;
      } else {
        x2.s = 1;
      }
      if (v2 === ~~v2 && v2 < 1e7) {
        for (e2 = 0, i3 = v2; i3 >= 10; i3 /= 10)
          e2++;
        if (external) {
          if (e2 > Decimal2.maxE) {
            x2.e = NaN;
            x2.d = null;
          } else if (e2 < Decimal2.minE) {
            x2.e = 0;
            x2.d = [0];
          } else {
            x2.e = e2;
            x2.d = [v2];
          }
        } else {
          x2.e = e2;
          x2.d = [v2];
        }
        return;
      } else if (v2 * 0 !== 0) {
        if (!v2)
          x2.s = NaN;
        x2.e = NaN;
        x2.d = null;
        return;
      }
      return parseDecimal(x2, v2.toString());
    } else if (t2 !== "string") {
      throw Error(invalidArgument + v2);
    }
    if ((i3 = v2.charCodeAt(0)) === 45) {
      v2 = v2.slice(1);
      x2.s = -1;
    } else {
      if (i3 === 43)
        v2 = v2.slice(1);
      x2.s = 1;
    }
    return isDecimal.test(v2) ? parseDecimal(x2, v2) : parseOther(x2, v2);
  }
  Decimal2.prototype = P;
  Decimal2.ROUND_UP = 0;
  Decimal2.ROUND_DOWN = 1;
  Decimal2.ROUND_CEIL = 2;
  Decimal2.ROUND_FLOOR = 3;
  Decimal2.ROUND_HALF_UP = 4;
  Decimal2.ROUND_HALF_DOWN = 5;
  Decimal2.ROUND_HALF_EVEN = 6;
  Decimal2.ROUND_HALF_CEIL = 7;
  Decimal2.ROUND_HALF_FLOOR = 8;
  Decimal2.EUCLID = 9;
  Decimal2.config = Decimal2.set = config;
  Decimal2.clone = clone;
  Decimal2.isDecimal = isDecimalInstance;
  Decimal2.abs = abs;
  Decimal2.acos = acos;
  Decimal2.acosh = acosh;
  Decimal2.add = add;
  Decimal2.asin = asin;
  Decimal2.asinh = asinh;
  Decimal2.atan = atan;
  Decimal2.atanh = atanh;
  Decimal2.atan2 = atan2;
  Decimal2.cbrt = cbrt;
  Decimal2.ceil = ceil;
  Decimal2.clamp = clamp;
  Decimal2.cos = cos;
  Decimal2.cosh = cosh;
  Decimal2.div = div;
  Decimal2.exp = exp;
  Decimal2.floor = floor;
  Decimal2.hypot = hypot;
  Decimal2.ln = ln;
  Decimal2.log = log2;
  Decimal2.log10 = log10;
  Decimal2.log2 = log22;
  Decimal2.max = max;
  Decimal2.min = min;
  Decimal2.mod = mod;
  Decimal2.mul = mul;
  Decimal2.pow = pow;
  Decimal2.random = random;
  Decimal2.round = round;
  Decimal2.sign = sign;
  Decimal2.sin = sin;
  Decimal2.sinh = sinh;
  Decimal2.sqrt = sqrt;
  Decimal2.sub = sub;
  Decimal2.sum = sum;
  Decimal2.tan = tan;
  Decimal2.tanh = tanh;
  Decimal2.trunc = trunc;
  if (obj === void 0)
    obj = {};
  if (obj) {
    if (obj.defaults !== true) {
      ps = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"];
      for (i2 = 0; i2 < ps.length; )
        if (!obj.hasOwnProperty(p2 = ps[i2++]))
          obj[p2] = this[p2];
    }
  }
  Decimal2.config(obj);
  return Decimal2;
}
function div(x2, y2) {
  return new this(x2).div(y2);
}
function exp(x2) {
  return new this(x2).exp();
}
function floor(x2) {
  return finalise(x2 = new this(x2), x2.e + 1, 3);
}
function hypot() {
  var i2, n2, t2 = new this(0);
  external = false;
  for (i2 = 0; i2 < arguments.length; ) {
    n2 = new this(arguments[i2++]);
    if (!n2.d) {
      if (n2.s) {
        external = true;
        return new this(1 / 0);
      }
      t2 = n2;
    } else if (t2.d) {
      t2 = t2.plus(n2.times(n2));
    }
  }
  external = true;
  return t2.sqrt();
}
function isDecimalInstance(obj) {
  return obj instanceof Decimal || obj && obj.toStringTag === tag || false;
}
function ln(x2) {
  return new this(x2).ln();
}
function log2(x2, y2) {
  return new this(x2).log(y2);
}
function log22(x2) {
  return new this(x2).log(2);
}
function log10(x2) {
  return new this(x2).log(10);
}
function max() {
  return maxOrMin(this, arguments, "lt");
}
function min() {
  return maxOrMin(this, arguments, "gt");
}
function mod(x2, y2) {
  return new this(x2).mod(y2);
}
function mul(x2, y2) {
  return new this(x2).mul(y2);
}
function pow(x2, y2) {
  return new this(x2).pow(y2);
}
function random(sd) {
  var d2, e2, k2, n2, i2 = 0, r2 = new this(1), rd = [];
  if (sd === void 0)
    sd = this.precision;
  else
    checkInt32(sd, 1, MAX_DIGITS);
  k2 = Math.ceil(sd / LOG_BASE);
  if (!this.crypto) {
    for (; i2 < k2; )
      rd[i2++] = Math.random() * 1e7 | 0;
  } else if (crypto.getRandomValues) {
    d2 = crypto.getRandomValues(new Uint32Array(k2));
    for (; i2 < k2; ) {
      n2 = d2[i2];
      if (n2 >= 429e7) {
        d2[i2] = crypto.getRandomValues(new Uint32Array(1))[0];
      } else {
        rd[i2++] = n2 % 1e7;
      }
    }
  } else if (crypto.randomBytes) {
    d2 = crypto.randomBytes(k2 *= 4);
    for (; i2 < k2; ) {
      n2 = d2[i2] + (d2[i2 + 1] << 8) + (d2[i2 + 2] << 16) + ((d2[i2 + 3] & 127) << 24);
      if (n2 >= 214e7) {
        crypto.randomBytes(4).copy(d2, i2);
      } else {
        rd.push(n2 % 1e7);
        i2 += 4;
      }
    }
    i2 = k2 / 4;
  } else {
    throw Error(cryptoUnavailable);
  }
  k2 = rd[--i2];
  sd %= LOG_BASE;
  if (k2 && sd) {
    n2 = mathpow(10, LOG_BASE - sd);
    rd[i2] = (k2 / n2 | 0) * n2;
  }
  for (; rd[i2] === 0; i2--)
    rd.pop();
  if (i2 < 0) {
    e2 = 0;
    rd = [0];
  } else {
    e2 = -1;
    for (; rd[0] === 0; e2 -= LOG_BASE)
      rd.shift();
    for (k2 = 1, n2 = rd[0]; n2 >= 10; n2 /= 10)
      k2++;
    if (k2 < LOG_BASE)
      e2 -= LOG_BASE - k2;
  }
  r2.e = e2;
  r2.d = rd;
  return r2;
}
function round(x2) {
  return finalise(x2 = new this(x2), x2.e + 1, this.rounding);
}
function sign(x2) {
  x2 = new this(x2);
  return x2.d ? x2.d[0] ? x2.s : 0 * x2.s : x2.s || NaN;
}
function sin(x2) {
  return new this(x2).sin();
}
function sinh(x2) {
  return new this(x2).sinh();
}
function sqrt(x2) {
  return new this(x2).sqrt();
}
function sub(x2, y2) {
  return new this(x2).sub(y2);
}
function sum() {
  var i2 = 0, args = arguments, x2 = new this(args[i2]);
  external = false;
  for (; x2.s && ++i2 < args.length; )
    x2 = x2.plus(args[i2]);
  external = true;
  return finalise(x2, this.precision, this.rounding);
}
function tan(x2) {
  return new this(x2).tan();
}
function tanh(x2) {
  return new this(x2).tanh();
}
function trunc(x2) {
  return finalise(x2 = new this(x2), x2.e + 1, 1);
}
P[Symbol.for("nodejs.util.inspect.custom")] = P.toString;
P[Symbol.toStringTag] = "Decimal";
var Decimal = P.constructor = clone(DEFAULTS);
LN10 = new Decimal(LN10);
PI = new Decimal(PI);
const formatter = new Intl.NumberFormat("fi-FI");
const formatNumber = (value) => {
  return formatter.format(value);
};
const getPriceArr$2 = (listingInfo) => {
  const debtDisplay = {
    [`${instance.t("debt")} (${DateTime.fromISO(
      listingInfo.apartment_fi.listing_price_debt_date
    ).toFormat("dd.MM.yyyy")})`]: `${formatNumber(
      listingInfo.apartment_fi.listing_price_debt
    )} ${listingInfo.currency_display}`
  };
  const priceAsking = new Decimal(listingInfo.listing_price_asking);
  const priceDebt = new Decimal(listingInfo.apartment_fi.listing_price_debt);
  const priceArr = [
    { [instance.t("price_for_sale")]: listingInfo.price_display },
    debtDisplay,
    {
      [instance.t("debt_deducted_price")]: `${Decimal.isDecimal(priceAsking) && Decimal.isDecimal(priceDebt) ? formatNumber(priceAsking.minus(priceDebt)) : "-"} ${listingInfo.currency_display}`
    },
    {
      [instance.t("price_per_square")]: listingInfo.price_per_square_display
    }
  ];
  return priceArr;
};
const getPriceArr$1 = (listingInfo) => {
  const { listing_market_state } = listingInfo.apartment_se;
  const priceArr = [
    ...[
      {
        [instance.t("price_for_sale_SE")]: listing_market_state === "upcoming" ? "Pre Sale" : `${listingInfo.price_display} (${listingInfo.price_per_square_display})`
      }
    ],
    {
      [instance.t("is_loaned")]: listingInfo.apartment_se.is_loaned ? instance.t("yes") : instance.t("no")
    },
    {
      [instance.t("loan_break_fee")]: listingInfo.apartment_se.loan_break_fee ? `${listingInfo.apartment_se.loan_break_fee} kr` : "-"
    },
    {
      [instance.t("owner_change_fee")]: listingInfo.apartment_se.owner_change_fee ? `${listingInfo.apartment_se.owner_change_fee} kr` : "-"
    }
  ];
  return priceArr;
};
const getPriceArr = (listingInfo) => {
  if (listingInfo.type === "apartment_fi") {
    return getPriceArr$2(listingInfo);
  } else if (listingInfo.type === "apartment_se") {
    return getPriceArr$1(listingInfo);
  }
};
const getFeeArr = (listingInfo) => {
  const feeArr = [];
  if (listingInfo.fees && listingInfo.fees.length > 0) {
    getFeesDisplay(listingInfo.fees, listingInfo.currency).forEach((fee) => {
      feeArr.push({
        [fee.name]: `${fee.value} ${fee.description ? `- ${fee.description}` : ""}`
      });
    });
  }
  return feeArr;
};
function ListingPriceInfo({ listingInfo }) {
  const { t: t2 } = useTranslation();
  const { case_type } = listingInfo;
  const country = listingInfo.location_country || "FI";
  const isSellCase = ["sell", "sell_from_buyer_service"].includes(case_type);
  const feeInfo = getFeeArr(listingInfo);
  if (feeInfo.length === 0 && !isSellCase) {
    return null;
  }
  return /* @__PURE__ */ jsx(ListingInfo, { headline: !isSellCase ? t2("fees", { context: country }) : t2("price_info"), children: /* @__PURE__ */ jsxs("div", { className: cx("flex flex-col lg:flex-row"), children: [
    isSellCase && /* @__PURE__ */ jsx("div", { className: "w-full lg:w-1/2", children: /* @__PURE__ */ jsx(ListingInfoTable, { infoArray: getPriceArr(listingInfo) }) }),
    feeInfo.length > 0 && /* @__PURE__ */ jsx("div", { className: cx("w-full", { "lg:w-1/2": isSellCase }), children: /* @__PURE__ */ jsx(ListingInfoTable, { infoArray: feeInfo }) })
  ] }) });
}
const SvgPeopleInQueue = (props) => /* @__PURE__ */ React$3.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 37 35.6", style: {
  enableBackground: "new 0 0 37 35.6"
}, xmlSpace: "preserve", ...props }, /* @__PURE__ */ React$3.createElement("style", { type: "text/css" }, "\n	.st0{fill:#FFFFFF;}\n"), /* @__PURE__ */ React$3.createElement("path", { className: "st0", d: "M29.2,35.6c-0.2,0-0.4-0.1-0.6-0.2c-0.7-0.5-7.3-5.4-7.3-9.5c0-3,2.2-4.8,4.4-4.8c1.7,0,2.7,0.9,3.5,1.9 c0.8-1.1,1.7-1.9,3.5-1.9c2.2,0,4.4,1.8,4.4,4.8c0,4.1-6.5,9-7.3,9.5C29.6,35.6,29.4,35.6,29.2,35.6z M25.7,23.1 c-1.2,0-2.4,1-2.4,2.8c0,2,2.9,5.2,5.8,7.5c3-2.3,5.8-5.5,5.8-7.5c0-1.7-1.2-2.8-2.4-2.8c-1.2,0-1.6,0.6-2.5,2.1L30,25.4 c-0.4,0.6-1.3,0.6-1.7,0l-0.1-0.2C27.3,23.8,26.9,23.1,25.7,23.1z" }), /* @__PURE__ */ React$3.createElement("path", { className: "st0", d: "M22.3,35.6H5.6c-0.6,0-1-0.4-1-1V17.8c0-0.6,0.4-1,1-1s1,0.4,1,1v15.8h15.7c0.6,0,1,0.4,1,1 S22.9,35.6,22.3,35.6z" }), /* @__PURE__ */ React$3.createElement("path", { className: "st0", d: "M36,18.1c-0.2,0-0.5-0.1-0.7-0.3L18.5,2.4L1.7,17.8c-0.4,0.4-1,0.3-1.4-0.1c-0.4-0.4-0.3-1,0.1-1.4L17.8,0.3 c0.4-0.4,1-0.4,1.4,0l17.5,16.1c0.4,0.4,0.4,1,0.1,1.4C36.5,17.9,36.3,18.1,36,18.1z" }), /* @__PURE__ */ React$3.createElement("path", { className: "st0", d: "M30,8c-0.6,0-1-0.4-1-1V3.5h-4.4c-0.6,0-1-0.4-1-1s0.4-1,1-1H30c0.6,0,1,0.4,1,1V7C31,7.6,30.6,8,30,8z" }), /* @__PURE__ */ React$3.createElement("path", { className: "st0", d: "M20.8,14.2h-4.6c-0.6,0-1-0.4-1-1V8.6c0-0.6,0.4-1,1-1h4.6c0.6,0,1,0.4,1,1v4.6C21.8,13.8,21.3,14.2,20.8,14.2z  M17.2,12.2h2.6V9.6h-2.6V12.2z" }));
function ScoutCTA({
  show_interest_links,
  show_add_match_link,
  buyer_service_links,
  potential_buyer_count,
  offer_deadline,
  case_type,
  listingGuid,
  country
}) {
  const { t: t2 } = useTranslation();
  const display_potential_buyer_count = !!potential_buyer_count && potential_buyer_count >= 3 && !show_add_match_link;
  let CTABodyTag = t2("see_apartment", { context: country });
  if (show_add_match_link) {
    CTABodyTag = t2("want_to_know_more");
  } else if (offer_deadline) {
    CTABodyTag = t2("Offer deadline");
  } else if (display_potential_buyer_count) {
    CTABodyTag = t2("However, you are the first in line so act fast");
  } else if (!show_interest_links) {
    CTABodyTag = t2("scout_make_offer");
  }
  return /* @__PURE__ */ jsxs("div", { className: "max-w-md overflow-hidden text-center lg:max-w-none mx-auto", children: [
    offer_deadline && /* @__PURE__ */ jsx("div", { className: "flex heading-with-text bg-pink-500", children: /* @__PURE__ */ jsx("div", { className: "text-white h-[50px] m-auto flex items-center", children: /* @__PURE__ */ jsx("h6", { children: t2("Exclusively for you") }) }) }),
    display_potential_buyer_count && !offer_deadline && /* @__PURE__ */ jsx("div", { className: "flex bg-pink-500", children: /* @__PURE__ */ jsxs("div", { className: "text-white h-[65px] m-auto flex items-center", children: [
      /* @__PURE__ */ jsx(SvgPeopleInQueue, { className: "w-[40px]" }),
      /* @__PURE__ */ jsx("h3", { className: "pl-[10px] m-0", children: potential_buyer_count }),
      /* @__PURE__ */ jsx("h6", { className: "pl-[10px] m-0", children: t2("potential buyers") })
    ] }) }),
    /* @__PURE__ */ jsxs("div", { className: "bg-pink-100 border-t-2 border-pink-500 px-6 pt-6 pb-6 mb-6 sm:px-11", children: [
      /* @__PURE__ */ jsxs("h6", { className: "mb-1 leading-loose text-pink-500", children: [
        CTABodyTag,
        offer_deadline && /* @__PURE__ */ jsx("h6", { className: "mb-2 mt-1", style: { fontSize: "25px" }, children: /* @__PURE__ */ jsx("b", { children: offer_deadline }) })
      ] }),
      case_type === "sell_from_buyer_service" && /* @__PURE__ */ jsx(
        Button,
        {
          size: "sm",
          className: "w-full mx-auto mt-2",
          buttonLink: `${"https://app.blok.ai"}/trade/${listingGuid}/`,
          children: t2("make_offer", { context: country })
        }
      ),
      show_add_match_link && /* @__PURE__ */ jsx(
        Button,
        {
          size: "sm",
          className: "w-full mx-auto mt-2",
          buttonLink: buyer_service_links.add_match,
          children: t2("match_interested", { context: country })
        }
      ),
      show_interest_links && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            size: "sm",
            className: "w-full mx-auto mt-2",
            buttonLink: buyer_service_links.interested,
            children: t2("match_interested", { context: country })
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            buttonStyle: "blue",
            className: "w-full mx-auto mt-2",
            size: "sm",
            buttonLink: buyer_service_links.reject,
            children: t2("match_reject", { context: country })
          }
        )
      ] })
    ] })
  ] });
}
function ScoutDocuments({
  buyer_service_links,
  listingGuid
}) {
  const { t: t2 } = useTranslation();
  return /* @__PURE__ */ jsxs("div", { className: "max-w-md p-6 mx-auto border border-gray-400 lg:p-11 lg:max-w-none", children: [
    /* @__PURE__ */ jsx("h5", { className: "mb-2 text-blue-500", children: t2("documents") }),
    /* @__PURE__ */ jsx("p", { className: "mb-3 text-sm text-gray-800", children: t2("download_document") }),
    /* @__PURE__ */ jsx(
      Button,
      {
        buttonLink: buyer_service_links && buyer_service_links.documents || `${"https://app.blok.ai"}/document/download/${listingGuid}/`,
        buttonStyle: "blue",
        className: "mt-2",
        size: "sm",
        children: t2("documents")
      }
    )
  ] });
}
function ScoutMobileCTA({ buyer_service_links }) {
  const { t: t2 } = useTranslation();
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: "bottom-0 z-10 w-100 bg-white sticky px-[25px] py-[17px]",
      style: { boxShadow: "0 0 10px 0 rgba(0, 0, 0, .15)" },
      children: /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("h5", { className: "text-center mb-3", children: t2("Want to go on a showing?") }),
        /* @__PURE__ */ jsxs("div", { className: "relative flex justify-between mx-auto max-w-[220px]", children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              style: { marginBottom: "0", width: "100px" },
              buttonLink: buyer_service_links == null ? void 0 : buyer_service_links.reject,
              size: "sm",
              children: t2("no")
            }
          ),
          /* @__PURE__ */ jsx(
            Button,
            {
              style: { marginBottom: "0", width: "100px" },
              buttonStyle: "blue",
              size: "sm",
              buttonLink: buyer_service_links == null ? void 0 : buyer_service_links.interested,
              children: t2("yes")
            }
          )
        ] })
      ] })
    }
  );
}
function ScoutTags({ tags }) {
  if (tags.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-1 px-0", children: tags.map(({ label }) => /* @__PURE__ */ jsx(
    "div",
    {
      className: "px-4 pt-2 pb-1.5 text-xs font-bold tracking-wider text-white uppercase rounded",
      style: { backgroundColor: "#ABD192" },
      children: label
    },
    label
  )) });
}
const global$1 = "";
const getTags = (listingInfo, t2) => {
  return [
    {
      key: "building_elevator_exists",
      value: true,
      label: t2("tag__elevator")
    },
    {
      key: "own_yard",
      value: true,
      label: t2("tag__own_yard")
    },
    {
      key: "fireplace",
      value: true,
      label: t2("tag__fireplace")
    },
    {
      key: "high_ceiling",
      value: true,
      label: t2("tag__high_ceiling")
    },
    {
      key: "sauna",
      value: "own",
      label: t2("tag__sauna__own")
    },
    {
      key: "sauna",
      value: "common",
      label: t2("tag__sauna__common")
    },
    {
      key: "balcony_type",
      value: "glazed",
      label: t2("tag__balcony_type__glazed")
    },
    {
      key: "balcony_type",
      value: "open",
      label: t2("tag__balcony_type__open")
    },
    {
      key: "balcony_type",
      value: "french",
      label: t2("tag__balcony_type__french")
    },
    {
      key: "balcony_type",
      value: "traditional",
      label: t2("tag__balcony_type__traditional")
    },
    {
      key: "balcony_type",
      value: "2_plus_balconies",
      label: t2("tag__balcony_type__2_plus_balconies")
    },
    {
      key: "balcony_type",
      value: "roof_terrace",
      label: t2("tag__balcony_type__roof_terrace")
    },
    {
      key: "balcony_type",
      value: "king",
      label: t2("tag__balcony_type__king")
    },
    {
      key: "balcony_type",
      value: "patio",
      label: t2("tag__balcony_type__patio")
    }
  ].filter((tag2) => listingInfo[tag2.key] == tag2.value);
};
function ScoutListing({ listingInfo, listingGuid, country }) {
  const { t: t2 } = useTranslation();
  const [iframeShown, setIframeShown] = useState$1(false);
  const [galleryOpenIndex, setGalleryOpenIndex] = useState$1(null);
  const { width } = useWindowSize();
  const onMobile = width < 992;
  const {
    blueprint,
    hero,
    hero_thumbnail,
    type: type2,
    location_latitude,
    location_longitude,
    case_type,
    photos,
    virtualpresentation,
    location_street_address,
    buyer_service_links,
    listing_owner_story,
    has_documents,
    potential_buyer_count,
    offer_deadline,
    anonymized,
    note_from_agent,
    is_secondary_match
  } = listingInfo;
  switch (type2) {
    case "apartment_fi":
      country = "FI";
      break;
    case "apartment_se":
      country = "SE";
      break;
    default:
      country = "FI";
      break;
  }
  function initIframe(e2, virtual) {
    e2.preventDefault();
    if (!onMobile) {
      setIframeShown(true);
    } else {
      window.location.href = virtual;
    }
  }
  function getBlueprintElement() {
    return blueprint && /* @__PURE__ */ jsxs("div", { className: "relative w-full h-full group", children: [
      /* @__PURE__ */ jsx(Overlay, {}),
      /* @__PURE__ */ jsx(
        "img",
        {
          src: blueprint,
          className: "object-contain w-full h-full",
          alt: ""
        }
      )
    ] });
  }
  function getHeroImage() {
    return hero && /* @__PURE__ */ jsxs("div", { className: "relative h-full group", children: [
      /* @__PURE__ */ jsx(Overlay, {}),
      /* @__PURE__ */ jsx(
        "img",
        {
          className: "object-cover w-full h-full",
          src: hero,
          alt: ""
        }
      )
    ] });
  }
  function getMapElement(fixed) {
    return /* @__PURE__ */ jsx(
      ListingMap,
      {
        latitude: Number(location_latitude),
        longitude: Number(location_longitude),
        fixed
      }
    );
  }
  function getVirtualPresentation() {
    let virtualPresentationThumb = "";
    if (hero) {
      virtualPresentationThumb = hero;
    } else if (virtualpresentation) {
      const matterportUrl = new URL(virtualpresentation);
      const matterportId = matterportUrl.searchParams.get("m");
      virtualPresentationThumb = `https://my.matterport.com/api/v1/player/models/${matterportId}/thumb`;
    }
    return virtualpresentation && /* @__PURE__ */ jsxs(Fragment, { children: [
      !iframeShown && /* @__PURE__ */ jsxs(
        "button",
        {
          onClick: (e2) => initIframe(e2, virtualpresentation),
          className: "relative w-full h-full",
          children: [
            /* @__PURE__ */ jsx(
              "img",
              {
                src: virtualPresentationThumb,
                alt: location_street_address,
                className: "object-cover w-full h-full"
              }
            ),
            /* @__PURE__ */ jsxs("div", { className: "absolute inset-0 flex flex-col items-center justify-center bg-blue-500 group bg-opacity-20", children: [
              /* @__PURE__ */ jsx(SvgVideoPlayer, { className: "text-white transition duration-200 transform scale-100 fill-current w-28 h-28 group-hover:text-blueLight-500 group-hover:scale-105" }),
              /* @__PURE__ */ jsx("p", { className: "mt-4 text-white h6", children: t2("view_3d") })
            ] })
          ]
        }
      ),
      !onMobile && iframeShown && /* @__PURE__ */ jsx(
        "iframe",
        {
          title: `${location_street_address} 3D presentation`,
          src: `${virtualpresentation}&play=1`,
          className: "w-full h-full",
          allowFullScreen: ""
        }
      )
    ] });
  }
  const BlueprintElement = getBlueprintElement();
  const HeroImage = getHeroImage();
  const MapElement = getMapElement(virtualpresentation || hero || blueprint || onMobile);
  const VirtualPresentation = getVirtualPresentation();
  function getPanelContent() {
    if (virtualpresentation)
      return VirtualPresentation;
    if (HeroImage && BlueprintElement) {
      return /* @__PURE__ */ jsxs("div", { className: "grid h-full grid-cols-12 grid-rows-6 gap-4", children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: "relative col-span-12 row-span-4 lg:h-auto lg:col-span-8 lg:row-span-6",
            onClick: () => setGalleryOpenIndex(0),
            children: HeroImage
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: "col-span-6 row-span-2 bg-blueLight-200 lg:col-span-4 lg:row-span-3",
            onClick: () => setGalleryOpenIndex(1),
            children: BlueprintElement
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "relative col-span-6 row-span-2 lg:col-span-4 lg:row-span-3", children: MapElement })
      ] });
    }
    if (BlueprintElement && !HeroImage) {
      return /* @__PURE__ */ jsxs("div", { className: "flex h-full gap-4", children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: "w-1/2 bg-blueLight-200",
            onClick: () => setGalleryOpenIndex(0),
            children: BlueprintElement
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "relative w-1/2", children: MapElement })
      ] });
    }
    if (!BlueprintElement && HeroImage) {
      return /* @__PURE__ */ jsxs("div", { className: "flex h-full gap-4", children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: "w-1/2 lg:w-2/3",
            onClick: () => setGalleryOpenIndex(0),
            children: HeroImage
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "relative w-1/2 lg:w-1/3", children: MapElement })
      ] });
    }
    return /* @__PURE__ */ jsx("div", { className: "relative h-full", children: MapElement });
  }
  const HeroElement = getPanelContent();
  const tags = getTags(listingInfo, t2);
  const show_interest_links = buyer_service_links && buyer_service_links.interested && buyer_service_links.reject;
  const show_add_match_link = buyer_service_links && buyer_service_links.add_match;
  const show_cta = show_interest_links || show_add_match_link || case_type === "sell_from_buyer_service";
  return /* @__PURE__ */ jsx(ListingContext.Provider, { value: {
    linkComponent: null
  }, children: /* @__PURE__ */ jsx("div", { id: "scout-app", className: "tailwind", children: /* @__PURE__ */ jsxs("div", { className: "antialiased", children: [
    /* @__PURE__ */ jsxs("div", { className: "relative overflow-x-hidden", children: [
      /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-12 gap-4", children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: cx(
              "col-span-12 row-start-1 lg:col-span-7 lg:row-start-auto min-h-[300px] relative overflow-hidden",
              {
                "lg:max-h-[470px]": !anonymized && !is_secondary_match && !note_from_agent
              }
            ),
            children: HeroElement
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: cx(
          "flex flex-col justify-center col-span-12 row-start-3 px-4 pt-6 pb-0 md:py-6 space-y-12 lg:py-12 lg:bg-gray-200 lg:col-span-5 lg:row-start-auto",
          {
            "lg:max-h-[470px]": !anonymized && !is_secondary_match && !note_from_agent
          }
        ), children: [
          /* @__PURE__ */ jsx(
            ScoutHeader,
            {
              listingInfo,
              country
            }
          ),
          anonymized && /* @__PURE__ */ jsx("p", { class: "text-sm max-w-[420px] leading-[1.6] mt-4", children: t2("anonymized_info") }),
          is_secondary_match && /* @__PURE__ */ jsx("p", { class: "text-sm max-w-[420px] leading-[1.6] mt-4", children: /* @__PURE__ */ jsx(Trans, { i18nKey: "secondary_match_note", components: [/* @__PURE__ */ jsx("b", {})] }) }),
          note_from_agent && /* @__PURE__ */ jsxs("p", { class: "text-sm max-w-[420px] leading-[1.6] mt-4", children: [
            "“",
            note_from_agent,
            "”",
            /* @__PURE__ */ jsx("br", {}),
            "–",
            t2("broker")
          ] })
        ] }),
        /* @__PURE__ */ jsx("div", { className: "col-span-12 row-start-2 lg:col-span-12 lg:row-start-auto", children: /* @__PURE__ */ jsx(
          ScoutPhotoSlider,
          {
            blueprint: blueprint ? blueprint : null,
            hero,
            hero_thumbnail,
            hasVirtualPresentation: virtualpresentation ? true : false,
            openIndex: galleryOpenIndex,
            setOpenIndex: setGalleryOpenIndex,
            photos,
            map: MapElement
          }
        ) })
      ] }),
      /* @__PURE__ */ jsx("div", { className: "container px-4 mt-10 lg:mt-14", children: /* @__PURE__ */ jsxs("div", { className: cx(
        "flex flex-col justify-between mt-8 space-y-10 lg:mt-12 md:flex-row md:space-x-8 md:space-y-0",
        {
          "min-h-[350px]": !listing_owner_story
        }
      ), children: [
        /* @__PURE__ */ jsxs("div", { className: "flex flex-col w-full md:w-8/12", children: [
          listing_owner_story && /* @__PURE__ */ jsx(ListingTextDescription, { children: listing_owner_story }),
          !listing_owner_story && /* @__PURE__ */ jsx("div", { className: "relative w-full h-[300px] md:h-full order-last", children: getMapElement(false) }),
          tags.length > 0 && /* @__PURE__ */ jsx("div", { className: cx({
            "mb-10 md:mt-10 md:mb-0 order-first md:order-last": !listing_owner_story
          }), children: /* @__PURE__ */ jsx(ScoutTags, { tags }) })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "w-full hidden md:block md:w-5/12 lg:w-4/12", children: [
          show_cta && /* @__PURE__ */ jsx(
            ScoutCTA,
            {
              show_interest_links,
              show_add_match_link,
              buyer_service_links,
              potential_buyer_count,
              offer_deadline,
              case_type,
              listingGuid,
              country
            }
          ),
          has_documents && /* @__PURE__ */ jsx(
            ScoutDocuments,
            {
              buyer_service_links,
              listingGuid
            }
          )
        ] })
      ] }) }),
      /* @__PURE__ */ jsx("div", { className: "container px-0 mt-10 lg:px-6 lg:mt-14", children: /* @__PURE__ */ jsxs("div", { className: "border-t border-b border-gray-500 divide-y divide-gray-500 lg:divide-y-0 lg:border-none lg:border-b-0", children: [
        /* @__PURE__ */ jsx(ListingPriceInfo, { listingInfo }),
        /* @__PURE__ */ jsx(ListingBasicInfo, { listingInfo }),
        /* @__PURE__ */ jsx(
          ListingRenovationInfo,
          {
            pastRenovations: listingInfo.past_renovations,
            upcomingRenovations: listingInfo.upcoming_renovations
          }
        )
      ] }) }),
      /* @__PURE__ */ jsxs("div", { className: "w-full md:hidden my-10", children: [
        show_cta && /* @__PURE__ */ jsx(
          ScoutCTA,
          {
            buyer_service_links,
            potential_buyer_count,
            offer_deadline,
            case_type,
            listingGuid,
            country
          }
        ),
        has_documents && /* @__PURE__ */ jsx(
          ScoutDocuments,
          {
            buyer_service_links,
            listingGuid
          }
        )
      ] })
    ] }),
    show_interest_links && onMobile && /* @__PURE__ */ jsx(ScoutMobileCTA, { buyer_service_links })
  ] }) }) });
}
/**
 * @remix-run/router v1.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
var Action;
(function(Action2) {
  Action2["Pop"] = "POP";
  Action2["Push"] = "PUSH";
  Action2["Replace"] = "REPLACE";
})(Action || (Action = {}));
function invariant(value, message) {
  if (value === false || value === null || typeof value === "undefined") {
    throw new Error(message);
  }
}
var ResultType;
(function(ResultType2) {
  ResultType2["data"] = "data";
  ResultType2["deferred"] = "deferred";
  ResultType2["redirect"] = "redirect";
  ResultType2["error"] = "error";
})(ResultType || (ResultType = {}));
const validMutationMethodsArr = ["post", "put", "patch", "delete"];
["get", ...validMutationMethodsArr];
/**
 * React Router v6.8.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function isPolyfill(x2, y2) {
  return x2 === y2 && (x2 !== 0 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
}
const is = typeof Object.is === "function" ? Object.is : isPolyfill;
const {
  useState,
  useEffect,
  useLayoutEffect,
  useDebugValue
} = React$3;
let didWarnOld18Alpha = false;
let didWarnUncachedGetSnapshot = false;
function useSyncExternalStore$2(subscribe, getSnapshot, getServerSnapshot) {
  if (process.env.NODE_ENV !== "production") {
    if (!didWarnOld18Alpha) {
      if ("startTransition" in React$3) {
        didWarnOld18Alpha = true;
        console.error("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release.");
      }
    }
  }
  const value = getSnapshot();
  if (process.env.NODE_ENV !== "production") {
    if (!didWarnUncachedGetSnapshot) {
      const cachedValue = getSnapshot();
      if (!is(value, cachedValue)) {
        console.error("The result of getSnapshot should be cached to avoid an infinite loop");
        didWarnUncachedGetSnapshot = true;
      }
    }
  }
  const [{
    inst
  }, forceUpdate] = useState({
    inst: {
      value,
      getSnapshot
    }
  });
  useLayoutEffect(() => {
    inst.value = value;
    inst.getSnapshot = getSnapshot;
    if (checkIfSnapshotChanged(inst)) {
      forceUpdate({
        inst
      });
    }
  }, [subscribe, value, getSnapshot]);
  useEffect(() => {
    if (checkIfSnapshotChanged(inst)) {
      forceUpdate({
        inst
      });
    }
    const handleStoreChange = () => {
      if (checkIfSnapshotChanged(inst)) {
        forceUpdate({
          inst
        });
      }
    };
    return subscribe(handleStoreChange);
  }, [subscribe]);
  useDebugValue(value);
  return value;
}
function checkIfSnapshotChanged(inst) {
  const latestGetSnapshot = inst.getSnapshot;
  const prevValue = inst.value;
  try {
    const nextValue = latestGetSnapshot();
    return !is(prevValue, nextValue);
  } catch (error2) {
    return true;
  }
}
function useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
  return getSnapshot();
}
const canUseDOM$1 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const isServerEnvironment = !canUseDOM$1;
const shim = isServerEnvironment ? useSyncExternalStore$1 : useSyncExternalStore$2;
"useSyncExternalStore" in React$3 ? ((module) => module.useSyncExternalStore)(React$3) : shim;
const DataRouterContext = /* @__PURE__ */ React$3.createContext(null);
if (process.env.NODE_ENV !== "production") {
  DataRouterContext.displayName = "DataRouter";
}
const DataRouterStateContext = /* @__PURE__ */ React$3.createContext(null);
if (process.env.NODE_ENV !== "production") {
  DataRouterStateContext.displayName = "DataRouterState";
}
const AwaitContext = /* @__PURE__ */ React$3.createContext(null);
if (process.env.NODE_ENV !== "production") {
  AwaitContext.displayName = "Await";
}
const NavigationContext = /* @__PURE__ */ React$3.createContext(null);
if (process.env.NODE_ENV !== "production") {
  NavigationContext.displayName = "Navigation";
}
const LocationContext = /* @__PURE__ */ React$3.createContext(null);
if (process.env.NODE_ENV !== "production") {
  LocationContext.displayName = "Location";
}
const RouteContext = /* @__PURE__ */ React$3.createContext({
  outlet: null,
  matches: []
});
if (process.env.NODE_ENV !== "production") {
  RouteContext.displayName = "Route";
}
const RouteErrorContext = /* @__PURE__ */ React$3.createContext(null);
if (process.env.NODE_ENV !== "production") {
  RouteErrorContext.displayName = "RouteError";
}
function useParams() {
  let {
    matches
  } = React$3.useContext(RouteContext);
  let routeMatch = matches[matches.length - 1];
  return routeMatch ? routeMatch.params : {};
}
var DataRouterHook;
(function(DataRouterHook2) {
  DataRouterHook2["UseBlocker"] = "useBlocker";
  DataRouterHook2["UseRevalidator"] = "useRevalidator";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(DataRouterStateHook2) {
  DataRouterStateHook2["UseLoaderData"] = "useLoaderData";
  DataRouterStateHook2["UseActionData"] = "useActionData";
  DataRouterStateHook2["UseRouteError"] = "useRouteError";
  DataRouterStateHook2["UseNavigation"] = "useNavigation";
  DataRouterStateHook2["UseRouteLoaderData"] = "useRouteLoaderData";
  DataRouterStateHook2["UseMatches"] = "useMatches";
  DataRouterStateHook2["UseRevalidator"] = "useRevalidator";
})(DataRouterStateHook || (DataRouterStateHook = {}));
function getDataRouterConsoleError(hookName) {
  return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterState(hookName) {
  let state = React$3.useContext(DataRouterStateContext);
  !state ? process.env.NODE_ENV !== "production" ? invariant(false, getDataRouterConsoleError(hookName)) : invariant(false) : void 0;
  return state;
}
function useRouteContext(hookName) {
  let route = React$3.useContext(RouteContext);
  !route ? process.env.NODE_ENV !== "production" ? invariant(false, getDataRouterConsoleError(hookName)) : invariant(false) : void 0;
  return route;
}
function useCurrentRouteId(hookName) {
  let route = useRouteContext(hookName);
  let thisRoute = route.matches[route.matches.length - 1];
  !thisRoute.route.id ? process.env.NODE_ENV !== "production" ? invariant(false, hookName + ' can only be used on routes that contain a unique "id"') : invariant(false) : void 0;
  return thisRoute.route.id;
}
function useLoaderData() {
  let state = useDataRouterState(DataRouterStateHook.UseLoaderData);
  let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
  if (state.errors && state.errors[routeId] != null) {
    console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
    return void 0;
  }
  return state.loaderData[routeId];
}
var AwaitRenderStatus;
(function(AwaitRenderStatus2) {
  AwaitRenderStatus2[AwaitRenderStatus2["pending"] = 0] = "pending";
  AwaitRenderStatus2[AwaitRenderStatus2["success"] = 1] = "success";
  AwaitRenderStatus2[AwaitRenderStatus2["error"] = 2] = "error";
})(AwaitRenderStatus || (AwaitRenderStatus = {}));
new Promise(() => {
});
var TrackVisibility$1 = {};
var propTypesExports = {};
var propTypes = {
  get exports() {
    return propTypesExports;
  },
  set exports(v2) {
    propTypesExports = v2;
  }
};
var reactIsExports = {};
var reactIs = {
  get exports() {
    return reactIsExports;
  },
  set exports(v2) {
    reactIsExports = v2;
  }
};
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min)
    return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for, c2 = b ? Symbol.for("react.element") : 60103, d2 = b ? Symbol.for("react.portal") : 60106, e2 = b ? Symbol.for("react.fragment") : 60107, f2 = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h2 = b ? Symbol.for("react.provider") : 60109, k2 = b ? Symbol.for("react.context") : 60110, l2 = b ? Symbol.for("react.async_mode") : 60111, m2 = b ? Symbol.for("react.concurrent_mode") : 60111, n2 = b ? Symbol.for("react.forward_ref") : 60112, p2 = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r2 = b ? Symbol.for("react.memo") : 60115, t2 = b ? Symbol.for("react.lazy") : 60116, v2 = b ? Symbol.for("react.block") : 60121, w2 = b ? Symbol.for("react.fundamental") : 60117, x2 = b ? Symbol.for("react.responder") : 60118, y2 = b ? Symbol.for("react.scope") : 60119;
  function z2(a2) {
    if ("object" === typeof a2 && null !== a2) {
      var u2 = a2.$$typeof;
      switch (u2) {
        case c2:
          switch (a2 = a2.type, a2) {
            case l2:
            case m2:
            case e2:
            case g:
            case f2:
            case p2:
              return a2;
            default:
              switch (a2 = a2 && a2.$$typeof, a2) {
                case k2:
                case n2:
                case t2:
                case r2:
                case h2:
                  return a2;
                default:
                  return u2;
              }
          }
        case d2:
          return u2;
      }
    }
  }
  function A2(a2) {
    return z2(a2) === m2;
  }
  reactIs_production_min.AsyncMode = l2;
  reactIs_production_min.ConcurrentMode = m2;
  reactIs_production_min.ContextConsumer = k2;
  reactIs_production_min.ContextProvider = h2;
  reactIs_production_min.Element = c2;
  reactIs_production_min.ForwardRef = n2;
  reactIs_production_min.Fragment = e2;
  reactIs_production_min.Lazy = t2;
  reactIs_production_min.Memo = r2;
  reactIs_production_min.Portal = d2;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f2;
  reactIs_production_min.Suspense = p2;
  reactIs_production_min.isAsyncMode = function(a2) {
    return A2(a2) || z2(a2) === l2;
  };
  reactIs_production_min.isConcurrentMode = A2;
  reactIs_production_min.isContextConsumer = function(a2) {
    return z2(a2) === k2;
  };
  reactIs_production_min.isContextProvider = function(a2) {
    return z2(a2) === h2;
  };
  reactIs_production_min.isElement = function(a2) {
    return "object" === typeof a2 && null !== a2 && a2.$$typeof === c2;
  };
  reactIs_production_min.isForwardRef = function(a2) {
    return z2(a2) === n2;
  };
  reactIs_production_min.isFragment = function(a2) {
    return z2(a2) === e2;
  };
  reactIs_production_min.isLazy = function(a2) {
    return z2(a2) === t2;
  };
  reactIs_production_min.isMemo = function(a2) {
    return z2(a2) === r2;
  };
  reactIs_production_min.isPortal = function(a2) {
    return z2(a2) === d2;
  };
  reactIs_production_min.isProfiler = function(a2) {
    return z2(a2) === g;
  };
  reactIs_production_min.isStrictMode = function(a2) {
    return z2(a2) === f2;
  };
  reactIs_production_min.isSuspense = function(a2) {
    return z2(a2) === p2;
  };
  reactIs_production_min.isValidElementType = function(a2) {
    return "string" === typeof a2 || "function" === typeof a2 || a2 === e2 || a2 === m2 || a2 === g || a2 === f2 || a2 === p2 || a2 === q || "object" === typeof a2 && null !== a2 && (a2.$$typeof === t2 || a2.$$typeof === r2 || a2.$$typeof === h2 || a2.$$typeof === k2 || a2.$$typeof === n2 || a2.$$typeof === w2 || a2.$$typeof === x2 || a2.$$typeof === y2 || a2.$$typeof === v2);
  };
  reactIs_production_min.typeOf = z2;
  return reactIs_production_min;
}
var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development)
    return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type2) {
        return typeof type2 === "string" || typeof type2 === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type2 === REACT_FRAGMENT_TYPE || type2 === REACT_CONCURRENT_MODE_TYPE || type2 === REACT_PROFILER_TYPE || type2 === REACT_STRICT_MODE_TYPE || type2 === REACT_SUSPENSE_TYPE || type2 === REACT_SUSPENSE_LIST_TYPE || typeof type2 === "object" && type2 !== null && (type2.$$typeof === REACT_LAZY_TYPE || type2.$$typeof === REACT_MEMO_TYPE || type2.$$typeof === REACT_PROVIDER_TYPE || type2.$$typeof === REACT_CONTEXT_TYPE || type2.$$typeof === REACT_FORWARD_REF_TYPE || type2.$$typeof === REACT_FUNDAMENTAL_TYPE || type2.$$typeof === REACT_RESPONDER_TYPE || type2.$$typeof === REACT_SCOPE_TYPE || type2.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type2 = object.type;
              switch (type2) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type2;
                default:
                  var $$typeofType = type2 && type2.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element2;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs)
    return reactIsExports;
  hasRequiredReactIs = 1;
  (function(module) {
    if (process.env.NODE_ENV === "production") {
      module.exports = requireReactIs_production_min();
    } else {
      module.exports = requireReactIs_development();
    }
  })(reactIs);
  return reactIsExports;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret)
    return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas)
    return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes)
    return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = requireHas();
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x2) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error2;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error2 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error2 = ex;
          }
          if (error2 && !(error2 instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error2 + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error2 instanceof Error && !(error2.message in loggedTypeFailures)) {
            loggedTypeFailures[error2.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning(
              "Failed " + location + " type: " + error2.message + (stack != null ? stack : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers)
    return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has2 = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x2) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement2, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is2(x2, y2) {
      if (x2 === y2) {
        return x2 !== 0 || 1 / x2 === 1 / y2;
      } else {
        return x2 !== x2 && y2 !== y2;
      }
    }
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === "object" ? data : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i2 = 0; i2 < propValue.length; i2++) {
          var error2 = typeChecker(propValue, i2, componentName, location, propFullName + "[" + i2 + "]", ReactPropTypesSecret);
          if (error2 instanceof Error) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement2(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i2 = 0; i2 < expectedValues.length; i2++) {
          if (is2(propValue, expectedValues[i2])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type2 = getPreciseType(value);
          if (type2 === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error2 = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error2 instanceof Error) {
              return error2;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
        var checker = arrayOfTypeCheckers[i2];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i2 + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i3 = 0; i3 < arrayOfTypeCheckers.length; i3++) {
          var checker2 = arrayOfTypeCheckers[i3];
          var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode2(props[propName])) {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type2) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type2 + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error2 = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error2) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error2 = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error2) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode2(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode2);
          }
          if (propValue === null || isValidElement2(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode2(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode2(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol2(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol2(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type2 = getPreciseType(value);
      switch (type2) {
        case "array":
        case "object":
          return "an " + type2;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type2;
        default:
          return type2;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims)
    return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim2(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim2.isRequired = shim2;
    function getShim() {
      return shim2;
    }
    var ReactPropTypes = {
      array: shim2,
      bigint: shim2,
      bool: shim2,
      func: shim2,
      number: shim2,
      object: shim2,
      string: shim2,
      symbol: shim2,
      any: shim2,
      arrayOf: getShim,
      element: shim2,
      elementType: shim2,
      instanceOf: getShim,
      node: shim2,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs();
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  propTypes.exports = requireFactoryWithThrowingShims()();
}
var FUNC_ERROR_TEXT$1 = "Expected a function";
var NAN = 0 / 0;
var symbolTag = "[object Symbol]";
var reTrim = /^\s+|\s+$/g;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$1 = freeGlobal || freeSelf || Function("return this")();
var objectProto = Object.prototype;
var objectToString = objectProto.toString;
var nativeMax$1 = Math.max, nativeMin$1 = Math.min;
var now$2 = function() {
  return root$1.Date.now();
};
function debounce$1(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber$1(wait) || 0;
  if (isObject$1(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax$1(toNumber$1(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result2 = wait - timeSinceLastCall;
    return maxing ? nativeMin$1(result2, maxWait - timeSinceLastInvoke) : result2;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now$2();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now$2());
  }
  function debounced() {
    var time = now$2(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
function throttle(func, wait, options) {
  var leading = true, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  if (isObject$1(options)) {
    leading = "leading" in options ? !!options.leading : leading;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  return debounce$1(func, wait, {
    "leading": leading,
    "maxWait": wait,
    "trailing": trailing
  });
}
function isObject$1(value) {
  var type2 = typeof value;
  return !!value && (type2 == "object" || type2 == "function");
}
function isObjectLike(value) {
  return !!value && typeof value == "object";
}
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
function toNumber$1(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$1(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, "");
  var isBinary2 = reIsBinary.test(value);
  return isBinary2 || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary2 ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var lodash_throttle = throttle;
var shallowequal = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
  if (ret !== void 0) {
    return !!ret;
  }
  if (objA === objB) {
    return true;
  }
  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }
  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) {
    return false;
  }
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];
    if (!bHasOwnProperty(key)) {
      return false;
    }
    var valueA = objA[key];
    var valueB = objB[key];
    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
    if (ret === false || ret === void 0 && valueA !== valueB) {
      return false;
    }
  }
  return true;
};
TrackVisibility$1.__esModule = true;
TrackVisibility$1.default = void 0;
var _react = _interopRequireWildcard(React__default$1);
var _propTypes = _interopRequireDefault$1(propTypesExports);
var _lodash = _interopRequireDefault$1(lodash_throttle);
var _shallowequal = _interopRequireDefault$1(shallowequal);
function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _extends$1() {
  _extends$1 = Object.assign || function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
var TrackVisibility = /* @__PURE__ */ function(_PureComponent) {
  _inheritsLoose$1(TrackVisibility2, _PureComponent);
  function TrackVisibility2(props) {
    var _this;
    _this = _PureComponent.call(this, props) || this;
    _this.isVisible = function(_ref, windowWidth, windowHeight) {
      var top = _ref.top, left = _ref.left, bottom = _ref.bottom, right = _ref.right, width = _ref.width, height = _ref.height;
      var _this$props = _this.props, offset2 = _this$props.offset, partialVisibility = _this$props.partialVisibility;
      if (top + right + bottom + left === 0) {
        return false;
      }
      var topThreshold = 0 - offset2;
      var leftThreshold = 0 - offset2;
      var widthCheck = windowWidth + offset2;
      var heightCheck = windowHeight + offset2;
      return partialVisibility ? top + height >= topThreshold && left + width >= leftThreshold && bottom - height <= heightCheck && right - width <= widthCheck : top >= topThreshold && left >= leftThreshold && bottom <= heightCheck && right <= widthCheck;
    };
    _this.isComponentVisible = function() {
      setTimeout(function() {
        if (!_this.nodeRef || !_this.nodeRef.getBoundingClientRect)
          return;
        var html = document.documentElement;
        var once = _this.props.once;
        var boundingClientRect = _this.nodeRef.getBoundingClientRect();
        var windowWidth = window.innerWidth || html.clientWidth;
        var windowHeight = window.innerHeight || html.clientHeight;
        var isVisible = _this.isVisible(boundingClientRect, windowWidth, windowHeight);
        if (isVisible && once) {
          _this.removeListener();
        }
        _this.setState({
          isVisible
        });
      }, 0);
    };
    _this.setNodeRef = function(ref) {
      return _this.nodeRef = ref;
    };
    _this.ownProps = Object.keys(TrackVisibility2.propTypes);
    _this.state = {
      isVisible: false
    };
    _this.throttleCb = (0, _lodash.default)(_this.isComponentVisible, _this.props.throttleInterval);
    props.nodeRef && _this.setNodeRef(props.nodeRef);
    return _this;
  }
  var _proto = TrackVisibility2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.attachListener();
    this.isComponentVisible();
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!(0, _shallowequal.default)(this.getChildProps(this.props), this.getChildProps(prevProps))) {
      this.isComponentVisible();
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeListener();
  };
  _proto.attachListener = function attachListener() {
    window.addEventListener("scroll", this.throttleCb);
    window.addEventListener("resize", this.throttleCb);
  };
  _proto.removeListener = function removeListener() {
    window.removeEventListener("scroll", this.throttleCb);
    window.removeEventListener("resize", this.throttleCb);
  };
  _proto.getChildProps = function getChildProps(props) {
    var _this2 = this;
    if (props === void 0) {
      props = this.props;
    }
    var childProps = {};
    Object.keys(props).forEach(function(key) {
      if (_this2.ownProps.indexOf(key) === -1) {
        childProps[key] = props[key];
      }
    });
    return childProps;
  };
  _proto.getChildren = function getChildren2() {
    var _this3 = this;
    if (typeof this.props.children === "function") {
      return this.props.children(_extends$1({}, this.getChildProps(), {
        isVisible: this.state.isVisible
      }));
    }
    return _react.default.Children.map(this.props.children, function(child) {
      return _react.default.cloneElement(child, _extends$1({}, _this3.getChildProps(), {
        isVisible: _this3.state.isVisible
      }));
    });
  };
  _proto.render = function render() {
    var _this$props2 = this.props, className = _this$props2.className, style = _this$props2.style, nodeRef = _this$props2.nodeRef, Tag = _this$props2.tag;
    var props = _extends$1({}, className && {
      className
    }, style && {
      style
    });
    return _react.default.createElement(Tag, _extends$1({
      ref: !nodeRef && this.setNodeRef
    }, props), this.getChildren());
  };
  return TrackVisibility2;
}(_react.PureComponent);
TrackVisibility$1.default = TrackVisibility;
TrackVisibility.propTypes = {
  /**
   * Define if the visibility need to be tracked once
   */
  once: _propTypes.default.bool,
  /**
   * Tweak the throttle interval
   * Check https://css-tricks.com/debouncing-throttling-explained-examples/ for more details
   */
  throttleInterval: function throttleInterval(props, propName, component) {
    var currentProp = props[propName];
    if (!Number.isInteger(currentProp) || currentProp < 0) {
      return new Error("The " + propName + " prop you provided to " + component + " is not a valid integer >= 0.");
    }
    return null;
  },
  /**
   * Pass one or more children to track
   */
  children: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element, _propTypes.default.arrayOf(_propTypes.default.element)]),
  /**
   * Additional style to apply
   */
  style: _propTypes.default.object,
  /**
   * Additional className to apply
   */
  className: _propTypes.default.string,
  /**
   * Define an offset. Can be useful for lazy loading
   */
  offset: _propTypes.default.number,
  /**
   * Update the visibility state as soon as a part of the tracked component is visible
   */
  partialVisibility: _propTypes.default.bool,
  /**
   * Exposed for testing but allows node other than internal wrapping <div /> to be tracked
   * for visibility
   */
  nodeRef: _propTypes.default.object,
  /**
   * Define a custom tag
   */
  tag: _propTypes.default.string
};
TrackVisibility.defaultProps = {
  once: false,
  throttleInterval: 150,
  offset: 0,
  partialVisibility: false,
  tag: "div"
};
var default_1 = void 0;
var _TrackVisibility = _interopRequireDefault(TrackVisibility$1);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var _default$1 = _TrackVisibility.default;
default_1 = _default$1;
var root = _root;
var now$1 = function() {
  return root.Date.now();
};
var now_1 = now$1;
var isObject = isObject_1, now = now_1, toNumber = toNumber_1;
var FUNC_ERROR_TEXT = "Expected a function";
var nativeMax = Math.max, nativeMin = Math.min;
function debounce(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now());
  }
  function debounced() {
    var time = now(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var debounce_1 = debounce;
var ClipLoader$1 = {};
var __assign = commonjsGlobal && commonjsGlobal.__assign || function() {
  __assign = Object.assign || function(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o3, m2, k2, k22) {
  if (k22 === void 0)
    k22 = k2;
  var desc = Object.getOwnPropertyDescriptor(m2, k2);
  if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) {
    desc = { enumerable: true, get: function() {
      return m2[k2];
    } };
  }
  Object.defineProperty(o3, k22, desc);
} : function(o3, m2, k2, k22) {
  if (k22 === void 0)
    k22 = k2;
  o3[k22] = m2[k2];
});
var __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o3, v2) {
  Object.defineProperty(o3, "default", { enumerable: true, value: v2 });
} : function(o3, v2) {
  o3["default"] = v2;
});
var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
  if (mod2 && mod2.__esModule)
    return mod2;
  var result = {};
  if (mod2 != null) {
    for (var k2 in mod2)
      if (k2 !== "default" && Object.prototype.hasOwnProperty.call(mod2, k2))
        __createBinding(result, mod2, k2);
  }
  __setModuleDefault(result, mod2);
  return result;
};
var __rest = commonjsGlobal && commonjsGlobal.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
Object.defineProperty(ClipLoader$1, "__esModule", { value: true });
var React$1 = __importStar(React__default$1);
var unitConverter_1 = unitConverter;
var animation_1 = animation;
var clip = (0, animation_1.createAnimation)("ClipLoader", "0% {transform: rotate(0deg) scale(1)} 50% {transform: rotate(180deg) scale(0.8)} 100% {transform: rotate(360deg) scale(1)}", "clip");
function ClipLoader(_a) {
  var _b = _a.loading, loading = _b === void 0 ? true : _b, _c = _a.color, color = _c === void 0 ? "#000000" : _c, _d = _a.speedMultiplier, speedMultiplier = _d === void 0 ? 1 : _d, _e2 = _a.cssOverride, cssOverride = _e2 === void 0 ? {} : _e2, _f = _a.size, size = _f === void 0 ? 35 : _f, additionalprops = __rest(_a, ["loading", "color", "speedMultiplier", "cssOverride", "size"]);
  var style = __assign({ background: "transparent !important", width: (0, unitConverter_1.cssValue)(size), height: (0, unitConverter_1.cssValue)(size), borderRadius: "100%", border: "2px solid", borderTopColor: color, borderBottomColor: "transparent", borderLeftColor: color, borderRightColor: color, display: "inline-block", animation: "".concat(clip, " ").concat(0.75 / speedMultiplier, "s 0s infinite linear"), animationFillMode: "both" }, cssOverride);
  if (!loading) {
    return null;
  }
  return React$1.createElement("span", __assign({ style }, additionalprops));
}
var _default = ClipLoader$1.default = ClipLoader;
function Blueprint({ blueprint, i18n, t: t2 }) {
  const [state, setState] = useState$1({
    lightbox: null
  });
  useEffect$1(() => {
    let lightbox = [];
    if (blueprint) {
      lightbox.push({
        src: `${blueprint}`,
        w: 0,
        h: 0
      });
    }
    lightbox.forEach((item, i2) => {
      const img = new Image();
      img.onload = function() {
        lightbox[parseInt(this.id)].w = this.width;
        lightbox[parseInt(this.id)].h = this.height;
      };
      img.src = item.src;
      img.id = i2;
    });
    setState({ lightbox });
  }, []);
  function openLightbox() {
    const pswpElement = document.querySelectorAll(".pswp")[0];
    const options = {
      history: false,
      focus: false,
      showAnimationDuration: 0,
      hideAnimationDuration: 0,
      fullscreenEl: false,
      zoomEl: false,
      shareEl: false
    };
    const gallery = new PhotoSwipe(
      pswpElement,
      PhotoSwipeUI_Default$1,
      state.lightbox,
      options
    );
    gallery.init();
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: "relative flex items-center justify-center group h-96",
        onClick: () => openLightbox(),
        style: { backgroundColor: "#e8f6f7" },
        children: [
          /* @__PURE__ */ jsx(Overlay, {}),
          /* @__PURE__ */ jsx(
            "img",
            {
              src: blueprint,
              alt: "Blueprint",
              className: "max-w-full max-h-full"
            }
          )
        ]
      },
      "item-blueprint"
    ),
    /* @__PURE__ */ jsx(Pswp, {})
  ] });
}
const Blueprint$1 = withTranslation()(Blueprint);
function ListingHeader({
  listingInfo,
  listingSold
}) {
  const { country, listingsUrl, linkDisabled } = useContext(ListingContext);
  const { t: t2 } = useTranslation();
  const priceDisplay = getPriceDisplay(listingInfo, listingSold, listingInfo.price_display);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: "text-gray-800", children: [
      /* @__PURE__ */ jsxs("h1", { className: "mb-4 text-blue-500 h3", children: [
        /* @__PURE__ */ jsxs("span", { className: "sr-only", children: [
          getCategoryDisplay(listingInfo.category),
          ":"
        ] }),
        listingInfo.location_street_address,
        country === "FI" && !listingSold && listingInfo.listing_display_specifier && ` ${listingInfo.location_specifier}`,
        country === "FI" && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("br", {}),
          listingInfo.location_postcode,
          " "
        ] }),
        country === "FI" && listingsUrl && !linkDisabled ? /* @__PURE__ */ jsx(
          Link,
          {
            url: `${listingsUrl}?country=FI&city=${listingInfo.location_municipality}&page=1`,
            children: listingInfo.location_municipality
          }
        ) : /* @__PURE__ */ jsx(Fragment, { children: ` ${listingInfo.location_municipality}` })
      ] }),
      /* @__PURE__ */ jsxs("div", { children: [
        listingInfo.case_type === "realty" && priceDisplay && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("p", { children: t2("bs_asking_price") }),
          /* @__PURE__ */ jsx("h4", { className: "mb-4 text-blue-500", children: priceDisplay })
        ] }),
        /* @__PURE__ */ jsx("p", { className: "text-[17px] leading-relaxed", children: listingInfo.floorplan_description }),
        country === "SE" && /* @__PURE__ */ jsx("p", { children: getAreaDisplay(listingInfo.area_living) })
      ] }),
      country === "SE" && /* @__PURE__ */ jsxs("div", { className: "mt-4", children: [
        listingInfo.bidding_open && /* @__PURE__ */ jsx("h4", { className: "text-blue-500", children: t2("bidding_open") }),
        listingInfo.bidding_open && listingInfo.highest_bid_display ? /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("p", { children: t2("highest_bid") }),
          /* @__PURE__ */ jsx("h3", { className: "text-blue-500", children: listingInfo.highest_bid_display })
        ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("p", { children: t2("price_for_sale_SE") }),
          /* @__PURE__ */ jsx("h3", { className: "text-blue-500", children: priceDisplay })
        ] })
      ] }),
      country === "FI" && /* @__PURE__ */ jsxs("div", { className: "mt-8", children: [
        /* @__PURE__ */ jsxs("h3", { className: "text-blue-500", children: [
          priceDisplay,
          " ",
          listingSold && `(${DateTime.fromISO(listingInfo.sold_at).toFormat(
            getLuxonDateFormat()
          )})`
        ] }),
        /* @__PURE__ */ jsxs("p", { children: [
          getAreaDisplay(listingInfo.area_living),
          " ",
          !listingSold && `(${listingInfo.price_per_square_display})`
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "grid text-gray-800 max-w-md grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-2", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-center space-x-2", children: [
        /* @__PURE__ */ jsx(SvgHousetype, { className: "flex-shrink-0 text-blue-500 fill-current w-11" }),
        /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("p", { className: "mb-1 text-sm", children: t2("type") }),
          /* @__PURE__ */ jsx("b", { className: "text-blue-500", children: getCategoryDisplay(listingInfo.category) })
        ] })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "flex items-center space-x-2", children: [
        /* @__PURE__ */ jsx(SvgBuilt, { className: "flex-shrink-0 text-blue-500 fill-current w-11" }),
        /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("p", { className: "mb-1 text-sm", children: t2("build_in") }),
          /* @__PURE__ */ jsx("b", { className: "text-blue-500", children: listingInfo.building_construction_year ? listingInfo.building_construction_year : "-" })
        ] })
      ] }),
      /* @__PURE__ */ jsx("div", { className: "flex items-center space-x-2", children: country === "FI" && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(SvgMaintenance, { className: "flex-shrink-0 text-blue-500 fill-current w-11" }),
        /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("p", { className: "mb-1 text-sm", children: t2("maintenance_fee") }),
          /* @__PURE__ */ jsx("b", { className: "text-blue-500", children: getMaintenanceFeeDisplay(listingInfo.fees, listingInfo.currency) })
        ] })
      ] }) || country === "SE" && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(SvgMonthlyFeeSe, { className: "flex-shrink-0 text-blue-500 fill-current w-11" }),
        /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("p", { className: "mb-1 text-sm", children: t2("association_fee") }),
          /* @__PURE__ */ jsx("b", { className: "text-blue-500", children: getAssociationFeeDisplay(listingInfo.fees, listingInfo.currency) })
        ] })
      ] }) }),
      /* @__PURE__ */ jsxs("div", { className: "flex items-center space-x-2", children: [
        /* @__PURE__ */ jsx(SvgLot, { className: "flex-shrink-0 text-blue-500 fill-current w-11" }),
        /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("p", { className: "mb-1 text-sm", children: t2(`lot_${country}`) }),
          /* @__PURE__ */ jsx("b", { className: "text-blue-500", children: getLotOwnershipDisplay(country, listingInfo.lot_ownership_type) || listingInfo.lot_ownership_info })
        ] })
      ] })
    ] })
  ] });
}
const SvgSpeechbubble = (props) => /* @__PURE__ */ React$3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 145 128.4", ...props }, /* @__PURE__ */ React$3.createElement("path", { d: "M112.2 96.8c18.1 0 32.8-14.6 32.8-32.6V32.6c0-18-14.7-32.6-32.8-32.6H32.8C14.7 0 0 14.6 0 32.6v31.6c0 18 14.7 32.6 32.8 32.6h35.3l35.4 31.3c.7.6 1.7.1 1.7-.8V96.7h7zm-43-1.8c-.2-.2-.4-.3-.7-.3H32.8c-17 0-30.7-13.7-30.7-30.6V32.5c0-16.9 13.8-30.6 30.7-30.6h79.4c17 0 30.7 13.7 30.7 30.6v31.6c0 16.9-13.8 30.6-30.7 30.6h-7.9c-.6 0-1 .5-1 1V125L69.2 95z" }));
const apartment_se = {
  agent: {
    name: true,
    phone: true,
    email: false,
    image: true,
    profile_picture: true
  }
};
const contactConfig = {
  apartment_se
};
function trackFbq(eventType, eventName) {
  if (typeof fbq !== "undefined") {
    fbq(eventType, eventName);
    return true;
  }
  return false;
}
function BsPlus(props) {
  return GenIcon({ "tag": "svg", "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" } }] })(props);
}
function BsX(props) {
  return GenIcon({ "tag": "svg", "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" } }] })(props);
}
function _interopDefault(ex) {
  return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}
var React = React__default$1;
var React__default = _interopDefault(React);
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function withSideEffect(reducePropsToState3, handleStateChangeOnClient, mapStateOnServer3) {
  if (typeof reducePropsToState3 !== "function") {
    throw new Error("Expected reducePropsToState to be a function.");
  }
  if (typeof handleStateChangeOnClient !== "function") {
    throw new Error("Expected handleStateChangeOnClient to be a function.");
  }
  if (typeof mapStateOnServer3 !== "undefined" && typeof mapStateOnServer3 !== "function") {
    throw new Error("Expected mapStateOnServer to either be undefined or a function.");
  }
  function getDisplayName2(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || "Component";
  }
  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== "function") {
      throw new Error("Expected WrappedComponent to be a React component.");
    }
    var mountedInstances = [];
    var state;
    function emitChange() {
      state = reducePropsToState3(mountedInstances.map(function(instance2) {
        return instance2.props;
      }));
      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer3) {
        state = mapStateOnServer3(state);
      }
    }
    var SideEffect = /* @__PURE__ */ function(_PureComponent) {
      _inheritsLoose(SideEffect2, _PureComponent);
      function SideEffect2() {
        return _PureComponent.apply(this, arguments) || this;
      }
      SideEffect2.peek = function peek() {
        return state;
      };
      SideEffect2.rewind = function rewind() {
        if (SideEffect2.canUseDOM) {
          throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
        }
        var recordedState = state;
        state = void 0;
        mountedInstances = [];
        return recordedState;
      };
      var _proto = SideEffect2.prototype;
      _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };
      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };
      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };
      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };
      return SideEffect2;
    }(React.PureComponent);
    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName2(WrappedComponent) + ")");
    _defineProperty(SideEffect, "canUseDOM", canUseDOM);
    return SideEffect;
  };
}
var lib = withSideEffect;
var hasElementType = typeof Element !== "undefined";
var hasMap = typeof Map === "function";
var hasSet = typeof Set === "function";
var hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
function equal(a2, b) {
  if (a2 === b)
    return true;
  if (a2 && b && typeof a2 == "object" && typeof b == "object") {
    if (a2.constructor !== b.constructor)
      return false;
    var length, i2, keys2;
    if (Array.isArray(a2)) {
      length = a2.length;
      if (length != b.length)
        return false;
      for (i2 = length; i2-- !== 0; )
        if (!equal(a2[i2], b[i2]))
          return false;
      return true;
    }
    var it;
    if (hasMap && a2 instanceof Map && b instanceof Map) {
      if (a2.size !== b.size)
        return false;
      it = a2.entries();
      while (!(i2 = it.next()).done)
        if (!b.has(i2.value[0]))
          return false;
      it = a2.entries();
      while (!(i2 = it.next()).done)
        if (!equal(i2.value[1], b.get(i2.value[0])))
          return false;
      return true;
    }
    if (hasSet && a2 instanceof Set && b instanceof Set) {
      if (a2.size !== b.size)
        return false;
      it = a2.entries();
      while (!(i2 = it.next()).done)
        if (!b.has(i2.value[0]))
          return false;
      return true;
    }
    if (hasArrayBuffer && ArrayBuffer.isView(a2) && ArrayBuffer.isView(b)) {
      length = a2.length;
      if (length != b.length)
        return false;
      for (i2 = length; i2-- !== 0; )
        if (a2[i2] !== b[i2])
          return false;
      return true;
    }
    if (a2.constructor === RegExp)
      return a2.source === b.source && a2.flags === b.flags;
    if (a2.valueOf !== Object.prototype.valueOf)
      return a2.valueOf() === b.valueOf();
    if (a2.toString !== Object.prototype.toString)
      return a2.toString() === b.toString();
    keys2 = Object.keys(a2);
    length = keys2.length;
    if (length !== Object.keys(b).length)
      return false;
    for (i2 = length; i2-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(b, keys2[i2]))
        return false;
    if (hasElementType && a2 instanceof Element)
      return false;
    for (i2 = length; i2-- !== 0; ) {
      if ((keys2[i2] === "_owner" || keys2[i2] === "__v" || keys2[i2] === "__o") && a2.$$typeof) {
        continue;
      }
      if (!equal(a2[keys2[i2]], b[keys2[i2]]))
        return false;
    }
    return true;
  }
  return a2 !== a2 && b !== b;
}
var reactFastCompare = function isEqual(a2, b) {
  try {
    return equal(a2, b);
  } catch (error2) {
    if ((error2.message || "").match(/stack|recursion/i)) {
      console.warn("react-fast-compare cannot handle circular refs");
      return false;
    }
    throw error2;
  }
};
var objectAssignExports = requireObjectAssign();
const objectAssign = /* @__PURE__ */ getDefaultExportFromCjs(objectAssignExports);
var ATTRIBUTE_NAMES = {
  BODY: "bodyAttributes",
  HTML: "htmlAttributes",
  TITLE: "titleAttributes"
};
var TAG_NAMES = {
  BASE: "base",
  BODY: "body",
  HEAD: "head",
  HTML: "html",
  LINK: "link",
  META: "meta",
  NOSCRIPT: "noscript",
  SCRIPT: "script",
  STYLE: "style",
  TITLE: "title"
};
var VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function(name) {
  return TAG_NAMES[name];
});
var TAG_PROPERTIES = {
  CHARSET: "charset",
  CSS_TEXT: "cssText",
  HREF: "href",
  HTTPEQUIV: "http-equiv",
  INNER_HTML: "innerHTML",
  ITEM_PROP: "itemprop",
  NAME: "name",
  PROPERTY: "property",
  REL: "rel",
  SRC: "src",
  TARGET: "target"
};
var REACT_TAG_MAP = {
  accesskey: "accessKey",
  charset: "charSet",
  class: "className",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  "http-equiv": "httpEquiv",
  itemprop: "itemProp",
  tabindex: "tabIndex"
};
var HELMET_PROPS = {
  DEFAULT_TITLE: "defaultTitle",
  DEFER: "defer",
  ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
  ON_CHANGE_CLIENT_STATE: "onChangeClientState",
  TITLE_TEMPLATE: "titleTemplate"
};
var HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function(obj, key) {
  obj[REACT_TAG_MAP[key]] = key;
  return obj;
}, {});
var SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
var HELMET_ATTRIBUTE = "data-react-helmet";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var classCallCheck = function(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
var createClass = function() {
  function defineProperties(target, props) {
    for (var i2 = 0; i2 < props.length; i2++) {
      var descriptor = props[i2];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _extends = Object.assign || function(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var inherits = function(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var objectWithoutProperties = function(obj, keys2) {
  var target = {};
  for (var i2 in obj) {
    if (keys2.indexOf(i2) >= 0)
      continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i2))
      continue;
    target[i2] = obj[i2];
  }
  return target;
};
var possibleConstructorReturn = function(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
};
var encodeSpecialCharacters = function encodeSpecialCharacters2(str) {
  var encode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  if (encode === false) {
    return String(str);
  }
  return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var getTitleFromPropsList = function getTitleFromPropsList2(propsList) {
  var innermostTitle = getInnermostProperty(propsList, TAG_NAMES.TITLE);
  var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);
  if (innermostTemplate && innermostTitle) {
    return innermostTemplate.replace(/%s/g, function() {
      return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
  }
  var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);
  return innermostTitle || innermostDefaultTitle || void 0;
};
var getOnChangeClientState = function getOnChangeClientState2(propsList) {
  return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {
  };
};
var getAttributesFromPropsList = function getAttributesFromPropsList2(tagType, propsList) {
  return propsList.filter(function(props) {
    return typeof props[tagType] !== "undefined";
  }).map(function(props) {
    return props[tagType];
  }).reduce(function(tagAttrs, current) {
    return _extends({}, tagAttrs, current);
  }, {});
};
var getBaseTagFromPropsList = function getBaseTagFromPropsList2(primaryAttributes, propsList) {
  return propsList.filter(function(props) {
    return typeof props[TAG_NAMES.BASE] !== "undefined";
  }).map(function(props) {
    return props[TAG_NAMES.BASE];
  }).reverse().reduce(function(innermostBaseTag, tag2) {
    if (!innermostBaseTag.length) {
      var keys2 = Object.keys(tag2);
      for (var i2 = 0; i2 < keys2.length; i2++) {
        var attributeKey = keys2[i2];
        var lowerCaseAttributeKey = attributeKey.toLowerCase();
        if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag2[lowerCaseAttributeKey]) {
          return innermostBaseTag.concat(tag2);
        }
      }
    }
    return innermostBaseTag;
  }, []);
};
var getTagsFromPropsList = function getTagsFromPropsList2(tagName, primaryAttributes, propsList) {
  var approvedSeenTags = {};
  return propsList.filter(function(props) {
    if (Array.isArray(props[tagName])) {
      return true;
    }
    if (typeof props[tagName] !== "undefined") {
      warn2("Helmet: " + tagName + ' should be of type "Array". Instead found type "' + _typeof(props[tagName]) + '"');
    }
    return false;
  }).map(function(props) {
    return props[tagName];
  }).reverse().reduce(function(approvedTags, instanceTags) {
    var instanceSeenTags = {};
    instanceTags.filter(function(tag2) {
      var primaryAttributeKey = void 0;
      var keys3 = Object.keys(tag2);
      for (var i3 = 0; i3 < keys3.length; i3++) {
        var attributeKey2 = keys3[i3];
        var lowerCaseAttributeKey = attributeKey2.toLowerCase();
        if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === TAG_PROPERTIES.REL && tag2[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === TAG_PROPERTIES.REL && tag2[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
          primaryAttributeKey = lowerCaseAttributeKey;
        }
        if (primaryAttributes.indexOf(attributeKey2) !== -1 && (attributeKey2 === TAG_PROPERTIES.INNER_HTML || attributeKey2 === TAG_PROPERTIES.CSS_TEXT || attributeKey2 === TAG_PROPERTIES.ITEM_PROP)) {
          primaryAttributeKey = attributeKey2;
        }
      }
      if (!primaryAttributeKey || !tag2[primaryAttributeKey]) {
        return false;
      }
      var value = tag2[primaryAttributeKey].toLowerCase();
      if (!approvedSeenTags[primaryAttributeKey]) {
        approvedSeenTags[primaryAttributeKey] = {};
      }
      if (!instanceSeenTags[primaryAttributeKey]) {
        instanceSeenTags[primaryAttributeKey] = {};
      }
      if (!approvedSeenTags[primaryAttributeKey][value]) {
        instanceSeenTags[primaryAttributeKey][value] = true;
        return true;
      }
      return false;
    }).reverse().forEach(function(tag2) {
      return approvedTags.push(tag2);
    });
    var keys2 = Object.keys(instanceSeenTags);
    for (var i2 = 0; i2 < keys2.length; i2++) {
      var attributeKey = keys2[i2];
      var tagUnion = objectAssign({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
      approvedSeenTags[attributeKey] = tagUnion;
    }
    return approvedTags;
  }, []).reverse();
};
var getInnermostProperty = function getInnermostProperty2(propsList, property2) {
  for (var i2 = propsList.length - 1; i2 >= 0; i2--) {
    var props = propsList[i2];
    if (props.hasOwnProperty(property2)) {
      return props[property2];
    }
  }
  return null;
};
var reducePropsToState = function reducePropsToState2(propsList) {
  return {
    baseTag: getBaseTagFromPropsList([TAG_PROPERTIES.HREF, TAG_PROPERTIES.TARGET], propsList),
    bodyAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.BODY, propsList),
    defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
    encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
    htmlAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.HTML, propsList),
    linkTags: getTagsFromPropsList(TAG_NAMES.LINK, [TAG_PROPERTIES.REL, TAG_PROPERTIES.HREF], propsList),
    metaTags: getTagsFromPropsList(TAG_NAMES.META, [TAG_PROPERTIES.NAME, TAG_PROPERTIES.CHARSET, TAG_PROPERTIES.HTTPEQUIV, TAG_PROPERTIES.PROPERTY, TAG_PROPERTIES.ITEM_PROP], propsList),
    noscriptTags: getTagsFromPropsList(TAG_NAMES.NOSCRIPT, [TAG_PROPERTIES.INNER_HTML], propsList),
    onChangeClientState: getOnChangeClientState(propsList),
    scriptTags: getTagsFromPropsList(TAG_NAMES.SCRIPT, [TAG_PROPERTIES.SRC, TAG_PROPERTIES.INNER_HTML], propsList),
    styleTags: getTagsFromPropsList(TAG_NAMES.STYLE, [TAG_PROPERTIES.CSS_TEXT], propsList),
    title: getTitleFromPropsList(propsList),
    titleAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.TITLE, propsList)
  };
};
var rafPolyfill = function() {
  var clock = Date.now();
  return function(callback) {
    var currentTime = Date.now();
    if (currentTime - clock > 16) {
      clock = currentTime;
      callback(currentTime);
    } else {
      setTimeout(function() {
        rafPolyfill(callback);
      }, 0);
    }
  };
}();
var cafPolyfill = function cafPolyfill2(id) {
  return clearTimeout(id);
};
var requestAnimationFrame$1 = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
var cancelAnimationFrame$1 = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
var warn2 = function warn3(msg) {
  return console && typeof console.warn === "function" && console.warn(msg);
};
var _helmetCallback = null;
var handleClientStateChange = function handleClientStateChange2(newState) {
  if (_helmetCallback) {
    cancelAnimationFrame$1(_helmetCallback);
  }
  if (newState.defer) {
    _helmetCallback = requestAnimationFrame$1(function() {
      commitTagChanges(newState, function() {
        _helmetCallback = null;
      });
    });
  } else {
    commitTagChanges(newState);
    _helmetCallback = null;
  }
};
var commitTagChanges = function commitTagChanges2(newState, cb) {
  var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
  updateAttributes(TAG_NAMES.BODY, bodyAttributes);
  updateAttributes(TAG_NAMES.HTML, htmlAttributes);
  updateTitle(title, titleAttributes);
  var tagUpdates = {
    baseTag: updateTags(TAG_NAMES.BASE, baseTag),
    linkTags: updateTags(TAG_NAMES.LINK, linkTags),
    metaTags: updateTags(TAG_NAMES.META, metaTags),
    noscriptTags: updateTags(TAG_NAMES.NOSCRIPT, noscriptTags),
    scriptTags: updateTags(TAG_NAMES.SCRIPT, scriptTags),
    styleTags: updateTags(TAG_NAMES.STYLE, styleTags)
  };
  var addedTags = {};
  var removedTags = {};
  Object.keys(tagUpdates).forEach(function(tagType) {
    var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
    if (newTags.length) {
      addedTags[tagType] = newTags;
    }
    if (oldTags.length) {
      removedTags[tagType] = tagUpdates[tagType].oldTags;
    }
  });
  cb && cb();
  onChangeClientState(newState, addedTags, removedTags);
};
var flattenArray = function flattenArray2(possibleArray) {
  return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var updateTitle = function updateTitle2(title, attributes) {
  if (typeof title !== "undefined" && document.title !== title) {
    document.title = flattenArray(title);
  }
  updateAttributes(TAG_NAMES.TITLE, attributes);
};
var updateAttributes = function updateAttributes2(tagName, attributes) {
  var elementTag = document.getElementsByTagName(tagName)[0];
  if (!elementTag) {
    return;
  }
  var helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
  var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
  var attributesToRemove = [].concat(helmetAttributes);
  var attributeKeys = Object.keys(attributes);
  for (var i2 = 0; i2 < attributeKeys.length; i2++) {
    var attribute = attributeKeys[i2];
    var value = attributes[attribute] || "";
    if (elementTag.getAttribute(attribute) !== value) {
      elementTag.setAttribute(attribute, value);
    }
    if (helmetAttributes.indexOf(attribute) === -1) {
      helmetAttributes.push(attribute);
    }
    var indexToSave = attributesToRemove.indexOf(attribute);
    if (indexToSave !== -1) {
      attributesToRemove.splice(indexToSave, 1);
    }
  }
  for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
    elementTag.removeAttribute(attributesToRemove[_i]);
  }
  if (helmetAttributes.length === attributesToRemove.length) {
    elementTag.removeAttribute(HELMET_ATTRIBUTE);
  } else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
    elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
  }
};
var updateTags = function updateTags2(type2, tags) {
  var headElement = document.head || document.querySelector(TAG_NAMES.HEAD);
  var tagNodes = headElement.querySelectorAll(type2 + "[" + HELMET_ATTRIBUTE + "]");
  var oldTags = Array.prototype.slice.call(tagNodes);
  var newTags = [];
  var indexToDelete = void 0;
  if (tags && tags.length) {
    tags.forEach(function(tag2) {
      var newElement = document.createElement(type2);
      for (var attribute in tag2) {
        if (tag2.hasOwnProperty(attribute)) {
          if (attribute === TAG_PROPERTIES.INNER_HTML) {
            newElement.innerHTML = tag2.innerHTML;
          } else if (attribute === TAG_PROPERTIES.CSS_TEXT) {
            if (newElement.styleSheet) {
              newElement.styleSheet.cssText = tag2.cssText;
            } else {
              newElement.appendChild(document.createTextNode(tag2.cssText));
            }
          } else {
            var value = typeof tag2[attribute] === "undefined" ? "" : tag2[attribute];
            newElement.setAttribute(attribute, value);
          }
        }
      }
      newElement.setAttribute(HELMET_ATTRIBUTE, "true");
      if (oldTags.some(function(existingTag, index) {
        indexToDelete = index;
        return newElement.isEqualNode(existingTag);
      })) {
        oldTags.splice(indexToDelete, 1);
      } else {
        newTags.push(newElement);
      }
    });
  }
  oldTags.forEach(function(tag2) {
    return tag2.parentNode.removeChild(tag2);
  });
  newTags.forEach(function(tag2) {
    return headElement.appendChild(tag2);
  });
  return {
    oldTags,
    newTags
  };
};
var generateElementAttributesAsString = function generateElementAttributesAsString2(attributes) {
  return Object.keys(attributes).reduce(function(str, key) {
    var attr = typeof attributes[key] !== "undefined" ? key + '="' + attributes[key] + '"' : "" + key;
    return str ? str + " " + attr : attr;
  }, "");
};
var generateTitleAsString = function generateTitleAsString2(type2, title, attributes, encode) {
  var attributeString = generateElementAttributesAsString(attributes);
  var flattenedTitle = flattenArray(title);
  return attributeString ? "<" + type2 + " " + HELMET_ATTRIBUTE + '="true" ' + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type2 + ">" : "<" + type2 + " " + HELMET_ATTRIBUTE + '="true">' + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type2 + ">";
};
var generateTagsAsString = function generateTagsAsString2(type2, tags, encode) {
  return tags.reduce(function(str, tag2) {
    var attributeHtml = Object.keys(tag2).filter(function(attribute) {
      return !(attribute === TAG_PROPERTIES.INNER_HTML || attribute === TAG_PROPERTIES.CSS_TEXT);
    }).reduce(function(string, attribute) {
      var attr = typeof tag2[attribute] === "undefined" ? attribute : attribute + '="' + encodeSpecialCharacters(tag2[attribute], encode) + '"';
      return string ? string + " " + attr : attr;
    }, "");
    var tagContent = tag2.innerHTML || tag2.cssText || "";
    var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type2) === -1;
    return str + "<" + type2 + " " + HELMET_ATTRIBUTE + '="true" ' + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type2 + ">");
  }, "");
};
var convertElementAttributestoReactProps = function convertElementAttributestoReactProps2(attributes) {
  var initProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return Object.keys(attributes).reduce(function(obj, key) {
    obj[REACT_TAG_MAP[key] || key] = attributes[key];
    return obj;
  }, initProps);
};
var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes2(props) {
  var initAttributes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return Object.keys(props).reduce(function(obj, key) {
    obj[HTML_TAG_MAP[key] || key] = props[key];
    return obj;
  }, initAttributes);
};
var generateTitleAsReactComponent = function generateTitleAsReactComponent2(type2, title, attributes) {
  var _initProps;
  var initProps = (_initProps = {
    key: title
  }, _initProps[HELMET_ATTRIBUTE] = true, _initProps);
  var props = convertElementAttributestoReactProps(attributes, initProps);
  return [React__default$1.createElement(TAG_NAMES.TITLE, props, title)];
};
var generateTagsAsReactComponent = function generateTagsAsReactComponent2(type2, tags) {
  return tags.map(function(tag2, i2) {
    var _mappedTag;
    var mappedTag = (_mappedTag = {
      key: i2
    }, _mappedTag[HELMET_ATTRIBUTE] = true, _mappedTag);
    Object.keys(tag2).forEach(function(attribute) {
      var mappedAttribute = REACT_TAG_MAP[attribute] || attribute;
      if (mappedAttribute === TAG_PROPERTIES.INNER_HTML || mappedAttribute === TAG_PROPERTIES.CSS_TEXT) {
        var content = tag2.innerHTML || tag2.cssText;
        mappedTag.dangerouslySetInnerHTML = { __html: content };
      } else {
        mappedTag[mappedAttribute] = tag2[attribute];
      }
    });
    return React__default$1.createElement(type2, mappedTag);
  });
};
var getMethodsForTag = function getMethodsForTag2(type2, tags, encode) {
  switch (type2) {
    case TAG_NAMES.TITLE:
      return {
        toComponent: function toComponent() {
          return generateTitleAsReactComponent(type2, tags.title, tags.titleAttributes);
        },
        toString: function toString2() {
          return generateTitleAsString(type2, tags.title, tags.titleAttributes, encode);
        }
      };
    case ATTRIBUTE_NAMES.BODY:
    case ATTRIBUTE_NAMES.HTML:
      return {
        toComponent: function toComponent() {
          return convertElementAttributestoReactProps(tags);
        },
        toString: function toString2() {
          return generateElementAttributesAsString(tags);
        }
      };
    default:
      return {
        toComponent: function toComponent() {
          return generateTagsAsReactComponent(type2, tags);
        },
        toString: function toString2() {
          return generateTagsAsString(type2, tags, encode);
        }
      };
  }
};
var mapStateOnServer = function mapStateOnServer2(_ref) {
  var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === void 0 ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
  return {
    base: getMethodsForTag(TAG_NAMES.BASE, baseTag, encode),
    bodyAttributes: getMethodsForTag(ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
    htmlAttributes: getMethodsForTag(ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
    link: getMethodsForTag(TAG_NAMES.LINK, linkTags, encode),
    meta: getMethodsForTag(TAG_NAMES.META, metaTags, encode),
    noscript: getMethodsForTag(TAG_NAMES.NOSCRIPT, noscriptTags, encode),
    script: getMethodsForTag(TAG_NAMES.SCRIPT, scriptTags, encode),
    style: getMethodsForTag(TAG_NAMES.STYLE, styleTags, encode),
    title: getMethodsForTag(TAG_NAMES.TITLE, { title, titleAttributes }, encode)
  };
};
var Helmet = function Helmet2(Component) {
  var _class, _temp;
  return _temp = _class = function(_React$Component) {
    inherits(HelmetWrapper, _React$Component);
    function HelmetWrapper() {
      classCallCheck(this, HelmetWrapper);
      return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
      return !reactFastCompare(this.props, nextProps);
    };
    HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
      if (!nestedChildren) {
        return null;
      }
      switch (child.type) {
        case TAG_NAMES.SCRIPT:
        case TAG_NAMES.NOSCRIPT:
          return {
            innerHTML: nestedChildren
          };
        case TAG_NAMES.STYLE:
          return {
            cssText: nestedChildren
          };
      }
      throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
    };
    HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
      var _babelHelpers$extends;
      var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
      return _extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _babelHelpers$extends));
    };
    HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
      var _babelHelpers$extends2, _babelHelpers$extends3;
      var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
      switch (child.type) {
        case TAG_NAMES.TITLE:
          return _extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = _extends({}, newChildProps), _babelHelpers$extends2));
        case TAG_NAMES.BODY:
          return _extends({}, newProps, {
            bodyAttributes: _extends({}, newChildProps)
          });
        case TAG_NAMES.HTML:
          return _extends({}, newProps, {
            htmlAttributes: _extends({}, newChildProps)
          });
      }
      return _extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = _extends({}, newChildProps), _babelHelpers$extends3));
    };
    HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
      var newFlattenedProps = _extends({}, newProps);
      Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
        var _babelHelpers$extends4;
        newFlattenedProps = _extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
      });
      return newFlattenedProps;
    };
    HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
      if (process.env.NODE_ENV !== "production") {
        if (!VALID_TAG_NAMES.some(function(name) {
          return child.type === name;
        })) {
          if (typeof child.type === "function") {
            return warn2("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
          }
          return warn2("Only elements types " + VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
        }
        if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function(nestedChild) {
          return typeof nestedChild !== "string";
        }))) {
          throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
        }
      }
      return true;
    };
    HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
      var _this2 = this;
      var arrayTypeChildren = {};
      React__default$1.Children.forEach(children, function(child) {
        if (!child || !child.props) {
          return;
        }
        var _child$props = child.props, nestedChildren = _child$props.children, childProps = objectWithoutProperties(_child$props, ["children"]);
        var newChildProps = convertReactPropstoHtmlAttributes(childProps);
        _this2.warnOnInvalidChildren(child, nestedChildren);
        switch (child.type) {
          case TAG_NAMES.LINK:
          case TAG_NAMES.META:
          case TAG_NAMES.NOSCRIPT:
          case TAG_NAMES.SCRIPT:
          case TAG_NAMES.STYLE:
            arrayTypeChildren = _this2.flattenArrayTypeChildren({
              child,
              arrayTypeChildren,
              newChildProps,
              nestedChildren
            });
            break;
          default:
            newProps = _this2.mapObjectTypeChildren({
              child,
              newProps,
              newChildProps,
              nestedChildren
            });
            break;
        }
      });
      newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
      return newProps;
    };
    HelmetWrapper.prototype.render = function render() {
      var _props = this.props, children = _props.children, props = objectWithoutProperties(_props, ["children"]);
      var newProps = _extends({}, props);
      if (children) {
        newProps = this.mapChildrenToProps(children, newProps);
      }
      return React__default$1.createElement(Component, newProps);
    };
    createClass(HelmetWrapper, null, [{
      key: "canUseDOM",
      // Component.peek comes from react-side-effect:
      // For testing, you may use a static peek() method available on the returned component.
      // It lets you get the current state without resetting the mounted instance stack.
      // Don’t use it for anything other than testing.
      /**
       * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
       * @param {Object} bodyAttributes: {"className": "root"}
       * @param {String} defaultTitle: "Default Title"
       * @param {Boolean} defer: true
       * @param {Boolean} encodeSpecialCharacters: true
       * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
       * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
       * @param {Array} meta: [{"name": "description", "content": "Test description"}]
       * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
       * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
       * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
       * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
       * @param {String} title: "Title"
       * @param {Object} titleAttributes: {"itemprop": "name"}
       * @param {String} titleTemplate: "MySite.com - %s"
       */
      set: function set$$1(canUseDOM2) {
        Component.canUseDOM = canUseDOM2;
      }
    }]);
    return HelmetWrapper;
  }(React__default$1.Component), _class.propTypes = {
    base: propTypesExports.object,
    bodyAttributes: propTypesExports.object,
    children: propTypesExports.oneOfType([propTypesExports.arrayOf(propTypesExports.node), propTypesExports.node]),
    defaultTitle: propTypesExports.string,
    defer: propTypesExports.bool,
    encodeSpecialCharacters: propTypesExports.bool,
    htmlAttributes: propTypesExports.object,
    link: propTypesExports.arrayOf(propTypesExports.object),
    meta: propTypesExports.arrayOf(propTypesExports.object),
    noscript: propTypesExports.arrayOf(propTypesExports.object),
    onChangeClientState: propTypesExports.func,
    script: propTypesExports.arrayOf(propTypesExports.object),
    style: propTypesExports.arrayOf(propTypesExports.object),
    title: propTypesExports.string,
    titleAttributes: propTypesExports.object,
    titleTemplate: propTypesExports.string
  }, _class.defaultProps = {
    defer: true,
    encodeSpecialCharacters: true
  }, _class.peek = Component.peek, _class.rewind = function() {
    var mappedState = Component.rewind();
    if (!mappedState) {
      mappedState = mapStateOnServer({
        baseTag: [],
        bodyAttributes: {},
        encodeSpecialCharacters: true,
        htmlAttributes: {},
        linkTags: [],
        metaTags: [],
        noscriptTags: [],
        scriptTags: [],
        styleTags: [],
        title: "",
        titleAttributes: {}
      });
    }
    return mappedState;
  }, _temp;
};
var NullComponent = function NullComponent2() {
  return null;
};
var HelmetSideEffects = lib(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);
var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;
function ListingCalculatorModal({
  linkDisabled,
  openLinkDisabledModal,
  listingInfo
}) {
  const { t: t2 } = useTranslation();
  const [show, setShow] = useState$1(false);
  useEffect$1(() => {
    window.mc_settings = {
      subheading: "Räkna på ditt bolån innan du ansöker för att se den ungefärliga månadskostnaden. För denna tjänst samarbetar vi med Lånekoll.",
      showObjectInfo: true,
      newWindowLink: true,
      link: "https://www.lanekoll.se/bolan/blok",
      theme: "blok",
      utmSource: "blok",
      showHousingFormButtons: false
    };
    window.mc_data = {
      prospectPrice: Number(listingInfo.listing_price_asking),
      fee: Number(listingInfo.association_fee_raw),
      housingForm: 1,
      housingFormLabel: getCategoryDisplay(listingInfo.category),
      tenureLabel: "Bostadsrätt",
      city: listingInfo.location_municipality,
      streetAddress: listingInfo.location_street_address,
      objectImage: listingInfo.hero_thumbnail
    };
  }, []);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(HelmetExport, { children: show && /* @__PURE__ */ jsx("script", { src: "https://k7i9i6w7.stackpathcdn.com/sm/mc-standalone.v2.min.js" }) }),
    /* @__PURE__ */ jsxs("div", { className: "px-6 pt-6 pb-6 mt-6 text-center border-t-2 sm:px-11 bg-blueLight-100 border-blueLight-500", children: [
      /* @__PURE__ */ jsx("h6", { className: "mb-1", children: t2("loan_promise_heading") }),
      linkDisabled ? /* @__PURE__ */ jsx(
        Button,
        {
          buttonStyle: "blue",
          className: "w-full mx-auto mt-2",
          size: "sm",
          onClick: openLinkDisabledModal,
          children: t2("loan_promise_btn")
        }
      ) : /* @__PURE__ */ jsx(
        Button,
        {
          buttonStyle: "blue",
          className: "w-full mx-auto mt-2",
          size: "sm",
          onClick: () => setShow(true),
          children: t2("loan_promise_btn")
        }
      )
    ] }),
    /* @__PURE__ */ jsxs(
      mt,
      {
        open: show,
        onClose: () => setShow(false),
        className: "tailwind",
        style: {
          position: "fixed",
          zIndex: 10,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        },
        children: [
          /* @__PURE__ */ jsx(mt.Overlay, { className: "fixed inset-0 z-10 bg-blue-500 opacity-80" }),
          /* @__PURE__ */ jsxs("div", { className: "relative z-20 max-w-3xl max-h-screen overflow-x-hidden overflow-y-auto bg-white", children: [
            /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between w-full px-6 pt-4 pb-3 border-b-2 border-blueLight-500", children: [
              /* @__PURE__ */ jsx(mt.Title, { className: "text-blue-500 h4", children: "Lånekalkylator i samarbete med Lånekoll" }),
              /* @__PURE__ */ jsxs(
                "button",
                {
                  onClick: () => setShow(false),
                  className: "flex-shrink-0 p-2",
                  children: [
                    /* @__PURE__ */ jsx("span", { className: "sr-only", children: t2("Close") }),
                    /* @__PURE__ */ jsx(BsX, { className: "w-7 h-7" })
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ jsx("div", { id: "mortgage-calculator-standalone", className: "-mx-px", children: /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center py-16", children: /* @__PURE__ */ jsx(_default, { color: "#555555" }) }) })
          ] })
        ]
      }
    )
  ] });
}
function ListingBiddingHistory({
  bids,
  price_display,
  highest_bid_display
}) {
  const { t: t2 } = useTranslation();
  const [expanded, setExpanded] = useState$1(false);
  function orderByDate(bids2) {
    bids2.sort((a2, b) => {
      return new Date(b.created_at) - new Date(a2.created_at);
    });
    return bids2;
  }
  function formatBids(bids2, limit2) {
    bids2 = orderByDate(bids2);
    if (!expanded) {
      bids2 = bids2.slice(0, limit2);
    }
    return bids2.map((bid2) => {
      return {
        ...bid2,
        date: DateTime.fromISO(bid2.created_at).toFormat(getLuxonShortDateFormat()),
        time: DateTime.fromISO(bid2.created_at).toFormat("HH.MM"),
        buyer_alias_id: bid2.buyer_alias.replace(/^\D+/g, "")
      };
    });
  }
  const limit = 5;
  const totalBids = bids.length;
  bids = formatBids(bids, limit);
  return /* @__PURE__ */ jsxs("div", { className: "mb-6 text-center border-t-2 border-b-2 bg-blueLight-100 border-blueLight-500", children: [
    /* @__PURE__ */ jsxs("header", { className: "py-7", children: [
      /* @__PURE__ */ jsx("h4", { className: "mb-4 text-blue-500", children: t2("bidding") }),
      /* @__PURE__ */ jsxs("p", { className: "mb-1 font-bold text-blue-500", children: [
        t2("highest_bid"),
        ": ",
        highest_bid_display
      ] }),
      /* @__PURE__ */ jsxs("p", { className: "text-gray-800", children: [
        t2("price_for_sale_SE"),
        ": ",
        price_display
      ] })
    ] }),
    /* @__PURE__ */ jsxs("table", { className: "min-w-full", children: [
      /* @__PURE__ */ jsx("thead", { className: "text-white bg-blueLight-500", children: /* @__PURE__ */ jsxs("tr", { children: [
        /* @__PURE__ */ jsx("th", { className: "p-4 text-left h6", children: t2("bid") }),
        /* @__PURE__ */ jsx("th", { className: "p-4 text-left h6", children: t2("date") }),
        /* @__PURE__ */ jsx("th", { className: "p-4 text-right h6", children: t2("bidder") })
      ] }) }),
      /* @__PURE__ */ jsx("tbody", { className: "text-sm text-gray-800", children: bids.map((bid2, index) => /* @__PURE__ */ jsxs(
        "tr",
        {
          className: cx(index % 2 === 0 ? "bg-blueLight-100" : "bg-white"),
          children: [
            /* @__PURE__ */ jsx("td", { className: "p-4 text-left", children: bid2.price_display }),
            /* @__PURE__ */ jsxs("td", { className: "p-4 text-left", children: [
              bid2.date,
              " ",
              bid2.time
            ] }),
            /* @__PURE__ */ jsx("td", { className: "p-4 text-right", children: bid2.buyer_alias_id })
          ]
        },
        bid2.created_at + index
      )) })
    ] }),
    !expanded && totalBids > limit && /* @__PURE__ */ jsxs(
      "button",
      {
        className: "flex items-center justify-center w-full p-4 mx-auto text-blue-500 bg-white",
        onClick: () => setExpanded(true),
        children: [
          /* @__PURE__ */ jsx(BsPlus, { className: "w-5 h-5 -mt-1 text-gray-800 fill-current" }),
          /* @__PURE__ */ jsx("span", { className: "ml-2 text-xs font-bold tracking-widest uppercase", children: t2("show_all_bids") })
        ]
      }
    )
  ] });
}
const BLOK_APP_URL = "https://app.blok.ai";
function ListingAction({
  title,
  subtitle,
  linkDisabled,
  linkContent,
  link,
  openLinkDisabledModal,
  handleClick
}) {
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx("h5", { className: "mb-2 text-blue-500", children: title }),
    /* @__PURE__ */ jsx("p", { className: "mb-3 text-sm text-gray-800", children: subtitle }),
    linkDisabled ? /* @__PURE__ */ jsx(
      Button,
      {
        buttonStyle: "blue",
        className: "w-full mx-auto mt-2",
        size: "sm",
        onClick: openLinkDisabledModal,
        children: linkContent
      }
    ) : /* @__PURE__ */ jsx(
      Button,
      {
        buttonLink: link,
        buttonStyle: "blue",
        className: "w-full mx-auto mt-2",
        size: "sm",
        tag: "a",
        onClick: handleClick,
        children: linkContent
      }
    )
  ] });
}
function Contacts({ type: type2, agent }) {
  const { t: t2 } = useTranslation();
  if (!contactConfig[type2]) {
    return null;
  }
  const content = {};
  if (contactConfig[type2].agent && agent) {
    const enabled = contactConfig[type2].agent;
    content.label = "responsible_broker";
    if (enabled.email && agent.email)
      content.email = agent.email;
    if (enabled.name && agent.name)
      content.title = agent.name;
    if (enabled.phone && agent.phone)
      content.phone = agent.phone;
    if (enabled.profile_picture && agent.profile_picture)
      content.image = agent.profile_picture;
  }
  return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs("div", { className: "flex items-center", children: [
    content.image && /* @__PURE__ */ jsx("div", { className: "flex-shrink-0 w-1/3 mr-4 overflow-hidden rounded-full", children: /* @__PURE__ */ jsx(
      "img",
      {
        alt: content.title,
        src: content.image,
        className: "overflow-hidden rounded-full"
      }
    ) }),
    /* @__PURE__ */ jsxs("div", { className: cx(content.image ? "w-2/3" : "w-full"), children: [
      content.label && // i18next-extract-disable-next-line
      /* @__PURE__ */ jsx("p", { className: "mb-1 text-sm text-gray-800", children: t2(content.label) }),
      content.title && /* @__PURE__ */ jsx("h5", { className: "mb-2 tracking-wide text-blue-500", children: content.title }),
      content.phone && /* @__PURE__ */ jsx("p", { className: "mb-2 text-sm text-gray-800", children: content.phone }),
      content.email && /* @__PURE__ */ jsx("p", { className: "text-sm text-gray-800", children: content.email })
    ] })
  ] }) });
}
function ListingDescription({
  listingInfo,
  openLinkDisabledModal
}) {
  var _a, _b;
  const { country, listingGuid, linkDisabled } = useContext(ListingContext);
  const { t: t2, i18n } = useTranslation();
  const [expanded, setExpanded] = useState$1(false);
  function formatDate(datetimeString, format) {
    return DateTime.fromISO(datetimeString, { setZone: true }).setLocale(i18n.language).toFormat(format);
  }
  let alerts;
  if (((_a = listingInfo.apartment_se) == null ? void 0 : _a.listing_market_state) === "upcoming") {
    alerts = /* @__PURE__ */ jsx("div", { className: "p-8 border-t-2 bg-blueLight-100 border-blueLight-500", children: /* @__PURE__ */ jsxs("p", { className: "text-sm text-blue-500", children: [
      /* @__PURE__ */ jsx("span", { className: "font-bold", children: t2("upcoming_apartment_bold") }),
      " ",
      t2("upcoming_apartment")
    ] }) });
  } else {
    alerts = /* @__PURE__ */ jsxs(Fragment, { children: [
      (_b = listingInfo.showings) == null ? void 0 : _b.map((showing, i2) => /* @__PURE__ */ jsxs(
        "div",
        {
          className: "px-5 pt-4 pb-4 mb-5 bg-pink-100 border-t-2 border-pink-500",
          children: [
            /* @__PURE__ */ jsxs("span", { className: "text-pink-500 h6", children: [
              t2("openhouse"),
              ": ",
              formatDate(showing.start, "EEE"),
              " ",
              formatDate(showing.start, "dd.MM.yyyy"),
              !showing.is_all_day && /* @__PURE__ */ jsxs(Fragment, { children: [
                " ",
                t2("klo"),
                " ",
                formatDate(showing.start, "HH.mm"),
                " -",
                " ",
                formatDate(showing.end, "HH.mm")
              ] })
            ] }),
            showing.description && /* @__PURE__ */ jsx("p", { className: "text-[14px] text-pink-500 pt-1", children: showing.description })
          ]
        },
        i2
      )),
      (!listingInfo.showings || listingInfo.showings.length === 0) && country !== "FI" && /* @__PURE__ */ jsx("div", { className: "px-5 pt-4 pb-3 bg-gray-200 border-t-2 border-gray-600", children: /* @__PURE__ */ jsx("span", { className: "text-gray-600 h6", children: t2("no_showing") }) })
    ] });
  }
  return /* @__PURE__ */ jsxs("div", { className: "container px-4 mt-8 lg:mt-12", children: [
    alerts,
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col justify-between mt-8 space-y-10 lg:mt-12 md:flex-row md:space-x-8 md:space-y-0", children: [
      /* @__PURE__ */ jsxs("div", { className: "w-full md:w-7/12 md:pb-5", children: [
        /* @__PURE__ */ jsx("h4", { className: "mb-6 text-blue-500", children: listingInfo.listing_title }),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: cx(
              "relative md:h-auto md:pb-0",
              expanded ? "h-auto pb-10" : "h-40 overflow-hidden"
            ),
            children: [
              /* @__PURE__ */ jsx("div", { className: "prose", children: /* @__PURE__ */ jsx("p", { className: "whitespace-pre-wrap", children: listingInfo.listing_description }) }),
              listingInfo.listing_owner_story && /* @__PURE__ */ jsxs("div", { className: "flex mt-11", children: [
                /* @__PURE__ */ jsx(SvgSpeechbubble, { className: "flex-shrink-0 fill-current text-blueLight-500 w-[95px] h-[85px]" }),
                /* @__PURE__ */ jsxs("div", { className: "pl-10 prose", children: [
                  /* @__PURE__ */ jsxs("p", { children: [
                    '"',
                    listingInfo.listing_owner_story,
                    '"'
                  ] }),
                  /* @__PURE__ */ jsxs("h6", { className: "mt-2", children: [
                    "– ",
                    t2("seller")
                  ] })
                ] })
              ] }),
              /* @__PURE__ */ jsx(
                "div",
                {
                  className: cx(
                    "md:hidden",
                    expanded ? "hidden" : "absolute inset-x-0 bottom-0 h-20 bg-gradient-to-b from-transparent to-white"
                  )
                }
              )
            ]
          }
        ),
        !expanded && /* @__PURE__ */ jsxs(
          "button",
          {
            className: "flex items-center w-full py-2 my-4 md:hidden",
            onClick: () => setExpanded(true),
            children: [
              /* @__PURE__ */ jsx(AiOutlinePlus, { className: "w-5 h-5 text-blue-500 fill-current" }),
              /* @__PURE__ */ jsx("span", { className: "ml-4 -mb-1 text-sm font-semibold tracking-widest text-blue-500 uppercase", children: t2("read_description") })
            ]
          }
        )
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "w-full md:w-5/12 lg:w-4/12", children: [
        listingInfo.type === "apartment_se" && listingInfo.bidding_open && /* @__PURE__ */ jsx(
          ListingBiddingHistory,
          {
            bids: listingInfo.bids,
            highest_bid_display: listingInfo.highest_bid_display,
            price_display: listingInfo.price_display
          }
        ),
        listingInfo.type === "apartment_fi" && /* @__PURE__ */ jsxs("div", { className: "px-6 pt-6 pb-6 mb-6 overflow-hidden text-center border-t-2 sm:px-11 bg-blueLight-100 border-blueLight-500", children: [
          /* @__PURE__ */ jsxs("h6", { className: "mb-1 leading-loose text-blue-500", children: [
            t2("book_private_showing_1"),
            /* @__PURE__ */ jsx("br", { className: "hidden md:block" }),
            t2("book_private_showing_2")
          ] }),
          linkDisabled ? /* @__PURE__ */ jsx(
            Button,
            {
              buttonStyle: "blue",
              className: "w-full mx-auto mt-2",
              size: "sm",
              onClick: openLinkDisabledModal,
              children: t2("make_a_booking")
            }
          ) : /* @__PURE__ */ jsx(
            Button,
            {
              buttonLink: `${BLOK_APP_URL}/inmail/contact/${listingInfo.slug}/?private_showing=on&_language=${i18n.language}`,
              buttonStyle: "blue",
              className: "w-full mx-auto mt-2",
              size: "sm",
              children: t2("make_a_booking")
            }
          )
        ] }),
        listingInfo.type === "apartment_se" && /* @__PURE__ */ jsxs("div", { className: "px-6 pt-6 pb-6 mb-6 text-center border-t-2 sm:px-11 bg-blueLight-100 border-blueLight-500", children: [
          /* @__PURE__ */ jsx("h6", { className: "mb-1 leading-loose text-blue-500", children: t2("book_showing__se") }),
          linkDisabled ? /* @__PURE__ */ jsx(
            Button,
            {
              buttonStyle: "blue",
              className: "w-full mx-auto mt-2",
              size: "sm",
              onClick: openLinkDisabledModal,
              children: t2("make_a_booking__se")
            }
          ) : /* @__PURE__ */ jsx(
            Button,
            {
              buttonLink: `${BLOK_APP_URL}/inmail/contact/${listingInfo.slug}/?showing=on&_language=${i18n.language}`,
              buttonStyle: "blue",
              className: "w-full mx-auto mt-2",
              size: "sm",
              children: t2("make_a_booking__se")
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "p-6 space-y-12 border border-gray-400 lg:p-11", children: [
          /* @__PURE__ */ jsx(
            ListingAction,
            {
              title: t2("documents"),
              subtitle: t2("download_document"),
              linkDisabled,
              openLinkDisabledModal,
              linkContent: t2("show_document"),
              link: `${BLOK_APP_URL}/document/download/${listingGuid}/?_language=${i18n.language}`,
              handleClick: () => trackFbq("trackCustom", `Download Document ${country}`)
            }
          ),
          /* @__PURE__ */ jsx(
            ListingAction,
            {
              title: t2("leaflet"),
              subtitle: t2("download_leaflet_pdf"),
              linkDisabled,
              openLinkDisabledModal,
              linkContent: t2("download_leaflet"),
              link: `${BLOK_APP_URL}/leaflet/pdf/${listingInfo.slug}`
            }
          ),
          /* @__PURE__ */ jsx(
            ListingAction,
            {
              title: t2("contact_title", { context: country }),
              subtitle: t2(`send_customer_service_msg`),
              linkDisabled,
              openLinkDisabledModal,
              linkContent: t2("contact", { context: country }),
              link: `${BLOK_APP_URL}/inmail/contact/${listingInfo.slug}/?_language=${i18n.language}`
            }
          ),
          listingInfo.type === "apartment_se" && listingInfo.apartment_se ? listingInfo.apartment_se.listing_market_state === "for_sale" && /* @__PURE__ */ jsx(
            ListingAction,
            {
              title: t2("register_for_bidding"),
              subtitle: t2("register_for_bidding_desc"),
              linkDisabled,
              openLinkDisabledModal,
              linkContent: t2("register_for_bidding_btn"),
              link: `${BLOK_APP_URL}/trade/${listingGuid}/?_language=${i18n.language}`
            }
          ) : !listingInfo.new_construction && /* @__PURE__ */ jsx(
            ListingAction,
            {
              title: t2("make_offer_FI"),
              subtitle: t2("make_offer_desc"),
              linkDisabled,
              openLinkDisabledModal,
              linkContent: t2("make_offer_FI"),
              link: `${BLOK_APP_URL}/trade/${listingGuid}/?_language=${i18n.language}`,
              handleClick: () => trackFbq("trackCustom", `Make Offer ${country}`)
            }
          ),
          /* @__PURE__ */ jsx(Contacts, { type: listingInfo.type, agent: listingInfo.agent })
        ] }),
        listingInfo.type === "apartment_se" && i18n.language === "sv" && /* @__PURE__ */ jsx(
          ListingCalculatorModal,
          {
            linkDisabled,
            openLinkDisabledModal,
            listingInfo
          }
        )
      ] })
    ] })
  ] });
}
function PriceDevelopment({ colorOption = "blue" }) {
  return /* @__PURE__ */ jsxs("div", { className: "relative max-w-sm mx-auto", children: [
    /* @__PURE__ */ jsx(
      "svg",
      {
        className: `w-full h-full stroke-current ${colorOption === "charcoal" ? "text-charcoal-500" : "text-blue-500"}`,
        viewBox: "0 0 297 68",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ jsx(
          "path",
          {
            d: "M2 66.5l26.594-23.625 29.884-4.348L79.574 18 118.9 41l25.975-18.25L188.56 43.5 216.3 30.8 235 43.5 295.293 2",
            strokeWidth: "4",
            fill: "none",
            fillRule: "evenodd"
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: `absolute flex items-center justify-center w-10 h-10 text-sm font-bold text-white rounded-full right-3.5 top-1.5 ${colorOption === "charcoal" ? "bg-charcoal-500" : "bg-blue-500"}`,
        children: "+2%"
      }
    )
  ] });
}
function PriceEstimate({ openLinkDisabledModal }) {
  const { linkDisabled, country } = useContext(ListingContext);
  const { t: t2 } = useTranslation();
  const buttonLink = {
    FI: t2("/en/valuation"),
    SE: t2("/en/valuation-web"),
    LEAD_SE: t2("/en/valuation-en"),
    LEAD_NO: t2("/en/valuation-en")
  }[country];
  function translate2(key, country2) {
    if (country2 === "SE") {
      key += "_SE";
    }
    return t2(key);
  }
  return /* @__PURE__ */ jsxs("div", { className: "h-full px-8 pb-8 text-center border-t-4 pt-11 sm:px-11 bg-blueLight-100 border-blueLight-500", children: [
    /* @__PURE__ */ jsxs("h3", { className: "text-blue-500 h4", children: [
      translate2("price_estimate__heading", country),
      /* @__PURE__ */ jsx("br", {}),
      translate2("price_estimate__subheading", country)
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "mx-auto mt-8 max-w-[300px]", children: [
      /* @__PURE__ */ jsx(PriceDevelopment, {}),
      linkDisabled ? /* @__PURE__ */ jsx(
        Button,
        {
          buttonStyle: "blue",
          buttonLabel: translate2("price_estimate__valuate", country),
          onClick: openLinkDisabledModal,
          className: "w-full mx-auto mt-8"
        }
      ) : /* @__PURE__ */ jsx(
        Button,
        {
          buttonStyle: "blue",
          buttonLabel: translate2("price_estimate__valuate", country),
          buttonLink,
          className: "w-full mx-auto mt-8"
        }
      )
    ] })
  ] });
}
const SvgFacade = (props) => /* @__PURE__ */ React$3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", x: 0, y: 0, viewBox: "0 0 66.2 65.8", xmlSpace: "preserve", ...props }, /* @__PURE__ */ React$3.createElement("path", { d: "M28.3 54c.2.2.4.3.7.3.1 0 .2 0 .4-.1l25.1-9.8c1.7-.4 2.9-1.6 3.3-3.3.5-1.9-.1-3.9-1.5-5.4l-3.5-3.5 4-3.5c.4-.4.5-1 .1-1.4L50.6 20c1.2-.1 2.3-.5 3.2-1.3l10.8-9.8c1-.9 1.7-2.2 1.7-3.6.1-1.4-.4-2.7-1.3-3.8-1.9-2.1-5.2-2.4-7.3-.4l-10.8 9.8c-1 .9-1.7 2.2-1.7 3.6-.1 1.4.4 2.7 1.3 3.8l8.3 9.6-3.3 2.9-5-4.8c-1.4-1.4-3.5-2-5.3-1.5-1.6.4-2.8 1.6-3.3 3.3l-9.8 25.1c-.2.4-.1.8.2 1.1zm19.8-41.4l10.8-9.8c.6-.5 1.3-.8 2.1-.8.9 0 1.8.4 2.4 1.1.6.6.8 1.5.8 2.3-.1.9-.4 1.6-1.1 2.2l-10.8 9.8c-.6.6-1.5.8-2.3.8-.8-.1-1.6-.4-2.2-1.1-.6-.6-.8-1.5-.8-2.3.1-.9.5-1.7 1.1-2.2zm-8.4 15.9v-.1c.4-1.3 1.3-1.8 1.9-1.9.3-.1.6-.1.8-.1.9 0 1.9.4 2.6 1.1l4.8 4.8-4.9 4.3c-.4.4-.5 1-.1 1.4.2.2.5.3.8.3.2 0 .5-.1.7-.2l5-4.4 3.6 3.6c.9.9 1.3 2.3 1 3.4-.3 1-1 1.6-1.9 1.9h-.1l-23 8.9 8.8-23z" }), /* @__PURE__ */ React$3.createElement("path", { d: "M65.2 49.8H51.3v2h12.9v12H46.7V52.2h-2v11.6H24.3v-13c0-.6-.4-1-1-1H13.2v-12h14.4v-2h-3.2v-12H36v-2h-3.2V9c0-.6-.4-1-1-1H1c-.6 0-1 .4-1 1v56c0 .6.4 1 1 1h64.2c.6 0 1-.4 1-1V51c0-.7-.4-1.2-1-1.2zM22.3 35.9H2v-12h20.3v12zm8.4-14H13.2V10h17.5v11.9zM2 10h9.2v12H2V10zm0 27.9h9.2v12H2v-12zm20.3 25.9H2v-12h20.3v12z" }));
const SvgPipe = (props) => /* @__PURE__ */ React$3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 34.7 31.9", ...props }, /* @__PURE__ */ React$3.createElement("path", { d: "M32.4 26.4V22v-.3c0-1.5.1-4.7-2.2-7-1.8-1.9-4.7-2.8-8.6-2.8h-1.4c-.2-1.3-1.4-2.4-2.8-2.4s-2.5 1-2.8 2.3h-2.9c-1.1 0-1.1-1.5-1.1-1.7V5.6c1.3-.2 2.4-1.4 2.4-2.8C13 1.3 11.7 0 10.2 0H2.8C1.3 0 0 1.3 0 2.8c0 1.4 1 2.5 2.3 2.8v4.7c0 1.5-.1 4.7 2.2 7 1.8 1.9 4.7 2.8 8.6 2.8h1.4c.2 1.3 1.4 2.3 2.8 2.3s2.5-1 2.8-2.3h2.8c1.1 0 1.1 1.5 1.1 1.7v4.6c-1.3.2-2.3 1.4-2.3 2.8 0 1.5 1.3 2.8 2.8 2.8h7.4c1.5 0 2.8-1.3 2.8-2.8 0-1.4-1-2.6-2.3-2.8zM1 2.8C1 1.8 1.8 1 2.8 1h7.4c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8H2.8c-1 0-1.8-.8-1.8-1.8zm4.3 13.8c-2-2.1-2-4.9-2-6.3V5.6h6.3v4.5c0 1.3.6 2.7 2.1 2.7h2.9v6.3h-1.4c-3.7 0-6.3-.8-7.9-2.5zm13.9 3c0 1-.8 1.8-1.8 1.8s-1.8-.8-1.8-1.8v-7.4c0-1 .8-1.8 1.8-1.8s1.8.8 1.8 1.8v7.4zm3.8-.5h-2.8v-6.3h1.4c3.6 0 6.3.8 7.9 2.5 2 2.1 2 4.9 2 6.3V26.4h-6.3v-4.6c-.1-1.4-.8-2.7-2.2-2.7zm8.9 11.8h-7.4c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8h7.4c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8z" }));
const SvgRoof = (props) => /* @__PURE__ */ React$3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 37.8 26.7", ...props }, /* @__PURE__ */ React$3.createElement("path", { d: "M36.8 25.5h-1.3c-.4 0-.8-.1-1.1-.3v-21c.3.1.7.2 1.1.2h1.3v21.1zM30 22.1c-1.4 0-2.3.9-3.1 1.7V3.2l.6-.6C28.4 1.7 29 1 30 1s1.6.7 2.3 1.5c.3.4.7.8 1.1 1.1v20.7c-.1-.1-.2-.3-.3-.4-.7-.8-1.6-1.8-3.1-1.8zm-7.2 2.8V4c.4.3.9.5 1.6.5.6 0 1.1-.2 1.6-.5v20.9c-.5.4-1 .7-1.6.7-.7 0-1.2-.3-1.6-.7zM19 22.2c-1.3 0-2.1.7-2.8 1.4V3c.1-.1.2-.3.4-.4.7-.8 1.4-1.5 2.5-1.5s1.7.7 2.4 1.5c.1.2.3.3.4.5v20.6c-.8-.8-1.6-1.5-2.9-1.5zM11.9 25V4.1c.4.2.8.3 1.4.3.8 0 1.4-.2 1.9-.6v20.8c-.5.5-1.1.9-1.9.9-.6.1-1.1-.1-1.4-.5zm-4.1-2.8c-1.8 0-2.7 1.1-3.4 2V3.7c.2-.3.5-.6.7-.9C5.8 1.9 6.4 1 7.8 1c1.3 0 1.9.7 2.6 1.6.2.2.3.4.5.7v20.5c-.7-.7-1.5-1.6-3.1-1.6zm-5.1 3.4H1V4.5h1.8c.2 0 .4-.1.6-.1v21c-.2.1-.4.2-.7.2zM37.3 3.4h-1.8c-1.1 0-1.7-.7-2.4-1.5C32.4 1 31.5 0 30 0s-2.4 1-3.2 1.9c-.8.8-1.4 1.6-2.5 1.6-.7 0-1.2-.4-1.7-.9-.2-.2-.3-.4-.5-.6-.7-.9-1.6-1.9-3.1-1.9-1.6 0-2.4 1-3.2 1.9-.7.8-1.4 1.5-2.5 1.5-1 0-1.5-.6-2.2-1.4-.7-.9-1.5-2-3.3-2-2 0-2.8 1.2-3.5 2.2-.6.7-1 1.2-1.6 1.2H.5c-.3 0-.5.2-.5.5v22.1c0 .3.2.5.5.5h2.2c1.1-.1 1.7-.9 2.3-1.7.7-.9 1.3-1.8 2.7-1.8 1.3 0 1.9.7 2.6 1.6.7.8 1.4 1.8 2.9 1.8 1.6 0 2.4-1 3.2-1.9.7-.8 1.4-1.5 2.5-1.5s1.7.7 2.4 1.5c.7.9 1.5 1.9 3 1.9s2.4-1 3.2-1.9c.8-.8 1.4-1.6 2.5-1.6 1 0 1.6.7 2.3 1.5.8.9 1.6 1.9 3.2 1.9h1.8c.1 0 .3-.1.4-.1.1-.1.1-.2.1-.4v-22c0-.3-.2-.5-.5-.5z", fillRule: "evenodd", clipRule: "evenodd" }));
function ImportantRenovationItem({ icon, title, repairs }) {
  const Icon = cloneElement(icon, {
    className: "fill-current text-blue-500 w-16 h-16"
  });
  return /* @__PURE__ */ jsxs("div", { className: "flex items-center w-full my-5 md:w-1/2 lg:w-1/4", children: [
    /* @__PURE__ */ jsx("div", { className: "flex-shrink-0", children: Icon }),
    /* @__PURE__ */ jsx("div", { className: "flex-1 px-8", children: /* @__PURE__ */ jsxs("div", { className: "mt-4 icon-details", children: [
      /* @__PURE__ */ jsx("span", { className: "font-bold text-blue-500", children: title }),
      repairs.map((repair, i2) => /* @__PURE__ */ jsxs("p", { className: "mt-1 text-gray-800", children: [
        repair.year_start,
        " ",
        repair.year_end ? `- ${repair.year_end}` : "",
        i2 === repairs.length - 1 ? /* @__PURE__ */ jsx("br", {}) : ""
      ] }, i2))
    ] }) })
  ] });
}
function ListingImportantRenovationInfo({ listingInfo }) {
  var _a, _b, _c;
  const { t: t2 } = useTranslation();
  if (((_a = listingInfo.important_renovations) == null ? void 0 : _a.facade) || ((_b = listingInfo.important_renovations) == null ? void 0 : _b.pipes) || ((_c = listingInfo.important_renovations) == null ? void 0 : _c.roof)) {
    return /* @__PURE__ */ jsx(ListingInfo, { headline: t2("important_renovation_info"), children: /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap", children: [
      /* @__PURE__ */ jsx(
        ImportantRenovationItem,
        {
          icon: /* @__PURE__ */ jsx(SvgBuilt, {}),
          title: t2("built_in"),
          repairs: [
            { year_start: listingInfo.building_construction_year ?? null }
          ]
        }
      ),
      listingInfo.important_renovations.facade && /* @__PURE__ */ jsx(
        ImportantRenovationItem,
        {
          icon: /* @__PURE__ */ jsx(SvgFacade, {}),
          title: t2("facade"),
          repairs: listingInfo.important_renovations.facade
        }
      ),
      listingInfo.important_renovations.pipes && /* @__PURE__ */ jsx(
        ImportantRenovationItem,
        {
          icon: /* @__PURE__ */ jsx(SvgPipe, {}),
          title: t2("pipes"),
          repairs: listingInfo.important_renovations.pipes
        }
      ),
      listingInfo.important_renovations.roof && /* @__PURE__ */ jsx(
        ImportantRenovationItem,
        {
          icon: /* @__PURE__ */ jsx(SvgRoof, {}),
          title: t2("roof"),
          repairs: listingInfo.important_renovations.roof
        }
      )
    ] }) });
  }
  return null;
}
function ListingOfferExplanation({
  listingInfo,
  openLinkDisabledModal
}) {
  const { listingGuid, linkDisabled, country } = useContext(ListingContext);
  const { t: t2, i18n } = useTranslation();
  if (listingInfo.type === "apartment_se" && listingInfo.apartment_se) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", { className: "container px-4", children: /* @__PURE__ */ jsxs("div", { className: "h-full py-10 mb-4 lg:px-10 lg:border-t-4 lg:mb-15 lg:bg-blueLight-100 lg:border-blueLight-500", children: [
    /* @__PURE__ */ jsx("h3", { className: "mb-6 text-blue-500", children: t2("how_to_send_offer", { context: country }) }),
    /* @__PURE__ */ jsxs("ol", { className: "relative text-gray-800 listing-app-custom-list", children: [
      /* @__PURE__ */ jsx("li", { className: "item-with-btn tailwind-item", children: linkDisabled ? /* @__PURE__ */ jsx(Button, { size: "sm", onClick: openLinkDisabledModal, children: t2("create_account") }) : /* @__PURE__ */ jsx(
        Button,
        {
          buttonLink: `${"https://app.blok.ai"}/accounts/signup/?_language=${i18n.language}`,
          size: "sm",
          children: t2("create_account")
        }
      ) }),
      /* @__PURE__ */ jsxs("li", { className: "item-with-btn tailwind-item", children: [
        t2("offer_step2_before_btn", { context: country }),
        linkDisabled ? /* @__PURE__ */ jsx(
          Button,
          {
            size: "sm",
            buttonStyle: "blue",
            className: "mx-2",
            onClick: openLinkDisabledModal,
            children: t2("make_offer", { context: country })
          }
        ) : /* @__PURE__ */ jsx(
          Button,
          {
            buttonLink: `${"https://app.blok.ai"}/trade/${listingGuid}/?_language=${i18n.language}`,
            buttonStyle: "blue",
            className: "mx-2",
            size: "sm",
            children: t2("make_offer", { context: country })
          }
        ),
        "- ",
        t2("offer_step2_after_btn", { context: country }),
        "."
      ] }),
      /* @__PURE__ */ jsx("li", { className: "tailwind-item", children: t2("offer_step3", { context: country }) }),
      /* @__PURE__ */ jsx("li", { className: "tailwind-item", children: t2("offer_step4", { context: country }) }),
      /* @__PURE__ */ jsx("li", { className: "tailwind-item", children: t2("offer_step5", { context: country }) })
    ] })
  ] }) });
}
const parseArr = (val) => {
  if (typeof val === "string")
    return [val];
  return val;
};
const getProperties = async (params) => {
  var _a, _b, _c, _d;
  try {
    let cityQuery = "", neighborhoodQuery = "", postcodeQuery = "", addressQuery = "", categoryQuery = "", roomQuery = "", searchQuery = "";
    const cityArr = parseArr(params.city);
    const neighborhoodArr = parseArr(params.neighborhood);
    const postcodeArr = parseArr(params.postcode);
    const addressArr = parseArr(params.address);
    const categoryArr = parseArr(params.category);
    const roomArr = parseArr(params.room);
    const searchArr = parseArr(params.search);
    if (cityArr && cityArr.length > 0)
      cityArr.forEach((item) => {
        cityQuery += `&city=${encodeURI(item)}`;
      });
    if (neighborhoodArr && neighborhoodArr.length > 0)
      neighborhoodArr.forEach((item) => {
        neighborhoodQuery += `&neighborhood=${encodeURI(item)}`;
      });
    if (postcodeArr && postcodeArr.length > 0)
      postcodeArr.forEach((item) => {
        postcodeQuery += `&postcode=${item}`;
      });
    if (addressArr && addressArr.length > 0)
      addressArr.forEach((item) => {
        addressQuery += `&address=${encodeURI(item)}`;
      });
    if (categoryArr && categoryArr.length > 0)
      categoryArr.forEach((item) => {
        categoryQuery += `&category=${item}`;
      });
    if (roomArr && roomArr.length > 0)
      roomArr.forEach((item) => {
        roomQuery += `&room=${item}`;
      });
    if (searchArr && searchArr.length > 0)
      searchArr.map((searchTerm) => {
        searchQuery += `&search=${encodeURI(searchTerm)}`;
      });
    const { data } = await axios.get(
      `${"https://app.blok.ai"}/api/v2/listings/data?${cityQuery}${neighborhoodQuery}${postcodeQuery}${addressQuery}${categoryQuery}${roomQuery}`,
      {
        params: {
          country: params.country,
          type: params.type,
          _language: params.lang ? params.lang : "en",
          sold: params.sold,
          new: params.new,
          page: params.page,
          page_size: params.size,
          order_by: params.order_by,
          area__lte: (_a = params.area) == null ? void 0 : _a.lte,
          area__gte: (_b = params.area) == null ? void 0 : _b.gte,
          price__gte: (_c = params.price) == null ? void 0 : _c.gte,
          price__lte: (_d = params.price) == null ? void 0 : _d.lte
        }
      }
    );
    return data;
  } catch (error2) {
    return error2.message;
  }
};
function ListingMobileNav({
  slug,
  i18n,
  t: t2
}) {
  let { country, listingsUrl, singleBaseUrl } = useContext(ListingContext);
  let listings = JSON.parse(sessionStorage.getItem("listings"));
  if (!listings) {
    listings = {
      query: {
        country,
        type: "",
        sold: false,
        new: false,
        page: 1,
        order_by: "-published_at",
        area: { gte: "", lte: "" },
        price: { gte: "", lte: "" },
        lang: i18n.language
      },
      search: null
    };
  }
  const [state, setState] = useState$1({
    listings,
    items: []
  });
  useEffect$1(() => {
    loadProperties({ ...state.listings.query, size: -1 }).then((res) => setState({ ...state, items: res }));
  }, []);
  async function loadProperties(query) {
    const { results } = await getProperties(query);
    return results;
  }
  function buildNav() {
    const { listings: listings2 } = state;
    const listingsQueryPath = listings2.search;
    const numOfItems = state.items.length;
    const idx = state.items.findIndex(
      (item) => item.slug === slug
    );
    if (idx === -1) {
      return null;
    }
    let pagination, prev, next;
    if (numOfItems > 1 && idx !== 0) {
      prev = state.items[idx - 1].slug;
    }
    if (idx !== numOfItems - 1) {
      next = state.items[idx + 1].slug;
    }
    if (numOfItems > 0) {
      pagination = `${idx + 1} / ${state.items.length}`;
    }
    return {
      back: listingsQueryPath,
      prev,
      next,
      pagination
    };
  }
  const nav = buildNav();
  if (!nav) {
    return null;
  }
  listingsUrl = listingsUrl || "/";
  singleBaseUrl = singleBaseUrl || "/";
  return /* @__PURE__ */ jsx("div", { className: "sticky top-0 z-10 block bg-gray-200 shadow-lg lg:hidden", children: /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between px-4 py-2", children: [
    /* @__PURE__ */ jsxs(
      Link,
      {
        url: nav.back ? `${listingsUrl}${nav.back}` : `${listingsUrl}`,
        className: "flex items-center justify-center w-12 h-12 bg-white rounded-full shadow-1",
        children: [
          /* @__PURE__ */ jsx("span", { className: "sr-only", children: t2("Back to search") }),
          /* @__PURE__ */ jsx(FaSearch, { className: "w-4 h-4 text-blue-500 fill-current" })
        ]
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: "flex items-center space-x-2", children: [
      nav.pagination && /* @__PURE__ */ jsx("span", { className: "mr-2 pt-[6px]", children: /* @__PURE__ */ jsx("b", { children: nav.pagination }) }),
      nav.prev && /* @__PURE__ */ jsxs(
        Link,
        {
          url: `${singleBaseUrl}${nav.prev}`,
          className: "flex items-center justify-center w-12 h-12 bg-white rounded-full shadow-1",
          children: [
            /* @__PURE__ */ jsx("span", { className: "sr-only", children: t2("Previous") }),
            /* @__PURE__ */ jsx(FaChevronLeft, { className: "w-4 h-4 text-blue-500 fill-current" })
          ]
        }
      ),
      nav.next && /* @__PURE__ */ jsxs(
        Link,
        {
          url: `${singleBaseUrl}${nav.next}`,
          className: "flex items-center justify-center w-12 h-12 bg-white rounded-full shadow-1",
          children: [
            /* @__PURE__ */ jsx("span", { className: "sr-only", children: t2("Next") }),
            /* @__PURE__ */ jsx(FaChevronRight, { className: "w-4 h-4 text-blue-500 fill-current" })
          ]
        }
      )
    ] })
  ] }) });
}
const ListingMobileNav$1 = withTranslation()(ListingMobileNav);
const SvgChevronRight = (props) => /* @__PURE__ */ React$3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 129 129", xmlnsXlink: "http://www.w3.org/1999/xlink", enableBackground: "new 0 0 129 129", ...props }, /* @__PURE__ */ React$3.createElement("g", null, /* @__PURE__ */ React$3.createElement("path", { d: "m40.4,121.3c-0.8,0.8-1.8,1.2-2.9,1.2s-2.1-0.4-2.9-1.2c-1.6-1.6-1.6-4.2 0-5.8l51-51-51-51c-1.6-1.6-1.6-4.2 0-5.8 1.6-1.6 4.2-1.6 5.8,0l53.9,53.9c1.6,1.6 1.6,4.2 0,5.8l-53.9,53.9z" })));
function PropertyItemBody({ item, sold, useOnMap }) {
  const { t: t2 } = useTranslation();
  function getPrice(item2) {
    if (item2.price_display) {
      return item2.price_display;
    }
    const currency = getCurrencyDisplayFromCountry(item2.location_country);
    return formatCurrency(item2.price, currency, true, 0);
  }
  function getRooms(item2) {
    return getRoomDisplay(item2.room_count);
  }
  function getArea(item2) {
    return getAreaDisplay(item2.area_living);
  }
  const bidding_open2 = item.bidding_open && !sold;
  const pre_sale = item.listing_market_state === "upcoming" && !sold && !bidding_open2;
  const { show_presale_text } = item;
  let priceDisplay = getPrice(item);
  if (sold) {
    priceDisplay = t2("Sold");
  } else if (pre_sale && show_presale_text) {
    priceDisplay = "PRE SALE";
  } else if (pre_sale && !show_presale_text) {
    priceDisplay = "";
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: cx(
          "mb-0 group flex bg-white flex-col break-words min-w-0 relative",
          { "hidden md:block max-w-[350px]": useOnMap }
        ),
        children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              className: cx(
                "flex items-center justify-center p-6 absolute inset-0 group-hover:bg-blue-500 group-hover:bg-opacity-80 transition"
              ),
              children: /* @__PURE__ */ jsx("p", { className: "text-center text-white transition opacity-0 group-hover:opacity-100", children: item.listing_title })
            }
          ),
          item.new_construction && /* @__PURE__ */ jsx("div", { className: "absolute p-4 bg-white rounded-full top-2 right-2", children: /* @__PURE__ */ jsx(FaHammer, { className: "text-blue-500 h-3.5" }) }),
          pre_sale && /* @__PURE__ */ jsx("div", { className: "absolute top-0 right-6 flag-pink", children: /* @__PURE__ */ jsxs("div", { className: "px-8 pt-3 text-xs font-bold tracking-widest text-center text-white uppercase bg-pink-500 leading-0", children: [
            /* @__PURE__ */ jsx("span", { className: "block", children: "Pre" }),
            /* @__PURE__ */ jsx("span", { className: "block -mt-0.5", children: "sale" })
          ] }) }),
          bidding_open2 && /* @__PURE__ */ jsx("div", { className: "absolute top-0 right-6 flag-blueLight", children: /* @__PURE__ */ jsxs("div", { className: "text-[11px] px-5 pt-3 font-bold tracking-wider text-center text-white uppercase bg-blueLight-800 leading-0", children: [
            /* @__PURE__ */ jsx("span", { className: "block", children: t2("Bidding") }),
            /* @__PURE__ */ jsx("span", { className: "block -mt-0.5", children: t2("in progress") })
          ] }) }),
          sold && /* @__PURE__ */ jsx("div", { className: "absolute top-0 right-6 flag-blue", children: /* @__PURE__ */ jsx("div", { className: "px-5 pt-3 text-xs font-bold tracking-widest text-center text-white uppercase bg-blue-500 leading-0", children: /* @__PURE__ */ jsx("span", { className: "block", children: t2("Sold") }) }) }),
          /* @__PURE__ */ jsx(
            "img",
            {
              className: "object-cover w-full rounded-none min-h-[240px] max-h-[240px]",
              loading: "lazy",
              style: { width: "600px", height: "400px" },
              src: item.hero_thumbnail,
              alt: `${item.hero} - ${item.location_street_address} ${!sold && (item.display_specifier || item.listing_display_specifier) ? item.location_specifier : ""}`
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: cx("flex-auto", useOnMap ? "pt-2 md:mt-4" : "py-4"), children: [
      /* @__PURE__ */ jsxs(
        "h4",
        {
          className: cx(
            "flex justify-between text-base text-blue-500",
            useOnMap ? "flex-col md:flex-row" : "items-center"
          ),
          children: [
            /* @__PURE__ */ jsxs("span", { className: "line-clamp-1", children: [
              item.location_street_address,
              " ",
              !sold && (item.display_specifier || item.listing_display_specifier) ? item.location_specifier : ""
            ] }),
            /* @__PURE__ */ jsx("span", { className: "flex-shrink-0 pl-1", children: priceDisplay })
          ]
        }
      ),
      /* @__PURE__ */ jsxs(
        "p",
        {
          className: cx(
            "flex justify-between text-sm text-gray-800",
            useOnMap ? "flex-col md:flex-row" : "items-center"
          ),
          children: [
            /* @__PURE__ */ jsxs("span", { children: [
              item.location_neighborhood,
              ", ",
              item.location_municipality
            ] }),
            /* @__PURE__ */ jsxs("span", { children: [
              getRooms(item),
              " · ",
              getArea(item)
            ] })
          ]
        }
      )
    ] })
  ] });
}
function PropertyItemArrow({ onChangeItem, direction, itemIndex }) {
  const { t: t2 } = useTranslation();
  const idxChange = direction === "left" ? -1 : 1;
  return /* @__PURE__ */ jsx(
    "button",
    {
      className: cx(
        "absolute z-10 w-10 h-10 rounded-full shadow-lg top-1/2 transform -translate-y-1/2 bg-blueLight-500 flex items-center justify-center",
        {
          "-left-5": direction === "left",
          "-right-5": direction === "right"
        }
      ),
      onClick: (e2) => {
        e2.preventDefault();
        onChangeItem(itemIndex + idxChange);
      },
      children: direction === "left" ? /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("span", { className: "sr-only", children: t2("Previous") }),
        /* @__PURE__ */ jsx(FaAngleLeft, { className: "w-5 h-5 text-white" })
      ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("span", { className: "sr-only", children: t2("Next") }),
        /* @__PURE__ */ jsx(FaAngleRight, { className: "w-5 h-5 text-white" })
      ] })
    }
  );
}
function PropertyItem({ initialItem, sold, onMouseOver, useOnMap }) {
  const { singleBaseUrl } = useContext(ListingContext);
  const [state, setState] = useState$1({
    item: initialItem,
    sameLocations: initialItem.sameLocation || [],
    itemIndex: 0
  });
  function changeItem(index) {
    const { sameLocations: sameLocations2 } = state;
    if (index < 0) {
      index = sameLocations2.length - 1;
    }
    if (index > sameLocations2.length - 1) {
      index = 0;
    }
    const item2 = sameLocations2[index];
    setState({
      ...state,
      item: item2,
      itemIndex: index
    });
  }
  const { item, itemIndex, sameLocations } = state;
  if (useOnMap) {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      sameLocations.length > 1 && /* @__PURE__ */ jsx(
        PropertyItemArrow,
        {
          onChangeItem: changeItem,
          itemIndex,
          direction: "left"
        }
      ),
      /* @__PURE__ */ jsx(
        Link,
        {
          url: singleBaseUrl ? `${singleBaseUrl}${item.slug}` : `/${item.slug}`,
          onMouseOver: onMouseOver ? () => onMouseOver(item) : () => {
          },
          className: "block min-w-[250px] sm:min-w-[320px]",
          children: /* @__PURE__ */ jsx(PropertyItemBody, { item, sold, useOnMap })
        }
      ),
      sameLocations.length > 1 && /* @__PURE__ */ jsx(
        PropertyItemArrow,
        {
          onChangeItem: changeItem,
          itemIndex,
          direction: "right"
        }
      )
    ] });
  }
  return /* @__PURE__ */ jsx(
    Link,
    {
      url: singleBaseUrl ? `${singleBaseUrl}${item.slug}` : `/${item.slug}`,
      onDragStart: (e2) => e2.preventDefault(),
      onMouseOver: onMouseOver ? () => onMouseOver(item) : () => {
      },
      children: /* @__PURE__ */ jsx(PropertyItemBody, { item, sold, useOnMap })
    }
  );
}
function ListingScroller({
  properties,
  insertPromo,
  slidesPerViewConfig,
  className
}) {
  const { width } = useWindowSize();
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const swiperRef = useRef(null);
  const [isSlideStart, setIsSlideStart] = useState$1(true);
  const [isSlideEnd, setIsSlideEnd] = useState$1(false);
  const carouselItems = () => {
    if (!properties || properties.length === 0) {
      return [1, 2, 3].map((number) => /* @__PURE__ */ jsx(SwiperSlide, { children: /* @__PURE__ */ jsx("div", { className: "bg-gray-300 animate-pulse h-[316px]" }) }, number));
    }
    const items2 = properties.map((apartment) => /* @__PURE__ */ jsx(SwiperSlide, { children: /* @__PURE__ */ jsx(PropertyItem, { initialItem: apartment, sold: apartment.sold }) }, apartment.slug));
    if (insertPromo) {
      items2.splice(
        2,
        0,
        /* @__PURE__ */ jsx(SwiperSlide, { children: insertPromo }, "similar-subscription")
      );
    }
    return items2;
  };
  const calculateSlidesPerView = (width2, spacesBetween) => {
    if (!width2 || width2 >= 576) {
      return 1.2;
    }
    const slideWidth = width2 - spacesBetween;
    return width2 / slideWidth - 73e-4;
  };
  const padding = Math.max(((width || 0) - 1115) / 2, 15);
  const items = carouselItems();
  const slidesPerView = calculateSlidesPerView(width, 30);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      Swiper2,
      {
        ref: swiperRef,
        modules: [Navigation, Scrollbar],
        onSlideChange: (swiper) => {
          setIsSlideStart(swiper.isBeginning);
          setIsSlideEnd(swiper.isEnd);
        },
        onToEdge: (swiper) => {
          setIsSlideStart(swiper.isBeginning);
          setIsSlideEnd(swiper.isEnd);
        },
        spaceBetween: 15,
        slidesPerView,
        className: cx(
          "!pt-4 !pb-4 sm:!pb-8 md:!pb-12",
          className,
          {
            "lg:!hidden": items.length < 4
          }
        ),
        centeredSlides: false,
        navigation: {
          prevEl: navigationPrevRef.current,
          nextEl: navigationNextRef.current
        },
        onBeforeInit: (swiper) => {
          swiper.params.navigation.prevEl = navigationPrevRef.current;
          swiper.params.navigation.nextEl = navigationNextRef.current;
        },
        slidesOffsetBefore: padding,
        slidesOffsetAfter: padding,
        breakpoints: {
          576: {
            slidesPerView: (slidesPerViewConfig == null ? void 0 : slidesPerViewConfig.sm) || 2.2,
            spaceBetween: 15,
            centeredSlides: false
          },
          992: {
            slidesPerView: (slidesPerViewConfig == null ? void 0 : slidesPerViewConfig.md) || 3.1,
            spaceBetween: 15,
            centeredSlides: false
          },
          1140: {
            slidesPerView: (slidesPerViewConfig == null ? void 0 : slidesPerViewConfig.lg) || 3.5,
            spaceBetween: 15,
            centeredSlides: false
          },
          1400: {
            slidesPerView: (slidesPerViewConfig == null ? void 0 : slidesPerViewConfig.xl) || 4.1,
            spaceBetween: 15,
            centeredSlides: false
          }
        },
        children: [
          items,
          /* @__PURE__ */ jsxs("div", { className: "mt-4 text-center", children: [
            /* @__PURE__ */ jsx(
              "div",
              {
                className: cx(
                  "bg-white rounded-full text-blue-500 h-[48px] w-[48px] leading-[50px] select-none",
                  "text-sm inline-block m-1.5 shadow-2 webkit-tab-highlight-color-transparent",
                  isSlideStart ? "opacity-50" : "cursor-pointer"
                ),
                ref: navigationPrevRef,
                children: /* @__PURE__ */ jsx(SvgChevronRight, { className: "w-4 h-4 fill-current inline-block transform rotate-180 stroke-current stroke-2 mr-1" })
              }
            ),
            /* @__PURE__ */ jsx(
              "div",
              {
                className: cx(
                  "bg-white rounded-full text-blue-500 h-[48px] w-[48px] leading-[50px] select-none",
                  "text-sm inline-block m-1.5 shadow-2 webkit-tab-highlight-color-transparent",
                  isSlideEnd ? "opacity-50" : "cursor-pointer"
                ),
                ref: navigationNextRef,
                children: /* @__PURE__ */ jsx(SvgChevronRight, { className: "w-4 h-4 fill-current inline-block stroke-current stroke-2 ml-0.5" })
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: cx("container hidden grid-cols-3 gap-5", {
          "lg:grid !pt-4 !pb-4 sm:!pb-8 md:!pb-12 mb-4 sm:mb-6 md:mb-8": items.length < 4
        }),
        children: items
      }
    )
  ] });
}
function ListingContent({
  loading,
  listingInfo,
  listingSold,
  similarApartments,
  t: t2
}) {
  useContext(ListingContext);
  const [state, setState] = useState$1({
    inlineIframe: window.innerWidth >= 768,
    iframeShown: false,
    linkDisabledModalShow: false
  });
  useEffect$1(() => {
    window.addEventListener("resize", debounce_1(handleResize, 300));
  }, []);
  function handleResize() {
    setState({
      ...state,
      inlineIframe: window.innerWidth >= 768
    });
  }
  function initIframe(e2, virtual) {
    e2.preventDefault();
    if (state.inlineIframe)
      setState({ ...state, iframeShown: true });
    else
      window.location.href = virtual;
  }
  function openLinkDisabledModal() {
    setState({ ...state, linkDisabledModalShow: true });
  }
  function closeLinkDisabledModal() {
    setState({ ...state, linkDisabledModalShow: false });
  }
  const { inlineIframe, iframeShown, linkDisabledModalShow } = state;
  function getVirtualPresentation() {
    let virtualPresentationThumb = "";
    if (listingInfo.hero) {
      virtualPresentationThumb = listingInfo.hero;
    } else if (listingInfo.virtualpresentation) {
      const matterportUrl = new URL(listingInfo.virtualpresentation);
      const matterportId = matterportUrl.searchParams.get("m");
      virtualPresentationThumb = `https://my.matterport.com/api/v1/player/models/${matterportId}/thumb`;
    }
    return listingInfo.virtualpresentation && /* @__PURE__ */ jsxs(Fragment, { children: [
      !iframeShown && /* @__PURE__ */ jsxs(
        "button",
        {
          onClick: (e2) => initIframe(e2, listingInfo.virtualpresentation),
          className: "relative w-full h-full",
          children: [
            /* @__PURE__ */ jsx(
              "img",
              {
                src: virtualPresentationThumb,
                alt: `${listingInfo.location_street_address}`,
                className: "object-cover w-full h-full"
              }
            ),
            /* @__PURE__ */ jsxs("div", { className: "absolute inset-0 flex flex-col items-center justify-center bg-blue-500 group bg-opacity-20", children: [
              /* @__PURE__ */ jsx(SvgVideoPlayer, { className: "text-white transition duration-200 transform scale-100 fill-current w-28 h-28 group-hover:text-blueLight-500 group-hover:scale-105" }),
              /* @__PURE__ */ jsx("p", { className: "mt-4 text-white h6", children: t2("view_3d") })
            ] })
          ]
        }
      ),
      inlineIframe && iframeShown && /* @__PURE__ */ jsx(
        "iframe",
        {
          title: `${listingInfo.location_street_address} 3D presentation`,
          src: `${listingInfo.virtualpresentation}&play=1`,
          className: "w-full h-full",
          allowFullScreen: ""
        }
      )
    ] });
  }
  function getHeroImage() {
    return listingInfo.hero && /* @__PURE__ */ jsx(
      "img",
      {
        className: "object-cover w-full h-full",
        src: listingInfo.hero,
        alt: `${listingInfo.location_street_address}`
      }
    );
  }
  function getMapElement() {
    return listingInfo.location_latitude && listingInfo.location_longitude && /* @__PURE__ */ jsx(default_1, { offset: 200, once: true, className: "flex-1", children: ({ isVisible }) => isVisible ? /* @__PURE__ */ jsx(
      ListingMap,
      {
        latitude: Number(listingInfo.location_latitude),
        longitude: Number(listingInfo.location_longitude)
      }
    ) : /* @__PURE__ */ jsx(
      "div",
      {
        className: "h-[400px]",
        style: { backgroundColor: "#e8e8e8" }
      }
    ) });
  }
  function getBlueprintElement() {
    return listingInfo.blueprint && /* @__PURE__ */ jsx(
      Blueprint$1,
      {
        blueprint: listingInfo.blueprint
      }
    );
  }
  const VirtualPresentation = getVirtualPresentation();
  const HeroImage = getHeroImage();
  const MapElement = getMapElement();
  const BlueprintElement = getBlueprintElement();
  const HeroElement = VirtualPresentation || HeroImage || BlueprintElement || MapElement;
  if (loading || !listingInfo) {
    return /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center w-full h-screen", children: /* @__PURE__ */ jsx(_default, { color: "#022640" }) });
  }
  return /* @__PURE__ */ jsxs("div", { className: "relative overflow-x-hidden", children: [
    /* @__PURE__ */ jsx(ListingMobileNav$1, { slug: listingInfo.slug }),
    /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-12 gap-4", children: [
      /* @__PURE__ */ jsx("div", { className: "col-span-12 row-start-1 lg:col-span-7 lg:row-start-auto lg:max-h-[550px] min-h-[300px] relative overflow-hidden", children: HeroElement }),
      /* @__PURE__ */ jsx("div", { className: "flex flex-col justify-center col-span-12 row-start-3 px-4 py-6 space-y-12 lg:py-12 lg:bg-gray-200 lg:col-span-5 lg:row-start-auto lg:max-h-[550px]", children: /* @__PURE__ */ jsx(
        ListingHeader,
        {
          listingInfo,
          listingSold
        }
      ) }),
      /* @__PURE__ */ jsx("div", { className: "col-span-12 row-start-2 lg:col-span-12 lg:row-start-auto", children: /* @__PURE__ */ jsx(
        PhotoSlider,
        {
          hero: listingInfo.hero,
          hero_thumbnail: listingInfo.hero_thumbnail,
          photos: listingInfo.photos,
          blueprint: listingInfo.blueprint
        }
      ) })
    ] }),
    !listingSold && /* @__PURE__ */ jsx(
      ListingDescription,
      {
        listingInfo,
        openLinkDisabledModal
      }
    ),
    !listingSold ? /* @__PURE__ */ jsx("div", { className: "container flex flex-col justify-center px-0 mt-12 xl:px-4 lg:flex-row lg:space-x-6", children: /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("div", { className: "relative flex w-full lg:w-2/3 h-80 lg:h-auto", children: MapElement }),
      /* @__PURE__ */ jsx("div", { className: "w-full px-4 mt-8 lg:mt-0 lg:w-1/3 lg:px-0", children: /* @__PURE__ */ jsx(PriceEstimate, { openLinkDisabledModal }) })
    ] }) }) : null,
    /* @__PURE__ */ jsxs("div", { className: "container px-0 mt-10 lg:px-6 lg:mt-14", children: [
      listingInfo.notifications && listingInfo.notifications.map((notification) => /* @__PURE__ */ jsxs("div", { className: "flex px-5 pt-4 pb-3 mx-4 mb-6 text-blue-500 uppercase bg-gray-500 border-t-2 border-blue-500", children: [
        /* @__PURE__ */ jsx(FaRegBell, {}),
        /* @__PURE__ */ jsx("p", { className: "ml-2 h6", children: notification.message })
      ] })),
      /* @__PURE__ */ jsxs("div", { className: "border-t border-b border-gray-500 divide-y divide-gray-500 lg:divide-y-0 lg:border-none lg:border-b-0", children: [
        !listingSold && /* @__PURE__ */ jsx(ListingPriceInfo, { listingInfo }),
        /* @__PURE__ */ jsx(ListingBasicInfo, { listingInfo }),
        /* @__PURE__ */ jsx(ListingImportantRenovationInfo, { listingInfo }),
        /* @__PURE__ */ jsx(
          ListingRenovationInfo,
          {
            pastRenovations: listingInfo.past_renovations,
            upcomingRenovations: listingInfo.upcoming_renovations
          }
        )
      ] })
    ] }),
    !listingSold && /* @__PURE__ */ jsx(
      ListingOfferExplanation,
      {
        listingInfo,
        openLinkDisabledModal
      }
    ),
    similarApartments && similarApartments.length > 0 && /* @__PURE__ */ jsxs("div", { className: "bg-gray-200 pt-15 pb-5", children: [
      /* @__PURE__ */ jsx("h3", { className: "px-4 text-center text-blue-500 mb-7", children: t2("similar_apartments") }),
      /* @__PURE__ */ jsx(
        ListingScroller,
        {
          slug: listingInfo.slug,
          properties: similarApartments
        }
      )
    ] }),
    /* @__PURE__ */ jsxs(
      mt,
      {
        open: linkDisabledModalShow,
        onClose: closeLinkDisabledModal,
        className: "tailwind",
        style: {
          position: "fixed",
          zIndex: 10,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflowY: "auto",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        },
        children: [
          /* @__PURE__ */ jsx(mt.Overlay, { className: "fixed inset-0 z-10 bg-blue-500 opacity-80" }),
          /* @__PURE__ */ jsxs("div", { className: "relative z-20 flex flex-col items-center justify-center px-16 pt-12 pb-10 bg-white rounded", children: [
            /* @__PURE__ */ jsx(mt.Title, { className: "text-center text-blue-500 h6", children: t2("link_disabled_desc") }),
            /* @__PURE__ */ jsx(
              Button,
              {
                onClick: closeLinkDisabledModal,
                buttonStyle: "blue",
                className: "mt-6",
                size: "sm",
                children: "OK"
              }
            )
          ] })
        ]
      }
    )
  ] });
}
const ListingContent$1 = withTranslation()(ListingContent);
const SvgError = (props) => /* @__PURE__ */ React$3.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 60 60", style: {
  enableBackground: "new 0 0 60 60"
}, xmlSpace: "preserve", ...props }, /* @__PURE__ */ React$3.createElement("style", { type: "text/css" }, "\n	.st0{fill:#022640;}\n"), /* @__PURE__ */ React$3.createElement("g", null, /* @__PURE__ */ React$3.createElement("g", { transform: "translate(-690.000000, -200.000000)" }, /* @__PURE__ */ React$3.createElement("g", { transform: "translate(691.000000, 201.000000)" }, /* @__PURE__ */ React$3.createElement("path", { className: "st0", d: "M31,46c-0.2,0-0.4-0.1-0.6-0.2c-0.4-0.3-0.6-0.9-0.2-1.4c3.8-5.3,10-8.4,16.8-8.4c0.6,0,1,0.4,1,1s-0.4,1-1,1c-6.1,0-11.8,2.8-15.2,7.6C31.6,45.9,31.3,46,31,46z" }), /* @__PURE__ */ React$3.createElement("path", { className: "st0", d: "M20,25c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S22.8,25,20,25z M20,17c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S21.7,17,20,17z" }), /* @__PURE__ */ React$3.createElement("path", { className: "st0", d: "M38,25c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S40.8,25,38,25z M38,17c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S39.7,17,38,17z" }), /* @__PURE__ */ React$3.createElement("path", { className: "st0", d: "M29,59C12.5,59-1,45.5-1,29C-1,12.5,12.5-1,29-1s30,13.5,30,30C59,45.5,45.5,59,29,59z M29,1C13.6,1,1,13.6,1,29c0,15.4,12.6,28,28,28s28-12.6,28-28C57,13.6,44.4,1,29,1z" })))));
function NotFoundContent() {
  const { t: t2 } = useTranslation();
  const { listingsUrl } = useContext(ListingContext);
  return /* @__PURE__ */ jsx("div", { className: "relative py-16 -mb-px bg-gray-200 md:py-20 lg:py-24", children: /* @__PURE__ */ jsxs("div", { className: "container max-w-xl space-y-6 lg:max-w-3xl", children: [
    /* @__PURE__ */ jsx(SvgError, { className: "relative block object-cover w-12 h-12 mx-auto" }),
    /* @__PURE__ */ jsx("h1", { className: "text-center text-blue-500 h2", children: t2("Unfortunately, we couldn't find the page you were looking for.") }),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col items-center justify-center space-y-4 lg:space-y-0 lg:space-x-6 lg:flex-row", children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          buttonStyle: "blue",
          buttonLink: listingsUrl,
          className: "w-full",
          children: t2("Properties on sale")
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          buttonStyle: "blue",
          buttonLink: "/",
          className: "w-full",
          children: t2("Go to homepage")
        }
      )
    ] })
  ] }) });
}
function Listing({
  listingInfo,
  listingGuid,
  listingSold,
  similarApartments,
  singleBaseUrl,
  listingsUrl,
  linkComponent,
  country,
  loading,
  preview,
  lang
}) {
  const { i18n } = useTranslation();
  useEffect$1(() => {
    if (!lang) {
      return;
    }
    i18n.changeLanguage(lang);
  }, [lang]);
  const params = useParams();
  if (params.slug) {
    const result = useLoaderData();
    if (!listingInfo) {
      listingInfo = result;
      listingGuid = result.case_id;
      listingSold = !!result.sold_at;
    }
  }
  if (!country && listingInfo) {
    switch (listingInfo.type) {
      case "apartment_fi":
        country = "FI";
        break;
      case "apartment_se":
        country = "SE";
        break;
    }
  }
  return /* @__PURE__ */ jsx(ListingContext.Provider, { value: {
    singleBaseUrl,
    listingsUrl,
    listingGuid,
    country,
    linkDisabled: preview,
    linkComponent
  }, children: /* @__PURE__ */ jsx("div", { id: "blok-listing", className: "tailwind", children: /* @__PURE__ */ jsxs("div", { className: "antialiased", children: [
    !listingInfo && loading ? /* @__PURE__ */ jsx("div", { className: "min-h-screen", children: /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-12 gap-4", children: [
      /* @__PURE__ */ jsx("div", { className: "col-span-12 row-start-1 lg:col-span-7 lg:row-start-auto h-[300px] sm:h-[550px] bg-gray-200" }),
      /* @__PURE__ */ jsx("div", { className: "flex flex-col justify-center col-span-12 row-start-3 px-4 py-6 space-y-12 lg:py-12 lg:bg-gray-200 lg:col-span-5 lg:row-start-auto" }),
      /* @__PURE__ */ jsx("div", { className: "px-4 col-span-12 row-start-2 lg:col-span-12 lg:row-start-auto flex space-x-4 h-[120px] overflow-hidden", children: Array.from(Array(20).keys()).map((number) => /* @__PURE__ */ jsx(
        "div",
        {
          className: "flex-shrink-0 h-full w-[140px] sm:w-[180px] bg-gray-200 animate-pulse"
        },
        number
      )) })
    ] }) }) : null,
    listingInfo && !loading ? /* @__PURE__ */ jsx(
      ListingContent$1,
      {
        loading,
        listingInfo,
        listingSold,
        similarApartments
      }
    ) : null,
    !listingInfo && !loading ? /* @__PURE__ */ jsx(NotFoundContent, {}) : null
  ] }) }) });
}
setupI18Next();
export {
  Listing,
  ScoutListing
};
